(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["ReactComplaintImage"] = factory(require("react"));
	else
		root["ReactComplaintImage"] = factory(root["React"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 138);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;

  var isValidElement = function isValidElement(object) {
    return (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(142)();
}

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.warn = exports.stripDiacritics = exports.scrollIntoViewIfNeeded = exports.preventInputBlur = exports.pluralize = exports.isShown = exports.getTruncatedOptions = exports.getStringLabelKey = exports.getOptionLabel = exports.getMenuItemId = exports.getMatchBounds = exports.getInputText = exports.getHintText = exports.getDisplayName = exports.getAccessibilityStatus = exports.defaultFilterBy = exports.addCustomOption = undefined;

var _addCustomOption2 = __webpack_require__(161);

var _addCustomOption3 = _interopRequireDefault(_addCustomOption2);

var _defaultFilterBy2 = __webpack_require__(162);

var _defaultFilterBy3 = _interopRequireDefault(_defaultFilterBy2);

var _getAccessibilityStatus2 = __webpack_require__(244);

var _getAccessibilityStatus3 = _interopRequireDefault(_getAccessibilityStatus2);

var _getDisplayName2 = __webpack_require__(245);

var _getDisplayName3 = _interopRequireDefault(_getDisplayName2);

var _getHintText2 = __webpack_require__(246);

var _getHintText3 = _interopRequireDefault(_getHintText2);

var _getInputText2 = __webpack_require__(250);

var _getInputText3 = _interopRequireDefault(_getInputText2);

var _getMatchBounds2 = __webpack_require__(99);

var _getMatchBounds3 = _interopRequireDefault(_getMatchBounds2);

var _getMenuItemId2 = __webpack_require__(251);

var _getMenuItemId3 = _interopRequireDefault(_getMenuItemId2);

var _getOptionLabel2 = __webpack_require__(54);

var _getOptionLabel3 = _interopRequireDefault(_getOptionLabel2);

var _getStringLabelKey2 = __webpack_require__(101);

var _getStringLabelKey3 = _interopRequireDefault(_getStringLabelKey2);

var _getTruncatedOptions2 = __webpack_require__(252);

var _getTruncatedOptions3 = _interopRequireDefault(_getTruncatedOptions2);

var _isShown2 = __webpack_require__(253);

var _isShown3 = _interopRequireDefault(_isShown2);

var _pluralize2 = __webpack_require__(254);

var _pluralize3 = _interopRequireDefault(_pluralize2);

var _preventInputBlur2 = __webpack_require__(255);

var _preventInputBlur3 = _interopRequireDefault(_preventInputBlur2);

var _scrollIntoViewIfNeeded2 = __webpack_require__(256);

var _scrollIntoViewIfNeeded3 = _interopRequireDefault(_scrollIntoViewIfNeeded2);

var _stripDiacritics2 = __webpack_require__(53);

var _stripDiacritics3 = _interopRequireDefault(_stripDiacritics2);

var _warn2 = __webpack_require__(9);

var _warn3 = _interopRequireDefault(_warn2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.addCustomOption = _addCustomOption3.default; /* eslint-disable object-curly-spacing */

exports.defaultFilterBy = _defaultFilterBy3.default;
exports.getAccessibilityStatus = _getAccessibilityStatus3.default;
exports.getDisplayName = _getDisplayName3.default;
exports.getHintText = _getHintText3.default;
exports.getInputText = _getInputText3.default;
exports.getMatchBounds = _getMatchBounds3.default;
exports.getMenuItemId = _getMenuItemId3.default;
exports.getOptionLabel = _getOptionLabel3.default;
exports.getStringLabelKey = _getStringLabelKey3.default;
exports.getTruncatedOptions = _getTruncatedOptions3.default;
exports.isShown = _isShown3.default;
exports.pluralize = _pluralize3.default;
exports.preventInputBlur = _preventInputBlur3.default;
exports.scrollIntoViewIfNeeded = _scrollIntoViewIfNeeded3.default;
exports.stripDiacritics = _stripDiacritics3.default;
exports.warn = _warn3.default;
/* eslint-enable object-curly-spacing */

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var freeGlobal = __webpack_require__(82);

/** Detect free variable `self`. */
var freeSelf = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg === 'undefined' ? 'undefined' : _typeof(arg);

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if ("function" === 'function' && _typeof(__webpack_require__(104)) === 'object' && __webpack_require__(104)) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
})();

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(140);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object';
}

module.exports = isObjectLike;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = warn;
exports._resetWarned = _resetWarned;

var _warning = __webpack_require__(243);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var warned = {}; /**
                  * This code is copied from: https://github.com/ReactTraining/react-router/blob/master/modules/routerWarning.js
                  */

function warn(falseToWarn, message) {
  // Only issue deprecation warnings once.
  if (!falseToWarn && message.indexOf('deprecated') !== -1) {
    if (warned[message]) {
      return;
    }
    warned[message] = true;
  }

  message = '[react-bootstrap-typeahead] ' + message;

  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
}

function _resetWarned() {
  warned = {};
}

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self
// eslint-disable-next-line no-new-func
: Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Symbol = __webpack_require__(23),
    getRawTag = __webpack_require__(159),
    objectToString = __webpack_require__(160);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
    if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
    }
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}

module.exports = baseGetTag;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseIsNative = __webpack_require__(174),
    getValue = __webpack_require__(177);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var dP = __webpack_require__(17);
var createDesc = __webpack_require__(37);
module.exports = __webpack_require__(19) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(26);
var IE8_DOM_DEFINE = __webpack_require__(112);
var toPrimitive = __webpack_require__(57);
var dP = Object.defineProperty;

exports.f = __webpack_require__(19) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) {/* empty */}
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports = function (it) {
  return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(27)(function () {
  return Object.defineProperty({}, 'a', { get: function get() {
      return 7;
    } }).a != 7;
});

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(115);
var defined = __webpack_require__(58);
module.exports = function (it) {
  return IObject(defined(it));
};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var store = __webpack_require__(61)('wks');
var uid = __webpack_require__(39);
var _Symbol = __webpack_require__(10).Symbol;
var USE_SYMBOL = typeof _Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] = USE_SYMBOL && _Symbol[name] || (USE_SYMBOL ? _Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable sort-keys */

/**
 * KeyCode
 *
 * Map of common (non-printable) keycodes for the `keydown` and `keyup` events.
 * Note that `keypress` handles things differently and may not return the same
 * values.
 */

module.exports = {
  BACKSPACE: 8,
  TAB: 9,
  RETURN: 13,
  ESC: 27,
  SPACE: 32,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40
};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var root = __webpack_require__(4);

/** Built-in value references. */
var _Symbol = root.Symbol;

module.exports = _Symbol;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isSymbol = __webpack_require__(29);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

module.exports = toKey;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global = __webpack_require__(10);
var core = __webpack_require__(15);
var ctx = __webpack_require__(111);
var hide = __webpack_require__(16);
var PROTOTYPE = 'prototype';

var $export = function $export(type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? function (C) {
      var F = function F(a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0:
              return new C();
            case 1:
              return new C(a);
            case 2:
              return new C(a, b);
          }return new C(a, b, c);
        }return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
      // make static versions for prototype methods
    }(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1; // forced
$export.G = 2; // global
$export.S = 4; // static
$export.P = 8; // proto
$export.B = 16; // bind
$export.W = 32; // wrap
$export.U = 64; // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isObject = __webpack_require__(18);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Based on ReactArt.js
 * Copyright (c) 2017-present Lavrenov Anton.
 * All rights reserved.
 *
 * MIT
 */


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var React = __webpack_require__(0);
var Konva = __webpack_require__(76);
var ReactFiberReconciler = __webpack_require__(144);
var ReactDOMComponentTree = __webpack_require__(146);
var HostConfig = __webpack_require__(147);

var _require = __webpack_require__(77),
    applyNodeProps = _require.applyNodeProps,
    toggleStrictMode = _require.toggleStrictMode;

var REACT_VERSION = '16.6.3';

if (React.version !== REACT_VERSION) {
  console.error('Version mismatch detected for react-konva and react. react-konva expects to have react version ' + REACT_VERSION + ', but it has version ' + React.version + '. Make sure versions are matched, otherwise, react-konva work is not guaranteed.');
}

var Stage = function (_React$Component) {
  _inherits(Stage, _React$Component);

  function Stage() {
    _classCallCheck(this, Stage);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Stage.prototype.componentDidMount = function componentDidMount() {
    if (!Konva.isBrowser) {
      return;
    }
    this._stage = new Konva.Stage({
      width: this.props.width,
      height: this.props.height,
      container: this._tagRef
    });

    this._setRef(this._stage);

    applyNodeProps(this._stage, this.props);

    this._mountNode = KonvaRenderer.createContainer(this._stage);
    KonvaRenderer.updateContainer(this.props.children, this._mountNode, this);
  };

  Stage.prototype._setRef = function _setRef(value) {
    var forwardedRef = this.props.forwardedRef;

    if (!forwardedRef) {
      return;
    }
    if (typeof forwardedRef === 'function') {
      forwardedRef(value);
    } else {
      forwardedRef.current = value;
    }
  };

  Stage.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (!Konva.isBrowser) {
      return;
    }
    this._setRef(this._stage);
    applyNodeProps(this._stage, this.props, prevProps);

    KonvaRenderer.updateContainer(this.props.children, this._mountNode, this);
  };

  Stage.prototype.componentWillUnmount = function componentWillUnmount() {
    if (!Konva.isBrowser) {
      return;
    }
    this._setRef(null);
    KonvaRenderer.updateContainer(null, this._mountNode, this);
    this._stage.destroy();
  };

  Stage.prototype.getStage = function getStage() {
    return this._stage;
  };

  Stage.prototype.render = function render() {
    var _this2 = this;

    var props = this.props;

    return React.createElement('div', {
      ref: function ref(_ref) {
        return _this2._tagRef = _ref;
      },
      accessKey: props.accessKey,
      className: props.className,
      role: props.role,
      style: props.style,
      tabIndex: props.tabIndex,
      title: props.title
    });
  };

  return Stage;
}(React.Component);

var KONVA_NODES = ['Layer', 'FastLayer', 'Group', 'Label', 'Rect', 'Circle', 'Ellipse', 'Wedge', 'Line', 'Sprite', 'Image', 'Text', 'TextPath', 'Star', 'Ring', 'Arc', 'Tag', 'Path', 'RegularPolygon', 'Arrow', 'Shape', 'Transformer'];

var TYPES = {};

KONVA_NODES.forEach(function (nodeName) {
  TYPES[nodeName] = nodeName;
});

var KonvaRenderer = ReactFiberReconciler(HostConfig);

KonvaRenderer.injectIntoDevTools({
  findFiberByHostInstance: ReactDOMComponentTree.getClosestInstanceFromNode,
  bundleType:  false ? 1 : 0,
  version: React.version,
  rendererPackageName: 'react-konva',
  getInspectorDataForViewTag: function getInspectorDataForViewTag() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    console.log(args);
  }
});

/** API */

var StageWrap = React.forwardRef(function (props, ref) {
  return React.createElement(Stage, _extends({}, props, { forwardedRef: ref }));
});

module.exports = _extends({}, TYPES, {
  Stage: StageWrap,
  useStrictMode: toggleStrictMode
});

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var baseGetTag = __webpack_require__(11),
    isObjectLike = __webpack_require__(8);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
    return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
}

module.exports = isSymbol;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var listCacheClear = __webpack_require__(164),
    listCacheDelete = __webpack_require__(165),
    listCacheGet = __webpack_require__(166),
    listCacheHas = __webpack_require__(167),
    listCacheSet = __webpack_require__(168);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var eq = __webpack_require__(32);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

module.exports = eq;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getNative = __webpack_require__(12);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isKeyable = __webpack_require__(186);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

module.exports = getMapData;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

module.exports = isIndex;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArray = __webpack_require__(2),
    isKey = __webpack_require__(52),
    stringToPath = __webpack_require__(226),
    toString = __webpack_require__(96);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(114);
var enumBugKeys = __webpack_require__(62);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(141);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *
 */


var validateFormat =  false ? function (format) {} : function (format) {
  if (format === undefined) {
    throw new Error('invariant(...): Second argument must be a string.');
  }
};
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments to provide
 * information about what broke and what you were expecting.
 *
 * The invariant message will be stripped in production, but the invariant will
 * remain to ensure logic does not differ in production.
 */

function invariant(condition, format) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  validateFormat(format);

  if (!condition) {
    var error;

    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return String(args[argIndex++]);
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // Skip invariant's own stack frame.

    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseIsEqualDeep = __webpack_require__(163),
    isObjectLike = __webpack_require__(8);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getNative = __webpack_require__(12),
    root = __webpack_require__(4);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseGetTag = __webpack_require__(11),
    isObject = __webpack_require__(7);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
    if (!isObject(value)) {
        return false;
    }
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var mapCacheClear = __webpack_require__(178),
    mapCacheDelete = __webpack_require__(185),
    mapCacheGet = __webpack_require__(187),
    mapCacheHas = __webpack_require__(188),
    mapCacheSet = __webpack_require__(189);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var arrayLikeKeys = __webpack_require__(204),
    baseKeys = __webpack_require__(211),
    isArrayLike = __webpack_require__(50);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseIsArguments = __webpack_require__(206),
    isObjectLike = __webpack_require__(8);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function () {
    return arguments;
}()) ? baseIsArguments : function (value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isFunction = __webpack_require__(45),
    isLength = __webpack_require__(49);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var castPath = __webpack_require__(36),
    toKey = __webpack_require__(24);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return index && index == length ? object : undefined;
}

module.exports = baseGet;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isArray = __webpack_require__(2),
    isSymbol = __webpack_require__(29);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}

module.exports = isKey;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = stripDiacritics;
/**
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Taken from: http://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript/18391901#18391901
 */

/* eslint-disable max-len */
var map = [{ 'base': 'A', 'letters': 'A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F' }, { 'base': 'AA', 'letters': '\uA732' }, { 'base': 'AE', 'letters': '\xC6\u01FC\u01E2' }, { 'base': 'AO', 'letters': '\uA734' }, { 'base': 'AU', 'letters': '\uA736' }, { 'base': 'AV', 'letters': '\uA738\uA73A' }, { 'base': 'AY', 'letters': '\uA73C' }, { 'base': 'B', 'letters': 'B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181' }, { 'base': 'C', 'letters': 'C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E' }, { 'base': 'D', 'letters': 'D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779\xD0' }, { 'base': 'DZ', 'letters': '\u01F1\u01C4' }, { 'base': 'Dz', 'letters': '\u01F2\u01C5' }, { 'base': 'E', 'letters': 'E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E' }, { 'base': 'F', 'letters': 'F\u24BB\uFF26\u1E1E\u0191\uA77B' }, { 'base': 'G', 'letters': 'G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E' }, { 'base': 'H', 'letters': 'H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D' }, { 'base': 'I', 'letters': 'I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197' }, { 'base': 'J', 'letters': 'J\u24BF\uFF2A\u0134\u0248' }, { 'base': 'K', 'letters': 'K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2' }, { 'base': 'L', 'letters': 'L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780' }, { 'base': 'LJ', 'letters': '\u01C7' }, { 'base': 'Lj', 'letters': '\u01C8' }, { 'base': 'M', 'letters': 'M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C' }, { 'base': 'N', 'letters': 'N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4' }, { 'base': 'NJ', 'letters': '\u01CA' }, { 'base': 'Nj', 'letters': '\u01CB' }, { 'base': 'O', 'letters': 'O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C' }, { 'base': 'OI', 'letters': '\u01A2' }, { 'base': 'OO', 'letters': '\uA74E' }, { 'base': 'OU', 'letters': '\u0222' }, { 'base': 'OE', 'letters': '\x8C\u0152' }, { 'base': 'oe', 'letters': '\x9C\u0153' }, { 'base': 'P', 'letters': 'P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754' }, { 'base': 'Q', 'letters': 'Q\u24C6\uFF31\uA756\uA758\u024A' }, { 'base': 'R', 'letters': 'R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782' }, { 'base': 'S', 'letters': 'S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784' }, { 'base': 'T', 'letters': 'T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786' }, { 'base': 'TZ', 'letters': '\uA728' }, { 'base': 'U', 'letters': 'U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244' }, { 'base': 'V', 'letters': 'V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245' }, { 'base': 'VY', 'letters': '\uA760' }, { 'base': 'W', 'letters': 'W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72' }, { 'base': 'X', 'letters': 'X\u24CD\uFF38\u1E8A\u1E8C' }, { 'base': 'Y', 'letters': 'Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE' }, { 'base': 'Z', 'letters': 'Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762' }, { 'base': 'a', 'letters': 'a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250' }, { 'base': 'aa', 'letters': '\uA733' }, { 'base': 'ae', 'letters': '\xE6\u01FD\u01E3' }, { 'base': 'ao', 'letters': '\uA735' }, { 'base': 'au', 'letters': '\uA737' }, { 'base': 'av', 'letters': '\uA739\uA73B' }, { 'base': 'ay', 'letters': '\uA73D' }, { 'base': 'b', 'letters': 'b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253' }, { 'base': 'c', 'letters': 'c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184' }, { 'base': 'd', 'letters': 'd\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A' }, { 'base': 'dz', 'letters': '\u01F3\u01C6' }, { 'base': 'e', 'letters': 'e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD' }, { 'base': 'f', 'letters': 'f\u24D5\uFF46\u1E1F\u0192\uA77C' }, { 'base': 'g', 'letters': 'g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F' }, { 'base': 'h', 'letters': 'h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265' }, { 'base': 'hv', 'letters': '\u0195' }, { 'base': 'i', 'letters': 'i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131' }, { 'base': 'j', 'letters': 'j\u24D9\uFF4A\u0135\u01F0\u0249' }, { 'base': 'k', 'letters': 'k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3' }, { 'base': 'l', 'letters': 'l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747' }, { 'base': 'lj', 'letters': '\u01C9' }, { 'base': 'm', 'letters': 'm\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F' }, { 'base': 'n', 'letters': 'n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5' }, { 'base': 'nj', 'letters': '\u01CC' }, { 'base': 'o', 'letters': 'o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275' }, { 'base': 'oi', 'letters': '\u01A3' }, { 'base': 'ou', 'letters': '\u0223' }, { 'base': 'oo', 'letters': '\uA74F' }, { 'base': 'p', 'letters': 'p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755' }, { 'base': 'q', 'letters': 'q\u24E0\uFF51\u024B\uA757\uA759' }, { 'base': 'r', 'letters': 'r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783' }, { 'base': 's', 'letters': 's\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B' }, { 'base': 't', 'letters': 't\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787' }, { 'base': 'tz', 'letters': '\uA729' }, { 'base': 'u', 'letters': 'u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289' }, { 'base': 'v', 'letters': 'v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C' }, { 'base': 'vy', 'letters': '\uA761' }, { 'base': 'w', 'letters': 'w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73' }, { 'base': 'x', 'letters': 'x\u24E7\uFF58\u1E8B\u1E8D' }, { 'base': 'y', 'letters': 'y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF' }, { 'base': 'z', 'letters': 'z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763' }];
/* eslint-enable max-len */

var diacriticsMap = {};
for (var ii = 0; ii < map.length; ii++) {
  var letters = map[ii].letters;
  for (var jj = 0; jj < letters.length; jj++) {
    diacriticsMap[letters[jj]] = map[ii].base;
  }
}

// "what?" version ... http://jsperf.com/diacritics/12
function stripDiacritics(str) {
  return str.replace(/[\u0300-\u036F]/g, '') // Remove combining diacritics
  /* eslint-disable-next-line no-control-regex */
  .replace(/[^\u0000-\u007E]/g, function (a) {
    return diacriticsMap[a] || a;
  });
}

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _invariant = __webpack_require__(248);

var _invariant2 = _interopRequireDefault(_invariant);

var _isPlainObject = __webpack_require__(100);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _getStringLabelKey = __webpack_require__(101);

var _getStringLabelKey2 = _interopRequireDefault(_getStringLabelKey);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Retrieves the display string from an option. Options can be the string
 * themselves, or an object with a defined display string. Anything else throws
 * an error.
 */
function getOptionLabel(option, labelKey) {
  if (option.paginationOption || option.customOption) {
    return option[(0, _getStringLabelKey2.default)(labelKey)];
  }

  var optionLabel = void 0;

  if (typeof option === 'string') {
    optionLabel = option;
  }

  if (typeof labelKey === 'function') {
    // This overwrites string options, but we assume the consumer wants to do
    // something custom if `labelKey` is a function.
    optionLabel = labelKey(option);
  } else if (typeof labelKey === 'string' && (0, _isPlainObject2.default)(option)) {
    optionLabel = option[labelKey];
  }

  !(typeof optionLabel === 'string') ?  false ? (0, _invariant2.default)(false, 'One or more options does not have a valid label string. Check the ' + '`labelKey` prop to ensure that it matches the correct option key and ' + 'provides a string for filtering and display.') : (0, _invariant2.default)(false) : void 0;

  return optionLabel;
}

exports.default = getOptionLabel;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */
function head(array) {
  return array && array.length ? array[0] : undefined;
}

module.exports = head;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createChainableTypeChecker = __webpack_require__(274);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function validate(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
  }

  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(validate);
module.exports = exports['default'];

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(18);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var shared = __webpack_require__(61)('keys');
var uid = __webpack_require__(39);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global = __webpack_require__(10);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = true;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(26);
var dPs = __webpack_require__(292);
var enumBugKeys = __webpack_require__(62);
var IE_PROTO = __webpack_require__(60)('IE_PROTO');
var Empty = function Empty() {/* empty */};
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var _createDict = function createDict() {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(113)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(293).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  _createDict = iframeDocument.F;
  while (i--) {
    delete _createDict[PROTOTYPE][enumBugKeys[i]];
  }return _createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = _createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var def = __webpack_require__(17).f;
var has = __webpack_require__(13);
var TAG = __webpack_require__(21)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.f = __webpack_require__(21);

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global = __webpack_require__(10);
var core = __webpack_require__(15);
var LIBRARY = __webpack_require__(64);
var wksExt = __webpack_require__(68);
var defineProperty = __webpack_require__(17).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseMenuItem = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _noop = __webpack_require__(71);

var _noop2 = _interopRequireDefault(_noop);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _menuItemContainer = __webpack_require__(134);

var _menuItemContainer2 = _interopRequireDefault(_menuItemContainer);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var BaseMenuItem = function (_React$Component) {
  _inherits(BaseMenuItem, _React$Component);

  function BaseMenuItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, BaseMenuItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BaseMenuItem.__proto__ || Object.getPrototypeOf(BaseMenuItem)).call.apply(_ref, [this].concat(args))), _this), _this._handleClick = function (e) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onClick = _this$props.onClick;

      e.preventDefault();
      !disabled && onClick(e);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(BaseMenuItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          children = _props.children,
          className = _props.className,
          disabled = _props.disabled,
          onClick = _props.onClick,
          onMouseDown = _props.onMouseDown,
          props = _objectWithoutProperties(_props, ['active', 'children', 'className', 'disabled', 'onClick', 'onMouseDown']);

      var conditionalClassNames = {
        'active': active,
        'disabled': disabled
      };

      return (
        /* eslint-disable jsx-a11y/anchor-is-valid */
        _react2.default.createElement('li', _extends({}, props, {
          className: (0, _classnames2.default)(conditionalClassNames, className) }), _react2.default.createElement('a', {
          className: (0, _classnames2.default)('dropdown-item', conditionalClassNames),
          href: '#',
          onClick: this._handleClick,
          onMouseDown: onMouseDown }, children))
        /* eslint-enable jsx-a11y/anchor-is-valid */

      );
    }
  }]);

  return BaseMenuItem;
}(_react2.default.Component);

BaseMenuItem.defaultProps = {
  onClick: _noop2.default
};

exports.BaseMenuItem = BaseMenuItem;
exports.default = (0, _menuItemContainer2.default)(BaseMenuItem);

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseCreate = __webpack_require__(135),
    baseLodash = __webpack_require__(73);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseCreate = __webpack_require__(135),
    baseLodash = __webpack_require__(73);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_RESULT__;var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};/*
 * Konva JavaScript Framework v2.5.1
 * http://konvajs.github.io/
 * Licensed under the MIT
 * Date: Thu Nov 08 2018
 *
 * Original work Copyright (C) 2011 - 2013 by Eric Rowell (KineticJS)
 * Modified work Copyright (C) 2014 - present by Anton Lavrenov (Konva)
 *
 * @license
 */// runtime check for already included Konva
(function(){'use strict';/**
   * @namespace Konva
   */var PI_OVER_180=Math.PI/180;var Konva={// public
version:'2.5.1',// private
stages:[],idCounter:0,ids:{},names:{},shapes:{},listenClickTap:false,inDblClickWindow:false,isBrowser:typeof window!=='undefined'&&(// browser case
{}.toString.call(window)==='[object Window]'||// electron case
{}.toString.call(window)==='[object global]'),isUnminified:/comment/.test(function(){/* comment */}),// configurations
enableTrace:false,traceArrMax:100,dblClickWindow:400,/**
     * Global pixel ratio configuration. KonvaJS automatically detect pixel ratio of current device.
     * But you may override such property, if you want to use your value.
     * @property pixelRatio
     * @default undefined
     * @memberof Konva
     * @example
     * Konva.pixelRatio = 1;
     */pixelRatio:undefined,/**
     * Drag distance property. If you start to drag a node you may want to wait until pointer is moved to some distance from start point,
     * only then start dragging. Default is 3px.
     * @property dragDistance
     * @default 0
     * @memberof Konva
     * @example
     * Konva.dragDistance = 10;
     */dragDistance:3,/**
     * Use degree values for angle properties. You may set this property to false if you want to use radiant values.
     * @property angleDeg
     * @default true
     * @memberof Konva
     * @example
     * node.rotation(45); // 45 degrees
     * Konva.angleDeg = false;
     * node.rotation(Math.PI / 2); // PI/2 radian
     */angleDeg:true,/**
     * Show different warnings about errors or wrong API usage
     * @property showWarnings
     * @default true
     * @memberof Konva
     * @example
     * Konva.showWarnings = false;
     */showWarnings:true,/**
     * @namespace Filters
     * @memberof Konva
     */Filters:{},/**
     * returns whether or not drag and drop is currently active
     * @method
     * @memberof Konva
     */isDragging:function isDragging(){var dd=Konva.DD;// if DD is not included with the build, then
// drag and drop is not even possible
if(dd){return dd.isDragging;}return false;},/**
     * returns whether or not a drag and drop operation is ready, but may
     *  not necessarily have started
     * @method
     * @memberof Konva
     */isDragReady:function isDragReady(){var dd=Konva.DD;// if DD is not included with the build, then
// drag and drop is not even possible
if(dd){return!!dd.node;}return false;},_addId:function _addId(node,id){if(!id){return;}// do we need this warning?
// if (this.ids[id]) {
//   Konva.Util.warn(
//     'Duplicate id "' +
//       id +
//       '". Please don not use same id several times. It may break find() method look up.'
//   );
// }
this.ids[id]=node;},_removeId:function _removeId(id){if(id!==undefined){delete this.ids[id];}},_addName:function _addName(node,name){if(name){if(!this.names[name]){this.names[name]=[];}this.names[name].push(node);}},_removeName:function _removeName(name,_id){if(!name){return;}var nodes=this.names[name];if(!nodes){return;}for(var n=0;n<nodes.length;n++){var no=nodes[n];if(no._id===_id){nodes.splice(n,1);}}if(nodes.length===0){delete this.names[name];}},getAngle:function getAngle(angle){return this.angleDeg?angle*PI_OVER_180:angle;},_detectIE:function _detectIE(ua){var msie=ua.indexOf('msie ');if(msie>0){// IE 10 or older => return version number
return parseInt(ua.substring(msie+5,ua.indexOf('.',msie)),10);}var trident=ua.indexOf('trident/');if(trident>0){// IE 11 => return version number
var rv=ua.indexOf('rv:');return parseInt(ua.substring(rv+3,ua.indexOf('.',rv)),10);}var edge=ua.indexOf('edge/');if(edge>0){// Edge (IE 12+) => return version number
return parseInt(ua.substring(edge+5,ua.indexOf('.',edge)),10);}// other browser
return false;},_parseUA:function _parseUA(userAgent){var ua=userAgent.toLowerCase(),// jQuery UA regex
match=/(chrome)[ /]([\w.]+)/.exec(ua)||/(webkit)[ /]([\w.]+)/.exec(ua)||/(opera)(?:.*version|)[ /]([\w.]+)/.exec(ua)||/(msie) ([\w.]+)/.exec(ua)||ua.indexOf('compatible')<0&&/(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua)||[],// adding mobile flag as well
mobile=!!userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/i),ieMobile=!!userAgent.match(/IEMobile/i);return{browser:match[1]||'',version:match[2]||'0',isIE:Konva._detectIE(ua),// adding mobile flab
mobile:mobile,ieMobile:ieMobile// If this is true (i.e., WP8), then Konva touch events are executed instead of equivalent Konva mouse events
};},// user agent
UA:undefined};var glob=typeof global!=='undefined'?global:typeof window!=='undefined'?window:typeof WorkerGlobalScope!=='undefined'?self:{};Konva.UA=Konva._parseUA(glob.navigator&&glob.navigator.userAgent||'');if(glob.Konva){console.error('Konva instance is already exist in current eviroment. '+'Please use only one instance.');}glob.Konva=Konva;Konva.global=glob;Konva.window=glob;Konva.document=glob.document;if(( false?'undefined':_typeof(exports))==='object'){module.exports=Konva;}else if(true){// AMD. Register as an anonymous module.
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return Konva;}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));}})();/*eslint-disable  eqeqeq, no-cond-assign, no-empty*/(function(){'use strict';/**
   * Collection constructor.  Collection extends
   *  Array.  This class is used in conjunction with {@link Konva.Container#get}
   * @constructor
   * @memberof Konva
   */Konva.Collection=function(){var args=[].slice.call(arguments),length=args.length,i=0;this.length=length;for(;i<length;i++){this[i]=args[i];}return this;};Konva.Collection.prototype=[];/**
   * iterate through node array and run a function for each node.
   *  The node and index is passed into the function
   * @method
   * @memberof Konva.Collection.prototype
   * @param {Function} func
   * @example
   * // get all nodes with name foo inside layer, and set x to 10 for each
   * layer.get('.foo').each(function(shape, n) {
   *   shape.setX(10);
   * });
   */Konva.Collection.prototype.each=function(func){for(var n=0;n<this.length;n++){func(this[n],n);}};/**
   * convert collection into an array
   * @method
   * @memberof Konva.Collection.prototype
   */Konva.Collection.prototype.toArray=function(){var arr=[],len=this.length,n;for(n=0;n<len;n++){arr.push(this[n]);}return arr;};/**
   * convert array into a collection
   * @method
   * @memberof Konva.Collection
   * @param {Array} arr
   */Konva.Collection.toCollection=function(arr){var collection=new Konva.Collection(),len=arr.length,n;for(n=0;n<len;n++){collection.push(arr[n]);}return collection;};// map one method by it's name
Konva.Collection._mapMethod=function(methodName){Konva.Collection.prototype[methodName]=function(){var len=this.length,i;var args=[].slice.call(arguments);for(i=0;i<len;i++){this[i][methodName].apply(this[i],args);}return this;};};Konva.Collection.mapMethods=function(constructor){var prot=constructor.prototype;for(var methodName in prot){Konva.Collection._mapMethod(methodName);}};/*
    * Last updated November 2011
    * By Simon Sarris
    * www.simonsarris.com
    * sarris@acm.org
    *
    * Free to use and distribute at will
    * So long as you are nice to people, etc
    *//*
    * The usage of this class was inspired by some of the work done by a forked
    * project, KineticJS-Ext by Wappworks, which is based on Simon's Transform
    * class.  Modified by Eric Rowell
    *//**
   * Transform constructor. Transform object is a private class of Konva framework.
   * In most of the cases you don't need to use it in your app.
   * But there is a documentation for that class in case you still want
   * to make some manual calculations.
   * @constructor
   * @param {Array} [m] Optional six-element matrix
   * @memberof Konva
   */Konva.Transform=function(m){this.m=m&&m.slice()||[1,0,0,1,0,0];};Konva.Transform.prototype={/**
     * Copy Konva.Transform object
     * @method
     * @memberof Konva.Transform.prototype
     * @returns {Konva.Transform}
     */copy:function copy(){return new Konva.Transform(this.m);},/**
     * Transform point
     * @method
     * @memberof Konva.Transform.prototype
     * @param {Object} point 2D point(x, y)
     * @returns {Object} 2D point(x, y)
     */point:function point(_point){var m=this.m;return{x:m[0]*_point.x+m[2]*_point.y+m[4],y:m[1]*_point.x+m[3]*_point.y+m[5]};},/**
     * Apply translation
     * @method
     * @memberof Konva.Transform.prototype
     * @param {Number} x
     * @param {Number} y
     * @returns {Konva.Transform}
     */translate:function translate(x,y){this.m[4]+=this.m[0]*x+this.m[2]*y;this.m[5]+=this.m[1]*x+this.m[3]*y;return this;},/**
     * Apply scale
     * @method
     * @memberof Konva.Transform.prototype
     * @param {Number} sx
     * @param {Number} sy
     * @returns {Konva.Transform}
     */scale:function scale(sx,sy){this.m[0]*=sx;this.m[1]*=sx;this.m[2]*=sy;this.m[3]*=sy;return this;},/**
     * Apply rotation
     * @method
     * @memberof Konva.Transform.prototype
     * @param {Number} rad  Angle in radians
     * @returns {Konva.Transform}
     */rotate:function rotate(rad){var c=Math.cos(rad);var s=Math.sin(rad);var m11=this.m[0]*c+this.m[2]*s;var m12=this.m[1]*c+this.m[3]*s;var m21=this.m[0]*-s+this.m[2]*c;var m22=this.m[1]*-s+this.m[3]*c;this.m[0]=m11;this.m[1]=m12;this.m[2]=m21;this.m[3]=m22;return this;},/**
     * Returns the translation
     * @method
     * @memberof Konva.Transform.prototype
     * @returns {Object} 2D point(x, y)
     */getTranslation:function getTranslation(){return{x:this.m[4],y:this.m[5]};},/**
     * Apply skew
     * @method
     * @memberof Konva.Transform.prototype
     * @param {Number} sx
     * @param {Number} sy
     * @returns {Konva.Transform}
     */skew:function skew(sx,sy){var m11=this.m[0]+this.m[2]*sy;var m12=this.m[1]+this.m[3]*sy;var m21=this.m[2]+this.m[0]*sx;var m22=this.m[3]+this.m[1]*sx;this.m[0]=m11;this.m[1]=m12;this.m[2]=m21;this.m[3]=m22;return this;},/**
     * Transform multiplication
     * @method
     * @memberof Konva.Transform.prototype
     * @param {Konva.Transform} matrix
     * @returns {Konva.Transform}
     */multiply:function multiply(matrix){var m11=this.m[0]*matrix.m[0]+this.m[2]*matrix.m[1];var m12=this.m[1]*matrix.m[0]+this.m[3]*matrix.m[1];var m21=this.m[0]*matrix.m[2]+this.m[2]*matrix.m[3];var m22=this.m[1]*matrix.m[2]+this.m[3]*matrix.m[3];var dx=this.m[0]*matrix.m[4]+this.m[2]*matrix.m[5]+this.m[4];var dy=this.m[1]*matrix.m[4]+this.m[3]*matrix.m[5]+this.m[5];this.m[0]=m11;this.m[1]=m12;this.m[2]=m21;this.m[3]=m22;this.m[4]=dx;this.m[5]=dy;return this;},/**
     * Invert the matrix
     * @method
     * @memberof Konva.Transform.prototype
     * @returns {Konva.Transform}
     */invert:function invert(){var d=1/(this.m[0]*this.m[3]-this.m[1]*this.m[2]);var m0=this.m[3]*d;var m1=-this.m[1]*d;var m2=-this.m[2]*d;var m3=this.m[0]*d;var m4=d*(this.m[2]*this.m[5]-this.m[3]*this.m[4]);var m5=d*(this.m[1]*this.m[4]-this.m[0]*this.m[5]);this.m[0]=m0;this.m[1]=m1;this.m[2]=m2;this.m[3]=m3;this.m[4]=m4;this.m[5]=m5;return this;},/**
     * return matrix
     * @method
     * @memberof Konva.Transform.prototype
     */getMatrix:function getMatrix(){return this.m;},/**
     * set to absolute position via translation
     * @method
     * @memberof Konva.Transform.prototype
     * @returns {Konva.Transform}
     * @author ericdrowell
     */setAbsolutePosition:function setAbsolutePosition(x,y){var m0=this.m[0],m1=this.m[1],m2=this.m[2],m3=this.m[3],m4=this.m[4],m5=this.m[5],yt=(m0*(y-m5)-m1*(x-m4))/(m0*m3-m1*m2),xt=(x-m4-m2*yt)/m0;return this.translate(xt,yt);}};// CONSTANTS
var CONTEXT_2D='2d',OBJECT_ARRAY='[object Array]',OBJECT_NUMBER='[object Number]',OBJECT_STRING='[object String]',OBJECT_BOOLEAN='[object Boolean]',PI_OVER_DEG180=Math.PI/180,DEG180_OVER_PI=180/Math.PI,HASH='#',EMPTY_STRING='',ZERO='0',KONVA_WARNING='Konva warning: ',KONVA_ERROR='Konva error: ',RGB_PAREN='rgb(',COLORS={aliceblue:[240,248,255],antiquewhite:[250,235,215],aqua:[0,255,255],aquamarine:[127,255,212],azure:[240,255,255],beige:[245,245,220],bisque:[255,228,196],black:[0,0,0],blanchedalmond:[255,235,205],blue:[0,0,255],blueviolet:[138,43,226],brown:[165,42,42],burlywood:[222,184,135],cadetblue:[95,158,160],chartreuse:[127,255,0],chocolate:[210,105,30],coral:[255,127,80],cornflowerblue:[100,149,237],cornsilk:[255,248,220],crimson:[220,20,60],cyan:[0,255,255],darkblue:[0,0,139],darkcyan:[0,139,139],darkgoldenrod:[184,132,11],darkgray:[169,169,169],darkgreen:[0,100,0],darkgrey:[169,169,169],darkkhaki:[189,183,107],darkmagenta:[139,0,139],darkolivegreen:[85,107,47],darkorange:[255,140,0],darkorchid:[153,50,204],darkred:[139,0,0],darksalmon:[233,150,122],darkseagreen:[143,188,143],darkslateblue:[72,61,139],darkslategray:[47,79,79],darkslategrey:[47,79,79],darkturquoise:[0,206,209],darkviolet:[148,0,211],deeppink:[255,20,147],deepskyblue:[0,191,255],dimgray:[105,105,105],dimgrey:[105,105,105],dodgerblue:[30,144,255],firebrick:[178,34,34],floralwhite:[255,255,240],forestgreen:[34,139,34],fuchsia:[255,0,255],gainsboro:[220,220,220],ghostwhite:[248,248,255],gold:[255,215,0],goldenrod:[218,165,32],gray:[128,128,128],green:[0,128,0],greenyellow:[173,255,47],grey:[128,128,128],honeydew:[240,255,240],hotpink:[255,105,180],indianred:[205,92,92],indigo:[75,0,130],ivory:[255,255,240],khaki:[240,230,140],lavender:[230,230,250],lavenderblush:[255,240,245],lawngreen:[124,252,0],lemonchiffon:[255,250,205],lightblue:[173,216,230],lightcoral:[240,128,128],lightcyan:[224,255,255],lightgoldenrodyellow:[250,250,210],lightgray:[211,211,211],lightgreen:[144,238,144],lightgrey:[211,211,211],lightpink:[255,182,193],lightsalmon:[255,160,122],lightseagreen:[32,178,170],lightskyblue:[135,206,250],lightslategray:[119,136,153],lightslategrey:[119,136,153],lightsteelblue:[176,196,222],lightyellow:[255,255,224],lime:[0,255,0],limegreen:[50,205,50],linen:[250,240,230],magenta:[255,0,255],maroon:[128,0,0],mediumaquamarine:[102,205,170],mediumblue:[0,0,205],mediumorchid:[186,85,211],mediumpurple:[147,112,219],mediumseagreen:[60,179,113],mediumslateblue:[123,104,238],mediumspringgreen:[0,250,154],mediumturquoise:[72,209,204],mediumvioletred:[199,21,133],midnightblue:[25,25,112],mintcream:[245,255,250],mistyrose:[255,228,225],moccasin:[255,228,181],navajowhite:[255,222,173],navy:[0,0,128],oldlace:[253,245,230],olive:[128,128,0],olivedrab:[107,142,35],orange:[255,165,0],orangered:[255,69,0],orchid:[218,112,214],palegoldenrod:[238,232,170],palegreen:[152,251,152],paleturquoise:[175,238,238],palevioletred:[219,112,147],papayawhip:[255,239,213],peachpuff:[255,218,185],peru:[205,133,63],pink:[255,192,203],plum:[221,160,203],powderblue:[176,224,230],purple:[128,0,128],rebeccapurple:[102,51,153],red:[255,0,0],rosybrown:[188,143,143],royalblue:[65,105,225],saddlebrown:[139,69,19],salmon:[250,128,114],sandybrown:[244,164,96],seagreen:[46,139,87],seashell:[255,245,238],sienna:[160,82,45],silver:[192,192,192],skyblue:[135,206,235],slateblue:[106,90,205],slategray:[119,128,144],slategrey:[119,128,144],snow:[255,255,250],springgreen:[0,255,127],steelblue:[70,130,180],tan:[210,180,140],teal:[0,128,128],thistle:[216,191,216],transparent:[255,255,255,0],tomato:[255,99,71],turquoise:[64,224,208],violet:[238,130,238],wheat:[245,222,179],white:[255,255,255],whitesmoke:[245,245,245],yellow:[255,255,0],yellowgreen:[154,205,5]},RGB_REGEX=/rgb\((\d{1,3}),(\d{1,3}),(\d{1,3})\)/;/**
   * @namespace Util
   * @memberof Konva
   */Konva.Util={/*
    * cherry-picked utilities from underscore.js
    */_isElement:function _isElement(obj){return!!(obj&&obj.nodeType==1);},_isFunction:function _isFunction(obj){return!!(obj&&obj.constructor&&obj.call&&obj.apply);},_isObject:function _isObject(obj){return!!obj&&obj.constructor===Object;},_isArray:function _isArray(obj){return Object.prototype.toString.call(obj)===OBJECT_ARRAY;},_isNumber:function _isNumber(obj){return Object.prototype.toString.call(obj)===OBJECT_NUMBER&&!isNaN(obj)&&isFinite(obj);},_isString:function _isString(obj){return Object.prototype.toString.call(obj)===OBJECT_STRING;},_isBoolean:function _isBoolean(obj){return Object.prototype.toString.call(obj)===OBJECT_BOOLEAN;},// arrays are objects too
isObject:function isObject(val){return val instanceof Object;},isValidSelector:function isValidSelector(selector){if(typeof selector!=='string'){return false;}var firstChar=selector[0];return firstChar==='#'||firstChar==='.'||firstChar===firstChar.toUpperCase();},_sign:function _sign(number){if(number===0){return 0;}if(number>0){return 1;}else{return-1;}},createCanvasElement:function createCanvasElement(){var canvas=Konva.isBrowser?Konva.document.createElement('canvas'):new Konva._nodeCanvas();// on some environments canvas.style is readonly
try{canvas.style=canvas.style||{};}catch(e){}return canvas;},_isInDocument:function _isInDocument(el){while(el=el.parentNode){if(el==Konva.document){return true;}}return false;},_simplifyArray:function _simplifyArray(arr){var retArr=[],len=arr.length,util=Konva.Util,n,val;for(n=0;n<len;n++){val=arr[n];if(util._isNumber(val)){val=Math.round(val*1000)/1000;}else if(!util._isString(val)){val=val.toString();}retArr.push(val);}return retArr;},/*
    * arg can be an image object or image data
    */_getImage:function _getImage(arg,callback){var imageObj,canvas;// if arg is null or undefined
if(!arg){callback(null);}else if(this._isElement(arg)){// if arg is already an image object
callback(arg);}else if(this._isString(arg)){// if arg is a string, then it's a data url
imageObj=new Konva.window.Image();imageObj.onload=function(){callback(imageObj);};imageObj.src=arg;}else if(arg.data){//if arg is an object that contains the data property, it's an image object
canvas=Konva.Util.createCanvasElement();canvas.width=arg.width;canvas.height=arg.height;var _context=canvas.getContext(CONTEXT_2D);_context.putImageData(arg,0,0);this._getImage(canvas.toDataURL(),callback);}else{callback(null);}},_getRGBAString:function _getRGBAString(obj){var red=obj.red||0,green=obj.green||0,blue=obj.blue||0,alpha=obj.alpha||1;return['rgba(',red,',',green,',',blue,',',alpha,')'].join(EMPTY_STRING);},_rgbToHex:function _rgbToHex(r,g,b){return((1<<24)+(r<<16)+(g<<8)+b).toString(16).slice(1);},_hexToRgb:function _hexToRgb(hex){hex=hex.replace(HASH,EMPTY_STRING);var bigint=parseInt(hex,16);return{r:bigint>>16&255,g:bigint>>8&255,b:bigint&255};},/**
     * return random hex color
     * @method
     * @memberof Konva.Util.prototype
     */getRandomColor:function getRandomColor(){var randColor=(Math.random()*0xffffff<<0).toString(16);while(randColor.length<6){randColor=ZERO+randColor;}return HASH+randColor;},/**
     * return value with default fallback
     * @method
     * @memberof Konva.Util.prototype
     */get:function get(val,def){if(val===undefined){return def;}else{return val;}},/**
     * get RGB components of a color
     * @method
     * @memberof Konva.Util.prototype
     * @param {String} color
     * @example
     * // each of the following examples return {r:0, g:0, b:255}
     * var rgb = Konva.Util.getRGB('blue');
     * var rgb = Konva.Util.getRGB('#0000ff');
     * var rgb = Konva.Util.getRGB('rgb(0,0,255)');
     */getRGB:function getRGB(color){var rgb;// color string
if(color in COLORS){rgb=COLORS[color];return{r:rgb[0],g:rgb[1],b:rgb[2]};}else if(color[0]===HASH){// hex
return this._hexToRgb(color.substring(1));}else if(color.substr(0,4)===RGB_PAREN){// rgb string
rgb=RGB_REGEX.exec(color.replace(/ /g,''));return{r:parseInt(rgb[1],10),g:parseInt(rgb[2],10),b:parseInt(rgb[3],10)};}else{// default
return{r:0,g:0,b:0};}},// convert any color string to RGBA object
// from https://github.com/component/color-parser
colorToRGBA:function colorToRGBA(str){str=str||'black';return Konva.Util._namedColorToRBA(str)||Konva.Util._hex3ColorToRGBA(str)||Konva.Util._hex6ColorToRGBA(str)||Konva.Util._rgbColorToRGBA(str)||Konva.Util._rgbaColorToRGBA(str);},// Parse named css color. Like "green"
_namedColorToRBA:function _namedColorToRBA(str){var c=COLORS[str.toLowerCase()];if(!c){return null;}return{r:c[0],g:c[1],b:c[2],a:1};},// Parse rgb(n, n, n)
_rgbColorToRGBA:function _rgbColorToRGBA(str){if(str.indexOf('rgb(')===0){str=str.match(/rgb\(([^)]+)\)/)[1];var parts=str.split(/ *, */).map(Number);return{r:parts[0],g:parts[1],b:parts[2],a:1};}},// Parse rgba(n, n, n, n)
_rgbaColorToRGBA:function _rgbaColorToRGBA(str){if(str.indexOf('rgba(')===0){str=str.match(/rgba\(([^)]+)\)/)[1];var parts=str.split(/ *, */).map(Number);return{r:parts[0],g:parts[1],b:parts[2],a:parts[3]};}},// Parse #nnnnnn
_hex6ColorToRGBA:function _hex6ColorToRGBA(str){if(str[0]==='#'&&str.length===7){return{r:parseInt(str.slice(1,3),16),g:parseInt(str.slice(3,5),16),b:parseInt(str.slice(5,7),16),a:1};}},// Parse #nnn
_hex3ColorToRGBA:function _hex3ColorToRGBA(str){if(str[0]==='#'&&str.length===4){return{r:parseInt(str[1]+str[1],16),g:parseInt(str[2]+str[2],16),b:parseInt(str[3]+str[3],16),a:1};}},// o1 takes precedence over o2
_merge:function _merge(o1,o2){var retObj=this._clone(o2);for(var key in o1){if(this._isObject(o1[key])){retObj[key]=this._merge(o1[key],retObj[key]);}else{retObj[key]=o1[key];}}return retObj;},trimRight:function trimRight(str){return str.replace(/\s+$/,'');},trimLeft:function trimLeft(str){return str.replace(/^\s+/,'');},/**
     * check intersection of two client rectangles
     * @method
     * @memberof Konva.Util.prototype
     */haveIntersection:function haveIntersection(r1,r2){return!(r2.x>r1.x+r1.width||r2.x+r2.width<r1.x||r2.y>r1.y+r1.height||r2.y+r2.height<r1.y);},cloneObject:function cloneObject(obj){var retObj={};for(var key in obj){if(this._isObject(obj[key])){retObj[key]=this.cloneObject(obj[key]);}else if(this._isArray(obj[key])){retObj[key]=this.cloneArray(obj[key]);}else{retObj[key]=obj[key];}}return retObj;},cloneArray:function cloneArray(arr){return arr.slice(0);},_degToRad:function _degToRad(deg){return deg*PI_OVER_DEG180;},_radToDeg:function _radToDeg(rad){return rad*DEG180_OVER_PI;},_capitalize:function _capitalize(str){return str.charAt(0).toUpperCase()+str.slice(1);},throw:function _throw(str){throw new Error(KONVA_ERROR+str);},error:function error(str){console.error(KONVA_ERROR+str);},warn:function warn(str){/*
             * IE9 on Windows7 64bit will throw a JS error
             * if we don't use window.console in the conditional
             */if(Konva.global.console&&console.warn&&Konva.showWarnings){console.warn(KONVA_WARNING+str);}},extend:function extend(child,parent){function Ctor(){this.constructor=child;}Ctor.prototype=parent.prototype;var oldProto=child.prototype;child.prototype=new Ctor();for(var key in oldProto){if(oldProto.hasOwnProperty(key)){child.prototype[key]=oldProto[key];}}child.__super__=parent.prototype;// create reference to parent
child.super=parent;},/**
     * adds methods to a constructor prototype
     * @method
     * @memberof Konva.Util.prototype
     * @param {Function} constructor
     * @param {Object} methods
     */addMethods:function addMethods(constructor,methods){var key;for(key in methods){constructor.prototype[key]=methods[key];}},_getControlPoints:function _getControlPoints(x0,y0,x1,y1,x2,y2,t){var d01=Math.sqrt(Math.pow(x1-x0,2)+Math.pow(y1-y0,2)),d12=Math.sqrt(Math.pow(x2-x1,2)+Math.pow(y2-y1,2)),fa=t*d01/(d01+d12),fb=t*d12/(d01+d12),p1x=x1-fa*(x2-x0),p1y=y1-fa*(y2-y0),p2x=x1+fb*(x2-x0),p2y=y1+fb*(y2-y0);return[p1x,p1y,p2x,p2y];},_expandPoints:function _expandPoints(p,tension){var len=p.length,allPoints=[],n,cp;for(n=2;n<len-2;n+=2){cp=Konva.Util._getControlPoints(p[n-2],p[n-1],p[n],p[n+1],p[n+2],p[n+3],tension);allPoints.push(cp[0]);allPoints.push(cp[1]);allPoints.push(p[n]);allPoints.push(p[n+1]);allPoints.push(cp[2]);allPoints.push(cp[3]);}return allPoints;},_removeLastLetter:function _removeLastLetter(str){return str.substring(0,str.length-1);},each:function each(obj,func){for(var key in obj){func(key,obj[key]);}},_inRange:function _inRange(val,left,right){return left<=val&&val<right;},_getProjectionToSegment:function _getProjectionToSegment(x1,y1,x2,y2,x3,y3){var x,y,dist;var pd2=(x1-x2)*(x1-x2)+(y1-y2)*(y1-y2);if(pd2==0){x=x1;y=y1;dist=(x3-x2)*(x3-x2)+(y3-y2)*(y3-y2);}else{var u=((x3-x1)*(x2-x1)+(y3-y1)*(y2-y1))/pd2;if(u<0){x=x1;y=y1;dist=(x1-x3)*(x1-x3)+(y1-y3)*(y1-y3);}else if(u>1.0){x=x2;y=y2;dist=(x2-x3)*(x2-x3)+(y2-y3)*(y2-y3);}else{x=x1+u*(x2-x1);y=y1+u*(y2-y1);dist=(x-x3)*(x-x3)+(y-y3)*(y-y3);}}return[x,y,dist];},// line as array of points.
// line might be closed
_getProjectionToLine:function _getProjectionToLine(pt,line,isClosed){var pc=Konva.Util.cloneObject(pt);var dist=Number.MAX_VALUE;line.forEach(function(p1,i){if(!isClosed&&i===line.length-1){return;}var p2=line[(i+1)%line.length];var proj=Konva.Util._getProjectionToSegment(p1.x,p1.y,p2.x,p2.y,pt.x,pt.y);var px=proj[0],py=proj[1],pdist=proj[2];if(pdist<dist){pc.x=px;pc.y=py;dist=pdist;}});return pc;},_prepareArrayForTween:function _prepareArrayForTween(startArray,endArray,isClosed){var n,start=[],end=[];if(startArray.length>endArray.length){var temp=endArray;endArray=startArray;startArray=temp;}for(n=0;n<startArray.length;n+=2){start.push({x:startArray[n],y:startArray[n+1]});}for(n=0;n<endArray.length;n+=2){end.push({x:endArray[n],y:endArray[n+1]});}var newStart=[];end.forEach(function(point){var pr=Konva.Util._getProjectionToLine(point,start,isClosed);newStart.push(pr.x);newStart.push(pr.y);});return newStart;},_prepareToStringify:function _prepareToStringify(obj){var desc;obj.visitedByCircularReferenceRemoval=true;for(var key in obj){if(!(obj.hasOwnProperty(key)&&obj[key]&&_typeof(obj[key])=='object')){continue;}desc=Object.getOwnPropertyDescriptor(obj,key);if(obj[key].visitedByCircularReferenceRemoval||Konva.Util._isElement(obj[key])){if(desc.configurable){delete obj[key];}else{return null;}}else if(Konva.Util._prepareToStringify(obj[key])===null){if(desc.configurable){delete obj[key];}else{return null;}}}delete obj.visitedByCircularReferenceRemoval;return obj;}};})();(function(){'use strict';// calculate pixel ratio
var _pixelRatio;function getDevicePixelRatio(){if(_pixelRatio){return _pixelRatio;}var canvas=Konva.Util.createCanvasElement();var context=canvas.getContext('2d');_pixelRatio=function(){var devicePixelRatio=Konva.window.devicePixelRatio||1,backingStoreRatio=context.webkitBackingStorePixelRatio||context.mozBackingStorePixelRatio||context.msBackingStorePixelRatio||context.oBackingStorePixelRatio||context.backingStorePixelRatio||1;return devicePixelRatio/backingStoreRatio;}();return _pixelRatio;}/**
   * Canvas Renderer constructor
   * @constructor
   * @abstract
   * @memberof Konva
   * @param {Object} config
   * @param {Number} config.width
   * @param {Number} config.height
   * @param {Number} config.pixelRatio KonvaJS automatically handles pixel ratio adjustments in order to render crisp drawings
   *  on all devices. Most desktops, low end tablets, and low end phones, have device pixel ratios
   *  of 1.  Some high end tablets and phones, like iPhones and iPads (not the mini) have a device pixel ratio
   *  of 2.  Some Macbook Pros, and iMacs also have a device pixel ratio of 2.  Some high end Android devices have pixel
   *  ratios of 2 or 3.  Some browsers like Firefox allow you to configure the pixel ratio of the viewport.  Unless otherwise
   *  specified, the pixel ratio will be defaulted to the actual device pixel ratio.  You can override the device pixel
   *  ratio for special situations, or, if you don't want the pixel ratio to be taken into account, you can set it to 1.
   */Konva.Canvas=function(config){this.init(config);};Konva.Canvas.prototype={init:function init(config){var conf=config||{};var pixelRatio=conf.pixelRatio||Konva.pixelRatio||getDevicePixelRatio();this.pixelRatio=pixelRatio;this._canvas=Konva.Util.createCanvasElement();// set inline styles
this._canvas.style.padding=0;this._canvas.style.margin=0;this._canvas.style.border=0;this._canvas.style.background='transparent';this._canvas.style.position='absolute';this._canvas.style.top=0;this._canvas.style.left=0;},/**
     * get canvas context
     * @method
     * @memberof Konva.Canvas.prototype
     * @returns {CanvasContext} context
     */getContext:function getContext(){return this.context;},/**
     * get pixel ratio
     * @method
     * @memberof Konva.Canvas.prototype
     * @returns {Number} pixel ratio
     */getPixelRatio:function getPixelRatio(){return this.pixelRatio;},/**
     * get pixel ratio
     * @method
     * @memberof Konva.Canvas.prototype
     * @param {Number} pixelRatio KonvaJS automatically handles pixel ratio adustments in order to render crisp drawings
     *  on all devices. Most desktops, low end tablets, and low end phones, have device pixel ratios
     *  of 1.  Some high end tablets and phones, like iPhones and iPads have a device pixel ratio
     *  of 2.  Some Macbook Pros, and iMacs also have a device pixel ratio of 2.  Some high end Android devices have pixel
     *  ratios of 2 or 3.  Some browsers like Firefox allow you to configure the pixel ratio of the viewport.  Unless otherwise
     *  specificed, the pixel ratio will be defaulted to the actual device pixel ratio.  You can override the device pixel
     *  ratio for special situations, or, if you don't want the pixel ratio to be taken into account, you can set it to 1.
     */setPixelRatio:function setPixelRatio(pixelRatio){var previousRatio=this.pixelRatio;this.pixelRatio=pixelRatio;this.setSize(this.getWidth()/previousRatio,this.getHeight()/previousRatio);},/**
     * set width
     * @method
     * @memberof Konva.Canvas.prototype
     * @param {Number} width
     */setWidth:function setWidth(width){// take into account pixel ratio
this.width=this._canvas.width=width*this.pixelRatio;this._canvas.style.width=width+'px';var pixelRatio=this.pixelRatio,_context=this.getContext()._context;_context.scale(pixelRatio,pixelRatio);},/**
     * set height
     * @method
     * @memberof Konva.Canvas.prototype
     * @param {Number} height
     */setHeight:function setHeight(height){// take into account pixel ratio
this.height=this._canvas.height=height*this.pixelRatio;this._canvas.style.height=height+'px';var pixelRatio=this.pixelRatio,_context=this.getContext()._context;_context.scale(pixelRatio,pixelRatio);},/**
     * get width
     * @method
     * @memberof Konva.Canvas.prototype
     * @returns {Number} width
     */getWidth:function getWidth(){return this.width;},/**
     * get height
     * @method
     * @memberof Konva.Canvas.prototype
     * @returns {Number} height
     */getHeight:function getHeight(){return this.height;},/**
     * set size
     * @method
     * @memberof Konva.Canvas.prototype
     * @param {Number} width
     * @param {Number} height
     */setSize:function setSize(width,height){this.setWidth(width);this.setHeight(height);},/**
     * to data url
     * @method
     * @memberof Konva.Canvas.prototype
     * @param {String} mimeType
     * @param {Number} quality between 0 and 1 for jpg mime types
     * @returns {String} data url string
     */toDataURL:function toDataURL(mimeType,quality){try{// If this call fails (due to browser bug, like in Firefox 3.6),
// then revert to previous no-parameter image/png behavior
return this._canvas.toDataURL(mimeType,quality);}catch(e){try{return this._canvas.toDataURL();}catch(err){Konva.Util.warn('Unable to get data URL. '+err.message);return'';}}}};Konva.SceneCanvas=function(config){var conf=config||{};var width=conf.width||0,height=conf.height||0;Konva.Canvas.call(this,conf);this.context=new Konva.SceneContext(this);this.setSize(width,height);};Konva.Util.extend(Konva.SceneCanvas,Konva.Canvas);Konva.HitCanvas=function(config){var conf=config||{};var width=conf.width||0,height=conf.height||0;Konva.Canvas.call(this,conf);this.context=new Konva.HitContext(this);this.setSize(width,height);this.hitCanvas=true;};Konva.Util.extend(Konva.HitCanvas,Konva.Canvas);})();(function(){'use strict';var COMMA=',',OPEN_PAREN='(',CLOSE_PAREN=')',OPEN_PAREN_BRACKET='([',CLOSE_BRACKET_PAREN='])',SEMICOLON=';',DOUBLE_PAREN='()',// EMPTY_STRING = '',
EQUALS='=',// SET = 'set',
CONTEXT_METHODS=['arc','arcTo','beginPath','bezierCurveTo','clearRect','clip','closePath','createLinearGradient','createPattern','createRadialGradient','drawImage','fill','fillText','getImageData','createImageData','lineTo','moveTo','putImageData','quadraticCurveTo','rect','restore','rotate','save','scale','setLineDash','setTransform','stroke','strokeText','transform','translate'];var CONTEXT_PROPERTIES=['fillStyle','strokeStyle','shadowColor','shadowBlur','shadowOffsetX','shadowOffsetY','lineCap','lineDashOffset','lineJoin','lineWidth','miterLimit','font','textAlign','textBaseline','globalAlpha','globalCompositeOperation'];/**
   * Canvas Context constructor
   * @constructor
   * @abstract
   * @memberof Konva
   */Konva.Context=function(canvas){this.init(canvas);};Konva.Context.prototype={init:function init(canvas){this.canvas=canvas;this._context=canvas._canvas.getContext('2d');if(Konva.enableTrace){this.traceArr=[];this._enableTrace();}},/**
     * fill shape
     * @method
     * @memberof Konva.Context.prototype
     * @param {Konva.Shape} shape
     */fillShape:function fillShape(shape){if(shape.getFillEnabled()){this._fill(shape);}},/**
     * stroke shape
     * @method
     * @memberof Konva.Context.prototype
     * @param {Konva.Shape} shape
     */strokeShape:function strokeShape(shape){if(shape.getStrokeEnabled()){this._stroke(shape);}},/**
     * fill then stroke
     * @method
     * @memberof Konva.Context.prototype
     * @param {Konva.Shape} shape
     */fillStrokeShape:function fillStrokeShape(shape){var fillEnabled=shape.getFillEnabled();if(fillEnabled){this._fill(shape);}if(shape.getStrokeEnabled()){this._stroke(shape);}},/**
     * get context trace if trace is enabled
     * @method
     * @memberof Konva.Context.prototype
     * @param {Boolean} relaxed if false, return strict context trace, which includes method names, method parameters
     *  properties, and property values.  If true, return relaxed context trace, which only returns method names and
     *  properites.
     * @returns {String}
     */getTrace:function getTrace(relaxed){var traceArr=this.traceArr,len=traceArr.length,str='',n,trace,method,args;for(n=0;n<len;n++){trace=traceArr[n];method=trace.method;// methods
if(method){args=trace.args;str+=method;if(relaxed){str+=DOUBLE_PAREN;}else{if(Konva.Util._isArray(args[0])){str+=OPEN_PAREN_BRACKET+args.join(COMMA)+CLOSE_BRACKET_PAREN;}else{str+=OPEN_PAREN+args.join(COMMA)+CLOSE_PAREN;}}}else{// properties
str+=trace.property;if(!relaxed){str+=EQUALS+trace.val;}}str+=SEMICOLON;}return str;},/**
     * clear trace if trace is enabled
     * @method
     * @memberof Konva.Context.prototype
     */clearTrace:function clearTrace(){this.traceArr=[];},_trace:function _trace(str){var traceArr=this.traceArr,len;traceArr.push(str);len=traceArr.length;if(len>=Konva.traceArrMax){traceArr.shift();}},/**
     * reset canvas context transform
     * @method
     * @memberof Konva.Context.prototype
     */reset:function reset(){var pixelRatio=this.getCanvas().getPixelRatio();this.setTransform(1*pixelRatio,0,0,1*pixelRatio,0,0);},/**
     * get canvas
     * @method
     * @memberof Konva.Context.prototype
     * @returns {Konva.Canvas}
     */getCanvas:function getCanvas(){return this.canvas;},/**
     * clear canvas
     * @method
     * @memberof Konva.Context.prototype
     * @param {Object} [bounds]
     * @param {Number} [bounds.x]
     * @param {Number} [bounds.y]
     * @param {Number} [bounds.width]
     * @param {Number} [bounds.height]
     */clear:function clear(bounds){var canvas=this.getCanvas();if(bounds){this.clearRect(bounds.x||0,bounds.y||0,bounds.width||0,bounds.height||0);}else{this.clearRect(0,0,canvas.getWidth()/canvas.pixelRatio,canvas.getHeight()/canvas.pixelRatio);}},_applyLineCap:function _applyLineCap(shape){var lineCap=shape.getLineCap();if(lineCap){this.setAttr('lineCap',lineCap);}},_applyOpacity:function _applyOpacity(shape){var absOpacity=shape.getAbsoluteOpacity();if(absOpacity!==1){this.setAttr('globalAlpha',absOpacity);}},_applyLineJoin:function _applyLineJoin(shape){var lineJoin=shape.getLineJoin();if(lineJoin){this.setAttr('lineJoin',lineJoin);}},setAttr:function setAttr(attr,val){this._context[attr]=val;},// context pass through methods
arc:function arc(){var a=arguments;this._context.arc(a[0],a[1],a[2],a[3],a[4],a[5]);},beginPath:function beginPath(){this._context.beginPath();},bezierCurveTo:function bezierCurveTo(){var a=arguments;this._context.bezierCurveTo(a[0],a[1],a[2],a[3],a[4],a[5]);},clearRect:function clearRect(){var a=arguments;this._context.clearRect(a[0],a[1],a[2],a[3]);},clip:function clip(){this._context.clip();},closePath:function closePath(){this._context.closePath();},createImageData:function createImageData(){var a=arguments;if(a.length===2){return this._context.createImageData(a[0],a[1]);}else if(a.length===1){return this._context.createImageData(a[0]);}},createLinearGradient:function createLinearGradient(){var a=arguments;return this._context.createLinearGradient(a[0],a[1],a[2],a[3]);},createPattern:function createPattern(){var a=arguments;return this._context.createPattern(a[0],a[1]);},createRadialGradient:function createRadialGradient(){var a=arguments;return this._context.createRadialGradient(a[0],a[1],a[2],a[3],a[4],a[5]);},drawImage:function drawImage(){var a=arguments,_context=this._context;if(a.length===3){_context.drawImage(a[0],a[1],a[2]);}else if(a.length===5){_context.drawImage(a[0],a[1],a[2],a[3],a[4]);}else if(a.length===9){_context.drawImage(a[0],a[1],a[2],a[3],a[4],a[5],a[6],a[7],a[8]);}},isPointInPath:function isPointInPath(x,y){return this._context.isPointInPath(x,y);},fill:function fill(){this._context.fill();},fillRect:function fillRect(x,y,width,height){this._context.fillRect(x,y,width,height);},strokeRect:function strokeRect(x,y,width,height){this._context.strokeRect(x,y,width,height);},fillText:function fillText(){var a=arguments;this._context.fillText(a[0],a[1],a[2]);},measureText:function measureText(text){return this._context.measureText(text);},getImageData:function getImageData(){var a=arguments;return this._context.getImageData(a[0],a[1],a[2],a[3]);},lineTo:function lineTo(){var a=arguments;this._context.lineTo(a[0],a[1]);},moveTo:function moveTo(){var a=arguments;this._context.moveTo(a[0],a[1]);},rect:function rect(){var a=arguments;this._context.rect(a[0],a[1],a[2],a[3]);},putImageData:function putImageData(){var a=arguments;this._context.putImageData(a[0],a[1],a[2]);},quadraticCurveTo:function quadraticCurveTo(){var a=arguments;this._context.quadraticCurveTo(a[0],a[1],a[2],a[3]);},restore:function restore(){this._context.restore();},rotate:function rotate(){var a=arguments;this._context.rotate(a[0]);},save:function save(){this._context.save();},scale:function scale(){var a=arguments;this._context.scale(a[0],a[1]);},setLineDash:function setLineDash(){var a=arguments,_context=this._context;// works for Chrome and IE11
if(this._context.setLineDash){_context.setLineDash(a[0]);}else if('mozDash'in _context){// verified that this works in firefox
_context.mozDash=a[0];}else if('webkitLineDash'in _context){// does not currently work for Safari
_context.webkitLineDash=a[0];}// no support for IE9 and IE10
},getLineDash:function getLineDash(){return this._context.getLineDash();},setTransform:function setTransform(){var a=arguments;this._context.setTransform(a[0],a[1],a[2],a[3],a[4],a[5]);},stroke:function stroke(){this._context.stroke();},strokeText:function strokeText(){var a=arguments;this._context.strokeText(a[0],a[1],a[2]);},transform:function transform(){var a=arguments;this._context.transform(a[0],a[1],a[2],a[3],a[4],a[5]);},translate:function translate(){var a=arguments;this._context.translate(a[0],a[1]);},_enableTrace:function _enableTrace(){var that=this,len=CONTEXT_METHODS.length,_simplifyArray=Konva.Util._simplifyArray,origSetter=this.setAttr,n,args;// to prevent creating scope function at each loop
var func=function func(methodName){var origMethod=that[methodName],ret;that[methodName]=function(){args=_simplifyArray(Array.prototype.slice.call(arguments,0));ret=origMethod.apply(that,arguments);that._trace({method:methodName,args:args});return ret;};};// methods
for(n=0;n<len;n++){func(CONTEXT_METHODS[n]);}// attrs
that.setAttr=function(){origSetter.apply(that,arguments);var prop=arguments[0];var val=arguments[1];if(prop==='shadowOffsetX'||prop==='shadowOffsetY'||prop==='shadowBlur'){val=val/this.canvas.getPixelRatio();}that._trace({property:prop,val:val});};}};CONTEXT_PROPERTIES.forEach(function(prop){Object.defineProperty(Konva.Context.prototype,prop,{get:function get(){return this._context[prop];},set:function set(val){this._context[prop]=val;}});});Konva.SceneContext=function(canvas){Konva.Context.call(this,canvas);};Konva.SceneContext.prototype={_fillColor:function _fillColor(shape){var fill=shape.fill();this.setAttr('fillStyle',fill);shape._fillFunc(this);},_fillPattern:function _fillPattern(shape){var fillPatternX=shape.getFillPatternX(),fillPatternY=shape.getFillPatternY(),fillPatternScale=shape.getFillPatternScale(),fillPatternRotation=Konva.getAngle(shape.getFillPatternRotation()),fillPatternOffset=shape.getFillPatternOffset();if(fillPatternX||fillPatternY){this.translate(fillPatternX||0,fillPatternY||0);}if(fillPatternRotation){this.rotate(fillPatternRotation);}if(fillPatternScale){this.scale(fillPatternScale.x,fillPatternScale.y);}if(fillPatternOffset){this.translate(-1*fillPatternOffset.x,-1*fillPatternOffset.y);}this.setAttr('fillStyle',this.createPattern(shape.getFillPatternImage(),shape.getFillPatternRepeat()||'repeat'));this.fill();},_fillLinearGradient:function _fillLinearGradient(shape){var start=shape.getFillLinearGradientStartPoint(),end=shape.getFillLinearGradientEndPoint(),colorStops=shape.getFillLinearGradientColorStops(),grd=this.createLinearGradient(start.x,start.y,end.x,end.y);if(colorStops){// build color stops
for(var n=0;n<colorStops.length;n+=2){grd.addColorStop(colorStops[n],colorStops[n+1]);}this.setAttr('fillStyle',grd);shape._fillFunc(this);}},_fillRadialGradient:function _fillRadialGradient(shape){var start=shape.getFillRadialGradientStartPoint(),end=shape.getFillRadialGradientEndPoint(),startRadius=shape.getFillRadialGradientStartRadius(),endRadius=shape.getFillRadialGradientEndRadius(),colorStops=shape.getFillRadialGradientColorStops(),grd=this.createRadialGradient(start.x,start.y,startRadius,end.x,end.y,endRadius);// build color stops
for(var n=0;n<colorStops.length;n+=2){grd.addColorStop(colorStops[n],colorStops[n+1]);}this.setAttr('fillStyle',grd);this.fill();},_fill:function _fill(shape){var hasColor=shape.fill(),fillPriority=shape.getFillPriority();// priority fills
if(hasColor&&fillPriority==='color'){this._fillColor(shape);return;}var hasPattern=shape.getFillPatternImage();if(hasPattern&&fillPriority==='pattern'){this._fillPattern(shape);return;}var hasLinearGradient=shape.getFillLinearGradientColorStops();if(hasLinearGradient&&fillPriority==='linear-gradient'){this._fillLinearGradient(shape);return;}var hasRadialGradient=shape.getFillRadialGradientColorStops();if(hasRadialGradient&&fillPriority==='radial-gradient'){this._fillRadialGradient(shape);return;}// now just try and fill with whatever is available
if(hasColor){this._fillColor(shape);}else if(hasPattern){this._fillPattern(shape);}else if(hasLinearGradient){this._fillLinearGradient(shape);}else if(hasRadialGradient){this._fillRadialGradient(shape);}},_strokeLinearGradient:function _strokeLinearGradient(shape){var start=shape.getStrokeLinearGradientStartPoint(),end=shape.getStrokeLinearGradientEndPoint(),colorStops=shape.getStrokeLinearGradientColorStops(),grd=this.createLinearGradient(start.x,start.y,end.x,end.y);if(colorStops){// build color stops
for(var n=0;n<colorStops.length;n+=2){grd.addColorStop(colorStops[n],colorStops[n+1]);}this.setAttr('strokeStyle',grd);}},_stroke:function _stroke(shape){var dash=shape.dash(),// ignore strokeScaleEnabled for Text
strokeScaleEnabled=shape.getStrokeScaleEnabled()||shape instanceof Konva.Text;if(shape.hasStroke()){if(!strokeScaleEnabled){this.save();this.setTransform(1,0,0,1,0,0);}this._applyLineCap(shape);if(dash&&shape.dashEnabled()){this.setLineDash(dash);this.setAttr('lineDashOffset',shape.dashOffset());}this.setAttr('lineWidth',shape.strokeWidth());if(!shape.getShadowForStrokeEnabled()){this.setAttr('shadowColor','rgba(0,0,0,0)');}// TODO - do we need to make like a fill function?
var hasLinearGradient=shape.getStrokeLinearGradientColorStops();if(hasLinearGradient){this._strokeLinearGradient(shape);}else{this.setAttr('strokeStyle',shape.stroke());}shape._strokeFunc(this);if(!strokeScaleEnabled){this.restore();}}},_applyShadow:function _applyShadow(shape){var util=Konva.Util,color=util.get(shape.getShadowRGBA(),'black'),blur=util.get(shape.getShadowBlur(),5),offset=util.get(shape.getShadowOffset(),{x:0,y:0}),scale=shape.getAbsoluteScale(),ratio=this.canvas.getPixelRatio(),scaleX=scale.x*ratio,scaleY=scale.y*ratio;this.setAttr('shadowColor',color);this.setAttr('shadowBlur',blur*Math.min(Math.abs(scaleX),Math.abs(scaleY)));this.setAttr('shadowOffsetX',offset.x*scaleX);this.setAttr('shadowOffsetY',offset.y*scaleY);},_applyGlobalCompositeOperation:function _applyGlobalCompositeOperation(shape){var globalCompositeOperation=shape.getGlobalCompositeOperation();if(globalCompositeOperation!=='source-over'){this.setAttr('globalCompositeOperation',globalCompositeOperation);}}};Konva.Util.extend(Konva.SceneContext,Konva.Context);Konva.HitContext=function(canvas){Konva.Context.call(this,canvas);};Konva.HitContext.prototype={_fill:function _fill(shape){this.save();this.setAttr('fillStyle',shape.colorKey);shape._fillFuncHit(this);this.restore();},_stroke:function _stroke(shape){if(shape.hasStroke()&&shape.strokeHitEnabled()){// ignore strokeScaleEnabled for Text
var strokeScaleEnabled=shape.getStrokeScaleEnabled()||shape instanceof Konva.Text;if(!strokeScaleEnabled){this.save();this.setTransform(1,0,0,1,0,0);}this._applyLineCap(shape);this.setAttr('lineWidth',shape.strokeWidth());this.setAttr('strokeStyle',shape.colorKey);shape._strokeFuncHit(this);if(!strokeScaleEnabled){this.restore();}}}};Konva.Util.extend(Konva.HitContext,Konva.Context);})();(function(){'use strict';// CONSTANTS
var GET='get',SET='set';Konva.Factory={addGetterSetter:function addGetterSetter(constructor,attr,def,validator,after){this.addGetter(constructor,attr,def);this.addSetter(constructor,attr,validator,after);this.addOverloadedGetterSetter(constructor,attr);},addGetter:function addGetter(constructor,attr,def){var method=GET+Konva.Util._capitalize(attr);constructor.prototype[method]=function(){var val=this.attrs[attr];return val===undefined?def:val;};},addSetter:function addSetter(constructor,attr,validator,after){// if (!validator && validator !== null) {
//   console.error(constructor, attr, 'has no validator.');
// }
var method=SET+Konva.Util._capitalize(attr);constructor.prototype[method]=function(val){if(validator&&val!==undefined&&val!==null){val=validator.call(this,val,attr);}this._setAttr(attr,val);if(after){after.call(this);}return this;};},addComponentsGetterSetter:function addComponentsGetterSetter(constructor,attr,components,validator,after){var len=components.length,capitalize=Konva.Util._capitalize,getter=GET+capitalize(attr),setter=SET+capitalize(attr),n,component;// getter
constructor.prototype[getter]=function(){var ret={};for(n=0;n<len;n++){component=components[n];ret[component]=this.getAttr(attr+capitalize(component));}return ret;};// setter
constructor.prototype[setter]=function(val){var oldVal=this.attrs[attr],key;if(validator){val=validator.call(this,val);}for(key in val){if(!val.hasOwnProperty(key)){continue;}this._setAttr(attr+capitalize(key),val[key]);}this._fireChangeEvent(attr,oldVal,val);if(after){after.call(this);}return this;};this.addOverloadedGetterSetter(constructor,attr);},addOverloadedGetterSetter:function addOverloadedGetterSetter(constructor,attr){var capitalizedAttr=Konva.Util._capitalize(attr),setter=SET+capitalizedAttr,getter=GET+capitalizedAttr;constructor.prototype[attr]=function(){// setting
if(arguments.length){this[setter](arguments[0]);return this;}// getting
return this[getter]();};},addDeprecatedGetterSetter:function addDeprecatedGetterSetter(constructor,attr,def,validator){Konva.Util.error('Adding deprecated '+attr);var method=GET+Konva.Util._capitalize(attr);var message=attr+' property is deprecated and will be removed soon. Look at Konva change log for more information.';constructor.prototype[method]=function(){Konva.Util.error(message);var val=this.attrs[attr];return val===undefined?def:val;};this.addSetter(constructor,attr,validator,function(){Konva.Util.error(message);});this.addOverloadedGetterSetter(constructor,attr);},backCompat:function backCompat(constructor,methods){Konva.Util.each(methods,function(oldMethodName,newMethodName){var method=constructor.prototype[newMethodName];var oldGetter=GET+Konva.Util._capitalize(oldMethodName);var oldSetter=SET+Konva.Util._capitalize(oldMethodName);function deprecated(){method.apply(this,arguments);Konva.Util.error('"'+oldMethodName+'" method is deprecated and will be removed soon. Use ""'+newMethodName+'" instead.');}constructor.prototype[oldMethodName]=deprecated;constructor.prototype[oldGetter]=deprecated;constructor.prototype[oldSetter]=deprecated;});},afterSetFilter:function afterSetFilter(){this._filterUpToDate=false;}};Konva.Validators={/**
     * @return {number}
     */RGBComponent:function RGBComponent(val){if(val>255){return 255;}else if(val<0){return 0;}return Math.round(val);},alphaComponent:function alphaComponent(val){if(val>1){return 1;}else if(val<0.0001){// chrome does not honor alpha values of 0
return 0.0001;}return val;},_formatValue:function _formatValue(val){if(Konva.Util._isString(val)){return'"'+val+'"';}if(Object.prototype.toString.call(val)==='[object Number]'){return val;}if(Konva.Util._isBoolean(val)){return val;}return Object.prototype.toString.call(val);},getNumberValidator:function getNumberValidator(){if(Konva.isUnminified){return function(val,attr){if(!Konva.Util._isNumber(val)){Konva.Util.warn(Konva.Validators._formatValue(val)+' is a not valid value for "'+attr+'" attribute. The value should be a number.');}return val;};}},getNumberOrAutoValidator:function getNumberOrAutoValidator(){if(Konva.isUnminified){return function(val,attr){var isNumber=Konva.Util._isNumber(val);var isAuto=val==='auto';if(!(isNumber||isAuto)){Konva.Util.warn(Konva.Validators._formatValue(val)+' is a not valid value for "'+attr+'" attribute. The value should be a number or "auto".');}return val;};}},getStringValidator:function getStringValidator(){if(Konva.isUnminified){return function(val,attr){if(!Konva.Util._isString(val)){Konva.Util.warn(Konva.Validators._formatValue(val)+' is a not valid value for "'+attr+'" attribute. The value should be a string.');}return val;};}},getFunctionValidator:function getFunctionValidator(){if(Konva.isUnminified){return function(val,attr){if(!Konva.Util._isFunction(val)){Konva.Util.warn(Konva.Validators._formatValue(val)+' is a not valid value for "'+attr+'" attribute. The value should be a function.');}return val;};}},getNumberArrayValidator:function getNumberArrayValidator(){if(Konva.isUnminified){return function(val,attr){if(!Konva.Util._isArray(val)){Konva.Util.warn(Konva.Validators._formatValue(val)+' is a not valid value for "'+attr+'" attribute. The value should be a array of numbers.');}else{val.forEach(function(item){if(!Konva.Util._isNumber(item)){Konva.Util.warn('"'+attr+'" attribute has non numeric element '+item+'. Make sure that all elements are numbers.');}});}return val;};}},getBooleanValidator:function getBooleanValidator(){if(Konva.isUnminified){return function(val,attr){var isBool=val===true||val===false;if(!isBool){Konva.Util.warn(Konva.Validators._formatValue(val)+' is a not valid value for "'+attr+'" attribute. The value should be a boolean.');}return val;};}}};})();(function(Konva){'use strict';// CONSTANTS
var ABSOLUTE_OPACITY='absoluteOpacity',ABSOLUTE_TRANSFORM='absoluteTransform',ABSOLUTE_SCALE='absoluteScale',CHANGE='Change',CHILDREN='children',DOT='.',EMPTY_STRING='',GET='get',ID='id',KONVA='konva',LISTENING='listening',MOUSEENTER='mouseenter',MOUSELEAVE='mouseleave',NAME='name',SET='set',SHAPE='Shape',SPACE=' ',STAGE='stage',TRANSFORM='transform',UPPER_STAGE='Stage',VISIBLE='visible',CLONE_BLACK_LIST=['id'],TRANSFORM_CHANGE_STR=['xChange.konva','yChange.konva','scaleXChange.konva','scaleYChange.konva','skewXChange.konva','skewYChange.konva','rotationChange.konva','offsetXChange.konva','offsetYChange.konva','transformsEnabledChange.konva'].join(SPACE),SCALE_CHANGE_STR=['scaleXChange.konva','scaleYChange.konva'].join(SPACE);/**
   * Node constructor. Nodes are entities that can be transformed, layered,
   * and have bound events. The stage, layers, groups, and shapes all extend Node.
   * @constructor
   * @memberof Konva
   * @abstract
   * @param {Object} config
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   */Konva.Node=function(config){this._init(config);};Konva.Util.addMethods(Konva.Node,{_init:function _init(config){this._id=Konva.idCounter++;this.eventListeners={};this.attrs={};this._cache={};this._filterUpToDate=false;this._isUnderCache=false;this.setAttrs(config);// event bindings for cache handling
this.on(TRANSFORM_CHANGE_STR,function(){this._clearCache(TRANSFORM);this._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM);});this.on(SCALE_CHANGE_STR,function(){this._clearSelfAndDescendantCache(ABSOLUTE_SCALE);});this.on('visibleChange.konva',function(){this._clearSelfAndDescendantCache(VISIBLE);});this.on('listeningChange.konva',function(){this._clearSelfAndDescendantCache(LISTENING);});this.on('opacityChange.konva',function(){this._clearSelfAndDescendantCache(ABSOLUTE_OPACITY);});},_clearCache:function _clearCache(attr){if(attr){delete this._cache[attr];}else{this._cache={};}},_getCache:function _getCache(attr,privateGetter){var cache=this._cache[attr];// if not cached, we need to set it using the private getter method.
if(cache===undefined){this._cache[attr]=privateGetter.call(this);}return this._cache[attr];},/*
         * when the logic for a cached result depends on ancestor propagation, use this
         * method to clear self and children cache
         */_clearSelfAndDescendantCache:function _clearSelfAndDescendantCache(attr){this._clearCache(attr);if(this.children){this.getChildren().each(function(node){node._clearSelfAndDescendantCache(attr);});}},/**
     * clear cached canvas
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Konva.Node}
     * @example
     * node.clearCache();
     */clearCache:function clearCache(){delete this._cache.canvas;this._filterUpToDate=false;return this;},/**
     *  cache node to improve drawing performance, apply filters, or create more accurate
     *  hit regions. For all basic shapes size of cache canvas will be automatically detected.
     *  If you need to cache your custom `Konva.Shape` instance you have to pass shape's bounding box
     *  properties. Look at [https://konvajs.github.io/docs/performance/Shape_Caching.html](link to demo page) for more information.
     * @method
     * @memberof Konva.Node.prototype
     * @param {Object} [config]
     * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Number} [config.offset]  increase canvas size by `offset` pixel in all directions.
     * @param {Boolean} [config.drawBorder] when set to true, a red border will be drawn around the cached
     *  region for debugging purposes
     * @param {Number} [config.pixelRatio] change quality (or pixel ratio) of cached image. pixelRatio = 2 will produce 2x sized cache.
     * @returns {Konva.Node}
     * @example
     * // cache a shape with the x,y position of the bounding box at the center and
     * // the width and height of the bounding box equal to the width and height of
     * // the shape obtained from shape.width() and shape.height()
     * image.cache();
     *
     * // cache a node and define the bounding box position and size
     * node.cache({
     *   x: -30,
     *   y: -30,
     *   width: 100,
     *   height: 200
     * });
     *
     * // cache a node and draw a red border around the bounding box
     * // for debugging purposes
     * node.cache({
     *   x: -30,
     *   y: -30,
     *   width: 100,
     *   height: 200,
     *   offset : 10,
     *   drawBorder: true
     * });
     */cache:function cache(config){var conf=config||{};var rect={};// don't call getClientRect if we have all attributes
// it means call it only if have one undefined
if(conf.x===undefined||conf.y===undefined||conf.width===undefined||conf.height===undefined){rect=this.getClientRect({skipTransform:true,relativeTo:this.getParent()});}var width=conf.width||rect.width,height=conf.height||rect.height,pixelRatio=conf.pixelRatio,x=conf.x===undefined?rect.x:conf.x,y=conf.y===undefined?rect.y:conf.y,offset=conf.offset||0,drawBorder=conf.drawBorder||false;if(!width||!height){Konva.Util.error('Can not cache the node. Width or height of the node equals 0. Caching is skipped.');return;}width+=offset*2;height+=offset*2;x-=offset;y-=offset;var cachedSceneCanvas=new Konva.SceneCanvas({pixelRatio:pixelRatio,width:width,height:height}),cachedFilterCanvas=new Konva.SceneCanvas({pixelRatio:pixelRatio,width:width,height:height}),cachedHitCanvas=new Konva.HitCanvas({pixelRatio:1,width:width,height:height}),sceneContext=cachedSceneCanvas.getContext(),hitContext=cachedHitCanvas.getContext();cachedHitCanvas.isCache=true;this.clearCache();sceneContext.save();hitContext.save();sceneContext.translate(-x,-y);hitContext.translate(-x,-y);// extra flag to skip on getAbsolute opacity calc
this._isUnderCache=true;this._clearSelfAndDescendantCache(ABSOLUTE_OPACITY);this._clearSelfAndDescendantCache(ABSOLUTE_SCALE);this.drawScene(cachedSceneCanvas,this,true);this.drawHit(cachedHitCanvas,this,true);this._isUnderCache=false;sceneContext.restore();hitContext.restore();// this will draw a red border around the cached box for
// debugging purposes
if(drawBorder){sceneContext.save();sceneContext.beginPath();sceneContext.rect(0,0,width,height);sceneContext.closePath();sceneContext.setAttr('strokeStyle','red');sceneContext.setAttr('lineWidth',5);sceneContext.stroke();sceneContext.restore();}this._cache.canvas={scene:cachedSceneCanvas,filter:cachedFilterCanvas,hit:cachedHitCanvas,x:x,y:y};return this;},/**
     * Return client rectangle {x, y, width, height} of node. This rectangle also include all styling (strokes, shadows, etc).
     * The rectangle position is relative to parent container.
     * @method
     * @memberof Konva.Node.prototype
     * @param {Object} config
     * @param {Boolean} [config.skipTransform] should we apply transform to node for calculating rect?
     * @param {Boolean} [config.skipShadow] should we apply shadow to the node for calculating bound box?
     * @param {Object} [config.relativeTo] calculate client rect relative to one of the parents
     * @returns {Object} rect with {x, y, width, height} properties
     * @example
     * var rect = new Konva.Rect({
     *      width : 100,
     *      height : 100,
     *      x : 50,
     *      y : 50,
     *      strokeWidth : 4,
     *      stroke : 'black',
     *      offsetX : 50,
     *      scaleY : 2
     * });
     *
     * // get client rect without think off transformations (position, rotation, scale, offset, etc)
     * rect.getClientRect({ skipTransform: true});
     * // returns {
     * //     x : -2,   // two pixels for stroke / 2
     * //     y : -2,
     * //     width : 104, // increased by 4 for stroke
     * //     height : 104
     * //}
     *
     * // get client rect with transformation applied
     * rect.getClientRect();
     * // returns Object {x: -2, y: 46, width: 104, height: 208}
     */getClientRect:function getClientRect(){// abstract method
// redefine in Container and Shape
throw new Error('abstract "getClientRect" method call');},_transformedRect:function _transformedRect(rect,top){var points=[{x:rect.x,y:rect.y},{x:rect.x+rect.width,y:rect.y},{x:rect.x+rect.width,y:rect.y+rect.height},{x:rect.x,y:rect.y+rect.height}];var minX,minY,maxX,maxY;var trans=this.getAbsoluteTransform(top);points.forEach(function(point){var transformed=trans.point(point);if(minX===undefined){minX=maxX=transformed.x;minY=maxY=transformed.y;}minX=Math.min(minX,transformed.x);minY=Math.min(minY,transformed.y);maxX=Math.max(maxX,transformed.x);maxY=Math.max(maxY,transformed.y);});return{x:minX,y:minY,width:maxX-minX,height:maxY-minY};},_drawCachedSceneCanvas:function _drawCachedSceneCanvas(context){context.save();context._applyOpacity(this);context._applyGlobalCompositeOperation(this);context.translate(this._cache.canvas.x,this._cache.canvas.y);var cacheCanvas=this._getCachedSceneCanvas();var ratio=cacheCanvas.pixelRatio;context.drawImage(cacheCanvas._canvas,0,0,cacheCanvas.width/ratio,cacheCanvas.height/ratio);context.restore();},_drawCachedHitCanvas:function _drawCachedHitCanvas(context){var cachedCanvas=this._cache.canvas,hitCanvas=cachedCanvas.hit;context.save();context.translate(this._cache.canvas.x,this._cache.canvas.y);context.drawImage(hitCanvas._canvas,0,0);context.restore();},_getCachedSceneCanvas:function _getCachedSceneCanvas(){var filters=this.filters(),cachedCanvas=this._cache.canvas,sceneCanvas=cachedCanvas.scene,filterCanvas=cachedCanvas.filter,filterContext=filterCanvas.getContext(),len,imageData,n,filter;if(filters){if(!this._filterUpToDate){var ratio=sceneCanvas.pixelRatio;try{len=filters.length;filterContext.clear();// copy cached canvas onto filter context
filterContext.drawImage(sceneCanvas._canvas,0,0,sceneCanvas.getWidth()/ratio,sceneCanvas.getHeight()/ratio);imageData=filterContext.getImageData(0,0,filterCanvas.getWidth(),filterCanvas.getHeight());// apply filters to filter context
for(n=0;n<len;n++){filter=filters[n];if(typeof filter!=='function'){Konva.Util.error('Filter should be type of function, but got '+(typeof filter==='undefined'?'undefined':_typeof(filter))+' insted. Please check correct filters');continue;}filter.call(this,imageData);filterContext.putImageData(imageData,0,0);}}catch(e){Konva.Util.error('Unable to apply filter. '+e.message);}this._filterUpToDate=true;}return filterCanvas;}return sceneCanvas;},/**
     * bind events to the node. KonvaJS supports mouseover, mousemove,
     *  mouseout, mouseenter, mouseleave, mousedown, mouseup, wheel, contextmenu, click, dblclick, touchstart, touchmove,
     *  touchend, tap, dbltap, dragstart, dragmove, and dragend events. The Konva Stage supports
     *  contentMouseover, contentMousemove, contentMouseout, contentMousedown, contentMouseup, contentWheel, contentContextmenu
     *  contentClick, contentDblclick, contentTouchstart, contentTouchmove, contentTouchend, contentTap,
     *  and contentDblTap.  Pass in a string of events delimited by a space to bind multiple events at once
     *  such as 'mousedown mouseup mousemove'. Include a namespace to bind an
     *  event by name such as 'click.foobar'.
     * @method
     * @memberof Konva.Node.prototype
     * @param {String} evtStr e.g. 'click', 'mousedown touchstart', 'mousedown.foo touchstart.foo'
     * @param {Function} handler The handler function is passed an event object
     * @returns {Konva.Node}
     * @example
     * // add click listener
     * node.on('click', function() {
     *   console.log('you clicked me!');
     * });
     *
     * // get the target node
     * node.on('click', function(evt) {
     *   console.log(evt.target);
     * });
     *
     * // stop event propagation
     * node.on('click', function(evt) {
     *   evt.cancelBubble = true;
     * });
     *
     * // bind multiple listeners
     * node.on('click touchstart', function() {
     *   console.log('you clicked/touched me!');
     * });
     *
     * // namespace listener
     * node.on('click.foo', function() {
     *   console.log('you clicked/touched me!');
     * });
     *
     * // get the event type
     * node.on('click tap', function(evt) {
     *   var eventType = evt.type;
     * });
     *
     * // get native event object
     * node.on('click tap', function(evt) {
     *   var nativeEvent = evt.evt;
     * });
     *
     * // for change events, get the old and new val
     * node.on('xChange', function(evt) {
     *   var oldVal = evt.oldVal;
     *   var newVal = evt.newVal;
     * });
     *
     * // get event targets
     * // with event delegations
     * layer.on('click', 'Group', function(evt) {
     *   var shape = evt.target;
     *   var group = evtn.currentTarger;
     * });
     */on:function on(evtStr,handler){if(arguments.length===3){return this._delegate.apply(this,arguments);}var events=evtStr.split(SPACE),len=events.length,n,event,parts,baseEvent,name;/*
             * loop through types and attach event listeners to
             * each one.  eg. 'click mouseover.namespace mouseout'
             * will create three event bindings
             */for(n=0;n<len;n++){event=events[n];parts=event.split(DOT);baseEvent=parts[0];name=parts[1]||EMPTY_STRING;// create events array if it doesn't exist
if(!this.eventListeners[baseEvent]){this.eventListeners[baseEvent]=[];}this.eventListeners[baseEvent].push({name:name,handler:handler});}return this;},/**
     * remove event bindings from the node. Pass in a string of
     *  event types delimmited by a space to remove multiple event
     *  bindings at once such as 'mousedown mouseup mousemove'.
     *  include a namespace to remove an event binding by name
     *  such as 'click.foobar'. If you only give a name like '.foobar',
     *  all events in that namespace will be removed.
     * @method
     * @memberof Konva.Node.prototype
     * @param {String} evtStr e.g. 'click', 'mousedown touchstart', '.foobar'
     * @returns {Konva.Node}
     * @example
     * // remove listener
     * node.off('click');
     *
     * // remove multiple listeners
     * node.off('click touchstart');
     *
     * // remove listener by name
     * node.off('click.foo');
     */off:function off(evtStr,callback){var events=(evtStr||'').split(SPACE),len=events.length,n,t,event,parts,baseEvent,name;if(!evtStr){// remove all events
for(t in this.eventListeners){this._off(t);}}for(n=0;n<len;n++){event=events[n];parts=event.split(DOT);baseEvent=parts[0];name=parts[1];if(baseEvent){if(this.eventListeners[baseEvent]){this._off(baseEvent,name,callback);}}else{for(t in this.eventListeners){this._off(t,name,callback);}}}return this;},// some event aliases for third party integration like HammerJS
dispatchEvent:function dispatchEvent(evt){var e={target:this,type:evt.type,evt:evt};this.fire(evt.type,e);return this;},addEventListener:function addEventListener(type,handler){// we have to pass native event to handler
this.on(type,function(evt){handler.call(this,evt.evt);});return this;},removeEventListener:function removeEventListener(type){this.off(type);return this;},// like node.on
_delegate:function _delegate(event,selector,handler){var stopNode=this;this.on(event,function(evt){var targets=evt.target.findAncestors(selector,true,stopNode);for(var i=0;i<targets.length;i++){evt=Konva.Util.cloneObject(evt);evt.currentTarget=targets[i];handler.call(targets[i],evt);}});},/**
     * remove self from parent, but don't destroy. You can reuse node later.
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Konva.Node}
     * @example
     * node.remove();
     */remove:function remove(){var parent=this.getParent();if(parent&&parent.children){parent.children.splice(this.index,1);parent._setChildrenIndices();delete this.parent;}// every cached attr that is calculated via node tree
// traversal must be cleared when removing a node
this._clearSelfAndDescendantCache(STAGE);this._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM);this._clearSelfAndDescendantCache(VISIBLE);this._clearSelfAndDescendantCache(LISTENING);this._clearSelfAndDescendantCache(ABSOLUTE_OPACITY);return this;},/**
     * remove and destroy a node. Kill it forever! You should not reuse node after destroy().
     * @method
     * @memberof Konva.Node.prototype
     * @example
     * node.destroy();
     */destroy:function destroy(){// remove from ids and names hashes
Konva._removeId(this.getId());// remove all names
var names=(this.getName()||'').split(/\s/g);for(var i=0;i<names.length;i++){var subname=names[i];Konva._removeName(subname,this._id);}this.remove();return this;},/**
     * get attr
     * @method
     * @memberof Konva.Node.prototype
     * @param {String} attr
     * @returns {Integer|String|Object|Array}
     * @example
     * var x = node.getAttr('x');
     */getAttr:function getAttr(attr){var method=GET+Konva.Util._capitalize(attr);if(Konva.Util._isFunction(this[method])){return this[method]();}// otherwise get directly
return this.attrs[attr];},/**
     * get ancestors
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Konva.Collection}
     * @example
     * shape.getAncestors().each(function(node) {
     *   console.log(node.getId());
     * })
     */getAncestors:function getAncestors(){var parent=this.getParent(),ancestors=new Konva.Collection();while(parent){ancestors.push(parent);parent=parent.getParent();}return ancestors;},/**
     * get attrs object literal
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Object}
     */getAttrs:function getAttrs(){return this.attrs||{};},/**
     * set multiple attrs at once using an object literal
     * @method
     * @memberof Konva.Node.prototype
     * @param {Object} config object containing key value pairs
     * @returns {Konva.Node}
     * @example
     * node.setAttrs({
     *   x: 5,
     *   fill: 'red'
     * });
     */setAttrs:function setAttrs(config){var key,method;if(!config){return this;}for(key in config){if(key===CHILDREN){continue;}method=SET+Konva.Util._capitalize(key);// use setter if available
if(Konva.Util._isFunction(this[method])){this[method](config[key]);}else{// otherwise set directly
this._setAttr(key,config[key]);}}return this;},/**
     * determine if node is listening for events by taking into account ancestors.
     *
     * Parent    | Self      | isListening
     * listening | listening |
     * ----------+-----------+------------
     * T         | T         | T
     * T         | F         | F
     * F         | T         | T
     * F         | F         | F
     * ----------+-----------+------------
     * T         | I         | T
     * F         | I         | F
     * I         | I         | T
     *
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Boolean}
     */isListening:function isListening(){return this._getCache(LISTENING,this._isListening);},_isListening:function _isListening(){var listening=this.getListening(),parent=this.getParent();// the following conditions are a simplification of the truth table above.
// please modify carefully
if(listening==='inherit'){if(parent){return parent.isListening();}else{return true;}}else{return listening;}},/**
     * determine if node is visible by taking into account ancestors.
     *
     * Parent    | Self      | isVisible
     * visible   | visible   |
     * ----------+-----------+------------
     * T         | T         | T
     * T         | F         | F
     * F         | T         | T
     * F         | F         | F
     * ----------+-----------+------------
     * T         | I         | T
     * F         | I         | F
     * I         | I         | T

      * @method
      * @memberof Konva.Node.prototype
      * @returns {Boolean}
      */isVisible:function isVisible(){return this._getCache(VISIBLE,this._isVisible);},_isVisible:function _isVisible(relativeTo){var visible=this.getVisible(),parent=this.getParent();if(relativeTo===parent&&visible==='inherit'){return true;}else if(relativeTo===parent){return visible;}// the following conditions are a simplification of the truth table above.
// please modify carefully
if(visible==='inherit'){if(parent){return parent._isVisible(relativeTo);}else{return true;}}else{return visible;}},/**
     * determine if listening is enabled by taking into account descendants.  If self or any children
     * have _isListeningEnabled set to true, then self also has listening enabled.
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Boolean}
     */shouldDrawHit:function shouldDrawHit(){var layer=this.getLayer();return!layer&&this.isListening()&&this.isVisible()||layer&&layer.hitGraphEnabled()&&this.isListening()&&this.isVisible();},/**
     * show node
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Konva.Node}
     */show:function show(){this.setVisible(true);return this;},/**
     * hide node.  Hidden nodes are no longer detectable
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Konva.Node}
     */hide:function hide(){this.setVisible(false);return this;},/**
     * get zIndex relative to the node's siblings who share the same parent
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Integer}
     */getZIndex:function getZIndex(){return this.index||0;},/**
     * get absolute z-index which takes into account sibling
     *  and ancestor indices
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Integer}
     */getAbsoluteZIndex:function getAbsoluteZIndex(){var depth=this.getDepth(),that=this,index=0,nodes,len,n,child;function addChildren(children){nodes=[];len=children.length;for(n=0;n<len;n++){child=children[n];index++;if(child.nodeType!==SHAPE){nodes=nodes.concat(child.getChildren().toArray());}if(child._id===that._id){n=len;}}if(nodes.length>0&&nodes[0].getDepth()<=depth){addChildren(nodes);}}if(that.nodeType!==UPPER_STAGE){addChildren(that.getStage().getChildren());}return index;},/**
     * get node depth in node tree.  Returns an integer.
     *  e.g. Stage depth will always be 0.  Layers will always be 1.  Groups and Shapes will always
     *  be >= 2
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Integer}
     */getDepth:function getDepth(){var depth=0,parent=this.parent;while(parent){depth++;parent=parent.parent;}return depth;},setPosition:function setPosition(pos){this.setX(pos.x);this.setY(pos.y);return this;},getPosition:function getPosition(){return{x:this.getX(),y:this.getY()};},/**
     * get absolute position relative to the top left corner of the stage container div
     * or relative to passed node
     * @method
     * @param {Object} [top] optional parent node
     * @memberof Konva.Node.prototype
     * @returns {Object}
     */getAbsolutePosition:function getAbsolutePosition(top){var absoluteMatrix=this.getAbsoluteTransform(top).getMatrix(),absoluteTransform=new Konva.Transform(),offset=this.offset();// clone the matrix array
absoluteTransform.m=absoluteMatrix.slice();absoluteTransform.translate(offset.x,offset.y);return absoluteTransform.getTranslation();},/**
     * set absolute position
     * @method
     * @memberof Konva.Node.prototype
     * @param {Object} pos
     * @param {Number} pos.x
     * @param {Number} pos.y
     * @returns {Konva.Node}
     */setAbsolutePosition:function setAbsolutePosition(pos){var origTrans=this._clearTransform(),it;// don't clear translation
this.attrs.x=origTrans.x;this.attrs.y=origTrans.y;delete origTrans.x;delete origTrans.y;// unravel transform
it=this.getAbsoluteTransform();it.invert();it.translate(pos.x,pos.y);pos={x:this.attrs.x+it.getTranslation().x,y:this.attrs.y+it.getTranslation().y};this.setPosition({x:pos.x,y:pos.y});this._setTransform(origTrans);return this;},_setTransform:function _setTransform(trans){var key;for(key in trans){this.attrs[key]=trans[key];}this._clearCache(TRANSFORM);this._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM);},_clearTransform:function _clearTransform(){var trans={x:this.getX(),y:this.getY(),rotation:this.getRotation(),scaleX:this.getScaleX(),scaleY:this.getScaleY(),offsetX:this.getOffsetX(),offsetY:this.getOffsetY(),skewX:this.getSkewX(),skewY:this.getSkewY()};this.attrs.x=0;this.attrs.y=0;this.attrs.rotation=0;this.attrs.scaleX=1;this.attrs.scaleY=1;this.attrs.offsetX=0;this.attrs.offsetY=0;this.attrs.skewX=0;this.attrs.skewY=0;this._clearCache(TRANSFORM);this._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM);// return original transform
return trans;},/**
     * move node by an amount relative to its current position
     * @method
     * @memberof Konva.Node.prototype
     * @param {Object} change
     * @param {Number} change.x
     * @param {Number} change.y
     * @returns {Konva.Node}
     * @example
     * // move node in x direction by 1px and y direction by 2px
     * node.move({
     *   x: 1,
     *   y: 2)
     * });
     */move:function move(change){var changeX=change.x,changeY=change.y,x=this.getX(),y=this.getY();if(changeX!==undefined){x+=changeX;}if(changeY!==undefined){y+=changeY;}this.setPosition({x:x,y:y});return this;},_eachAncestorReverse:function _eachAncestorReverse(func,top){var family=[],parent=this.getParent(),len,n;// if top node is defined, and this node is top node,
// there's no need to build a family tree.  just execute
// func with this because it will be the only node
if(top&&top._id===this._id){func(this);return;}family.unshift(this);while(parent&&(!top||parent._id!==top._id)){family.unshift(parent);parent=parent.parent;}len=family.length;for(n=0;n<len;n++){func(family[n]);}},/**
     * rotate node by an amount in degrees relative to its current rotation
     * @method
     * @memberof Konva.Node.prototype
     * @param {Number} theta
     * @returns {Konva.Node}
     */rotate:function rotate(theta){this.setRotation(this.getRotation()+theta);return this;},/**
     * move node to the top of its siblings
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Boolean}
     */moveToTop:function moveToTop(){if(!this.parent){Konva.Util.warn('Node has no parent. moveToTop function is ignored.');return false;}var index=this.index;this.parent.children.splice(index,1);this.parent.children.push(this);this.parent._setChildrenIndices();return true;},/**
     * move node up
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Boolean} flag is moved or not
     */moveUp:function moveUp(){if(!this.parent){Konva.Util.warn('Node has no parent. moveUp function is ignored.');return false;}var index=this.index,len=this.parent.getChildren().length;if(index<len-1){this.parent.children.splice(index,1);this.parent.children.splice(index+1,0,this);this.parent._setChildrenIndices();return true;}return false;},/**
     * move node down
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Boolean}
     */moveDown:function moveDown(){if(!this.parent){Konva.Util.warn('Node has no parent. moveDown function is ignored.');return false;}var index=this.index;if(index>0){this.parent.children.splice(index,1);this.parent.children.splice(index-1,0,this);this.parent._setChildrenIndices();return true;}return false;},/**
     * move node to the bottom of its siblings
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Boolean}
     */moveToBottom:function moveToBottom(){if(!this.parent){Konva.Util.warn('Node has no parent. moveToBottom function is ignored.');return false;}var index=this.index;if(index>0){this.parent.children.splice(index,1);this.parent.children.unshift(this);this.parent._setChildrenIndices();return true;}return false;},/**
     * set zIndex relative to siblings
     * @method
     * @memberof Konva.Node.prototype
     * @param {Integer} zIndex
     * @returns {Konva.Node}
     */setZIndex:function setZIndex(zIndex){if(!this.parent){Konva.Util.warn('Node has no parent. zIndex parameter is ignored.');return false;}var index=this.index;this.parent.children.splice(index,1);this.parent.children.splice(zIndex,0,this);this.parent._setChildrenIndices();return this;},/**
     * get absolute opacity
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Number}
     */getAbsoluteOpacity:function getAbsoluteOpacity(){return this._getCache(ABSOLUTE_OPACITY,this._getAbsoluteOpacity);},_getAbsoluteOpacity:function _getAbsoluteOpacity(){var absOpacity=this.getOpacity();var parent=this.getParent();if(parent&&!parent._isUnderCache){absOpacity*=this.getParent().getAbsoluteOpacity();}return absOpacity;},/**
     * move node to another container
     * @method
     * @memberof Konva.Node.prototype
     * @param {Container} newContainer
     * @returns {Konva.Node}
     * @example
     * // move node from current layer into layer2
     * node.moveTo(layer2);
     */moveTo:function moveTo(newContainer){// do nothing if new container is already parent
if(this.getParent()!==newContainer){// this.remove my be overrided by drag and drop
// buy we need original
(this.__originalRemove||this.remove).call(this);newContainer.add(this);}return this;},/**
     * convert Node into an object for serialization.  Returns an object.
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Object}
     */toObject:function toObject(){var obj={},attrs=this.getAttrs(),key,val,getter,defaultValue;obj.attrs={};for(key in attrs){val=attrs[key];getter=typeof this[key]==='function'&&this[key];// remove attr value so that we can extract the default value from the getter
delete attrs[key];defaultValue=getter?getter.call(this):null;// restore attr value
attrs[key]=val;if(defaultValue!==val){obj.attrs[key]=val;}}obj.className=this.getClassName();return Konva.Util._prepareToStringify(obj);},/**
     * convert Node into a JSON string.  Returns a JSON string.
     * @method
     * @memberof Konva.Node.prototype
     * @returns {String}}
     */toJSON:function toJSON(){return JSON.stringify(this.toObject());},/**
     * get parent container
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Konva.Node}
     */getParent:function getParent(){return this.parent;},/**
     * get all ancestros (parent then parent of the parent, etc) of the node
     * @method
     * @memberof Konva.Node.prototype
     * @param {String} [selector] selector for search
     * @param {Boolean} [includeSelf] show we think that node is ancestro itself?
     * @param {Konva.Node} [stopNode] optional node where we need to stop searching (one of ancestors)
     * @returns {Array} [ancestors]
     * @example
     * // get one of the parent group
     * var parentGroups = node.findAncestors('Group');
     */findAncestors:function findAncestors(selector,includeSelf,stopNode){var res=[];if(includeSelf&&this._isMatch(selector)){res.push(this);}var ancestor=this.parent;while(ancestor){if(ancestor===stopNode){return res;}if(ancestor._isMatch(selector)){res.push(ancestor);}ancestor=ancestor.parent;}return res;},/**
     * get ancestor (parent or parent of the parent, etc) of the node that match passed selector
     * @method
     * @memberof Konva.Node.prototype
     * @param {String} [selector] selector for search
     * @param {Boolean} [includeSelf] show we think that node is ancestro itself?
     * @param {Konva.Node} [stopNode] optional node where we need to stop searching (one of ancestors)
     * @returns {Konva.Node} ancestor
     * @example
     * // get one of the parent group
     * var group = node.findAncestors('.mygroup');
     */findAncestor:function findAncestor(selector,includeSelf,stopNode){return this.findAncestors(selector,includeSelf,stopNode)[0];},// is current node match passed selector?
_isMatch:function _isMatch(selector){if(!selector){return false;}var selectorArr=selector.replace(/ /g,'').split(','),len=selectorArr.length,n,sel;for(n=0;n<len;n++){sel=selectorArr[n];if(!Konva.Util.isValidSelector(sel)){Konva.Util.warn('Selector "'+sel+'" is invalid. Allowed selectors examples are "#foo", ".bar" or "Group".');Konva.Util.warn('If you have a custom shape with such className, please change it to start with upper letter like "Triangle".');Konva.Util.warn('Konva is awesome, right?');}// id selector
if(sel.charAt(0)==='#'){if(this.id()===sel.slice(1)){return true;}}else if(sel.charAt(0)==='.'){// name selector
if(this.hasName(sel.slice(1))){return true;}}else if(this._get(sel).length!==0){return true;}}return false;},/**
     * get layer ancestor
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Konva.Layer}
     */getLayer:function getLayer(){var parent=this.getParent();return parent?parent.getLayer():null;},/**
     * get stage ancestor
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Konva.Stage}
     */getStage:function getStage(){return this._getCache(STAGE,this._getStage);},_getStage:function _getStage(){var parent=this.getParent();if(parent){return parent.getStage();}else{return undefined;}},/**
     * fire event
     * @method
     * @memberof Konva.Node.prototype
     * @param {String} eventType event type.  can be a regular event, like click, mouseover, or mouseout, or it can be a custom event, like myCustomEvent
     * @param {Event} [evt] event object
     * @param {Boolean} [bubble] setting the value to false, or leaving it undefined, will result in the event
     *  not bubbling.  Setting the value to true will result in the event bubbling.
     * @returns {Konva.Node}
     * @example
     * // manually fire click event
     * node.fire('click');
     *
     * // fire custom event
     * node.fire('foo');
     *
     * // fire custom event with custom event object
     * node.fire('foo', {
     *   bar: 10
     * });
     *
     * // fire click event that bubbles
     * node.fire('click', null, true);
     */fire:function fire(eventType,evt,bubble){evt=evt||{};evt.target=evt.target||this;// bubble
if(bubble){this._fireAndBubble(eventType,evt);}else{// no bubble
this._fire(eventType,evt);}return this;},/**
     * get absolute transform of the node which takes into
     *  account its ancestor transforms
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Konva.Transform}
     */getAbsoluteTransform:function getAbsoluteTransform(top){// if using an argument, we can't cache the result.
if(top){return this._getAbsoluteTransform(top);}else{// if no argument, we can cache the result
return this._getCache(ABSOLUTE_TRANSFORM,this._getAbsoluteTransform);}},_getAbsoluteTransform:function _getAbsoluteTransform(top){var at=new Konva.Transform();// start with stage and traverse downwards to self
this._eachAncestorReverse(function(node){var transformsEnabled=node.transformsEnabled();if(transformsEnabled==='all'){at.multiply(node.getTransform());}else if(transformsEnabled==='position'){at.translate(node.getX()-node.getOffsetX(),node.getY()-node.getOffsetY());}},top);return at;},/**
     * get absolute scale of the node which takes into
     *  account its ancestor scales
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Konva.Transform}
     */getAbsoluteScale:function getAbsoluteScale(top){// if using an argument, we can't cache the result.
if(top){return this._getAbsoluteScale(top);}else{// if no argument, we can cache the result
return this._getCache(ABSOLUTE_SCALE,this._getAbsoluteScale);}},_getAbsoluteScale:function _getAbsoluteScale(top){// this is special logic for caching with some shapes with shadow
var parent=this;while(parent){if(parent._isUnderCache){top=parent;}parent=parent.getParent();}var scaleX=1,scaleY=1;// start with stage and traverse downwards to self
this._eachAncestorReverse(function(node){scaleX*=node.scaleX();scaleY*=node.scaleY();},top);return{x:scaleX,y:scaleY};},/**
     * get transform of the node
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Konva.Transform}
     */getTransform:function getTransform(){return this._getCache(TRANSFORM,this._getTransform);},_getTransform:function _getTransform(){var m=new Konva.Transform(),x=this.getX(),y=this.getY(),rotation=Konva.getAngle(this.getRotation()),scaleX=this.getScaleX(),scaleY=this.getScaleY(),skewX=this.getSkewX(),skewY=this.getSkewY(),offsetX=this.getOffsetX(),offsetY=this.getOffsetY();if(x!==0||y!==0){m.translate(x,y);}if(rotation!==0){m.rotate(rotation);}if(skewX!==0||skewY!==0){m.skew(skewX,skewY);}if(scaleX!==1||scaleY!==1){m.scale(scaleX,scaleY);}if(offsetX!==0||offsetY!==0){m.translate(-1*offsetX,-1*offsetY);}return m;},/**
     * clone node.  Returns a new Node instance with identical attributes.  You can also override
     *  the node properties with an object literal, enabling you to use an existing node as a template
     *  for another node
     * @method
     * @memberof Konva.Node.prototype
     * @param {Object} obj override attrs
     * @returns {Konva.Node}
     * @example
     * // simple clone
     * var clone = node.clone();
     *
     * // clone a node and override the x position
     * var clone = rect.clone({
     *   x: 5
     * });
     */clone:function clone(obj){// instantiate new node
var attrs=Konva.Util.cloneObject(this.attrs),key,allListeners,len,n,listener;// filter black attrs
for(var i in CLONE_BLACK_LIST){var blockAttr=CLONE_BLACK_LIST[i];delete attrs[blockAttr];}// apply attr overrides
for(key in obj){attrs[key]=obj[key];}var node=new this.constructor(attrs);// copy over listeners
for(key in this.eventListeners){allListeners=this.eventListeners[key];len=allListeners.length;for(n=0;n<len;n++){listener=allListeners[n];/*
                     * don't include konva namespaced listeners because
                     *  these are generated by the constructors
                     */if(listener.name.indexOf(KONVA)<0){// if listeners array doesn't exist, then create it
if(!node.eventListeners[key]){node.eventListeners[key]=[];}node.eventListeners[key].push(listener);}}}return node;},_toKonvaCanvas:function _toKonvaCanvas(config){config=config||{};var box=this.getClientRect();var stage=this.getStage(),x=config.x!==undefined?config.x:box.x,y=config.y!==undefined?config.y:box.y,pixelRatio=config.pixelRatio||1,canvas=new Konva.SceneCanvas({width:config.width||box.width||(stage?stage.getWidth():0),height:config.height||box.height||(stage?stage.getHeight():0),pixelRatio:pixelRatio}),context=canvas.getContext();context.save();if(x||y){context.translate(-1*x,-1*y);}this.drawScene(canvas);context.restore();return canvas;},/**
     * converts node into an canvas element.
     * @method
     * @memberof Konva.Node.prototype
     * @param {Object} config
     * @param {Function} config.callback function executed when the composite has completed
     * @param {Number} [config.x] x position of canvas section
     * @param {Number} [config.y] y position of canvas section
     * @param {Number} [config.width] width of canvas section
     * @param {Number} [config.height] height of canvas section
     * @paremt {Number} [config.pixelRatio] pixelRatio of ouput image.  Default is 1.
     * @example
     * var canvas = node.toCanvas();
     */toCanvas:function toCanvas(config){return this._toKonvaCanvas(config)._canvas;},/**
     * Creates a composite data URL. If MIME type is not
     * specified, then "image/png" will result. For "image/jpeg", specify a quality
     * level as quality (range 0.0 - 1.0)
     * @method
     * @memberof Konva.Node.prototype
     * @param {Object} config
     * @param {String} [config.mimeType] can be "image/png" or "image/jpeg".
     *  "image/png" is the default
     * @param {Number} [config.x] x position of canvas section
     * @param {Number} [config.y] y position of canvas section
     * @param {Number} [config.width] width of canvas section
     * @param {Number} [config.height] height of canvas section
     * @param {Number} [config.quality] jpeg quality.  If using an "image/jpeg" mimeType,
     *  you can specify the quality from 0 to 1, where 0 is very poor quality and 1
     *  is very high quality
     * @param {Number} [config.pixelRatio] pixelRatio of output image url. Default is 1
     * @returns {String}
     */toDataURL:function toDataURL(config){config=config||{};var mimeType=config.mimeType||null,quality=config.quality||null;var url=this._toKonvaCanvas(config).toDataURL(mimeType,quality);if(config.callback){config.callback(url);}return url;},/**
     * converts node into an image.  Since the toImage
     *  method is asynchronous, a callback is required.  toImage is most commonly used
     *  to cache complex drawings as an image so that they don't have to constantly be redrawn
     * @method
     * @memberof Konva.Node.prototype
     * @param {Object} config
     * @param {Function} config.callback function executed when the composite has completed
     * @param {String} [config.mimeType] can be "image/png" or "image/jpeg".
     *  "image/png" is the default
     * @param {Number} [config.x] x position of canvas section
     * @param {Number} [config.y] y position of canvas section
     * @param {Number} [config.width] width of canvas section
     * @param {Number} [config.height] height of canvas section
     * @param {Number} [config.quality] jpeg quality.  If using an "image/jpeg" mimeType,
     *  you can specify the quality from 0 to 1, where 0 is very poor quality and 1
     *  is very high quality
     * @paremt {Number} [config.pixelRatio] pixelRatio of ouput image.  Default is 1.
     * @example
     * var image = node.toImage({
     *   callback: function(img) {
     *     // do stuff with img
     *   }
     * });
     */toImage:function toImage(config){if(!config||!config.callback){throw'callback required for toImage method config argument';}var callback=config.callback;delete config.callback;Konva.Util._getImage(this.toDataURL(config),function(img){callback(img);});},setSize:function setSize(size){this.setWidth(size.width);this.setHeight(size.height);return this;},getSize:function getSize(){return{width:this.getWidth(),height:this.getHeight()};},getWidth:function getWidth(){return this.attrs.width||0;},getHeight:function getHeight(){return this.attrs.height||0;},/**
     * get class name, which may return Stage, Layer, Group, or shape class names like Rect, Circle, Text, etc.
     * @method
     * @memberof Konva.Node.prototype
     * @returns {String}
     */getClassName:function getClassName(){return this.className||this.nodeType;},/**
     * get the node type, which may return Stage, Layer, Group, or Node
     * @method
     * @memberof Konva.Node.prototype
     * @returns {String}
     */getType:function getType(){return this.nodeType;},getDragDistance:function getDragDistance(){// compare with undefined because we need to track 0 value
if(this.attrs.dragDistance!==undefined){return this.attrs.dragDistance;}else if(this.parent){return this.parent.getDragDistance();}else{return Konva.dragDistance;}},_get:function _get(selector){return this.className===selector||this.nodeType===selector?[this]:[];},_off:function _off(type,name,callback){var evtListeners=this.eventListeners[type],i,evtName,handler;for(i=0;i<evtListeners.length;i++){evtName=evtListeners[i].name;handler=evtListeners[i].handler;// the following two conditions must be true in order to remove a handler:
// 1) the current event name cannot be konva unless the event name is konva
//    this enables developers to force remove a konva specific listener for whatever reason
// 2) an event name is not specified, or if one is specified, it matches the current event name
if((evtName!=='konva'||name==='konva')&&(!name||evtName===name)&&(!callback||callback===handler)){evtListeners.splice(i,1);if(evtListeners.length===0){delete this.eventListeners[type];break;}i--;}}},_fireChangeEvent:function _fireChangeEvent(attr,oldVal,newVal){this._fire(attr+CHANGE,{oldVal:oldVal,newVal:newVal});},setId:function setId(id){var oldId=this.getId();Konva._removeId(oldId);Konva._addId(this,id);this._setAttr(ID,id);return this;},setName:function setName(name){var oldNames=(this.getName()||'').split(/\s/g);var newNames=(name||'').split(/\s/g);var subname,i;// remove all subnames
for(i=0;i<oldNames.length;i++){subname=oldNames[i];if(newNames.indexOf(subname)===-1&&subname){Konva._removeName(subname,this._id);}}// add new names
for(i=0;i<newNames.length;i++){subname=newNames[i];if(oldNames.indexOf(subname)===-1&&subname){Konva._addName(this,subname);}}this._setAttr(NAME,name);return this;},// naming methods
/**
     * add name to node
     * @method
     * @memberof Konva.Node.prototype
     * @param {String} name
     * @returns {Konva.Node}
     * @example
     * node.name('red');
     * node.addName('selected');
     * node.name(); // return 'red selected'
     */addName:function addName(name){if(!this.hasName(name)){var oldName=this.name();var newName=oldName?oldName+' '+name:name;this.setName(newName);}return this;},/**
     * check is node has name
     * @method
     * @memberof Konva.Node.prototype
     * @param {String} name
     * @returns {Boolean}
     * @example
     * node.name('red');
     * node.hasName('red');   // return true
     * node.hasName('selected'); // return false
     */hasName:function hasName(name){var names=(this.name()||'').split(/\s/g);return names.indexOf(name)!==-1;},/**
     * remove name from node
     * @method
     * @memberof Konva.Node.prototype
     * @param {String} name
     * @returns {Konva.Node}
     * @example
     * node.name('red selected');
     * node.removeName('selected');
     * node.hasName('selected'); // return false
     * node.name(); // return 'red'
     */removeName:function removeName(name){var names=(this.name()||'').split(/\s/g);var index=names.indexOf(name);if(index!==-1){names.splice(index,1);this.setName(names.join(' '));}return this;},/**
     * set attr
     * @method
     * @memberof Konva.Node.prototype
     * @param {String} attr
     * @param {*} val
     * @returns {Konva.Node}
     * @example
     * node.setAttr('x', 5);
     */setAttr:function setAttr(attr,val){var method=SET+Konva.Util._capitalize(attr),func=this[method];if(Konva.Util._isFunction(func)){func.call(this,val);}else{// otherwise set directly
this._setAttr(attr,val);}return this;},_setAttr:function _setAttr(key,val){var oldVal;oldVal=this.attrs[key];var same=oldVal===val;if(same&&!Konva.Util.isObject(val)){return;}if(val===undefined||val===null){delete this.attrs[key];}else{this.attrs[key]=val;}this._fireChangeEvent(key,oldVal,val);},_setComponentAttr:function _setComponentAttr(key,component,val){var oldVal;if(val!==undefined){oldVal=this.attrs[key];if(!oldVal){// set value to default value using getAttr
this.attrs[key]=this.getAttr(key);}this.attrs[key][component]=val;this._fireChangeEvent(key,oldVal,val);}},_fireAndBubble:function _fireAndBubble(eventType,evt,compareShape){var okayToRun=true;if(evt&&this.nodeType===SHAPE){evt.target=this;}if(eventType===MOUSEENTER&&compareShape&&(this._id===compareShape._id||this.isAncestorOf&&this.isAncestorOf(compareShape))){okayToRun=false;}else if(eventType===MOUSELEAVE&&compareShape&&(this._id===compareShape._id||this.isAncestorOf&&this.isAncestorOf(compareShape))){okayToRun=false;}if(okayToRun){this._fire(eventType,evt);// simulate event bubbling
var stopBubble=(eventType===MOUSEENTER||eventType===MOUSELEAVE)&&compareShape&&compareShape.isAncestorOf&&compareShape.isAncestorOf(this)&&!compareShape.isAncestorOf(this.parent);if((evt&&!evt.cancelBubble||!evt)&&this.parent&&this.parent.isListening()&&!stopBubble){if(compareShape&&compareShape.parent){this._fireAndBubble.call(this.parent,eventType,evt,compareShape.parent);}else{this._fireAndBubble.call(this.parent,eventType,evt);}}}},_fire:function _fire(eventType,evt){var events=this.eventListeners[eventType],i;evt=evt||{};evt.currentTarget=this;evt.type=eventType;if(events){for(i=0;i<events.length;i++){events[i].handler.call(this,evt);}}},/**
     * draw both scene and hit graphs.  If the node being drawn is the stage, all of the layers will be cleared and redrawn
     * @method
     * @memberof Konva.Node.prototype
     * @returns {Konva.Node}
     */draw:function draw(){this.drawScene();this.drawHit();return this;}});/**
   * create node with JSON string or an Object.  De-serializtion does not generate custom
   *  shape drawing functions, images, or event handlers (this would make the
   *  serialized object huge).  If your app uses custom shapes, images, and
   *  event handlers (it probably does), then you need to select the appropriate
   *  shapes after loading the stage and set these properties via on(), setSceneFunc(),
   *  and setImage() methods
   * @method
   * @memberof Konva.Node
   * @param {String|Object} json string or object
   * @param {Element} [container] optional container dom element used only if you're
   *  creating a stage node
   */Konva.Node.create=function(data,container){if(Konva.Util._isString(data)){data=JSON.parse(data);}return this._createNode(data,container);};Konva.Node._createNode=function(obj,container){var className=Konva.Node.prototype.getClassName.call(obj),children=obj.children,no,len,n;// if container was passed in, add it to attrs
if(container){obj.attrs.container=container;}no=new Konva[className](obj.attrs);if(children){len=children.length;for(n=0;n<len;n++){no.add(this._createNode(children[n]));}}return no;};// =========================== add getters setters ===========================
Konva.Factory.addOverloadedGetterSetter(Konva.Node,'position');/**
   * get/set node position relative to parent
   * @name position
   * @method
   * @memberof Konva.Node.prototype
   * @param {Object} pos
   * @param {Number} pos.x
   * @param {Number} pos.y
   * @returns {Object}
   * @example
   * // get position
   * var position = node.position();
   *
   * // set position
   * node.position({
   *   x: 5
   *   y: 10
   * });
   */Konva.Factory.addGetterSetter(Konva.Node,'x',0,Konva.Validators.getNumberValidator());/**
   * get/set x position
   * @name x
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} x
   * @returns {Object}
   * @example
   * // get x
   * var x = node.x();
   *
   * // set x
   * node.x(5);
   */Konva.Factory.addGetterSetter(Konva.Node,'y',0,Konva.Validators.getNumberValidator());/**
   * get/set y position
   * @name y
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} y
   * @returns {Integer}
   * @example
   * // get y
   * var y = node.y();
   *
   * // set y
   * node.y(5);
   */Konva.Factory.addGetterSetter(Konva.Node,'globalCompositeOperation','source-over',Konva.Validators.getStringValidator());/**
   * get/set globalCompositeOperation of a shape
   * @name globalCompositeOperation
   * @method
   * @memberof Konva.Node.prototype
   * @param {String} type
   * @returns {String}
   * @example
   * // get globalCompositeOperation
   * var globalCompositeOperation = shape.globalCompositeOperation();
   *
   * // set globalCompositeOperation
   * shape.globalCompositeOperation('source-in');
   */Konva.Factory.addGetterSetter(Konva.Node,'opacity',1,Konva.Validators.getNumberValidator());/**
   * get/set opacity.  Opacity values range from 0 to 1.
   *  A node with an opacity of 0 is fully transparent, and a node
   *  with an opacity of 1 is fully opaque
   * @name opacity
   * @method
   * @memberof Konva.Node.prototype
   * @param {Object} opacity
   * @returns {Number}
   * @example
   * // get opacity
   * var opacity = node.opacity();
   *
   * // set opacity
   * node.opacity(0.5);
   */Konva.Factory.addGetter(Konva.Node,'name');Konva.Factory.addOverloadedGetterSetter(Konva.Node,'name');/**
   * get/set name
   * @name name
   * @method
   * @memberof Konva.Node.prototype
   * @param {String} name
   * @returns {String}
   * @example
   * // get name
   * var name = node.name();
   *
   * // set name
   * node.name('foo');
   *
   * // also node may have multiple names (as css classes)
   * node.name('foo bar');
   */Konva.Factory.addGetter(Konva.Node,'id');Konva.Factory.addOverloadedGetterSetter(Konva.Node,'id');/**
   * get/set id. Id is global for whole page.
   * @name id
   * @method
   * @memberof Konva.Node.prototype
   * @param {String} id
   * @returns {String}
   * @example
   * // get id
   * var name = node.id();
   *
   * // set id
   * node.id('foo');
   */Konva.Factory.addGetterSetter(Konva.Node,'rotation',0,Konva.Validators.getNumberValidator());/**
   * get/set rotation in degrees
   * @name rotation
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} rotation
   * @returns {Number}
   * @example
   * // get rotation in degrees
   * var rotation = node.rotation();
   *
   * // set rotation in degrees
   * node.rotation(45);
   */Konva.Factory.addComponentsGetterSetter(Konva.Node,'scale',['x','y']);/**
   * get/set scale
   * @name scale
   * @param {Object} scale
   * @param {Number} scale.x
   * @param {Number} scale.y
   * @method
   * @memberof Konva.Node.prototype
   * @returns {Object}
   * @example
   * // get scale
   * var scale = node.scale();
   *
   * // set scale
   * shape.scale({
   *   x: 2
   *   y: 3
   * });
   */Konva.Factory.addGetterSetter(Konva.Node,'scaleX',1,Konva.Validators.getNumberValidator());/**
   * get/set scale x
   * @name scaleX
   * @param {Number} x
   * @method
   * @memberof Konva.Node.prototype
   * @returns {Number}
   * @example
   * // get scale x
   * var scaleX = node.scaleX();
   *
   * // set scale x
   * node.scaleX(2);
   */Konva.Factory.addGetterSetter(Konva.Node,'scaleY',1,Konva.Validators.getNumberValidator());/**
   * get/set scale y
   * @name scaleY
   * @param {Number} y
   * @method
   * @memberof Konva.Node.prototype
   * @returns {Number}
   * @example
   * // get scale y
   * var scaleY = node.scaleY();
   *
   * // set scale y
   * node.scaleY(2);
   */Konva.Factory.addComponentsGetterSetter(Konva.Node,'skew',['x','y']);/**
   * get/set skew
   * @name skew
   * @param {Object} skew
   * @param {Number} skew.x
   * @param {Number} skew.y
   * @method
   * @memberof Konva.Node.prototype
   * @returns {Object}
   * @example
   * // get skew
   * var skew = node.skew();
   *
   * // set skew
   * node.skew({
   *   x: 20
   *   y: 10
   * });
   */Konva.Factory.addGetterSetter(Konva.Node,'skewX',0,Konva.Validators.getNumberValidator());/**
   * get/set skew x
   * @name skewX
   * @param {Number} x
   * @method
   * @memberof Konva.Node.prototype
   * @returns {Number}
   * @example
   * // get skew x
   * var skewX = node.skewX();
   *
   * // set skew x
   * node.skewX(3);
   */Konva.Factory.addGetterSetter(Konva.Node,'skewY',0,Konva.Validators.getNumberValidator());/**
   * get/set skew y
   * @name skewY
   * @param {Number} y
   * @method
   * @memberof Konva.Node.prototype
   * @returns {Number}
   * @example
   * // get skew y
   * var skewY = node.skewY();
   *
   * // set skew y
   * node.skewY(3);
   */Konva.Factory.addComponentsGetterSetter(Konva.Node,'offset',['x','y']);/**
   * get/set offset.  Offsets the default position and rotation point
   * @method
   * @memberof Konva.Node.prototype
   * @param {Object} offset
   * @param {Number} offset.x
   * @param {Number} offset.y
   * @returns {Object}
   * @example
   * // get offset
   * var offset = node.offset();
   *
   * // set offset
   * node.offset({
   *   x: 20
   *   y: 10
   * });
   */Konva.Factory.addGetterSetter(Konva.Node,'offsetX',0,Konva.Validators.getNumberValidator());/**
   * get/set offset x
   * @name offsetX
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} x
   * @returns {Number}
   * @example
   * // get offset x
   * var offsetX = node.offsetX();
   *
   * // set offset x
   * node.offsetX(3);
   */Konva.Factory.addGetterSetter(Konva.Node,'offsetY',0,Konva.Validators.getNumberValidator());/**
   * get/set offset y
   * @name offsetY
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} y
   * @returns {Number}
   * @example
   * // get offset y
   * var offsetY = node.offsetY();
   *
   * // set offset y
   * node.offsetY(3);
   */Konva.Factory.addSetter(Konva.Node,'dragDistance',Konva.Validators.getNumberValidator());Konva.Factory.addOverloadedGetterSetter(Konva.Node,'dragDistance');/**
   * get/set drag distance
   * @name dragDistance
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} distance
   * @returns {Number}
   * @example
   * // get drag distance
   * var dragDistance = node.dragDistance();
   *
   * // set distance
   * // node starts dragging only if pointer moved more then 3 pixels
   * node.dragDistance(3);
   * // or set globally
   * Konva.dragDistance = 3;
   */Konva.Factory.addSetter(Konva.Node,'width',Konva.Validators.getNumberValidator());Konva.Factory.addOverloadedGetterSetter(Konva.Node,'width');/**
   * get/set width
   * @name width
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} width
   * @returns {Number}
   * @example
   * // get width
   * var width = node.width();
   *
   * // set width
   * node.width(100);
   */Konva.Factory.addSetter(Konva.Node,'height',Konva.Validators.getNumberValidator());Konva.Factory.addOverloadedGetterSetter(Konva.Node,'height');/**
   * get/set height
   * @name height
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} height
   * @returns {Number}
   * @example
   * // get height
   * var height = node.height();
   *
   * // set height
   * node.height(100);
   */Konva.Factory.addGetterSetter(Konva.Node,'listening','inherit',function(val){var isValid=val===true||val===false||val==='inherit';if(!isValid){Konva.Util.warn(val+' is a not valid value for "listening" attribute. The value may be true, false or "inherit".');}return val;});/**
   * get/set listenig attr.  If you need to determine if a node is listening or not
   *   by taking into account its parents, use the isListening() method
   * @name listening
   * @method
   * @memberof Konva.Node.prototype
   * @param {Boolean|String} listening Can be "inherit", true, or false.  The default is "inherit".
   * @returns {Boolean|String}
   * @example
   * // get listening attr
   * var listening = node.listening();
   *
   * // stop listening for events
   * node.listening(false);
   *
   * // listen for events
   * node.listening(true);
   *
   * // listen to events according to the parent
   * node.listening('inherit');
   *//**
   * get/set preventDefault
   * By default all shapes will prevent default behaviour
   * of a browser on a pointer move or tap.
   * that will prevent native scrolling when you are trying to drag&drop a node
   * but sometimes you may need to enable default actions
   * in that case you can set the property to false
   * @name preventDefault
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} preventDefault
   * @returns {Number}
   * @example
   * // get preventDefault
   * var shouldPrevent = shape.preventDefault();
   *
   * // set preventDefault
   * shape.preventDefault(false);
   */Konva.Factory.addGetterSetter(Konva.Node,'preventDefault',true,Konva.Validators.getBooleanValidator());Konva.Factory.addGetterSetter(Konva.Node,'filters',null,function(val){this._filterUpToDate=false;return val;});/**
   * get/set filters.  Filters are applied to cached canvases
   * @name filters
   * @method
   * @memberof Konva.Node.prototype
   * @param {Array} filters array of filters
   * @returns {Array}
   * @example
   * // get filters
   * var filters = node.filters();
   *
   * // set a single filter
   * node.cache();
   * node.filters([Konva.Filters.Blur]);
   *
   * // set multiple filters
   * node.cache();
   * node.filters([
   *   Konva.Filters.Blur,
   *   Konva.Filters.Sepia,
   *   Konva.Filters.Invert
   * ]);
   */Konva.Factory.addGetterSetter(Konva.Node,'visible','inherit',function(val){var isValid=val===true||val===false||val==='inherit';if(!isValid){Konva.Util.warn(val+' is a not valid value for "visible" attribute. The value may be true, false or "inherit".');}return val;});/**
   * get/set visible attr.  Can be "inherit", true, or false.  The default is "inherit".
   *   If you need to determine if a node is visible or not
   *   by taking into account its parents, use the isVisible() method
   * @name visible
   * @method
   * @memberof Konva.Node.prototype
   * @param {Boolean|String} visible
   * @returns {Boolean|String}
   * @example
   * // get visible attr
   * var visible = node.visible();
   *
   * // make invisible
   * node.visible(false);
   *
   * // make visible
   * node.visible(true);
   *
   * // make visible according to the parent
   * node.visible('inherit');
   */Konva.Factory.addGetterSetter(Konva.Node,'transformsEnabled','all',Konva.Validators.getStringValidator());/**
   * get/set transforms that are enabled.  Can be "all", "none", or "position".  The default
   *  is "all"
   * @name transformsEnabled
   * @method
   * @memberof Konva.Node.prototype
   * @param {String} enabled
   * @returns {String}
   * @example
   * // enable position transform only to improve draw performance
   * node.transformsEnabled('position');
   *
   * // enable all transforms
   * node.transformsEnabled('all');
   *//**
   * get/set node size
   * @name size
   * @method
   * @memberof Konva.Node.prototype
   * @param {Object} size
   * @param {Number} size.width
   * @param {Number} size.height
   * @returns {Object}
   * @example
   * // get node size
   * var size = node.size();
   * var x = size.x;
   * var y = size.y;
   *
   * // set size
   * node.size({
   *   width: 100,
   *   height: 200
   * });
   */Konva.Factory.addOverloadedGetterSetter(Konva.Node,'size');Konva.Factory.backCompat(Konva.Node,{rotateDeg:'rotate',setRotationDeg:'setRotation',getRotationDeg:'getRotation'});Konva.Collection.mapMethods(Konva.Node);})(Konva);(function(){'use strict';/**
   * Grayscale Filter
   * @function
   * @memberof Konva.Filters
   * @param {Object} imageData
   * @example
   * node.cache();
   * node.filters([Konva.Filters.Grayscale]);
   */Konva.Filters.Grayscale=function(imageData){var data=imageData.data,len=data.length,i,brightness;for(i=0;i<len;i+=4){brightness=0.34*data[i]+0.5*data[i+1]+0.16*data[i+2];// red
data[i]=brightness;// green
data[i+1]=brightness;// blue
data[i+2]=brightness;}};})();(function(Konva){'use strict';/**
   * Brighten Filter.
   * @function
   * @memberof Konva.Filters
   * @param {Object} imageData
   * @example
   * node.cache();
   * node.filters([Konva.Filters.Brighten]);
   * node.brightness(0.8);
   */Konva.Filters.Brighten=function(imageData){var brightness=this.brightness()*255,data=imageData.data,len=data.length,i;for(i=0;i<len;i+=4){// red
data[i]+=brightness;// green
data[i+1]+=brightness;// blue
data[i+2]+=brightness;}};Konva.Factory.addGetterSetter(Konva.Node,'brightness',0,Konva.Validators.getNumberValidator(),Konva.Factory.afterSetFilter);/**
   * get/set filter brightness.  The brightness is a number between -1 and 1.&nbsp; Positive values
   *  brighten the pixels and negative values darken them. Use with {@link Konva.Filters.Brighten} filter.
   * @name brightness
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} brightness value between -1 and 1
   * @returns {Number}
   */})(Konva);(function(){'use strict';/**
   * Invert Filter
   * @function
   * @memberof Konva.Filters
   * @param {Object} imageData
   * @example
   * node.cache();
   * node.filters([Konva.Filters.Invert]);
   */Konva.Filters.Invert=function(imageData){var data=imageData.data,len=data.length,i;for(i=0;i<len;i+=4){// red
data[i]=255-data[i];// green
data[i+1]=255-data[i+1];// blue
data[i+2]=255-data[i+2];}};})();/*
 the Gauss filter
 master repo: https://github.com/pavelpower/kineticjsGaussFilter
*/(function(Konva){'use strict';/*

     StackBlur - a fast almost Gaussian Blur For Canvas

     Version:   0.5
     Author:    Mario Klingemann
     Contact:   mario@quasimondo.com
     Website:   http://www.quasimondo.com/StackBlurForCanvas
     Twitter:   @quasimondo

     In case you find this class useful - especially in commercial projects -
     I am not totally unhappy for a small donation to my PayPal account
     mario@quasimondo.de

     Or support me on flattr:
     https://flattr.com/thing/72791/StackBlur-a-fast-almost-Gaussian-Blur-Effect-for-CanvasJavascript

     Copyright (c) 2010 Mario Klingemann

     Permission is hereby granted, free of charge, to any person
     obtaining a copy of this software and associated documentation
     files (the "Software"), to deal in the Software without
     restriction, including without limitation the rights to use,
     copy, modify, merge, publish, distribute, sublicense, and/or sell
     copies of the Software, and to permit persons to whom the
     Software is furnished to do so, subject to the following
     conditions:

     The above copyright notice and this permission notice shall be
     included in all copies or substantial portions of the Software.

     THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
     EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
     OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
     NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
     HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
     WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
     FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
     OTHER DEALINGS IN THE SOFTWARE.
     */function BlurStack(){this.r=0;this.g=0;this.b=0;this.a=0;this.next=null;}var mul_table=[512,512,456,512,328,456,335,512,405,328,271,456,388,335,292,512,454,405,364,328,298,271,496,456,420,388,360,335,312,292,273,512,482,454,428,405,383,364,345,328,312,298,284,271,259,496,475,456,437,420,404,388,374,360,347,335,323,312,302,292,282,273,265,512,497,482,468,454,441,428,417,405,394,383,373,364,354,345,337,328,320,312,305,298,291,284,278,271,265,259,507,496,485,475,465,456,446,437,428,420,412,404,396,388,381,374,367,360,354,347,341,335,329,323,318,312,307,302,297,292,287,282,278,273,269,265,261,512,505,497,489,482,475,468,461,454,447,441,435,428,422,417,411,405,399,394,389,383,378,373,368,364,359,354,350,345,341,337,332,328,324,320,316,312,309,305,301,298,294,291,287,284,281,278,274,271,268,265,262,259,257,507,501,496,491,485,480,475,470,465,460,456,451,446,442,437,433,428,424,420,416,412,408,404,400,396,392,388,385,381,377,374,370,367,363,360,357,354,350,347,344,341,338,335,332,329,326,323,320,318,315,312,310,307,304,302,299,297,294,292,289,287,285,282,280,278,275,273,271,269,267,265,263,261,259];var shg_table=[9,11,12,13,13,14,14,15,15,15,15,16,16,16,16,17,17,17,17,17,17,17,18,18,18,18,18,18,18,18,18,19,19,19,19,19,19,19,19,19,19,19,19,19,19,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24];function filterGaussBlurRGBA(imageData,radius){var pixels=imageData.data,width=imageData.width,height=imageData.height;var x,y,i,p,yp,yi,yw,r_sum,g_sum,b_sum,a_sum,r_out_sum,g_out_sum,b_out_sum,a_out_sum,r_in_sum,g_in_sum,b_in_sum,a_in_sum,pr,pg,pb,pa,rbs;var div=radius+radius+1,widthMinus1=width-1,heightMinus1=height-1,radiusPlus1=radius+1,sumFactor=radiusPlus1*(radiusPlus1+1)/2,stackStart=new BlurStack(),stackEnd=null,stack=stackStart,stackIn=null,stackOut=null,mul_sum=mul_table[radius],shg_sum=shg_table[radius];for(i=1;i<div;i++){stack=stack.next=new BlurStack();if(i===radiusPlus1){stackEnd=stack;}}stack.next=stackStart;yw=yi=0;for(y=0;y<height;y++){r_in_sum=g_in_sum=b_in_sum=a_in_sum=r_sum=g_sum=b_sum=a_sum=0;r_out_sum=radiusPlus1*(pr=pixels[yi]);g_out_sum=radiusPlus1*(pg=pixels[yi+1]);b_out_sum=radiusPlus1*(pb=pixels[yi+2]);a_out_sum=radiusPlus1*(pa=pixels[yi+3]);r_sum+=sumFactor*pr;g_sum+=sumFactor*pg;b_sum+=sumFactor*pb;a_sum+=sumFactor*pa;stack=stackStart;for(i=0;i<radiusPlus1;i++){stack.r=pr;stack.g=pg;stack.b=pb;stack.a=pa;stack=stack.next;}for(i=1;i<radiusPlus1;i++){p=yi+((widthMinus1<i?widthMinus1:i)<<2);r_sum+=(stack.r=pr=pixels[p])*(rbs=radiusPlus1-i);g_sum+=(stack.g=pg=pixels[p+1])*rbs;b_sum+=(stack.b=pb=pixels[p+2])*rbs;a_sum+=(stack.a=pa=pixels[p+3])*rbs;r_in_sum+=pr;g_in_sum+=pg;b_in_sum+=pb;a_in_sum+=pa;stack=stack.next;}stackIn=stackStart;stackOut=stackEnd;for(x=0;x<width;x++){pixels[yi+3]=pa=a_sum*mul_sum>>shg_sum;if(pa!==0){pa=255/pa;pixels[yi]=(r_sum*mul_sum>>shg_sum)*pa;pixels[yi+1]=(g_sum*mul_sum>>shg_sum)*pa;pixels[yi+2]=(b_sum*mul_sum>>shg_sum)*pa;}else{pixels[yi]=pixels[yi+1]=pixels[yi+2]=0;}r_sum-=r_out_sum;g_sum-=g_out_sum;b_sum-=b_out_sum;a_sum-=a_out_sum;r_out_sum-=stackIn.r;g_out_sum-=stackIn.g;b_out_sum-=stackIn.b;a_out_sum-=stackIn.a;p=yw+((p=x+radius+1)<widthMinus1?p:widthMinus1)<<2;r_in_sum+=stackIn.r=pixels[p];g_in_sum+=stackIn.g=pixels[p+1];b_in_sum+=stackIn.b=pixels[p+2];a_in_sum+=stackIn.a=pixels[p+3];r_sum+=r_in_sum;g_sum+=g_in_sum;b_sum+=b_in_sum;a_sum+=a_in_sum;stackIn=stackIn.next;r_out_sum+=pr=stackOut.r;g_out_sum+=pg=stackOut.g;b_out_sum+=pb=stackOut.b;a_out_sum+=pa=stackOut.a;r_in_sum-=pr;g_in_sum-=pg;b_in_sum-=pb;a_in_sum-=pa;stackOut=stackOut.next;yi+=4;}yw+=width;}for(x=0;x<width;x++){g_in_sum=b_in_sum=a_in_sum=r_in_sum=g_sum=b_sum=a_sum=r_sum=0;yi=x<<2;r_out_sum=radiusPlus1*(pr=pixels[yi]);g_out_sum=radiusPlus1*(pg=pixels[yi+1]);b_out_sum=radiusPlus1*(pb=pixels[yi+2]);a_out_sum=radiusPlus1*(pa=pixels[yi+3]);r_sum+=sumFactor*pr;g_sum+=sumFactor*pg;b_sum+=sumFactor*pb;a_sum+=sumFactor*pa;stack=stackStart;for(i=0;i<radiusPlus1;i++){stack.r=pr;stack.g=pg;stack.b=pb;stack.a=pa;stack=stack.next;}yp=width;for(i=1;i<=radius;i++){yi=yp+x<<2;r_sum+=(stack.r=pr=pixels[yi])*(rbs=radiusPlus1-i);g_sum+=(stack.g=pg=pixels[yi+1])*rbs;b_sum+=(stack.b=pb=pixels[yi+2])*rbs;a_sum+=(stack.a=pa=pixels[yi+3])*rbs;r_in_sum+=pr;g_in_sum+=pg;b_in_sum+=pb;a_in_sum+=pa;stack=stack.next;if(i<heightMinus1){yp+=width;}}yi=x;stackIn=stackStart;stackOut=stackEnd;for(y=0;y<height;y++){p=yi<<2;pixels[p+3]=pa=a_sum*mul_sum>>shg_sum;if(pa>0){pa=255/pa;pixels[p]=(r_sum*mul_sum>>shg_sum)*pa;pixels[p+1]=(g_sum*mul_sum>>shg_sum)*pa;pixels[p+2]=(b_sum*mul_sum>>shg_sum)*pa;}else{pixels[p]=pixels[p+1]=pixels[p+2]=0;}r_sum-=r_out_sum;g_sum-=g_out_sum;b_sum-=b_out_sum;a_sum-=a_out_sum;r_out_sum-=stackIn.r;g_out_sum-=stackIn.g;b_out_sum-=stackIn.b;a_out_sum-=stackIn.a;p=x+((p=y+radiusPlus1)<heightMinus1?p:heightMinus1)*width<<2;r_sum+=r_in_sum+=stackIn.r=pixels[p];g_sum+=g_in_sum+=stackIn.g=pixels[p+1];b_sum+=b_in_sum+=stackIn.b=pixels[p+2];a_sum+=a_in_sum+=stackIn.a=pixels[p+3];stackIn=stackIn.next;r_out_sum+=pr=stackOut.r;g_out_sum+=pg=stackOut.g;b_out_sum+=pb=stackOut.b;a_out_sum+=pa=stackOut.a;r_in_sum-=pr;g_in_sum-=pg;b_in_sum-=pb;a_in_sum-=pa;stackOut=stackOut.next;yi+=width;}}}/**
   * Blur Filter
   * @function
   * @name Blur
   * @memberof Konva.Filters
   * @param {Object} imageData
   * @example
   * node.cache();
   * node.filters([Konva.Filters.Blur]);
   * node.blurRadius(10);
   */Konva.Filters.Blur=function Blur(imageData){var radius=Math.round(this.blurRadius());if(radius>0){filterGaussBlurRGBA(imageData,radius);}};Konva.Factory.addGetterSetter(Konva.Node,'blurRadius',0,Konva.Validators.getNumberValidator(),Konva.Factory.afterSetFilter);/**
   * get/set blur radius. Use with {@link Konva.Filters.Blur} filter
   * @name blurRadius
   * @method
   * @memberof Konva.Node.prototype
   * @param {Integer} radius
   * @returns {Integer}
   */})(Konva);/*eslint-disable  max-depth */(function(){'use strict';function pixelAt(idata,x,y){var idx=(y*idata.width+x)*4;var d=[];d.push(idata.data[idx++],idata.data[idx++],idata.data[idx++],idata.data[idx++]);return d;}function rgbDistance(p1,p2){return Math.sqrt(Math.pow(p1[0]-p2[0],2)+Math.pow(p1[1]-p2[1],2)+Math.pow(p1[2]-p2[2],2));}function rgbMean(pTab){var m=[0,0,0];for(var i=0;i<pTab.length;i++){m[0]+=pTab[i][0];m[1]+=pTab[i][1];m[2]+=pTab[i][2];}m[0]/=pTab.length;m[1]/=pTab.length;m[2]/=pTab.length;return m;}function backgroundMask(idata,threshold){var rgbv_no=pixelAt(idata,0,0);var rgbv_ne=pixelAt(idata,idata.width-1,0);var rgbv_so=pixelAt(idata,0,idata.height-1);var rgbv_se=pixelAt(idata,idata.width-1,idata.height-1);var thres=threshold||10;if(rgbDistance(rgbv_no,rgbv_ne)<thres&&rgbDistance(rgbv_ne,rgbv_se)<thres&&rgbDistance(rgbv_se,rgbv_so)<thres&&rgbDistance(rgbv_so,rgbv_no)<thres){// Mean color
var mean=rgbMean([rgbv_ne,rgbv_no,rgbv_se,rgbv_so]);// Mask based on color distance
var mask=[];for(var i=0;i<idata.width*idata.height;i++){var d=rgbDistance(mean,[idata.data[i*4],idata.data[i*4+1],idata.data[i*4+2]]);mask[i]=d<thres?0:255;}return mask;}}function applyMask(idata,mask){for(var i=0;i<idata.width*idata.height;i++){idata.data[4*i+3]=mask[i];}}function erodeMask(mask,sw,sh){var weights=[1,1,1,1,0,1,1,1,1];var side=Math.round(Math.sqrt(weights.length));var halfSide=Math.floor(side/2);var maskResult=[];for(var y=0;y<sh;y++){for(var x=0;x<sw;x++){var so=y*sw+x;var a=0;for(var cy=0;cy<side;cy++){for(var cx=0;cx<side;cx++){var scy=y+cy-halfSide;var scx=x+cx-halfSide;if(scy>=0&&scy<sh&&scx>=0&&scx<sw){var srcOff=scy*sw+scx;var wt=weights[cy*side+cx];a+=mask[srcOff]*wt;}}}maskResult[so]=a===255*8?255:0;}}return maskResult;}function dilateMask(mask,sw,sh){var weights=[1,1,1,1,1,1,1,1,1];var side=Math.round(Math.sqrt(weights.length));var halfSide=Math.floor(side/2);var maskResult=[];for(var y=0;y<sh;y++){for(var x=0;x<sw;x++){var so=y*sw+x;var a=0;for(var cy=0;cy<side;cy++){for(var cx=0;cx<side;cx++){var scy=y+cy-halfSide;var scx=x+cx-halfSide;if(scy>=0&&scy<sh&&scx>=0&&scx<sw){var srcOff=scy*sw+scx;var wt=weights[cy*side+cx];a+=mask[srcOff]*wt;}}}maskResult[so]=a>=255*4?255:0;}}return maskResult;}function smoothEdgeMask(mask,sw,sh){var weights=[1/9,1/9,1/9,1/9,1/9,1/9,1/9,1/9,1/9];var side=Math.round(Math.sqrt(weights.length));var halfSide=Math.floor(side/2);var maskResult=[];for(var y=0;y<sh;y++){for(var x=0;x<sw;x++){var so=y*sw+x;var a=0;for(var cy=0;cy<side;cy++){for(var cx=0;cx<side;cx++){var scy=y+cy-halfSide;var scx=x+cx-halfSide;if(scy>=0&&scy<sh&&scx>=0&&scx<sw){var srcOff=scy*sw+scx;var wt=weights[cy*side+cx];a+=mask[srcOff]*wt;}}}maskResult[so]=a;}}return maskResult;}/**
   * Mask Filter
   * @function
   * @name Mask
   * @memberof Konva.Filters
   * @param {Object} imageData
   * @example
   * node.cache();
   * node.filters([Konva.Filters.Mask]);
   * node.threshold(200);
   */Konva.Filters.Mask=function(imageData){// Detect pixels close to the background color
var threshold=this.threshold(),mask=backgroundMask(imageData,threshold);if(mask){// Erode
mask=erodeMask(mask,imageData.width,imageData.height);// Dilate
mask=dilateMask(mask,imageData.width,imageData.height);// Gradient
mask=smoothEdgeMask(mask,imageData.width,imageData.height);// Apply mask
applyMask(imageData,mask);// todo : Update hit region function according to mask
}return imageData;};Konva.Factory.addGetterSetter(Konva.Node,'threshold',0,Konva.Validators.getNumberValidator(),Konva.Factory.afterSetFilter);})();(function(){'use strict';/**
   * RGB Filter
   * @function
   * @name RGB
   * @memberof Konva.Filters
   * @param {Object} imageData
   * @author ippo615
   * @example
   * node.cache();
   * node.filters([Konva.Filters.RGB]);
   * node.blue(120);
   * node.green(200);
   */Konva.Filters.RGB=function(imageData){var data=imageData.data,nPixels=data.length,red=this.red(),green=this.green(),blue=this.blue(),i,brightness;for(i=0;i<nPixels;i+=4){brightness=(0.34*data[i]+0.5*data[i+1]+0.16*data[i+2])/255;data[i]=brightness*red;// r
data[i+1]=brightness*green;// g
data[i+2]=brightness*blue;// b
data[i+3]=data[i+3];// alpha
}};Konva.Factory.addGetterSetter(Konva.Node,'red',0,function(val){this._filterUpToDate=false;if(val>255){return 255;}else if(val<0){return 0;}else{return Math.round(val);}});/**
   * get/set filter red value. Use with {@link Konva.Filters.RGB} filter.
   * @name red
   * @method
   * @memberof Konva.Node.prototype
   * @param {Integer} red value between 0 and 255
   * @returns {Integer}
   */Konva.Factory.addGetterSetter(Konva.Node,'green',0,function(val){this._filterUpToDate=false;if(val>255){return 255;}else if(val<0){return 0;}else{return Math.round(val);}});/**
   * get/set filter green value. Use with {@link Konva.Filters.RGB} filter.
   * @name green
   * @method
   * @memberof Konva.Node.prototype
   * @param {Integer} green value between 0 and 255
   * @returns {Integer}
   */Konva.Factory.addGetterSetter(Konva.Node,'blue',0,Konva.Validators.RGBComponent,Konva.Factory.afterSetFilter);/**
   * get/set filter blue value. Use with {@link Konva.Filters.RGB} filter.
   * @name blue
   * @method
   * @memberof Konva.Node.prototype
   * @param {Integer} blue value between 0 and 255
   * @returns {Integer}
   */})();(function(){'use strict';/**
   * RGBA Filter
   * @function
   * @name RGBA
   * @memberof Konva.Filters
   * @param {Object} imageData
   * @author codefo
   * @example
   * node.cache();
   * node.filters([Konva.Filters.RGBA]);
   * node.blue(120);
   * node.green(200);
   * node.alpha(0.3);
   */Konva.Filters.RGBA=function(imageData){var data=imageData.data,nPixels=data.length,red=this.red(),green=this.green(),blue=this.blue(),alpha=this.alpha(),i,ia;for(i=0;i<nPixels;i+=4){ia=1-alpha;data[i]=red*alpha+data[i]*ia;// r
data[i+1]=green*alpha+data[i+1]*ia;// g
data[i+2]=blue*alpha+data[i+2]*ia;// b
}};Konva.Factory.addGetterSetter(Konva.Node,'red',0,function(val){this._filterUpToDate=false;if(val>255){return 255;}else if(val<0){return 0;}else{return Math.round(val);}});/**
   * get/set filter red value. Use with {@link Konva.Filters.RGBA} filter.
   * @name red
   * @method
   * @memberof Konva.Node.prototype
   * @param {Integer} red value between 0 and 255
   * @returns {Integer}
   */Konva.Factory.addGetterSetter(Konva.Node,'green',0,function(val){this._filterUpToDate=false;if(val>255){return 255;}else if(val<0){return 0;}else{return Math.round(val);}});/**
   * get/set filter green value. Use with {@link Konva.Filters.RGBA} filter.
   * @name green
   * @method
   * @memberof Konva.Node.prototype
   * @param {Integer} green value between 0 and 255
   * @returns {Integer}
   */Konva.Factory.addGetterSetter(Konva.Node,'blue',0,Konva.Validators.RGBComponent,Konva.Factory.afterSetFilter);/**
   * get/set filter blue value. Use with {@link Konva.Filters.RGBA} filter.
   * @name blue
   * @method
   * @memberof Konva.Node.prototype
   * @param {Integer} blue value between 0 and 255
   * @returns {Integer}
   */Konva.Factory.addGetterSetter(Konva.Node,'alpha',1,function(val){this._filterUpToDate=false;if(val>1){return 1;}else if(val<0){return 0;}else{return val;}});/**
   * get/set filter alpha value. Use with {@link Konva.Filters.RGBA} filter.
   * @name alpha
   * @method
   * @memberof Konva.Node.prototype
   * @param {Float} alpha value between 0 and 1
   * @returns {Float}
   */})();(function(){'use strict';/**
   * HSV Filter. Adjusts the hue, saturation and value
   * @function
   * @name HSV
   * @memberof Konva.Filters
   * @param {Object} imageData
   * @author ippo615
   * @example
   * image.filters([Konva.Filters.HSV]);
   * image.value(200);
   */Konva.Filters.HSV=function(imageData){var data=imageData.data,nPixels=data.length,v=Math.pow(2,this.value()),s=Math.pow(2,this.saturation()),h=Math.abs(this.hue()+360)%360,i;// Basis for the technique used:
// http://beesbuzz.biz/code/hsv_color_transforms.php
// V is the value multiplier (1 for none, 2 for double, 0.5 for half)
// S is the saturation multiplier (1 for none, 2 for double, 0.5 for half)
// H is the hue shift in degrees (0 to 360)
// vsu = V*S*cos(H*PI/180);
// vsw = V*S*sin(H*PI/180);
//[ .299V+.701vsu+.168vsw    .587V-.587vsu+.330vsw    .114V-.114vsu-.497vsw ] [R]
//[ .299V-.299vsu-.328vsw    .587V+.413vsu+.035vsw    .114V-.114vsu+.292vsw ]*[G]
//[ .299V-.300vsu+1.25vsw    .587V-.588vsu-1.05vsw    .114V+.886vsu-.203vsw ] [B]
// Precompute the values in the matrix:
var vsu=v*s*Math.cos(h*Math.PI/180),vsw=v*s*Math.sin(h*Math.PI/180);// (result spot)(source spot)
var rr=0.299*v+0.701*vsu+0.167*vsw,rg=0.587*v-0.587*vsu+0.33*vsw,rb=0.114*v-0.114*vsu-0.497*vsw;var gr=0.299*v-0.299*vsu-0.328*vsw,gg=0.587*v+0.413*vsu+0.035*vsw,gb=0.114*v-0.114*vsu+0.293*vsw;var br=0.299*v-0.3*vsu+1.25*vsw,bg=0.587*v-0.586*vsu-1.05*vsw,bb=0.114*v+0.886*vsu-0.2*vsw;var r,g,b,a;for(i=0;i<nPixels;i+=4){r=data[i+0];g=data[i+1];b=data[i+2];a=data[i+3];data[i+0]=rr*r+rg*g+rb*b;data[i+1]=gr*r+gg*g+gb*b;data[i+2]=br*r+bg*g+bb*b;data[i+3]=a;// alpha
}};Konva.Factory.addGetterSetter(Konva.Node,'hue',0,Konva.Validators.getNumberValidator(),Konva.Factory.afterSetFilter);/**
   * get/set hsv hue in degrees. Use with {@link Konva.Filters.HSV} or {@link Konva.Filters.HSL} filter.
   * @name hue
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} hue value between 0 and 359
   * @returns {Number}
   */Konva.Factory.addGetterSetter(Konva.Node,'saturation',0,Konva.Validators.getNumberValidator(),Konva.Factory.afterSetFilter);/**
   * get/set hsv saturation. Use with {@link Konva.Filters.HSV} or {@link Konva.Filters.HSL} filter.
   * @name saturation
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} saturation 0 is no change, -1.0 halves the saturation, 1.0 doubles, etc..
   * @returns {Number}
   */Konva.Factory.addGetterSetter(Konva.Node,'value',0,Konva.Validators.getNumberValidator(),Konva.Factory.afterSetFilter);/**
   * get/set hsv value. Use with {@link Konva.Filters.HSV} filter.
   * @name value
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} value 0 is no change, -1.0 halves the value, 1.0 doubles, etc..
   * @returns {Number}
   */})();(function(){'use strict';Konva.Factory.addGetterSetter(Konva.Node,'hue',0,Konva.Validators.getNumberValidator(),Konva.Factory.afterSetFilter);/**
   * get/set hsv hue in degrees. Use with {@link Konva.Filters.HSV} or {@link Konva.Filters.HSL} filter.
   * @name hue
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} hue value between 0 and 359
   * @returns {Number}
   */Konva.Factory.addGetterSetter(Konva.Node,'saturation',0,Konva.Validators.getNumberValidator(),Konva.Factory.afterSetFilter);/**
   * get/set hsv saturation. Use with {@link Konva.Filters.HSV} or {@link Konva.Filters.HSL} filter.
   * @name saturation
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} saturation 0 is no change, -1.0 halves the saturation, 1.0 doubles, etc..
   * @returns {Number}
   */Konva.Factory.addGetterSetter(Konva.Node,'luminance',0,Konva.Validators.getNumberValidator(),Konva.Factory.afterSetFilter);/**
   * get/set hsl luminance. Use with {@link Konva.Filters.HSL} filter.
   * @name value
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} value from -1 to 1
   * @returns {Number}
   *//**
   * HSL Filter. Adjusts the hue, saturation and luminance (or lightness)
   * @function
   * @memberof Konva.Filters
   * @param {Object} imageData
   * @author ippo615
   * @example
   * image.filters([Konva.Filters.HSL]);
   * image.luminance(200);
   */Konva.Filters.HSL=function(imageData){var data=imageData.data,nPixels=data.length,v=1,s=Math.pow(2,this.saturation()),h=Math.abs(this.hue()+360)%360,l=this.luminance()*127,i;// Basis for the technique used:
// http://beesbuzz.biz/code/hsv_color_transforms.php
// V is the value multiplier (1 for none, 2 for double, 0.5 for half)
// S is the saturation multiplier (1 for none, 2 for double, 0.5 for half)
// H is the hue shift in degrees (0 to 360)
// vsu = V*S*cos(H*PI/180);
// vsw = V*S*sin(H*PI/180);
//[ .299V+.701vsu+.168vsw    .587V-.587vsu+.330vsw    .114V-.114vsu-.497vsw ] [R]
//[ .299V-.299vsu-.328vsw    .587V+.413vsu+.035vsw    .114V-.114vsu+.292vsw ]*[G]
//[ .299V-.300vsu+1.25vsw    .587V-.588vsu-1.05vsw    .114V+.886vsu-.203vsw ] [B]
// Precompute the values in the matrix:
var vsu=v*s*Math.cos(h*Math.PI/180),vsw=v*s*Math.sin(h*Math.PI/180);// (result spot)(source spot)
var rr=0.299*v+0.701*vsu+0.167*vsw,rg=0.587*v-0.587*vsu+0.33*vsw,rb=0.114*v-0.114*vsu-0.497*vsw;var gr=0.299*v-0.299*vsu-0.328*vsw,gg=0.587*v+0.413*vsu+0.035*vsw,gb=0.114*v-0.114*vsu+0.293*vsw;var br=0.299*v-0.3*vsu+1.25*vsw,bg=0.587*v-0.586*vsu-1.05*vsw,bb=0.114*v+0.886*vsu-0.2*vsw;var r,g,b,a;for(i=0;i<nPixels;i+=4){r=data[i+0];g=data[i+1];b=data[i+2];a=data[i+3];data[i+0]=rr*r+rg*g+rb*b+l;data[i+1]=gr*r+gg*g+gb*b+l;data[i+2]=br*r+bg*g+bb*b+l;data[i+3]=a;// alpha
}};})();(function(){'use strict';/**
   * Emboss Filter.
   * Pixastic Lib - Emboss filter - v0.1.0
   * Copyright (c) 2008 Jacob Seidelin, jseidelin@nihilogic.dk, http://blog.nihilogic.dk/
   * License: [http://www.pixastic.com/lib/license.txt]
   * @function
   * @memberof Konva.Filters
   * @param {Object} imageData
   * @example
   * node.cache();
   * node.filters([Konva.Filters.Emboss]);
   * node.embossStrength(0.8);
   * node.embossWhiteLevel(0.3);
   * node.embossDirection('right');
   * node.embossBlend(true);
   */Konva.Filters.Emboss=function(imageData){// pixastic strength is between 0 and 10.  I want it between 0 and 1
// pixastic greyLevel is between 0 and 255.  I want it between 0 and 1.  Also,
// a max value of greyLevel yields a white emboss, and the min value yields a black
// emboss.  Therefore, I changed greyLevel to whiteLevel
var strength=this.embossStrength()*10,greyLevel=this.embossWhiteLevel()*255,direction=this.embossDirection(),blend=this.embossBlend(),dirY=0,dirX=0,data=imageData.data,w=imageData.width,h=imageData.height,w4=w*4,y=h;switch(direction){case'top-left':dirY=-1;dirX=-1;break;case'top':dirY=-1;dirX=0;break;case'top-right':dirY=-1;dirX=1;break;case'right':dirY=0;dirX=1;break;case'bottom-right':dirY=1;dirX=1;break;case'bottom':dirY=1;dirX=0;break;case'bottom-left':dirY=1;dirX=-1;break;case'left':dirY=0;dirX=-1;break;default:Konva.Util.error('Unknown emboss direction: '+direction);}do{var offsetY=(y-1)*w4;var otherY=dirY;if(y+otherY<1){otherY=0;}if(y+otherY>h){otherY=0;}var offsetYOther=(y-1+otherY)*w*4;var x=w;do{var offset=offsetY+(x-1)*4;var otherX=dirX;if(x+otherX<1){otherX=0;}if(x+otherX>w){otherX=0;}var offsetOther=offsetYOther+(x-1+otherX)*4;var dR=data[offset]-data[offsetOther];var dG=data[offset+1]-data[offsetOther+1];var dB=data[offset+2]-data[offsetOther+2];var dif=dR;var absDif=dif>0?dif:-dif;var absG=dG>0?dG:-dG;var absB=dB>0?dB:-dB;if(absG>absDif){dif=dG;}if(absB>absDif){dif=dB;}dif*=strength;if(blend){var r=data[offset]+dif;var g=data[offset+1]+dif;var b=data[offset+2]+dif;data[offset]=r>255?255:r<0?0:r;data[offset+1]=g>255?255:g<0?0:g;data[offset+2]=b>255?255:b<0?0:b;}else{var grey=greyLevel-dif;if(grey<0){grey=0;}else if(grey>255){grey=255;}data[offset]=data[offset+1]=data[offset+2]=grey;}}while(--x);}while(--y);};Konva.Factory.addGetterSetter(Konva.Node,'embossStrength',0.5,Konva.Validators.getNumberValidator(),Konva.Factory.afterSetFilter);/**
   * get/set emboss strength. Use with {@link Konva.Filters.Emboss} filter.
   * @name embossStrength
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} level between 0 and 1.  Default is 0.5
   * @returns {Number}
   */Konva.Factory.addGetterSetter(Konva.Node,'embossWhiteLevel',0.5,Konva.Validators.getNumberValidator(),Konva.Factory.afterSetFilter);/**
   * get/set emboss white level. Use with {@link Konva.Filters.Emboss} filter.
   * @name embossWhiteLevel
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} embossWhiteLevel between 0 and 1.  Default is 0.5
   * @returns {Number}
   */Konva.Factory.addGetterSetter(Konva.Node,'embossDirection','top-left',null,Konva.Factory.afterSetFilter);/**
   * get/set emboss direction. Use with {@link Konva.Filters.Emboss} filter.
   * @name embossDirection
   * @method
   * @memberof Konva.Node.prototype
   * @param {String} embossDirection can be top-left, top, top-right, right, bottom-right, bottom, bottom-left or left
   *   The default is top-left
   * @returns {String}
   */Konva.Factory.addGetterSetter(Konva.Node,'embossBlend',false,null,Konva.Factory.afterSetFilter);/**
   * get/set emboss blend. Use with {@link Konva.Filters.Emboss} filter.
   * @name embossBlend
   * @method
   * @memberof Konva.Node.prototype
   * @param {Boolean} embossBlend
   * @returns {Boolean}
   */})();(function(){'use strict';function remap(fromValue,fromMin,fromMax,toMin,toMax){// Compute the range of the data
var fromRange=fromMax-fromMin,toRange=toMax-toMin,toValue;// If either range is 0, then the value can only be mapped to 1 value
if(fromRange===0){return toMin+toRange/2;}if(toRange===0){return toMin;}// (1) untranslate, (2) unscale, (3) rescale, (4) retranslate
toValue=(fromValue-fromMin)/fromRange;toValue=toRange*toValue+toMin;return toValue;}/**
   * Enhance Filter. Adjusts the colors so that they span the widest
   *  possible range (ie 0-255). Performs w*h pixel reads and w*h pixel
   *  writes.
   * @function
   * @name Enhance
   * @memberof Konva.Filters
   * @param {Object} imageData
   * @author ippo615
   * @example
   * node.cache();
   * node.filters([Konva.Filters.Enhance]);
   * node.enhance(0.4);
   */Konva.Filters.Enhance=function(imageData){var data=imageData.data,nSubPixels=data.length,rMin=data[0],rMax=rMin,r,gMin=data[1],gMax=gMin,g,bMin=data[2],bMax=bMin,b,i;// If we are not enhancing anything - don't do any computation
var enhanceAmount=this.enhance();if(enhanceAmount===0){return;}// 1st Pass - find the min and max for each channel:
for(i=0;i<nSubPixels;i+=4){r=data[i+0];if(r<rMin){rMin=r;}else if(r>rMax){rMax=r;}g=data[i+1];if(g<gMin){gMin=g;}else if(g>gMax){gMax=g;}b=data[i+2];if(b<bMin){bMin=b;}else if(b>bMax){bMax=b;}//a = data[i + 3];
//if (a < aMin) { aMin = a; } else
//if (a > aMax) { aMax = a; }
}// If there is only 1 level - don't remap
if(rMax===rMin){rMax=255;rMin=0;}if(gMax===gMin){gMax=255;gMin=0;}if(bMax===bMin){bMax=255;bMin=0;}var rMid,rGoalMax,rGoalMin,gMid,gGoalMax,gGoalMin,bMid,bGoalMax,bGoalMin;// If the enhancement is positive - stretch the histogram
if(enhanceAmount>0){rGoalMax=rMax+enhanceAmount*(255-rMax);rGoalMin=rMin-enhanceAmount*(rMin-0);gGoalMax=gMax+enhanceAmount*(255-gMax);gGoalMin=gMin-enhanceAmount*(gMin-0);bGoalMax=bMax+enhanceAmount*(255-bMax);bGoalMin=bMin-enhanceAmount*(bMin-0);// If the enhancement is negative -   compress the histogram
}else{rMid=(rMax+rMin)*0.5;rGoalMax=rMax+enhanceAmount*(rMax-rMid);rGoalMin=rMin+enhanceAmount*(rMin-rMid);gMid=(gMax+gMin)*0.5;gGoalMax=gMax+enhanceAmount*(gMax-gMid);gGoalMin=gMin+enhanceAmount*(gMin-gMid);bMid=(bMax+bMin)*0.5;bGoalMax=bMax+enhanceAmount*(bMax-bMid);bGoalMin=bMin+enhanceAmount*(bMin-bMid);}// Pass 2 - remap everything, except the alpha
for(i=0;i<nSubPixels;i+=4){data[i+0]=remap(data[i+0],rMin,rMax,rGoalMin,rGoalMax);data[i+1]=remap(data[i+1],gMin,gMax,gGoalMin,gGoalMax);data[i+2]=remap(data[i+2],bMin,bMax,bGoalMin,bGoalMax);//data[i + 3] = remap(data[i + 3], aMin, aMax, aGoalMin, aGoalMax);
}};/**
   * get/set enhance. Use with {@link Konva.Filters.Enhance} filter. -1 to 1 values
   * @name enhance
   * @method
   * @memberof Konva.Node.prototype
   * @param {Float} amount
   * @returns {Float}
   */Konva.Factory.addGetterSetter(Konva.Node,'enhance',0,Konva.Validators.getNumberValidator(),Konva.Factory.afterSetFilter);})();(function(){'use strict';/**
   * Posterize Filter. Adjusts the channels so that there are no more
   *  than n different values for that channel. This is also applied
   *  to the alpha channel.
   * @function
   * @name Posterize
   * @author ippo615
   * @memberof Konva.Filters
   * @param {Object} imageData
   * @example
   * node.cache();
   * node.filters([Konva.Filters.Posterize]);
   * node.levels(0.8); // between 0 and 1
   */Konva.Filters.Posterize=function(imageData){// level must be between 1 and 255
var levels=Math.round(this.levels()*254)+1,data=imageData.data,len=data.length,scale=255/levels,i;for(i=0;i<len;i+=1){data[i]=Math.floor(data[i]/scale)*scale;}};Konva.Factory.addGetterSetter(Konva.Node,'levels',0.5,Konva.Validators.getNumberValidator(),Konva.Factory.afterSetFilter);/**
   * get/set levels.  Must be a number between 0 and 1.  Use with {@link Konva.Filters.Posterize} filter.
   * @name levels
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} level between 0 and 1
   * @returns {Number}
   */})();(function(){'use strict';/**
   * Noise Filter. Randomly adds or substracts to the color channels
   * @function
   * @name Noise
   * @memberof Konva.Filters
   * @param {Object} imageData
   * @author ippo615
   * @example
   * node.cache();
   * node.filters([Konva.Filters.Noise]);
   * node.noise(0.8);
   */Konva.Filters.Noise=function(imageData){var amount=this.noise()*255,data=imageData.data,nPixels=data.length,half=amount/2,i;for(i=0;i<nPixels;i+=4){data[i+0]+=half-2*half*Math.random();data[i+1]+=half-2*half*Math.random();data[i+2]+=half-2*half*Math.random();}};Konva.Factory.addGetterSetter(Konva.Node,'noise',0.2,Konva.Validators.getNumberValidator(),Konva.Factory.afterSetFilter);/**
   * get/set noise amount.  Must be a value between 0 and 1. Use with {@link Konva.Filters.Noise} filter.
   * @name noise
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} noise
   * @returns {Number}
   */})();/*eslint-disable max-depth */(function(){'use strict';/**
   * Pixelate Filter. Averages groups of pixels and redraws
   *  them as larger pixels
   * @function
   * @name Pixelate
   * @memberof Konva.Filters
   * @param {Object} imageData
   * @author ippo615
   * @example
   * node.cache();
   * node.filters([Konva.Filters.Pixelate]);
   * node.pixelSize(10);
   */Konva.Filters.Pixelate=function(imageData){var pixelSize=Math.ceil(this.pixelSize()),width=imageData.width,height=imageData.height,x,y,i,//pixelsPerBin = pixelSize * pixelSize,
red,green,blue,alpha,nBinsX=Math.ceil(width/pixelSize),nBinsY=Math.ceil(height/pixelSize),xBinStart,xBinEnd,yBinStart,yBinEnd,xBin,yBin,pixelsInBin;imageData=imageData.data;if(pixelSize<=0){Konva.Util.error('pixelSize value can not be <= 0');return;}for(xBin=0;xBin<nBinsX;xBin+=1){for(yBin=0;yBin<nBinsY;yBin+=1){// Initialize the color accumlators to 0
red=0;green=0;blue=0;alpha=0;// Determine which pixels are included in this bin
xBinStart=xBin*pixelSize;xBinEnd=xBinStart+pixelSize;yBinStart=yBin*pixelSize;yBinEnd=yBinStart+pixelSize;// Add all of the pixels to this bin!
pixelsInBin=0;for(x=xBinStart;x<xBinEnd;x+=1){if(x>=width){continue;}for(y=yBinStart;y<yBinEnd;y+=1){if(y>=height){continue;}i=(width*y+x)*4;red+=imageData[i+0];green+=imageData[i+1];blue+=imageData[i+2];alpha+=imageData[i+3];pixelsInBin+=1;}}// Make sure the channels are between 0-255
red=red/pixelsInBin;green=green/pixelsInBin;blue=blue/pixelsInBin;alpha=alpha/pixelsInBin;// Draw this bin
for(x=xBinStart;x<xBinEnd;x+=1){if(x>=width){continue;}for(y=yBinStart;y<yBinEnd;y+=1){if(y>=height){continue;}i=(width*y+x)*4;imageData[i+0]=red;imageData[i+1]=green;imageData[i+2]=blue;imageData[i+3]=alpha;}}}}};Konva.Factory.addGetterSetter(Konva.Node,'pixelSize',8,Konva.Validators.getNumberValidator(),Konva.Factory.afterSetFilter);/**
   * get/set pixel size. Use with {@link Konva.Filters.Pixelate} filter.
   * @name pixelSize
   * @method
   * @memberof Konva.Node.prototype
   * @param {Integer} pixelSize
   * @returns {Integer}
   */})();(function(){'use strict';/**
   * Threshold Filter. Pushes any value above the mid point to
   *  the max and any value below the mid point to the min.
   *  This affects the alpha channel.
   * @function
   * @name Threshold
   * @memberof Konva.Filters
   * @param {Object} imageData
   * @author ippo615
   * @example
   * node.cache();
   * node.filters([Konva.Filters.Threshold]);
   * node.threshold(0.1);
   */Konva.Filters.Threshold=function(imageData){var level=this.threshold()*255,data=imageData.data,len=data.length,i;for(i=0;i<len;i+=1){data[i]=data[i]<level?0:255;}};Konva.Factory.addGetterSetter(Konva.Node,'threshold',0.5,Konva.Validators.getNumberValidator(),Konva.Factory.afterSetFilter);/**
   * get/set threshold.  Must be a value between 0 and 1. Use with {@link Konva.Filters.Threshold} or {@link Konva.Filters.Mask} filter.
   * @name threshold
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} threshold
   * @returns {Number}
   */})();(function(){'use strict';/**
   * Sepia Filter
   * Based on: Pixastic Lib - Sepia filter - v0.1.0
   * Copyright (c) 2008 Jacob Seidelin, jseidelin@nihilogic.dk, http://blog.nihilogic.dk/
   * @function
   * @name Sepia
   * @memberof Konva.Filters
   * @param {Object} imageData
   * @author Jacob Seidelin <jseidelin@nihilogic.dk>
   * @license MPL v1.1 [http://www.pixastic.com/lib/license.txt]
   * @example
   * node.cache();
   * node.filters([Konva.Filters.Sepia]);
   */Konva.Filters.Sepia=function(imageData){var data=imageData.data,w=imageData.width,y=imageData.height,w4=w*4,offsetY,x,offset,or,og,ob,r,g,b;do{offsetY=(y-1)*w4;x=w;do{offset=offsetY+(x-1)*4;or=data[offset];og=data[offset+1];ob=data[offset+2];r=or*0.393+og*0.769+ob*0.189;g=or*0.349+og*0.686+ob*0.168;b=or*0.272+og*0.534+ob*0.131;data[offset]=r>255?255:r;data[offset+1]=g>255?255:g;data[offset+2]=b>255?255:b;data[offset+3]=data[offset+3];}while(--x);}while(--y);};})();(function(){'use strict';/**
   * Solarize Filter
   * Pixastic Lib - Solarize filter - v0.1.0
   * Copyright (c) 2008 Jacob Seidelin, jseidelin@nihilogic.dk, http://blog.nihilogic.dk/
   * License: [http://www.pixastic.com/lib/license.txt]
   * @function
   * @name Solarize
   * @memberof Konva.Filters
   * @param {Object} imageData
   * @example
   * node.cache();
   * node.filters([Konva.Filters.Solarize]);
   */Konva.Filters.Solarize=function(imageData){var data=imageData.data,w=imageData.width,h=imageData.height,w4=w*4,y=h;do{var offsetY=(y-1)*w4;var x=w;do{var offset=offsetY+(x-1)*4;var r=data[offset];var g=data[offset+1];var b=data[offset+2];if(r>127){r=255-r;}if(g>127){g=255-g;}if(b>127){b=255-b;}data[offset]=r;data[offset+1]=g;data[offset+2]=b;}while(--x);}while(--y);};})();(function(){'use strict';/*
   * ToPolar Filter. Converts image data to polar coordinates. Performs
   *  w*h*4 pixel reads and w*h pixel writes. The r axis is placed along
   *  what would be the y axis and the theta axis along the x axis.
   * @function
   * @author ippo615
   * @memberof Konva.Filters
   * @param {ImageData} src, the source image data (what will be transformed)
   * @param {ImageData} dst, the destination image data (where it will be saved)
   * @param {Object} opt
   * @param {Number} [opt.polarCenterX] horizontal location for the center of the circle,
   *  default is in the middle
   * @param {Number} [opt.polarCenterY] vertical location for the center of the circle,
   *  default is in the middle
   */var ToPolar=function ToPolar(src,dst,opt){var srcPixels=src.data,dstPixels=dst.data,xSize=src.width,ySize=src.height,xMid=opt.polarCenterX||xSize/2,yMid=opt.polarCenterY||ySize/2,i,x,y,r=0,g=0,b=0,a=0;// Find the largest radius
var rad,rMax=Math.sqrt(xMid*xMid+yMid*yMid);x=xSize-xMid;y=ySize-yMid;rad=Math.sqrt(x*x+y*y);rMax=rad>rMax?rad:rMax;// We'll be uisng y as the radius, and x as the angle (theta=t)
var rSize=ySize,tSize=xSize,radius,theta;// We want to cover all angles (0-360) and we need to convert to
// radians (*PI/180)
var conversion=360/tSize*Math.PI/180,sin,cos;// var x1, x2, x1i, x2i, y1, y2, y1i, y2i, scale;
for(theta=0;theta<tSize;theta+=1){sin=Math.sin(theta*conversion);cos=Math.cos(theta*conversion);for(radius=0;radius<rSize;radius+=1){x=Math.floor(xMid+rMax*radius/rSize*cos);y=Math.floor(yMid+rMax*radius/rSize*sin);i=(y*xSize+x)*4;r=srcPixels[i+0];g=srcPixels[i+1];b=srcPixels[i+2];a=srcPixels[i+3];// Store it
//i = (theta * xSize  +  radius) * 4;
i=(theta+radius*xSize)*4;dstPixels[i+0]=r;dstPixels[i+1]=g;dstPixels[i+2]=b;dstPixels[i+3]=a;}}};/*
     * FromPolar Filter. Converts image data from polar coordinates back to rectangular.
     *  Performs w*h*4 pixel reads and w*h pixel writes.
     * @function
     * @author ippo615
     * @memberof Konva.Filters
     * @param {ImageData} src, the source image data (what will be transformed)
     * @param {ImageData} dst, the destination image data (where it will be saved)
     * @param {Object} opt
     * @param {Number} [opt.polarCenterX] horizontal location for the center of the circle,
     *  default is in the middle
     * @param {Number} [opt.polarCenterY] vertical location for the center of the circle,
     *  default is in the middle
     * @param {Number} [opt.polarRotation] amount to rotate the image counterclockwis,
     *  0 is no rotation, 360 degrees is a full rotation
     */var FromPolar=function FromPolar(src,dst,opt){var srcPixels=src.data,dstPixels=dst.data,xSize=src.width,ySize=src.height,xMid=opt.polarCenterX||xSize/2,yMid=opt.polarCenterY||ySize/2,i,x,y,dx,dy,r=0,g=0,b=0,a=0;// Find the largest radius
var rad,rMax=Math.sqrt(xMid*xMid+yMid*yMid);x=xSize-xMid;y=ySize-yMid;rad=Math.sqrt(x*x+y*y);rMax=rad>rMax?rad:rMax;// We'll be uisng x as the radius, and y as the angle (theta=t)
var rSize=ySize,tSize=xSize,radius,theta,phaseShift=opt.polarRotation||0;// We need to convert to degrees and we need to make sure
// it's between (0-360)
// var conversion = tSize/360*180/Math.PI;
//var conversion = tSize/360*180/Math.PI;
var x1,y1;for(x=0;x<xSize;x+=1){for(y=0;y<ySize;y+=1){dx=x-xMid;dy=y-yMid;radius=Math.sqrt(dx*dx+dy*dy)*rSize/rMax;theta=(Math.atan2(dy,dx)*180/Math.PI+360+phaseShift)%360;theta=theta*tSize/360;x1=Math.floor(theta);y1=Math.floor(radius);i=(y1*xSize+x1)*4;r=srcPixels[i+0];g=srcPixels[i+1];b=srcPixels[i+2];a=srcPixels[i+3];// Store it
i=(y*xSize+x)*4;dstPixels[i+0]=r;dstPixels[i+1]=g;dstPixels[i+2]=b;dstPixels[i+3]=a;}}};//Konva.Filters.ToPolar = Konva.Util._FilterWrapDoubleBuffer(ToPolar);
//Konva.Filters.FromPolar = Konva.Util._FilterWrapDoubleBuffer(FromPolar);
// create a temporary canvas for working - shared between multiple calls
/*
     * Kaleidoscope Filter.
     * @function
     * @name Kaleidoscope
     * @author ippo615
     * @memberof Konva.Filters
     * @example
     * node.cache();
     * node.filters([Konva.Filters.Kaleidoscope]);
     * node.kaleidoscopePower(3);
     * node.kaleidoscopeAngle(45);
     */Konva.Filters.Kaleidoscope=function(imageData){var xSize=imageData.width,ySize=imageData.height;var x,y,xoff,i,r,g,b,a,srcPos,dstPos;var power=Math.round(this.kaleidoscopePower());var angle=Math.round(this.kaleidoscopeAngle());var offset=Math.floor(xSize*(angle%360)/360);if(power<1){return;}// Work with our shared buffer canvas
var tempCanvas=Konva.Util.createCanvasElement();tempCanvas.width=xSize;tempCanvas.height=ySize;var scratchData=tempCanvas.getContext('2d').getImageData(0,0,xSize,ySize);// Convert thhe original to polar coordinates
ToPolar(imageData,scratchData,{polarCenterX:xSize/2,polarCenterY:ySize/2});// Determine how big each section will be, if it's too small
// make it bigger
var minSectionSize=xSize/Math.pow(2,power);while(minSectionSize<=8){minSectionSize=minSectionSize*2;power-=1;}minSectionSize=Math.ceil(minSectionSize);var sectionSize=minSectionSize;// Copy the offset region to 0
// Depending on the size of filter and location of the offset we may need
// to copy the section backwards to prevent it from rewriting itself
var xStart=0,xEnd=sectionSize,xDelta=1;if(offset+minSectionSize>xSize){xStart=sectionSize;xEnd=0;xDelta=-1;}for(y=0;y<ySize;y+=1){for(x=xStart;x!==xEnd;x+=xDelta){xoff=Math.round(x+offset)%xSize;srcPos=(xSize*y+xoff)*4;r=scratchData.data[srcPos+0];g=scratchData.data[srcPos+1];b=scratchData.data[srcPos+2];a=scratchData.data[srcPos+3];dstPos=(xSize*y+x)*4;scratchData.data[dstPos+0]=r;scratchData.data[dstPos+1]=g;scratchData.data[dstPos+2]=b;scratchData.data[dstPos+3]=a;}}// Perform the actual effect
for(y=0;y<ySize;y+=1){sectionSize=Math.floor(minSectionSize);for(i=0;i<power;i+=1){for(x=0;x<sectionSize+1;x+=1){srcPos=(xSize*y+x)*4;r=scratchData.data[srcPos+0];g=scratchData.data[srcPos+1];b=scratchData.data[srcPos+2];a=scratchData.data[srcPos+3];dstPos=(xSize*y+sectionSize*2-x-1)*4;scratchData.data[dstPos+0]=r;scratchData.data[dstPos+1]=g;scratchData.data[dstPos+2]=b;scratchData.data[dstPos+3]=a;}sectionSize*=2;}}// Convert back from polar coordinates
FromPolar(scratchData,imageData,{polarRotation:0});};/**
   * get/set kaleidoscope power. Use with {@link Konva.Filters.Kaleidoscope} filter.
   * @name kaleidoscopePower
   * @method
   * @memberof Konva.Node.prototype
   * @param {Integer} power of kaleidoscope
   * @returns {Integer}
   */Konva.Factory.addGetterSetter(Konva.Node,'kaleidoscopePower',2,Konva.Validators.getNumberValidator(),Konva.Factory.afterSetFilter);/**
   * get/set kaleidoscope angle. Use with {@link Konva.Filters.Kaleidoscope} filter.
   * @name kaleidoscopeAngle
   * @method
   * @memberof Konva.Node.prototype
   * @param {Integer} degrees
   * @returns {Integer}
   */Konva.Factory.addGetterSetter(Konva.Node,'kaleidoscopeAngle',0,Konva.Validators.getNumberValidator(),Konva.Factory.afterSetFilter);})();(function(Konva){'use strict';/**
   * Contrast Filter.
   * @function
   * @memberof Konva.Filters
   * @param {Object} imageData
   * @example
   * node.cache();
   * node.filters([Konva.Filters.Contrast]);
   * node.contrast(10);
   */Konva.Filters.Contrast=function(imageData){var adjust=Math.pow((parseInt(this.contrast())+100)/100,2);var data=imageData.data,nPixels=data.length,red=150,green=150,blue=150,i;for(i=0;i<nPixels;i+=4){red=data[i];green=data[i+1];blue=data[i+2];//Red channel
red/=255;red-=0.5;red*=adjust;red+=0.5;red*=255;//Green channel
green/=255;green-=0.5;green*=adjust;green+=0.5;green*=255;//Blue channel
blue/=255;blue-=0.5;blue*=adjust;blue+=0.5;blue*=255;red=red<0?0:red>255?255:red;green=green<0?0:green>255?255:green;blue=blue<0?0:blue>255?255:blue;data[i]=red;data[i+1]=green;data[i+2]=blue;}};/**
   * get/set filter contrast.  The contrast is a number between -100 and 100.
   * Use with {@link Konva.Filters.Contrast} filter.
   * @name contrast
   * @method
   * @memberof Konva.Node.prototype
   * @param {Number} contrast value between -100 and 100
   * @returns {Number}
   */Konva.Factory.addGetterSetter(Konva.Node,'contrast',0,Konva.Validators.getNumberValidator(),Konva.Factory.afterSetFilter);})(Konva);(function(){'use strict';/**
   * Container constructor.&nbsp; Containers are used to contain nodes or other containers
   * @constructor
   * @memberof Konva
   * @augments Konva.Node
   * @abstract
   * @param {Object} config
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * * @param {Object} [config.clip] set clip
     * @param {Number} [config.clipX] set clip x
     * @param {Number} [config.clipY] set clip y
     * @param {Number} [config.clipWidth] set clip width
     * @param {Number} [config.clipHeight] set clip height
     * @param {Function} [config.clipFunc] set clip func

   */Konva.Container=function(config){this.__init(config);};Konva.Util.addMethods(Konva.Container,{__init:function __init(config){this.children=new Konva.Collection();Konva.Node.call(this,config);},/**
     * returns a {@link Konva.Collection} of direct descendant nodes
     * @method
     * @memberof Konva.Container.prototype
     * @param {Function} [filterFunc] filter function
     * @returns {Konva.Collection}
     * @example
     * // get all children
     * var children = layer.getChildren();
     *
     * // get only circles
     * var circles = layer.getChildren(function(node){
     *    return node.getClassName() === 'Circle';
     * });
     */getChildren:function getChildren(filterFunc){if(!filterFunc){return this.children;}var results=new Konva.Collection();this.children.each(function(child){if(filterFunc(child)){results.push(child);}});return results;},/**
     * determine if node has children
     * @method
     * @memberof Konva.Container.prototype
     * @returns {Boolean}
     */hasChildren:function hasChildren(){return this.getChildren().length>0;},/**
     * remove all children
     * @method
     * @memberof Konva.Container.prototype
     */removeChildren:function removeChildren(){var children=Konva.Collection.toCollection(this.children);var child;for(var i=0;i<children.length;i++){child=children[i];// reset parent to prevent many _setChildrenIndices calls
delete child.parent;child.index=0;child.remove();}children=null;this.children=new Konva.Collection();return this;},/**
     * destroy all children
     * @method
     * @memberof Konva.Container.prototype
     */destroyChildren:function destroyChildren(){var children=Konva.Collection.toCollection(this.children);var child;for(var i=0;i<children.length;i++){child=children[i];// reset parent to prevent many _setChildrenIndices calls
delete child.parent;child.index=0;child.destroy();}children=null;this.children=new Konva.Collection();return this;},/**
     * Add node or nodes to container.
     * @method
     * @memberof Konva.Container.prototype
     * @param {...Konva.Node} child
     * @returns {Container}
     * @example
     * layer.add(shape1, shape2, shape3);
     */add:function add(child){if(arguments.length>1){for(var i=0;i<arguments.length;i++){this.add(arguments[i]);}return this;}if(child.getParent()){child.moveTo(this);return this;}var children=this.children;this._validateAdd(child);child.index=children.length;child.parent=this;children.push(child);this._fire('add',{child:child});// if node under drag we need to update drag animation
if(Konva.DD&&child.isDragging()){Konva.DD.anim.setLayers(child.getLayer());}// chainable
return this;},destroy:function destroy(){// destroy children
if(this.hasChildren()){this.destroyChildren();}// then destroy self
Konva.Node.prototype.destroy.call(this);return this;},/**
     * return a {@link Konva.Collection} of nodes that match the selector.
     * You can provide a string with '#' for id selections and '.' for name selections.
     * Or a function that will return true/false when a node is passed through.  See example below.
     * With strings you can also select by type or class name. Pass multiple selectors
     * separated by a space.
     * @method
     * @memberof Konva.Container.prototype
     * @param {String | Function} selector
     * @returns {Collection}
     * @example
     *
     * Passing a string as a selector
     * // select node with id foo
     * var node = stage.find('#foo');
     *
     * // select nodes with name bar inside layer
     * var nodes = layer.find('.bar');
     *
     * // select all groups inside layer
     * var nodes = layer.find('Group');
     *
     * // select all rectangles inside layer
     * var nodes = layer.find('Rect');
     *
     * // select node with an id of foo or a name of bar inside layer
     * var nodes = layer.find('#foo, .bar');
     *
     * Passing a function as a selector
     *
     * // get all Groups
     * var groups = stage.find(node => {
     *  return node.getType() === 'Group';
     * });
     *
     * // get only Nodes with partial opacity
     * var alphaNodes = layer.find(node => {
     *  return node.getType() === 'Node' && node.getAbsoluteOpacity() < 1;
     * });
     */find:function find(selector){// protecting _generalFind to prevent user from accidentally adding
// second argument and getting unexpected `findOne` result
return this._generalFind(selector,false);},/**
     * return a first node from `find` method
     * @method
     * @memberof Konva.Container.prototype
     * @param {String | Function} selector
     * @returns {Konva.Node | Undefined}
     * @example
     * // select node with id foo
     * var node = stage.findOne('#foo');
     *
     * // select node with name bar inside layer
     * var nodes = layer.findOne('.bar');
     *
     * // select the first node to return true in a function
     * var node = stage.findOne(node => {
     *  return node.getType() === 'Shape'
     * })
     */findOne:function findOne(selector){var result=this._generalFind(selector,true);return result.length>0?result[0]:undefined;},_generalFind:function _generalFind(selector,findOne){var retArr=[];if(typeof selector==='string'){retArr=this._findByString(selector,findOne);}else if(typeof selector==='function'){retArr=this._findByFunction(selector,findOne);}return Konva.Collection.toCollection(retArr);},_findByString:function _findByString(selector){var retArr=[],selectorArr=selector.replace(/ /g,'').split(','),len=selectorArr.length,n,i,sel,arr,node,children,clen;for(n=0;n<len;n++){sel=selectorArr[n];if(!Konva.Util.isValidSelector(sel)){var message='Selector "'+sel+'" is invalid. Allowed selectors examples are "#foo", ".bar" or "Group".\n'+'If you have a custom shape with such className, please change it to start with upper letter like "Triangle".\n'+'Konva is awesome, right?';Konva.Util.warn(message);}// id selector
if(sel.charAt(0)==='#'){node=this._getNodeById(sel.slice(1));if(node){retArr.push(node);}}else if(sel.charAt(0)==='.'){// name selector
arr=this._getNodesByName(sel.slice(1));retArr=retArr.concat(arr);}else{// unrecognized selector, pass to children
children=this.getChildren();clen=children.length;for(i=0;i<clen;i++){retArr=retArr.concat(children[i]._get(sel));}}}return retArr;},// (fn: ((Node) => boolean, findOne?: boolean)
_findByFunction:function _findByFunction(fn,findOne){var retArr=[];var addItems=function addItems(el){// escape function if we've already found one.
if(findOne&&retArr.length>0){return;}var children=el.getChildren();var clen=children.length;if(fn(el)){retArr=retArr.concat(el);}for(var i=0;i<clen;i++){addItems(children[i]);}};addItems(this);return retArr;},_getNodeById:function _getNodeById(key){var node=Konva.ids[key];if(node!==undefined&&this.isAncestorOf(node)){return node;}return null;},_getNodesByName:function _getNodesByName(key){var arr=Konva.names[key]||[];return this._getDescendants(arr);},_get:function _get(selector){var retArr=Konva.Node.prototype._get.call(this,selector);var children=this.getChildren();var len=children.length;for(var n=0;n<len;n++){retArr=retArr.concat(children[n]._get(selector));}return retArr;},// extenders
toObject:function toObject(){var obj=Konva.Node.prototype.toObject.call(this);obj.children=[];var children=this.getChildren();var len=children.length;for(var n=0;n<len;n++){var child=children[n];obj.children.push(child.toObject());}return obj;},_getDescendants:function _getDescendants(arr){var retArr=[];var len=arr.length;for(var n=0;n<len;n++){var node=arr[n];if(this.isAncestorOf(node)){retArr.push(node);}}return retArr;},/**
     * determine if node is an ancestor
     * of descendant
     * @method
     * @memberof Konva.Container.prototype
     * @param {Konva.Node} node
     */isAncestorOf:function isAncestorOf(node){var parent=node.getParent();while(parent){if(parent._id===this._id){return true;}parent=parent.getParent();}return false;},clone:function clone(obj){// call super method
var node=Konva.Node.prototype.clone.call(this,obj);this.getChildren().each(function(no){node.add(no.clone());});return node;},/**
     * get all shapes that intersect a point.  Note: because this method must clear a temporary
     * canvas and redraw every shape inside the container, it should only be used for special sitations
     * because it performs very poorly.  Please use the {@link Konva.Stage#getIntersection} method if at all possible
     * because it performs much better
     * @method
     * @memberof Konva.Container.prototype
     * @param {Object} pos
     * @param {Number} pos.x
     * @param {Number} pos.y
     * @returns {Array} array of shapes
     */getAllIntersections:function getAllIntersections(pos){var arr=[];this.find('Shape').each(function(shape){if(shape.isVisible()&&shape.intersects(pos)){arr.push(shape);}});return arr;},_setChildrenIndices:function _setChildrenIndices(){this.children.each(function(child,n){child.index=n;});},drawScene:function drawScene(can,top,caching){var layer=this.getLayer(),canvas=can||layer&&layer.getCanvas(),context=canvas&&canvas.getContext(),cachedCanvas=this._cache.canvas,cachedSceneCanvas=cachedCanvas&&cachedCanvas.scene;if(this.isVisible()||caching){if(!caching&&cachedSceneCanvas){context.save();layer._applyTransform(this,context,top);this._drawCachedSceneCanvas(context);context.restore();}else{this._drawChildren(canvas,'drawScene',top,false,caching);}}return this;},drawHit:function drawHit(can,top,caching){var layer=this.getLayer(),canvas=can||layer&&layer.hitCanvas,context=canvas&&canvas.getContext(),cachedCanvas=this._cache.canvas,cachedHitCanvas=cachedCanvas&&cachedCanvas.hit;if(this.shouldDrawHit(canvas)||caching){if(layer){layer.clearHitCache();}if(!caching&&cachedHitCanvas){context.save();layer._applyTransform(this,context,top);this._drawCachedHitCanvas(context);context.restore();}else{this._drawChildren(canvas,'drawHit',top);}}return this;},_drawChildren:function _drawChildren(canvas,drawMethod,top,caching,skipBuffer){var layer=this.getLayer(),context=canvas&&canvas.getContext(),clipWidth=this.getClipWidth(),clipHeight=this.getClipHeight(),clipFunc=this.getClipFunc(),hasClip=clipWidth&&clipHeight||clipFunc,clipX,clipY;if(hasClip&&layer){context.save();var transform=this.getAbsoluteTransform(top);var m=transform.getMatrix();context.transform(m[0],m[1],m[2],m[3],m[4],m[5]);context.beginPath();if(clipFunc){clipFunc.call(this,context,this);}else{clipX=this.getClipX();clipY=this.getClipY();context.rect(clipX,clipY,clipWidth,clipHeight);}context.clip();m=transform.copy().invert().getMatrix();context.transform(m[0],m[1],m[2],m[3],m[4],m[5]);}this.children.each(function(child){child[drawMethod](canvas,top,caching,skipBuffer);});if(hasClip){context.restore();}},shouldDrawHit:function shouldDrawHit(canvas){var layer=this.getLayer();var dd=Konva.DD;var layerUnderDrag=dd&&Konva.isDragging()&&Konva.DD.anim.getLayers().indexOf(layer)!==-1;return canvas&&canvas.isCache||layer&&layer.hitGraphEnabled()&&this.isVisible()&&!layerUnderDrag;},getClientRect:function getClientRect(attrs){attrs=attrs||{};var skipTransform=attrs.skipTransform;var relativeTo=attrs.relativeTo;var minX,minY,maxX,maxY;var selfRect={x:Infinity,y:Infinity,width:0,height:0};var that=this;this.children.each(function(child){// skip invisible children
if(!child.getVisible()){return;}var rect=child.getClientRect({relativeTo:that,skipShadow:attrs.skipShadow});// skip invisible children (like empty groups)
if(rect.width===0&&rect.height===0){return;}if(minX===undefined){// initial value for first child
minX=rect.x;minY=rect.y;maxX=rect.x+rect.width;maxY=rect.y+rect.height;}else{minX=Math.min(minX,rect.x);minY=Math.min(minY,rect.y);maxX=Math.max(maxX,rect.x+rect.width);maxY=Math.max(maxY,rect.y+rect.height);}});// if child is group we need to make sure it has visible shapes inside
var shapes=this.find('Shape');var hasVisible=false;for(var i=0;i<shapes.length;i++){var shape=shapes[i];if(shape._isVisible(this)){hasVisible=true;break;}}if(hasVisible){selfRect={x:minX,y:minY,width:maxX-minX,height:maxY-minY};}else{selfRect={x:0,y:0,width:0,height:0};}if(!skipTransform){return this._transformedRect(selfRect,relativeTo);}return selfRect;}});Konva.Util.extend(Konva.Container,Konva.Node);// deprecated methods
Konva.Container.prototype.get=Konva.Container.prototype.find;// add getters setters
Konva.Factory.addComponentsGetterSetter(Konva.Container,'clip',['x','y','width','height']);/**
   * get/set clip
   * @method
   * @name clip
   * @memberof Konva.Container.prototype
   * @param {Object} clip
   * @param {Number} clip.x
   * @param {Number} clip.y
   * @param {Number} clip.width
   * @param {Number} clip.height
   * @returns {Object}
   * @example
   * // get clip
   * var clip = container.clip();
   *
   * // set clip
   * container.setClip({
   *   x: 20,
   *   y: 20,
   *   width: 20,
   *   height: 20
   * });
   */Konva.Factory.addGetterSetter(Konva.Container,'clipX',undefined,Konva.Validators.getNumberValidator());/**
   * get/set clip x
   * @name clipX
   * @method
   * @memberof Konva.Container.prototype
   * @param {Number} x
   * @returns {Number}
   * @example
   * // get clip x
   * var clipX = container.clipX();
   *
   * // set clip x
   * container.clipX(10);
   */Konva.Factory.addGetterSetter(Konva.Container,'clipY',undefined,Konva.Validators.getNumberValidator());/**
   * get/set clip y
   * @name clipY
   * @method
   * @memberof Konva.Container.prototype
   * @param {Number} y
   * @returns {Number}
   * @example
   * // get clip y
   * var clipY = container.clipY();
   *
   * // set clip y
   * container.clipY(10);
   */Konva.Factory.addGetterSetter(Konva.Container,'clipWidth',undefined,Konva.Validators.getNumberValidator());/**
   * get/set clip width
   * @name clipWidth
   * @method
   * @memberof Konva.Container.prototype
   * @param {Number} width
   * @returns {Number}
   * @example
   * // get clip width
   * var clipWidth = container.clipWidth();
   *
   * // set clip width
   * container.clipWidth(100);
   */Konva.Factory.addGetterSetter(Konva.Container,'clipHeight',undefined,Konva.Validators.getNumberValidator());/**
   * get/set clip height
   * @name clipHeight
   * @method
   * @memberof Konva.Container.prototype
   * @param {Number} height
   * @returns {Number}
   * @example
   * // get clip height
   * var clipHeight = container.clipHeight();
   *
   * // set clip height
   * container.clipHeight(100);
   */Konva.Factory.addGetterSetter(Konva.Container,'clipFunc');/**
   * get/set clip function
   * @name clipFunc
   * @method
   * @memberof Konva.Container.prototype
   * @param {Function} function
   * @returns {Function}
   * @example
   * // get clip function
   * var clipFunction = container.clipFunc();
   *
   * // set clip height
   * container.clipFunc(function(ctx) {
   *   ctx.rect(0, 0, 100, 100);
   * });
   */Konva.Collection.mapMethods(Konva.Container);})();(function(Konva){'use strict';var HAS_SHADOW='hasShadow';var SHADOW_RGBA='shadowRGBA';function _fillFunc(context){context.fill();}function _strokeFunc(context){context.stroke();}function _fillFuncHit(context){context.fill();}function _strokeFuncHit(context){context.stroke();}function _clearHasShadowCache(){this._clearCache(HAS_SHADOW);}function _clearGetShadowRGBACache(){this._clearCache(SHADOW_RGBA);}/**
   * Shape constructor.  Shapes are primitive objects such as rectangles,
   *  circles, text, lines, etc.
   * @constructor
   * @memberof Konva
   * @augments Konva.Node
   * @param {Object} config
   * @param {String} [config.fill] fill color
     * @param {Image} [config.fillPatternImage] fill pattern image
     * @param {Number} [config.fillPatternX]
     * @param {Number} [config.fillPatternY]
     * @param {Object} [config.fillPatternOffset] object with x and y component
     * @param {Number} [config.fillPatternOffsetX] 
     * @param {Number} [config.fillPatternOffsetY] 
     * @param {Object} [config.fillPatternScale] object with x and y component
     * @param {Number} [config.fillPatternScaleX]
     * @param {Number} [config.fillPatternScaleY]
     * @param {Number} [config.fillPatternRotation]
     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientStartPointX]
     * @param {Number} [config.fillLinearGradientStartPointY]
     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientEndPointX]
     * @param {Number} [config.fillLinearGradientEndPointY]
     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientStartPointX]
     * @param {Number} [config.fillRadialGradientStartPointY]
     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientEndPointX] 
     * @param {Number} [config.fillRadialGradientEndPointY] 
     * @param {Number} [config.fillRadialGradientStartRadius]
     * @param {Number} [config.fillRadialGradientEndRadius]
     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
     * @param {String} [config.stroke] stroke color
     * @param {Number} [config.strokeWidth] stroke width
     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
     *  is miter
     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
     *  is butt
     * @param {String} [config.shadowColor]
     * @param {Number} [config.shadowBlur]
     * @param {Object} [config.shadowOffset] object with x and y component
     * @param {Number} [config.shadowOffsetX]
     * @param {Number} [config.shadowOffsetY]
     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
     *  between 0 and 1
     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
     * @param {Array} [config.dash]
     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * @example
   * var customShape = new Konva.Shape({
   *   x: 5,
   *   y: 10,
   *   fill: 'red',
   *   // a Konva.Canvas renderer is passed into the sceneFunc function
   *   sceneFunc: function(context, shape) {
   *     context.beginPath();
   *     context.moveTo(200, 50);
   *     context.lineTo(420, 80);
   *     context.quadraticCurveTo(300, 100, 260, 170);
   *     context.closePath();
   *     // Konva specific method
   *     context.fillStrokeShape(shape);
   *   }
   *});
   */Konva.Shape=function(config){this.__init(config);};Konva.Util.addMethods(Konva.Shape,{__init:function __init(config){this.nodeType='Shape';this._fillFunc=_fillFunc;this._strokeFunc=_strokeFunc;this._fillFuncHit=_fillFuncHit;this._strokeFuncHit=_strokeFuncHit;// set colorKey
var shapes=Konva.shapes;var key;while(true){key=Konva.Util.getRandomColor();if(key&&!(key in shapes)){break;}}this.colorKey=key;shapes[key]=this;// call super constructor
Konva.Node.call(this,config);this.on('shadowColorChange.konva shadowBlurChange.konva shadowOffsetChange.konva shadowOpacityChange.konva shadowEnabledChange.konva',_clearHasShadowCache);this.on('shadowColorChange.konva shadowOpacityChange.konva shadowEnabledChange.konva',_clearGetShadowRGBACache);},hasChildren:function hasChildren(){return false;},getChildren:function getChildren(){return[];},/**
     * get canvas context tied to the layer
     * @method
     * @memberof Konva.Shape.prototype
     * @returns {Konva.Context}
     */getContext:function getContext(){return this.getLayer().getContext();},/**
     * get canvas renderer tied to the layer.  Note that this returns a canvas renderer, not a canvas element
     * @method
     * @memberof Konva.Shape.prototype
     * @returns {Konva.Canvas}
     */getCanvas:function getCanvas(){return this.getLayer().getCanvas();},/**
     * returns whether or not a shadow will be rendered
     * @method
     * @memberof Konva.Shape.prototype
     * @returns {Boolean}
     */hasShadow:function hasShadow(){return this._getCache(HAS_SHADOW,this._hasShadow);},_hasShadow:function _hasShadow(){return this.getShadowEnabled()&&this.getShadowOpacity()!==0&&!!(this.getShadowColor()||this.getShadowBlur()||this.getShadowOffsetX()||this.getShadowOffsetY());},getShadowRGBA:function getShadowRGBA(){return this._getCache(SHADOW_RGBA,this._getShadowRGBA);},_getShadowRGBA:function _getShadowRGBA(){if(this.hasShadow()){var rgba=Konva.Util.colorToRGBA(this.shadowColor());return'rgba('+rgba.r+','+rgba.g+','+rgba.b+','+rgba.a*(this.getShadowOpacity()||1)+')';}},/**
     * returns whether or not the shape will be filled
     * @method
     * @memberof Konva.Shape.prototype
     * @returns {Boolean}
     */hasFill:function hasFill(){return!!(this.getFill()||this.getFillPatternImage()||this.getFillLinearGradientColorStops()||this.getFillRadialGradientColorStops());},/**
     * returns whether or not the shape will be stroked
     * @method
     * @memberof Konva.Shape.prototype
     * @returns {Boolean}
     */hasStroke:function hasStroke(){return this.strokeEnabled()&&!!(this.stroke()||this.getStrokeLinearGradientColorStops())// TODO: do we need radial gradient
// this.getStrokeRadialGradientColorStops()
;},/**
     * determines if point is in the shape, regardless if other shapes are on top of it.  Note: because
     *  this method clears a temporary canvas and then redraws the shape, it performs very poorly if executed many times
     *  consecutively.  Please use the {@link Konva.Stage#getIntersection} method if at all possible
     *  because it performs much better
     * @method
     * @memberof Konva.Shape.prototype
     * @param {Object} point
     * @param {Number} point.x
     * @param {Number} point.y
     * @returns {Boolean}
     */intersects:function intersects(point){var stage=this.getStage(),bufferHitCanvas=stage.bufferHitCanvas,p;bufferHitCanvas.getContext().clear();this.drawHit(bufferHitCanvas);p=bufferHitCanvas.context.getImageData(Math.round(point.x),Math.round(point.y),1,1).data;return p[3]>0;},// extends Node.prototype.destroy
destroy:function destroy(){Konva.Node.prototype.destroy.call(this);delete Konva.shapes[this.colorKey];return this;},_useBufferCanvas:function _useBufferCanvas(caching){return!caching&&this.perfectDrawEnabled()&&this.getAbsoluteOpacity()!==1&&this.hasFill()&&this.hasStroke()&&this.getStage()||this.perfectDrawEnabled()&&this.hasShadow()&&this.getAbsoluteOpacity()!==1&&this.hasFill()&&this.hasStroke()&&this.getStage();},/**
     * return self rectangle (x, y, width, height) of shape.
     * This method are not taken into account transformation and styles.
     * @method
     * @memberof Konva.Shape.prototype
     * @returns {Object} rect with {x, y, width, height} properties
     * @example
     *
     * rect.getSelfRect();  // return {x:0, y:0, width:rect.width(), height:rect.height()}
     * circle.getSelfRect();  // return {x: - circle.width() / 2, y: - circle.height() / 2, width:circle.width(), height:circle.height()}
     *
     */getSelfRect:function getSelfRect(){var size=this.getSize();return{x:this._centroid?Math.round(-size.width/2):0,y:this._centroid?Math.round(-size.height/2):0,width:size.width,height:size.height};},getClientRect:function getClientRect(attrs){attrs=attrs||{};var skipTransform=attrs.skipTransform;var relativeTo=attrs.relativeTo;var fillRect=this.getSelfRect();var strokeWidth=this.hasStroke()&&this.strokeWidth()||0;var fillAndStrokeWidth=fillRect.width+strokeWidth;var fillAndStrokeHeight=fillRect.height+strokeWidth;var applyShadow=!attrs.skipShadow&&this.hasShadow();var shadowOffsetX=applyShadow?this.shadowOffsetX():0;var shadowOffsetY=applyShadow?this.shadowOffsetY():0;var preWidth=fillAndStrokeWidth+Math.abs(shadowOffsetX);var preHeight=fillAndStrokeHeight+Math.abs(shadowOffsetY);var blurRadius=applyShadow&&this.shadowBlur()||0;var width=preWidth+blurRadius*2;var height=preHeight+blurRadius*2;// if stroke, for example = 3
// we need to set x to 1.5, but after Math.round it will be 2
// as we have additional offset we need to increase width and height by 1 pixel
var roundingOffset=0;if(Math.round(strokeWidth/2)!==strokeWidth/2){roundingOffset=1;}var rect={width:width+roundingOffset,height:height+roundingOffset,x:-Math.round(strokeWidth/2+blurRadius)+Math.min(shadowOffsetX,0)+fillRect.x,y:-Math.round(strokeWidth/2+blurRadius)+Math.min(shadowOffsetY,0)+fillRect.y};if(!skipTransform){return this._transformedRect(rect,relativeTo);}return rect;},drawScene:function drawScene(can,top,caching,skipBuffer){var layer=this.getLayer(),canvas=can||layer.getCanvas(),context=canvas.getContext(),cachedCanvas=this._cache.canvas,drawFunc=this.sceneFunc(),hasShadow=this.hasShadow(),hasStroke=this.hasStroke(),stage,bufferCanvas,bufferContext;if(!this.isVisible()&&!caching){return this;}if(cachedCanvas){context.save();layer._applyTransform(this,context,top);this._drawCachedSceneCanvas(context);context.restore();return this;}if(!drawFunc){return this;}context.save();// if buffer canvas is needed
if(this._useBufferCanvas(caching)&&!skipBuffer){stage=this.getStage();bufferCanvas=stage.bufferCanvas;bufferContext=bufferCanvas.getContext();bufferContext.clear();bufferContext.save();bufferContext._applyLineJoin(this);// layer might be undefined if we are using cache before adding to layer
if(!caching){if(layer){layer._applyTransform(this,bufferContext,top);}else{var m=this.getAbsoluteTransform(top).getMatrix();context.transform(m[0],m[1],m[2],m[3],m[4],m[5]);}}drawFunc.call(this,bufferContext,this);bufferContext.restore();var ratio=bufferCanvas.pixelRatio;if(hasShadow&&!canvas.hitCanvas){context.save();context._applyShadow(this);context._applyOpacity(this);context._applyGlobalCompositeOperation(this);context.drawImage(bufferCanvas._canvas,0,0,bufferCanvas.width/ratio,bufferCanvas.height/ratio);context.restore();}else{context._applyOpacity(this);context._applyGlobalCompositeOperation(this);context.drawImage(bufferCanvas._canvas,0,0,bufferCanvas.width/ratio,bufferCanvas.height/ratio);}}else{// if buffer canvas is not needed
context._applyLineJoin(this);// layer might be undefined if we are using cache before adding to layer
if(!caching){if(layer){layer._applyTransform(this,context,top);}else{var o=this.getAbsoluteTransform(top).getMatrix();context.transform(o[0],o[1],o[2],o[3],o[4],o[5]);}}if(hasShadow&&hasStroke&&!canvas.hitCanvas){context.save();// apply shadow
if(!caching){context._applyOpacity(this);context._applyGlobalCompositeOperation(this);}context._applyShadow(this);drawFunc.call(this,context,this);context.restore();// if shape has stroke we need to redraw shape
// otherwise we will see a shadow under stroke (and over fill)
// but I think this is unexpected behavior
if(this.hasFill()&&this.getShadowForStrokeEnabled()){drawFunc.call(this,context,this);}}else if(hasShadow&&!canvas.hitCanvas){context.save();if(!caching){context._applyOpacity(this);context._applyGlobalCompositeOperation(this);}context._applyShadow(this);drawFunc.call(this,context,this);context.restore();}else{if(!caching){context._applyOpacity(this);context._applyGlobalCompositeOperation(this);}drawFunc.call(this,context,this);}}context.restore();return this;},drawHit:function drawHit(can,top,caching){var layer=this.getLayer(),canvas=can||layer.hitCanvas,context=canvas.getContext(),drawFunc=this.hitFunc()||this.sceneFunc(),cachedCanvas=this._cache.canvas,cachedHitCanvas=cachedCanvas&&cachedCanvas.hit;if(!this.shouldDrawHit(canvas)&&!caching){return this;}if(layer){layer.clearHitCache();}if(cachedHitCanvas){context.save();layer._applyTransform(this,context,top);this._drawCachedHitCanvas(context);context.restore();return this;}if(!drawFunc){return this;}context.save();context._applyLineJoin(this);if(!caching){if(layer){layer._applyTransform(this,context,top);}else{var o=this.getAbsoluteTransform(top).getMatrix();context.transform(o[0],o[1],o[2],o[3],o[4],o[5]);}}drawFunc.call(this,context,this);context.restore();return this;},/**
     * draw hit graph using the cached scene canvas
     * @method
     * @memberof Konva.Shape.prototype
     * @param {Integer} alphaThreshold alpha channel threshold that determines whether or not
     *  a pixel should be drawn onto the hit graph.  Must be a value between 0 and 255.
     *  The default is 0
     * @returns {Konva.Shape}
     * @example
     * shape.cache();
     * shape.drawHitFromCache();
     */drawHitFromCache:function drawHitFromCache(alphaThreshold){var threshold=alphaThreshold||0,cachedCanvas=this._cache.canvas,sceneCanvas=this._getCachedSceneCanvas(),hitCanvas=cachedCanvas.hit,hitContext=hitCanvas.getContext(),hitWidth=hitCanvas.getWidth(),hitHeight=hitCanvas.getHeight(),hitImageData,hitData,len,rgbColorKey,i,alpha;hitContext.clear();hitContext.drawImage(sceneCanvas._canvas,0,0,hitWidth,hitHeight);try{hitImageData=hitContext.getImageData(0,0,hitWidth,hitHeight);hitData=hitImageData.data;len=hitData.length;rgbColorKey=Konva.Util._hexToRgb(this.colorKey);// replace non transparent pixels with color key
for(i=0;i<len;i+=4){alpha=hitData[i+3];if(alpha>threshold){hitData[i]=rgbColorKey.r;hitData[i+1]=rgbColorKey.g;hitData[i+2]=rgbColorKey.b;hitData[i+3]=255;}else{hitData[i+3]=0;}}hitContext.putImageData(hitImageData,0,0);}catch(e){Konva.Util.error('Unable to draw hit graph from cached scene canvas. '+e.message);}return this;}});Konva.Util.extend(Konva.Shape,Konva.Node);// add getters and setters
Konva.Factory.addGetterSetter(Konva.Shape,'stroke',undefined,Konva.Validators.getStringValidator());/**
   * get/set stroke color
   * @name stroke
   * @method
   * @memberof Konva.Shape.prototype
   * @param {String} color
   * @returns {String}
   * @example
   * // get stroke color
   * var stroke = shape.stroke();
   *
   * // set stroke color with color string
   * shape.stroke('green');
   *
   * // set stroke color with hex
   * shape.stroke('#00ff00');
   *
   * // set stroke color with rgb
   * shape.stroke('rgb(0,255,0)');
   *
   * // set stroke color with rgba and make it 50% opaque
   * shape.stroke('rgba(0,255,0,0.5');
   */Konva.Factory.addGetterSetter(Konva.Shape,'strokeWidth',2,Konva.Validators.getNumberValidator());/**
   * get/set stroke width
   * @name strokeWidth
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} strokeWidth
   * @returns {Number}
   * @example
   * // get stroke width
   * var strokeWidth = shape.strokeWidth();
   *
   * // set stroke width
   * shape.strokeWidth();
   */Konva.Factory.addGetterSetter(Konva.Shape,'strokeHitEnabled',true,Konva.Validators.getBooleanValidator());/**
   * get/set strokeHitEnabled property. Useful for performance optimization.
   * You may set `shape.strokeHitEnabled(false)`. In this case stroke will be no draw on hit canvas, so hit area
   * of shape will be decreased (by lineWidth / 2). Remember that non closed line with `strokeHitEnabled = false`
   * will be not drawn on hit canvas, that is mean line will no trigger pointer events (like mouseover)
   * Default value is true
   * @name strokeHitEnabled
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Boolean} strokeHitEnabled
   * @returns {Boolean}
   * @example
   * // get strokeHitEnabled
   * var strokeHitEnabled = shape.strokeHitEnabled();
   *
   * // set strokeHitEnabled
   * shape.strokeHitEnabled();
   */Konva.Factory.addGetterSetter(Konva.Shape,'perfectDrawEnabled',true,Konva.Validators.getBooleanValidator());/**
   * get/set perfectDrawEnabled. If a shape has fill, stroke and opacity you may set `perfectDrawEnabled` to false to improve performance.
   * See http://konvajs.github.io/docs/performance/Disable_Perfect_Draw.html for more information.
   * Default value is true
   * @name perfectDrawEnabled
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Boolean} perfectDrawEnabled
   * @returns {Boolean}
   * @example
   * // get perfectDrawEnabled
   * var perfectDrawEnabled = shape.perfectDrawEnabled();
   *
   * // set perfectDrawEnabled
   * shape.perfectDrawEnabled();
   */Konva.Factory.addGetterSetter(Konva.Shape,'shadowForStrokeEnabled',true,Konva.Validators.getBooleanValidator());/**
   * get/set shadowForStrokeEnabled. Useful for performance optimization.
   * You may set `shape.shadowForStrokeEnabled(false)`. In this case stroke will be no draw shadow for stroke.
   * Remember if you set `shadowForStrokeEnabled = false` for non closed line - that line with have no shadow!.
   * Default value is true
   * @name shadowForStrokeEnabled
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Boolean} shadowForStrokeEnabled
   * @returns {Boolean}
   * @example
   * // get shadowForStrokeEnabled
   * var shadowForStrokeEnabled = shape.shadowForStrokeEnabled();
   *
   * // set shadowForStrokeEnabled
   * shape.shadowForStrokeEnabled();
   */Konva.Factory.addGetterSetter(Konva.Shape,'lineJoin');/**
   * get/set line join.  Can be miter, round, or bevel.  The
   *  default is miter
   * @name lineJoin
   * @method
   * @memberof Konva.Shape.prototype
   * @param {String} lineJoin
   * @returns {String}
   * @example
   * // get line join
   * var lineJoin = shape.lineJoin();
   *
   * // set line join
   * shape.lineJoin('round');
   */Konva.Factory.addGetterSetter(Konva.Shape,'lineCap');/**
   * get/set line cap.  Can be butt, round, or square
   * @name lineCap
   * @method
   * @memberof Konva.Shape.prototype
   * @param {String} lineCap
   * @returns {String}
   * @example
   * // get line cap
   * var lineCap = shape.lineCap();
   *
   * // set line cap
   * shape.lineCap('round');
   */Konva.Factory.addGetterSetter(Konva.Shape,'sceneFunc');/**
   * get/set scene draw function
   * @name sceneFunc
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Function} drawFunc drawing function
   * @returns {Function}
   * @example
   * // get scene draw function
   * var sceneFunc = shape.sceneFunc();
   *
   * // set scene draw function
   * shape.sceneFunc(function(context) {
   *   context.beginPath();
   *   context.rect(0, 0, this.width(), this.height());
   *   context.closePath();
   *   context.fillStrokeShape(this);
   * });
   */Konva.Factory.addGetterSetter(Konva.Shape,'hitFunc');/**
   * get/set hit draw function
   * @name hitFunc
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Function} drawFunc drawing function
   * @returns {Function}
   * @example
   * // get hit draw function
   * var hitFunc = shape.hitFunc();
   *
   * // set hit draw function
   * shape.hitFunc(function(context) {
   *   context.beginPath();
   *   context.rect(0, 0, this.width(), this.height());
   *   context.closePath();
   *   context.fillStrokeShape(this);
   * });
   */Konva.Factory.addGetterSetter(Konva.Shape,'dash');/**
   * get/set dash array for stroke.
   * @name dash
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Array} dash
   * @returns {Array}
   * @example
   *  // apply dashed stroke that is 10px long and 5 pixels apart
   *  line.dash([10, 5]);
   *  // apply dashed stroke that is made up of alternating dashed
   *  // lines that are 10px long and 20px apart, and dots that have
   *  // a radius of 5px and are 20px apart
   *  line.dash([10, 20, 0.001, 20]);
   */Konva.Factory.addGetterSetter(Konva.Shape,'dashOffset',0,Konva.Validators.getNumberValidator());/**
   * get/set dash offset for stroke.
   * @name dash
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} dash offset
   * @returns {Number}
   * @example
   *  // apply dashed stroke that is 10px long and 5 pixels apart with an offset of 5px
   *  line.dash([10, 5]);
   *  line.dashOffset(5);
   */Konva.Factory.addGetterSetter(Konva.Shape,'shadowColor',undefined,Konva.Validators.getStringValidator());/**
   * get/set shadow color
   * @name shadowColor
   * @method
   * @memberof Konva.Shape.prototype
   * @param {String} color
   * @returns {String}
   * @example
   * // get shadow color
   * var shadow = shape.shadowColor();
   *
   * // set shadow color with color string
   * shape.shadowColor('green');
   *
   * // set shadow color with hex
   * shape.shadowColor('#00ff00');
   *
   * // set shadow color with rgb
   * shape.shadowColor('rgb(0,255,0)');
   *
   * // set shadow color with rgba and make it 50% opaque
   * shape.shadowColor('rgba(0,255,0,0.5');
   */Konva.Factory.addGetterSetter(Konva.Shape,'shadowBlur',0,Konva.Validators.getNumberValidator());/**
   * get/set shadow blur
   * @name shadowBlur
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} blur
   * @returns {Number}
   * @example
   * // get shadow blur
   * var shadowBlur = shape.shadowBlur();
   *
   * // set shadow blur
   * shape.shadowBlur(10);
   */Konva.Factory.addGetterSetter(Konva.Shape,'shadowOpacity',1,Konva.Validators.getNumberValidator());/**
   * get/set shadow opacity.  must be a value between 0 and 1
   * @name shadowOpacity
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} opacity
   * @returns {Number}
   * @example
   * // get shadow opacity
   * var shadowOpacity = shape.shadowOpacity();
   *
   * // set shadow opacity
   * shape.shadowOpacity(0.5);
   */Konva.Factory.addComponentsGetterSetter(Konva.Shape,'shadowOffset',['x','y']);/**
   * get/set shadow offset
   * @name shadowOffset
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Object} offset
   * @param {Number} offset.x
   * @param {Number} offset.y
   * @returns {Object}
   * @example
   * // get shadow offset
   * var shadowOffset = shape.shadowOffset();
   *
   * // set shadow offset
   * shape.shadowOffset({
   *   x: 20
   *   y: 10
   * });
   */Konva.Factory.addGetterSetter(Konva.Shape,'shadowOffsetX',0,Konva.Validators.getNumberValidator());/**
   * get/set shadow offset x
   * @name shadowOffsetX
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} x
   * @returns {Number}
   * @example
   * // get shadow offset x
   * var shadowOffsetX = shape.shadowOffsetX();
   *
   * // set shadow offset x
   * shape.shadowOffsetX(5);
   */Konva.Factory.addGetterSetter(Konva.Shape,'shadowOffsetY',0,Konva.Validators.getNumberValidator());/**
   * get/set shadow offset y
   * @name shadowOffsetY
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} y
   * @returns {Number}
   * @example
   * // get shadow offset y
   * var shadowOffsetY = shape.shadowOffsetY();
   *
   * // set shadow offset y
   * shape.shadowOffsetY(5);
   */Konva.Factory.addGetterSetter(Konva.Shape,'fillPatternImage');/**
   * get/set fill pattern image
   * @name fillPatternImage
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Image} image object
   * @returns {Image}
   * @example
   * // get fill pattern image
   * var fillPatternImage = shape.fillPatternImage();
   *
   * // set fill pattern image
   * var imageObj = new Image();
   * imageObj.onload = function() {
   *   shape.fillPatternImage(imageObj);
   * };
   * imageObj.src = 'path/to/image/jpg';
   */Konva.Factory.addGetterSetter(Konva.Shape,'fill',undefined,Konva.Validators.getStringValidator());/**
   * get/set fill color
   * @name fill
   * @method
   * @memberof Konva.Shape.prototype
   * @param {String} color
   * @returns {String}
   * @example
   * // get fill color
   * var fill = shape.fill();
   *
   * // set fill color with color string
   * shape.fill('green');
   *
   * // set fill color with hex
   * shape.fill('#00ff00');
   *
   * // set fill color with rgb
   * shape.fill('rgb(0,255,0)');
   *
   * // set fill color with rgba and make it 50% opaque
   * shape.fill('rgba(0,255,0,0.5');
   *
   * // shape without fill
   * shape.fill(null);
   */Konva.Factory.addGetterSetter(Konva.Shape,'fillPatternX',0,Konva.Validators.getNumberValidator());/**
   * get/set fill pattern x
   * @name fillPatternX
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} x
   * @returns {Number}
   * @example
   * // get fill pattern x
   * var fillPatternX = shape.fillPatternX();
   * // set fill pattern x
   * shape.fillPatternX(20);
   */Konva.Factory.addGetterSetter(Konva.Shape,'fillPatternY',0,Konva.Validators.getNumberValidator());/**
   * get/set fill pattern y
   * @name fillPatternY
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} y
   * @returns {Number}
   * @example
   * // get fill pattern y
   * var fillPatternY = shape.fillPatternY();
   * // set fill pattern y
   * shape.fillPatternY(20);
   */Konva.Factory.addGetterSetter(Konva.Shape,'fillLinearGradientColorStops');/**
   * get/set fill linear gradient color stops
   * @name fillLinearGradientColorStops
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Array} colorStops
   * @returns {Array} colorStops
   * @example
   * // get fill linear gradient color stops
   * var colorStops = shape.fillLinearGradientColorStops();
   *
   * // create a linear gradient that starts with red, changes to blue
   * // halfway through, and then changes to green
   * shape.fillLinearGradientColorStops(0, 'red', 0.5, 'blue', 1, 'green');
   */Konva.Factory.addGetterSetter(Konva.Shape,'strokeLinearGradientColorStops');/**
   * get/set stroke linear gradient color stops
   * @name strokeLinearGradientColorStops
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Array} colorStops
   * @returns {Array} colorStops
   * @example
   * // get stroke linear gradient color stops
   * var colorStops = shape.strokeLinearGradientColorStops();
   *
   * // create a linear gradient that starts with red, changes to blue
   * // halfway through, and then changes to green
   * shape.strokeLinearGradientColorStops([0, 'red', 0.5, 'blue', 1, 'green']);
   */Konva.Factory.addGetterSetter(Konva.Shape,'fillRadialGradientStartRadius',0);/**
   * get/set fill radial gradient start radius
   * @name fillRadialGradientStartRadius
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} radius
   * @returns {Number}
   * @example
   * // get radial gradient start radius
   * var startRadius = shape.fillRadialGradientStartRadius();
   *
   * // set radial gradient start radius
   * shape.fillRadialGradientStartRadius(0);
   */Konva.Factory.addGetterSetter(Konva.Shape,'fillRadialGradientEndRadius',0);/**
   * get/set fill radial gradient end radius
   * @name fillRadialGradientEndRadius
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} radius
   * @returns {Number}
   * @example
   * // get radial gradient end radius
   * var endRadius = shape.fillRadialGradientEndRadius();
   *
   * // set radial gradient end radius
   * shape.fillRadialGradientEndRadius(100);
   */Konva.Factory.addGetterSetter(Konva.Shape,'fillRadialGradientColorStops');/**
   * get/set fill radial gradient color stops
   * @name fillRadialGradientColorStops
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} colorStops
   * @returns {Array}
   * @example
   * // get fill radial gradient color stops
   * var colorStops = shape.fillRadialGradientColorStops();
   *
   * // create a radial gradient that starts with red, changes to blue
   * // halfway through, and then changes to green
   * shape.fillRadialGradientColorStops(0, 'red', 0.5, 'blue', 1, 'green');
   */Konva.Factory.addGetterSetter(Konva.Shape,'fillPatternRepeat','repeat');/**
   * get/set fill pattern repeat.  Can be 'repeat', 'repeat-x', 'repeat-y', or 'no-repeat'.  The default is 'repeat'
   * @name fillPatternRepeat
   * @method
   * @memberof Konva.Shape.prototype
   * @param {String} repeat
   * @returns {String}
   * @example
   * // get fill pattern repeat
   * var repeat = shape.fillPatternRepeat();
   *
   * // repeat pattern in x direction only
   * shape.fillPatternRepeat('repeat-x');
   *
   * // do not repeat the pattern
   * shape.fillPatternRepeat('no repeat');
   */Konva.Factory.addGetterSetter(Konva.Shape,'fillEnabled',true);/**
   * get/set fill enabled flag
   * @name fillEnabled
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Boolean} enabled
   * @returns {Boolean}
   * @example
   * // get fill enabled flag
   * var fillEnabled = shape.fillEnabled();
   *
   * // disable fill
   * shape.fillEnabled(false);
   *
   * // enable fill
   * shape.fillEnabled(true);
   */Konva.Factory.addGetterSetter(Konva.Shape,'strokeEnabled',true);/**
   * get/set stroke enabled flag
   * @name strokeEnabled
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Boolean} enabled
   * @returns {Boolean}
   * @example
   * // get stroke enabled flag
   * var strokeEnabled = shape.strokeEnabled();
   *
   * // disable stroke
   * shape.strokeEnabled(false);
   *
   * // enable stroke
   * shape.strokeEnabled(true);
   */Konva.Factory.addGetterSetter(Konva.Shape,'shadowEnabled',true);/**
   * get/set shadow enabled flag
   * @name shadowEnabled
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Boolean} enabled
   * @returns {Boolean}
   * @example
   * // get shadow enabled flag
   * var shadowEnabled = shape.shadowEnabled();
   *
   * // disable shadow
   * shape.shadowEnabled(false);
   *
   * // enable shadow
   * shape.shadowEnabled(true);
   */Konva.Factory.addGetterSetter(Konva.Shape,'dashEnabled',true);/**
   * get/set dash enabled flag
   * @name dashEnabled
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Boolean} enabled
   * @returns {Boolean}
   * @example
   * // get dash enabled flag
   * var dashEnabled = shape.dashEnabled();
   *
   * // disable dash
   * shape.dashEnabled(false);
   *
   * // enable dash
   * shape.dashEnabled(true);
   */Konva.Factory.addGetterSetter(Konva.Shape,'strokeScaleEnabled',true);/**
   * get/set strokeScale enabled flag
   * @name strokeScaleEnabled
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Boolean} enabled
   * @returns {Boolean}
   * @example
   * // get stroke scale enabled flag
   * var strokeScaleEnabled = shape.strokeScaleEnabled();
   *
   * // disable stroke scale
   * shape.strokeScaleEnabled(false);
   *
   * // enable stroke scale
   * shape.strokeScaleEnabled(true);
   */Konva.Factory.addGetterSetter(Konva.Shape,'fillPriority','color');/**
   * get/set fill priority.  can be color, pattern, linear-gradient, or radial-gradient.  The default is color.
   *   This is handy if you want to toggle between different fill types.
   * @name fillPriority
   * @method
   * @memberof Konva.Shape.prototype
   * @param {String} priority
   * @returns {String}
   * @example
   * // get fill priority
   * var fillPriority = shape.fillPriority();
   *
   * // set fill priority
   * shape.fillPriority('linear-gradient');
   */Konva.Factory.addComponentsGetterSetter(Konva.Shape,'fillPatternOffset',['x','y']);/**
   * get/set fill pattern offset
   * @name fillPatternOffset
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Object} offset
   * @param {Number} offset.x
   * @param {Number} offset.y
   * @returns {Object}
   * @example
   * // get fill pattern offset
   * var patternOffset = shape.fillPatternOffset();
   *
   * // set fill pattern offset
   * shape.fillPatternOffset({
   *   x: 20
   *   y: 10
   * });
   */Konva.Factory.addGetterSetter(Konva.Shape,'fillPatternOffsetX',0,Konva.Validators.getNumberValidator());/**
   * get/set fill pattern offset x
   * @name fillPatternOffsetX
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} x
   * @returns {Number}
   * @example
   * // get fill pattern offset x
   * var patternOffsetX = shape.fillPatternOffsetX();
   *
   * // set fill pattern offset x
   * shape.fillPatternOffsetX(20);
   */Konva.Factory.addGetterSetter(Konva.Shape,'fillPatternOffsetY',0,Konva.Validators.getNumberValidator());/**
   * get/set fill pattern offset y
   * @name fillPatternOffsetY
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} y
   * @returns {Number}
   * @example
   * // get fill pattern offset y
   * var patternOffsetY = shape.fillPatternOffsetY();
   *
   * // set fill pattern offset y
   * shape.fillPatternOffsetY(10);
   */Konva.Factory.addComponentsGetterSetter(Konva.Shape,'fillPatternScale',['x','y']);/**
   * get/set fill pattern scale
   * @name fillPatternScale
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Object} scale
   * @param {Number} scale.x
   * @param {Number} scale.y
   * @returns {Object}
   * @example
   * // get fill pattern scale
   * var patternScale = shape.fillPatternScale();
   *
   * // set fill pattern scale
   * shape.fillPatternScale({
   *   x: 2
   *   y: 2
   * });
   */Konva.Factory.addGetterSetter(Konva.Shape,'fillPatternScaleX',1,Konva.Validators.getNumberValidator());/**
   * get/set fill pattern scale x
   * @name fillPatternScaleX
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} x
   * @returns {Number}
   * @example
   * // get fill pattern scale x
   * var patternScaleX = shape.fillPatternScaleX();
   *
   * // set fill pattern scale x
   * shape.fillPatternScaleX(2);
   */Konva.Factory.addGetterSetter(Konva.Shape,'fillPatternScaleY',1,Konva.Validators.getNumberValidator());/**
   * get/set fill pattern scale y
   * @name fillPatternScaleY
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} y
   * @returns {Number}
   * @example
   * // get fill pattern scale y
   * var patternScaleY = shape.fillPatternScaleY();
   *
   * // set fill pattern scale y
   * shape.fillPatternScaleY(2);
   */Konva.Factory.addComponentsGetterSetter(Konva.Shape,'fillLinearGradientStartPoint',['x','y']);/**
   * get/set fill linear gradient start point
   * @name fillLinearGradientStartPoint
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Object} startPoint
   * @param {Number} startPoint.x
   * @param {Number} startPoint.y
   * @returns {Object}
   * @example
   * // get fill linear gradient start point
   * var startPoint = shape.fillLinearGradientStartPoint();
   *
   * // set fill linear gradient start point
   * shape.fillLinearGradientStartPoint({
   *   x: 20
   *   y: 10
   * });
   */Konva.Factory.addComponentsGetterSetter(Konva.Shape,'strokeLinearGradientStartPoint',['x','y']);/**
   * get/set stroke linear gradient start point
   * @name strokeLinearGradientStartPoint
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Object} startPoint
   * @param {Number} startPoint.x
   * @param {Number} startPoint.y
   * @returns {Object}
   * @example
   * // get stroke linear gradient start point
   * var startPoint = shape.strokeLinearGradientStartPoint();
   *
   * // set stroke linear gradient start point
   * shape.strokeLinearGradientStartPoint({
   *   x: 20
   *   y: 10
   * });
   */Konva.Factory.addGetterSetter(Konva.Shape,'fillLinearGradientStartPointX',0);/**
   * get/set fill linear gradient start point x
   * @name fillLinearGradientStartPointX
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} x
   * @returns {Number}
   * @example
   * // get fill linear gradient start point x
   * var startPointX = shape.fillLinearGradientStartPointX();
   *
   * // set fill linear gradient start point x
   * shape.fillLinearGradientStartPointX(20);
   */Konva.Factory.addGetterSetter(Konva.Shape,'strokeLinearGradientStartPointX',0);/**
   * get/set stroke linear gradient start point x
   * @name linearLinearGradientStartPointX
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} x
   * @returns {Number}
   * @example
   * // get stroke linear gradient start point x
   * var startPointX = shape.strokeLinearGradientStartPointX();
   *
   * // set stroke linear gradient start point x
   * shape.strokeLinearGradientStartPointX(20);
   */Konva.Factory.addGetterSetter(Konva.Shape,'fillLinearGradientStartPointY',0);/**
   * get/set fill linear gradient start point y
   * @name fillLinearGradientStartPointY
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} y
   * @returns {Number}
   * @example
   * // get fill linear gradient start point y
   * var startPointY = shape.fillLinearGradientStartPointY();
   *
   * // set fill linear gradient start point y
   * shape.fillLinearGradientStartPointY(20);
   */Konva.Factory.addGetterSetter(Konva.Shape,'strokeLinearGradientStartPointY',0);/**
   * get/set stroke linear gradient start point y
   * @name strokeLinearGradientStartPointY
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} y
   * @returns {Number}
   * @example
   * // get stroke linear gradient start point y
   * var startPointY = shape.strokeLinearGradientStartPointY();
   *
   * // set stroke linear gradient start point y
   * shape.strokeLinearGradientStartPointY(20);
   */Konva.Factory.addComponentsGetterSetter(Konva.Shape,'fillLinearGradientEndPoint',['x','y']);/**
   * get/set fill linear gradient end point
   * @name fillLinearGradientEndPoint
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Object} endPoint
   * @param {Number} endPoint.x
   * @param {Number} endPoint.y
   * @returns {Object}
   * @example
   * // get fill linear gradient end point
   * var endPoint = shape.fillLinearGradientEndPoint();
   *
   * // set fill linear gradient end point
   * shape.fillLinearGradientEndPoint({
   *   x: 20
   *   y: 10
   * });
   */Konva.Factory.addComponentsGetterSetter(Konva.Shape,'strokeLinearGradientEndPoint',['x','y']);/**
   * get/set stroke linear gradient end point
   * @name strokeLinearGradientEndPoint
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Object} endPoint
   * @param {Number} endPoint.x
   * @param {Number} endPoint.y
   * @returns {Object}
   * @example
   * // get stroke linear gradient end point
   * var endPoint = shape.strokeLinearGradientEndPoint();
   *
   * // set stroke linear gradient end point
   * shape.strokeLinearGradientEndPoint({
   *   x: 20
   *   y: 10
   * });
   */Konva.Factory.addGetterSetter(Konva.Shape,'fillLinearGradientEndPointX',0);/**
   * get/set fill linear gradient end point x
   * @name fillLinearGradientEndPointX
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} x
   * @returns {Number}
   * @example
   * // get fill linear gradient end point x
   * var endPointX = shape.fillLinearGradientEndPointX();
   *
   * // set fill linear gradient end point x
   * shape.fillLinearGradientEndPointX(20);
   */Konva.Factory.addGetterSetter(Konva.Shape,'strokeLinearGradientEndPointX',0);/**
   * get/set fill linear gradient end point x
   * @name strokeLinearGradientEndPointX
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} x
   * @returns {Number}
   * @example
   * // get stroke linear gradient end point x
   * var endPointX = shape.strokeLinearGradientEndPointX();
   *
   * // set stroke linear gradient end point x
   * shape.strokeLinearGradientEndPointX(20);
   */Konva.Factory.addGetterSetter(Konva.Shape,'fillLinearGradientEndPointY',0);/**
   * get/set fill linear gradient end point y
   * @name fillLinearGradientEndPointY
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} y
   * @returns {Number}
   * @example
   * // get fill linear gradient end point y
   * var endPointY = shape.fillLinearGradientEndPointY();
   *
   * // set fill linear gradient end point y
   * shape.fillLinearGradientEndPointY(20);
   */Konva.Factory.addGetterSetter(Konva.Shape,'strokeLinearGradientEndPointY',0);/**
   * get/set stroke linear gradient end point y
   * @name strokeLinearGradientEndPointY
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} y
   * @returns {Number}
   * @example
   * // get stroke linear gradient end point y
   * var endPointY = shape.strokeLinearGradientEndPointY();
   *
   * // set stroke linear gradient end point y
   * shape.strokeLinearGradientEndPointY(20);
   */Konva.Factory.addComponentsGetterSetter(Konva.Shape,'fillRadialGradientStartPoint',['x','y']);/**
   * get/set fill radial gradient start point
   * @name fillRadialGradientStartPoint
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Object} startPoint
   * @param {Number} startPoint.x
   * @param {Number} startPoint.y
   * @returns {Object}
   * @example
   * // get fill radial gradient start point
   * var startPoint = shape.fillRadialGradientStartPoint();
   *
   * // set fill radial gradient start point
   * shape.fillRadialGradientStartPoint({
   *   x: 20
   *   y: 10
   * });
   */Konva.Factory.addGetterSetter(Konva.Shape,'fillRadialGradientStartPointX',0);/**
   * get/set fill radial gradient start point x
   * @name fillRadialGradientStartPointX
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} x
   * @returns {Number}
   * @example
   * // get fill radial gradient start point x
   * var startPointX = shape.fillRadialGradientStartPointX();
   *
   * // set fill radial gradient start point x
   * shape.fillRadialGradientStartPointX(20);
   */Konva.Factory.addGetterSetter(Konva.Shape,'fillRadialGradientStartPointY',0);/**
   * get/set fill radial gradient start point y
   * @name fillRadialGradientStartPointY
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} y
   * @returns {Number}
   * @example
   * // get fill radial gradient start point y
   * var startPointY = shape.fillRadialGradientStartPointY();
   *
   * // set fill radial gradient start point y
   * shape.fillRadialGradientStartPointY(20);
   */Konva.Factory.addComponentsGetterSetter(Konva.Shape,'fillRadialGradientEndPoint',['x','y']);/**
   * get/set fill radial gradient end point
   * @name fillRadialGradientEndPoint
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Object} endPoint
   * @param {Number} endPoint.x
   * @param {Number} endPoint.y
   * @returns {Object}
   * @example
   * // get fill radial gradient end point
   * var endPoint = shape.fillRadialGradientEndPoint();
   *
   * // set fill radial gradient end point
   * shape.fillRadialGradientEndPoint({
   *   x: 20
   *   y: 10
   * });
   */Konva.Factory.addGetterSetter(Konva.Shape,'fillRadialGradientEndPointX',0);/**
   * get/set fill radial gradient end point x
   * @name fillRadialGradientEndPointX
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} x
   * @returns {Number}
   * @example
   * // get fill radial gradient end point x
   * var endPointX = shape.fillRadialGradientEndPointX();
   *
   * // set fill radial gradient end point x
   * shape.fillRadialGradientEndPointX(20);
   */Konva.Factory.addGetterSetter(Konva.Shape,'fillRadialGradientEndPointY',0);/**
   * get/set fill radial gradient end point y
   * @name fillRadialGradientEndPointY
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} y
   * @returns {Number}
   * @example
   * // get fill radial gradient end point y
   * var endPointY = shape.fillRadialGradientEndPointY();
   *
   * // set fill radial gradient end point y
   * shape.fillRadialGradientEndPointY(20);
   */Konva.Factory.addGetterSetter(Konva.Shape,'fillPatternRotation',0);/**
   * get/set fill pattern rotation in degrees
   * @name fillPatternRotation
   * @method
   * @memberof Konva.Shape.prototype
   * @param {Number} rotation
   * @returns {Konva.Shape}
   * @example
   * // get fill pattern rotation
   * var patternRotation = shape.fillPatternRotation();
   *
   * // set fill pattern rotation
   * shape.fillPatternRotation(20);
   */Konva.Factory.backCompat(Konva.Shape,{dashArray:'dash',getDashArray:'getDash',setDashArray:'getDash',drawFunc:'sceneFunc',getDrawFunc:'getSceneFunc',setDrawFunc:'setSceneFunc',drawHitFunc:'hitFunc',getDrawHitFunc:'getHitFunc',setDrawHitFunc:'setHitFunc'});Konva.Collection.mapMethods(Konva.Shape);})(Konva);(function(){'use strict';// CONSTANTS
var STAGE='Stage',STRING='string',PX='px',MOUSEOUT='mouseout',MOUSELEAVE='mouseleave',MOUSEOVER='mouseover',MOUSEENTER='mouseenter',MOUSEMOVE='mousemove',MOUSEDOWN='mousedown',MOUSEUP='mouseup',CONTEXTMENU='contextmenu',CLICK='click',DBL_CLICK='dblclick',TOUCHSTART='touchstart',TOUCHEND='touchend',TAP='tap',DBL_TAP='dbltap',TOUCHMOVE='touchmove',WHEEL='wheel',CONTENT_MOUSEOUT='contentMouseout',CONTENT_MOUSEOVER='contentMouseover',CONTENT_MOUSEMOVE='contentMousemove',CONTENT_MOUSEDOWN='contentMousedown',CONTENT_MOUSEUP='contentMouseup',CONTENT_CONTEXTMENU='contentContextmenu',CONTENT_CLICK='contentClick',CONTENT_DBL_CLICK='contentDblclick',CONTENT_TOUCHSTART='contentTouchstart',CONTENT_TOUCHEND='contentTouchend',CONTENT_DBL_TAP='contentDbltap',CONTENT_TAP='contentTap',CONTENT_TOUCHMOVE='contentTouchmove',CONTENT_WHEEL='contentWheel',DIV='div',RELATIVE='relative',KONVA_CONTENT='konvajs-content',SPACE=' ',UNDERSCORE='_',CONTAINER='container',EMPTY_STRING='',EVENTS=[MOUSEDOWN,MOUSEMOVE,MOUSEUP,MOUSEOUT,TOUCHSTART,TOUCHMOVE,TOUCHEND,MOUSEOVER,WHEEL,CONTEXTMENU],// cached variables
eventsLength=EVENTS.length;function addEvent(ctx,eventName){ctx.content.addEventListener(eventName,function(evt){ctx[UNDERSCORE+eventName](evt);},false);}/**
   * Stage constructor.  A stage is used to contain multiple layers
   * @constructor
   * @memberof Konva
   * @augments Konva.Container
   * @param {Object} config
   * @param {String|Element} config.container Container selector or DOM element
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * @example
   * var stage = new Konva.Stage({
   *   width: 500,
   *   height: 800,
   *   container: 'containerId' // or "#containerId" or ".containerClass"
   * });
   */Konva.Stage=function(config){this.___init(config);};Konva.Util.addMethods(Konva.Stage,{___init:function ___init(config){this.nodeType=STAGE;// call super constructor
Konva.Container.call(this,config);this._id=Konva.idCounter++;this._buildDOM();this._bindContentEvents();this._enableNestedTransforms=false;Konva.stages.push(this);},_validateAdd:function _validateAdd(child){if(child.getType()!=='Layer'){Konva.Util.throw('You may only add layers to the stage.');}},/**
     * set container dom element which contains the stage wrapper div element
     * @method
     * @memberof Konva.Stage.prototype
     * @param {DomElement} container can pass in a dom element or id string
     */setContainer:function setContainer(container){if((typeof container==='undefined'?'undefined':_typeof(container))===STRING){if(container.charAt(0)==='.'){var className=container.slice(1);container=Konva.document.getElementsByClassName(className)[0];}else{var id;if(container.charAt(0)!=='#'){id=container;}else{id=container.slice(1);}container=Konva.document.getElementById(id);}if(!container){throw'Can not find container in document with id '+id;}}this._setAttr(CONTAINER,container);return this;},shouldDrawHit:function shouldDrawHit(){return true;},draw:function draw(){Konva.Node.prototype.draw.call(this);return this;},/**
     * draw layer scene graphs
     * @name draw
     * @method
     * @memberof Konva.Stage.prototype
     *//**
     * draw layer hit graphs
     * @name drawHit
     * @method
     * @memberof Konva.Stage.prototype
     *//**
     * set height
     * @method
     * @memberof Konva.Stage.prototype
     * @param {Number} height
     */setHeight:function setHeight(height){Konva.Node.prototype.setHeight.call(this,height);this._resizeDOM();return this;},/**
     * set width
     * @method
     * @memberof Konva.Stage.prototype
     * @param {Number} width
     */setWidth:function setWidth(width){Konva.Node.prototype.setWidth.call(this,width);this._resizeDOM();return this;},/**
     * clear all layers
     * @method
     * @memberof Konva.Stage.prototype
     */clear:function clear(){var layers=this.children,len=layers.length,n;for(n=0;n<len;n++){layers[n].clear();}return this;},clone:function clone(obj){if(!obj){obj={};}obj.container=Konva.document.createElement(DIV);return Konva.Container.prototype.clone.call(this,obj);},/**
     * destroy stage
     * @method
     * @memberof Konva.Stage.prototype
     */destroy:function destroy(){var content=this.content;Konva.Container.prototype.destroy.call(this);if(content&&Konva.Util._isInDocument(content)){this.getContainer().removeChild(content);}var index=Konva.stages.indexOf(this);if(index>-1){Konva.stages.splice(index,1);}return this;},/**
     * get pointer position which can be a touch position or mouse position
     * @method
     * @memberof Konva.Stage.prototype
     * @returns {Object}
     */getPointerPosition:function getPointerPosition(){return this.pointerPos;},getStage:function getStage(){return this;},/**
     * get stage content div element which has the
     *  the class name "konvajs-content"
     * @method
     * @memberof Konva.Stage.prototype
     */getContent:function getContent(){return this.content;},_toKonvaCanvas:function _toKonvaCanvas(config){config=config||{};var x=config.x||0,y=config.y||0,canvas=new Konva.SceneCanvas({width:config.width||this.getWidth(),height:config.height||this.getHeight(),pixelRatio:config.pixelRatio||1}),_context=canvas.getContext()._context,layers=this.children;if(x||y){_context.translate(-1*x,-1*y);}layers.each(function(layer){if(!layer.isVisible()){return;}var layerCanvas=layer._toKonvaCanvas(config);_context.drawImage(layerCanvas._canvas,x,y,layerCanvas.getWidth()/layerCanvas.getPixelRatio(),layerCanvas.getHeight()/layerCanvas.getPixelRatio());});return canvas;},/**
     * converts stage into an image.
     * @method
     * @memberof Konva.Stage.prototype
     * @param {Object} config
     * @param {Function} config.callback function executed when the composite has completed
     * @param {String} [config.mimeType] can be "image/png" or "image/jpeg".
     *  "image/png" is the default
     * @param {Number} [config.x] x position of canvas section
     * @param {Number} [config.y] y position of canvas section
     * @param {Number} [config.width] width of canvas section
     * @param {Number} [config.height] height of canvas section
     * @param {Number} [config.quality] jpeg quality.  If using an "image/jpeg" mimeType,
     *  you can specify the quality from 0 to 1, where 0 is very poor quality and 1
     *  is very high quality
     */toImage:function toImage(config){var cb=config.callback;config.callback=function(dataUrl){Konva.Util._getImage(dataUrl,function(img){cb(img);});};this.toDataURL(config);},/**
     * get visible intersection shape. This is the preferred
     *  method for determining if a point intersects a shape or not
     * @method
     * @memberof Konva.Stage.prototype
     * @param {Object} pos
     * @param {Number} pos.x
     * @param {Number} pos.y
     * @param {String} [selector]
     * @returns {Konva.Node}
     * @example
     * var shape = stage.getIntersection({x: 50, y: 50});
     * // or if you interested in shape parent:
     * var group = stage.getIntersection({x: 50, y: 50}, 'Group');
     */getIntersection:function getIntersection(pos,selector){var layers=this.getChildren(),len=layers.length,end=len-1,n,shape;for(n=end;n>=0;n--){shape=layers[n].getIntersection(pos,selector);if(shape){return shape;}}return null;},_resizeDOM:function _resizeDOM(){if(this.content){var width=this.getWidth(),height=this.getHeight(),layers=this.getChildren(),len=layers.length,n,layer;// set content dimensions
this.content.style.width=width+PX;this.content.style.height=height+PX;this.bufferCanvas.setSize(width,height);this.bufferHitCanvas.setSize(width,height);// set layer dimensions
for(n=0;n<len;n++){layer=layers[n];layer.setSize(width,height);layer.draw();}}},/**
     * add layer or layers to stage
     * @method
     * @memberof Konva.Stage.prototype
     * @param {...Konva.Layer} layer
     * @example
     * stage.add(layer1, layer2, layer3);
     */add:function add(layer){if(arguments.length>1){for(var i=0;i<arguments.length;i++){this.add(arguments[i]);}return this;}Konva.Container.prototype.add.call(this,layer);layer._setCanvasSize(this.width(),this.height());// draw layer and append canvas to container
layer.draw();if(Konva.isBrowser){this.content.appendChild(layer.canvas._canvas);}// chainable
return this;},getParent:function getParent(){return null;},getLayer:function getLayer(){return null;},/**
     * returns a {@link Konva.Collection} of layers
     * @method
     * @memberof Konva.Stage.prototype
     */getLayers:function getLayers(){return this.getChildren();},_bindContentEvents:function _bindContentEvents(){if(!Konva.isBrowser){return;}for(var n=0;n<eventsLength;n++){addEvent(this,EVENTS[n]);}},_mouseover:function _mouseover(evt){if(!Konva.UA.mobile){this._setPointerPosition(evt);this._fire(CONTENT_MOUSEOVER,{evt:evt});}},_mouseout:function _mouseout(evt){if(!Konva.UA.mobile){this._setPointerPosition(evt);var targetShape=this.targetShape;if(targetShape&&!Konva.isDragging()){targetShape._fireAndBubble(MOUSEOUT,{evt:evt});targetShape._fireAndBubble(MOUSELEAVE,{evt:evt});this.targetShape=null;}this.pointerPos=undefined;this._fire(CONTENT_MOUSEOUT,{evt:evt});}},_mousemove:function _mousemove(evt){// workaround for mobile IE to force touch event when unhandled pointer event elevates into a mouse event
if(Konva.UA.ieMobile){return this._touchmove(evt);}// workaround fake mousemove event in chrome browser https://code.google.com/p/chromium/issues/detail?id=161464
if((typeof evt.movementX!=='undefined'||typeof evt.movementY!=='undefined')&&evt.movementY===0&&evt.movementX===0){return null;}if(Konva.UA.mobile){return null;}this._setPointerPosition(evt);var shape;if(!Konva.isDragging()){shape=this.getIntersection(this.getPointerPosition());if(shape&&shape.isListening()){if(!Konva.isDragging()&&(!this.targetShape||this.targetShape._id!==shape._id)){if(this.targetShape){this.targetShape._fireAndBubble(MOUSEOUT,{evt:evt},shape);this.targetShape._fireAndBubble(MOUSELEAVE,{evt:evt},shape);}shape._fireAndBubble(MOUSEOVER,{evt:evt},this.targetShape);shape._fireAndBubble(MOUSEENTER,{evt:evt},this.targetShape);this.targetShape=shape;}else{shape._fireAndBubble(MOUSEMOVE,{evt:evt});}}else{/*
                 * if no shape was detected, clear target shape and try
                 * to run mouseout from previous target shape
                 */if(this.targetShape&&!Konva.isDragging()){this.targetShape._fireAndBubble(MOUSEOUT,{evt:evt});this.targetShape._fireAndBubble(MOUSELEAVE,{evt:evt});this.targetShape=null;}this._fire(MOUSEMOVE,{evt:evt,target:this,currentTarget:this});}// content event
this._fire(CONTENT_MOUSEMOVE,{evt:evt});}// always call preventDefault for desktop events because some browsers
// try to drag and drop the canvas element
if(evt.cancelable){evt.preventDefault();}},_mousedown:function _mousedown(evt){// workaround for mobile IE to force touch event when unhandled pointer event elevates into a mouse event
if(Konva.UA.ieMobile){return this._touchstart(evt);}if(!Konva.UA.mobile){this._setPointerPosition(evt);var shape=this.getIntersection(this.getPointerPosition());Konva.listenClickTap=true;if(shape&&shape.isListening()){this.clickStartShape=shape;shape._fireAndBubble(MOUSEDOWN,{evt:evt});}else{this._fire(MOUSEDOWN,{evt:evt,target:this,currentTarget:this});}// content event
this._fire(CONTENT_MOUSEDOWN,{evt:evt});}// always call preventDefault for desktop events because some browsers
// try to drag and drop the canvas element
// TODO: if we preventDefault() it will cancel event detection outside of window inside iframe
// but we need it for better drag&drop
// can we disable native drag&drop somehow differently?
// if (evt.cancelable) {
// evt.preventDefault();
// }
},_mouseup:function _mouseup(evt){// workaround for mobile IE to force touch event when unhandled pointer event elevates into a mouse event
if(Konva.UA.ieMobile){return this._touchend(evt);}if(!Konva.UA.mobile){this._setPointerPosition(evt);var shape=this.getIntersection(this.getPointerPosition()),clickStartShape=this.clickStartShape,clickEndShape=this.clickEndShape,fireDblClick=false,dd=Konva.DD;if(Konva.inDblClickWindow){fireDblClick=true;clearTimeout(this.dblTimeout);// Konva.inDblClickWindow = false;
}else if(!dd||!dd.justDragged){// don't set inDblClickWindow after dragging
Konva.inDblClickWindow=true;clearTimeout(this.dblTimeout);}else if(dd){dd.justDragged=false;}this.dblTimeout=setTimeout(function(){Konva.inDblClickWindow=false;},Konva.dblClickWindow);if(shape&&shape.isListening()){this.clickEndShape=shape;shape._fireAndBubble(MOUSEUP,{evt:evt});// detect if click or double click occurred
if(Konva.listenClickTap&&clickStartShape&&clickStartShape._id===shape._id){shape._fireAndBubble(CLICK,{evt:evt});if(fireDblClick&&clickEndShape&&clickEndShape._id===shape._id){shape._fireAndBubble(DBL_CLICK,{evt:evt});}}}else{this._fire(MOUSEUP,{evt:evt,target:this,currentTarget:this});if(Konva.listenClickTap){this._fire(CLICK,{evt:evt,target:this,currentTarget:this});}if(fireDblClick){this._fire(DBL_CLICK,{evt:evt,target:this,currentTarget:this});}}// content events
this._fire(CONTENT_MOUSEUP,{evt:evt});if(Konva.listenClickTap){this._fire(CONTENT_CLICK,{evt:evt});if(fireDblClick){this._fire(CONTENT_DBL_CLICK,{evt:evt});}}Konva.listenClickTap=false;}// always call preventDefault for desktop events because some browsers
// try to drag and drop the canvas element
if(evt.cancelable){evt.preventDefault();}},_contextmenu:function _contextmenu(evt){this._setPointerPosition(evt);var shape=this.getIntersection(this.getPointerPosition());if(shape&&shape.isListening()){shape._fireAndBubble(CONTEXTMENU,{evt:evt});}else{this._fire(CONTEXTMENU,{evt:evt,target:this,currentTarget:this});}this._fire(CONTENT_CONTEXTMENU,{evt:evt});},_touchstart:function _touchstart(evt){this._setPointerPosition(evt);var shape=this.getIntersection(this.getPointerPosition());Konva.listenClickTap=true;if(shape&&shape.isListening()){this.tapStartShape=shape;shape._fireAndBubble(TOUCHSTART,{evt:evt});// only call preventDefault if the shape is listening for events
if(shape.isListening()&&shape.preventDefault()&&evt.cancelable){evt.preventDefault();}}else{this._fire(TOUCHSTART,{evt:evt,target:this,currentTarget:this});}// content event
this._fire(CONTENT_TOUCHSTART,{evt:evt});},_touchend:function _touchend(evt){this._setPointerPosition(evt);var shape=this.getIntersection(this.getPointerPosition()),fireDblClick=false;if(Konva.inDblClickWindow){fireDblClick=true;clearTimeout(this.dblTimeout);// Konva.inDblClickWindow = false;
}else{Konva.inDblClickWindow=true;clearTimeout(this.dblTimeout);}this.dblTimeout=setTimeout(function(){Konva.inDblClickWindow=false;},Konva.dblClickWindow);if(shape&&shape.isListening()){shape._fireAndBubble(TOUCHEND,{evt:evt});// detect if tap or double tap occurred
if(Konva.listenClickTap&&this.tapStartShape&&shape._id===this.tapStartShape._id){shape._fireAndBubble(TAP,{evt:evt});if(fireDblClick){shape._fireAndBubble(DBL_TAP,{evt:evt});}}// only call preventDefault if the shape is listening for events
if(shape.isListening()&&shape.preventDefault()&&evt.cancelable){evt.preventDefault();}}else{this._fire(TOUCHEND,{evt:evt,target:this,currentTarget:this});if(Konva.listenClickTap){this._fire(TAP,{evt:evt,target:this,currentTarget:this});}if(fireDblClick){this._fire(DBL_TAP,{evt:evt,target:this,currentTarget:this});}}// content events
this._fire(CONTENT_TOUCHEND,{evt:evt});if(Konva.listenClickTap){this._fire(CONTENT_TAP,{evt:evt});if(fireDblClick){this._fire(CONTENT_DBL_TAP,{evt:evt});}}Konva.listenClickTap=false;},_touchmove:function _touchmove(evt){this._setPointerPosition(evt);var dd=Konva.DD,shape;if(!Konva.isDragging()){shape=this.getIntersection(this.getPointerPosition());if(shape&&shape.isListening()){shape._fireAndBubble(TOUCHMOVE,{evt:evt});// only call preventDefault if the shape is listening for events
if(shape.isListening()&&shape.preventDefault()&&evt.cancelable){evt.preventDefault();}}else{this._fire(TOUCHMOVE,{evt:evt,target:this,currentTarget:this});}this._fire(CONTENT_TOUCHMOVE,{evt:evt});}if(dd){if(Konva.isDragging()&&Konva.DD.node.preventDefault()&&evt.cancelable){evt.preventDefault();}}},_wheel:function _wheel(evt){this._setPointerPosition(evt);var shape=this.getIntersection(this.getPointerPosition());if(shape&&shape.isListening()){shape._fireAndBubble(WHEEL,{evt:evt});}else{this._fire(WHEEL,{evt:evt,target:this,currentTarget:this});}this._fire(CONTENT_WHEEL,{evt:evt});},_setPointerPosition:function _setPointerPosition(evt){var contentPosition=this._getContentPosition(),x=null,y=null;evt=evt?evt:window.event;// touch events
if(evt.touches!==undefined){// currently, only handle one finger
if(evt.touches.length>0){var touch=evt.touches[0];// get the information for finger #1
x=touch.clientX-contentPosition.left;y=touch.clientY-contentPosition.top;}}else{// mouse events
x=evt.clientX-contentPosition.left;y=evt.clientY-contentPosition.top;}if(x!==null&&y!==null){this.pointerPos={x:x,y:y};}},_getContentPosition:function _getContentPosition(){var rect=this.content.getBoundingClientRect?this.content.getBoundingClientRect():{top:0,left:0};return{top:rect.top,left:rect.left};},_buildDOM:function _buildDOM(){// the buffer canvas pixel ratio must be 1 because it is used as an
// intermediate canvas before copying the result onto a scene canvas.
// not setting it to 1 will result in an over compensation
this.bufferCanvas=new Konva.SceneCanvas();this.bufferHitCanvas=new Konva.HitCanvas({pixelRatio:1});if(!Konva.isBrowser){return;}var container=this.getContainer();if(!container){throw'Stage has no container. A container is required.';}// clear content inside container
container.innerHTML=EMPTY_STRING;// content
this.content=Konva.document.createElement(DIV);this.content.style.position=RELATIVE;this.content.style.userSelect='none';this.content.className=KONVA_CONTENT;this.content.setAttribute('role','presentation');container.appendChild(this.content);this._resizeDOM();},_onContent:function _onContent(typesStr,handler){var types=typesStr.split(SPACE),len=types.length,n,baseEvent;for(n=0;n<len;n++){baseEvent=types[n];this.content.addEventListener(baseEvent,handler,false);}},// currently cache function is now working for stage, because stage has no its own canvas element
// TODO: may be it is better to cache all children layers?
cache:function cache(){Konva.Util.warn('Cache function is not allowed for stage. You may use cache only for layers, groups and shapes.');},clearCache:function clearCache(){}});Konva.Util.extend(Konva.Stage,Konva.Container);// add getters and setters
Konva.Factory.addGetter(Konva.Stage,'container');Konva.Factory.addOverloadedGetterSetter(Konva.Stage,'container');/**
   * get container DOM element
   * @name container
   * @method
   * @memberof Konva.Stage.prototype
   * @returns {DomElement} container
   * @example
   * // get container
   * var container = stage.container();
   * // set container
   * var container = document.createElement('div');
   * body.appendChild(container);
   * stage.container(container);
   */})();(function(Konva){'use strict';/**
   * BaseLayer constructor.
   * @constructor
   * @memberof Konva
   * @augments Konva.Container
   * @param {Object} config
   * @param {Boolean} [config.clearBeforeDraw] set this property to false if you don't want
   * to clear the canvas before each layer draw.  The default value is true.
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * * @param {Object} [config.clip] set clip
     * @param {Number} [config.clipX] set clip x
     * @param {Number} [config.clipY] set clip y
     * @param {Number} [config.clipWidth] set clip width
     * @param {Number} [config.clipHeight] set clip height
     * @param {Function} [config.clipFunc] set clip func

   */Konva.BaseLayer=function(config){this.___init(config);};Konva.Util.addMethods(Konva.BaseLayer,{___init:function ___init(config){this.nodeType='Layer';Konva.Container.call(this,config);},createPNGStream:function createPNGStream(){return this.canvas._canvas.createPNGStream();},/**
     * get layer canvas
     * @method
     * @memberof Konva.BaseLayer.prototype
     */getCanvas:function getCanvas(){return this.canvas;},/**
     * get layer hit canvas
     * @method
     * @memberof Konva.BaseLayer.prototype
     */getHitCanvas:function getHitCanvas(){return this.hitCanvas;},/**
     * get layer canvas context
     * @method
     * @memberof Konva.BaseLayer.prototype
     */getContext:function getContext(){return this.getCanvas().getContext();},/**
     * clear scene and hit canvas contexts tied to the layer
     * @method
     * @memberof Konva.BaseLayer.prototype
     * @param {Object} [bounds]
     * @param {Number} [bounds.x]
     * @param {Number} [bounds.y]
     * @param {Number} [bounds.width]
     * @param {Number} [bounds.height]
     * @example
     * layer.clear();
     * layer.clear({
     *   x : 0,
     *   y : 0,
     *   width : 100,
     *   height : 100
     * });
     */clear:function clear(bounds){this.getContext().clear(bounds);return this;},clearHitCache:function clearHitCache(){this._hitImageData=undefined;},// extend Node.prototype.setZIndex
setZIndex:function setZIndex(index){Konva.Node.prototype.setZIndex.call(this,index);var stage=this.getStage();if(stage){stage.content.removeChild(this.getCanvas()._canvas);if(index<stage.getChildren().length-1){stage.content.insertBefore(this.getCanvas()._canvas,stage.getChildren()[index+1].getCanvas()._canvas);}else{stage.content.appendChild(this.getCanvas()._canvas);}}return this;},// extend Node.prototype.moveToTop
moveToTop:function moveToTop(){Konva.Node.prototype.moveToTop.call(this);var stage=this.getStage();if(stage){stage.content.removeChild(this.getCanvas()._canvas);stage.content.appendChild(this.getCanvas()._canvas);}return this;},// extend Node.prototype.moveUp
moveUp:function moveUp(){var moved=Konva.Node.prototype.moveUp.call(this);if(!moved){return this;}var stage=this.getStage();if(!stage){return this;}stage.content.removeChild(this.getCanvas()._canvas);if(this.index<stage.getChildren().length-1){stage.content.insertBefore(this.getCanvas()._canvas,stage.getChildren()[this.index+1].getCanvas()._canvas);}else{stage.content.appendChild(this.getCanvas()._canvas);}return this;},// extend Node.prototype.moveDown
moveDown:function moveDown(){if(Konva.Node.prototype.moveDown.call(this)){var stage=this.getStage();if(stage){var children=stage.getChildren();stage.content.removeChild(this.getCanvas()._canvas);stage.content.insertBefore(this.getCanvas()._canvas,children[this.index+1].getCanvas()._canvas);}}return this;},// extend Node.prototype.moveToBottom
moveToBottom:function moveToBottom(){if(Konva.Node.prototype.moveToBottom.call(this)){var stage=this.getStage();if(stage){var children=stage.getChildren();stage.content.removeChild(this.getCanvas()._canvas);stage.content.insertBefore(this.getCanvas()._canvas,children[1].getCanvas()._canvas);}}return this;},getLayer:function getLayer(){return this;},remove:function remove(){var _canvas=this.getCanvas()._canvas;Konva.Node.prototype.remove.call(this);if(_canvas&&_canvas.parentNode&&Konva.Util._isInDocument(_canvas)){_canvas.parentNode.removeChild(_canvas);}return this;},getStage:function getStage(){return this.parent;},setSize:function setSize(width,height){this.canvas.setSize(width,height);return this;},_toKonvaCanvas:function _toKonvaCanvas(config){config=config||{};config.width=config.width||this.getWidth();config.height=config.height||this.getHeight();config.x=config.x!==undefined?config.x:this.getX();config.y=config.y!==undefined?config.y:this.getY();return Konva.Node.prototype._toKonvaCanvas.call(this,config);},/**
     * get/set width of layer.getter return width of stage. setter doing nothing.
     * if you want change width use `stage.width(value);`
     * @name width
     * @method
     * @memberof Konva.BaseLayer.prototype
     * @returns {Number}
     * @example
     * var width = layer.width();
     */getWidth:function getWidth(){if(this.parent){return this.parent.getWidth();}},setWidth:function setWidth(){Konva.Util.warn('Can not change width of layer. Use "stage.width(value)" function instead.');},/**
     * get/set height of layer.getter return height of stage. setter doing nothing.
     * if you want change height use `stage.height(value);`
     * @name height
     * @method
     * @memberof Konva.BaseLayer.prototype
     * @returns {Number}
     * @example
     * var height = layer.height();
     */getHeight:function getHeight(){if(this.parent){return this.parent.getHeight();}},setHeight:function setHeight(){Konva.Util.warn('Can not change height of layer. Use "stage.height(value)" function instead.');},// the apply transform method is handled by the Layer and FastLayer class
// because it is up to the layer to decide if an absolute or relative transform
// should be used
_applyTransform:function _applyTransform(shape,context,top){var m=shape.getAbsoluteTransform(top).getMatrix();context.transform(m[0],m[1],m[2],m[3],m[4],m[5]);}});Konva.Util.extend(Konva.BaseLayer,Konva.Container);// add getters and setters
Konva.Factory.addGetterSetter(Konva.BaseLayer,'clearBeforeDraw',true);/**
   * get/set clearBeforeDraw flag which determines if the layer is cleared or not
   *  before drawing
   * @name clearBeforeDraw
   * @method
   * @memberof Konva.BaseLayer.prototype
   * @param {Boolean} clearBeforeDraw
   * @returns {Boolean}
   * @example
   * // get clearBeforeDraw flag
   * var clearBeforeDraw = layer.clearBeforeDraw();
   *
   * // disable clear before draw
   * layer.clearBeforeDraw(false);
   *
   * // enable clear before draw
   * layer.clearBeforeDraw(true);
   */Konva.Collection.mapMethods(Konva.BaseLayer);})(Konva);(function(){'use strict';// constants
var HASH='#',BEFORE_DRAW='beforeDraw',DRAW='draw',/*
         * 2 - 3 - 4
         * |       |
         * 1 - 0   5
         *         |
         * 8 - 7 - 6
         */INTERSECTION_OFFSETS=[{x:0,y:0},// 0
{x:-1,y:-1},// 2
{x:1,y:-1},// 4
{x:1,y:1},// 6
{x:-1,y:1// 8
}],INTERSECTION_OFFSETS_LEN=INTERSECTION_OFFSETS.length;/**
   * Layer constructor.  Layers are tied to their own canvas element and are used
   * to contain groups or shapes.
   * @constructor
   * @memberof Konva
   * @augments Konva.BaseLayer
   * @param {Object} config
   * @param {Boolean} [config.clearBeforeDraw] set this property to false if you don't want
   * to clear the canvas before each layer draw.  The default value is true.
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * * @param {Object} [config.clip] set clip
     * @param {Number} [config.clipX] set clip x
     * @param {Number} [config.clipY] set clip y
     * @param {Number} [config.clipWidth] set clip width
     * @param {Number} [config.clipHeight] set clip height
     * @param {Function} [config.clipFunc] set clip func

   * @example
   * var layer = new Konva.Layer();
   */Konva.Layer=function(config){this.____init(config);};Konva.Util.addMethods(Konva.Layer,{____init:function ____init(config){this.nodeType='Layer';this.canvas=new Konva.SceneCanvas();this.hitCanvas=new Konva.HitCanvas({pixelRatio:1});// call super constructor
Konva.BaseLayer.call(this,config);},_setCanvasSize:function _setCanvasSize(width,height){this.canvas.setSize(width,height);this.hitCanvas.setSize(width,height);},_validateAdd:function _validateAdd(child){var type=child.getType();if(type!=='Group'&&type!=='Shape'){Konva.Util.throw('You may only add groups and shapes to a layer.');}},/**
     * get visible intersection shape. This is the preferred
     * method for determining if a point intersects a shape or not
     * also you may pass optional selector parametr to return ancestor of intersected shape
     * @method
     * @memberof Konva.Layer.prototype
     * @param {Object} pos
     * @param {Number} pos.x
     * @param {Number} pos.y
     * @param {String} [selector]
     * @returns {Konva.Node}
     * @example
     * var shape = layer.getIntersection({x: 50, y: 50});
     * // or if you interested in shape parent:
     * var group = layer.getIntersection({x: 50, y: 50}, 'Group');
     */getIntersection:function getIntersection(pos,selector){var obj,i,intersectionOffset,shape;if(!this.hitGraphEnabled()||!this.isVisible()){return null;}// in some cases antialiased area may be bigger than 1px
// it is possible if we will cache node, then scale it a lot
// TODO: check { 0; 0 } point before loop, and remove it from INTERSECTION_OFFSETS.
var spiralSearchDistance=1;var continueSearch=false;while(true){for(i=0;i<INTERSECTION_OFFSETS_LEN;i++){intersectionOffset=INTERSECTION_OFFSETS[i];obj=this._getIntersection({x:pos.x+intersectionOffset.x*spiralSearchDistance,y:pos.y+intersectionOffset.y*spiralSearchDistance});shape=obj.shape;if(shape&&selector){return shape.findAncestor(selector,true);}else if(shape){return shape;}// we should continue search if we found antialiased pixel
// that means our node somewhere very close
continueSearch=!!obj.antialiased;// stop search if found empty pixel
if(!obj.antialiased){break;}}// if no shape, and no antialiased pixel, we should end searching
if(continueSearch){spiralSearchDistance+=1;}else{return null;}}},_getImageData:function _getImageData(x,y){var width=this.hitCanvas.width||1,height=this.hitCanvas.height||1,index=Math.round(y)*width+Math.round(x);if(!this._hitImageData){this._hitImageData=this.hitCanvas.context.getImageData(0,0,width,height);}return[this._hitImageData.data[4*index+0],// Red
this._hitImageData.data[4*index+1],// Green
this._hitImageData.data[4*index+2],// Blue
this._hitImageData.data[4*index+3]// Alpha
];},_getIntersection:function _getIntersection(pos){var ratio=this.hitCanvas.pixelRatio;var p=this.hitCanvas.context.getImageData(Math.round(pos.x*ratio),Math.round(pos.y*ratio),1,1).data,p3=p[3],colorKey,shape;// fully opaque pixel
if(p3===255){colorKey=Konva.Util._rgbToHex(p[0],p[1],p[2]);shape=Konva.shapes[HASH+colorKey];if(shape){return{shape:shape};}return{antialiased:true};}else if(p3>0){// antialiased pixel
return{antialiased:true};}// empty pixel
return{};},drawScene:function drawScene(can,top){var layer=this.getLayer(),canvas=can||layer&&layer.getCanvas();this._fire(BEFORE_DRAW,{node:this});if(this.getClearBeforeDraw()){canvas.getContext().clear();}Konva.Container.prototype.drawScene.call(this,canvas,top);this._fire(DRAW,{node:this});return this;},drawHit:function drawHit(can,top){var layer=this.getLayer(),canvas=can||layer&&layer.hitCanvas;if(layer&&layer.getClearBeforeDraw()){layer.getHitCanvas().getContext().clear();}Konva.Container.prototype.drawHit.call(this,canvas,top);this.imageData=null;// Clear imageData cache
return this;},clear:function clear(bounds){Konva.BaseLayer.prototype.clear.call(this,bounds);this.getHitCanvas().getContext().clear(bounds);this.imageData=null;// Clear getImageData cache
return this;},// extend Node.prototype.setVisible
setVisible:function setVisible(visible){Konva.Node.prototype.setVisible.call(this,visible);if(visible){this.getCanvas()._canvas.style.display='block';this.hitCanvas._canvas.style.display='block';}else{this.getCanvas()._canvas.style.display='none';this.hitCanvas._canvas.style.display='none';}return this;},/**
     * enable hit graph
     * @name enableHitGraph
     * @method
     * @memberof Konva.Layer.prototype
     * @returns {Layer}
     */enableHitGraph:function enableHitGraph(){this.setHitGraphEnabled(true);return this;},/**
     * disable hit graph
     * @name disableHitGraph
     * @method
     * @memberof Konva.Layer.prototype
     * @returns {Layer}
     */disableHitGraph:function disableHitGraph(){this.setHitGraphEnabled(false);return this;},setSize:function setSize(width,height){Konva.BaseLayer.prototype.setSize.call(this,width,height);this.hitCanvas.setSize(width,height);return this;}});Konva.Util.extend(Konva.Layer,Konva.BaseLayer);Konva.Factory.addGetterSetter(Konva.Layer,'hitGraphEnabled',true);/**
   * get/set hitGraphEnabled flag.  Disabling the hit graph will greatly increase
   *  draw performance because the hit graph will not be redrawn each time the layer is
   *  drawn.  This, however, also disables mouse/touch event detection
   * @name hitGraphEnabled
   * @method
   * @memberof Konva.Layer.prototype
   * @param {Boolean} enabled
   * @returns {Boolean}
   * @example
   * // get hitGraphEnabled flag
   * var hitGraphEnabled = layer.hitGraphEnabled();
   *
   * // disable hit graph
   * layer.hitGraphEnabled(false);
   *
   * // enable hit graph
   * layer.hitGraphEnabled(true);
   */Konva.Collection.mapMethods(Konva.Layer);})();(function(){'use strict';/**
   * FastLayer constructor. Layers are tied to their own canvas element and are used
   * to contain shapes only.  If you don't need node nesting, mouse and touch interactions,
   * or event pub/sub, you should use FastLayer instead of Layer to create your layers.
   * It renders about 2x faster than normal layers.
   * @constructor
   * @memberof Konva
   * @augments Konva.BaseLayer
   * @param {Object} config
   * @param {Boolean} [config.clearBeforeDraw] set this property to false if you don't want
   * to clear the canvas before each layer draw.  The default value is true.
   * @param {Boolean} [config.visible]
   * @param {String} [config.id] unique id
   * @param {String} [config.name] non-unique name
   * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
   * * @param {Object} [config.clip] set clip
     * @param {Number} [config.clipX] set clip x
     * @param {Number} [config.clipY] set clip y
     * @param {Number} [config.clipWidth] set clip width
     * @param {Number} [config.clipHeight] set clip height
     * @param {Function} [config.clipFunc] set clip func

   * @example
   * var layer = new Konva.FastLayer();
   */Konva.FastLayer=function(config){this.____init(config);};Konva.Util.addMethods(Konva.FastLayer,{____init:function ____init(config){this.nodeType='Layer';this.canvas=new Konva.SceneCanvas();// call super constructor
Konva.BaseLayer.call(this,config);},_validateAdd:function _validateAdd(child){var type=child.getType();if(type!=='Shape'){Konva.Util.throw('You may only add shapes to a fast layer.');}},_setCanvasSize:function _setCanvasSize(width,height){this.canvas.setSize(width,height);},hitGraphEnabled:function hitGraphEnabled(){return false;},getIntersection:function getIntersection(){return null;},drawScene:function drawScene(can){var layer=this.getLayer(),canvas=can||layer&&layer.getCanvas();if(this.getClearBeforeDraw()){canvas.getContext().clear();}Konva.Container.prototype.drawScene.call(this,canvas);return this;},draw:function draw(){this.drawScene();return this;},// extend Node.prototype.setVisible
setVisible:function setVisible(visible){Konva.Node.prototype.setVisible.call(this,visible);if(visible){this.getCanvas()._canvas.style.display='block';}else{this.getCanvas()._canvas.style.display='none';}return this;}});Konva.Util.extend(Konva.FastLayer,Konva.BaseLayer);Konva.Collection.mapMethods(Konva.FastLayer);})();(function(){'use strict';/**
   * Group constructor.  Groups are used to contain shapes or other groups.
   * @constructor
   * @memberof Konva
   * @augments Konva.Container
   * @param {Object} config
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * * @param {Object} [config.clip] set clip
     * @param {Number} [config.clipX] set clip x
     * @param {Number} [config.clipY] set clip y
     * @param {Number} [config.clipWidth] set clip width
     * @param {Number} [config.clipHeight] set clip height
     * @param {Function} [config.clipFunc] set clip func

   * @example
   * var group = new Konva.Group();
   */Konva.Group=function(config){this.___init(config);};Konva.Util.addMethods(Konva.Group,{___init:function ___init(config){this.nodeType='Group';// call super constructor
Konva.Container.call(this,config);},_validateAdd:function _validateAdd(child){var type=child.getType();if(type!=='Group'&&type!=='Shape'){Konva.Util.throw('You may only add groups and shapes to groups.');}}});Konva.Util.extend(Konva.Group,Konva.Container);Konva.Collection.mapMethods(Konva.Group);})();(function(Konva){'use strict';var now=function(){if(Konva.global.performance&&Konva.global.performance.now){return function(){return Konva.global.performance.now();};}return function(){return new Date().getTime();};}();function FRAF(callback){setTimeout(callback,1000/60);}var RAF=function(){return Konva.global.requestAnimationFrame||Konva.global.webkitRequestAnimationFrame||Konva.global.mozRequestAnimationFrame||Konva.global.oRequestAnimationFrame||Konva.global.msRequestAnimationFrame||FRAF;}();function requestAnimFrame(){return RAF.apply(Konva.global,arguments);}/**
   * Animation constructor.  A stage is used to contain multiple layers and handle
   * @constructor
   * @memberof Konva
   * @param {Function} func function executed on each animation frame.  The function is passed a frame object, which contains
   *  timeDiff, lastTime, time, and frameRate properties.  The timeDiff property is the number of milliseconds that have passed
   *  since the last animation frame.  The lastTime property is time in milliseconds that elapsed from the moment the animation started
   *  to the last animation frame.  The time property is the time in milliseconds that ellapsed from the moment the animation started
   *  to the current animation frame.  The frameRate property is the current frame rate in frames / second. Return false from function,
   *  if you don't need to redraw layer/layers on some frames.
   * @param {Konva.Layer|Array} [layers] layer(s) to be redrawn on each animation frame. Can be a layer, an array of layers, or null.
   *  Not specifying a node will result in no redraw.
   * @example
   * // move a node to the right at 50 pixels / second
   * var velocity = 50;
   *
   * var anim = new Konva.Animation(function(frame) {
   *   var dist = velocity * (frame.timeDiff / 1000);
   *   node.move(dist, 0);
   * }, layer);
   *
   * anim.start();
   */Konva.Animation=function(func,layers){var Anim=Konva.Animation;this.func=func;this.setLayers(layers);this.id=Anim.animIdCounter++;this.frame={time:0,timeDiff:0,lastTime:now()};};/*
     * Animation methods
     */Konva.Animation.prototype={/**
     * set layers to be redrawn on each animation frame
     * @method
     * @memberof Konva.Animation.prototype
     * @param {Konva.Layer|Array} [layers] layer(s) to be redrawn.&nbsp; Can be a layer, an array of layers, or null.  Not specifying a node will result in no redraw.
     * @return {Konva.Animation} this
     */setLayers:function setLayers(layers){var lays=[];// if passing in no layers
if(!layers){lays=[];}else if(layers.length>0){// if passing in an array of Layers
// NOTE: layers could be an array or Konva.Collection.  for simplicity, I'm just inspecting
// the length property to check for both cases
lays=layers;}else{// if passing in a Layer
lays=[layers];}this.layers=lays;return this;},/**
     * get layers
     * @method
     * @memberof Konva.Animation.prototype
     * @return {Array} Array of Konva.Layer
     */getLayers:function getLayers(){return this.layers;},/**
     * add layer.  Returns true if the layer was added, and false if it was not
     * @method
     * @memberof Konva.Animation.prototype
     * @param {Konva.Layer} layer to add
     * @return {Bool} true if layer is added to animation, otherwise false
     */addLayer:function addLayer(layer){var layers=this.layers,len=layers.length,n;// don't add the layer if it already exists
for(n=0;n<len;n++){if(layers[n]._id===layer._id){return false;}}this.layers.push(layer);return true;},/**
     * determine if animation is running or not.  returns true or false
     * @method
     * @memberof Konva.Animation.prototype
     * @return {Bool} is animation running?
     */isRunning:function isRunning(){var a=Konva.Animation,animations=a.animations,len=animations.length,n;for(n=0;n<len;n++){if(animations[n].id===this.id){return true;}}return false;},/**
     * start animation
     * @method
     * @memberof Konva.Animation.prototype
     * @return {Konva.Animation} this
     */start:function start(){var Anim=Konva.Animation;this.stop();this.frame.timeDiff=0;this.frame.lastTime=now();Anim._addAnimation(this);return this;},/**
     * stop animation
     * @method
     * @memberof Konva.Animation.prototype
     * @return {Konva.Animation} this
     */stop:function stop(){Konva.Animation._removeAnimation(this);return this;},_updateFrameObject:function _updateFrameObject(time){this.frame.timeDiff=time-this.frame.lastTime;this.frame.lastTime=time;this.frame.time+=this.frame.timeDiff;this.frame.frameRate=1000/this.frame.timeDiff;}};Konva.Animation.animations=[];Konva.Animation.animIdCounter=0;Konva.Animation.animRunning=false;Konva.Animation._addAnimation=function(anim){this.animations.push(anim);this._handleAnimation();};Konva.Animation._removeAnimation=function(anim){var id=anim.id,animations=this.animations,len=animations.length,n;for(n=0;n<len;n++){if(animations[n].id===id){this.animations.splice(n,1);break;}}};Konva.Animation._runFrames=function(){var layerHash={},animations=this.animations,anim,layers,func,n,i,layersLen,layer,key,needRedraw;/*
         * loop through all animations and execute animation
         *  function.  if the animation object has specified node,
         *  we can add the node to the nodes hash to eliminate
         *  drawing the same node multiple times.  The node property
         *  can be the stage itself or a layer
         *//*
         * WARNING: don't cache animations.length because it could change while
         * the for loop is running, causing a JS error
         */for(n=0;n<animations.length;n++){anim=animations[n];layers=anim.layers;func=anim.func;anim._updateFrameObject(now());layersLen=layers.length;// if animation object has a function, execute it
if(func){// allow anim bypassing drawing
needRedraw=func.call(anim,anim.frame)!==false;}else{needRedraw=true;}if(!needRedraw){continue;}for(i=0;i<layersLen;i++){layer=layers[i];if(layer._id!==undefined){layerHash[layer._id]=layer;}}}for(key in layerHash){if(!layerHash.hasOwnProperty(key)){continue;}layerHash[key].draw();}};Konva.Animation._animationLoop=function(){var Anim=Konva.Animation;if(Anim.animations.length){Anim._runFrames();requestAnimFrame(Anim._animationLoop);}else{Anim.animRunning=false;}};Konva.Animation._handleAnimation=function(){if(!this.animRunning){this.animRunning=true;requestAnimFrame(this._animationLoop);}};/**
   * batch draw. this function will not do immediate draw
   * but it will schedule drawing to next tick (requestAnimFrame)
   * @method
   * @return {Konva.Layer} this
   * @memberof Konva.Base.prototype
   */Konva.BaseLayer.prototype.batchDraw=function(){var that=this,Anim=Konva.Animation;if(!this.batchAnim){this.batchAnim=new Anim(function(){// stop animation after first tick
that.batchAnim.stop();},this);}if(!this.batchAnim.isRunning()){this.batchAnim.start();}return this;};/**
   * batch draw
   * @method
   * @return {Konva.Stage} this
   * @memberof Konva.Stage.prototype
   */Konva.Stage.prototype.batchDraw=function(){this.getChildren().each(function(layer){layer.batchDraw();});return this;};})(Konva);(function(){'use strict';var blacklist={node:1,duration:1,easing:1,onFinish:1,yoyo:1},PAUSED=1,PLAYING=2,REVERSING=3,idCounter=0,colorAttrs=['fill','stroke','shadowColor'];var Tween=function Tween(prop,propFunc,func,begin,finish,duration,yoyo){this.prop=prop;this.propFunc=propFunc;this.begin=begin;this._pos=begin;this.duration=duration;this._change=0;this.prevPos=0;this.yoyo=yoyo;this._time=0;this._position=0;this._startTime=0;this._finish=0;this.func=func;this._change=finish-this.begin;this.pause();};/*
     * Tween methods
     */Tween.prototype={fire:function fire(str){var handler=this[str];if(handler){handler();}},setTime:function setTime(t){if(t>this.duration){if(this.yoyo){this._time=this.duration;this.reverse();}else{this.finish();}}else if(t<0){if(this.yoyo){this._time=0;this.play();}else{this.reset();}}else{this._time=t;this.update();}},getTime:function getTime(){return this._time;},setPosition:function setPosition(p){this.prevPos=this._pos;this.propFunc(p);this._pos=p;},getPosition:function getPosition(t){if(t===undefined){t=this._time;}return this.func(t,this.begin,this._change,this.duration);},play:function play(){this.state=PLAYING;this._startTime=this.getTimer()-this._time;this.onEnterFrame();this.fire('onPlay');},reverse:function reverse(){this.state=REVERSING;this._time=this.duration-this._time;this._startTime=this.getTimer()-this._time;this.onEnterFrame();this.fire('onReverse');},seek:function seek(t){this.pause();this._time=t;this.update();this.fire('onSeek');},reset:function reset(){this.pause();this._time=0;this.update();this.fire('onReset');},finish:function finish(){this.pause();this._time=this.duration;this.update();this.fire('onFinish');},update:function update(){this.setPosition(this.getPosition(this._time));},onEnterFrame:function onEnterFrame(){var t=this.getTimer()-this._startTime;if(this.state===PLAYING){this.setTime(t);}else if(this.state===REVERSING){this.setTime(this.duration-t);}},pause:function pause(){this.state=PAUSED;this.fire('onPause');},getTimer:function getTimer(){return new Date().getTime();}};/**
   * Tween constructor.  Tweens enable you to animate a node between the current state and a new state.
   *  You can play, pause, reverse, seek, reset, and finish tweens.  By default, tweens are animated using
   *  a linear easing.  For more tweening options, check out {@link Konva.Easings}
   * @constructor
   * @memberof Konva
   * @example
   * // instantiate new tween which fully rotates a node in 1 second
   * var tween = new Konva.Tween({
   *   node: node,
   *   rotationDeg: 360,
   *   duration: 1,
   *   easing: Konva.Easings.EaseInOut
   * });
   *
   * // play tween
   * tween.play();
   *
   * // pause tween
   * tween.pause();
   */Konva.Tween=function(config){var that=this,node=config.node,nodeId=node._id,duration,easing=config.easing||Konva.Easings.Linear,yoyo=!!config.yoyo,key;if(typeof config.duration==='undefined'){duration=0.3;}else if(config.duration===0){// zero is bad value for duration
duration=0.001;}else{duration=config.duration;}this.node=node;this._id=idCounter++;var layers=node.getLayer()||(node instanceof Konva.Stage?node.getLayers():null);if(!layers){Konva.Util.error('Tween constructor have `node` that is not in a layer. Please add node into layer first.');}this.anim=new Konva.Animation(function(){that.tween.onEnterFrame();},layers);this.tween=new Tween(key,function(i){that._tweenFunc(i);},easing,0,1,duration*1000,yoyo);this._addListeners();// init attrs map
if(!Konva.Tween.attrs[nodeId]){Konva.Tween.attrs[nodeId]={};}if(!Konva.Tween.attrs[nodeId][this._id]){Konva.Tween.attrs[nodeId][this._id]={};}// init tweens map
if(!Konva.Tween.tweens[nodeId]){Konva.Tween.tweens[nodeId]={};}for(key in config){if(blacklist[key]===undefined){this._addAttr(key,config[key]);}}this.reset();// callbacks
this.onFinish=config.onFinish;this.onReset=config.onReset;};// start/diff object = attrs.nodeId.tweenId.attr
Konva.Tween.attrs={};// tweenId = tweens.nodeId.attr
Konva.Tween.tweens={};Konva.Tween.prototype={_addAttr:function _addAttr(key,end){var node=this.node,nodeId=node._id,start,diff,tweenId,n,len,trueEnd,trueStart,endRGBA;// remove conflict from tween map if it exists
tweenId=Konva.Tween.tweens[nodeId][key];if(tweenId){delete Konva.Tween.attrs[nodeId][tweenId][key];}// add to tween map
start=node.getAttr(key);if(Konva.Util._isArray(end)){diff=[];len=Math.max(end.length,start.length);if(key==='points'&&end.length!==start.length){// before tweening points we need to make sure that start.length === end.length
// Konva.Util._prepareArrayForTween thinking that end.length > start.length
if(end.length>start.length){// so in this case we will increase number of starting points
trueStart=start;start=Konva.Util._prepareArrayForTween(start,end,node.closed());}else{// in this case we will increase number of eding points
trueEnd=end;end=Konva.Util._prepareArrayForTween(end,start,node.closed());}}if(key.indexOf('fill')===0){for(n=0;n<len;n++){if(n%2===0){diff.push(end[n]-start[n]);}else{var startRGBA=Konva.Util.colorToRGBA(start[n]);endRGBA=Konva.Util.colorToRGBA(end[n]);start[n]=startRGBA;diff.push({r:endRGBA.r-startRGBA.r,g:endRGBA.g-startRGBA.g,b:endRGBA.b-startRGBA.b,a:endRGBA.a-startRGBA.a});}}}else{for(n=0;n<len;n++){diff.push(end[n]-start[n]);}}}else if(colorAttrs.indexOf(key)!==-1){start=Konva.Util.colorToRGBA(start);endRGBA=Konva.Util.colorToRGBA(end);diff={r:endRGBA.r-start.r,g:endRGBA.g-start.g,b:endRGBA.b-start.b,a:endRGBA.a-start.a};}else{diff=end-start;}Konva.Tween.attrs[nodeId][this._id][key]={start:start,diff:diff,end:end,trueEnd:trueEnd,trueStart:trueStart};Konva.Tween.tweens[nodeId][key]=this._id;},_tweenFunc:function _tweenFunc(i){var node=this.node,attrs=Konva.Tween.attrs[node._id][this._id],key,attr,start,diff,newVal,n,len,end;for(key in attrs){attr=attrs[key];start=attr.start;diff=attr.diff;end=attr.end;if(Konva.Util._isArray(start)){newVal=[];len=Math.max(start.length,end.length);if(key.indexOf('fill')===0){for(n=0;n<len;n++){if(n%2===0){newVal.push((start[n]||0)+diff[n]*i);}else{newVal.push('rgba('+Math.round(start[n].r+diff[n].r*i)+','+Math.round(start[n].g+diff[n].g*i)+','+Math.round(start[n].b+diff[n].b*i)+','+(start[n].a+diff[n].a*i)+')');}}}else{for(n=0;n<len;n++){newVal.push((start[n]||0)+diff[n]*i);}}}else if(colorAttrs.indexOf(key)!==-1){newVal='rgba('+Math.round(start.r+diff.r*i)+','+Math.round(start.g+diff.g*i)+','+Math.round(start.b+diff.b*i)+','+(start.a+diff.a*i)+')';}else{newVal=start+diff*i;}node.setAttr(key,newVal);}},_addListeners:function _addListeners(){var that=this;// start listeners
this.tween.onPlay=function(){that.anim.start();};this.tween.onReverse=function(){that.anim.start();};// stop listeners
this.tween.onPause=function(){that.anim.stop();};this.tween.onFinish=function(){var node=that.node;// after tweening  points of line we need to set original end
var attrs=Konva.Tween.attrs[node._id][that._id];if(attrs.points&&attrs.points.trueEnd){node.points(attrs.points.trueEnd);}if(that.onFinish){that.onFinish.call(that);}};this.tween.onReset=function(){var node=that.node;// after tweening  points of line we need to set original start
var attrs=Konva.Tween.attrs[node._id][that._id];if(attrs.points&&attrs.points.trueStart){node.points(attrs.points.trueStart);}if(that.onReset){that.onReset();}};},/**
     * play
     * @method
     * @memberof Konva.Tween.prototype
     * @returns {Tween}
     */play:function play(){this.tween.play();return this;},/**
     * reverse
     * @method
     * @memberof Konva.Tween.prototype
     * @returns {Tween}
     */reverse:function reverse(){this.tween.reverse();return this;},/**
     * reset
     * @method
     * @memberof Konva.Tween.prototype
     * @returns {Tween}
     */reset:function reset(){this.tween.reset();return this;},/**
     * seek
     * @method
     * @memberof Konva.Tween.prototype
     * @param {Integer} t time in seconds between 0 and the duration
     * @returns {Tween}
     */seek:function seek(t){this.tween.seek(t*1000);return this;},/**
     * pause
     * @method
     * @memberof Konva.Tween.prototype
     * @returns {Tween}
     */pause:function pause(){this.tween.pause();return this;},/**
     * finish
     * @method
     * @memberof Konva.Tween.prototype
     * @returns {Tween}
     */finish:function finish(){this.tween.finish();return this;},/**
     * destroy
     * @method
     * @memberof Konva.Tween.prototype
     */destroy:function destroy(){var nodeId=this.node._id,thisId=this._id,attrs=Konva.Tween.tweens[nodeId],key;this.pause();for(key in attrs){delete Konva.Tween.tweens[nodeId][key];}delete Konva.Tween.attrs[nodeId][thisId];}};/**
   * Tween node properties. Shorter usage of {@link Konva.Tween} object.
   *
   * @method Konva.Node#to
   * @memberof Konva.Node
   * @param {Object} [params] tween params
   * @example
   *
   * circle.to({
   *  x : 50,
   *  duration : 0.5
   * });
   */Konva.Node.prototype.to=function(params){var onFinish=params.onFinish;params.node=this;params.onFinish=function(){this.destroy();if(onFinish){onFinish();}};var tween=new Konva.Tween(params);tween.play();};/*
    * These eases were ported from an Adobe Flash tweening library to JavaScript
    * by Xaric
    *//**
   * @namespace Easings
   * @memberof Konva
   */Konva.Easings={/**
     * back ease in
     * @function
     * @memberof Konva.Easings
     */BackEaseIn:function BackEaseIn(t,b,c,d){var s=1.70158;return c*(t/=d)*t*((s+1)*t-s)+b;},/**
     * back ease out
     * @function
     * @memberof Konva.Easings
     */BackEaseOut:function BackEaseOut(t,b,c,d){var s=1.70158;return c*((t=t/d-1)*t*((s+1)*t+s)+1)+b;},/**
     * back ease in out
     * @function
     * @memberof Konva.Easings
     */BackEaseInOut:function BackEaseInOut(t,b,c,d){var s=1.70158;if((t/=d/2)<1){return c/2*(t*t*(((s*=1.525)+1)*t-s))+b;}return c/2*((t-=2)*t*(((s*=1.525)+1)*t+s)+2)+b;},/**
     * elastic ease in
     * @function
     * @memberof Konva.Easings
     */ElasticEaseIn:function ElasticEaseIn(t,b,c,d,a,p){// added s = 0
var s=0;if(t===0){return b;}if((t/=d)===1){return b+c;}if(!p){p=d*0.3;}if(!a||a<Math.abs(c)){a=c;s=p/4;}else{s=p/(2*Math.PI)*Math.asin(c/a);}return-(a*Math.pow(2,10*(t-=1))*Math.sin((t*d-s)*(2*Math.PI)/p))+b;},/**
     * elastic ease out
     * @function
     * @memberof Konva.Easings
     */ElasticEaseOut:function ElasticEaseOut(t,b,c,d,a,p){// added s = 0
var s=0;if(t===0){return b;}if((t/=d)===1){return b+c;}if(!p){p=d*0.3;}if(!a||a<Math.abs(c)){a=c;s=p/4;}else{s=p/(2*Math.PI)*Math.asin(c/a);}return a*Math.pow(2,-10*t)*Math.sin((t*d-s)*(2*Math.PI)/p)+c+b;},/**
     * elastic ease in out
     * @function
     * @memberof Konva.Easings
     */ElasticEaseInOut:function ElasticEaseInOut(t,b,c,d,a,p){// added s = 0
var s=0;if(t===0){return b;}if((t/=d/2)===2){return b+c;}if(!p){p=d*(0.3*1.5);}if(!a||a<Math.abs(c)){a=c;s=p/4;}else{s=p/(2*Math.PI)*Math.asin(c/a);}if(t<1){return-0.5*(a*Math.pow(2,10*(t-=1))*Math.sin((t*d-s)*(2*Math.PI)/p))+b;}return a*Math.pow(2,-10*(t-=1))*Math.sin((t*d-s)*(2*Math.PI)/p)*0.5+c+b;},/**
     * bounce ease out
     * @function
     * @memberof Konva.Easings
     */BounceEaseOut:function BounceEaseOut(t,b,c,d){if((t/=d)<1/2.75){return c*(7.5625*t*t)+b;}else if(t<2/2.75){return c*(7.5625*(t-=1.5/2.75)*t+0.75)+b;}else if(t<2.5/2.75){return c*(7.5625*(t-=2.25/2.75)*t+0.9375)+b;}else{return c*(7.5625*(t-=2.625/2.75)*t+0.984375)+b;}},/**
     * bounce ease in
     * @function
     * @memberof Konva.Easings
     */BounceEaseIn:function BounceEaseIn(t,b,c,d){return c-Konva.Easings.BounceEaseOut(d-t,0,c,d)+b;},/**
     * bounce ease in out
     * @function
     * @memberof Konva.Easings
     */BounceEaseInOut:function BounceEaseInOut(t,b,c,d){if(t<d/2){return Konva.Easings.BounceEaseIn(t*2,0,c,d)*0.5+b;}else{return Konva.Easings.BounceEaseOut(t*2-d,0,c,d)*0.5+c*0.5+b;}},/**
     * ease in
     * @function
     * @memberof Konva.Easings
     */EaseIn:function EaseIn(t,b,c,d){return c*(t/=d)*t+b;},/**
     * ease out
     * @function
     * @memberof Konva.Easings
     */EaseOut:function EaseOut(t,b,c,d){return-c*(t/=d)*(t-2)+b;},/**
     * ease in out
     * @function
     * @memberof Konva.Easings
     */EaseInOut:function EaseInOut(t,b,c,d){if((t/=d/2)<1){return c/2*t*t+b;}return-c/2*(--t*(t-2)-1)+b;},/**
     * strong ease in
     * @function
     * @memberof Konva.Easings
     */StrongEaseIn:function StrongEaseIn(t,b,c,d){return c*(t/=d)*t*t*t*t+b;},/**
     * strong ease out
     * @function
     * @memberof Konva.Easings
     */StrongEaseOut:function StrongEaseOut(t,b,c,d){return c*((t=t/d-1)*t*t*t*t+1)+b;},/**
     * strong ease in out
     * @function
     * @memberof Konva.Easings
     */StrongEaseInOut:function StrongEaseInOut(t,b,c,d){if((t/=d/2)<1){return c/2*t*t*t*t*t+b;}return c/2*((t-=2)*t*t*t*t+2)+b;},/**
     * linear
     * @function
     * @memberof Konva.Easings
     */Linear:function Linear(t,b,c,d){return c*t/d+b;}};})();(function(){'use strict';Konva.DD={// properties
anim:new Konva.Animation(function(){var b=this.dirty;this.dirty=false;return b;}),isDragging:false,justDragged:false,offset:{x:0,y:0},node:null,// methods
_drag:function _drag(evt){var dd=Konva.DD,node=dd.node;if(node){if(!dd.isDragging){var pos=node.getStage().getPointerPosition();// it is possible that pos is undefined
// reattach it
if(!pos){node.getStage()._setPointerPosition(evt);pos=node.getStage().getPointerPosition();}var dragDistance=node.dragDistance();var distance=Math.max(Math.abs(pos.x-dd.startPointerPos.x),Math.abs(pos.y-dd.startPointerPos.y));if(distance<dragDistance){return;}}node.getStage()._setPointerPosition(evt);if(!dd.isDragging){dd.isDragging=true;node.fire('dragstart',{type:'dragstart',target:node,evt:evt},true);// a user can stop dragging inside `dragstart`
if(!node.isDragging()){return;}}node._setDragPosition(evt);// execute ondragmove if defined
node.fire('dragmove',{type:'dragmove',target:node,evt:evt},true);}},_endDragBefore:function _endDragBefore(evt){var dd=Konva.DD,node=dd.node,layer;if(node){layer=node.getLayer();dd.anim.stop();// only fire dragend event if the drag and drop
// operation actually started.
if(dd.isDragging){dd.isDragging=false;dd.justDragged=true;Konva.listenClickTap=false;if(evt){evt.dragEndNode=node;}}delete dd.node;if(node.getLayer()||layer||node instanceof Konva.Stage){(layer||node).draw();}}},_endDragAfter:function _endDragAfter(evt){evt=evt||{};var dragEndNode=evt.dragEndNode;if(evt&&dragEndNode){dragEndNode.fire('dragend',{type:'dragend',target:dragEndNode,evt:evt},true);}}};// Node extenders
/**
   * initiate drag and drop
   * @method
   * @memberof Konva.Node.prototype
   */Konva.Node.prototype.startDrag=function(){var dd=Konva.DD,stage=this.getStage(),layer=this.getLayer(),pos=stage.getPointerPosition(),ap=this.getAbsolutePosition();if(pos){if(dd.node){dd.node.stopDrag();}dd.node=this;dd.startPointerPos=pos;dd.offset.x=pos.x-ap.x;dd.offset.y=pos.y-ap.y;dd.anim.setLayers(layer||this.getLayers());dd.anim.start();this._setDragPosition();}};Konva.Node.prototype._setDragPosition=function(evt){var dd=Konva.DD,pos=this.getStage().getPointerPosition(),dbf=this.getDragBoundFunc();if(!pos){return;}var newNodePos={x:pos.x-dd.offset.x,y:pos.y-dd.offset.y};if(dbf!==undefined){newNodePos=dbf.call(this,newNodePos,evt);}this.setAbsolutePosition(newNodePos);if(!this._lastPos||this._lastPos.x!==newNodePos.x||this._lastPos.y!==newNodePos.y){dd.anim.dirty=true;}this._lastPos=newNodePos;};/**
   * stop drag and drop
   * @method
   * @memberof Konva.Node.prototype
   */Konva.Node.prototype.stopDrag=function(){var dd=Konva.DD,evt={};dd._endDragBefore(evt);dd._endDragAfter(evt);};Konva.Node.prototype.setDraggable=function(draggable){this._setAttr('draggable',draggable);this._dragChange();};var origRemove=Konva.Node.prototype.remove;Konva.Node.prototype.__originalRemove=origRemove;Konva.Node.prototype.remove=function(){var dd=Konva.DD;// stop DD
if(dd.node&&dd.node._id===this._id){this.stopDrag();}origRemove.call(this);};/**
   * determine if node is currently in drag and drop mode
   * @method
   * @memberof Konva.Node.prototype
   */Konva.Node.prototype.isDragging=function(){var dd=Konva.DD;return!!(dd.node&&dd.node._id===this._id&&dd.isDragging);};Konva.Node.prototype._listenDrag=function(){var that=this;this._dragCleanup();if(this.getClassName()==='Stage'){this.on('contentMousedown.konva contentTouchstart.konva',function(evt){if(!Konva.DD.node){that.startDrag(evt);}});}else{this.on('mousedown.konva touchstart.konva',function(evt){// ignore right and middle buttons
if(evt.evt.button===1||evt.evt.button===2){return;}if(!Konva.DD.node){that.startDrag(evt);}});}// listening is required for drag and drop
/*
        this._listeningEnabled = true;
        this._clearSelfAndAncestorCache('listeningEnabled');
        */};Konva.Node.prototype._dragChange=function(){if(this.attrs.draggable){this._listenDrag();}else{// remove event listeners
this._dragCleanup();/*
             * force drag and drop to end
             * if this node is currently in
             * drag and drop mode
             */var stage=this.getStage();var dd=Konva.DD;if(stage&&dd.node&&dd.node._id===this._id){dd.node.stopDrag();}}};Konva.Node.prototype._dragCleanup=function(){if(this.getClassName()==='Stage'){this.off('contentMousedown.konva');this.off('contentTouchstart.konva');}else{this.off('mousedown.konva');this.off('touchstart.konva');}};Konva.Factory.addGetterSetter(Konva.Node,'dragBoundFunc');/**
   * get/set drag bound function.  This is used to override the default
   *  drag and drop position.
   * @name dragBoundFunc
   * @method
   * @memberof Konva.Node.prototype
   * @param {Function} dragBoundFunc
   * @returns {Function}
   * @example
   * // get drag bound function
   * var dragBoundFunc = node.dragBoundFunc();
   *
   * // create vertical drag and drop
   * node.dragBoundFunc(function(pos){
   *   // important pos - is absolute position of the node
   *   // you should return absolute position too
   *   return {
   *     x: this.getAbsolutePosition().x,
   *     y: pos.y
   *   };
   * });
   */Konva.Factory.addGetter(Konva.Node,'draggable',false);Konva.Factory.addOverloadedGetterSetter(Konva.Node,'draggable');/**
   * get/set draggable flag
   * @name draggable
   * @method
   * @memberof Konva.Node.prototype
   * @param {Boolean} draggable
   * @returns {Boolean}
   * @example
   * // get draggable flag
   * var draggable = node.draggable();
   *
   * // enable drag and drop
   * node.draggable(true);
   *
   * // disable drag and drop
   * node.draggable(false);
   */if(Konva.isBrowser){window.addEventListener('mouseup',Konva.DD._endDragBefore,true);window.addEventListener('touchend',Konva.DD._endDragBefore,true);window.addEventListener('mousemove',Konva.DD._drag);window.addEventListener('touchmove',Konva.DD._drag);window.addEventListener('mouseup',Konva.DD._endDragAfter,false);window.addEventListener('touchend',Konva.DD._endDragAfter,false);}})();(function(){'use strict';/**
   * Rect constructor
   * @constructor
   * @memberof Konva
   * @augments Konva.Shape
   * @param {Object} config
   * @param {Number} [config.cornerRadius]
   * @param {String} [config.fill] fill color
     * @param {Image} [config.fillPatternImage] fill pattern image
     * @param {Number} [config.fillPatternX]
     * @param {Number} [config.fillPatternY]
     * @param {Object} [config.fillPatternOffset] object with x and y component
     * @param {Number} [config.fillPatternOffsetX] 
     * @param {Number} [config.fillPatternOffsetY] 
     * @param {Object} [config.fillPatternScale] object with x and y component
     * @param {Number} [config.fillPatternScaleX]
     * @param {Number} [config.fillPatternScaleY]
     * @param {Number} [config.fillPatternRotation]
     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientStartPointX]
     * @param {Number} [config.fillLinearGradientStartPointY]
     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientEndPointX]
     * @param {Number} [config.fillLinearGradientEndPointY]
     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientStartPointX]
     * @param {Number} [config.fillRadialGradientStartPointY]
     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientEndPointX] 
     * @param {Number} [config.fillRadialGradientEndPointY] 
     * @param {Number} [config.fillRadialGradientStartRadius]
     * @param {Number} [config.fillRadialGradientEndRadius]
     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
     * @param {String} [config.stroke] stroke color
     * @param {Number} [config.strokeWidth] stroke width
     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
     *  is miter
     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
     *  is butt
     * @param {String} [config.shadowColor]
     * @param {Number} [config.shadowBlur]
     * @param {Object} [config.shadowOffset] object with x and y component
     * @param {Number} [config.shadowOffsetX]
     * @param {Number} [config.shadowOffsetY]
     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
     *  between 0 and 1
     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
     * @param {Array} [config.dash]
     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * @example
   * var rect = new Konva.Rect({
   *   width: 100,
   *   height: 50,
   *   fill: 'red',
   *   stroke: 'black',
   *   strokeWidth: 5
   * });
   */Konva.Rect=function(config){this.___init(config);};Konva.Rect.prototype={___init:function ___init(config){Konva.Shape.call(this,config);this.className='Rect';this.sceneFunc(this._sceneFunc);},_sceneFunc:function _sceneFunc(context){var cornerRadius=this.getCornerRadius(),width=this.getWidth(),height=this.getHeight();context.beginPath();if(!cornerRadius){// simple rect - don't bother doing all that complicated maths stuff.
context.rect(0,0,width,height);}else{// arcTo would be nicer, but browser support is patchy (Opera)
cornerRadius=Math.min(cornerRadius,width/2,height/2);context.moveTo(cornerRadius,0);context.lineTo(width-cornerRadius,0);context.arc(width-cornerRadius,cornerRadius,cornerRadius,Math.PI*3/2,0,false);context.lineTo(width,height-cornerRadius);context.arc(width-cornerRadius,height-cornerRadius,cornerRadius,0,Math.PI/2,false);context.lineTo(cornerRadius,height);context.arc(cornerRadius,height-cornerRadius,cornerRadius,Math.PI/2,Math.PI,false);context.lineTo(0,cornerRadius);context.arc(cornerRadius,cornerRadius,cornerRadius,Math.PI,Math.PI*3/2,false);}context.closePath();context.fillStrokeShape(this);}};Konva.Util.extend(Konva.Rect,Konva.Shape);Konva.Factory.addGetterSetter(Konva.Rect,'cornerRadius',0,Konva.Validators.getNumberValidator());/**
   * get/set corner radius
   * @name cornerRadius
   * @method
   * @memberof Konva.Rect.prototype
   * @param {Number} cornerRadius
   * @returns {Number}
   * @example
   * // get corner radius
   * var cornerRadius = rect.cornerRadius();
   *
   * // set corner radius
   * rect.cornerRadius(10);
   */Konva.Collection.mapMethods(Konva.Rect);})();(function(Konva){'use strict';// the 0.0001 offset fixes a bug in Chrome 27
var PIx2=Math.PI*2-0.0001,CIRCLE='Circle';/**
   * Circle constructor
   * @constructor
   * @memberof Konva
   * @augments Konva.Shape
   * @param {Object} config
   * @param {Number} config.radius
   * @param {String} [config.fill] fill color
     * @param {Image} [config.fillPatternImage] fill pattern image
     * @param {Number} [config.fillPatternX]
     * @param {Number} [config.fillPatternY]
     * @param {Object} [config.fillPatternOffset] object with x and y component
     * @param {Number} [config.fillPatternOffsetX] 
     * @param {Number} [config.fillPatternOffsetY] 
     * @param {Object} [config.fillPatternScale] object with x and y component
     * @param {Number} [config.fillPatternScaleX]
     * @param {Number} [config.fillPatternScaleY]
     * @param {Number} [config.fillPatternRotation]
     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientStartPointX]
     * @param {Number} [config.fillLinearGradientStartPointY]
     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientEndPointX]
     * @param {Number} [config.fillLinearGradientEndPointY]
     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientStartPointX]
     * @param {Number} [config.fillRadialGradientStartPointY]
     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientEndPointX] 
     * @param {Number} [config.fillRadialGradientEndPointY] 
     * @param {Number} [config.fillRadialGradientStartRadius]
     * @param {Number} [config.fillRadialGradientEndRadius]
     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
     * @param {String} [config.stroke] stroke color
     * @param {Number} [config.strokeWidth] stroke width
     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
     *  is miter
     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
     *  is butt
     * @param {String} [config.shadowColor]
     * @param {Number} [config.shadowBlur]
     * @param {Object} [config.shadowOffset] object with x and y component
     * @param {Number} [config.shadowOffsetX]
     * @param {Number} [config.shadowOffsetY]
     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
     *  between 0 and 1
     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
     * @param {Array} [config.dash]
     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * @example
   * // create circle
   * var circle = new Konva.Circle({
   *   radius: 40,
   *   fill: 'red',
   *   stroke: 'black'
   *   strokeWidth: 5
   * });
   */Konva.Circle=function(config){this.___init(config);};Konva.Circle.prototype={_centroid:true,___init:function ___init(config){// call super constructor
Konva.Shape.call(this,config);this.className=CIRCLE;this.sceneFunc(this._sceneFunc);},_sceneFunc:function _sceneFunc(context){context.beginPath();context.arc(0,0,this.getRadius(),0,PIx2,false);context.closePath();context.fillStrokeShape(this);},// implements Shape.prototype.getWidth()
getWidth:function getWidth(){return this.getRadius()*2;},// implements Shape.prototype.getHeight()
getHeight:function getHeight(){return this.getRadius()*2;},// implements Shape.prototype.setWidth()
setWidth:function setWidth(width){Konva.Node.prototype.setWidth.call(this,width);if(this.radius()!==width/2){this.setRadius(width/2);}},// implements Shape.prototype.setHeight()
setHeight:function setHeight(height){Konva.Node.prototype.setHeight.call(this,height);if(this.radius()!==height/2){this.setRadius(height/2);}}};Konva.Util.extend(Konva.Circle,Konva.Shape);// add getters setters
Konva.Factory.addGetterSetter(Konva.Circle,'radius',0,Konva.Validators.getNumberValidator());Konva.Factory.addOverloadedGetterSetter(Konva.Circle,'radius');/**
   * get/set radius
   * @name radius
   * @method
   * @memberof Konva.Circle.prototype
   * @param {Number} radius
   * @returns {Number}
   * @example
   * // get radius
   * var radius = circle.radius();
   *
   * // set radius
   * circle.radius(10);
   */Konva.Collection.mapMethods(Konva.Circle);})(Konva);(function(){'use strict';// the 0.0001 offset fixes a bug in Chrome 27
var PIx2=Math.PI*2-0.0001,ELLIPSE='Ellipse';/**
   * Ellipse constructor
   * @constructor
   * @augments Konva.Shape
   * @param {Object} config
   * @param {Object} config.radius defines x and y radius
   * @param {String} [config.fill] fill color
     * @param {Image} [config.fillPatternImage] fill pattern image
     * @param {Number} [config.fillPatternX]
     * @param {Number} [config.fillPatternY]
     * @param {Object} [config.fillPatternOffset] object with x and y component
     * @param {Number} [config.fillPatternOffsetX] 
     * @param {Number} [config.fillPatternOffsetY] 
     * @param {Object} [config.fillPatternScale] object with x and y component
     * @param {Number} [config.fillPatternScaleX]
     * @param {Number} [config.fillPatternScaleY]
     * @param {Number} [config.fillPatternRotation]
     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientStartPointX]
     * @param {Number} [config.fillLinearGradientStartPointY]
     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientEndPointX]
     * @param {Number} [config.fillLinearGradientEndPointY]
     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientStartPointX]
     * @param {Number} [config.fillRadialGradientStartPointY]
     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientEndPointX] 
     * @param {Number} [config.fillRadialGradientEndPointY] 
     * @param {Number} [config.fillRadialGradientStartRadius]
     * @param {Number} [config.fillRadialGradientEndRadius]
     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
     * @param {String} [config.stroke] stroke color
     * @param {Number} [config.strokeWidth] stroke width
     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
     *  is miter
     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
     *  is butt
     * @param {String} [config.shadowColor]
     * @param {Number} [config.shadowBlur]
     * @param {Object} [config.shadowOffset] object with x and y component
     * @param {Number} [config.shadowOffsetX]
     * @param {Number} [config.shadowOffsetY]
     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
     *  between 0 and 1
     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
     * @param {Array} [config.dash]
     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * @example
   * var ellipse = new Konva.Ellipse({
   *   radius : {
   *     x : 50,
   *     y : 50
   *   },
   *   fill: 'red'
   * });
   */Konva.Ellipse=function(config){this.___init(config);};Konva.Ellipse.prototype={_centroid:true,___init:function ___init(config){// call super constructor
Konva.Shape.call(this,config);this.className=ELLIPSE;this.sceneFunc(this._sceneFunc);},_sceneFunc:function _sceneFunc(context){var rx=this.getRadiusX(),ry=this.getRadiusY();context.beginPath();context.save();if(rx!==ry){context.scale(1,ry/rx);}context.arc(0,0,rx,0,PIx2,false);context.restore();context.closePath();context.fillStrokeShape(this);},// implements Shape.prototype.getWidth()
getWidth:function getWidth(){return this.getRadiusX()*2;},// implements Shape.prototype.getHeight()
getHeight:function getHeight(){return this.getRadiusY()*2;},// implements Shape.prototype.setWidth()
setWidth:function setWidth(width){Konva.Node.prototype.setWidth.call(this,width);this.setRadius({x:width/2});},// implements Shape.prototype.setHeight()
setHeight:function setHeight(height){Konva.Node.prototype.setHeight.call(this,height);this.setRadius({y:height/2});}};Konva.Util.extend(Konva.Ellipse,Konva.Shape);// add getters setters
Konva.Factory.addComponentsGetterSetter(Konva.Ellipse,'radius',['x','y']);/**
   * get/set radius
   * @name radius
   * @method
   * @memberof Konva.Ellipse.prototype
   * @param {Object} radius
   * @param {Number} radius.x
   * @param {Number} radius.y
   * @returns {Object}
   * @example
   * // get radius
   * var radius = ellipse.radius();
   *
   * // set radius
   * ellipse.radius({
   *   x: 200,
   *   y: 100
   * });
   */Konva.Factory.addGetterSetter(Konva.Ellipse,'radiusX',0,Konva.Validators.getNumberValidator());/**
   * get/set radius x
   * @name radiusX
   * @method
   * @memberof Konva.Ellipse.prototype
   * @param {Number} x
   * @returns {Number}
   * @example
   * // get radius x
   * var radiusX = ellipse.radiusX();
   *
   * // set radius x
   * ellipse.radiusX(200);
   */Konva.Factory.addGetterSetter(Konva.Ellipse,'radiusY',0,Konva.Validators.getNumberValidator());/**
   * get/set radius y
   * @name radiusY
   * @method
   * @memberof Konva.Ellipse.prototype
   * @param {Number} y
   * @returns {Number}
   * @example
   * // get radius y
   * var radiusY = ellipse.radiusY();
   *
   * // set radius y
   * ellipse.radiusY(200);
   */Konva.Collection.mapMethods(Konva.Ellipse);})();(function(){'use strict';// the 0.0001 offset fixes a bug in Chrome 27
var PIx2=Math.PI*2-0.0001;/**
   * Ring constructor
   * @constructor
   * @augments Konva.Shape
   * @param {Object} config
   * @param {Number} config.innerRadius
   * @param {Number} config.outerRadius
   * @param {Boolean} [config.clockwise]
   * @param {String} [config.fill] fill color
     * @param {Image} [config.fillPatternImage] fill pattern image
     * @param {Number} [config.fillPatternX]
     * @param {Number} [config.fillPatternY]
     * @param {Object} [config.fillPatternOffset] object with x and y component
     * @param {Number} [config.fillPatternOffsetX] 
     * @param {Number} [config.fillPatternOffsetY] 
     * @param {Object} [config.fillPatternScale] object with x and y component
     * @param {Number} [config.fillPatternScaleX]
     * @param {Number} [config.fillPatternScaleY]
     * @param {Number} [config.fillPatternRotation]
     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientStartPointX]
     * @param {Number} [config.fillLinearGradientStartPointY]
     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientEndPointX]
     * @param {Number} [config.fillLinearGradientEndPointY]
     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientStartPointX]
     * @param {Number} [config.fillRadialGradientStartPointY]
     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientEndPointX] 
     * @param {Number} [config.fillRadialGradientEndPointY] 
     * @param {Number} [config.fillRadialGradientStartRadius]
     * @param {Number} [config.fillRadialGradientEndRadius]
     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
     * @param {String} [config.stroke] stroke color
     * @param {Number} [config.strokeWidth] stroke width
     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
     *  is miter
     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
     *  is butt
     * @param {String} [config.shadowColor]
     * @param {Number} [config.shadowBlur]
     * @param {Object} [config.shadowOffset] object with x and y component
     * @param {Number} [config.shadowOffsetX]
     * @param {Number} [config.shadowOffsetY]
     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
     *  between 0 and 1
     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
     * @param {Array} [config.dash]
     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * @example
   * var ring = new Konva.Ring({
   *   innerRadius: 40,
   *   outerRadius: 80,
   *   fill: 'red',
   *   stroke: 'black',
   *   strokeWidth: 5
   * });
   */Konva.Ring=function(config){this.___init(config);};Konva.Ring.prototype={_centroid:true,___init:function ___init(config){// call super constructor
Konva.Shape.call(this,config);this.className='Ring';this.sceneFunc(this._sceneFunc);},_sceneFunc:function _sceneFunc(context){context.beginPath();context.arc(0,0,this.getInnerRadius(),0,PIx2,false);context.moveTo(this.getOuterRadius(),0);context.arc(0,0,this.getOuterRadius(),PIx2,0,true);context.closePath();context.fillStrokeShape(this);},// implements Shape.prototype.getWidth()
getWidth:function getWidth(){return this.getOuterRadius()*2;},// implements Shape.prototype.getHeight()
getHeight:function getHeight(){return this.getOuterRadius()*2;},// implements Shape.prototype.setWidth()
setWidth:function setWidth(width){Konva.Node.prototype.setWidth.call(this,width);if(this.outerRadius()!==width/2){this.setOuterRadius(width/2);}},// implements Shape.prototype.setHeight()
setHeight:function setHeight(height){Konva.Node.prototype.setHeight.call(this,height);if(this.outerRadius()!==height/2){this.setOuterRadius(height/2);}},setOuterRadius:function setOuterRadius(val){this._setAttr('outerRadius',val);this.setWidth(val*2);this.setHeight(val*2);}};Konva.Util.extend(Konva.Ring,Konva.Shape);// add getters setters
Konva.Factory.addGetterSetter(Konva.Ring,'innerRadius',0,Konva.Validators.getNumberValidator());/**
   * get/set innerRadius
   * @name innerRadius
   * @method
   * @memberof Konva.Ring.prototype
   * @param {Number} innerRadius
   * @returns {Number}
   * @example
   * // get inner radius
   * var innerRadius = ring.innerRadius();
   *
   * // set inner radius
   * ring.innerRadius(20);
   */Konva.Factory.addGetter(Konva.Ring,'outerRadius',0,Konva.Validators.getNumberValidator());Konva.Factory.addOverloadedGetterSetter(Konva.Ring,'outerRadius');/**
   * get/set outerRadius
   * @name outerRadius
   * @method
   * @memberof Konva.Ring.prototype
   * @param {Number} outerRadius
   * @returns {Number}
   * @example
   * // get outer radius
   * var outerRadius = ring.outerRadius();
   *
   * // set outer radius
   * ring.outerRadius(20);
   */Konva.Collection.mapMethods(Konva.Ring);})();(function(){'use strict';/**
   * Wedge constructor
   * @constructor
   * @augments Konva.Shape
   * @param {Object} config
   * @param {Number} config.angle in degrees
   * @param {Number} config.radius
   * @param {Boolean} [config.clockwise]
   * @param {String} [config.fill] fill color
     * @param {Image} [config.fillPatternImage] fill pattern image
     * @param {Number} [config.fillPatternX]
     * @param {Number} [config.fillPatternY]
     * @param {Object} [config.fillPatternOffset] object with x and y component
     * @param {Number} [config.fillPatternOffsetX] 
     * @param {Number} [config.fillPatternOffsetY] 
     * @param {Object} [config.fillPatternScale] object with x and y component
     * @param {Number} [config.fillPatternScaleX]
     * @param {Number} [config.fillPatternScaleY]
     * @param {Number} [config.fillPatternRotation]
     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientStartPointX]
     * @param {Number} [config.fillLinearGradientStartPointY]
     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientEndPointX]
     * @param {Number} [config.fillLinearGradientEndPointY]
     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientStartPointX]
     * @param {Number} [config.fillRadialGradientStartPointY]
     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientEndPointX] 
     * @param {Number} [config.fillRadialGradientEndPointY] 
     * @param {Number} [config.fillRadialGradientStartRadius]
     * @param {Number} [config.fillRadialGradientEndRadius]
     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
     * @param {String} [config.stroke] stroke color
     * @param {Number} [config.strokeWidth] stroke width
     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
     *  is miter
     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
     *  is butt
     * @param {String} [config.shadowColor]
     * @param {Number} [config.shadowBlur]
     * @param {Object} [config.shadowOffset] object with x and y component
     * @param {Number} [config.shadowOffsetX]
     * @param {Number} [config.shadowOffsetY]
     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
     *  between 0 and 1
     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
     * @param {Array} [config.dash]
     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * @example
   * // draw a wedge that's pointing downwards
   * var wedge = new Konva.Wedge({
   *   radius: 40,
   *   fill: 'red',
   *   stroke: 'black'
   *   strokeWidth: 5,
   *   angleDeg: 60,
   *   rotationDeg: -120
   * });
   */Konva.Wedge=function(config){this.___init(config);};Konva.Wedge.prototype={_centroid:true,___init:function ___init(config){// call super constructor
Konva.Shape.call(this,config);this.className='Wedge';this.sceneFunc(this._sceneFunc);},_sceneFunc:function _sceneFunc(context){context.beginPath();context.arc(0,0,this.getRadius(),0,Konva.getAngle(this.getAngle()),this.getClockwise());context.lineTo(0,0);context.closePath();context.fillStrokeShape(this);},// implements Shape.prototype.getWidth()
getWidth:function getWidth(){return this.getRadius()*2;},// implements Shape.prototype.getHeight()
getHeight:function getHeight(){return this.getRadius()*2;},// implements Shape.prototype.setWidth()
setWidth:function setWidth(width){Konva.Node.prototype.setWidth.call(this,width);if(this.radius()!==width/2){this.setRadius(width/2);}},// implements Shape.prototype.setHeight()
setHeight:function setHeight(height){Konva.Node.prototype.setHeight.call(this,height);if(this.radius()!==height/2){this.setRadius(height/2);}}};Konva.Util.extend(Konva.Wedge,Konva.Shape);// add getters setters
Konva.Factory.addGetterSetter(Konva.Wedge,'radius',0,Konva.Validators.getNumberValidator());/**
   * get/set radius
   * @name radius
   * @method
   * @memberof Konva.Wedge.prototype
   * @param {Number} radius
   * @returns {Number}
   * @example
   * // get radius
   * var radius = wedge.radius();
   *
   * // set radius
   * wedge.radius(10);
   */Konva.Factory.addGetterSetter(Konva.Wedge,'angle',0,Konva.Validators.getNumberValidator());/**
   * get/set angle in degrees
   * @name angle
   * @method
   * @memberof Konva.Wedge.prototype
   * @param {Number} angle
   * @returns {Number}
   * @example
   * // get angle
   * var angle = wedge.angle();
   *
   * // set angle
   * wedge.angle(20);
   */Konva.Factory.addGetterSetter(Konva.Wedge,'clockwise',false);/**
   * get/set clockwise flag
   * @name clockwise
   * @method
   * @memberof Konva.Wedge.prototype
   * @param {Number} clockwise
   * @returns {Number}
   * @example
   * // get clockwise flag
   * var clockwise = wedge.clockwise();
   *
   * // draw wedge counter-clockwise
   * wedge.clockwise(false);
   *
   * // draw wedge clockwise
   * wedge.clockwise(true);
   */Konva.Factory.backCompat(Konva.Wedge,{angleDeg:'angle',getAngleDeg:'getAngle',setAngleDeg:'setAngle'});Konva.Collection.mapMethods(Konva.Wedge);})();(function(Konva){'use strict';/**
   * Arc constructor
   * @constructor
   * @augments Konva.Shape
   * @param {Object} config
   * @param {Number} config.angle in degrees
   * @param {Number} config.innerRadius
   * @param {Number} config.outerRadius
   * @param {Boolean} [config.clockwise]
   * @param {String} [config.fill] fill color
     * @param {Image} [config.fillPatternImage] fill pattern image
     * @param {Number} [config.fillPatternX]
     * @param {Number} [config.fillPatternY]
     * @param {Object} [config.fillPatternOffset] object with x and y component
     * @param {Number} [config.fillPatternOffsetX] 
     * @param {Number} [config.fillPatternOffsetY] 
     * @param {Object} [config.fillPatternScale] object with x and y component
     * @param {Number} [config.fillPatternScaleX]
     * @param {Number} [config.fillPatternScaleY]
     * @param {Number} [config.fillPatternRotation]
     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientStartPointX]
     * @param {Number} [config.fillLinearGradientStartPointY]
     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientEndPointX]
     * @param {Number} [config.fillLinearGradientEndPointY]
     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientStartPointX]
     * @param {Number} [config.fillRadialGradientStartPointY]
     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientEndPointX] 
     * @param {Number} [config.fillRadialGradientEndPointY] 
     * @param {Number} [config.fillRadialGradientStartRadius]
     * @param {Number} [config.fillRadialGradientEndRadius]
     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
     * @param {String} [config.stroke] stroke color
     * @param {Number} [config.strokeWidth] stroke width
     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
     *  is miter
     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
     *  is butt
     * @param {String} [config.shadowColor]
     * @param {Number} [config.shadowBlur]
     * @param {Object} [config.shadowOffset] object with x and y component
     * @param {Number} [config.shadowOffsetX]
     * @param {Number} [config.shadowOffsetY]
     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
     *  between 0 and 1
     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
     * @param {Array} [config.dash]
     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * @example
   * // draw a Arc that's pointing downwards
   * var arc = new Konva.Arc({
   *   innerRadius: 40,
   *   outerRadius: 80,
   *   fill: 'red',
   *   stroke: 'black'
   *   strokeWidth: 5,
   *   angle: 60,
   *   rotationDeg: -120
   * });
   */Konva.Arc=function(config){this.___init(config);};Konva.Arc.prototype={_centroid:true,___init:function ___init(config){// call super constructor
Konva.Shape.call(this,config);this.className='Arc';this.sceneFunc(this._sceneFunc);},_sceneFunc:function _sceneFunc(context){var angle=Konva.getAngle(this.angle()),clockwise=this.clockwise();context.beginPath();context.arc(0,0,this.getOuterRadius(),0,angle,clockwise);context.arc(0,0,this.getInnerRadius(),angle,0,!clockwise);context.closePath();context.fillStrokeShape(this);},// implements Shape.prototype.getWidth()
getWidth:function getWidth(){return this.getOuterRadius()*2;},// implements Shape.prototype.getHeight()
getHeight:function getHeight(){return this.getOuterRadius()*2;},// implements Shape.prototype.setWidth()
setWidth:function setWidth(width){Konva.Node.prototype.setWidth.call(this,width);if(this.getOuterRadius()!==width/2){this.setOuterRadius(width/2);}},// implements Shape.prototype.setHeight()
setHeight:function setHeight(height){Konva.Node.prototype.setHeight.call(this,height);if(this.getOuterRadius()!==height/2){this.setOuterRadius(height/2);}}};Konva.Util.extend(Konva.Arc,Konva.Shape);// add getters setters
Konva.Factory.addGetterSetter(Konva.Arc,'innerRadius',0,Konva.Validators.getNumberValidator());/**
   * get/set innerRadius
   * @name innerRadius
   * @method
   * @memberof Konva.Arc.prototype
   * @param {Number} innerRadius
   * @returns {Number}
   * @example
   * // get inner radius
   * var innerRadius = arc.innerRadius();
   *
   * // set inner radius
   * arc.innerRadius(20);
   */Konva.Factory.addGetterSetter(Konva.Arc,'outerRadius',0,Konva.Validators.getNumberValidator());/**
   * get/set outerRadius
   * @name outerRadius
   * @method
   * @memberof Konva.Arc.prototype
   * @param {Number} outerRadius
   * @returns {Number}
   * @example
   * // get outer radius
   * var outerRadius = arc.outerRadius();
   *
   * // set outer radius
   * arc.outerRadius(20);
   */Konva.Factory.addGetterSetter(Konva.Arc,'angle',0,Konva.Validators.getNumberValidator());/**
   * get/set angle in degrees
   * @name angle
   * @method
   * @memberof Konva.Arc.prototype
   * @param {Number} angle
   * @returns {Number}
   * @example
   * // get angle
   * var angle = arc.angle();
   *
   * // set angle
   * arc.angle(20);
   */Konva.Factory.addGetterSetter(Konva.Arc,'clockwise',false);/**
   * get/set clockwise flag
   * @name clockwise
   * @method
   * @memberof Konva.Arc.prototype
   * @param {Boolean} clockwise
   * @returns {Boolean}
   * @example
   * // get clockwise flag
   * var clockwise = arc.clockwise();
   *
   * // draw arc counter-clockwise
   * arc.clockwise(false);
   *
   * // draw arc clockwise
   * arc.clockwise(true);
   */Konva.Collection.mapMethods(Konva.Arc);})(Konva);(function(){'use strict';// CONSTANTS
var IMAGE='Image';/**
   * Image constructor
   * @constructor
   * @memberof Konva
   * @augments Konva.Shape
   * @param {Object} config
   * @param {Image} config.image
   * @param {Object} [config.crop]
   * @param {String} [config.fill] fill color
     * @param {Image} [config.fillPatternImage] fill pattern image
     * @param {Number} [config.fillPatternX]
     * @param {Number} [config.fillPatternY]
     * @param {Object} [config.fillPatternOffset] object with x and y component
     * @param {Number} [config.fillPatternOffsetX] 
     * @param {Number} [config.fillPatternOffsetY] 
     * @param {Object} [config.fillPatternScale] object with x and y component
     * @param {Number} [config.fillPatternScaleX]
     * @param {Number} [config.fillPatternScaleY]
     * @param {Number} [config.fillPatternRotation]
     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientStartPointX]
     * @param {Number} [config.fillLinearGradientStartPointY]
     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientEndPointX]
     * @param {Number} [config.fillLinearGradientEndPointY]
     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientStartPointX]
     * @param {Number} [config.fillRadialGradientStartPointY]
     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientEndPointX] 
     * @param {Number} [config.fillRadialGradientEndPointY] 
     * @param {Number} [config.fillRadialGradientStartRadius]
     * @param {Number} [config.fillRadialGradientEndRadius]
     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
     * @param {String} [config.stroke] stroke color
     * @param {Number} [config.strokeWidth] stroke width
     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
     *  is miter
     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
     *  is butt
     * @param {String} [config.shadowColor]
     * @param {Number} [config.shadowBlur]
     * @param {Object} [config.shadowOffset] object with x and y component
     * @param {Number} [config.shadowOffsetX]
     * @param {Number} [config.shadowOffsetY]
     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
     *  between 0 and 1
     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
     * @param {Array} [config.dash]
     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * @example
   * var imageObj = new Image();
   * imageObj.onload = function() {
   *   var image = new Konva.Image({
   *     x: 200,
   *     y: 50,
   *     image: imageObj,
   *     width: 100,
   *     height: 100
   *   });
   * };
   * imageObj.src = '/path/to/image.jpg'
   */Konva.Image=function(config){this.___init(config);};Konva.Image.prototype={___init:function ___init(config){// call super constructor
Konva.Shape.call(this,config);this.className=IMAGE;this.sceneFunc(this._sceneFunc);this.hitFunc(this._hitFunc);},_useBufferCanvas:function _useBufferCanvas(){return(this.hasShadow()||this.getAbsoluteOpacity()!==1)&&this.hasStroke()&&this.getStage();},_sceneFunc:function _sceneFunc(context){var width=this.getWidth(),height=this.getHeight(),image=this.getImage(),cropWidth,cropHeight,params;if(image){cropWidth=this.getCropWidth();cropHeight=this.getCropHeight();if(cropWidth&&cropHeight){params=[image,this.getCropX(),this.getCropY(),cropWidth,cropHeight,0,0,width,height];}else{params=[image,0,0,width,height];}}if(this.hasFill()||this.hasStroke()){context.beginPath();context.rect(0,0,width,height);context.closePath();context.fillStrokeShape(this);}if(image){context.drawImage.apply(context,params);}},_hitFunc:function _hitFunc(context){var width=this.getWidth(),height=this.getHeight();context.beginPath();context.rect(0,0,width,height);context.closePath();context.fillStrokeShape(this);},getWidth:function getWidth(){var image=this.getImage();return this.attrs.width||(image?image.width:0);},getHeight:function getHeight(){var image=this.getImage();return this.attrs.height||(image?image.height:0);}};Konva.Util.extend(Konva.Image,Konva.Shape);// add getters setters
Konva.Factory.addGetterSetter(Konva.Image,'image');/**
   * set image
   * @name setImage
   * @method
   * @memberof Konva.Image.prototype
   * @param {Image} image
   *//**
   * get image
   * @name getImage
   * @method
   * @memberof Konva.Image.prototype
   * @returns {Image}
   */Konva.Factory.addComponentsGetterSetter(Konva.Image,'crop',['x','y','width','height']);/**
   * get/set crop
   * @method
   * @name crop
   * @memberof Konva.Image.prototype
   * @param {Object} crop
   * @param {Number} crop.x
   * @param {Number} crop.y
   * @param {Number} crop.width
   * @param {Number} crop.height
   * @returns {Object}
   * @example
   * // get crop
   * var crop = image.crop();
   *
   * // set crop
   * image.crop({
   *   x: 20,
   *   y: 20,
   *   width: 20,
   *   height: 20
   * });
   */Konva.Factory.addGetterSetter(Konva.Image,'cropX',0,Konva.Validators.getNumberValidator());/**
   * get/set crop x
   * @method
   * @name cropX
   * @memberof Konva.Image.prototype
   * @param {Number} x
   * @returns {Number}
   * @example
   * // get crop x
   * var cropX = image.cropX();
   *
   * // set crop x
   * image.cropX(20);
   */Konva.Factory.addGetterSetter(Konva.Image,'cropY',0,Konva.Validators.getNumberValidator());/**
   * get/set crop y
   * @name cropY
   * @method
   * @memberof Konva.Image.prototype
   * @param {Number} y
   * @returns {Number}
   * @example
   * // get crop y
   * var cropY = image.cropY();
   *
   * // set crop y
   * image.cropY(20);
   */Konva.Factory.addGetterSetter(Konva.Image,'cropWidth',0,Konva.Validators.getNumberValidator());/**
   * get/set crop width
   * @name cropWidth
   * @method
   * @memberof Konva.Image.prototype
   * @param {Number} width
   * @returns {Number}
   * @example
   * // get crop width
   * var cropWidth = image.cropWidth();
   *
   * // set crop width
   * image.cropWidth(20);
   */Konva.Factory.addGetterSetter(Konva.Image,'cropHeight',0,Konva.Validators.getNumberValidator());/**
   * get/set crop height
   * @name cropHeight
   * @method
   * @memberof Konva.Image.prototype
   * @param {Number} height
   * @returns {Number}
   * @example
   * // get crop height
   * var cropHeight = image.cropHeight();
   *
   * // set crop height
   * image.cropHeight(20);
   */Konva.Collection.mapMethods(Konva.Image);/**
   * load image from given url and create `Konva.Image` instance
   * @method
   * @memberof Konva.Image
   * @param {String} url image source
   * @param {Function} callback with Konva.Image instance as first argument
   * @example
   *  Konva.Image.fromURL(imageURL, function(image){
   *    // image is Konva.Image instance
   *    layer.add(image);
   *    layer.draw();
   *  });
   */Konva.Image.fromURL=function(url,callback){var img=new Image();img.onload=function(){var image=new Konva.Image({image:img});callback(image);};img.crossOrigin='Anonymous';img.src=url;};})();/*eslint-disable max-depth */(function(){'use strict';// var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
// constants
var AUTO='auto',//CANVAS = 'canvas',
CENTER='center',JUSTIFY='justify',CHANGE_KONVA='Change.konva',CONTEXT_2D='2d',DASH='-',EMPTY_STRING='',LEFT='left',TEXT='text',TEXT_UPPER='Text',TOP='top',BOTTOM='bottom',MIDDLE='middle',NORMAL='normal',PX_SPACE='px ',SPACE=' ',RIGHT='right',WORD='word',CHAR='char',NONE='none',ELLIPSIS='…',ATTR_CHANGE_LIST=['fontFamily','fontSize','fontStyle','fontVariant','padding','align','verticalAlign','lineHeight','text','width','height','wrap','ellipsis','letterSpacing'],// cached variables
attrChangeListLen=ATTR_CHANGE_LIST.length;var dummyContext;function getDummyContext(){if(dummyContext){return dummyContext;}dummyContext=Konva.Util.createCanvasElement().getContext(CONTEXT_2D);return dummyContext;}/**
   * Text constructor
   * @constructor
   * @memberof Konva
   * @augments Konva.Shape
   * @param {Object} config
   * @param {String} [config.fontFamily] default is Arial
   * @param {Number} [config.fontSize] in pixels.  Default is 12
   * @param {String} [config.fontStyle] can be normal, bold, or italic.  Default is normal
   * @param {String} [config.fontVariant] can be normal or small-caps.  Default is normal
   * @param {String} config.text
   * @param {String} [config.align] can be left, center, or right
   * @param {String} [config.verticalAlign] can be top, middle or bottom
   * @param {Number} [config.padding]
   * @param {Number} [config.lineHeight] default is 1
   * @param {String} [config.wrap] can be word, char, or none. Default is word
   * @param {Boolean} [config.ellipsis] can be true or false. Default is false. if Konva.Text config is set to wrap="none" and ellipsis=true, then it will add "..." to the end
   * @param {String} [config.fill] fill color
     * @param {Image} [config.fillPatternImage] fill pattern image
     * @param {Number} [config.fillPatternX]
     * @param {Number} [config.fillPatternY]
     * @param {Object} [config.fillPatternOffset] object with x and y component
     * @param {Number} [config.fillPatternOffsetX] 
     * @param {Number} [config.fillPatternOffsetY] 
     * @param {Object} [config.fillPatternScale] object with x and y component
     * @param {Number} [config.fillPatternScaleX]
     * @param {Number} [config.fillPatternScaleY]
     * @param {Number} [config.fillPatternRotation]
     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientStartPointX]
     * @param {Number} [config.fillLinearGradientStartPointY]
     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientEndPointX]
     * @param {Number} [config.fillLinearGradientEndPointY]
     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientStartPointX]
     * @param {Number} [config.fillRadialGradientStartPointY]
     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientEndPointX] 
     * @param {Number} [config.fillRadialGradientEndPointY] 
     * @param {Number} [config.fillRadialGradientStartRadius]
     * @param {Number} [config.fillRadialGradientEndRadius]
     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
     * @param {String} [config.stroke] stroke color
     * @param {Number} [config.strokeWidth] stroke width
     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
     *  is miter
     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
     *  is butt
     * @param {String} [config.shadowColor]
     * @param {Number} [config.shadowBlur]
     * @param {Object} [config.shadowOffset] object with x and y component
     * @param {Number} [config.shadowOffsetX]
     * @param {Number} [config.shadowOffsetY]
     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
     *  between 0 and 1
     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
     * @param {Array} [config.dash]
     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * @example
   * var text = new Konva.Text({
   *   x: 10,
   *   y: 15,
   *   text: 'Simple Text',
   *   fontSize: 30,
   *   fontFamily: 'Calibri',
   *   fill: 'green'
   * });
   */Konva.Text=function(config){this.___init(config);};function _fillFunc(context){context.fillText(this.partialText,0,0);}function _strokeFunc(context){context.strokeText(this.partialText,0,0);}Konva.Text.prototype={___init:function ___init(config){config=config||{};// set default color to black
if(!config.fillLinearGradientColorStops&&!config.fillRadialGradientColorStops){config.fill=config.fill||'black';}//
// if (config.width === undefined) {
//     config.width = AUTO;
// }
// if (config.height === undefined) {
//     config.height = AUTO;
// }
// call super constructor
Konva.Shape.call(this,config);this._fillFunc=_fillFunc;this._strokeFunc=_strokeFunc;this.className=TEXT_UPPER;// update text data for certain attr changes
for(var n=0;n<attrChangeListLen;n++){this.on(ATTR_CHANGE_LIST[n]+CHANGE_KONVA,this._setTextData);}this._setTextData();this.sceneFunc(this._sceneFunc);this.hitFunc(this._hitFunc);},_sceneFunc:function _sceneFunc(context){var padding=this.getPadding(),textHeight=this.getTextHeight(),lineHeightPx=this.getLineHeight()*textHeight,textArr=this.textArr,textArrLen=textArr.length,verticalAlign=this.getVerticalAlign(),alignY=0,align=this.getAlign(),totalWidth=this.getWidth(),letterSpacing=this.getLetterSpacing(),textDecoration=this.textDecoration(),fill=this.fill(),fontSize=this.fontSize(),n;context.setAttr('font',this._getContextFont());context.setAttr('textBaseline',MIDDLE);context.setAttr('textAlign',LEFT);// handle vertical alignment
if(verticalAlign===MIDDLE){alignY=(this.getHeight()-textArrLen*lineHeightPx-padding*2)/2;}else if(verticalAlign===BOTTOM){alignY=this.getHeight()-textArrLen*lineHeightPx-padding*2;}if(padding){context.translate(padding,0);context.translate(0,alignY+padding+lineHeightPx/2);}else{context.translate(0,alignY+lineHeightPx/2);}// draw text lines
for(n=0;n<textArrLen;n++){var obj=textArr[n],text=obj.text,width=obj.width,lastLine=n!==textArrLen-1,spacesNumber,oneWord,lineWidth;// horizontal alignment
context.save();if(align===RIGHT){context.translate(totalWidth-width-padding*2,0);}else if(align===CENTER){context.translate((totalWidth-width-padding*2)/2,0);}if(textDecoration.indexOf('underline')!==-1){context.save();context.beginPath();context.moveTo(0,Math.round(lineHeightPx/2));spacesNumber=text.split(' ').length-1;oneWord=spacesNumber===0;lineWidth=align===JUSTIFY&&lastLine&&!oneWord?totalWidth-padding*2:width;context.lineTo(Math.round(lineWidth),Math.round(lineHeightPx/2));// TODO: I have no idea what is real ratio
// just /15 looks good enough
context.lineWidth=fontSize/15;context.strokeStyle=fill;context.stroke();context.restore();}if(textDecoration.indexOf('line-through')!==-1){context.save();context.beginPath();context.moveTo(0,0);spacesNumber=text.split(' ').length-1;oneWord=spacesNumber===0;lineWidth=align===JUSTIFY&&lastLine&&!oneWord?totalWidth-padding*2:width;context.lineTo(Math.round(lineWidth),0);context.lineWidth=fontSize/15;context.strokeStyle=fill;context.stroke();context.restore();}if(letterSpacing!==0||align===JUSTIFY){//   var words = text.split(' ');
spacesNumber=text.split(' ').length-1;for(var li=0;li<text.length;li++){var letter=text[li];// skip justify for the last line
if(letter===' '&&n!==textArrLen-1&&align===JUSTIFY){context.translate(Math.floor((totalWidth-padding*2-width)/spacesNumber),0);}this.partialText=letter;context.fillStrokeShape(this);context.translate(Math.round(this._getTextSize(letter).width)+letterSpacing,0);}}else{this.partialText=text;context.fillStrokeShape(this);}context.restore();if(textArrLen>1){context.translate(0,lineHeightPx);}}},_hitFunc:function _hitFunc(context){var width=this.getWidth(),height=this.getHeight();context.beginPath();context.rect(0,0,width,height);context.closePath();context.fillStrokeShape(this);},setText:function setText(text){var str=Konva.Util._isString(text)?text:(text||'').toString();this._setAttr(TEXT,str);return this;},/**
     * get width of text area, which includes padding
     * @method
     * @memberof Konva.Text.prototype
     * @returns {Number}
     */getWidth:function getWidth(){var isAuto=this.attrs.width===AUTO||this.attrs.width===undefined;return isAuto?this.getTextWidth()+this.getPadding()*2:this.attrs.width;},/**
     * get the height of the text area, which takes into account multi-line text, line heights, and padding
     * @method
     * @memberof Konva.Text.prototype
     * @returns {Number}
     */getHeight:function getHeight(){var isAuto=this.attrs.height===AUTO||this.attrs.height===undefined;return isAuto?this.getTextHeight()*this.textArr.length*this.getLineHeight()+this.getPadding()*2:this.attrs.height;},/**
     * get text width
     * @method
     * @memberof Konva.Text.prototype
     * @returns {Number}
     */getTextWidth:function getTextWidth(){return this.textWidth;},/**
     * get height of one line text
     * @method
     * @memberof Konva.Text.prototype
     * @returns {Number}
     */getTextHeight:function getTextHeight(){return this.textHeight;},_getTextSize:function _getTextSize(text){var _context=getDummyContext(),fontSize=this.getFontSize(),metrics;_context.save();_context.font=this._getContextFont();metrics=_context.measureText(text);_context.restore();return{width:metrics.width,height:parseInt(fontSize,10)};},_getContextFont:function _getContextFont(){// IE don't want to work with usual font style
// bold was not working
// removing font variant will solve
// fix for: https://github.com/konvajs/konva/issues/94
if(Konva.UA.isIE){return this.getFontStyle()+SPACE+this.getFontSize()+PX_SPACE+this.getFontFamily();}return this.getFontStyle()+SPACE+this.getFontVariant()+SPACE+this.getFontSize()+PX_SPACE+this.getFontFamily();},_addTextLine:function _addTextLine(line){if(this.align()===JUSTIFY){line=line.trim();}var width=this._getTextWidth(line);return this.textArr.push({text:line,width:width});},_getTextWidth:function _getTextWidth(text){var latterSpacing=this.getLetterSpacing();var length=text.length;return getDummyContext().measureText(text).width+(length?latterSpacing*(length-1):0);},_setTextData:function _setTextData(){var lines=this.getText().split('\n'),fontSize=+this.getFontSize(),textWidth=0,lineHeightPx=this.getLineHeight()*fontSize,width=this.attrs.width,height=this.attrs.height,fixedWidth=width!==AUTO,fixedHeight=height!==AUTO,padding=this.getPadding(),maxWidth=width-padding*2,maxHeightPx=height-padding*2,currentHeightPx=0,wrap=this.getWrap(),// align = this.getAlign(),
shouldWrap=wrap!==NONE,wrapAtWord=wrap!==CHAR&&shouldWrap,shouldAddEllipsis=this.getEllipsis()&&!shouldWrap;this.textArr=[];getDummyContext().font=this._getContextFont();for(var i=0,max=lines.length;i<max;++i){var line=lines[i];var additionalWidth=shouldAddEllipsis?this._getTextWidth(ELLIPSIS):0;var lineWidth=this._getTextWidth(line);if(fixedWidth&&lineWidth>maxWidth){/*
          * if width is fixed and line does not fit entirely
          * break the line into multiple fitting lines
          */while(line.length>0){/*
            * use binary search to find the longest substring that
            * that would fit in the specified width
            */var low=0,high=line.length,match='',matchWidth=0;while(low<high){var mid=low+high>>>1,substr=line.slice(0,mid+1),substrWidth=this._getTextWidth(substr)+additionalWidth;if(substrWidth<=maxWidth){low=mid+1;match=substr+(shouldAddEllipsis?ELLIPSIS:'');matchWidth=substrWidth;}else{high=mid;}}/*
            * 'low' is now the index of the substring end
            * 'match' is the substring
            * 'matchWidth' is the substring width in px
            */if(match){// a fitting substring was found
if(wrapAtWord){// try to find a space or dash where wrapping could be done
var wrapIndex;var nextChar=line[match.length];var nextIsSpaceOrDash=nextChar===SPACE||nextChar===DASH;if(nextIsSpaceOrDash&&matchWidth<=maxWidth){wrapIndex=match.length;}else{wrapIndex=Math.max(match.lastIndexOf(SPACE),match.lastIndexOf(DASH))+1;}if(wrapIndex>0){// re-cut the substring found at the space/dash position
low=wrapIndex;match=match.slice(0,low);matchWidth=this._getTextWidth(match);}}// if (align === 'right') {
match=Konva.Util.trimRight(match);// }
this._addTextLine(match);textWidth=Math.max(textWidth,matchWidth);currentHeightPx+=lineHeightPx;if(!shouldWrap||fixedHeight&&currentHeightPx+lineHeightPx>maxHeightPx){/*
                * stop wrapping if wrapping is disabled or if adding
                * one more line would overflow the fixed height
                */break;}line=line.slice(low);line=Konva.Util.trimLeft(line);if(line.length>0){// Check if the remaining text would fit on one line
lineWidth=this._getTextWidth(line);if(lineWidth<=maxWidth){// if it does, add the line and break out of the loop
this._addTextLine(line);currentHeightPx+=lineHeightPx;textWidth=Math.max(textWidth,lineWidth);break;}}}else{// not even one character could fit in the element, abort
break;}}}else{// element width is automatically adjusted to max line width
this._addTextLine(line);currentHeightPx+=lineHeightPx;textWidth=Math.max(textWidth,lineWidth);}// if element height is fixed, abort if adding one more line would overflow
if(fixedHeight&&currentHeightPx+lineHeightPx>maxHeightPx){break;}}this.textHeight=fontSize;// var maxTextWidth = 0;
// for(var j = 0; j < this.textArr.length; j++) {
//     maxTextWidth = Math.max(maxTextWidth, this.textArr[j].width);
// }
this.textWidth=textWidth;}};Konva.Util.extend(Konva.Text,Konva.Shape);Konva.Factory.addSetter(Konva.Node,'width',Konva.Validators.getNumberOrAutoValidator());Konva.Factory.addSetter(Konva.Node,'height',Konva.Validators.getNumberOrAutoValidator());// add getters setters
Konva.Factory.addGetterSetter(Konva.Text,'fontFamily','Arial');/**
   * get/set font family
   * @name fontFamily
   * @method
   * @memberof Konva.Text.prototype
   * @param {String} fontFamily
   * @returns {String}
   * @example
   * // get font family
   * var fontFamily = text.fontFamily();
   *
   * // set font family
   * text.fontFamily('Arial');
   */Konva.Factory.addGetterSetter(Konva.Text,'fontSize',12,Konva.Validators.getNumberValidator());/**
   * get/set font size in pixels
   * @name fontSize
   * @method
   * @memberof Konva.Text.prototype
   * @param {Number} fontSize
   * @returns {Number}
   * @example
   * // get font size
   * var fontSize = text.fontSize();
   *
   * // set font size to 22px
   * text.fontSize(22);
   */Konva.Factory.addGetterSetter(Konva.Text,'fontStyle',NORMAL);/**
   * set font style.  Can be 'normal', 'italic', or 'bold'.  'normal' is the default.
   * @name fontStyle
   * @method
   * @memberof Konva.Text.prototype
   * @param {String} fontStyle
   * @returns {String}
   * @example
   * // get font style
   * var fontStyle = text.fontStyle();
   *
   * // set font style
   * text.fontStyle('bold');
   */Konva.Factory.addGetterSetter(Konva.Text,'fontVariant',NORMAL);/**
   * set font variant.  Can be 'normal' or 'small-caps'.  'normal' is the default.
   * @name fontVariant
   * @method
   * @memberof Konva.Text.prototype
   * @param {String} fontVariant
   * @returns {String}
   * @example
   * // get font variant
   * var fontVariant = text.fontVariant();
   *
   * // set font variant
   * text.fontVariant('small-caps');
   */Konva.Factory.addGetterSetter(Konva.Text,'padding',0,Konva.Validators.getNumberValidator());/**
   * set padding
   * @name padding
   * @method
   * @memberof Konva.Text.prototype
   * @param {Number} padding
   * @returns {Number}
   * @example
   * // get padding
   * var padding = text.padding();
   *
   * // set padding to 10 pixels
   * text.padding(10);
   */Konva.Factory.addGetterSetter(Konva.Text,'align',LEFT);/**
   * get/set horizontal align of text.  Can be 'left', 'center', 'right' or 'justify'
   * @name align
   * @method
   * @memberof Konva.Text.prototype
   * @param {String} align
   * @returns {String}
   * @example
   * // get text align
   * var align = text.align();
   *
   * // center text
   * text.align('center');
   *
   * // align text to right
   * text.align('right');
   */Konva.Factory.addGetterSetter(Konva.Text,'verticalAlign',TOP);/**
   * get/set vertical align of text.  Can be 'top', 'middle', 'bottom'.
   * @name verticalAlign
   * @method
   * @memberof Konva.Text.prototype
   * @param {String} verticalAlign
   * @returns {String}
   * @example
   * // get text vertical align
   * var verticalAlign = text.verticalAlign();
   *
   * // center text
   * text.verticalAlign('middle');
   */Konva.Factory.addGetterSetter(Konva.Text,'lineHeight',1,Konva.Validators.getNumberValidator());/**
   * get/set line height.  The default is 1.
   * @name lineHeight
   * @method
   * @memberof Konva.Text.prototype
   * @param {Number} lineHeight
   * @returns {Number}
   * @example
   * // get line height
   * var lineHeight = text.lineHeight();
   *
   * // set the line height
   * text.lineHeight(2);
   */Konva.Factory.addGetterSetter(Konva.Text,'wrap',WORD);/**
   * get/set wrap.  Can be word, char, or none. Default is word.
   * @name wrap
   * @method
   * @memberof Konva.Text.prototype
   * @param {String} wrap
   * @returns {String}
   * @example
   * // get wrap
   * var wrap = text.wrap();
   *
   * // set wrap
   * text.wrap('word');
   */Konva.Factory.addGetterSetter(Konva.Text,'ellipsis',false);/**
   * get/set ellipsis.  Can be true or false. Default is false.
   * if Konva.Text config is set to wrap="none" and ellipsis=true, then it will add "..." to the end
   * @name ellipsis
   * @method
   * @memberof Konva.Text.prototype
   * @param {Boolean} ellipsis
   * @returns {Boolean}
   * @example
   * // get ellipsis
   * var ellipsis = text.ellipsis();
   *
   * // set ellipsis
   * text.ellipsis(true);
   */Konva.Factory.addGetterSetter(Konva.Text,'letterSpacing',0,Konva.Validators.getNumberValidator());/**
   * set letter spacing property. Default value is 0.
   * @name letterSpacing
   * @method
   * @memberof Konva.TextPath.prototype
   * @param {Number} letterSpacing
   */Konva.Factory.addGetter(Konva.Text,'text',EMPTY_STRING);Konva.Factory.addOverloadedGetterSetter(Konva.Text,'text');/**
   * get/set text
   * @name getText
   * @method
   * @memberof Konva.Text.prototype
   * @param {String} text
   * @returns {String}
   * @example
   * // get text
   * var text = text.text();
   *
   * // set text
   * text.text('Hello world!');
   */Konva.Factory.addGetterSetter(Konva.Text,'textDecoration',EMPTY_STRING);/**
   * get/set text decoration of a text.  Possible values are 'underline', 'line-through' or combination of these values separated by space
   * @name textDecoration
   * @method
   * @memberof Konva.Text.prototype
   * @param {String} textDecoration
   * @returns {String}
   * @example
   * // get text decoration
   * var textDecoration = text.textDecoration();
   *
   * // underline text
   * text.textDecoration('underline');
   *
   * // strike text
   * text.textDecoration('line-through');
   *
   * // underline and strike text
   * text.textDecoration('underline line-through');
   */Konva.Collection.mapMethods(Konva.Text);})();(function(){'use strict';/**
   * Line constructor.&nbsp; Lines are defined by an array of points and
   *  a tension
   * @constructor
   * @memberof Konva
   * @augments Konva.Shape
   * @param {Object} config
   * @param {Array} config.points Flat array of points coordinates. You should define them as [x1, y1, x2, y2, x3, y3].
   * @param {Number} [config.tension] Higher values will result in a more curvy line.  A value of 0 will result in no interpolation.
   *   The default is 0
   * @param {Boolean} [config.closed] defines whether or not the line shape is closed, creating a polygon or blob
   * @param {Boolean} [config.bezier] if no tension is provided but bezier=true, we draw the line as a bezier using the passed points
   * @param {String} [config.fill] fill color
     * @param {Image} [config.fillPatternImage] fill pattern image
     * @param {Number} [config.fillPatternX]
     * @param {Number} [config.fillPatternY]
     * @param {Object} [config.fillPatternOffset] object with x and y component
     * @param {Number} [config.fillPatternOffsetX] 
     * @param {Number} [config.fillPatternOffsetY] 
     * @param {Object} [config.fillPatternScale] object with x and y component
     * @param {Number} [config.fillPatternScaleX]
     * @param {Number} [config.fillPatternScaleY]
     * @param {Number} [config.fillPatternRotation]
     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientStartPointX]
     * @param {Number} [config.fillLinearGradientStartPointY]
     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientEndPointX]
     * @param {Number} [config.fillLinearGradientEndPointY]
     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientStartPointX]
     * @param {Number} [config.fillRadialGradientStartPointY]
     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientEndPointX] 
     * @param {Number} [config.fillRadialGradientEndPointY] 
     * @param {Number} [config.fillRadialGradientStartRadius]
     * @param {Number} [config.fillRadialGradientEndRadius]
     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
     * @param {String} [config.stroke] stroke color
     * @param {Number} [config.strokeWidth] stroke width
     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
     *  is miter
     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
     *  is butt
     * @param {String} [config.shadowColor]
     * @param {Number} [config.shadowBlur]
     * @param {Object} [config.shadowOffset] object with x and y component
     * @param {Number} [config.shadowOffsetX]
     * @param {Number} [config.shadowOffsetY]
     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
     *  between 0 and 1
     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
     * @param {Array} [config.dash]
     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * @example
   * var line = new Konva.Line({
   *   x: 100,
   *   y: 50,
   *   points: [73, 70, 340, 23, 450, 60, 500, 20],
   *   stroke: 'red',
   *   tension: 1
   * });
   */Konva.Line=function(config){this.___init(config);};Konva.Line.prototype={___init:function ___init(config){// call super constructor
Konva.Shape.call(this,config);this.className='Line';this.on('pointsChange.konva tensionChange.konva closedChange.konva bezierChange.konva',function(){this._clearCache('tensionPoints');});this.sceneFunc(this._sceneFunc);},_sceneFunc:function _sceneFunc(context){var points=this.getPoints(),length=points.length,tension=this.getTension(),closed=this.getClosed(),bezier=this.getBezier(),tp,len,n;if(!length){return;}context.beginPath();context.moveTo(points[0],points[1]);// tension
if(tension!==0&&length>4){tp=this.getTensionPoints();len=tp.length;n=closed?0:4;if(!closed){context.quadraticCurveTo(tp[0],tp[1],tp[2],tp[3]);}while(n<len-2){context.bezierCurveTo(tp[n++],tp[n++],tp[n++],tp[n++],tp[n++],tp[n++]);}if(!closed){context.quadraticCurveTo(tp[len-2],tp[len-1],points[length-2],points[length-1]);}}else if(bezier){// no tension but bezier
n=2;while(n<length){context.bezierCurveTo(points[n++],points[n++],points[n++],points[n++],points[n++],points[n++]);}}else{// no tension
for(n=2;n<length;n+=2){context.lineTo(points[n],points[n+1]);}}// closed e.g. polygons and blobs
if(closed){context.closePath();context.fillStrokeShape(this);}else{// open e.g. lines and splines
context.strokeShape(this);}},getTensionPoints:function getTensionPoints(){return this._getCache('tensionPoints',this._getTensionPoints);},_getTensionPoints:function _getTensionPoints(){if(this.getClosed()){return this._getTensionPointsClosed();}else{return Konva.Util._expandPoints(this.getPoints(),this.getTension());}},_getTensionPointsClosed:function _getTensionPointsClosed(){var p=this.getPoints(),len=p.length,tension=this.getTension(),util=Konva.Util,firstControlPoints=util._getControlPoints(p[len-2],p[len-1],p[0],p[1],p[2],p[3],tension),lastControlPoints=util._getControlPoints(p[len-4],p[len-3],p[len-2],p[len-1],p[0],p[1],tension),middle=Konva.Util._expandPoints(p,tension),tp=[firstControlPoints[2],firstControlPoints[3]].concat(middle).concat([lastControlPoints[0],lastControlPoints[1],p[len-2],p[len-1],lastControlPoints[2],lastControlPoints[3],firstControlPoints[0],firstControlPoints[1],p[0],p[1]]);return tp;},getWidth:function getWidth(){return this.getSelfRect().width;},getHeight:function getHeight(){return this.getSelfRect().height;},// overload size detection
getSelfRect:function getSelfRect(){var points;if(this.getTension()!==0){points=this._getTensionPoints();}else{points=this.getPoints();}var minX=points[0];var maxX=points[0];var minY=points[1];var maxY=points[1];var x,y;for(var i=0;i<points.length/2;i++){x=points[i*2];y=points[i*2+1];minX=Math.min(minX,x);maxX=Math.max(maxX,x);minY=Math.min(minY,y);maxY=Math.max(maxY,y);}return{x:Math.round(minX),y:Math.round(minY),width:Math.round(maxX-minX),height:Math.round(maxY-minY)};}};Konva.Util.extend(Konva.Line,Konva.Shape);// add getters setters
Konva.Factory.addGetterSetter(Konva.Line,'closed',false);/**
   * get/set closed flag.  The default is false
   * @name closed
   * @method
   * @memberof Konva.Line.prototype
   * @param {Boolean} closed
   * @returns {Boolean}
   * @example
   * // get closed flag
   * var closed = line.closed();
   *
   * // close the shape
   * line.closed(true);
   *
   * // open the shape
   * line.closed(false);
   */Konva.Factory.addGetterSetter(Konva.Line,'bezier',false);/**
   * get/set bezier flag.  The default is false
   * @name bezier
   * @method
   * @memberof Konva.Line.prototype
   * @param {Boolean} bezier
   * @returns {Boolean}
   * @example
   * // get whether the line is a bezier
   * var isBezier = line.bezier();
   *
   * // set whether the line is a bezier
   * line.bezier(true);
   */Konva.Factory.addGetterSetter(Konva.Line,'tension',0,Konva.Validators.getNumberValidator());/**
   * get/set tension
   * @name tension
   * @method
   * @memberof Konva.Line.prototype
   * @param {Number} Higher values will result in a more curvy line.  A value of 0 will result in no interpolation.
   *   The default is 0
   * @returns {Number}
   * @example
   * // get tension
   * var tension = line.tension();
   *
   * // set tension
   * line.tension(3);
   */Konva.Factory.addGetterSetter(Konva.Line,'points',[],Konva.Validators.getNumberArrayValidator());/**
   * get/set points array
   * @name points
   * @method
   * @memberof Konva.Line.prototype
   * @param {Array} points
   * @returns {Array}
   * @example
   * // get points
   * var points = line.points();
   *
   * // set points
   * line.points([10, 20, 30, 40, 50, 60]);
   *
   * // push a new point
   * line.points(line.points().concat([70, 80]));
   */Konva.Collection.mapMethods(Konva.Line);})();(function(){'use strict';/**
   * Sprite constructor
   * @constructor
   * @memberof Konva
   * @augments Konva.Shape
   * @param {Object} config
   * @param {String} config.animation animation key
   * @param {Object} config.animations animation map
   * @param {Integer} [config.frameIndex] animation frame index
   * @param {Image} config.image image object
   * @param {Integer} [config.frameRate] animation frame rate
   * @param {String} [config.fill] fill color
     * @param {Image} [config.fillPatternImage] fill pattern image
     * @param {Number} [config.fillPatternX]
     * @param {Number} [config.fillPatternY]
     * @param {Object} [config.fillPatternOffset] object with x and y component
     * @param {Number} [config.fillPatternOffsetX] 
     * @param {Number} [config.fillPatternOffsetY] 
     * @param {Object} [config.fillPatternScale] object with x and y component
     * @param {Number} [config.fillPatternScaleX]
     * @param {Number} [config.fillPatternScaleY]
     * @param {Number} [config.fillPatternRotation]
     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientStartPointX]
     * @param {Number} [config.fillLinearGradientStartPointY]
     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientEndPointX]
     * @param {Number} [config.fillLinearGradientEndPointY]
     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientStartPointX]
     * @param {Number} [config.fillRadialGradientStartPointY]
     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientEndPointX] 
     * @param {Number} [config.fillRadialGradientEndPointY] 
     * @param {Number} [config.fillRadialGradientStartRadius]
     * @param {Number} [config.fillRadialGradientEndRadius]
     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
     * @param {String} [config.stroke] stroke color
     * @param {Number} [config.strokeWidth] stroke width
     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
     *  is miter
     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
     *  is butt
     * @param {String} [config.shadowColor]
     * @param {Number} [config.shadowBlur]
     * @param {Object} [config.shadowOffset] object with x and y component
     * @param {Number} [config.shadowOffsetX]
     * @param {Number} [config.shadowOffsetY]
     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
     *  between 0 and 1
     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
     * @param {Array} [config.dash]
     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * @example
   * var imageObj = new Image();
   * imageObj.onload = function() {
   *   var sprite = new Konva.Sprite({
   *     x: 200,
   *     y: 100,
   *     image: imageObj,
   *     animation: 'standing',
   *     animations: {
   *       standing: [
   *         // x, y, width, height (6 frames)
   *         0, 0, 49, 109,
   *         52, 0, 49, 109,
   *         105, 0, 49, 109,
   *         158, 0, 49, 109,
   *         210, 0, 49, 109,
   *         262, 0, 49, 109
   *       ],
   *       kicking: [
   *         // x, y, width, height (6 frames)
   *         0, 109, 45, 98,
   *         45, 109, 45, 98,
   *         95, 109, 63, 98,
   *         156, 109, 70, 98,
   *         229, 109, 60, 98,
   *         287, 109, 41, 98
   *       ]
   *     },
   *     frameRate: 7,
   *     frameIndex: 0
   *   });
   * };
   * imageObj.src = '/path/to/image.jpg'
   */Konva.Sprite=function(config){this.___init(config);};Konva.Sprite.prototype={___init:function ___init(config){// call super constructor
Konva.Shape.call(this,config);this.className='Sprite';this._updated=true;var that=this;this.anim=new Konva.Animation(function(){// if we don't need to redraw layer we should return false
var updated=that._updated;that._updated=false;return updated;});this.on('animationChange.konva',function(){// reset index when animation changes
this.frameIndex(0);});this.on('frameIndexChange.konva',function(){this._updated=true;});// smooth change for frameRate
this.on('frameRateChange.konva',function(){if(!this.anim.isRunning()){return;}clearInterval(this.interval);this._setInterval();});this.sceneFunc(this._sceneFunc);this.hitFunc(this._hitFunc);},_sceneFunc:function _sceneFunc(context){var anim=this.getAnimation(),index=this.frameIndex(),ix4=index*4,set=this.getAnimations()[anim],offsets=this.frameOffsets(),x=set[ix4+0],y=set[ix4+1],width=set[ix4+2],height=set[ix4+3],image=this.getImage();if(this.hasFill()||this.hasStroke()){context.beginPath();context.rect(0,0,width,height);context.closePath();context.fillStrokeShape(this);}if(image){if(offsets){var offset=offsets[anim],ix2=index*2;context.drawImage(image,x,y,width,height,offset[ix2+0],offset[ix2+1],width,height);}else{context.drawImage(image,x,y,width,height,0,0,width,height);}}},_hitFunc:function _hitFunc(context){var anim=this.getAnimation(),index=this.frameIndex(),ix4=index*4,set=this.getAnimations()[anim],offsets=this.frameOffsets(),width=set[ix4+2],height=set[ix4+3];context.beginPath();if(offsets){var offset=offsets[anim];var ix2=index*2;context.rect(offset[ix2+0],offset[ix2+1],width,height);}else{context.rect(0,0,width,height);}context.closePath();context.fillShape(this);},_useBufferCanvas:function _useBufferCanvas(){return(this.hasShadow()||this.getAbsoluteOpacity()!==1)&&this.hasStroke();},_setInterval:function _setInterval(){var that=this;this.interval=setInterval(function(){that._updateIndex();},1000/this.getFrameRate());},/**
     * start sprite animation
     * @method
     * @memberof Konva.Sprite.prototype
     */start:function start(){if(this.isRunning()){return;}var layer=this.getLayer();/*
             * animation object has no executable function because
             *  the updates are done with a fixed FPS with the setInterval
             *  below.  The anim object only needs the layer reference for
             *  redraw
             */this.anim.setLayers(layer);this._setInterval();this.anim.start();},/**
     * stop sprite animation
     * @method
     * @memberof Konva.Sprite.prototype
     */stop:function stop(){this.anim.stop();clearInterval(this.interval);},/**
     * determine if animation of sprite is running or not.  returns true or false
     * @method
     * @memberof Konva.Animation.prototype
     * @returns {Boolean}
     */isRunning:function isRunning(){return this.anim.isRunning();},_updateIndex:function _updateIndex(){var index=this.frameIndex(),animation=this.getAnimation(),animations=this.getAnimations(),anim=animations[animation],len=anim.length/4;if(index<len-1){this.frameIndex(index+1);}else{this.frameIndex(0);}}};Konva.Util.extend(Konva.Sprite,Konva.Shape);// add getters setters
Konva.Factory.addGetterSetter(Konva.Sprite,'animation');/**
   * get/set animation key
   * @name animation
   * @method
   * @memberof Konva.Sprite.prototype
   * @param {String} anim animation key
   * @returns {String}
   * @example
   * // get animation key
   * var animation = sprite.animation();
   *
   * // set animation key
   * sprite.animation('kicking');
   */Konva.Factory.addGetterSetter(Konva.Sprite,'animations');/**
   * get/set animations map
   * @name animations
   * @method
   * @memberof Konva.Sprite.prototype
   * @param {Object} animations
   * @returns {Object}
   * @example
   * // get animations map
   * var animations = sprite.animations();
   *
   * // set animations map
   * sprite.animations({
   *   standing: [
   *     // x, y, width, height (6 frames)
   *     0, 0, 49, 109,
   *     52, 0, 49, 109,
   *     105, 0, 49, 109,
   *     158, 0, 49, 109,
   *     210, 0, 49, 109,
   *     262, 0, 49, 109
   *   ],
   *   kicking: [
   *     // x, y, width, height (6 frames)
   *     0, 109, 45, 98,
   *     45, 109, 45, 98,
   *     95, 109, 63, 98,
   *     156, 109, 70, 98,
   *     229, 109, 60, 98,
   *     287, 109, 41, 98
   *   ]
   * });
   */Konva.Factory.addGetterSetter(Konva.Sprite,'frameOffsets');/**
   * get/set offsets map
   * @name offsets
   * @method
   * @memberof Konva.Sprite.prototype
   * @param {Object} offsets
   * @returns {Object}
   * @example
   * // get offsets map
   * var offsets = sprite.offsets();
   *
   * // set offsets map
   * sprite.offsets({
   *   standing: [
   *     // x, y (6 frames)
   *     0, 0,
   *     0, 0,
   *     5, 0,
   *     0, 0,
   *     0, 3,
   *     2, 0
   *   ],
   *   kicking: [
   *     // x, y (6 frames)
   *     0, 5,
   *     5, 0,
   *     10, 0,
   *     0, 0,
   *     2, 1,
   *     0, 0
   *   ]
   * });
   */Konva.Factory.addGetterSetter(Konva.Sprite,'image');/**
   * get/set image
   * @name image
   * @method
   * @memberof Konva.Sprite.prototype
   * @param {Image} image
   * @returns {Image}
   * @example
   * // get image
   * var image = sprite.image();
   *
   * // set image
   * sprite.image(imageObj);
   */Konva.Factory.addGetterSetter(Konva.Sprite,'frameIndex',0,Konva.Validators.getNumberValidator());/**
   * set/set animation frame index
   * @name frameIndex
   * @method
   * @memberof Konva.Sprite.prototype
   * @param {Integer} frameIndex
   * @returns {Integer}
   * @example
   * // get animation frame index
   * var frameIndex = sprite.frameIndex();
   *
   * // set animation frame index
   * sprite.frameIndex(3);
   */Konva.Factory.addGetterSetter(Konva.Sprite,'frameRate',17,Konva.Validators.getNumberValidator());/**
   * get/set frame rate in frames per second.  Increase this number to make the sprite
   *  animation run faster, and decrease the number to make the sprite animation run slower
   *  The default is 17 frames per second
   * @name frameRate
   * @method
   * @memberof Konva.Sprite.prototype
   * @param {Integer} frameRate
   * @returns {Integer}
   * @example
   * // get frame rate
   * var frameRate = sprite.frameRate();
   *
   * // set frame rate to 2 frames per second
   * sprite.frameRate(2);
   */Konva.Factory.backCompat(Konva.Sprite,{index:'frameIndex',getIndex:'getFrameIndex',setIndex:'setFrameIndex'});Konva.Collection.mapMethods(Konva.Sprite);})();/*eslint-disable  no-shadow, max-len, max-depth */(function(){'use strict';/**
   * Path constructor.
   * @author Jason Follas
   * @constructor
   * @memberof Konva
   * @augments Konva.Shape
   * @param {Object} config
   * @param {String} config.data SVG data string
   * @param {String} [config.fill] fill color
     * @param {Image} [config.fillPatternImage] fill pattern image
     * @param {Number} [config.fillPatternX]
     * @param {Number} [config.fillPatternY]
     * @param {Object} [config.fillPatternOffset] object with x and y component
     * @param {Number} [config.fillPatternOffsetX] 
     * @param {Number} [config.fillPatternOffsetY] 
     * @param {Object} [config.fillPatternScale] object with x and y component
     * @param {Number} [config.fillPatternScaleX]
     * @param {Number} [config.fillPatternScaleY]
     * @param {Number} [config.fillPatternRotation]
     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientStartPointX]
     * @param {Number} [config.fillLinearGradientStartPointY]
     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientEndPointX]
     * @param {Number} [config.fillLinearGradientEndPointY]
     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientStartPointX]
     * @param {Number} [config.fillRadialGradientStartPointY]
     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientEndPointX] 
     * @param {Number} [config.fillRadialGradientEndPointY] 
     * @param {Number} [config.fillRadialGradientStartRadius]
     * @param {Number} [config.fillRadialGradientEndRadius]
     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
     * @param {String} [config.stroke] stroke color
     * @param {Number} [config.strokeWidth] stroke width
     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
     *  is miter
     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
     *  is butt
     * @param {String} [config.shadowColor]
     * @param {Number} [config.shadowBlur]
     * @param {Object} [config.shadowOffset] object with x and y component
     * @param {Number} [config.shadowOffsetX]
     * @param {Number} [config.shadowOffsetY]
     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
     *  between 0 and 1
     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
     * @param {Array} [config.dash]
     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * @example
   * var path = new Konva.Path({
   *   x: 240,
   *   y: 40,
   *   data: 'M12.582,9.551C3.251,16.237,0.921,29.021,7.08,38.564l-2.36,1.689l4.893,2.262l4.893,2.262l-0.568-5.36l-0.567-5.359l-2.365,1.694c-4.657-7.375-2.83-17.185,4.352-22.33c7.451-5.338,17.817-3.625,23.156,3.824c5.337,7.449,3.625,17.813-3.821,23.152l2.857,3.988c9.617-6.893,11.827-20.277,4.935-29.896C35.591,4.87,22.204,2.658,12.582,9.551z',
   *   fill: 'green',
   *   scale: 2
   * });
   */Konva.Path=function(config){this.___init(config);};Konva.Path.prototype={___init:function ___init(config){this.dataArray=[];var that=this;// call super constructor
Konva.Shape.call(this,config);this.className='Path';this.dataArray=Konva.Path.parsePathData(this.getData());this.pathLength=0;for(var i=0;i<this.dataArray.length;++i){this.pathLength+=this.dataArray[i].pathLength;}this.on('dataChange.konva',function(){that.dataArray=Konva.Path.parsePathData(this.getData());this.pathLength=0;for(var i=0;i<this.dataArray.length;++i){this.pathLength+=this.dataArray[i].pathLength;}});this.sceneFunc(this._sceneFunc);},_sceneFunc:function _sceneFunc(context){var ca=this.dataArray;// context position
context.beginPath();for(var n=0;n<ca.length;n++){var c=ca[n].command;var p=ca[n].points;switch(c){case'L':context.lineTo(p[0],p[1]);break;case'M':context.moveTo(p[0],p[1]);break;case'C':context.bezierCurveTo(p[0],p[1],p[2],p[3],p[4],p[5]);break;case'Q':context.quadraticCurveTo(p[0],p[1],p[2],p[3]);break;case'A':var cx=p[0],cy=p[1],rx=p[2],ry=p[3],theta=p[4],dTheta=p[5],psi=p[6],fs=p[7];var r=rx>ry?rx:ry;var scaleX=rx>ry?1:rx/ry;var scaleY=rx>ry?ry/rx:1;context.translate(cx,cy);context.rotate(psi);context.scale(scaleX,scaleY);context.arc(0,0,r,theta,theta+dTheta,1-fs);context.scale(1/scaleX,1/scaleY);context.rotate(-psi);context.translate(-cx,-cy);break;case'z':context.closePath();break;}}context.fillStrokeShape(this);},getSelfRect:function getSelfRect(){var points=[];this.dataArray.forEach(function(data){points=points.concat(data.points);});var minX=points[0];var maxX=points[0];var minY=points[1];var maxY=points[1];var x,y;for(var i=0;i<points.length/2;i++){x=points[i*2];y=points[i*2+1];// skip bad values
// TODO: prevent them from parsing function
if(!isNaN(x)){minX=Math.min(minX,x);maxX=Math.max(maxX,x);}if(!isNaN(y)){minY=Math.min(minY,y);maxY=Math.max(maxY,y);}}return{x:Math.round(minX),y:Math.round(minY),width:Math.round(maxX-minX),height:Math.round(maxY-minY)};},/**
     * Return length of the path.
     * @method
     * @memberof Konva.Path.prototype
     * @returns {Number} length
     * @example
     * var length = path.getLength();
     */getLength:function getLength(){return this.pathLength;},/**
     * Get point on path at specific length of the path
     * @method
     * @memberof Konva.Path.prototype
     * @param {Number} length length
     * @returns {Object} point {x,y} point
     * @example
     * var point = path.getPointAtLength(10);
     */getPointAtLength:function getPointAtLength(length){var point,i=0,ii=this.dataArray.length;if(!ii){return null;}while(i<ii&&length>this.dataArray[i].pathLength){length-=this.dataArray[i].pathLength;++i;}if(i===ii){point=this.dataArray[i-1].points.slice(-2);return{x:point[0],y:point[1]};}if(length<0.01){point=this.dataArray[i].points.slice(0,2);return{x:point[0],y:point[1]};}var cp=this.dataArray[i];var p=cp.points;switch(cp.command){case'L':return Konva.Path.getPointOnLine(length,cp.start.x,cp.start.y,p[0],p[1]);case'C':return Konva.Path.getPointOnCubicBezier(length/cp.pathLength,cp.start.x,cp.start.y,p[0],p[1],p[2],p[3],p[4],p[5]);case'Q':return Konva.Path.getPointOnQuadraticBezier(length/cp.pathLength,cp.start.x,cp.start.y,p[0],p[1],p[2],p[3]);case'A':var cx=p[0],cy=p[1],rx=p[2],ry=p[3],theta=p[4],dTheta=p[5],psi=p[6];theta+=dTheta*length/cp.pathLength;return Konva.Path.getPointOnEllipticalArc(cx,cy,rx,ry,theta,psi);}return null;}};Konva.Util.extend(Konva.Path,Konva.Shape);Konva.Path.getLineLength=function(x1,y1,x2,y2){return Math.sqrt((x2-x1)*(x2-x1)+(y2-y1)*(y2-y1));};Konva.Path.getPointOnLine=function(dist,P1x,P1y,P2x,P2y,fromX,fromY){if(fromX===undefined){fromX=P1x;}if(fromY===undefined){fromY=P1y;}var m=(P2y-P1y)/(P2x-P1x+0.00000001);var run=Math.sqrt(dist*dist/(1+m*m));if(P2x<P1x){run*=-1;}var rise=m*run;var pt;if(P2x===P1x){// vertical line
pt={x:fromX,y:fromY+rise};}else if((fromY-P1y)/(fromX-P1x+0.00000001)===m){pt={x:fromX+run,y:fromY+rise};}else{var ix,iy;var len=this.getLineLength(P1x,P1y,P2x,P2y);if(len<0.00000001){return undefined;}var u=(fromX-P1x)*(P2x-P1x)+(fromY-P1y)*(P2y-P1y);u=u/(len*len);ix=P1x+u*(P2x-P1x);iy=P1y+u*(P2y-P1y);var pRise=this.getLineLength(fromX,fromY,ix,iy);var pRun=Math.sqrt(dist*dist-pRise*pRise);run=Math.sqrt(pRun*pRun/(1+m*m));if(P2x<P1x){run*=-1;}rise=m*run;pt={x:ix+run,y:iy+rise};}return pt;};Konva.Path.getPointOnCubicBezier=function(pct,P1x,P1y,P2x,P2y,P3x,P3y,P4x,P4y){function CB1(t){return t*t*t;}function CB2(t){return 3*t*t*(1-t);}function CB3(t){return 3*t*(1-t)*(1-t);}function CB4(t){return(1-t)*(1-t)*(1-t);}var x=P4x*CB1(pct)+P3x*CB2(pct)+P2x*CB3(pct)+P1x*CB4(pct);var y=P4y*CB1(pct)+P3y*CB2(pct)+P2y*CB3(pct)+P1y*CB4(pct);return{x:x,y:y};};Konva.Path.getPointOnQuadraticBezier=function(pct,P1x,P1y,P2x,P2y,P3x,P3y){function QB1(t){return t*t;}function QB2(t){return 2*t*(1-t);}function QB3(t){return(1-t)*(1-t);}var x=P3x*QB1(pct)+P2x*QB2(pct)+P1x*QB3(pct);var y=P3y*QB1(pct)+P2y*QB2(pct)+P1y*QB3(pct);return{x:x,y:y};};Konva.Path.getPointOnEllipticalArc=function(cx,cy,rx,ry,theta,psi){var cosPsi=Math.cos(psi),sinPsi=Math.sin(psi);var pt={x:rx*Math.cos(theta),y:ry*Math.sin(theta)};return{x:cx+(pt.x*cosPsi-pt.y*sinPsi),y:cy+(pt.x*sinPsi+pt.y*cosPsi)};};/*
     * get parsed data array from the data
     *  string.  V, v, H, h, and l data are converted to
     *  L data for the purpose of high performance Path
     *  rendering
     */Konva.Path.parsePathData=function(data){// Path Data Segment must begin with a moveTo
//m (x y)+  Relative moveTo (subsequent points are treated as lineTo)
//M (x y)+  Absolute moveTo (subsequent points are treated as lineTo)
//l (x y)+  Relative lineTo
//L (x y)+  Absolute LineTo
//h (x)+    Relative horizontal lineTo
//H (x)+    Absolute horizontal lineTo
//v (y)+    Relative vertical lineTo
//V (y)+    Absolute vertical lineTo
//z (closepath)
//Z (closepath)
//c (x1 y1 x2 y2 x y)+ Relative Bezier curve
//C (x1 y1 x2 y2 x y)+ Absolute Bezier curve
//q (x1 y1 x y)+       Relative Quadratic Bezier
//Q (x1 y1 x y)+       Absolute Quadratic Bezier
//t (x y)+    Shorthand/Smooth Relative Quadratic Bezier
//T (x y)+    Shorthand/Smooth Absolute Quadratic Bezier
//s (x2 y2 x y)+       Shorthand/Smooth Relative Bezier curve
//S (x2 y2 x y)+       Shorthand/Smooth Absolute Bezier curve
//a (rx ry x-axis-rotation large-arc-flag sweep-flag x y)+     Relative Elliptical Arc
//A (rx ry x-axis-rotation large-arc-flag sweep-flag x y)+  Absolute Elliptical Arc
// return early if data is not defined
if(!data){return[];}// command string
var cs=data;// command chars
var cc=['m','M','l','L','v','V','h','H','z','Z','c','C','q','Q','t','T','s','S','a','A'];// convert white spaces to commas
cs=cs.replace(new RegExp(' ','g'),',');// create pipes so that we can split the data
for(var n=0;n<cc.length;n++){cs=cs.replace(new RegExp(cc[n],'g'),'|'+cc[n]);}// create array
var arr=cs.split('|');var ca=[];var coords=[];// init context point
var cpx=0;var cpy=0;var re=/([-+]?((\d+\.\d+)|((\d+)|(\.\d+)))(?:e[-+]?\d+)?)/gi;var match;for(n=1;n<arr.length;n++){var str=arr[n];var c=str.charAt(0);str=str.slice(1);coords.length=0;while(match=re.exec(str)){coords.push(match[0]);}// while ((match = re.exec(str))) {
//   coords.push(match[0]);
// }
var p=[];for(var j=0,jlen=coords.length;j<jlen;j++){var parsed=parseFloat(coords[j]);if(!isNaN(parsed)){p.push(parsed);}else{p.push(0);}}while(p.length>0){if(isNaN(p[0])){// case for a trailing comma before next command
break;}var cmd=null;var points=[];var startX=cpx,startY=cpy;// Move var from within the switch to up here (jshint)
var prevCmd,ctlPtx,ctlPty;// Ss, Tt
var rx,ry,psi,fa,fs,x1,y1;// Aa
// convert l, H, h, V, and v to L
switch(c){// Note: Keep the lineTo's above the moveTo's in this switch
case'l':cpx+=p.shift();cpy+=p.shift();cmd='L';points.push(cpx,cpy);break;case'L':cpx=p.shift();cpy=p.shift();points.push(cpx,cpy);break;// Note: lineTo handlers need to be above this point
case'm':var dx=p.shift();var dy=p.shift();cpx+=dx;cpy+=dy;cmd='M';// After closing the path move the current position
// to the the first point of the path (if any).
if(ca.length>2&&ca[ca.length-1].command==='z'){for(var idx=ca.length-2;idx>=0;idx--){if(ca[idx].command==='M'){cpx=ca[idx].points[0]+dx;cpy=ca[idx].points[1]+dy;break;}}}points.push(cpx,cpy);c='l';// subsequent points are treated as relative lineTo
break;case'M':cpx=p.shift();cpy=p.shift();cmd='M';points.push(cpx,cpy);c='L';// subsequent points are treated as absolute lineTo
break;case'h':cpx+=p.shift();cmd='L';points.push(cpx,cpy);break;case'H':cpx=p.shift();cmd='L';points.push(cpx,cpy);break;case'v':cpy+=p.shift();cmd='L';points.push(cpx,cpy);break;case'V':cpy=p.shift();cmd='L';points.push(cpx,cpy);break;case'C':points.push(p.shift(),p.shift(),p.shift(),p.shift());cpx=p.shift();cpy=p.shift();points.push(cpx,cpy);break;case'c':points.push(cpx+p.shift(),cpy+p.shift(),cpx+p.shift(),cpy+p.shift());cpx+=p.shift();cpy+=p.shift();cmd='C';points.push(cpx,cpy);break;case'S':ctlPtx=cpx;ctlPty=cpy;prevCmd=ca[ca.length-1];if(prevCmd.command==='C'){ctlPtx=cpx+(cpx-prevCmd.points[2]);ctlPty=cpy+(cpy-prevCmd.points[3]);}points.push(ctlPtx,ctlPty,p.shift(),p.shift());cpx=p.shift();cpy=p.shift();cmd='C';points.push(cpx,cpy);break;case's':ctlPtx=cpx;ctlPty=cpy;prevCmd=ca[ca.length-1];if(prevCmd.command==='C'){ctlPtx=cpx+(cpx-prevCmd.points[2]);ctlPty=cpy+(cpy-prevCmd.points[3]);}points.push(ctlPtx,ctlPty,cpx+p.shift(),cpy+p.shift());cpx+=p.shift();cpy+=p.shift();cmd='C';points.push(cpx,cpy);break;case'Q':points.push(p.shift(),p.shift());cpx=p.shift();cpy=p.shift();points.push(cpx,cpy);break;case'q':points.push(cpx+p.shift(),cpy+p.shift());cpx+=p.shift();cpy+=p.shift();cmd='Q';points.push(cpx,cpy);break;case'T':ctlPtx=cpx;ctlPty=cpy;prevCmd=ca[ca.length-1];if(prevCmd.command==='Q'){ctlPtx=cpx+(cpx-prevCmd.points[0]);ctlPty=cpy+(cpy-prevCmd.points[1]);}cpx=p.shift();cpy=p.shift();cmd='Q';points.push(ctlPtx,ctlPty,cpx,cpy);break;case't':ctlPtx=cpx;ctlPty=cpy;prevCmd=ca[ca.length-1];if(prevCmd.command==='Q'){ctlPtx=cpx+(cpx-prevCmd.points[0]);ctlPty=cpy+(cpy-prevCmd.points[1]);}cpx+=p.shift();cpy+=p.shift();cmd='Q';points.push(ctlPtx,ctlPty,cpx,cpy);break;case'A':rx=p.shift();ry=p.shift();psi=p.shift();fa=p.shift();fs=p.shift();x1=cpx;y1=cpy;cpx=p.shift();cpy=p.shift();cmd='A';points=this.convertEndpointToCenterParameterization(x1,y1,cpx,cpy,fa,fs,rx,ry,psi);break;case'a':rx=p.shift();ry=p.shift();psi=p.shift();fa=p.shift();fs=p.shift();x1=cpx;y1=cpy;cpx+=p.shift();cpy+=p.shift();cmd='A';points=this.convertEndpointToCenterParameterization(x1,y1,cpx,cpy,fa,fs,rx,ry,psi);break;}ca.push({command:cmd||c,points:points,start:{x:startX,y:startY},pathLength:this.calcLength(startX,startY,cmd||c,points)});}if(c==='z'||c==='Z'){ca.push({command:'z',points:[],start:undefined,pathLength:0});}}return ca;};Konva.Path.calcLength=function(x,y,cmd,points){var len,p1,p2,t;var path=Konva.Path;switch(cmd){case'L':return path.getLineLength(x,y,points[0],points[1]);case'C':// Approximates by breaking curve into 100 line segments
len=0.0;p1=path.getPointOnCubicBezier(0,x,y,points[0],points[1],points[2],points[3],points[4],points[5]);for(t=0.01;t<=1;t+=0.01){p2=path.getPointOnCubicBezier(t,x,y,points[0],points[1],points[2],points[3],points[4],points[5]);len+=path.getLineLength(p1.x,p1.y,p2.x,p2.y);p1=p2;}return len;case'Q':// Approximates by breaking curve into 100 line segments
len=0.0;p1=path.getPointOnQuadraticBezier(0,x,y,points[0],points[1],points[2],points[3]);for(t=0.01;t<=1;t+=0.01){p2=path.getPointOnQuadraticBezier(t,x,y,points[0],points[1],points[2],points[3]);len+=path.getLineLength(p1.x,p1.y,p2.x,p2.y);p1=p2;}return len;case'A':// Approximates by breaking curve into line segments
len=0.0;var start=points[4];// 4 = theta
var dTheta=points[5];// 5 = dTheta
var end=points[4]+dTheta;var inc=Math.PI/180.0;// 1 degree resolution
if(Math.abs(start-end)<inc){inc=Math.abs(start-end);}// Note: for purpose of calculating arc length, not going to worry about rotating X-axis by angle psi
p1=path.getPointOnEllipticalArc(points[0],points[1],points[2],points[3],start,0);if(dTheta<0){// clockwise
for(t=start-inc;t>end;t-=inc){p2=path.getPointOnEllipticalArc(points[0],points[1],points[2],points[3],t,0);len+=path.getLineLength(p1.x,p1.y,p2.x,p2.y);p1=p2;}}else{// counter-clockwise
for(t=start+inc;t<end;t+=inc){p2=path.getPointOnEllipticalArc(points[0],points[1],points[2],points[3],t,0);len+=path.getLineLength(p1.x,p1.y,p2.x,p2.y);p1=p2;}}p2=path.getPointOnEllipticalArc(points[0],points[1],points[2],points[3],end,0);len+=path.getLineLength(p1.x,p1.y,p2.x,p2.y);return len;}return 0;};Konva.Path.convertEndpointToCenterParameterization=function(x1,y1,x2,y2,fa,fs,rx,ry,psiDeg){// Derived from: http://www.w3.org/TR/SVG/implnote.html#ArcImplementationNotes
var psi=psiDeg*(Math.PI/180.0);var xp=Math.cos(psi)*(x1-x2)/2.0+Math.sin(psi)*(y1-y2)/2.0;var yp=-1*Math.sin(psi)*(x1-x2)/2.0+Math.cos(psi)*(y1-y2)/2.0;var lambda=xp*xp/(rx*rx)+yp*yp/(ry*ry);if(lambda>1){rx*=Math.sqrt(lambda);ry*=Math.sqrt(lambda);}var f=Math.sqrt((rx*rx*(ry*ry)-rx*rx*(yp*yp)-ry*ry*(xp*xp))/(rx*rx*(yp*yp)+ry*ry*(xp*xp)));if(fa===fs){f*=-1;}if(isNaN(f)){f=0;}var cxp=f*rx*yp/ry;var cyp=f*-ry*xp/rx;var cx=(x1+x2)/2.0+Math.cos(psi)*cxp-Math.sin(psi)*cyp;var cy=(y1+y2)/2.0+Math.sin(psi)*cxp+Math.cos(psi)*cyp;var vMag=function vMag(v){return Math.sqrt(v[0]*v[0]+v[1]*v[1]);};var vRatio=function vRatio(u,v){return(u[0]*v[0]+u[1]*v[1])/(vMag(u)*vMag(v));};var vAngle=function vAngle(u,v){return(u[0]*v[1]<u[1]*v[0]?-1:1)*Math.acos(vRatio(u,v));};var theta=vAngle([1,0],[(xp-cxp)/rx,(yp-cyp)/ry]);var u=[(xp-cxp)/rx,(yp-cyp)/ry];var v=[(-1*xp-cxp)/rx,(-1*yp-cyp)/ry];var dTheta=vAngle(u,v);if(vRatio(u,v)<=-1){dTheta=Math.PI;}if(vRatio(u,v)>=1){dTheta=0;}if(fs===0&&dTheta>0){dTheta=dTheta-2*Math.PI;}if(fs===1&&dTheta<0){dTheta=dTheta+2*Math.PI;}return[cx,cy,rx,ry,theta,dTheta,psi,fs];};// add getters setters
Konva.Factory.addGetterSetter(Konva.Path,'data');/**
   * set SVG path data string.  This method
   *  also automatically parses the data string
   *  into a data array.  Currently supported SVG data:
   *  M, m, L, l, H, h, V, v, Q, q, T, t, C, c, S, s, A, a, Z, z
   * @name setData
   * @method
   * @memberof Konva.Path.prototype
   * @param {String} SVG path command string
   *//**
   * get SVG path data string
   * @name getData
   * @method
   * @memberof Konva.Path.prototype
   */Konva.Collection.mapMethods(Konva.Path);})();(function(){'use strict';var EMPTY_STRING='',//CALIBRI = 'Calibri',
NORMAL='normal';/**
   * Path constructor.
   * @author Jason Follas
   * @constructor
   * @memberof Konva
   * @augments Konva.Shape
   * @param {Object} config
   * @param {String} [config.fontFamily] default is Calibri
   * @param {Number} [config.fontSize] default is 12
   * @param {String} [config.fontStyle] can be normal, bold, or italic.  Default is normal
   * @param {String} [config.fontVariant] can be normal or small-caps.  Default is normal
   * @param {String} config.text
   * @param {String} config.data SVG data string
   * @param {Function} config.getKerning a getter for kerning values for the specified characters
   * @param {String} [config.fill] fill color
     * @param {Image} [config.fillPatternImage] fill pattern image
     * @param {Number} [config.fillPatternX]
     * @param {Number} [config.fillPatternY]
     * @param {Object} [config.fillPatternOffset] object with x and y component
     * @param {Number} [config.fillPatternOffsetX] 
     * @param {Number} [config.fillPatternOffsetY] 
     * @param {Object} [config.fillPatternScale] object with x and y component
     * @param {Number} [config.fillPatternScaleX]
     * @param {Number} [config.fillPatternScaleY]
     * @param {Number} [config.fillPatternRotation]
     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientStartPointX]
     * @param {Number} [config.fillLinearGradientStartPointY]
     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientEndPointX]
     * @param {Number} [config.fillLinearGradientEndPointY]
     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientStartPointX]
     * @param {Number} [config.fillRadialGradientStartPointY]
     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientEndPointX] 
     * @param {Number} [config.fillRadialGradientEndPointY] 
     * @param {Number} [config.fillRadialGradientStartRadius]
     * @param {Number} [config.fillRadialGradientEndRadius]
     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
     * @param {String} [config.stroke] stroke color
     * @param {Number} [config.strokeWidth] stroke width
     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
     *  is miter
     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
     *  is butt
     * @param {String} [config.shadowColor]
     * @param {Number} [config.shadowBlur]
     * @param {Object} [config.shadowOffset] object with x and y component
     * @param {Number} [config.shadowOffsetX]
     * @param {Number} [config.shadowOffsetY]
     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
     *  between 0 and 1
     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
     * @param {Array} [config.dash]
     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * @example
   * var kerningPairs = {
   *   'A': {
   *     ' ': -0.05517578125,
   *     'T': -0.07421875,
   *     'V': -0.07421875,
   *   },
   *   'V': {
   *     ',': -0.091796875,
   *     ":": -0.037109375,
   *     ";": -0.037109375,
   *     "A": -0.07421875,
   *   }
   * }
   * var textpath = new Konva.TextPath({
   *   x: 100,
   *   y: 50,
   *   fill: '#333',
   *   fontSize: '24',
   *   fontFamily: 'Arial',
   *   text: 'All the world\'s a stage, and all the men and women merely players.',
   *   data: 'M10,10 C0,0 10,150 100,100 S300,150 400,50',
   *   getKerning: function(leftChar, rightChar) {
   *     return kerningPairs.hasOwnProperty(leftChar) ? pairs[leftChar][rightChar] || 0 : 0
   *   }
   * });
   */Konva.TextPath=function(config){this.___init(config);};function _fillFunc(context){context.fillText(this.partialText,0,0);}function _strokeFunc(context){context.strokeText(this.partialText,0,0);}Konva.TextPath.prototype={___init:function ___init(config){var that=this;this.dummyCanvas=Konva.Util.createCanvasElement();this.dataArray=[];this.getKerning=config&&config.getKerning;// call super constructor
Konva.Shape.call(this,config);// overrides
// TODO: shouldn't this be on the prototype?
this._fillFunc=_fillFunc;this._strokeFunc=_strokeFunc;this._fillFuncHit=_fillFunc;this._strokeFuncHit=_strokeFunc;this.className='TextPath';this.dataArray=Konva.Path.parsePathData(this.attrs.data);this.on('dataChange.konva',function(){that.dataArray=Konva.Path.parsePathData(this.attrs.data);that._setTextData();});// update text data for certain attr changes
this.on('textChange.konva alignChange.konva letterSpacingChange.konva',that._setTextData);that._setTextData();this.sceneFunc(this._sceneFunc);this.hitFunc(this._hitFunc);},_sceneFunc:function _sceneFunc(context){context.setAttr('font',this._getContextFont());context.setAttr('textBaseline',this.getTextBaseline());context.setAttr('textAlign','left');context.save();var textDecoration=this.textDecoration();var fill=this.fill();var fontSize=this.fontSize();var glyphInfo=this.glyphInfo;if(textDecoration==='underline'){context.beginPath();}for(var i=0;i<glyphInfo.length;i++){context.save();var p0=glyphInfo[i].p0;context.translate(p0.x,p0.y);context.rotate(glyphInfo[i].rotation);this.partialText=glyphInfo[i].text;context.fillStrokeShape(this);if(textDecoration==='underline'){if(i===0){context.moveTo(0,fontSize/2+1);}context.lineTo(fontSize,fontSize/2+1);}context.restore();//// To assist with debugging visually, uncomment following
//
// if (i % 2)
// context.strokeStyle = 'cyan';
// else
// context.strokeStyle = 'green';
// var p1 = glyphInfo[i].p1;
// context.moveTo(p0.x, p0.y);
// context.lineTo(p1.x, p1.y);
// context.stroke();
}if(textDecoration==='underline'){context.strokeStyle=fill;context.lineWidth=fontSize/20;context.stroke();}context.restore();},_hitFunc:function _hitFunc(context){context.beginPath();var glyphInfo=this.glyphInfo;if(glyphInfo.length>=1){var p0=glyphInfo[0].p0;context.moveTo(p0.x,p0.y);}for(var i=0;i<glyphInfo.length;i++){var p1=glyphInfo[i].p1;context.lineTo(p1.x,p1.y);}context.setAttr('lineWidth',this.getFontSize());context.setAttr('strokeStyle',this.colorKey);context.stroke();},/**
     * get text width in pixels
     * @method
     * @memberof Konva.TextPath.prototype
     */getTextWidth:function getTextWidth(){return this.textWidth;},/**
     * get text height in pixels
     * @method
     * @memberof Konva.TextPath.prototype
     */getTextHeight:function getTextHeight(){return this.textHeight;},/**
     * set text
     * @method
     * @memberof Konva.TextPath.prototype
     * @param {String} text
     */setText:function setText(text){Konva.Text.prototype.setText.call(this,text);},_getTextSize:function _getTextSize(text){var dummyCanvas=this.dummyCanvas;var _context=dummyCanvas.getContext('2d');_context.save();_context.font=this._getContextFont();var metrics=_context.measureText(text);_context.restore();return{width:metrics.width,height:parseInt(this.attrs.fontSize,10)};},_setTextData:function _setTextData(){var that=this;var size=this._getTextSize(this.attrs.text);var letterSpacing=this.getLetterSpacing();var align=this.align();this.textWidth=size.width;this.textHeight=size.height;var textFullWidth=Math.max(this.textWidth+((this.attrs.text||'').length-1)*letterSpacing,0);this.glyphInfo=[];var fullPathWidth=0;for(var l=0;l<that.dataArray.length;l++){if(that.dataArray[l].pathLength>0){fullPathWidth+=that.dataArray[l].pathLength;}}var offset=0;if(align==='center'){offset=Math.max(0,fullPathWidth/2-textFullWidth/2);}if(align==='right'){offset=Math.max(0,fullPathWidth-textFullWidth);}var charArr=this.getText().split('');var spacesNumber=this.getText().split(' ').length-1;var p0,p1,pathCmd;var pIndex=-1;var currentT=0;// var sumLength = 0;
// for(var j = 0; j < that.dataArray.length; j++) {
//   if(that.dataArray[j].pathLength > 0) {
//
//     if (sumLength + that.dataArray[j].pathLength > offset) {}
//       fullPathWidth += that.dataArray[j].pathLength;
//   }
// }
var getNextPathSegment=function getNextPathSegment(){currentT=0;var pathData=that.dataArray;for(var j=pIndex+1;j<pathData.length;j++){if(pathData[j].pathLength>0){pIndex=j;return pathData[j];}else if(pathData[j].command==='M'){p0={x:pathData[j].points[0],y:pathData[j].points[1]};}}return{};};var findSegmentToFitCharacter=function findSegmentToFitCharacter(c){var glyphWidth=that._getTextSize(c).width+letterSpacing;if(c===' '&&align==='justify'){glyphWidth+=(fullPathWidth-textFullWidth)/spacesNumber;}var currLen=0;var attempts=0;p1=undefined;while(Math.abs(glyphWidth-currLen)/glyphWidth>0.01&&attempts<25){attempts++;var cumulativePathLength=currLen;while(pathCmd===undefined){pathCmd=getNextPathSegment();if(pathCmd&&cumulativePathLength+pathCmd.pathLength<glyphWidth){cumulativePathLength+=pathCmd.pathLength;pathCmd=undefined;}}if(pathCmd==={}||p0===undefined){return undefined;}var needNewSegment=false;switch(pathCmd.command){case'L':if(Konva.Path.getLineLength(p0.x,p0.y,pathCmd.points[0],pathCmd.points[1])>glyphWidth){p1=Konva.Path.getPointOnLine(glyphWidth,p0.x,p0.y,pathCmd.points[0],pathCmd.points[1],p0.x,p0.y);}else{pathCmd=undefined;}break;case'A':var start=pathCmd.points[4];// 4 = theta
var dTheta=pathCmd.points[5];// 5 = dTheta
var end=pathCmd.points[4]+dTheta;if(currentT===0){currentT=start+0.00000001;}else if(glyphWidth>currLen){// Just in case start is 0
currentT+=Math.PI/180.0*dTheta/Math.abs(dTheta);}else{currentT-=Math.PI/360.0*dTheta/Math.abs(dTheta);}// Credit for bug fix: @therth https://github.com/ericdrowell/KonvaJS/issues/249
// Old code failed to render text along arc of this path: "M 50 50 a 150 50 0 0 1 250 50 l 50 0"
if(dTheta<0&&currentT<end||dTheta>=0&&currentT>end){currentT=end;needNewSegment=true;}p1=Konva.Path.getPointOnEllipticalArc(pathCmd.points[0],pathCmd.points[1],pathCmd.points[2],pathCmd.points[3],currentT,pathCmd.points[6]);break;case'C':if(currentT===0){if(glyphWidth>pathCmd.pathLength){currentT=0.00000001;}else{currentT=glyphWidth/pathCmd.pathLength;}}else if(glyphWidth>currLen){currentT+=(glyphWidth-currLen)/pathCmd.pathLength;}else{currentT-=(currLen-glyphWidth)/pathCmd.pathLength;}if(currentT>1.0){currentT=1.0;needNewSegment=true;}p1=Konva.Path.getPointOnCubicBezier(currentT,pathCmd.start.x,pathCmd.start.y,pathCmd.points[0],pathCmd.points[1],pathCmd.points[2],pathCmd.points[3],pathCmd.points[4],pathCmd.points[5]);break;case'Q':if(currentT===0){currentT=glyphWidth/pathCmd.pathLength;}else if(glyphWidth>currLen){currentT+=(glyphWidth-currLen)/pathCmd.pathLength;}else{currentT-=(currLen-glyphWidth)/pathCmd.pathLength;}if(currentT>1.0){currentT=1.0;needNewSegment=true;}p1=Konva.Path.getPointOnQuadraticBezier(currentT,pathCmd.start.x,pathCmd.start.y,pathCmd.points[0],pathCmd.points[1],pathCmd.points[2],pathCmd.points[3]);break;}if(p1!==undefined){currLen=Konva.Path.getLineLength(p0.x,p0.y,p1.x,p1.y);}if(needNewSegment){needNewSegment=false;pathCmd=undefined;}}};// fake search for offset, this is very bad approach
// TODO: find other way to add offset from start (for align)
var testChar='C';var glyphWidth=that._getTextSize(testChar).width+letterSpacing;for(var k=0;k<offset/glyphWidth;k++){findSegmentToFitCharacter(testChar);if(p0===undefined||p1===undefined){break;}p0=p1;}for(var i=0;i<charArr.length;i++){// Find p1 such that line segment between p0 and p1 is approx. width of glyph
findSegmentToFitCharacter(charArr[i]);if(p0===undefined||p1===undefined){break;}var width=Konva.Path.getLineLength(p0.x,p0.y,p1.x,p1.y);var kern=0;if(this.getKerning){try{// getKerning is a user provided getter. Make sure it never breaks our logic
kern=this.getKerning(charArr[i-1],charArr[i])*this.fontSize();}catch(e){kern=0;}}p0.x+=kern;p1.x+=kern;this.textWidth+=kern;var midpoint=Konva.Path.getPointOnLine(kern+width/2.0,p0.x,p0.y,p1.x,p1.y);var rotation=Math.atan2(p1.y-p0.y,p1.x-p0.x);this.glyphInfo.push({transposeX:midpoint.x,transposeY:midpoint.y,text:charArr[i],rotation:rotation,p0:p0,p1:p1});p0=p1;}},getSelfRect:function getSelfRect(){var points=[];this.glyphInfo.forEach(function(info){points.push(info.p0.x);points.push(info.p0.y);points.push(info.p1.x);points.push(info.p1.y);});var minX=points[0];var maxX=points[0];var minY=points[0];var maxY=points[0];var x,y;for(var i=0;i<points.length/2;i++){x=points[i*2];y=points[i*2+1];minX=Math.min(minX,x);maxX=Math.max(maxX,x);minY=Math.min(minY,y);maxY=Math.max(maxY,y);}var fontSize=this.fontSize();return{x:Math.round(minX)-fontSize/2,y:Math.round(minY)-fontSize/2,width:Math.round(maxX-minX)+fontSize,height:Math.round(maxY-minY)+fontSize};}};// map TextPath methods to Text
Konva.TextPath.prototype._getContextFont=Konva.Text.prototype._getContextFont;Konva.Util.extend(Konva.TextPath,Konva.Shape);// add setters and getters
Konva.Factory.addGetterSetter(Konva.TextPath,'data');/**
   * set SVG path data string.  This method
   *  also automatically parses the data string
   *  into a data array.  Currently supported SVG data:
   *  M, m, L, l, H, h, V, v, Q, q, T, t, C, c, S, s, A, a, Z, z
   * @name setData
   * @method
   * @memberof Konva.TextPath.prototype
   * @param {String} SVG path command string
   *//**
   * get SVG path data string
   * @name getData
   * @method
   * @memberof Konva.TextPath.prototype
   */Konva.Factory.addGetterSetter(Konva.TextPath,'fontFamily','Arial');/**
   * set font family
   * @name setFontFamily
   * @method
   * @memberof Konva.TextPath.prototype
   * @param {String} fontFamily
   *//**
   * get font family
   * @name getFontFamily
   * @method
   * @memberof Konva.TextPath.prototype
   */Konva.Factory.addGetterSetter(Konva.TextPath,'fontSize',12,Konva.Validators.getNumberValidator());/**
   * set font size
   * @name setFontSize
   * @method
   * @memberof Konva.TextPath.prototype
   * @param {int} fontSize
   *//**
   * get font size
   * @name getFontSize
   * @method
   * @memberof Konva.TextPath.prototype
   */Konva.Factory.addGetterSetter(Konva.TextPath,'fontStyle',NORMAL);/**
   * set font style.  Can be 'normal', 'italic', or 'bold'.  'normal' is the default.
   * @name setFontStyle
   * @method
   * @memberof Konva.TextPath.prototype
   * @param {String} fontStyle
   */Konva.Factory.addGetterSetter(Konva.TextPath,'align','left');/**
   * get/set horizontal align of text.  Can be 'left', 'center', 'right' or 'justify'
   * @name align
   * @method
   * @memberof Konva.Text.prototype
   * @param {String} align
   * @returns {String}
   * @example
   * // get text align
   * var align = text.align();
   *
   * // center text
   * text.align('center');
   *
   * // align text to right
   * text.align('right');
   */Konva.Factory.addGetterSetter(Konva.TextPath,'letterSpacing',0,Konva.Validators.getNumberValidator());/**
   * set letter spacing property. Default value is 0.
   * @name letterSpacing
   * @method
   * @memberof Konva.TextPath.prototype
   * @param {Number} letterSpacing
   */Konva.Factory.addGetterSetter(Konva.TextPath,'textBaseline','middle');/**
   * set textBaseline property. Default value is 'middle'.
   * Can be 'top', 'bottom', 'middle', 'alphabetic', 'hanging'
   * @name textBaseline
   * @method
   * @memberof Konva.TextPath.prototype
   * @param {Number} textBaseline
   *//**
   * get font style
   * @name getFontStyle
   * @method
   * @memberof Konva.TextPath.prototype
   */Konva.Factory.addGetterSetter(Konva.TextPath,'fontVariant',NORMAL);/**
   * set font variant.  Can be 'normal' or 'small-caps'.  'normal' is the default.
   * @name setFontVariant
   * @method
   * @memberof Konva.TextPath.prototype
   * @param {String} fontVariant
   *//**
   * @get font variant
   * @name getFontVariant
   * @method
   * @memberof Konva.TextPath.prototype
   */Konva.Factory.addGetter(Konva.TextPath,'text',EMPTY_STRING);/**
   * get text
   * @name getText
   * @method
   * @memberof Konva.TextPath.prototype
   */Konva.Factory.addGetterSetter(Konva.TextPath,'textDecoration',null);/**
   * get/set text decoration of a text.  Can be '' or 'underline'
   * @name textDecoration
   * @method
   * @memberof Konva.Text.prototype
   * @param {String} textDecoration
   * @returns {String}
   * @example
   * // get text decoration
   * var textDecoration = text.textDecoration();
   *
   * // center text
   * text.textDecoration('underline');
   */Konva.Collection.mapMethods(Konva.TextPath);})();(function(){'use strict';/**
   * RegularPolygon constructor.&nbsp; Examples include triangles, squares, pentagons, hexagons, etc.
   * @constructor
   * @memberof Konva
   * @augments Konva.Shape
   * @param {Object} config
   * @param {Number} config.sides
   * @param {Number} config.radius
   * @param {String} [config.fill] fill color
     * @param {Image} [config.fillPatternImage] fill pattern image
     * @param {Number} [config.fillPatternX]
     * @param {Number} [config.fillPatternY]
     * @param {Object} [config.fillPatternOffset] object with x and y component
     * @param {Number} [config.fillPatternOffsetX] 
     * @param {Number} [config.fillPatternOffsetY] 
     * @param {Object} [config.fillPatternScale] object with x and y component
     * @param {Number} [config.fillPatternScaleX]
     * @param {Number} [config.fillPatternScaleY]
     * @param {Number} [config.fillPatternRotation]
     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientStartPointX]
     * @param {Number} [config.fillLinearGradientStartPointY]
     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientEndPointX]
     * @param {Number} [config.fillLinearGradientEndPointY]
     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientStartPointX]
     * @param {Number} [config.fillRadialGradientStartPointY]
     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientEndPointX] 
     * @param {Number} [config.fillRadialGradientEndPointY] 
     * @param {Number} [config.fillRadialGradientStartRadius]
     * @param {Number} [config.fillRadialGradientEndRadius]
     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
     * @param {String} [config.stroke] stroke color
     * @param {Number} [config.strokeWidth] stroke width
     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
     *  is miter
     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
     *  is butt
     * @param {String} [config.shadowColor]
     * @param {Number} [config.shadowBlur]
     * @param {Object} [config.shadowOffset] object with x and y component
     * @param {Number} [config.shadowOffsetX]
     * @param {Number} [config.shadowOffsetY]
     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
     *  between 0 and 1
     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
     * @param {Array} [config.dash]
     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * @example
   * var hexagon = new Konva.RegularPolygon({
   *   x: 100,
   *   y: 200,
   *   sides: 6,
   *   radius: 70,
   *   fill: 'red',
   *   stroke: 'black',
   *   strokeWidth: 4
   * });
   */Konva.RegularPolygon=function(config){this.___init(config);};Konva.RegularPolygon.prototype={_centroid:true,___init:function ___init(config){// call super constructor
Konva.Shape.call(this,config);this.className='RegularPolygon';this.sceneFunc(this._sceneFunc);},_sceneFunc:function _sceneFunc(context){var sides=this.attrs.sides,radius=this.attrs.radius,n,x,y;context.beginPath();context.moveTo(0,0-radius);for(n=1;n<sides;n++){x=radius*Math.sin(n*2*Math.PI/sides);y=-1*radius*Math.cos(n*2*Math.PI/sides);context.lineTo(x,y);}context.closePath();context.fillStrokeShape(this);},getWidth:function getWidth(){return this.getRadius()*2;},// implements Shape.prototype.getHeight()
getHeight:function getHeight(){return this.getRadius()*2;},// implements Shape.prototype.setWidth()
setWidth:function setWidth(width){Konva.Node.prototype.setWidth.call(this,width);if(this.radius()!==width/2){this.setRadius(width/2);}},// implements Shape.prototype.setHeight()
setHeight:function setHeight(height){Konva.Node.prototype.setHeight.call(this,height);if(this.radius()!==height/2){this.setRadius(height/2);}}};Konva.Util.extend(Konva.RegularPolygon,Konva.Shape);// add getters setters
Konva.Factory.addGetterSetter(Konva.RegularPolygon,'radius',0,Konva.Validators.getNumberValidator());/**
   * set radius
   * @name setRadius
   * @method
   * @memberof Konva.RegularPolygon.prototype
   * @param {Number} radius
   *//**
   * get radius
   * @name getRadius
   * @method
   * @memberof Konva.RegularPolygon.prototype
   */Konva.Factory.addGetterSetter(Konva.RegularPolygon,'sides',0,Konva.Validators.getNumberValidator());/**
   * set number of sides
   * @name setSides
   * @method
   * @memberof Konva.RegularPolygon.prototype
   * @param {int} sides
   *//**
   * get number of sides
   * @name getSides
   * @method
   * @memberof Konva.RegularPolygon.prototype
   */Konva.Collection.mapMethods(Konva.RegularPolygon);})();(function(){'use strict';/**
   * Star constructor
   * @constructor
   * @memberof Konva
   * @augments Konva.Shape
   * @param {Object} config
   * @param {Integer} config.numPoints
   * @param {Number} config.innerRadius
   * @param {Number} config.outerRadius
   * @param {String} [config.fill] fill color
     * @param {Image} [config.fillPatternImage] fill pattern image
     * @param {Number} [config.fillPatternX]
     * @param {Number} [config.fillPatternY]
     * @param {Object} [config.fillPatternOffset] object with x and y component
     * @param {Number} [config.fillPatternOffsetX] 
     * @param {Number} [config.fillPatternOffsetY] 
     * @param {Object} [config.fillPatternScale] object with x and y component
     * @param {Number} [config.fillPatternScaleX]
     * @param {Number} [config.fillPatternScaleY]
     * @param {Number} [config.fillPatternRotation]
     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientStartPointX]
     * @param {Number} [config.fillLinearGradientStartPointY]
     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientEndPointX]
     * @param {Number} [config.fillLinearGradientEndPointY]
     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientStartPointX]
     * @param {Number} [config.fillRadialGradientStartPointY]
     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientEndPointX] 
     * @param {Number} [config.fillRadialGradientEndPointY] 
     * @param {Number} [config.fillRadialGradientStartRadius]
     * @param {Number} [config.fillRadialGradientEndRadius]
     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
     * @param {String} [config.stroke] stroke color
     * @param {Number} [config.strokeWidth] stroke width
     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
     *  is miter
     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
     *  is butt
     * @param {String} [config.shadowColor]
     * @param {Number} [config.shadowBlur]
     * @param {Object} [config.shadowOffset] object with x and y component
     * @param {Number} [config.shadowOffsetX]
     * @param {Number} [config.shadowOffsetY]
     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
     *  between 0 and 1
     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
     * @param {Array} [config.dash]
     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * @example
   * var star = new Konva.Star({
   *   x: 100,
   *   y: 200,
   *   numPoints: 5,
   *   innerRadius: 70,
   *   outerRadius: 70,
   *   fill: 'red',
   *   stroke: 'black',
   *   strokeWidth: 4
   * });
   */Konva.Star=function(config){this.___init(config);};Konva.Star.prototype={_centroid:true,___init:function ___init(config){// call super constructor
Konva.Shape.call(this,config);this.className='Star';this.sceneFunc(this._sceneFunc);},_sceneFunc:function _sceneFunc(context){var innerRadius=this.innerRadius(),outerRadius=this.outerRadius(),numPoints=this.numPoints();context.beginPath();context.moveTo(0,0-outerRadius);for(var n=1;n<numPoints*2;n++){var radius=n%2===0?outerRadius:innerRadius;var x=radius*Math.sin(n*Math.PI/numPoints);var y=-1*radius*Math.cos(n*Math.PI/numPoints);context.lineTo(x,y);}context.closePath();context.fillStrokeShape(this);},// implements Shape.prototype.getWidth()
getWidth:function getWidth(){return this.getOuterRadius()*2;},// implements Shape.prototype.getHeight()
getHeight:function getHeight(){return this.getOuterRadius()*2;},// implements Shape.prototype.setWidth()
setWidth:function setWidth(width){Konva.Node.prototype.setWidth.call(this,width);if(this.outerRadius()!==width/2){this.setOuterRadius(width/2);}},// implements Shape.prototype.setHeight()
setHeight:function setHeight(height){Konva.Node.prototype.setHeight.call(this,height);if(this.outerRadius()!==height/2){this.setOuterRadius(height/2);}}};Konva.Util.extend(Konva.Star,Konva.Shape);// add getters setters
Konva.Factory.addGetterSetter(Konva.Star,'numPoints',5,Konva.Validators.getNumberValidator());/**
   * set number of points
   * @name setNumPoints
   * @method
   * @memberof Konva.Star.prototype
   * @param {Integer} points
   *//**
   * get number of points
   * @name getNumPoints
   * @method
   * @memberof Konva.Star.prototype
   */Konva.Factory.addGetterSetter(Konva.Star,'innerRadius',0,Konva.Validators.getNumberValidator());/**
   * set inner radius
   * @name setInnerRadius
   * @method
   * @memberof Konva.Star.prototype
   * @param {Number} radius
   *//**
   * get inner radius
   * @name getInnerRadius
   * @method
   * @memberof Konva.Star.prototype
   */Konva.Factory.addGetterSetter(Konva.Star,'outerRadius',0,Konva.Validators.getNumberValidator());/**
   * set outer radius
   * @name setOuterRadius
   * @method
   * @memberof Konva.Star.prototype
   * @param {Number} radius
   *//**
   * get outer radius
   * @name getOuterRadius
   * @method
   * @memberof Konva.Star.prototype
   */Konva.Collection.mapMethods(Konva.Star);})();(function(){'use strict';// constants
var ATTR_CHANGE_LIST=['fontFamily','fontSize','fontStyle','padding','lineHeight','text','width'],CHANGE_KONVA='Change.konva',NONE='none',UP='up',RIGHT='right',DOWN='down',LEFT='left',LABEL='Label',// cached variables
attrChangeListLen=ATTR_CHANGE_LIST.length;/**
   * Label constructor.&nbsp; Labels are groups that contain a Text and Tag shape
   * @constructor
   * @memberof Konva
   * @param {Object} config
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * @example
   * // create label
   * var label = new Konva.Label({
   *   x: 100,
   *   y: 100,
   *   draggable: true
   * });
   *
   * // add a tag to the label
   * label.add(new Konva.Tag({
   *   fill: '#bbb',
   *   stroke: '#333',
   *   shadowColor: 'black',
   *   shadowBlur: 10,
   *   shadowOffset: [10, 10],
   *   shadowOpacity: 0.2,
   *   lineJoin: 'round',
   *   pointerDirection: 'up',
   *   pointerWidth: 20,
   *   pointerHeight: 20,
   *   cornerRadius: 5
   * }));
   *
   * // add text to the label
   * label.add(new Konva.Text({
   *   text: 'Hello World!',
   *   fontSize: 50,
   *   lineHeight: 1.2,
   *   padding: 10,
   *   fill: 'green'
   *  }));
   */Konva.Label=function(config){this.____init(config);};Konva.Label.prototype={____init:function ____init(config){var that=this;Konva.Group.call(this,config);this.className=LABEL;this.on('add.konva',function(evt){that._addListeners(evt.child);that._sync();});},/**
     * get Text shape for the label.  You need to access the Text shape in order to update
     * the text properties
     * @name getText
     * @method
     * @memberof Konva.Label.prototype
     */getText:function getText(){return this.find('Text')[0];},/**
     * get Tag shape for the label.  You need to access the Tag shape in order to update
     * the pointer properties and the corner radius
     * @name getTag
     * @method
     * @memberof Konva.Label.prototype
     */getTag:function getTag(){return this.find('Tag')[0];},_addListeners:function _addListeners(text){var that=this,n;var func=function func(){that._sync();};// update text data for certain attr changes
for(n=0;n<attrChangeListLen;n++){text.on(ATTR_CHANGE_LIST[n]+CHANGE_KONVA,func);}},getWidth:function getWidth(){return this.getText().getWidth();},getHeight:function getHeight(){return this.getText().getHeight();},_sync:function _sync(){var text=this.getText(),tag=this.getTag(),width,height,pointerDirection,pointerWidth,x,y,pointerHeight;if(text&&tag){width=text.getWidth();height=text.getHeight();pointerDirection=tag.getPointerDirection();pointerWidth=tag.getPointerWidth();pointerHeight=tag.getPointerHeight();x=0;y=0;switch(pointerDirection){case UP:x=width/2;y=-1*pointerHeight;break;case RIGHT:x=width+pointerWidth;y=height/2;break;case DOWN:x=width/2;y=height+pointerHeight;break;case LEFT:x=-1*pointerWidth;y=height/2;break;}tag.setAttrs({x:-1*x,y:-1*y,width:width,height:height});text.setAttrs({x:-1*x,y:-1*y});}}};Konva.Util.extend(Konva.Label,Konva.Group);Konva.Collection.mapMethods(Konva.Label);/**
   * Tag constructor.&nbsp; A Tag can be configured
   *  to have a pointer element that points up, right, down, or left
   * @constructor
   * @memberof Konva
   * @param {Object} config
   * @param {String} [config.pointerDirection] can be up, right, down, left, or none; the default
   *  is none.  When a pointer is present, the positioning of the label is relative to the tip of the pointer.
   * @param {Number} [config.pointerWidth]
   * @param {Number} [config.pointerHeight]
   * @param {Number} [config.cornerRadius]
   */Konva.Tag=function(config){this.___init(config);};Konva.Tag.prototype={___init:function ___init(config){Konva.Shape.call(this,config);this.className='Tag';this.sceneFunc(this._sceneFunc);},_sceneFunc:function _sceneFunc(context){var width=this.getWidth(),height=this.getHeight(),pointerDirection=this.getPointerDirection(),pointerWidth=this.getPointerWidth(),pointerHeight=this.getPointerHeight(),cornerRadius=Math.min(this.getCornerRadius(),width/2,height/2);context.beginPath();if(!cornerRadius){context.moveTo(0,0);}else{context.moveTo(cornerRadius,0);}if(pointerDirection===UP){context.lineTo((width-pointerWidth)/2,0);context.lineTo(width/2,-1*pointerHeight);context.lineTo((width+pointerWidth)/2,0);}if(!cornerRadius){context.lineTo(width,0);}else{context.lineTo(width-cornerRadius,0);context.arc(width-cornerRadius,cornerRadius,cornerRadius,Math.PI*3/2,0,false);}if(pointerDirection===RIGHT){context.lineTo(width,(height-pointerHeight)/2);context.lineTo(width+pointerWidth,height/2);context.lineTo(width,(height+pointerHeight)/2);}if(!cornerRadius){context.lineTo(width,height);}else{context.lineTo(width,height-cornerRadius);context.arc(width-cornerRadius,height-cornerRadius,cornerRadius,0,Math.PI/2,false);}if(pointerDirection===DOWN){context.lineTo((width+pointerWidth)/2,height);context.lineTo(width/2,height+pointerHeight);context.lineTo((width-pointerWidth)/2,height);}if(!cornerRadius){context.lineTo(0,height);}else{context.lineTo(cornerRadius,height);context.arc(cornerRadius,height-cornerRadius,cornerRadius,Math.PI/2,Math.PI,false);}if(pointerDirection===LEFT){context.lineTo(0,(height+pointerHeight)/2);context.lineTo(-1*pointerWidth,height/2);context.lineTo(0,(height-pointerHeight)/2);}if(cornerRadius){context.lineTo(0,cornerRadius);context.arc(cornerRadius,cornerRadius,cornerRadius,Math.PI,Math.PI*3/2,false);}context.closePath();context.fillStrokeShape(this);},getSelfRect:function getSelfRect(){var x=0,y=0,pointerWidth=this.getPointerWidth(),pointerHeight=this.getPointerHeight(),direction=this.pointerDirection(),width=this.getWidth(),height=this.getHeight();if(direction===UP){y-=pointerHeight;height+=pointerHeight;}else if(direction===DOWN){height+=pointerHeight;}else if(direction===LEFT){// ARGH!!! I have no idea why should I used magic 1.5!!!!!!!!!
x-=pointerWidth*1.5;width+=pointerWidth;}else if(direction===RIGHT){width+=pointerWidth*1.5;}return{x:x,y:y,width:width,height:height};}};Konva.Util.extend(Konva.Tag,Konva.Shape);Konva.Factory.addGetterSetter(Konva.Tag,'pointerDirection',NONE);/**
   * set pointer Direction
   * @name setPointerDirection
   * @method
   * @memberof Konva.Tag.prototype
   * @param {String} pointerDirection can be up, right, down, left, or none.  The
   *  default is none
   *//**
   * get pointer Direction
   * @name getPointerDirection
   * @method
   * @memberof Konva.Tag.prototype
   */Konva.Factory.addGetterSetter(Konva.Tag,'pointerWidth',0,Konva.Validators.getNumberValidator());/**
   * set pointer width
   * @name setPointerWidth
   * @method
   * @memberof Konva.Tag.prototype
   * @param {Number} pointerWidth
   *//**
   * get pointer width
   * @name getPointerWidth
   * @method
   * @memberof Konva.Tag.prototype
   */Konva.Factory.addGetterSetter(Konva.Tag,'pointerHeight',0,Konva.Validators.getNumberValidator());/**
   * set pointer height
   * @name setPointerHeight
   * @method
   * @memberof Konva.Tag.prototype
   * @param {Number} pointerHeight
   *//**
   * get pointer height
   * @name getPointerHeight
   * @method
   * @memberof Konva.Tag.prototype
   */Konva.Factory.addGetterSetter(Konva.Tag,'cornerRadius',0,Konva.Validators.getNumberValidator());/**
   * set corner radius
   * @name setCornerRadius
   * @method
   * @memberof Konva.Tag.prototype
   * @param {Number} corner radius
   *//**
   * get corner radius
   * @name getCornerRadius
   * @method
   * @memberof Konva.Tag.prototype
   */Konva.Collection.mapMethods(Konva.Tag);})();(function(Konva){'use strict';/**
   * Arrow constructor
   * @constructor
   * @memberof Konva
   * @augments Konva.Shape
   * @param {Object} config
   * @param {Array} config.points Flat array of points coordinates. You should define them as [x1, y1, x2, y2, x3, y3].
   * @param {Number} [config.tension] Higher values will result in a more curvy line.  A value of 0 will result in no interpolation.
   *   The default is 0
   * @param {Number} config.pointerLength Arrow pointer length. Default value is 10.
   * @param {Number} config.pointerWidth Arrow pointer width. Default value is 10.
   * @param {Boolean} config.pointerAtBeginning Do we need to draw pointer on both sides?. Default false.
   * @param {String} [config.fill] fill color
     * @param {Image} [config.fillPatternImage] fill pattern image
     * @param {Number} [config.fillPatternX]
     * @param {Number} [config.fillPatternY]
     * @param {Object} [config.fillPatternOffset] object with x and y component
     * @param {Number} [config.fillPatternOffsetX] 
     * @param {Number} [config.fillPatternOffsetY] 
     * @param {Object} [config.fillPatternScale] object with x and y component
     * @param {Number} [config.fillPatternScaleX]
     * @param {Number} [config.fillPatternScaleY]
     * @param {Number} [config.fillPatternRotation]
     * @param {String} [config.fillPatternRepeat] can be "repeat", "repeat-x", "repeat-y", or "no-repeat".  The default is "no-repeat"
     * @param {Object} [config.fillLinearGradientStartPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientStartPointX]
     * @param {Number} [config.fillLinearGradientStartPointY]
     * @param {Object} [config.fillLinearGradientEndPoint] object with x and y component
     * @param {Number} [config.fillLinearGradientEndPointX]
     * @param {Number} [config.fillLinearGradientEndPointY]
     * @param {Array} [config.fillLinearGradientColorStops] array of color stops
     * @param {Object} [config.fillRadialGradientStartPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientStartPointX]
     * @param {Number} [config.fillRadialGradientStartPointY]
     * @param {Object} [config.fillRadialGradientEndPoint] object with x and y component
     * @param {Number} [config.fillRadialGradientEndPointX] 
     * @param {Number} [config.fillRadialGradientEndPointY] 
     * @param {Number} [config.fillRadialGradientStartRadius]
     * @param {Number} [config.fillRadialGradientEndRadius]
     * @param {Array} [config.fillRadialGradientColorStops] array of color stops
     * @param {Boolean} [config.fillEnabled] flag which enables or disables the fill.  The default value is true
     * @param {String} [config.fillPriority] can be color, linear-gradient, radial-graident, or pattern.  The default value is color.  The fillPriority property makes it really easy to toggle between different fill types.  For example, if you want to toggle between a fill color style and a fill pattern style, simply set the fill property and the fillPattern properties, and then use setFillPriority('color') to render the shape with a color fill, or use setFillPriority('pattern') to render the shape with the pattern fill configuration
     * @param {String} [config.stroke] stroke color
     * @param {Number} [config.strokeWidth] stroke width
     * @param {Boolean} [config.strokeHitEnabled] flag which enables or disables stroke hit region.  The default is true
     * @param {Boolean} [config.perfectDrawEnabled] flag which enables or disables using buffer canvas.  The default is true
     * @param {Boolean} [config.shadowForStrokeEnabled] flag which enables or disables shasow for stroke.  The default is true
     * @param {Boolean} [config.strokeScaleEnabled] flag which enables or disables stroke scale.  The default is true
     * @param {Boolean} [config.strokeEnabled] flag which enables or disables the stroke.  The default value is true
     * @param {String} [config.lineJoin] can be miter, round, or bevel.  The default
     *  is miter
     * @param {String} [config.lineCap] can be butt, round, or sqare.  The default
     *  is butt
     * @param {String} [config.shadowColor]
     * @param {Number} [config.shadowBlur]
     * @param {Object} [config.shadowOffset] object with x and y component
     * @param {Number} [config.shadowOffsetX]
     * @param {Number} [config.shadowOffsetY]
     * @param {Number} [config.shadowOpacity] shadow opacity.  Can be any real number
     *  between 0 and 1
     * @param {Boolean} [config.shadowEnabled] flag which enables or disables the shadow.  The default value is true
     * @param {Array} [config.dash]
     * @param {Boolean} [config.dashEnabled] flag which enables or disables the dashArray.  The default value is true
   * @param {Number} [config.x]
     * @param {Number} [config.y]
     * @param {Number} [config.width]
     * @param {Number} [config.height]
     * @param {Boolean} [config.visible]
     * @param {Boolean} [config.listening] whether or not the node is listening for events
     * @param {String} [config.id] unique id
     * @param {String} [config.name] non-unique name
     * @param {Number} [config.opacity] determines node opacity.  Can be any number between 0 and 1
     * @param {Object} [config.scale] set scale
     * @param {Number} [config.scaleX] set scale x
     * @param {Number} [config.scaleY] set scale y
     * @param {Number} [config.rotation] rotation in degrees
     * @param {Object} [config.offset] offset from center point and rotation point
     * @param {Number} [config.offsetX] set offset x
     * @param {Number} [config.offsetY] set offset y
     * @param {Boolean} [config.draggable] makes the node draggable.  When stages are draggable, you can drag and drop
     *  the entire stage by dragging any portion of the stage
     * @param {Number} [config.dragDistance]
     * @param {Function} [config.dragBoundFunc]
   * @example
   * var line = new Konva.Line({
   *   points: [73, 70, 340, 23, 450, 60, 500, 20],
   *   stroke: 'red',
   *   tension: 1,
   *   pointerLength : 10,
   *   pointerWidth : 12
   * });
   */Konva.Arrow=function(config){this.____init(config);};Konva.Arrow.prototype={____init:function ____init(config){// call super constructor
Konva.Line.call(this,config);this.className='Arrow';},_sceneFunc:function _sceneFunc(ctx){Konva.Line.prototype._sceneFunc.apply(this,arguments);var PI2=Math.PI*2;var points=this.points();var tp=points;var fromTension=this.getTension()!==0&&points.length>4;if(fromTension){tp=this.getTensionPoints();}var n=points.length;var dx,dy;if(fromTension){dx=points[n-2]-tp[n-2];dy=points[n-1]-tp[n-1];}else{dx=points[n-2]-points[n-4];dy=points[n-1]-points[n-3];}var radians=(Math.atan2(dy,dx)+PI2)%PI2;var length=this.pointerLength();var width=this.pointerWidth();ctx.save();ctx.beginPath();ctx.translate(points[n-2],points[n-1]);ctx.rotate(radians);ctx.moveTo(0,0);ctx.lineTo(-length,width/2);ctx.lineTo(-length,-width/2);ctx.closePath();ctx.restore();if(this.pointerAtBeginning()){ctx.save();ctx.translate(points[0],points[1]);if(fromTension){dx=tp[0]-points[0];dy=tp[1]-points[1];}else{dx=points[2]-points[0];dy=points[3]-points[1];}ctx.rotate((Math.atan2(-dy,-dx)+PI2)%PI2);ctx.moveTo(0,0);ctx.lineTo(-length,width/2);ctx.lineTo(-length,-width/2);ctx.closePath();ctx.restore();}// here is a tricky part
// we need to disable dash for arrow pointers
var isDashEnabled=this.dashEnabled();if(isDashEnabled){// manually disable dash for head
// it is better not to use setter here,
// because it will trigger attr change event
this.attrs.dashEnabled=false;ctx.setLineDash([]);}ctx.fillStrokeShape(this);// restore old value
if(isDashEnabled){this.attrs.dashEnabled=true;}}};Konva.Util.extend(Konva.Arrow,Konva.Line);/**
   * get/set pointerLength
   * @name pointerLength
   * @method
   * @memberof Konva.Arrow.prototype
   * @param {Number} Length of pointer of arrow.
   *   The default is 10.
   * @returns {Number}
   * @example
   * // get tension
   * var pointerLength = line.pointerLength();
   *
   * // set tension
   * line.pointerLength(15);
   */Konva.Factory.addGetterSetter(Konva.Arrow,'pointerLength',10,Konva.Validators.getNumberValidator());/**
   * get/set pointerWidth
   * @name pointerWidth
   * @method
   * @memberof Konva.Arrow.prototype
   * @param {Number} Width of pointer of arrow.
   *   The default is 10.
   * @returns {Number}
   * @example
   * // get tension
   * var pointerWidth = line.pointerWidth();
   *
   * // set tension
   * line.pointerWidth(15);
   */Konva.Factory.addGetterSetter(Konva.Arrow,'pointerWidth',10,Konva.Validators.getNumberValidator());/**
   * get/set pointerAtBeginning
   * @name pointerAtBeginning
   * @method
   * @memberof Konva.Arrow.prototype
   * @param {Number} Should pointer displayed at beginning of arrow.
   *   The default is false.
   * @returns {Boolean}
   * @example
   * // get tension
   * var pointerAtBeginning = line.pointerAtBeginning();
   *
   * // set tension
   * line.pointerAtBeginning(true);
   */Konva.Factory.addGetterSetter(Konva.Arrow,'pointerAtBeginning',false);Konva.Collection.mapMethods(Konva.Arrow);})(Konva);(function(Konva){'use strict';var ATTR_CHANGE_LIST=['resizeEnabledChange','rotateAnchorOffsetChange','rotateEnabledChange','enabledAnchorsChange','anchorSizeChange','borderEnabledChange','borderStrokeChange','borderStrokeWidthChange','anchorStrokeChange','anchorStrokeWidthChange','anchorFillChange','anchorCornerRadiusChange'].join(' ');var NODE_RECT='nodeRect';var TRANSFORM_CHANGE_STR=['xChange.resizer','yChange.resizer','widthChange.resizer','heightChange.resizer','scaleXChange.resizer','scaleYChange.resizer','skewXChange.resizer','skewYChange.resizer','rotationChange.resizer','offsetXChange.resizer','offsetYChange.resizer','transformsEnabledChange.resizer'].join(' ');var REDRAW_CHANGE_STR=['widthChange.resizer','heightChange.resizer','scaleXChange.resizer','scaleYChange.resizer','skewXChange.resizer','skewYChange.resizer','rotationChange.resizer','offsetXChange.resizer','offsetYChange.resizer'].join(' ');var ANGLES={'top-left':-45,'top-center':0,'top-right':45,'middle-right':-90,'middle-left':90,'bottom-left':-135,'bottom-center':180,'bottom-right':135};function getCursor(anchorName,rad,isMirrored){if(anchorName==='rotater'){return'crosshair';}rad+=Konva.Util._degToRad(ANGLES[anchorName]||0);// If we are mirrored, we need to mirror the angle (this is not the same as
// rotate).
if(isMirrored){rad*=-1;}var angle=(Konva.Util._radToDeg(rad)%360+360)%360;if(Konva.Util._inRange(angle,315+22.5,360)||Konva.Util._inRange(angle,0,22.5)){// TOP
return'ns-resize';}else if(Konva.Util._inRange(angle,45-22.5,45+22.5)){// TOP - RIGHT
return'nesw-resize';}else if(Konva.Util._inRange(angle,90-22.5,90+22.5)){// RIGHT
return'ew-resize';}else if(Konva.Util._inRange(angle,135-22.5,135+22.5)){// BOTTOM - RIGHT
return'nwse-resize';}else if(Konva.Util._inRange(angle,180-22.5,180+22.5)){// BOTTOM
return'ns-resize';}else if(Konva.Util._inRange(angle,225-22.5,225+22.5)){// BOTTOM - LEFT
return'nesw-resize';}else if(Konva.Util._inRange(angle,270-22.5,270+22.5)){// RIGHT
return'ew-resize';}else if(Konva.Util._inRange(angle,315-22.5,315+22.5)){// BOTTOM - RIGHT
return'nwse-resize';}else{// how can we can there?
// TODO: throw error
Konva.Util.error('Transformer has unknown angle for cursor detection: '+angle);return'pointer';}}/**
   * Transformer constructor.  Transformer is a special type of group that allow you transform Konva
   * primitives and shapes. Transforming tool is not changing `width` and `height` properties of nodes
   * when you resize them. Instead it changes `scaleX` and `scaleY` properties.
   * @constructor
   * @memberof Konva
   * @param {Object} config
   * @param {Boolean} [config.resizeEnabled] Default is true
   * @param {Boolean} [config.rotateEnabled] Default is true
   * @param {Array} [config.rotationSnaps] Array of angles for rotation snaps. Default is []
   * @param {Number} [config.rotateAnchorOffset] Default is 50
   * @param {Number} [config.padding] Default is 0
   * @param {Boolean} [config.borderEnabled] Should we draw border? Default is true
   * @param {String} [config.borderStroke] Border stroke color
   * @param {Number} [config.borderStrokeWidth] Border stroke size
   * @param {Array} [config.borderDash] Array for border dash.
   * @param {String} [config.anchorFill] Anchor fill color
   * @param {String} [config.anchorStroke] Anchor stroke color
   * @param {String} [config.anchorCornerRadius] Anchor corner radius
   * @param {Number} [config.anchorStrokeWidth] Anchor stroke size
   * @param {Number} [config.anchorSize] Default is 10
   * @param {Boolean} [config.keepRatio] Should we keep ratio when we are moving edges? Default is true
   * @param {Boolean} [config.centeredScaling] Should we resize relative to node's center? Default is false
   * @param {Array} [config.enabledAnchors] Array of names of enabled handles
   * @param {Function} [config.boundBoxFunc] Bounding box function
   * @example
   * var transformer = new Konva.Transformer({
   *   node: rectangle,
   *   rotateAnchorOffset: 60,
   *   enabledAnchors: ['top-left', 'top-right', 'bottom-left', 'bottom-right']
   * });
   * layer.add(transformer);
   */Konva.Transformer=function(config){this.____init(config);};var ANCHORS_NAMES=['top-left','top-center','top-right','middle-right','middle-left','bottom-left','bottom-center','bottom-right'];Konva.Transformer.prototype={_centroid:false,____init:function ____init(config){// call super constructor
Konva.Group.call(this,config);this.className='Transformer';this._createElements();// bindings
this._handleMouseMove=this._handleMouseMove.bind(this);this._handleMouseUp=this._handleMouseUp.bind(this);this.update=this.update.bind(this);// update transformer data for certain attr changes
this.on(ATTR_CHANGE_LIST,this.update);if(this.getNode()){this.update();}},/**
     * alias to `setNode`
     * @method
     * @memberof Konva.Transformer.prototype
     * @returns {Konva.Transformer}
     * @example
     * transformer.attachTo(shape);
     */attachTo:function attachTo(node){this.setNode(node);},/**
     * attach transformer to a Konva.Node. Transformer will adapt to its size and listen its events
     * @method
     * @memberof Konva.Transformer.prototype
     * @returns {Konva.Transformer}
     * @example
     * transformer.setNode(shape);
     */setNode:function setNode(node){if(this._node){this.detach();}this._node=node;this._resetTransformCache();node.on(TRANSFORM_CHANGE_STR,this._resetTransformCache.bind(this));node.on(REDRAW_CHANGE_STR,function(){if(!this._transforming){this.update();}}.bind(this));// TODO: why do we need this?
var elementsCreated=!!this.findOne('.top-left');if(elementsCreated){this.update();}return this;},getNode:function getNode(){return this._node;},/**
     * detach transformer from a attached node
     * @method
     * @memberof Konva.Transformer.prototype
     * @returns {Konva.Transformer}
     * @example
     * transformer.detach();
     */detach:function detach(){if(this.getNode()){this.getNode().off('.resizer');this._node=undefined;}this._resetTransformCache();},_resetTransformCache:function _resetTransformCache(){this._clearCache(NODE_RECT);this._clearCache('transform');this._clearSelfAndDescendantCache('absoluteTransform');},_getNodeRect:function _getNodeRect(){return this._getCache(NODE_RECT,this.__getNodeRect);},__getNodeRect:function __getNodeRect(){var node=this.getNode();if(!node){return{x:-Number.MAX_SAFE_INTEGER,y:-Number.MAX_SAFE_INTEGER,width:0,height:0,rotation:0};}var rect=node.getClientRect({skipTransform:true,skipShadow:true});var rotation=Konva.getAngle(node.rotation());var dx=rect.x*node.scaleX()-node.offsetX()*node.scaleX();var dy=rect.y*node.scaleY()-node.offsetY()*node.scaleY();return{x:node.x()+dx*Math.cos(rotation)+dy*Math.sin(-rotation),y:node.y()+dy*Math.cos(rotation)+dx*Math.sin(rotation),width:rect.width*node.scaleX(),height:rect.height*node.scaleY(),rotation:node.rotation()};},getX:function getX(){return this._getNodeRect().x;},getY:function getY(){return this._getNodeRect().y;},getRotation:function getRotation(){return this._getNodeRect().rotation;},getWidth:function getWidth(){return this._getNodeRect().width;},getHeight:function getHeight(){return this._getNodeRect().height;},_createElements:function _createElements(){this._createBack();ANCHORS_NAMES.forEach(function(name){this._createAnchor(name);}.bind(this));this._createAnchor('rotater');},_createAnchor:function _createAnchor(name){var anchor=new Konva.Rect({stroke:'rgb(0, 161, 255)',fill:'white',strokeWidth:1,name:name+' _anchor',dragDistance:0,draggable:true});var self=this;anchor.on('mousedown touchstart',function(e){self._handleMouseDown(e);});anchor.on('dragstart',function(e){e.cancelBubble=true;});anchor.on('dragmove',function(e){e.cancelBubble=true;});anchor.on('dragend',function(e){e.cancelBubble=true;});// add hover styling
anchor.on('mouseenter',function(){var tr=this.getParent();var rad=Konva.getAngle(tr.rotation());var scale=tr.getNode().getAbsoluteScale();// If scale.y < 0 xor scale.x < 0 we need to flip (not rotate).
var isMirrored=scale.y*scale.x<0;var cursor=getCursor(name,rad,isMirrored);anchor.getStage().content.style.cursor=cursor;tr._cursorChange=true;});anchor.on('mouseout',function(){if(!anchor.getStage()||!this.getParent()){return;}anchor.getStage().content.style.cursor='';this.getParent()._cursorChange=false;});this.add(anchor);},_createBack:function _createBack(){var back=new Konva.Shape({name:'back',width:0,height:0,listening:false,sceneFunc:function sceneFunc(ctx){var tr=this.getParent();var padding=tr.getPadding();ctx.beginPath();ctx.rect(-padding,-padding,this.width()+padding*2,this.height()+padding*2);ctx.moveTo(this.width()/2,-padding);if(tr.rotateEnabled()){ctx.lineTo(this.width()/2,-tr.rotateAnchorOffset()*Konva.Util._sign(this.height()));}ctx.fillStrokeShape(this);}});this.add(back);},_handleMouseDown:function _handleMouseDown(e){this.movingResizer=e.target.name().split(' ')[0];// var node = this.getNode();
var attrs=this._getNodeRect();var width=attrs.width;var height=attrs.height;var hypotenuse=Math.sqrt(Math.pow(width,2)+Math.pow(height,2));this.sin=height/hypotenuse;this.cos=width/hypotenuse;window.addEventListener('mousemove',this._handleMouseMove);window.addEventListener('touchmove',this._handleMouseMove);window.addEventListener('mouseup',this._handleMouseUp,true);window.addEventListener('touchend',this._handleMouseUp,true);this._transforming=true;this._fire('transformstart',{evt:e});this.getNode()._fire('transformstart',{evt:e});},_handleMouseMove:function _handleMouseMove(e){var x,y,newHypotenuse;var resizerNode=this.findOne('.'+this.movingResizer);var stage=resizerNode.getStage();var box=stage.getContent().getBoundingClientRect();var zeroPoint={x:box.left,y:box.top};var pointerPos={left:e.clientX!==undefined?e.clientX:e.touches[0].clientX,top:e.clientX!==undefined?e.clientY:e.touches[0].clientY};var newAbsPos={x:pointerPos.left-zeroPoint.x,y:pointerPos.top-zeroPoint.y};resizerNode.setAbsolutePosition(newAbsPos);var keepProportion=this.keepRatio()||e.shiftKey;// console.log(keepProportion);
if(this.movingResizer==='top-left'){if(keepProportion){newHypotenuse=Math.sqrt(Math.pow(this.findOne('.bottom-right').x()-resizerNode.x(),2)+Math.pow(this.findOne('.bottom-right').y()-resizerNode.y(),2));x=newHypotenuse*this.cos;y=newHypotenuse*this.sin;this.findOne('.top-left').x(this.findOne('.bottom-right').x()-x);this.findOne('.top-left').y(this.findOne('.bottom-right').y()-y);}}else if(this.movingResizer==='top-center'){this.findOne('.top-left').y(resizerNode.y());}else if(this.movingResizer==='top-right'){if(keepProportion){newHypotenuse=Math.sqrt(Math.pow(this.findOne('.bottom-left').x()-resizerNode.x(),2)+Math.pow(this.findOne('.bottom-left').y()-resizerNode.y(),2));x=newHypotenuse*this.cos;y=newHypotenuse*this.sin;this.findOne('.top-right').x(x);this.findOne('.top-right').y(this.findOne('.bottom-left').y()-y);}var pos=resizerNode.position();this.findOne('.top-left').y(pos.y);this.findOne('.bottom-right').x(pos.x);}else if(this.movingResizer==='middle-left'){this.findOne('.top-left').x(resizerNode.x());}else if(this.movingResizer==='middle-right'){this.findOne('.bottom-right').x(resizerNode.x());}else if(this.movingResizer==='bottom-left'){if(keepProportion){newHypotenuse=Math.sqrt(Math.pow(this.findOne('.top-right').x()-resizerNode.x(),2)+Math.pow(this.findOne('.top-right').y()-resizerNode.y(),2));x=newHypotenuse*this.cos;y=newHypotenuse*this.sin;this.findOne('.bottom-left').x(this.findOne('.top-right').x()-x);this.findOne('.bottom-left').y(y);}pos=resizerNode.position();this.findOne('.top-left').x(pos.x);this.findOne('.bottom-right').y(pos.y);}else if(this.movingResizer==='bottom-center'){this.findOne('.bottom-right').y(resizerNode.y());}else if(this.movingResizer==='bottom-right'){if(keepProportion){newHypotenuse=Math.sqrt(Math.pow(this.findOne('.bottom-right').x(),2)+Math.pow(this.findOne('.bottom-right').y(),2));x=newHypotenuse*this.cos;y=newHypotenuse*this.sin;this.findOne('.bottom-right').x(x);this.findOne('.bottom-right').y(y);}}else if(this.movingResizer==='rotater'){var padding=this.getPadding();var attrs=this._getNodeRect();x=resizerNode.x()-attrs.width/2;y=-resizerNode.y()+attrs.height/2;var dAlpha=Math.atan2(-y,x)+Math.PI/2;if(attrs.height<0){dAlpha-=Math.PI;}var rot=Konva.getAngle(this.rotation());var newRotation=Konva.Util._radToDeg(rot)+Konva.Util._radToDeg(dAlpha);var alpha=Konva.getAngle(this.getNode().rotation());var newAlpha=Konva.Util._degToRad(newRotation);var snaps=this.rotationSnaps();var offset=0.1;for(var i=0;i<snaps.length;i++){var angle=Konva.getAngle(snaps[i]);var dif=Math.abs(angle-Konva.Util._degToRad(newRotation))%(Math.PI*2);if(dif<offset){newRotation=Konva.Util._radToDeg(angle);newAlpha=Konva.Util._degToRad(newRotation);}}var dx=padding;var dy=padding;this._fitNodeInto({rotation:Konva.angleDeg?newRotation:Konva.Util._degToRad(newRotation),x:attrs.x+(attrs.width/2+padding)*(Math.cos(alpha)-Math.cos(newAlpha))+(attrs.height/2+padding)*(Math.sin(-alpha)-Math.sin(-newAlpha))-(dx*Math.cos(rot)+dy*Math.sin(-rot)),y:attrs.y+(attrs.height/2+padding)*(Math.cos(alpha)-Math.cos(newAlpha))+(attrs.width/2+padding)*(Math.sin(alpha)-Math.sin(newAlpha))-(dy*Math.cos(rot)+dx*Math.sin(rot)),width:attrs.width+padding*2,height:attrs.height+padding*2},e);}else{console.error(new Error('Wrong position argument of selection resizer: ',this.movingResizer));}if(this.movingResizer==='rotater'){return;}var absPos=this.findOne('.top-left').getAbsolutePosition(this.getParent());var centeredScaling=this.getCenteredScaling()||e.altKey;if(centeredScaling){var topLeft=this.findOne('.top-left');var bottomRight=this.findOne('.bottom-right');var topOffsetX=topLeft.x();var topOffsetY=topLeft.y();var bottomOffsetX=this.getWidth()-bottomRight.x();var bottomOffsetY=this.getHeight()-bottomRight.y();// console.log(topOffsetX, topOffsetY, bottomOffsetX, bottomOffsetY);
bottomRight.move({x:-topOffsetX,y:-topOffsetY});topLeft.move({x:bottomOffsetX,y:bottomOffsetY});absPos=topLeft.getAbsolutePosition(this.getParent());}x=absPos.x;y=absPos.y;var width=this.findOne('.bottom-right').x()-this.findOne('.top-left').x();var height=this.findOne('.bottom-right').y()-this.findOne('.top-left').y();// console.log(x, y, width, height);
this._fitNodeInto({x:x+this.offsetX(),y:y+this.offsetY(),width:width,height:height},e);},_handleMouseUp:function _handleMouseUp(e){this._removeEvents(e);},_removeEvents:function _removeEvents(e){if(this._transforming){this._transforming=false;window.removeEventListener('mousemove',this._handleMouseMove);window.removeEventListener('touchmove',this._handleMouseMove);window.removeEventListener('mouseup',this._handleMouseUp,true);window.removeEventListener('touchend',this._handleMouseUp,true);this._fire('transformend',{evt:e});var node=this.getNode();if(node){node.fire('transformend',{evt:e});}}},_fitNodeInto:function _fitNodeInto(newAttrs,evt){// waring! in this attrs padding may be included
var boundBoxFunc=this.getBoundBoxFunc();if(boundBoxFunc){var oldAttrs=this._getNodeRect();newAttrs=boundBoxFunc.call(this,oldAttrs,newAttrs);}this._settings=true;var node=this.getNode();if(newAttrs.rotation!==undefined){this.getNode().rotation(newAttrs.rotation);}var pure=node.getClientRect({skipTransform:true,skipShadow:true});var padding=this.getPadding();var scaleX=(newAttrs.width-padding*2)/pure.width;var scaleY=(newAttrs.height-padding*2)/pure.height;var rotation=Konva.getAngle(node.getRotation());var dx=pure.x*scaleX-padding-node.offsetX()*scaleX;var dy=pure.y*scaleY-padding-node.offsetY()*scaleY;this.getNode().setAttrs({scaleX:scaleX,scaleY:scaleY,x:newAttrs.x-(dx*Math.cos(rotation)+dy*Math.sin(-rotation)),y:newAttrs.y-(dy*Math.cos(rotation)+dx*Math.sin(rotation))});this._settings=false;this._fire('transform',{evt:evt});this.getNode()._fire('transform',{evt:evt});this.update();this.getLayer().batchDraw();},/**
     * force update of Konva.Transformer.
     * Use it when you updated attached Konva.Group and now you need to reset transformer size
     * @method
     * @memberof Konva.Transformer.prototype
     */forceUpdate:function forceUpdate(){this._resetTransformCache();this.update();},update:function update(){var attrs=this._getNodeRect();var node=this.getNode();var scale={x:1,y:1};if(node&&node.getParent()){scale=node.getParent().getAbsoluteScale();}var invertedScale={x:1/scale.x,y:1/scale.y};var width=attrs.width;var height=attrs.height;var enabledAnchors=this.enabledAnchors();var resizeEnabled=this.resizeEnabled();var padding=this.getPadding();var anchorSize=this.getAnchorSize();this.find('._anchor').setAttrs({width:anchorSize,height:anchorSize,offsetX:anchorSize/2,offsetY:anchorSize/2,stroke:this.getAnchorStroke(),strokeWidth:this.getAnchorStrokeWidth(),fill:this.getAnchorFill(),cornerRadius:this.getAnchorCornerRadius()});this.findOne('.top-left').setAttrs({x:-padding,y:-padding,scale:invertedScale,visible:resizeEnabled&&enabledAnchors.indexOf('top-left')>=0});this.findOne('.top-center').setAttrs({x:width/2,y:-padding,scale:invertedScale,visible:resizeEnabled&&enabledAnchors.indexOf('top-center')>=0});this.findOne('.top-right').setAttrs({x:width+padding,y:-padding,scale:invertedScale,visible:resizeEnabled&&enabledAnchors.indexOf('top-right')>=0});this.findOne('.middle-left').setAttrs({x:-padding,y:height/2,scale:invertedScale,visible:resizeEnabled&&enabledAnchors.indexOf('middle-left')>=0});this.findOne('.middle-right').setAttrs({x:width+padding,y:height/2,scale:invertedScale,visible:resizeEnabled&&enabledAnchors.indexOf('middle-right')>=0});this.findOne('.bottom-left').setAttrs({x:-padding,y:height+padding,scale:invertedScale,visible:resizeEnabled&&enabledAnchors.indexOf('bottom-left')>=0});this.findOne('.bottom-center').setAttrs({x:width/2,y:height+padding,scale:invertedScale,visible:resizeEnabled&&enabledAnchors.indexOf('bottom-center')>=0});this.findOne('.bottom-right').setAttrs({x:width+padding,y:height+padding,scale:invertedScale,visible:resizeEnabled&&enabledAnchors.indexOf('bottom-right')>=0});var scaledRotateAnchorOffset=-this.rotateAnchorOffset()*Math.abs(invertedScale.y);this.findOne('.rotater').setAttrs({x:width/2,y:scaledRotateAnchorOffset*Konva.Util._sign(height),scale:invertedScale,visible:this.rotateEnabled()});this.findOne('.back').setAttrs({width:width*scale.x,height:height*scale.y,scale:invertedScale,visible:this.borderEnabled(),stroke:this.getBorderStroke(),strokeWidth:this.getBorderStrokeWidth(),dash:this.getBorderDash()});},/**
     * determine if transformer is in active transform
     * @method
     * @memberof Konva.Transformer.prototype
     * @returns {Boolean}
     */isTransforming:function isTransforming(){return this._transforming;},/**
     * Stop active transform action
     * @method
     * @memberof Konva.Transformer.prototype
     * @returns {Boolean}
     */stopTransform:function stopTransform(){if(this._transforming){this._removeEvents();var resizerNode=this.findOne('.'+this.movingResizer);if(resizerNode){resizerNode.stopDrag();}}},destroy:function destroy(){// console.log(this.isTransforming() && this.getStage());
if(this.getStage()&&this._cursorChange){this.getStage().content.style.cursor='';}Konva.Group.prototype.destroy.call(this);this.detach();this._removeEvents();},// do not work as a container
// we will recreate inner nodes manually
toObject:function toObject(){return Konva.Node.prototype.toObject.call(this);}};Konva.Util.extend(Konva.Transformer,Konva.Group);function validateResizers(val){if(!(val instanceof Array)){Konva.Util.warn('enabledAnchors value should be an array');}if(val instanceof Array){val.forEach(function(name){if(ANCHORS_NAMES.indexOf(name)===-1){Konva.Util.warn('Unknown anchor name: '+name+'. Available names are: '+ANCHORS_NAMES.join(', '));}});}return val||[];}/**
   * get/set enabled handlers
   * @name enabledAnchors
   * @method
   * @memberof Konva.Transformer.prototype
   * @param {Array} array
   * @returns {Array}
   * @example
   * // get list of handlers
   * var enabledAnchors = transformer.enabledAnchors();
   *
   * // set handlers
   * transformer.enabledAnchors(['top-left', 'top-center', 'top-right', 'middle-right', 'middle-left', 'bottom-left', 'bottom-center', 'bottom-right']);
   */Konva.Factory.addGetterSetter(Konva.Transformer,'enabledAnchors',ANCHORS_NAMES,validateResizers);/**
   * get/set resize ability. If false it will automatically hide resizing handlers
   * @name resizeEnabled
   * @method
   * @memberof Konva.Transformer.prototype
   * @param {Array} array
   * @returns {Array}
   * @example
   * // get
   * var resizeEnabled = transformer.resizeEnabled();
   *
   * // set
   * transformer.resizeEnabled(false);
   */Konva.Factory.addGetterSetter(Konva.Transformer,'resizeEnabled',true);/**
   * get/set anchor size. Default is 10
   * @name validateAnchors
   * @method
   * @memberof Konva.Transformer.prototype
   * @param {Number} 10
   * @returns {Number}
   * @example
   * // get
   * var anchorSize = transformer.anchorSize();
   *
   * // set
   * transformer.anchorSize(20)
   */Konva.Factory.addGetterSetter(Konva.Transformer,'anchorSize',10,Konva.Validators.getNumberValidator());/**
   * get/set ability to rotate.
   * @name rotateEnabled
   * @method
   * @memberof Konva.Transformer.prototype
   * @param {Boolean} enabled
   * @returns {Boolean}
   * @example
   * // get
   * var rotateEnabled = transformer.rotateEnabled();
   *
   * // set
   * transformer.rotateEnabled(false);
   */Konva.Factory.addGetterSetter(Konva.Transformer,'rotateEnabled',true);/**
   * get/set rotation snaps angles.
   * @name rotationSnaps
   * @method
   * @memberof Konva.Transformer.prototype
   * @param {Array} array
   * @returns {Array}
   * @example
   * // get
   * var rotationSnaps = transformer.rotationSnaps();
   *
   * // set
   * transformer.rotationSnaps([0, 90, 180, 270]);
   */Konva.Factory.addGetterSetter(Konva.Transformer,'rotationSnaps',[]);/**
   * get/set distance for rotation handler
   * @name rotateAnchorOffset
   * @method
   * @memberof Konva.Transformer.prototype
   * @param {Number} offset
   * @returns {Number}
   * @example
   * // get
   * var rotateAnchorOffset = transformer.rotateAnchorOffset();
   *
   * // set
   * transformer.rotateAnchorOffset(100);
   */Konva.Factory.addGetterSetter(Konva.Transformer,'rotateAnchorOffset',50,Konva.Validators.getNumberValidator());/**
   * get/set visibility of border
   * @name borderEnabled
   * @method
   * @memberof Konva.Transformer.prototype
   * @param {Boolean} enabled
   * @returns {Boolean}
   * @example
   * // get
   * var borderEnabled = transformer.borderEnabled();
   *
   * // set
   * transformer.borderEnabled(false);
   */Konva.Factory.addGetterSetter(Konva.Transformer,'borderEnabled',true);/**
   * get/set anchor stroke color
   * @name anchorStroke
   * @method
   * @memberof Konva.Transformer.prototype
   * @param {Boolean} enabled
   * @returns {Boolean}
   * @example
   * // get
   * var anchorStroke = transformer.anchorStroke();
   *
   * // set
   * transformer.anchorStroke('red');
   */Konva.Factory.addGetterSetter(Konva.Transformer,'anchorStroke','rgb(0, 161, 255)');/**
   * get/set anchor stroke width
   * @name anchorStrokeWidth
   * @method
   * @memberof Konva.Transformer.prototype
   * @param {Boolean} enabled
   * @returns {Boolean}
   * @example
   * // get
   * var anchorStrokeWidth = transformer.anchorStrokeWidth();
   *
   * // set
   * transformer.anchorStrokeWidth(3);
   */Konva.Factory.addGetterSetter(Konva.Transformer,'anchorStrokeWidth',1,Konva.Validators.getNumberValidator());/**
   * get/set anchor fill color
   * @name anchorFill
   * @method
   * @memberof Konva.Transformer.prototype
   * @param {Boolean} enabled
   * @returns {Boolean}
   * @example
   * // get
   * var anchorFill = transformer.anchorFill();
   *
   * // set
   * transformer.anchorFill('red');
   */Konva.Factory.addGetterSetter(Konva.Transformer,'anchorFill','white');/**
   * get/set anchor corner radius
   * @name anchorCornerRadius
   * @method
   * @memberof Konva.Transformer.prototype
   * @param {Number} enabled
   * @returns {Number}
   * @example
   * // get
   * var anchorCornerRadius = transformer.anchorCornerRadius();
   *
   * // set
   * transformer.anchorCornerRadius(3);
   */Konva.Factory.addGetterSetter(Konva.Transformer,'anchorCornerRadius',0,Konva.Validators.getNumberValidator());/**
   * get/set border stroke color
   * @name borderStroke
   * @method
   * @memberof Konva.Transformer.prototype
   * @param {Boolean} enabled
   * @returns {Boolean}
   * @example
   * // get
   * var borderStroke = transformer.borderStroke();
   *
   * // set
   * transformer.borderStroke('red');
   */Konva.Factory.addGetterSetter(Konva.Transformer,'borderStroke','rgb(0, 161, 255)');/**
   * get/set border stroke width
   * @name borderStrokeWidth
   * @method
   * @memberof Konva.Transformer.prototype
   * @param {Boolean} enabled
   * @returns {Boolean}
   * @example
   * // get
   * var borderStrokeWidth = transformer.borderStrokeWidth();
   *
   * // set
   * transformer.borderStrokeWidth(3);
   */Konva.Factory.addGetterSetter(Konva.Transformer,'borderStrokeWidth',1,Konva.Validators.getNumberValidator());/**
   * get/set border dash array
   * @name borderDash
   * @method
   * @memberof Konva.Transformer.prototype
   * @param {Boolean} enabled
   * @returns {Boolean}
   * @example
   * // get
   * var borderDash = transformer.borderDash();
   *
   * // set
   * transformer.borderDash([2, 2]);
   */Konva.Factory.addGetterSetter(Konva.Transformer,'borderDash');/**
   * get/set should we keep ratio while resize anchors at corners
   * @name keepRatio
   * @method
   * @memberof Konva.Transformer.prototype
   * @param {Boolean} keepRatio
   * @returns {Boolean}
   * @example
   * // get
   * var keepRatio = transformer.keepRatio();
   *
   * // set
   * transformer.keepRatio(false);
   */Konva.Factory.addGetterSetter(Konva.Transformer,'keepRatio',true);/**
   * get/set should we resize relative to node's center?
   * @name centeredScaling
   * @method
   * @memberof Konva.Transformer.prototype
   * @param {Boolean} centeredScaling
   * @returns {Boolean}
   * @example
   * // get
   * var centeredScaling = transformer.centeredScaling();
   *
   * // set
   * transformer.centeredScaling(true);
   */Konva.Factory.addGetterSetter(Konva.Transformer,'centeredScaling',false);/**
   * get/set padding
   * @name padding
   * @method
   * @memberof Konva.Transformer.prototype
   * @param {Number} padding
   * @returns {Number}
   * @example
   * // get
   * var padding = transformer.padding();
   *
   * // set
   * transformer.padding(10);
   */Konva.Factory.addGetterSetter(Konva.Transformer,'padding',0,Konva.Validators.getNumberValidator());Konva.Factory.addOverloadedGetterSetter(Konva.Transformer,'node');/**
   * get/set bounding box function
   * @name boundBoxFunc
   * @method
   * @memberof Konva.Transformer.prototype
   * @param {Function} func
   * @returns {Function}
   * @example
   * // get
   * var boundBoxFunc = transformer.boundBoxFunc();
   *
   * // set
   * transformer.boundBoxFunc(function(oldBox, newBox) {
   *   if (newBox.width > 200) {
   *     return oldBox;
   *   }
   *   return newBox;
   * });
   */Konva.Factory.addGetterSetter(Konva.Transformer,'boundBoxFunc');Konva.Factory.backCompat(Konva.Transformer,{lineEnabled:'borderEnabled',rotateHandlerOffset:'rotateAnchorOffset',enabledHandlers:'enabledAnchors'});Konva.Collection.mapMethods(Konva.Transformer);})(Konva);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.toggleStrictMode = toggleStrictMode;
exports.applyNodeProps = applyNodeProps;
exports.updatePicture = updatePicture;
var propsToSkip = {
  children: true,
  ref: true,
  key: true,
  style: true,
  forwardedRef: true
};

var idWarningShowed = false;
var zIndexWarningShowed = false;
var useStrictMode = false;

var EVENTS_NAMESPACE = exports.EVENTS_NAMESPACE = '.react-konva-event';

function toggleStrictMode(value) {
  useStrictMode = value;
}

function applyNodeProps(instance, props) {
  var oldProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!idWarningShowed && 'id' in props) {
    var message = 'ReactKonva: You are using "id" attribute for a Konva node. In some very rare cases it may produce bugs. Currently we recommend not to use it and use "name" attribute instead.\nYou are using id = "' + props.id + '".\nFor me info see: https://github.com/konvajs/react-konva/issues/119';
    console.warn(message);
    idWarningShowed = true;
  }

  if (!zIndexWarningShowed && 'zIndex' in props) {
    var _message = 'ReactKonva: You are using "zIndex" attribute for a Konva node.\nreact-konva may get confused with ordering. Just define correct order of elements in your render function of a component.\nFor me info see: https://github.com/konvajs/react-konva/issues/194\n';
    console.warn(_message);
    zIndexWarningShowed = true;
  }

  var updatedProps = {};
  var hasUpdates = false;
  for (var key in oldProps) {
    if (propsToSkip[key]) {
      continue;
    }
    var isEvent = key.slice(0, 2) === 'on';
    var propChanged = oldProps[key] !== props[key];
    if (isEvent && propChanged) {
      var eventName = key.substr(2).toLowerCase();
      if (eventName.substr(0, 7) === 'content') {
        eventName = 'content' + eventName.substr(7, 1).toUpperCase() + eventName.substr(8);
      }
      instance.off(eventName, oldProps[key]);
    }
    var toRemove = !props.hasOwnProperty(key);
    if (toRemove) {
      instance.setAttr(key, undefined);
    }
  }

  var strictUpdate = useStrictMode || props._useStrictMode;

  for (var key in props) {
    if (propsToSkip[key]) {
      continue;
    }
    var isEvent = key.slice(0, 2) === 'on';
    var toAdd = oldProps[key] !== props[key];
    if (isEvent && toAdd) {
      var eventName = key.substr(2).toLowerCase();
      if (eventName.substr(0, 7) === 'content') {
        eventName = 'content' + eventName.substr(7, 1).toUpperCase() + eventName.substr(8);
      }
      if (props[key]) {
        instance.on(eventName + EVENTS_NAMESPACE, props[key]);
      }
    }
    if (!isEvent && (props[key] !== oldProps[key] || strictUpdate && props[key] !== instance.getAttr(key))) {
      hasUpdates = true;
      updatedProps[key] = props[key];
    }
  }

  if (hasUpdates) {
    instance.setAttrs(updatedProps);
    updatePicture(instance);
  }
}

function updatePicture(node) {
  var drawingNode = node.getLayer() || node.getStage();
  drawingNode && drawingNode.batchDraw();
}

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Complaint;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactKonva = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Complaint(_ref) {
  var _ref$pos = _ref.pos,
      x = _ref$pos.x,
      y = _ref$pos.y,
      conf = _objectWithoutProperties(_ref, ["pos"]);

  return _react2.default.createElement(_reactKonva.Circle, _extends({ x: x, y: y }, conf));
}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Complaint;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactKonva = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Complaint(_ref) {
  var index = _ref.index,
      _ref$pos = _ref.pos,
      x = _ref$pos.x,
      y = _ref$pos.y,
      conf = _objectWithoutProperties(_ref, ["index", "pos"]);

  var text = index < 9 ? " " + (index + 1) : "" + (index + 1);
  return _react2.default.createElement(_reactKonva.Text, _extends({
    x: x - conf.fontSize / 2,
    y: y - conf.fontSize / 2
  }, conf, {
    text: text
  }));
}

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var scope = typeof global !== "undefined" && global || typeof self !== "undefined" && self || window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function () {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function () {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout = exports.clearInterval = function (timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function () {};
Timeout.prototype.close = function () {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function (item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function (item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function (item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout) item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(150);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = typeof self !== "undefined" && self.setImmediate || typeof global !== "undefined" && global.setImmediate || undefined && undefined.setImmediate;
exports.clearImmediate = typeof self !== "undefined" && self.clearImmediate || typeof global !== "undefined" && global.clearImmediate || undefined && undefined.clearImmediate;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _debounce = __webpack_require__(156);

var _debounce2 = _interopRequireDefault(_debounce);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(3);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var DEFAULT_DELAY_MS = 200;

/**
 * HoC that encapsulates common behavior and functionality for doing
 * asynchronous searches, including:
 *
 *  - Debouncing user input
 *  - Query caching (optional)
 *  - Search prompt and empty results behaviors
 */
var asyncContainer = function asyncContainer(Typeahead) {
  var WrappedTypeahead = function (_React$Component) {
    _inherits(WrappedTypeahead, _React$Component);

    function WrappedTypeahead() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, WrappedTypeahead);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WrappedTypeahead.__proto__ || Object.getPrototypeOf(WrappedTypeahead)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        query: ''
      }, _this._getEmptyLabel = function () {
        var _this$props = _this.props,
            emptyLabel = _this$props.emptyLabel,
            isLoading = _this$props.isLoading,
            promptText = _this$props.promptText,
            searchText = _this$props.searchText,
            useCache = _this$props.useCache;
        var query = _this.state.query;

        if (!query.length) {
          return promptText;
        }

        if (isLoading || useCache && !_this._cache[query]) {
          return searchText;
        }

        return emptyLabel;
      }, _this._handleInputChange = function (query, e) {
        _this.props.onInputChange && _this.props.onInputChange(query, e);
        _this._handleSearchDebounced(query);
      }, _this._handleSearch = function (query) {
        var _this$props2 = _this.props,
            minLength = _this$props2.minLength,
            onSearch = _this$props2.onSearch,
            useCache = _this$props2.useCache;

        _this.setState({ query: query });

        if (!query || minLength && query.length < minLength) {
          return;
        }

        // Use cached results, if available.
        if (useCache && _this._cache[query]) {
          return;
        }

        // Perform the search.
        onSearch(query);
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(WrappedTypeahead, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        this._cache = {};
        this._handleSearchDebounced = (0, _debounce2.default)(this._handleSearch, this.props.delay);
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var options = nextProps.options,
            useCache = nextProps.useCache;

        if (!this.props.isLoading) {
          return;
        }

        if (useCache) {
          this._cache[this.state.query] = options;
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this._cache = {};
        this._handleSearchDebounced.cancel();
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _props = this.props,
            options = _props.options,
            useCache = _props.useCache,
            props = _objectWithoutProperties(_props, ['options', 'useCache']);

        var cachedQuery = this._cache[this.state.query];
        var emptyLabel = this._getEmptyLabel();

        // Short-circuit the creation of custom selections while the user is in
        // the process of searching. The logic for whether or not to display the
        // custom menu option is basically the same as whether we display the
        // empty label, so use that as a proxy.
        var allowNew = props.allowNew && emptyLabel === props.emptyLabel;
        // Unless allowNew is a function,
        // in which case it is up to the function to decide
        if (typeof props.allowNew === 'function') {
          allowNew = props.allowNew;
        }

        return _react2.default.createElement(Typeahead, _extends({}, props, {
          allowNew: allowNew,
          emptyLabel: emptyLabel,
          onInputChange: this._handleInputChange,
          options: useCache && cachedQuery ? cachedQuery : options,
          ref: function ref(instance) {
            return _this2._instance = instance;
          }
        }));
      }

      /**
       * Make the component instance available.
       */

    }, {
      key: 'getInstance',
      value: function getInstance() {
        return this._instance.getInstance();
      }
    }]);

    return WrappedTypeahead;
  }(_react2.default.Component);

  WrappedTypeahead.displayName = 'AsyncContainer(' + (0, _utils.getDisplayName)(Typeahead) + ')';

  WrappedTypeahead.propTypes = {
    /**
     * Delay, in milliseconds, before performing search.
     */
    delay: _propTypes2.default.number,
    /**
     * Whether or not a request is currently pending. Necessary for the
     * container to know when new results are available.
     */
    isLoading: _propTypes2.default.bool.isRequired,
    /**
     * Callback to perform when the search is executed.
     */
    onSearch: _propTypes2.default.func.isRequired,
    /**
     * Options to be passed to the typeahead. Will typically be the query
     * results, but can also be initial default options.
     */
    options: _propTypes2.default.array,
    /**
     * Message displayed in the menu when there is no user input.
     */
    promptText: _propTypes2.default.node,
    /**
     * Message displayed in the menu while the request is pending.
     */
    searchText: _propTypes2.default.node,
    /**
     * Whether or not the component should cache query results.
     */
    useCache: _propTypes2.default.bool
  };

  WrappedTypeahead.defaultProps = {
    delay: DEFAULT_DELAY_MS,
    minLength: 2,
    options: [],
    promptText: 'Type to search...',
    searchText: 'Searching...',
    useCache: true
  };

  return WrappedTypeahead;
};

exports.default = asyncContainer;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/** Detect free variable `global` from Node.js. */
var freeGlobal = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseIsEqual = __webpack_require__(43);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ListCache = __webpack_require__(30),
    stackClear = __webpack_require__(169),
    stackDelete = __webpack_require__(170),
    stackGet = __webpack_require__(171),
    stackHas = __webpack_require__(172),
    stackSet = __webpack_require__(173);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SetCache = __webpack_require__(190),
    arraySome = __webpack_require__(87),
    cacheHas = __webpack_require__(193);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function (othValue, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var root = __webpack_require__(4),
    stubFalse = __webpack_require__(207);

/** Detect free variable `exports`. */
var freeExports = ( false ? 'undefined' : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && ( false ? 'undefined' : _typeof(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(90)(module)))

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function () {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function get() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function get() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseIsTypedArray = __webpack_require__(208),
    baseUnary = __webpack_require__(209),
    nodeUtil = __webpack_require__(210);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getNative = __webpack_require__(12),
    root = __webpack_require__(4);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isObject = __webpack_require__(7);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function (object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
  };
}

module.exports = matchesStrictComparable;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseToString = __webpack_require__(229);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseHasIn = __webpack_require__(231),
    hasPath = __webpack_require__(232);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getMatchBounds;

var _escapeStringRegexp = __webpack_require__(247);

var _escapeStringRegexp2 = _interopRequireDefault(_escapeStringRegexp);

var _stripDiacritics = __webpack_require__(53);

var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var CASE_INSENSITIVE = 'i';
var COMBINING_MARKS = /[\u0300-\u036F]/;

function getMatchBounds(subject, search) {
  search = new RegExp((0, _escapeStringRegexp2.default)((0, _stripDiacritics2.default)(search)), CASE_INSENSITIVE);

  var matches = search.exec((0, _stripDiacritics2.default)(subject));

  if (!matches) {
    return null;
  }

  var start = matches.index;
  var matchLength = matches[0].length;

  // Account for combining marks, which changes the indices.
  if (COMBINING_MARKS.test(subject)) {
    // Starting at the beginning of the subject string, check for the number of
    // combining marks and increment the start index whenever one is found.
    for (var ii = 0; ii <= start; ii++) {
      if (COMBINING_MARKS.test(subject[ii])) {
        start++;
      }
    }

    // Similarly, increment the length of the match string if it contains a
    // combining mark.
    for (var _ii = start; _ii <= start + matchLength; _ii++) {
      if (COMBINING_MARKS.test(subject[_ii])) {
        matchLength++;
      }
    }
  }

  return {
    end: start + matchLength,
    start: start
  };
}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseGetTag = __webpack_require__(11),
    getPrototype = __webpack_require__(249),
    isObjectLike = __webpack_require__(8);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getStringLabelKey;

var _defaultLabelKey = __webpack_require__(102);

function getStringLabelKey(labelKey) {
  return typeof labelKey === 'string' ? labelKey : _defaultLabelKey.DEFAULT_LABELKEY;
}

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DEFAULT_LABELKEY = exports.DEFAULT_LABELKEY = 'label';

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _pick = __webpack_require__(257);

var _pick2 = _interopRequireDefault(_pick);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(6);

var _ClearButton = __webpack_require__(107);

var _ClearButton2 = _interopRequireDefault(_ClearButton);

var _Loader = __webpack_require__(272);

var _Loader2 = _interopRequireDefault(_Loader);

var _Overlay = __webpack_require__(273);

var _Overlay2 = _interopRequireDefault(_Overlay);

var _TypeaheadInputMulti = __webpack_require__(324);

var _TypeaheadInputMulti2 = _interopRequireDefault(_TypeaheadInputMulti);

var _TypeaheadInputSingle = __webpack_require__(326);

var _TypeaheadInputSingle2 = _interopRequireDefault(_TypeaheadInputSingle);

var _TypeaheadMenu = __webpack_require__(131);

var _TypeaheadMenu2 = _interopRequireDefault(_TypeaheadMenu);

var _typeaheadContainer = __webpack_require__(328);

var _typeaheadContainer2 = _interopRequireDefault(_typeaheadContainer);

var _utils = __webpack_require__(3);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Typeahead = function (_React$Component) {
  _inherits(Typeahead, _React$Component);

  function Typeahead() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Typeahead);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Typeahead.__proto__ || Object.getPrototypeOf(Typeahead)).call.apply(_ref, [this].concat(args))), _this), _this._renderInput = function (inputProps) {
      var Input = inputProps.multiple ? _TypeaheadInputMulti2.default : _TypeaheadInputSingle2.default;

      return _react2.default.createElement(Input, inputProps);
    }, _this._renderAux = function () {
      var _this$props = _this.props,
          bsSize = _this$props.bsSize,
          clearButton = _this$props.clearButton,
          disabled = _this$props.disabled,
          isLoading = _this$props.isLoading,
          onClear = _this$props.onClear,
          selected = _this$props.selected;

      var content = void 0;

      if (isLoading) {
        content = _react2.default.createElement(_Loader2.default, { bsSize: bsSize });
      } else if (clearButton && !disabled && selected.length) {
        content = _react2.default.createElement(_ClearButton2.default, {
          bsSize: bsSize,
          onClick: onClear,
          onFocus: function onFocus(e) {
            // Prevent the main input from auto-focusing again.
            e.stopPropagation();
          },
          onMouseDown: _utils.preventInputBlur
        });
      }

      return content ? _react2.default.createElement('div', {
        className: (0, _classnames2.default)('rbt-aux', {
          'rbt-aux-lg': bsSize === 'large' || bsSize === 'lg'
        }) }, content) : null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Typeahead, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var allowNew = nextProps.allowNew,
          onInitialItemChange = nextProps.onInitialItemChange,
          results = nextProps.results;

      // Clear the initial item when there are no results.

      if (!(allowNew || results.length)) {
        onInitialItemChange(null);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          bodyContainer = _props.bodyContainer,
          children = _props.children,
          className = _props.className,
          isMenuShown = _props.isMenuShown,
          menuId = _props.menuId,
          renderMenu = _props.renderMenu,
          results = _props.results;

      var inputProps = (0, _pick2.default)(this.props, ['activeIndex', 'activeItem', 'bsSize', 'disabled', 'initialItem', 'inputProps', 'inputRef', 'isInvalid', 'isMenuShown', 'isValid', 'labelKey', 'menuId', 'multiple', 'onAdd', 'onBlur', 'onChange', 'onFocus', 'onKeyDown', 'onRemove', 'placeholder', 'renderToken', 'selected', 'selectHintOnEnter', 'text']);

      var overlayProps = (0, _pick2.default)(this.props, ['align', 'className', 'dropup', 'flip', 'onMenuHide', 'onMenuShow']);

      var menuProps = (0, _pick2.default)(this.props, ['emptyLabel', 'labelKey', 'maxHeight', 'newSelectionPrefix', 'renderMenuItemChildren', 'text']);

      var auxContent = this._renderAux();

      return _react2.default.createElement('div', {
        className: (0, _classnames2.default)('rbt', 'clearfix', 'open', {
          'has-aux': !!auxContent
        }, className),
        style: { position: 'relative' },
        tabIndex: -1 }, this._renderInput(_extends({}, inputProps, {
        // Use `findDOMNode` here since it's easier and less fragile than
        // forwarding refs down to the input's container.
        // TODO: Consider using `forwardRef` when React 16.3 usage is higher.
        ref: function ref(node) {
          return _this2._inputContainer = (0, _reactDom.findDOMNode)(node);
        }
      })), typeof children === 'function' ? children(this.props) : children, auxContent, _react2.default.createElement(_Overlay2.default, _extends({}, overlayProps, {
        container: bodyContainer ? document.body : this,
        referenceElement: this._inputContainer,
        show: isMenuShown }), renderMenu(results, _extends({}, menuProps, { id: menuId }))), _react2.default.createElement('div', {
        'aria-atomic': true,
        'aria-live': 'polite',
        className: 'sr-only rbt-sr-status',
        role: 'status' }, (0, _utils.getAccessibilityStatus)(this.props)));
    }
  }]);

  return Typeahead;
}(_react2.default.Component);

Typeahead.propTypes = {
  renderMenu: _propTypes2.default.func
};

Typeahead.defaultProps = {
  renderMenu: function renderMenu(results, menuProps) {
    return _react2.default.createElement(_TypeaheadMenu2.default, _extends({}, menuProps, { options: results }));
  }
};

exports.default = (0, _typeaheadContainer2.default)(Typeahead);

/***/ }),
/* 104 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getNative = __webpack_require__(12);

var defineProperty = function () {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();

module.exports = defineProperty;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var flatten = __webpack_require__(263),
    overRest = __webpack_require__(266),
    setToString = __webpack_require__(268);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

/**
 * ClearButton
 *
 * http://getbootstrap.com/css/#helper-classes-close
 */
var ClearButton = function ClearButton(_ref) {
  var bsSize = _ref.bsSize,
      className = _ref.className,
      label = _ref.label,
      _onClick = _ref.onClick,
      props = _objectWithoutProperties(_ref, ['bsSize', 'className', 'label', 'onClick']);

  return _react2.default.createElement('button', _extends({}, props, {
    'aria-label': label,
    className: (0, _classnames2.default)('close', 'rbt-close', {
      'rbt-close-lg': bsSize === 'large' || bsSize === 'lg'
    }, className),
    onClick: function onClick(e) {
      e.stopPropagation();
      _onClick(e);
    },
    type: 'button' }), _react2.default.createElement('span', { 'aria-hidden': 'true' }, '\xD7'), _react2.default.createElement('span', { className: 'sr-only' }, label));
};

ClearButton.propTypes = {
  bsSize: _propTypes2.default.oneOf(['large', 'lg', 'small', 'sm']),
  label: _propTypes2.default.string,
  onClick: _propTypes2.default.func.isRequired
};

ClearButton.defaultProps = {
  label: 'Clear'
};

exports.default = ClearButton;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getContainer;

var _reactDom = __webpack_require__(6);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom2.default.findDOMNode(container) || defaultContainer;
}
module.exports = exports['default'];

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (componentOrElement) {
  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
};

var _reactDom = __webpack_require__(6);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _ownerDocument = __webpack_require__(276);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

module.exports = exports['default'];

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(279);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// optional / simple context binding
var aFunction = __webpack_require__(282);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1:
      return function (a) {
        return fn.call(that, a);
      };
    case 2:
      return function (a, b) {
        return fn.call(that, a, b);
      };
    case 3:
      return function (a, b, c) {
        return fn.call(that, a, b, c);
      };
  }
  return function () /* ...args */{
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = !__webpack_require__(19) && !__webpack_require__(27)(function () {
  return Object.defineProperty(__webpack_require__(113)('div'), 'a', { get: function get() {
      return 7;
    } }).a != 7;
});

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isObject = __webpack_require__(18);
var document = __webpack_require__(10).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = __webpack_require__(13);
var toIObject = __webpack_require__(20);
var arrayIndexOf = __webpack_require__(284)(false);
var IE_PROTO = __webpack_require__(60)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) {
    if (key != IE_PROTO) has(O, key) && result.push(key);
  } // Don't enum bug & hidden keys
  while (names.length > i) {
    if (has(O, key = names[i++])) {
      ~arrayIndexOf(result, key) || result.push(key);
    }
  }return result;
};

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(116);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 7.1.13 ToObject(argument)
var defined = __webpack_require__(58);
module.exports = function (it) {
  return Object(defined(it));
};

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(120);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _iterator = __webpack_require__(287);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(299);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && _typeof2(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var LIBRARY = __webpack_require__(64);
var $export = __webpack_require__(25);
var redefine = __webpack_require__(122);
var hide = __webpack_require__(16);
var has = __webpack_require__(13);
var Iterators = __webpack_require__(65);
var $iterCreate = __webpack_require__(291);
var setToStringTag = __webpack_require__(67);
var getPrototypeOf = __webpack_require__(294);
var ITERATOR = __webpack_require__(21)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function returnThis() {
  return this;
};

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function getMethod(kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS:
        return function keys() {
          return new Constructor(this, kind);
        };
      case VALUES:
        return function values() {
          return new Constructor(this, kind);
        };
    }return function entries() {
      return new Constructor(this, kind);
    };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = !BUGGY && $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() {
      return $native.call(this);
    };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(16);

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(114);
var hiddenKeys = __webpack_require__(62).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var pIE = __webpack_require__(40);
var createDesc = __webpack_require__(37);
var toIObject = __webpack_require__(20);
var toPrimitive = __webpack_require__(57);
var has = __webpack_require__(13);
var IE8_DOM_DEFINE = __webpack_require__(112);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(19) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) {/* empty */}
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(309);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(313);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(120);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ClearButton = __webpack_require__(107);

var _ClearButton2 = _interopRequireDefault(_ClearButton);

var _tokenContainer = __webpack_require__(127);

var _tokenContainer2 = _interopRequireDefault(_tokenContainer);

var _keyCode = __webpack_require__(22);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * Token
 *
 * Individual token component, generally displayed within the TokenizerInput
 * component, but can also be rendered on its own.
 */
var Token = function (_React$Component) {
  _inherits(Token, _React$Component);

  function Token() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Token);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Token.__proto__ || Object.getPrototypeOf(Token)).call.apply(_ref, [this].concat(args))), _this), _this._renderRemoveableToken = function () {
      var _this$props = _this.props,
          active = _this$props.active,
          children = _this$props.children,
          className = _this$props.className,
          onRemove = _this$props.onRemove,
          props = _objectWithoutProperties(_this$props, ['active', 'children', 'className', 'onRemove']);

      return _react2.default.createElement('div', _extends({}, props, {
        className: (0, _classnames2.default)('rbt-token', 'rbt-token-removeable', {
          'rbt-token-active': active
        }, className) }), children, _react2.default.createElement(_ClearButton2.default, {
        className: 'rbt-token-remove-button',
        label: 'Remove',
        onClick: onRemove,
        onKeyDown: _this._handleRemoveButtonKeydown,
        tabIndex: -1
      }));
    }, _this._renderToken = function () {
      var _this$props2 = _this.props,
          children = _this$props2.children,
          className = _this$props2.className,
          disabled = _this$props2.disabled,
          href = _this$props2.href;

      var classnames = (0, _classnames2.default)('rbt-token', {
        'rbt-token-disabled': disabled
      }, className);

      if (href) {
        return _react2.default.createElement('a', { className: classnames, href: href }, children);
      }

      return _react2.default.createElement('div', { className: classnames }, children);
    }, _this._handleRemoveButtonKeydown = function (e) {
      switch (e.keyCode) {
        case _keyCode.RETURN:
          _this.props.onRemove();
          break;
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Token, [{
    key: 'render',
    value: function render() {
      return this.props.onRemove && !this.props.disabled ? this._renderRemoveableToken() : this._renderToken();
    }
  }]);

  return Token;
}(_react2.default.Component);

Token.propTypes = {
  active: _propTypes2.default.bool,
  /**
   * Handler for removing/deleting the token. If not defined, the token will
   * be rendered in a read-only state.
   */
  onRemove: _propTypes2.default.func,
  tabIndex: _propTypes2.default.number
};

Token.defaultProps = {
  active: false,
  tabIndex: 0
};

exports.default = (0, _tokenContainer2.default)(Token);

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactOnclickoutside = __webpack_require__(128);

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _utils = __webpack_require__(3);

var _keyCode = __webpack_require__(22);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * Higher-order component that encapsulates Token behaviors, allowing them to
 * be easily re-used.
 */
var tokenContainer = function tokenContainer(Component) {
  var WrappedComponent = function (_React$Component) {
    _inherits(WrappedComponent, _React$Component);

    function WrappedComponent() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, WrappedComponent);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WrappedComponent.__proto__ || Object.getPrototypeOf(WrappedComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        active: false
      }, _this._handleBlur = function (e) {
        _this.setState({ active: false });
      }, _this._handleKeyDown = function (e) {
        switch (e.keyCode) {
          case _keyCode.BACKSPACE:
            if (_this.state.active) {
              // Prevent backspace keypress from triggering the browser "back"
              // action.
              e.preventDefault();
              _this.props.onRemove();
            }
            break;
        }
      }, _this.handleClickOutside = function (e) {
        _this._handleBlur();
      }, _this._handleActive = function (e) {
        e.stopPropagation();
        _this.setState({ active: true });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(WrappedComponent, [{
      key: 'render',
      value: function render() {
        var _props = this.props,
            disableOnClickOutside = _props.disableOnClickOutside,
            enableOnClickOutside = _props.enableOnClickOutside,
            eventTypes = _props.eventTypes,
            outsideClickIgnoreClass = _props.outsideClickIgnoreClass,
            preventDefault = _props.preventDefault,
            stopPropagation = _props.stopPropagation,
            tokenProps = _objectWithoutProperties(_props, ['disableOnClickOutside', 'enableOnClickOutside', 'eventTypes', 'outsideClickIgnoreClass', 'preventDefault', 'stopPropagation']);

        return _react2.default.createElement(Component, _extends({}, tokenProps, this.state, {
          onBlur: this._handleBlur,
          onClick: this._handleActive,
          onFocus: this._handleActive,
          onKeyDown: this._handleKeyDown
        }));
      }

      /**
       * From `onClickOutside` HOC.
       */

    }]);

    return WrappedComponent;
  }(_react2.default.Component);

  WrappedComponent.displayName = 'TokenContainer(' + (0, _utils.getDisplayName)(Component) + ')';

  return (0, _reactOnclickoutside2.default)(WrappedComponent);
};

exports.default = tokenContainer;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IGNORE_CLASS_NAME = undefined;

var _react = __webpack_require__(0);

var _reactDom = __webpack_require__(6);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.


  while (current.parentNode) {
    if (isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}

// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};

function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();

var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */

function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = null;
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

  if (isTouchEvent && passiveEventSupport) {
    handlerOptions = {
      passive: !instance.props.preventDefault
    };
  }

  return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */

function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error('WrappedComponent lacks a handleClickOutside(event) function for processing outside click events.');
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.props.disableOnClickOutside) return;
          if (_this.componentNode === null) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_this, eventName));
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_this, eventName));
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */

    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (!WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error('WrappedComponent lacks a function for processing outside click events specified by the handleClickOutside config option.');
        }
      }

      this.componentNode = (0, _reactDom.findDOMNode)(this.getInstance());
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = (0, _reactDom.findDOMNode)(this.getInstance());
    };
    /**
     * Remove all document's event listeners for this component
     */

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    };
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */

    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _props = this.props,
          excludeScrollbar = _props.excludeScrollbar,
          props = _objectWithoutProperties(_props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return (0, _react.createElement)(WrappedComponent, props);
    };

    return onClickOutside;
  }(_react.Component), _class.displayName = "OnClickOutside(" + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}

exports.IGNORE_CLASS_NAME = IGNORE_CLASS_NAME;
exports.default = onClickOutsideHOC;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(3);

var _keyCode = __webpack_require__(22);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

// IE doesn't seem to get the composite computed value (eg: 'padding',
// 'borderStyle', etc.), so generate these from the individual values.
function interpolateStyle(styles, attr) {
  var subattr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  // Title-case the sub-attribute.
  if (subattr) {
    subattr = subattr.replace(subattr[0], subattr[0].toUpperCase());
  }

  return ['Top', 'Right', 'Bottom', 'Left'].map(function (dir) {
    return styles[attr + dir + subattr];
  }).join(' ');
}

function copyStyles(inputNode, hintNode) {
  var inputStyle = window.getComputedStyle(inputNode);

  hintNode.style.borderStyle = interpolateStyle(inputStyle, 'border', 'style');
  hintNode.style.borderWidth = interpolateStyle(inputStyle, 'border', 'width');
  hintNode.style.fontSize = inputStyle.fontSize;
  hintNode.style.lineHeight = inputStyle.lineHeight;
  hintNode.style.margin = interpolateStyle(inputStyle, 'margin');
  hintNode.style.padding = interpolateStyle(inputStyle, 'padding');
}

function hintContainer(Input) {
  var HintedInput = function (_React$Component) {
    _inherits(HintedInput, _React$Component);

    function HintedInput() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, HintedInput);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HintedInput.__proto__ || Object.getPrototypeOf(HintedInput)).call.apply(_ref, [this].concat(args))), _this), _this._handleKeyDown = function (e) {
        var _this$context = _this.context,
            hintText = _this$context.hintText,
            initialItem = _this$context.initialItem,
            onAdd = _this$context.onAdd,
            selectHintOnEnter = _this$context.selectHintOnEnter;
        var _this$props = _this.props,
            onKeyDown = _this$props.onKeyDown,
            value = _this$props.value;

        if (hintText && (e.keyCode === _keyCode.RETURN && selectHintOnEnter || e.keyCode === _keyCode.RIGHT && e.target.selectionStart === value.length || e.keyCode === _keyCode.TAB)) {
          e.preventDefault(); // Prevent input from blurring on TAB.
          onAdd(initialItem);
        }

        onKeyDown(e);
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(HintedInput, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        copyStyles(this._input, this._hint);
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        copyStyles(this._input, this._hint);
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        return _react2.default.createElement('div', {
          className: 'rbt-input-hint-container',
          style: { position: 'relative' } }, _react2.default.createElement(Input, _extends({}, this.props, {
          inputRef: function inputRef(input) {
            _this2._input = input;
            _this2.props.inputRef(input);
          },
          onKeyDown: this._handleKeyDown
        })), _react2.default.createElement('input', {
          'aria-hidden': true,
          className: 'rbt-input-hint',
          readOnly: true,
          ref: function ref(hint) {
            return _this2._hint = hint;
          },
          style: {
            backgroundColor: 'transparent',
            borderColor: 'transparent',
            boxShadow: 'none',
            color: 'rgba(0, 0, 0, 0.35)',
            left: 0,
            pointerEvents: 'none',
            position: 'absolute',
            top: 0
          },
          tabIndex: -1,
          value: this.context.hintText
        }));
      }
    }]);

    return HintedInput;
  }(_react2.default.Component);

  HintedInput.displayName = 'HintContainer(' + (0, _utils.getDisplayName)(Input) + ')';

  HintedInput.contextTypes = {
    hintText: _propTypes2.default.string.isRequired,
    initialItem: _propTypes2.default.oneOfType([_propTypes2.default.object.isRequired, _propTypes2.default.string.isRequired]),
    onAdd: _propTypes2.default.func.isRequired,
    selectHintOnEnter: _propTypes2.default.bool.isRequired
  };

  return HintedInput;
}

exports.default = hintContainer;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(3);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function inputContainer(Input) {
  var WrappedInput = function (_React$Component) {
    _inherits(WrappedInput, _React$Component);

    function WrappedInput() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, WrappedInput);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WrappedInput.__proto__ || Object.getPrototypeOf(WrappedInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        isFocused: false
      }, _this._handleBlur = function (e) {
        e.persist();
        _this.setState({ isFocused: false }, function () {
          return _this.props.onBlur(e);
        });
      }, _this._handleFocus = function (e) {
        e.persist();
        _this.setState({ isFocused: true }, function () {
          return _this.props.onFocus(e);
        });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(WrappedInput, [{
      key: 'getChildContext',
      value: function getChildContext() {
        var _props = this.props,
            initialItem = _props.initialItem,
            onAdd = _props.onAdd,
            selectHintOnEnter = _props.selectHintOnEnter;

        return {
          hintText: (0, _utils.getHintText)(this.props),
          initialItem: initialItem,
          onAdd: onAdd,
          selectHintOnEnter: selectHintOnEnter
        };
      }
    }, {
      key: 'render',
      value: function render() {
        var _cx;

        var _props2 = this.props,
            activeIndex = _props2.activeIndex,
            bsSize = _props2.bsSize,
            disabled = _props2.disabled,
            inputRef = _props2.inputRef,
            isInvalid = _props2.isInvalid,
            isMenuShown = _props2.isMenuShown,
            isValid = _props2.isValid,
            labelKey = _props2.labelKey,
            menuId = _props2.menuId,
            multiple = _props2.multiple,
            onChange = _props2.onChange,
            onKeyDown = _props2.onKeyDown,
            onRemove = _props2.onRemove,
            placeholder = _props2.placeholder,
            renderToken = _props2.renderToken,
            selected = _props2.selected;

        // Add a11y-related props.

        var inputProps = _extends({}, this.props.inputProps, {
          'aria-activedescendant': activeIndex >= 0 ? (0, _utils.getMenuItemId)(activeIndex) : '',
          'aria-autocomplete': multiple ? 'list' : 'both',
          'aria-expanded': isMenuShown,
          'aria-haspopup': 'listbox',
          'aria-owns': menuId,
          autoComplete: this.props.inputProps.autoComplete || 'nope',
          disabled: disabled,
          inputRef: inputRef,
          onBlur: this._handleBlur,
          onChange: onChange,
          // Re-open the menu, eg: if it's closed via ESC.
          onClick: this._handleFocus,
          onFocus: this._handleFocus,
          onKeyDown: onKeyDown,
          placeholder: selected.length ? null : placeholder,
          // Comboboxes are single-select by definition:
          // https://www.w3.org/TR/wai-aria-practices-1.1/#combobox
          role: 'combobox',
          value: (0, _utils.getInputText)(this.props)
        });

        var className = inputProps.className || '';

        if (multiple) {
          inputProps = _extends({}, inputProps, {
            inputClassName: className,
            labelKey: labelKey,
            onRemove: onRemove,
            renderToken: renderToken,
            role: '',
            selected: selected
          });
        }

        return _react2.default.createElement(Input, _extends({}, inputProps, {
          className: (0, _classnames2.default)('rbt-input', (_cx = {}, _defineProperty(_cx, className, !multiple), _defineProperty(_cx, 'focus', this.state.isFocused), _defineProperty(_cx, 'input-lg form-control-lg', bsSize === 'large' || bsSize === 'lg'), _defineProperty(_cx, 'input-sm form-control-sm', bsSize === 'small' || bsSize === 'sm'), _defineProperty(_cx, 'is-invalid', isInvalid), _defineProperty(_cx, 'is-valid', isValid), _cx))
        }));
      }
    }]);

    return WrappedInput;
  }(_react2.default.Component);

  WrappedInput.displayName = 'InputContainer(' + (0, _utils.getDisplayName)(Input) + ')';

  WrappedInput.childContextTypes = {
    hintText: _propTypes2.default.string.isRequired,
    initialItem: _propTypes2.default.oneOfType([_propTypes2.default.object.isRequired, _propTypes2.default.string.isRequired]),
    onAdd: _propTypes2.default.func.isRequired,
    selectHintOnEnter: _propTypes2.default.bool.isRequired
  };

  return WrappedInput;
}

exports.default = inputContainer;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Highlighter = __webpack_require__(132);

var _Highlighter2 = _interopRequireDefault(_Highlighter);

var _Menu = __webpack_require__(133);

var _Menu2 = _interopRequireDefault(_Menu);

var _MenuItem = __webpack_require__(70);

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _utils = __webpack_require__(3);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var TypeaheadMenu = function (_React$Component) {
  _inherits(TypeaheadMenu, _React$Component);

  function TypeaheadMenu() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TypeaheadMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TypeaheadMenu.__proto__ || Object.getPrototypeOf(TypeaheadMenu)).call.apply(_ref, [this].concat(args))), _this), _this._renderMenuItem = function (option, idx) {
      var _this$props = _this.props,
          labelKey = _this$props.labelKey,
          newSelectionPrefix = _this$props.newSelectionPrefix,
          renderMenuItemChildren = _this$props.renderMenuItemChildren,
          text = _this$props.text;

      var label = (0, _utils.getOptionLabel)(option, labelKey);

      var menuItemProps = {
        disabled: option.disabled,
        key: idx,
        label: label,
        option: option,
        position: idx
      };

      if (option.customOption) {
        return _react2.default.createElement(_MenuItem2.default, _extends({}, menuItemProps, {
          className: 'rbt-menu-custom-option',
          label: newSelectionPrefix + label }), newSelectionPrefix, _react2.default.createElement(_Highlighter2.default, { search: text }, label));
      }

      if (option.paginationOption) {
        return [_react2.default.createElement(_Menu2.default.Divider, { key: 'pagination-item-divider' }), _react2.default.createElement(_MenuItem2.default, _extends({}, menuItemProps, {
          className: 'rbt-menu-pagination-option',
          key: 'pagination-item' }), label)];
      }

      return _react2.default.createElement(_MenuItem2.default, menuItemProps, renderMenuItemChildren(option, _this.props, idx));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TypeaheadMenu, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          labelKey = _props.labelKey,
          newSelectionPrefix = _props.newSelectionPrefix,
          options = _props.options,
          renderMenuItemChildren = _props.renderMenuItemChildren,
          text = _props.text,
          menuProps = _objectWithoutProperties(_props, ['labelKey', 'newSelectionPrefix', 'options', 'renderMenuItemChildren', 'text']);

      return _react2.default.createElement(_Menu2.default, menuProps, options.map(this._renderMenuItem));
    }
  }]);

  return TypeaheadMenu;
}(_react2.default.Component);

TypeaheadMenu.propTypes = {
  /**
   * Provides the ability to specify a prefix before the user-entered text to
   * indicate that the selection will be new. No-op unless `allowNew={true}`.
   */
  newSelectionPrefix: _propTypes2.default.string,
  /**
   * Provides a hook for customized rendering of menu item contents.
   */
  renderMenuItemChildren: _propTypes2.default.func
};

TypeaheadMenu.defaultProps = {
  newSelectionPrefix: 'New selection: ',
  renderMenuItemChildren: function renderMenuItemChildren(option, props, idx) {
    return _react2.default.createElement(_Highlighter2.default, { search: props.text }, (0, _utils.getOptionLabel)(option, props.labelKey));
  }
};

exports.default = TypeaheadMenu;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(3);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * Stripped-down version of https://github.com/helior/react-highlighter
 *
 * Results are already filtered by the time the component is used internally so
 * we can safely ignore case and diacritical marks for the purposes of matching.
 */
var Highlighter = function (_React$PureComponent) {
  _inherits(Highlighter, _React$PureComponent);

  function Highlighter() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Highlighter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Highlighter.__proto__ || Object.getPrototypeOf(Highlighter)).call.apply(_ref, [this].concat(args))), _this), _this._count = 0, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Highlighter, [{
    key: 'render',
    value: function render() {
      var children = this.props.search ? this._renderHighlightedChildren() : this.props.children;

      return _react2.default.createElement('span', null, children);
    }
  }, {
    key: '_renderHighlightedChildren',
    value: function _renderHighlightedChildren() {
      var children = [];
      var remaining = this.props.children;

      while (remaining) {
        var bounds = (0, _utils.getMatchBounds)(remaining, this.props.search);

        if (!bounds) {
          this._count++;
          children.push(_react2.default.createElement('span', { key: this._count }, remaining));
          return children;
        }

        // Capture the string that leads up to a match...
        var nonMatch = remaining.slice(0, bounds.start);
        if (nonMatch) {
          this._count++;
          children.push(_react2.default.createElement('span', { key: this._count }, nonMatch));
        }

        // Now, capture the matching string...
        var match = remaining.slice(bounds.start, bounds.end);
        if (match) {
          this._count++;
          children.push(_react2.default.createElement('mark', { className: 'rbt-highlight-text', key: this._count }, match));
        }

        // And if there's anything left over, continue the loop.
        remaining = remaining.slice(bounds.end);
      }

      return children;
    }
  }]);

  return Highlighter;
}(_react2.default.PureComponent);

Highlighter.propTypes = {
  children: _propTypes2.default.string.isRequired,
  search: _propTypes2.default.string.isRequired
};

exports.default = Highlighter;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isRequiredForA11y = __webpack_require__(327);

var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _MenuItem = __webpack_require__(70);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * Menu component that handles empty state when passed a set of results.
 */
var Menu = function (_React$Component) {
  _inherits(Menu, _React$Component);

  function Menu() {
    _classCallCheck(this, Menu);

    return _possibleConstructorReturn(this, (Menu.__proto__ || Object.getPrototypeOf(Menu)).apply(this, arguments));
  }

  _createClass(Menu, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          emptyLabel = _props.emptyLabel,
          id = _props.id,
          innerRef = _props.innerRef,
          maxHeight = _props.maxHeight,
          style = _props.style;

      var contents = _react.Children.count(children) === 0 ? _react2.default.createElement(_MenuItem.BaseMenuItem, { disabled: true }, emptyLabel) : children;

      return _react2.default.createElement('ul', {
        className: (0, _classnames2.default)('rbt-menu', 'dropdown-menu', 'show', className),
        id: id,
        ref: innerRef,
        role: 'listbox',
        style: _extends({}, style, {
          display: 'block',
          maxHeight: maxHeight,
          overflow: 'auto'
        }) }, contents);
    }
  }]);

  return Menu;
}(_react2.default.Component);

Menu.propTypes = {
  /**
   * Needed for accessibility.
   */
  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])),
  /**
   * Maximum height of the dropdown menu.
   */
  maxHeight: _propTypes2.default.string
};

Menu.defaultProps = {
  maxHeight: '300px'
};

Menu.Divider = function (props) {
  return _react2.default.createElement('li', { className: 'divider dropdown-divider', role: 'separator' });
};

Menu.Header = function (props) {
  return _react2.default.createElement('li', _extends({}, props, { className: 'dropdown-header' }));
};

exports.default = Menu;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(6);

var _utils = __webpack_require__(3);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var menuItemContainer = function menuItemContainer(Component) {
  var WrappedMenuItem = function (_React$Component) {
    _inherits(WrappedMenuItem, _React$Component);

    function WrappedMenuItem() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, WrappedMenuItem);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WrappedMenuItem.__proto__ || Object.getPrototypeOf(WrappedMenuItem)).call.apply(_ref, [this].concat(args))), _this), _this._handleClick = function (e) {
        var _this$props = _this.props,
            option = _this$props.option,
            onClick = _this$props.onClick;

        _this.context.onMenuItemClick(option, e);
        onClick && onClick(e);
      }, _this._updateInitialItem = function (props) {
        var option = props.option,
            position = props.position;

        if (position === 0) {
          _this.context.onInitialItemChange(option);
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(WrappedMenuItem, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        this._updateInitialItem(this.props);
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps, nextContext) {
        var currentlyActive = this.context.activeIndex === this.props.position;
        var option = nextProps.option,
            position = nextProps.position;
        var activeIndex = nextContext.activeIndex,
            onActiveItemChange = nextContext.onActiveItemChange;

        if (position == null) {
          return;
        }

        // The item will become active.
        if (activeIndex === position) {
          // Ensures that if the menu items exceed the bounds of the menu, the
          // menu will scroll up or down as the user hits the arrow keys.
          (0, _utils.scrollIntoViewIfNeeded)((0, _reactDom.findDOMNode)(this));

          // Fire the change handler when the menu item becomes active.
          !currentlyActive && onActiveItemChange(option);
        }

        this._updateInitialItem(nextProps);
      }
    }, {
      key: 'render',
      value: function render() {
        var _context = this.context,
            activeIndex = _context.activeIndex,
            isOnlyResult = _context.isOnlyResult;

        var _props = this.props,
            label = _props.label,
            option = _props.option,
            position = _props.position,
            props = _objectWithoutProperties(_props, ['label', 'option', 'position']);

        var active = isOnlyResult || activeIndex === position;

        return _react2.default.createElement(Component, _extends({}, props, {
          active: active,
          'aria-label': label,
          'aria-selected': active,
          id: (0, _utils.getMenuItemId)(position),
          onClick: this._handleClick,
          onMouseDown: _utils.preventInputBlur,
          role: 'option'
        }));
      }
    }]);

    return WrappedMenuItem;
  }(_react2.default.Component);

  WrappedMenuItem.displayName = 'MenuItemContainer(' + (0, _utils.getDisplayName)(Component) + ')';

  WrappedMenuItem.propTypes = {
    option: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]).isRequired,
    position: _propTypes2.default.number
  };

  WrappedMenuItem.contextTypes = {
    activeIndex: _propTypes2.default.number.isRequired,
    isOnlyResult: _propTypes2.default.bool.isRequired,
    onActiveItemChange: _propTypes2.default.func.isRequired,
    onInitialItemChange: _propTypes2.default.func.isRequired,
    onMenuItemClick: _propTypes2.default.func.isRequired
  };

  return WrappedMenuItem;
};

exports.default = menuItemContainer;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isObject = __webpack_require__(7);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = function () {
  function object() {}
  return function (proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object();
    object.prototype = undefined;
    return result;
  };
}();

module.exports = baseCreate;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var metaMap = __webpack_require__(331),
    noop = __webpack_require__(71);

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function (func) {
  return metaMap.get(func);
};

module.exports = getData;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var realNames = __webpack_require__(332);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = func.name + '',
      array = realNames[result],
      length = hasOwnProperty.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.complaintImageFactory = complaintImageFactory;
exports.multipleComplaintImageFactory = multipleComplaintImageFactory;

var _ComplaintImageFactory = __webpack_require__(139);

var _ComplaintImageFactory2 = _interopRequireDefault(_ComplaintImageFactory);

var _MultipleComplaintImageFactory = __webpack_require__(152);

var _MultipleComplaintImageFactory2 = _interopRequireDefault(_MultipleComplaintImageFactory);

var _DefaultComplaintText = __webpack_require__(153);

var _DefaultComplaintText2 = _interopRequireDefault(_DefaultComplaintText);

var _DefaultSelectImages = __webpack_require__(348);

var _DefaultSelectImages2 = _interopRequireDefault(_DefaultSelectImages);

var _SelectMultipleImages = __webpack_require__(349);

var _SelectMultipleImages2 = _interopRequireDefault(_SelectMultipleImages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function complaintImageFactory() {
  var ComplaintText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _DefaultComplaintText2.default;
  var SelectImages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _DefaultSelectImages2.default;

  return (0, _ComplaintImageFactory2.default)(ComplaintText, SelectImages);
}

function multipleComplaintImageFactory() {
  var ComplaintText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _DefaultComplaintText2.default;
  var SelectImages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _SelectMultipleImages2.default;

  return (0, _MultipleComplaintImageFactory2.default)(ComplaintText, SelectImages);
}

exports.default = {
  complaintImageFactory: complaintImageFactory,
  multipleComplaintImageFactory: multipleComplaintImageFactory
};

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = function (Complaints, SelectImages) {
  var ComplainImage = function (_Component) {
    _inherits(ComplainImage, _Component);

    function ComplainImage(props) {
      _classCallCheck(this, ComplainImage);

      var _this = _possibleConstructorReturn(this, (ComplainImage.__proto__ || Object.getPrototypeOf(ComplainImage)).call(this, props));

      _initialiseProps.call(_this);

      var _this$props$value = _this.props.value;
      _this$props$value = _this$props$value === undefined ? {} : _this$props$value;
      var _this$props$value$url = _this$props$value.url,
          url = _this$props$value$url === undefined ? props.images[0].url : _this$props$value$url,
          _this$props$value$com = _this$props$value.complaints,
          complaints = _this$props$value$com === undefined ? [] : _this$props$value$com;


      _this.state = { url: url, complaints: complaints };
      _this.changeImage(url, false);
      return _this;
    }

    _createClass(ComplainImage, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _ReactDOM$findDOMNode = _reactDom2.default.findDOMNode(this.refs["image-frame"]).getBoundingClientRect(),
            width = _ReactDOM$findDOMNode.width;

        var imagePadding = this.props.imagePadding;


        var stage = this.refs.stage.getStage();

        stage.width(width);
        stage.height(width);

        var image = this.refs.image;
        image.width(width - imagePadding);
        image.height(width - imagePadding);
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _props = this.props,
            images = _props.images,
            _props$complaint = _props.complaint,
            circle = _props$complaint.circle,
            text = _props$complaint.text,
            imageClassName = _props.imageClassName,
            complaintClassName = _props.complaintClassName,
            markerColors = _props.markerColors;
        var _state = this.state,
            url = _state.url,
            image = _state.image,
            complaints = _state.complaints;


        var uiDisplay = null;
        var uiOptions = null;
        this.props.images.forEach(function (item) {
          if (item.url === _this2.state.url) {
            uiDisplay = item.uiDisplay;
            uiOptions = item.uiOptions;
          }
        });

        return _react2.default.createElement(
          _react.Fragment,
          null,
          _react2.default.createElement(
            "div",
            { id: "image", className: imageClassName, ref: "image-frame" },
            _react2.default.createElement(SelectImages, {
              images: images,
              selected: url,
              onSelect: this.changeImage
            }),
            _react2.default.createElement(
              "div",
              null,
              _react2.default.createElement(
                "a",
                {
                  className: "btn",
                  style: {
                    position: "absolute",
                    left: "1px",
                    padding: "2px",
                    zIndex: 99,
                    fontSize: "10px",
                    color: "red"
                  },
                  onClick: function onClick() {
                    _this2.setState({
                      complaints: []
                    }, _this2.notify);
                  } },
                _react2.default.createElement("span", {
                  style: { fontSize: "10px" },
                  className: "glyphicon glyphicon-refresh"
                }),
                "\xA0Clear All"
              )
            ),
            _react2.default.createElement(
              _reactKonva.Stage,
              {
                onClick: this.handleClick,
                onTap: this.handleTap,
                ref: "stage" },
              _react2.default.createElement(
                _reactKonva.Layer,
                { visible: true, ref: "layer" },
                _react2.default.createElement(_reactKonva.Image, { ref: "image", image: image }),
                complaints.map(function (conf, i) {
                  var stroke = markerColors ? markerColors[i % markerColors.length] : circle.stroke;
                  var markerConf = Object.assign({}, conf, circle, { stroke: stroke });
                  return _react2.default.createElement(_ComplaintMarker2.default, _extends({ key: i }, markerConf));
                }),
                complaints.map(function (conf, i) {
                  var fill = markerColors ? markerColors[i % markerColors.length] : circle.fill;
                  var indicatorConf = Object.assign({}, conf, text, { fill: fill });
                  return _react2.default.createElement(_ComplaintIndicator2.default, _extends({ key: i, index: i }, indicatorConf));
                })
              )
            )
          ),
          _react2.default.createElement(
            "div",
            { className: complaintClassName },
            _react2.default.createElement(Complaints, {
              complaints: complaints,
              markerColors: markerColors,
              onChange: this.handleTextChange,
              onDelete: this.handleDelete,
              uiDisplay: uiDisplay,
              uiOptions: uiOptions
            })
          )
        );
      }
    }]);

    return ComplainImage;
  }(_react.Component);

  var _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.changeImage = function (url) {
      var notifyOnLoad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var image = new window.Image();
      image.src = url;
      image.onload = function () {
        if (notifyOnLoad) {
          _this3.setState({ image: image, url: url, complaints: [] }, _this3.notify);
        } else {
          _this3.setState({ image: image, url: url });
        }
      };
    };

    this.handleClick = function (evt) {
      var pointerPos = evt.currentTarget.pointerPos,
          className = evt.target.className;

      if (className !== "Image") {
        return;
      }

      _this3.setState(function (state) {
        var complaints = state.complaints.concat({ pos: pointerPos });
        return Object.assign({}, state, { complaints: complaints });
      }, _this3.notify);
    };

    this.handleTap = function (evt) {
      var pointerPos = evt.currentTarget.pointerPos,
          className = evt.target.className;

      if (className !== "Image") {
        return;
      }

      _this3.setState(function (state) {
        var complaints = state.complaints.concat({ pos: pointerPos });
        return Object.assign({}, state, { complaints: complaints });
      }, _this3.notify);
    };

    this.handleTextChange = function (i, text) {
      _this3.setState(function (_ref) {
        var url = _ref.url,
            complaints = _ref.complaints;

        var complaint = Object.assign({}, complaints[i], { text: text });

        complaints = complaints.slice();
        complaints.splice(i, 1, complaint);

        return { url: url, complaints: complaints };
      }, _this3.notify);
    };

    this.handleDelete = function (i) {
      _this3.setState(function (_ref2) {
        var url = _ref2.url,
            complaints = _ref2.complaints;

        complaints = complaints.slice();
        complaints.splice(i, 1);

        _this3.props.onChange({ url: url, complaints: complaints });
        return { url: url, complaints: complaints };
      }, _this3.notify);
    };

    this.notify = function () {
      /** 
        I believe render is in the call stack and this async operation settimeout sends the function to the webapi.
        Even if the timeout is 0, it does not get added to the call stack until the call stack is empty
        this solves our problem of notify executing before the render function
        or use promise new Promise((event) => setTimeout(event, 10)).then(()=> {
      */
      (0, _timers.setTimeout)(function () {
        if (_this3.props.onChange) {
          var stage = _this3.refs.stage.getStage();
          var event = {
            url: _this3.state.url,
            complaints: _this3.state.complaints,
            dataURI: stage.toDataURL()
          };
          _this3.props.onChange(event);
        }
      }, 0);
    };
  };

  ComplainImage.defaultProps = {
    complaint: {
      circle: {
        radius: 10,
        stroke: "#38A8E8",
        strokeWidth: 2
      },
      text: {
        fontSize: 12,
        fontFamily: "Roboto",
        fill: "black"
      }
    },
    imagePadding: 30,
    imageClassName: "col-md-5 col-sm-12",
    complaintClassName: "col-md-7 col-sm-12"
  };

  ComplainImage.propTypes = {
    value: _propTypes2.default.shape({
      url: _propTypes2.default.string.isRequired,
      complaint: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        pos: _propTypes2.default.shape({
          x: _propTypes2.default.number.isRequired,
          y: _propTypes2.default.number.isRequired
        }),
        text: _propTypes2.default.string.isRequired
      }))
    }),
    images: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      name: _propTypes2.default.string.isRequired,
      url: _propTypes2.default.string.isRequired
    })).isRequired,
    imagePadding: _propTypes2.default.number,
    imageClassName: _propTypes2.default.string,
    complaintClassName: _propTypes2.default.string,
    complaint: _propTypes2.default.shape({
      radius: _propTypes2.default.number,
      stroke: _propTypes2.default.string,
      strokeWidth: _propTypes2.default.number
    }),
    markerColors: _propTypes2.default.arrayOf(_propTypes2.default.string),
    onChange: _propTypes2.default.func
  };

  return ComplainImage;
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(6);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactKonva = __webpack_require__(28);

var _ComplaintMarker = __webpack_require__(78);

var _ComplaintMarker2 = _interopRequireDefault(_ComplaintMarker);

var _ComplaintIndicator = __webpack_require__(79);

var _ComplaintIndicator2 = _interopRequireDefault(_ComplaintIndicator);

var _timers = __webpack_require__(80);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.6.1
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var aa = __webpack_require__(0),
    n = __webpack_require__(75),
    ba = __webpack_require__(41);function ca(a, b, c, d, e, f, g, h) {
  if (!a) {
    a = void 0;if (void 0 === b) a = Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
      var k = [c, d, e, f, g, h],
          l = 0;a = Error(b.replace(/%s/g, function () {
        return k[l++];
      }));a.name = "Invariant Violation";
    }a.framesToPop = 1;throw a;
  }
}
function t(a) {
  for (var b = arguments.length - 1, c = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, d = 0; d < b; d++) {
    c += "&args[]=" + encodeURIComponent(arguments[d + 1]);
  }ca(!1, "Minified React error #" + a + "; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ", c);
}aa ? void 0 : t("227");function da(a, b, c, d, e, f, g, h, k) {
  var l = Array.prototype.slice.call(arguments, 3);try {
    b.apply(c, l);
  } catch (m) {
    this.onError(m);
  }
}
var ea = !1,
    fa = null,
    ha = !1,
    ia = null,
    ja = { onError: function onError(a) {
    ea = !0;fa = a;
  } };function ka(a, b, c, d, e, f, g, h, k) {
  ea = !1;fa = null;da.apply(ja, arguments);
}function la(a, b, c, d, e, f, g, h, k) {
  ka.apply(this, arguments);if (ea) {
    if (ea) {
      var l = fa;ea = !1;fa = null;
    } else t("198"), l = void 0;ha || (ha = !0, ia = l);
  }
}var ma = null,
    na = {};
function oa() {
  if (ma) for (var a in na) {
    var b = na[a],
        c = ma.indexOf(a);-1 < c ? void 0 : t("96", a);if (!pa[c]) {
      b.extractEvents ? void 0 : t("97", a);pa[c] = b;c = b.eventTypes;for (var d in c) {
        var e = void 0;var f = c[d],
            g = b,
            h = d;qa.hasOwnProperty(h) ? t("99", h) : void 0;qa[h] = f;var k = f.phasedRegistrationNames;if (k) {
          for (e in k) {
            k.hasOwnProperty(e) && ra(k[e], g, h);
          }e = !0;
        } else f.registrationName ? (ra(f.registrationName, g, h), e = !0) : e = !1;e ? void 0 : t("98", d, a);
      }
    }
  }
}
function ra(a, b, c) {
  sa[a] ? t("100", a) : void 0;sa[a] = b;ta[a] = b.eventTypes[c].dependencies;
}var pa = [],
    qa = {},
    sa = {},
    ta = {},
    ua = null,
    va = null,
    wa = null;function xa(a, b, c) {
  var d = a.type || "unknown-event";a.currentTarget = wa(c);la(d, b, void 0, a);a.currentTarget = null;
}function ya(a, b) {
  null == b ? t("30") : void 0;if (null == a) return b;if (Array.isArray(a)) {
    if (Array.isArray(b)) return a.push.apply(a, b), a;a.push(b);return a;
  }return Array.isArray(b) ? [a].concat(b) : [a, b];
}
function za(a, b, c) {
  Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);
}var Aa = null;function Ba(a) {
  if (a) {
    var b = a._dispatchListeners,
        c = a._dispatchInstances;if (Array.isArray(b)) for (var d = 0; d < b.length && !a.isPropagationStopped(); d++) {
      xa(a, b[d], c[d]);
    } else b && xa(a, b, c);a._dispatchListeners = null;a._dispatchInstances = null;a.isPersistent() || a.constructor.release(a);
  }
}
var Ca = { injectEventPluginOrder: function injectEventPluginOrder(a) {
    ma ? t("101") : void 0;ma = Array.prototype.slice.call(a);oa();
  }, injectEventPluginsByName: function injectEventPluginsByName(a) {
    var b = !1,
        c;for (c in a) {
      if (a.hasOwnProperty(c)) {
        var d = a[c];na.hasOwnProperty(c) && na[c] === d || (na[c] ? t("102", c) : void 0, na[c] = d, b = !0);
      }
    }b && oa();
  } };
function Da(a, b) {
  var c = a.stateNode;if (!c) return null;var d = ua(c);if (!d) return null;c = d[b];a: switch (b) {case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":
      (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));a = !d;break a;default:
      a = !1;}if (a) return null;c && "function" !== typeof c ? t("231", b, typeof c === "undefined" ? "undefined" : _typeof(c)) : void 0;
  return c;
}function Ea(a) {
  null !== a && (Aa = ya(Aa, a));a = Aa;Aa = null;if (a && (za(a, Ba), Aa ? t("95") : void 0, ha)) throw a = ia, ha = !1, ia = null, a;
}var Fa = Math.random().toString(36).slice(2),
    Ga = "__reactInternalInstance$" + Fa,
    Ha = "__reactEventHandlers$" + Fa;function Ia(a) {
  if (a[Ga]) return a[Ga];for (; !a[Ga];) {
    if (a.parentNode) a = a.parentNode;else return null;
  }a = a[Ga];return 5 === a.tag || 6 === a.tag ? a : null;
}function Ja(a) {
  a = a[Ga];return !a || 5 !== a.tag && 6 !== a.tag ? null : a;
}
function Ka(a) {
  if (5 === a.tag || 6 === a.tag) return a.stateNode;t("33");
}function La(a) {
  return a[Ha] || null;
}function Ma(a) {
  do {
    a = a.return;
  } while (a && 5 !== a.tag);return a ? a : null;
}function Na(a, b, c) {
  if (b = Da(a, c.dispatchConfig.phasedRegistrationNames[b])) c._dispatchListeners = ya(c._dispatchListeners, b), c._dispatchInstances = ya(c._dispatchInstances, a);
}
function Oa(a) {
  if (a && a.dispatchConfig.phasedRegistrationNames) {
    for (var b = a._targetInst, c = []; b;) {
      c.push(b), b = Ma(b);
    }for (b = c.length; 0 < b--;) {
      Na(c[b], "captured", a);
    }for (b = 0; b < c.length; b++) {
      Na(c[b], "bubbled", a);
    }
  }
}function Pa(a, b, c) {
  a && c && c.dispatchConfig.registrationName && (b = Da(a, c.dispatchConfig.registrationName)) && (c._dispatchListeners = ya(c._dispatchListeners, b), c._dispatchInstances = ya(c._dispatchInstances, a));
}function Qa(a) {
  a && a.dispatchConfig.registrationName && Pa(a._targetInst, null, a);
}
function Ra(a) {
  za(a, Oa);
}var Sa = !("undefined" === typeof window || !window.document || !window.document.createElement);function Ta(a, b) {
  var c = {};c[a.toLowerCase()] = b.toLowerCase();c["Webkit" + a] = "webkit" + b;c["Moz" + a] = "moz" + b;return c;
}var Ua = { animationend: Ta("Animation", "AnimationEnd"), animationiteration: Ta("Animation", "AnimationIteration"), animationstart: Ta("Animation", "AnimationStart"), transitionend: Ta("Transition", "TransitionEnd") },
    Va = {},
    Wa = {};
Sa && (Wa = document.createElement("div").style, "AnimationEvent" in window || (delete Ua.animationend.animation, delete Ua.animationiteration.animation, delete Ua.animationstart.animation), "TransitionEvent" in window || delete Ua.transitionend.transition);function Xa(a) {
  if (Va[a]) return Va[a];if (!Ua[a]) return a;var b = Ua[a],
      c;for (c in b) {
    if (b.hasOwnProperty(c) && c in Wa) return Va[a] = b[c];
  }return a;
}
var Ya = Xa("animationend"),
    Za = Xa("animationiteration"),
    $a = Xa("animationstart"),
    ab = Xa("transitionend"),
    bb = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),
    cb = null,
    eb = null,
    fb = null;
function gb() {
  if (fb) return fb;var a,
      b = eb,
      c = b.length,
      d,
      e = "value" in cb ? cb.value : cb.textContent,
      f = e.length;for (a = 0; a < c && b[a] === e[a]; a++) {}var g = c - a;for (d = 1; d <= g && b[c - d] === e[f - d]; d++) {}return fb = e.slice(a, 1 < d ? 1 - d : void 0);
}function hb() {
  return !0;
}function ib() {
  return !1;
}
function A(a, b, c, d) {
  this.dispatchConfig = a;this._targetInst = b;this.nativeEvent = c;a = this.constructor.Interface;for (var e in a) {
    a.hasOwnProperty(e) && ((b = a[e]) ? this[e] = b(c) : "target" === e ? this.target = d : this[e] = c[e]);
  }this.isDefaultPrevented = (null != c.defaultPrevented ? c.defaultPrevented : !1 === c.returnValue) ? hb : ib;this.isPropagationStopped = ib;return this;
}
n(A.prototype, { preventDefault: function preventDefault() {
    this.defaultPrevented = !0;var a = this.nativeEvent;a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = hb);
  }, stopPropagation: function stopPropagation() {
    var a = this.nativeEvent;a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = hb);
  }, persist: function persist() {
    this.isPersistent = hb;
  }, isPersistent: ib, destructor: function destructor() {
    var a = this.constructor.Interface,
        b;for (b in a) {
      this[b] = null;
    }this.nativeEvent = this._targetInst = this.dispatchConfig = null;this.isPropagationStopped = this.isDefaultPrevented = ib;this._dispatchInstances = this._dispatchListeners = null;
  } });A.Interface = { type: null, target: null, currentTarget: function currentTarget() {
    return null;
  }, eventPhase: null, bubbles: null, cancelable: null, timeStamp: function timeStamp(a) {
    return a.timeStamp || Date.now();
  }, defaultPrevented: null, isTrusted: null };
A.extend = function (a) {
  function b() {}function c() {
    return d.apply(this, arguments);
  }var d = this;b.prototype = d.prototype;var e = new b();n(e, c.prototype);c.prototype = e;c.prototype.constructor = c;c.Interface = n({}, d.Interface, a);c.extend = d.extend;jb(c);return c;
};jb(A);function kb(a, b, c, d) {
  if (this.eventPool.length) {
    var e = this.eventPool.pop();this.call(e, a, b, c, d);return e;
  }return new this(a, b, c, d);
}function lb(a) {
  a instanceof this ? void 0 : t("279");a.destructor();10 > this.eventPool.length && this.eventPool.push(a);
}
function jb(a) {
  a.eventPool = [];a.getPooled = kb;a.release = lb;
}var mb = A.extend({ data: null }),
    nb = A.extend({ data: null }),
    ob = [9, 13, 27, 32],
    pb = Sa && "CompositionEvent" in window,
    qb = null;Sa && "documentMode" in document && (qb = document.documentMode);
var rb = Sa && "TextEvent" in window && !qb,
    sb = Sa && (!pb || qb && 8 < qb && 11 >= qb),
    tb = String.fromCharCode(32),
    ub = { beforeInput: { phasedRegistrationNames: { bubbled: "onBeforeInput", captured: "onBeforeInputCapture" }, dependencies: ["compositionend", "keypress", "textInput", "paste"] }, compositionEnd: { phasedRegistrationNames: { bubbled: "onCompositionEnd", captured: "onCompositionEndCapture" }, dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ") }, compositionStart: { phasedRegistrationNames: { bubbled: "onCompositionStart",
      captured: "onCompositionStartCapture" }, dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ") }, compositionUpdate: { phasedRegistrationNames: { bubbled: "onCompositionUpdate", captured: "onCompositionUpdateCapture" }, dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ") } },
    vb = !1;
function wb(a, b) {
  switch (a) {case "keyup":
      return -1 !== ob.indexOf(b.keyCode);case "keydown":
      return 229 !== b.keyCode;case "keypress":case "mousedown":case "blur":
      return !0;default:
      return !1;}
}function xb(a) {
  a = a.detail;return "object" === (typeof a === "undefined" ? "undefined" : _typeof(a)) && "data" in a ? a.data : null;
}var yb = !1;function zb(a, b) {
  switch (a) {case "compositionend":
      return xb(b);case "keypress":
      if (32 !== b.which) return null;vb = !0;return tb;case "textInput":
      return a = b.data, a === tb && vb ? null : a;default:
      return null;}
}
function Ab(a, b) {
  if (yb) return "compositionend" === a || !pb && wb(a, b) ? (a = gb(), fb = eb = cb = null, yb = !1, a) : null;switch (a) {case "paste":
      return null;case "keypress":
      if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
        if (b.char && 1 < b.char.length) return b.char;if (b.which) return String.fromCharCode(b.which);
      }return null;case "compositionend":
      return sb && "ko" !== b.locale ? null : b.data;default:
      return null;}
}
var Bb = { eventTypes: ub, extractEvents: function extractEvents(a, b, c, d) {
    var e = void 0;var f = void 0;if (pb) b: {
      switch (a) {case "compositionstart":
          e = ub.compositionStart;break b;case "compositionend":
          e = ub.compositionEnd;break b;case "compositionupdate":
          e = ub.compositionUpdate;break b;}e = void 0;
    } else yb ? wb(a, c) && (e = ub.compositionEnd) : "keydown" === a && 229 === c.keyCode && (e = ub.compositionStart);e ? (sb && "ko" !== c.locale && (yb || e !== ub.compositionStart ? e === ub.compositionEnd && yb && (f = gb()) : (cb = d, eb = "value" in cb ? cb.value : cb.textContent, yb = !0)), e = mb.getPooled(e, b, c, d), f ? e.data = f : (f = xb(c), null !== f && (e.data = f)), Ra(e), f = e) : f = null;(a = rb ? zb(a, c) : Ab(a, c)) ? (b = nb.getPooled(ub.beforeInput, b, c, d), b.data = a, Ra(b)) : b = null;return null === f ? b : null === b ? f : [f, b];
  } },
    Cb = null,
    Db = null,
    Eb = null;function Hb(a) {
  if (a = va(a)) {
    "function" !== typeof Cb ? t("280") : void 0;var b = ua(a.stateNode);Cb(a.stateNode, a.type, b);
  }
}function Ib(a) {
  Db ? Eb ? Eb.push(a) : Eb = [a] : Db = a;
}function Jb() {
  if (Db) {
    var a = Db,
        b = Eb;Eb = Db = null;Hb(a);if (b) for (a = 0; a < b.length; a++) {
      Hb(b[a]);
    }
  }
}
function Kb(a, b) {
  return a(b);
}function Lb(a, b, c) {
  return a(b, c);
}function Mb() {}var Nb = !1;function Ob(a, b) {
  if (Nb) return a(b);Nb = !0;try {
    return Kb(a, b);
  } finally {
    if (Nb = !1, null !== Db || null !== Eb) Mb(), Jb();
  }
}var Pb = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };function Qb(a) {
  var b = a && a.nodeName && a.nodeName.toLowerCase();return "input" === b ? !!Pb[a.type] : "textarea" === b ? !0 : !1;
}
function Rb(a) {
  a = a.target || a.srcElement || window;a.correspondingUseElement && (a = a.correspondingUseElement);return 3 === a.nodeType ? a.parentNode : a;
}function Sb(a) {
  if (!Sa) return !1;a = "on" + a;var b = a in document;b || (b = document.createElement("div"), b.setAttribute(a, "return;"), b = "function" === typeof b[a]);return b;
}function Tb(a) {
  var b = a.type;return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ub(a) {
  var b = Tb(a) ? "checked" : "value",
      c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b),
      d = "" + a[b];if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
    var e = c.get,
        f = c.set;Object.defineProperty(a, b, { configurable: !0, get: function get() {
        return e.call(this);
      }, set: function set(a) {
        d = "" + a;f.call(this, a);
      } });Object.defineProperty(a, b, { enumerable: c.enumerable });return { getValue: function getValue() {
        return d;
      }, setValue: function setValue(a) {
        d = "" + a;
      }, stopTracking: function stopTracking() {
        a._valueTracker = null;delete a[b];
      } };
  }
}function Vb(a) {
  a._valueTracker || (a._valueTracker = Ub(a));
}function Wb(a) {
  if (!a) return !1;var b = a._valueTracker;if (!b) return !0;var c = b.getValue();var d = "";a && (d = Tb(a) ? a.checked ? "true" : "false" : a.value);a = d;return a !== c ? (b.setValue(a), !0) : !1;
}
var Xb = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
    Yb = /^(.*)[\\\/]/,
    D = "function" === typeof Symbol && Symbol.for,
    Zb = D ? Symbol.for("react.element") : 60103,
    $b = D ? Symbol.for("react.portal") : 60106,
    ac = D ? Symbol.for("react.fragment") : 60107,
    bc = D ? Symbol.for("react.strict_mode") : 60108,
    cc = D ? Symbol.for("react.profiler") : 60114,
    dc = D ? Symbol.for("react.provider") : 60109,
    ec = D ? Symbol.for("react.context") : 60110,
    fc = D ? Symbol.for("react.concurrent_mode") : 60111,
    gc = D ? Symbol.for("react.forward_ref") : 60112,
    hc = D ? Symbol.for("react.suspense") : 60113,
    ic = D ? Symbol.for("react.memo") : 60115,
    jc = D ? Symbol.for("react.lazy") : 60116,
    kc = "function" === typeof Symbol && Symbol.iterator;function lc(a) {
  if (null === a || "object" !== (typeof a === "undefined" ? "undefined" : _typeof(a))) return null;a = kc && a[kc] || a["@@iterator"];return "function" === typeof a ? a : null;
}
function mc(a) {
  if (null == a) return null;if ("function" === typeof a) return a.displayName || a.name || null;if ("string" === typeof a) return a;switch (a) {case fc:
      return "ConcurrentMode";case ac:
      return "Fragment";case $b:
      return "Portal";case cc:
      return "Profiler";case bc:
      return "StrictMode";case hc:
      return "Suspense";}if ("object" === (typeof a === "undefined" ? "undefined" : _typeof(a))) switch (a.$$typeof) {case ec:
      return "Context.Consumer";case dc:
      return "Context.Provider";case gc:
      var b = a.render;b = b.displayName || b.name || "";return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");case ic:
      return mc(a.type);case jc:
      if (a = 1 === a._status ? a._result : null) return mc(a);}return null;
}function nc(a) {
  var b = "";do {
    a: switch (a.tag) {case 2:case 16:case 0:case 1:case 5:case 8:case 13:
        var c = a._debugOwner,
            d = a._debugSource,
            e = mc(a.type);var f = null;c && (f = mc(c.type));c = e;e = "";d ? e = " (at " + d.fileName.replace(Yb, "") + ":" + d.lineNumber + ")" : f && (e = " (created by " + f + ")");f = "\n    in " + (c || "Unknown") + e;break a;default:
        f = "";}b += f;a = a.return;
  } while (a);return b;
}
var oc = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
    pc = Object.prototype.hasOwnProperty,
    qc = {},
    rc = {};
function sc(a) {
  if (pc.call(rc, a)) return !0;if (pc.call(qc, a)) return !1;if (oc.test(a)) return rc[a] = !0;qc[a] = !0;return !1;
}function tc(a, b, c, d) {
  if (null !== c && 0 === c.type) return !1;switch (typeof b === "undefined" ? "undefined" : _typeof(b)) {case "function":case "symbol":
      return !0;case "boolean":
      if (d) return !1;if (null !== c) return !c.acceptsBooleans;a = a.toLowerCase().slice(0, 5);return "data-" !== a && "aria-" !== a;default:
      return !1;}
}
function uc(a, b, c, d) {
  if (null === b || "undefined" === typeof b || tc(a, b, c, d)) return !0;if (d) return !1;if (null !== c) switch (c.type) {case 3:
      return !b;case 4:
      return !1 === b;case 5:
      return isNaN(b);case 6:
      return isNaN(b) || 1 > b;}return !1;
}function E(a, b, c, d, e) {
  this.acceptsBooleans = 2 === b || 3 === b || 4 === b;this.attributeName = d;this.attributeNamespace = e;this.mustUseProperty = c;this.propertyName = a;this.type = b;
}var F = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (a) {
  F[a] = new E(a, 0, !1, a, null);
});[["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (a) {
  var b = a[0];F[b] = new E(b, 1, !1, a[1], null);
});["contentEditable", "draggable", "spellCheck", "value"].forEach(function (a) {
  F[a] = new E(a, 2, !1, a.toLowerCase(), null);
});
["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (a) {
  F[a] = new E(a, 2, !1, a, null);
});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (a) {
  F[a] = new E(a, 3, !1, a.toLowerCase(), null);
});["checked", "multiple", "muted", "selected"].forEach(function (a) {
  F[a] = new E(a, 3, !0, a, null);
});
["capture", "download"].forEach(function (a) {
  F[a] = new E(a, 4, !1, a, null);
});["cols", "rows", "size", "span"].forEach(function (a) {
  F[a] = new E(a, 6, !1, a, null);
});["rowSpan", "start"].forEach(function (a) {
  F[a] = new E(a, 5, !1, a.toLowerCase(), null);
});var vc = /[\-:]([a-z])/g;function xc(a) {
  return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (a) {
  var b = a.replace(vc, xc);F[b] = new E(b, 1, !1, a, null);
});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (a) {
  var b = a.replace(vc, xc);F[b] = new E(b, 1, !1, a, "http://www.w3.org/1999/xlink");
});["xml:base", "xml:lang", "xml:space"].forEach(function (a) {
  var b = a.replace(vc, xc);F[b] = new E(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace");
});F.tabIndex = new E("tabIndex", 1, !1, "tabindex", null);
function yc(a, b, c, d) {
  var e = F.hasOwnProperty(b) ? F[b] : null;var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;f || (uc(b, c, e, d) && (c = null), d || null === e ? sc(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
function zc(a) {
  switch (typeof a === "undefined" ? "undefined" : _typeof(a)) {case "boolean":case "number":case "object":case "string":case "undefined":
      return a;default:
      return "";}
}function Ac(a, b) {
  var c = b.checked;return n({}, b, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: null != c ? c : a._wrapperState.initialChecked });
}
function Bc(a, b) {
  var c = null == b.defaultValue ? "" : b.defaultValue,
      d = null != b.checked ? b.checked : b.defaultChecked;c = zc(null != b.value ? b.value : c);a._wrapperState = { initialChecked: d, initialValue: c, controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value };
}function Cc(a, b) {
  b = b.checked;null != b && yc(a, "checked", b, !1);
}
function Dc(a, b) {
  Cc(a, b);var c = zc(b.value),
      d = b.type;if (null != c) {
    if ("number" === d) {
      if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
    } else a.value !== "" + c && (a.value = "" + c);
  } else if ("submit" === d || "reset" === d) {
    a.removeAttribute("value");return;
  }b.hasOwnProperty("value") ? Ec(a, b.type, c) : b.hasOwnProperty("defaultValue") && Ec(a, b.type, zc(b.defaultValue));null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function Fc(a, b, c) {
  if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
    var d = b.type;if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;b = "" + a._wrapperState.initialValue;c || b === a.value || (a.value = b);a.defaultValue = b;
  }c = a.name;"" !== c && (a.name = "");a.defaultChecked = !a.defaultChecked;a.defaultChecked = !!a._wrapperState.initialChecked;"" !== c && (a.name = c);
}
function Ec(a, b, c) {
  if ("number" !== b || a.ownerDocument.activeElement !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}var Gc = { change: { phasedRegistrationNames: { bubbled: "onChange", captured: "onChangeCapture" }, dependencies: "blur change click focus input keydown keyup selectionchange".split(" ") } };function Hc(a, b, c) {
  a = A.getPooled(Gc.change, a, b, c);a.type = "change";Ib(c);Ra(a);return a;
}var Jc = null,
    Kc = null;function Lc(a) {
  Ea(a);
}
function Mc(a) {
  var b = Ka(a);if (Wb(b)) return a;
}function Nc(a, b) {
  if ("change" === a) return b;
}var Oc = !1;Sa && (Oc = Sb("input") && (!document.documentMode || 9 < document.documentMode));function Pc() {
  Jc && (Jc.detachEvent("onpropertychange", Qc), Kc = Jc = null);
}function Qc(a) {
  "value" === a.propertyName && Mc(Kc) && (a = Hc(Kc, a, Rb(a)), Ob(Lc, a));
}function Rc(a, b, c) {
  "focus" === a ? (Pc(), Jc = b, Kc = c, Jc.attachEvent("onpropertychange", Qc)) : "blur" === a && Pc();
}function Sc(a) {
  if ("selectionchange" === a || "keyup" === a || "keydown" === a) return Mc(Kc);
}
function Tc(a, b) {
  if ("click" === a) return Mc(b);
}function Uc(a, b) {
  if ("input" === a || "change" === a) return Mc(b);
}
var Vc = { eventTypes: Gc, _isInputEventSupported: Oc, extractEvents: function extractEvents(a, b, c, d) {
    var e = b ? Ka(b) : window,
        f = void 0,
        g = void 0,
        h = e.nodeName && e.nodeName.toLowerCase();"select" === h || "input" === h && "file" === e.type ? f = Nc : Qb(e) ? Oc ? f = Uc : (f = Sc, g = Rc) : (h = e.nodeName) && "input" === h.toLowerCase() && ("checkbox" === e.type || "radio" === e.type) && (f = Tc);if (f && (f = f(a, b))) return Hc(f, c, d);g && g(a, e, b);"blur" === a && (a = e._wrapperState) && a.controlled && "number" === e.type && Ec(e, "number", e.value);
  } },
    Wc = A.extend({ view: null, detail: null }),
    Xc = { Alt: "altKey",
  Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };function Yc(a) {
  var b = this.nativeEvent;return b.getModifierState ? b.getModifierState(a) : (a = Xc[a]) ? !!b[a] : !1;
}function Zc() {
  return Yc;
}
var $c = 0,
    ad = 0,
    bd = !1,
    cd = !1,
    dd = Wc.extend({ screenX: null, screenY: null, clientX: null, clientY: null, pageX: null, pageY: null, ctrlKey: null, shiftKey: null, altKey: null, metaKey: null, getModifierState: Zc, button: null, buttons: null, relatedTarget: function relatedTarget(a) {
    return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
  }, movementX: function movementX(a) {
    if ("movementX" in a) return a.movementX;var b = $c;$c = a.screenX;return bd ? "mousemove" === a.type ? a.screenX - b : 0 : (bd = !0, 0);
  }, movementY: function movementY(a) {
    if ("movementY" in a) return a.movementY;
    var b = ad;ad = a.screenY;return cd ? "mousemove" === a.type ? a.screenY - b : 0 : (cd = !0, 0);
  } }),
    ed = dd.extend({ pointerId: null, width: null, height: null, pressure: null, tangentialPressure: null, tiltX: null, tiltY: null, twist: null, pointerType: null, isPrimary: null }),
    fd = { mouseEnter: { registrationName: "onMouseEnter", dependencies: ["mouseout", "mouseover"] }, mouseLeave: { registrationName: "onMouseLeave", dependencies: ["mouseout", "mouseover"] }, pointerEnter: { registrationName: "onPointerEnter", dependencies: ["pointerout", "pointerover"] }, pointerLeave: { registrationName: "onPointerLeave",
    dependencies: ["pointerout", "pointerover"] } },
    gd = { eventTypes: fd, extractEvents: function extractEvents(a, b, c, d) {
    var e = "mouseover" === a || "pointerover" === a,
        f = "mouseout" === a || "pointerout" === a;if (e && (c.relatedTarget || c.fromElement) || !f && !e) return null;e = d.window === d ? d : (e = d.ownerDocument) ? e.defaultView || e.parentWindow : window;f ? (f = b, b = (b = c.relatedTarget || c.toElement) ? Ia(b) : null) : f = null;if (f === b) return null;var g = void 0,
        h = void 0,
        k = void 0,
        l = void 0;if ("mouseout" === a || "mouseover" === a) g = dd, h = fd.mouseLeave, k = fd.mouseEnter, l = "mouse";else if ("pointerout" === a || "pointerover" === a) g = ed, h = fd.pointerLeave, k = fd.pointerEnter, l = "pointer";var m = null == f ? e : Ka(f);e = null == b ? e : Ka(b);a = g.getPooled(h, f, c, d);a.type = l + "leave";a.target = m;a.relatedTarget = e;c = g.getPooled(k, b, c, d);c.type = l + "enter";c.target = e;c.relatedTarget = m;d = b;if (f && d) a: {
      b = f;e = d;l = 0;for (g = b; g; g = Ma(g)) {
        l++;
      }g = 0;for (k = e; k; k = Ma(k)) {
        g++;
      }for (; 0 < l - g;) {
        b = Ma(b), l--;
      }for (; 0 < g - l;) {
        e = Ma(e), g--;
      }for (; l--;) {
        if (b === e || b === e.alternate) break a;b = Ma(b);e = Ma(e);
      }b = null;
    } else b = null;e = b;for (b = []; f && f !== e;) {
      l = f.alternate;if (null !== l && l === e) break;b.push(f);f = Ma(f);
    }for (f = []; d && d !== e;) {
      l = d.alternate;if (null !== l && l === e) break;f.push(d);d = Ma(d);
    }for (d = 0; d < b.length; d++) {
      Pa(b[d], "bubbled", a);
    }for (d = f.length; 0 < d--;) {
      Pa(f[d], "captured", c);
    }return [a, c];
  } },
    hd = Object.prototype.hasOwnProperty;function id(a, b) {
  return a === b ? 0 !== a || 0 !== b || 1 / a === 1 / b : a !== a && b !== b;
}
function jd(a, b) {
  if (id(a, b)) return !0;if ("object" !== (typeof a === "undefined" ? "undefined" : _typeof(a)) || null === a || "object" !== (typeof b === "undefined" ? "undefined" : _typeof(b)) || null === b) return !1;var c = Object.keys(a),
      d = Object.keys(b);if (c.length !== d.length) return !1;for (d = 0; d < c.length; d++) {
    if (!hd.call(b, c[d]) || !id(a[c[d]], b[c[d]])) return !1;
  }return !0;
}function kd(a) {
  var b = a;if (a.alternate) for (; b.return;) {
    b = b.return;
  } else {
    if (0 !== (b.effectTag & 2)) return 1;for (; b.return;) {
      if (b = b.return, 0 !== (b.effectTag & 2)) return 1;
    }
  }return 3 === b.tag ? 2 : 3;
}function ld(a) {
  2 !== kd(a) ? t("188") : void 0;
}
function md(a) {
  var b = a.alternate;if (!b) return b = kd(a), 3 === b ? t("188") : void 0, 1 === b ? null : a;for (var c = a, d = b;;) {
    var e = c.return,
        f = e ? e.alternate : null;if (!e || !f) break;if (e.child === f.child) {
      for (var g = e.child; g;) {
        if (g === c) return ld(e), a;if (g === d) return ld(e), b;g = g.sibling;
      }t("188");
    }if (c.return !== d.return) c = e, d = f;else {
      g = !1;for (var h = e.child; h;) {
        if (h === c) {
          g = !0;c = e;d = f;break;
        }if (h === d) {
          g = !0;d = e;c = f;break;
        }h = h.sibling;
      }if (!g) {
        for (h = f.child; h;) {
          if (h === c) {
            g = !0;c = f;d = e;break;
          }if (h === d) {
            g = !0;d = f;c = e;break;
          }h = h.sibling;
        }g ? void 0 : t("189");
      }
    }c.alternate !== d ? t("190") : void 0;
  }3 !== c.tag ? t("188") : void 0;return c.stateNode.current === c ? a : b;
}function nd(a) {
  a = md(a);if (!a) return null;for (var b = a;;) {
    if (5 === b.tag || 6 === b.tag) return b;if (b.child) b.child.return = b, b = b.child;else {
      if (b === a) break;for (; !b.sibling;) {
        if (!b.return || b.return === a) return null;b = b.return;
      }b.sibling.return = b.return;b = b.sibling;
    }
  }return null;
}
var od = A.extend({ animationName: null, elapsedTime: null, pseudoElement: null }),
    pd = A.extend({ clipboardData: function clipboardData(a) {
    return "clipboardData" in a ? a.clipboardData : window.clipboardData;
  } }),
    qd = Wc.extend({ relatedTarget: null });function rd(a) {
  var b = a.keyCode;"charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;10 === a && (a = 13);return 32 <= a || 13 === a ? a : 0;
}
var sd = { Esc: "Escape", Spacebar: " ", Left: "ArrowLeft", Up: "ArrowUp", Right: "ArrowRight", Down: "ArrowDown", Del: "Delete", Win: "OS", Menu: "ContextMenu", Apps: "ContextMenu", Scroll: "ScrollLock", MozPrintableKey: "Unidentified" },
    td = { 8: "Backspace", 9: "Tab", 12: "Clear", 13: "Enter", 16: "Shift", 17: "Control", 18: "Alt", 19: "Pause", 20: "CapsLock", 27: "Escape", 32: " ", 33: "PageUp", 34: "PageDown", 35: "End", 36: "Home", 37: "ArrowLeft", 38: "ArrowUp", 39: "ArrowRight", 40: "ArrowDown", 45: "Insert", 46: "Delete", 112: "F1", 113: "F2", 114: "F3", 115: "F4",
  116: "F5", 117: "F6", 118: "F7", 119: "F8", 120: "F9", 121: "F10", 122: "F11", 123: "F12", 144: "NumLock", 145: "ScrollLock", 224: "Meta" },
    ud = Wc.extend({ key: function key(a) {
    if (a.key) {
      var b = sd[a.key] || a.key;if ("Unidentified" !== b) return b;
    }return "keypress" === a.type ? (a = rd(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? td[a.keyCode] || "Unidentified" : "";
  }, location: null, ctrlKey: null, shiftKey: null, altKey: null, metaKey: null, repeat: null, locale: null, getModifierState: Zc, charCode: function charCode(a) {
    return "keypress" === a.type ? rd(a) : 0;
  }, keyCode: function keyCode(a) {
    return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
  }, which: function which(a) {
    return "keypress" === a.type ? rd(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
  } }),
    vd = dd.extend({ dataTransfer: null }),
    wd = Wc.extend({ touches: null, targetTouches: null, changedTouches: null, altKey: null, metaKey: null, ctrlKey: null, shiftKey: null, getModifierState: Zc }),
    xd = A.extend({ propertyName: null, elapsedTime: null, pseudoElement: null }),
    yd = dd.extend({ deltaX: function deltaX(a) {
    return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
  }, deltaY: function deltaY(a) {
    return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
  }, deltaZ: null, deltaMode: null }),
    zd = [["abort", "abort"], [Ya, "animationEnd"], [Za, "animationIteration"], [$a, "animationStart"], ["canplay", "canPlay"], ["canplaythrough", "canPlayThrough"], ["drag", "drag"], ["dragenter", "dragEnter"], ["dragexit", "dragExit"], ["dragleave", "dragLeave"], ["dragover", "dragOver"], ["durationchange", "durationChange"], ["emptied", "emptied"], ["encrypted", "encrypted"], ["ended", "ended"], ["error", "error"], ["gotpointercapture", "gotPointerCapture"], ["load", "load"], ["loadeddata", "loadedData"], ["loadedmetadata", "loadedMetadata"], ["loadstart", "loadStart"], ["lostpointercapture", "lostPointerCapture"], ["mousemove", "mouseMove"], ["mouseout", "mouseOut"], ["mouseover", "mouseOver"], ["playing", "playing"], ["pointermove", "pointerMove"], ["pointerout", "pointerOut"], ["pointerover", "pointerOver"], ["progress", "progress"], ["scroll", "scroll"], ["seeking", "seeking"], ["stalled", "stalled"], ["suspend", "suspend"], ["timeupdate", "timeUpdate"], ["toggle", "toggle"], ["touchmove", "touchMove"], [ab, "transitionEnd"], ["waiting", "waiting"], ["wheel", "wheel"]],
    Ad = {},
    Bd = {};function Cd(a, b) {
  var c = a[0];a = a[1];var d = "on" + (a[0].toUpperCase() + a.slice(1));b = { phasedRegistrationNames: { bubbled: d, captured: d + "Capture" }, dependencies: [c], isInteractive: b };Ad[a] = b;Bd[c] = b;
}
[["blur", "blur"], ["cancel", "cancel"], ["click", "click"], ["close", "close"], ["contextmenu", "contextMenu"], ["copy", "copy"], ["cut", "cut"], ["auxclick", "auxClick"], ["dblclick", "doubleClick"], ["dragend", "dragEnd"], ["dragstart", "dragStart"], ["drop", "drop"], ["focus", "focus"], ["input", "input"], ["invalid", "invalid"], ["keydown", "keyDown"], ["keypress", "keyPress"], ["keyup", "keyUp"], ["mousedown", "mouseDown"], ["mouseup", "mouseUp"], ["paste", "paste"], ["pause", "pause"], ["play", "play"], ["pointercancel", "pointerCancel"], ["pointerdown", "pointerDown"], ["pointerup", "pointerUp"], ["ratechange", "rateChange"], ["reset", "reset"], ["seeked", "seeked"], ["submit", "submit"], ["touchcancel", "touchCancel"], ["touchend", "touchEnd"], ["touchstart", "touchStart"], ["volumechange", "volumeChange"]].forEach(function (a) {
  Cd(a, !0);
});zd.forEach(function (a) {
  Cd(a, !1);
});
var Dd = { eventTypes: Ad, isInteractiveTopLevelEventType: function isInteractiveTopLevelEventType(a) {
    a = Bd[a];return void 0 !== a && !0 === a.isInteractive;
  }, extractEvents: function extractEvents(a, b, c, d) {
    var e = Bd[a];if (!e) return null;switch (a) {case "keypress":
        if (0 === rd(c)) return null;case "keydown":case "keyup":
        a = ud;break;case "blur":case "focus":
        a = qd;break;case "click":
        if (2 === c.button) return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":
        a = dd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":
        a = vd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":
        a = wd;break;case Ya:case Za:case $a:
        a = od;break;case ab:
        a = xd;break;case "scroll":
        a = Wc;break;case "wheel":
        a = yd;break;case "copy":case "cut":case "paste":
        a = pd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":
        a = ed;break;default:
        a = A;}b = a.getPooled(e, b, c, d);Ra(b);return b;
  } },
    Ed = Dd.isInteractiveTopLevelEventType,
    Fd = [];function Gd(a) {
  var b = a.targetInst,
      c = b;do {
    if (!c) {
      a.ancestors.push(c);break;
    }var d;for (d = c; d.return;) {
      d = d.return;
    }d = 3 !== d.tag ? null : d.stateNode.containerInfo;if (!d) break;a.ancestors.push(c);c = Ia(d);
  } while (c);for (c = 0; c < a.ancestors.length; c++) {
    b = a.ancestors[c];var e = Rb(a.nativeEvent);d = a.topLevelType;for (var f = a.nativeEvent, g = null, h = 0; h < pa.length; h++) {
      var k = pa[h];k && (k = k.extractEvents(d, b, f, e)) && (g = ya(g, k));
    }Ea(g);
  }
}var Hd = !0;
function G(a, b) {
  if (!b) return null;var c = (Ed(a) ? Id : Jd).bind(null, a);b.addEventListener(a, c, !1);
}function Kd(a, b) {
  if (!b) return null;var c = (Ed(a) ? Id : Jd).bind(null, a);b.addEventListener(a, c, !0);
}function Id(a, b) {
  Lb(Jd, a, b);
}
function Jd(a, b) {
  if (Hd) {
    var c = Rb(b);c = Ia(c);null === c || "number" !== typeof c.tag || 2 === kd(c) || (c = null);if (Fd.length) {
      var d = Fd.pop();d.topLevelType = a;d.nativeEvent = b;d.targetInst = c;a = d;
    } else a = { topLevelType: a, nativeEvent: b, targetInst: c, ancestors: [] };try {
      Ob(Gd, a);
    } finally {
      a.topLevelType = null, a.nativeEvent = null, a.targetInst = null, a.ancestors.length = 0, 10 > Fd.length && Fd.push(a);
    }
  }
}var Ld = {},
    Md = 0,
    Nd = "_reactListenersID" + ("" + Math.random()).slice(2);
function Od(a) {
  Object.prototype.hasOwnProperty.call(a, Nd) || (a[Nd] = Md++, Ld[a[Nd]] = {});return Ld[a[Nd]];
}function Pd(a) {
  a = a || ("undefined" !== typeof document ? document : void 0);if ("undefined" === typeof a) return null;try {
    return a.activeElement || a.body;
  } catch (b) {
    return a.body;
  }
}function Qd(a) {
  for (; a && a.firstChild;) {
    a = a.firstChild;
  }return a;
}
function Rd(a, b) {
  var c = Qd(a);a = 0;for (var d; c;) {
    if (3 === c.nodeType) {
      d = a + c.textContent.length;if (a <= b && d >= b) return { node: c, offset: b - a };a = d;
    }a: {
      for (; c;) {
        if (c.nextSibling) {
          c = c.nextSibling;break a;
        }c = c.parentNode;
      }c = void 0;
    }c = Qd(c);
  }
}function Sd(a, b) {
  return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Sd(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Td() {
  for (var a = window, b = Pd(); b instanceof a.HTMLIFrameElement;) {
    try {
      a = b.contentDocument.defaultView;
    } catch (c) {
      break;
    }b = Pd(a.document);
  }return b;
}function Ud(a) {
  var b = a && a.nodeName && a.nodeName.toLowerCase();return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Vd = Sa && "documentMode" in document && 11 >= document.documentMode,
    Wd = { select: { phasedRegistrationNames: { bubbled: "onSelect", captured: "onSelectCapture" }, dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ") } },
    Xd = null,
    Yd = null,
    Zd = null,
    $d = !1;
function ae(a, b) {
  var c = b.window === b ? b.document : 9 === b.nodeType ? b : b.ownerDocument;if ($d || null == Xd || Xd !== Pd(c)) return null;c = Xd;"selectionStart" in c && Ud(c) ? c = { start: c.selectionStart, end: c.selectionEnd } : (c = (c.ownerDocument && c.ownerDocument.defaultView || window).getSelection(), c = { anchorNode: c.anchorNode, anchorOffset: c.anchorOffset, focusNode: c.focusNode, focusOffset: c.focusOffset });return Zd && jd(Zd, c) ? null : (Zd = c, a = A.getPooled(Wd.select, Yd, a, b), a.type = "select", a.target = Xd, Ra(a), a);
}
var be = { eventTypes: Wd, extractEvents: function extractEvents(a, b, c, d) {
    var e = d.window === d ? d.document : 9 === d.nodeType ? d : d.ownerDocument,
        f;if (!(f = !e)) {
      a: {
        e = Od(e);f = ta.onSelect;for (var g = 0; g < f.length; g++) {
          var h = f[g];if (!e.hasOwnProperty(h) || !e[h]) {
            e = !1;break a;
          }
        }e = !0;
      }f = !e;
    }if (f) return null;e = b ? Ka(b) : window;switch (a) {case "focus":
        if (Qb(e) || "true" === e.contentEditable) Xd = e, Yd = b, Zd = null;break;case "blur":
        Zd = Yd = Xd = null;break;case "mousedown":
        $d = !0;break;case "contextmenu":case "mouseup":case "dragend":
        return $d = !1, ae(c, d);case "selectionchange":
        if (Vd) break;
      case "keydown":case "keyup":
        return ae(c, d);}return null;
  } };Ca.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ua = La;va = Ja;wa = Ka;Ca.injectEventPluginsByName({ SimpleEventPlugin: Dd, EnterLeaveEventPlugin: gd, ChangeEventPlugin: Vc, SelectEventPlugin: be, BeforeInputEventPlugin: Bb });function de(a) {
  var b = "";aa.Children.forEach(a, function (a) {
    null != a && (b += a);
  });return b;
}
function ee(a, b) {
  a = n({ children: void 0 }, b);if (b = de(b.children)) a.children = b;return a;
}function fe(a, b, c, d) {
  a = a.options;if (b) {
    b = {};for (var e = 0; e < c.length; e++) {
      b["$" + c[e]] = !0;
    }for (c = 0; c < a.length; c++) {
      e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    }
  } else {
    c = "" + zc(c);b = null;for (e = 0; e < a.length; e++) {
      if (a[e].value === c) {
        a[e].selected = !0;d && (a[e].defaultSelected = !0);return;
      }null !== b || a[e].disabled || (b = a[e]);
    }null !== b && (b.selected = !0);
  }
}
function ge(a, b) {
  null != b.dangerouslySetInnerHTML ? t("91") : void 0;return n({}, b, { value: void 0, defaultValue: void 0, children: "" + a._wrapperState.initialValue });
}function he(a, b) {
  var c = b.value;null == c && (c = b.defaultValue, b = b.children, null != b && (null != c ? t("92") : void 0, Array.isArray(b) && (1 >= b.length ? void 0 : t("93"), b = b[0]), c = b), null == c && (c = ""));a._wrapperState = { initialValue: zc(c) };
}
function ie(a, b) {
  var c = zc(b.value),
      d = zc(b.defaultValue);null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));null != d && (a.defaultValue = "" + d);
}function je(a) {
  var b = a.textContent;b === a._wrapperState.initialValue && (a.value = b);
}var ke = { html: "http://www.w3.org/1999/xhtml", mathml: "http://www.w3.org/1998/Math/MathML", svg: "http://www.w3.org/2000/svg" };
function le(a) {
  switch (a) {case "svg":
      return "http://www.w3.org/2000/svg";case "math":
      return "http://www.w3.org/1998/Math/MathML";default:
      return "http://www.w3.org/1999/xhtml";}
}function me(a, b) {
  return null == a || "http://www.w3.org/1999/xhtml" === a ? le(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var ne = void 0,
    oe = function (a) {
  return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function (b, c, d, e) {
    MSApp.execUnsafeLocalFunction(function () {
      return a(b, c, d, e);
    });
  } : a;
}(function (a, b) {
  if (a.namespaceURI !== ke.svg || "innerHTML" in a) a.innerHTML = b;else {
    ne = ne || document.createElement("div");ne.innerHTML = "<svg>" + b + "</svg>";for (b = ne.firstChild; a.firstChild;) {
      a.removeChild(a.firstChild);
    }for (; b.firstChild;) {
      a.appendChild(b.firstChild);
    }
  }
});
function pe(a, b) {
  if (b) {
    var c = a.firstChild;if (c && c === a.lastChild && 3 === c.nodeType) {
      c.nodeValue = b;return;
    }
  }a.textContent = b;
}
var qe = { animationIterationCount: !0, borderImageOutset: !0, borderImageSlice: !0, borderImageWidth: !0, boxFlex: !0, boxFlexGroup: !0, boxOrdinalGroup: !0, columnCount: !0, columns: !0, flex: !0, flexGrow: !0, flexPositive: !0, flexShrink: !0, flexNegative: !0, flexOrder: !0, gridArea: !0, gridRow: !0, gridRowEnd: !0, gridRowSpan: !0, gridRowStart: !0, gridColumn: !0, gridColumnEnd: !0, gridColumnSpan: !0, gridColumnStart: !0, fontWeight: !0, lineClamp: !0, lineHeight: !0, opacity: !0, order: !0, orphans: !0, tabSize: !0, widows: !0, zIndex: !0, zoom: !0, fillOpacity: !0,
  floodOpacity: !0, stopOpacity: !0, strokeDasharray: !0, strokeDashoffset: !0, strokeMiterlimit: !0, strokeOpacity: !0, strokeWidth: !0 },
    re = ["Webkit", "ms", "Moz", "O"];Object.keys(qe).forEach(function (a) {
  re.forEach(function (b) {
    b = b + a.charAt(0).toUpperCase() + a.substring(1);qe[b] = qe[a];
  });
});function se(a, b, c) {
  return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qe.hasOwnProperty(a) && qe[a] ? ("" + b).trim() : b + "px";
}
function te(a, b) {
  a = a.style;for (var c in b) {
    if (b.hasOwnProperty(c)) {
      var d = 0 === c.indexOf("--"),
          e = se(c, b[c], d);"float" === c && (c = "cssFloat");d ? a.setProperty(c, e) : a[c] = e;
    }
  }
}var ue = n({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
function ve(a, b) {
  b && (ue[a] && (null != b.children || null != b.dangerouslySetInnerHTML ? t("137", a, "") : void 0), null != b.dangerouslySetInnerHTML && (null != b.children ? t("60") : void 0, "object" === _typeof(b.dangerouslySetInnerHTML) && "__html" in b.dangerouslySetInnerHTML ? void 0 : t("61")), null != b.style && "object" !== _typeof(b.style) ? t("62", "") : void 0);
}
function we(a, b) {
  if (-1 === a.indexOf("-")) return "string" === typeof b.is;switch (a) {case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":
      return !1;default:
      return !0;}
}
function xe(a, b) {
  a = 9 === a.nodeType || 11 === a.nodeType ? a : a.ownerDocument;var c = Od(a);b = ta[b];for (var d = 0; d < b.length; d++) {
    var e = b[d];if (!c.hasOwnProperty(e) || !c[e]) {
      switch (e) {case "scroll":
          Kd("scroll", a);break;case "focus":case "blur":
          Kd("focus", a);Kd("blur", a);c.blur = !0;c.focus = !0;break;case "cancel":case "close":
          Sb(e) && Kd(e, a);break;case "invalid":case "submit":case "reset":
          break;default:
          -1 === bb.indexOf(e) && G(e, a);}c[e] = !0;
    }
  }
}function ye() {}var ze = null,
    Ae = null;
function Be(a, b) {
  switch (a) {case "button":case "input":case "select":case "textarea":
      return !!b.autoFocus;}return !1;
}function Ce(a, b) {
  return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === _typeof(b.dangerouslySetInnerHTML) && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}var De = "function" === typeof setTimeout ? setTimeout : void 0,
    Ee = "function" === typeof clearTimeout ? clearTimeout : void 0;
function Fe(a) {
  for (a = a.nextSibling; a && 1 !== a.nodeType && 3 !== a.nodeType;) {
    a = a.nextSibling;
  }return a;
}function Ge(a) {
  for (a = a.firstChild; a && 1 !== a.nodeType && 3 !== a.nodeType;) {
    a = a.nextSibling;
  }return a;
}new Set();var He = [],
    Ie = -1;function H(a) {
  0 > Ie || (a.current = He[Ie], He[Ie] = null, Ie--);
}function I(a, b) {
  Ie++;He[Ie] = a.current;a.current = b;
}var Je = {},
    J = { current: Je },
    K = { current: !1 },
    Ke = Je;
function Le(a, b) {
  var c = a.type.contextTypes;if (!c) return Je;var d = a.stateNode;if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;var e = {},
      f;for (f in c) {
    e[f] = b[f];
  }d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);return e;
}function L(a) {
  a = a.childContextTypes;return null !== a && void 0 !== a;
}function Me(a) {
  H(K, a);H(J, a);
}function Ne(a) {
  H(K, a);H(J, a);
}
function Oe(a, b, c) {
  J.current !== Je ? t("168") : void 0;I(J, b, a);I(K, c, a);
}function Pe(a, b, c) {
  var d = a.stateNode;a = b.childContextTypes;if ("function" !== typeof d.getChildContext) return c;d = d.getChildContext();for (var e in d) {
    e in a ? void 0 : t("108", mc(b) || "Unknown", e);
  }return n({}, c, d);
}function Qe(a) {
  var b = a.stateNode;b = b && b.__reactInternalMemoizedMergedChildContext || Je;Ke = J.current;I(J, b, a);I(K, K.current, a);return !0;
}
function Re(a, b, c) {
  var d = a.stateNode;d ? void 0 : t("169");c ? (b = Pe(a, b, Ke), d.__reactInternalMemoizedMergedChildContext = b, H(K, a), H(J, a), I(J, b, a)) : H(K, a);I(K, c, a);
}var Se = null,
    Te = null;function Ue(a) {
  return function (b) {
    try {
      return a(b);
    } catch (c) {}
  };
}
function Ve(a) {
  if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;if (b.isDisabled || !b.supportsFiber) return !0;try {
    var c = b.inject(a);Se = Ue(function (a) {
      return b.onCommitFiberRoot(c, a);
    });Te = Ue(function (a) {
      return b.onCommitFiberUnmount(c, a);
    });
  } catch (d) {}return !0;
}
function We(a, b, c, d) {
  this.tag = a;this.key = c;this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;this.index = 0;this.ref = null;this.pendingProps = b;this.firstContextDependency = this.memoizedState = this.updateQueue = this.memoizedProps = null;this.mode = d;this.effectTag = 0;this.lastEffect = this.firstEffect = this.nextEffect = null;this.childExpirationTime = this.expirationTime = 0;this.alternate = null;
}function M(a, b, c, d) {
  return new We(a, b, c, d);
}
function Xe(a) {
  a = a.prototype;return !(!a || !a.isReactComponent);
}function Ye(a) {
  if ("function" === typeof a) return Xe(a) ? 1 : 0;if (void 0 !== a && null !== a) {
    a = a.$$typeof;if (a === gc) return 11;if (a === ic) return 14;
  }return 2;
}
function Ze(a, b) {
  var c = a.alternate;null === c ? (c = M(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.effectTag = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);c.childExpirationTime = a.childExpirationTime;c.expirationTime = a.expirationTime;c.child = a.child;c.memoizedProps = a.memoizedProps;c.memoizedState = a.memoizedState;c.updateQueue = a.updateQueue;c.firstContextDependency = a.firstContextDependency;c.sibling = a.sibling;
  c.index = a.index;c.ref = a.ref;return c;
}
function $e(a, b, c, d, e, f) {
  var g = 2;d = a;if ("function" === typeof a) Xe(a) && (g = 1);else if ("string" === typeof a) g = 5;else a: switch (a) {case ac:
      return af(c.children, e, f, b);case fc:
      return bf(c, e | 3, f, b);case bc:
      return bf(c, e | 2, f, b);case cc:
      return a = M(12, c, b, e | 4), a.elementType = cc, a.type = cc, a.expirationTime = f, a;case hc:
      return a = M(13, c, b, e), a.elementType = hc, a.type = hc, a.expirationTime = f, a;default:
      if ("object" === (typeof a === "undefined" ? "undefined" : _typeof(a)) && null !== a) switch (a.$$typeof) {case dc:
          g = 10;break a;case ec:
          g = 9;break a;case gc:
          g = 11;break a;case ic:
          g = 14;break a;case jc:
          g = 16;d = null;break a;}t("130", null == a ? a : typeof a === "undefined" ? "undefined" : _typeof(a), "");}b = M(g, c, b, e);b.elementType = a;b.type = d;b.expirationTime = f;return b;
}function af(a, b, c, d) {
  a = M(7, a, d, b);a.expirationTime = c;return a;
}function bf(a, b, c, d) {
  a = M(8, a, d, b);b = 0 === (b & 1) ? bc : fc;a.elementType = b;a.type = b;a.expirationTime = c;return a;
}function cf(a, b, c) {
  a = M(6, a, null, b);a.expirationTime = c;return a;
}
function df(a, b, c) {
  b = M(4, null !== a.children ? a.children : [], a.key, b);b.expirationTime = c;b.stateNode = { containerInfo: a.containerInfo, pendingChildren: null, implementation: a.implementation };return b;
}function ef(a, b) {
  a.didError = !1;var c = a.earliestPendingTime;0 === c ? a.earliestPendingTime = a.latestPendingTime = b : c < b ? a.earliestPendingTime = b : a.latestPendingTime > b && (a.latestPendingTime = b);ff(b, a);
}
function gf(a, b) {
  a.didError = !1;var c = a.latestPingedTime;0 !== c && c >= b && (a.latestPingedTime = 0);c = a.earliestPendingTime;var d = a.latestPendingTime;c === b ? a.earliestPendingTime = d === b ? a.latestPendingTime = 0 : d : d === b && (a.latestPendingTime = c);c = a.earliestSuspendedTime;d = a.latestSuspendedTime;0 === c ? a.earliestSuspendedTime = a.latestSuspendedTime = b : c < b ? a.earliestSuspendedTime = b : d > b && (a.latestSuspendedTime = b);ff(b, a);
}
function hf(a, b) {
  var c = a.earliestPendingTime;a = a.earliestSuspendedTime;c > b && (b = c);a > b && (b = a);return b;
}function ff(a, b) {
  var c = b.earliestSuspendedTime,
      d = b.latestSuspendedTime,
      e = b.earliestPendingTime,
      f = b.latestPingedTime;e = 0 !== e ? e : f;0 === e && (0 === a || d < a) && (e = d);a = e;0 !== a && c > a && (a = c);b.nextExpirationTimeToWorkOn = e;b.expirationTime = a;
}var jf = !1;
function kf(a) {
  return { baseState: a, firstUpdate: null, lastUpdate: null, firstCapturedUpdate: null, lastCapturedUpdate: null, firstEffect: null, lastEffect: null, firstCapturedEffect: null, lastCapturedEffect: null };
}function lf(a) {
  return { baseState: a.baseState, firstUpdate: a.firstUpdate, lastUpdate: a.lastUpdate, firstCapturedUpdate: null, lastCapturedUpdate: null, firstEffect: null, lastEffect: null, firstCapturedEffect: null, lastCapturedEffect: null };
}
function mf(a) {
  return { expirationTime: a, tag: 0, payload: null, callback: null, next: null, nextEffect: null };
}function nf(a, b) {
  null === a.lastUpdate ? a.firstUpdate = a.lastUpdate = b : (a.lastUpdate.next = b, a.lastUpdate = b);
}
function of(a, b) {
  var c = a.alternate;if (null === c) {
    var d = a.updateQueue;var e = null;null === d && (d = a.updateQueue = kf(a.memoizedState));
  } else d = a.updateQueue, e = c.updateQueue, null === d ? null === e ? (d = a.updateQueue = kf(a.memoizedState), e = c.updateQueue = kf(c.memoizedState)) : d = a.updateQueue = lf(e) : null === e && (e = c.updateQueue = lf(d));null === e || d === e ? nf(d, b) : null === d.lastUpdate || null === e.lastUpdate ? (nf(d, b), nf(e, b)) : (nf(d, b), e.lastUpdate = b);
}
function pf(a, b) {
  var c = a.updateQueue;c = null === c ? a.updateQueue = kf(a.memoizedState) : qf(a, c);null === c.lastCapturedUpdate ? c.firstCapturedUpdate = c.lastCapturedUpdate = b : (c.lastCapturedUpdate.next = b, c.lastCapturedUpdate = b);
}function qf(a, b) {
  var c = a.alternate;null !== c && b === c.updateQueue && (b = a.updateQueue = lf(b));return b;
}
function rf(a, b, c, d, e, f) {
  switch (c.tag) {case 1:
      return a = c.payload, "function" === typeof a ? a.call(f, d, e) : a;case 3:
      a.effectTag = a.effectTag & -2049 | 64;case 0:
      a = c.payload;e = "function" === typeof a ? a.call(f, d, e) : a;if (null === e || void 0 === e) break;return n({}, d, e);case 2:
      jf = !0;}return d;
}
function sf(a, b, c, d, e) {
  jf = !1;b = qf(a, b);for (var f = b.baseState, g = null, h = 0, k = b.firstUpdate, l = f; null !== k;) {
    var m = k.expirationTime;m < e ? (null === g && (g = k, f = l), h < m && (h = m)) : (l = rf(a, b, k, l, c, d), null !== k.callback && (a.effectTag |= 32, k.nextEffect = null, null === b.lastEffect ? b.firstEffect = b.lastEffect = k : (b.lastEffect.nextEffect = k, b.lastEffect = k)));k = k.next;
  }m = null;for (k = b.firstCapturedUpdate; null !== k;) {
    var q = k.expirationTime;q < e ? (null === m && (m = k, null === g && (f = l)), h < q && (h = q)) : (l = rf(a, b, k, l, c, d), null !== k.callback && (a.effectTag |= 32, k.nextEffect = null, null === b.lastCapturedEffect ? b.firstCapturedEffect = b.lastCapturedEffect = k : (b.lastCapturedEffect.nextEffect = k, b.lastCapturedEffect = k)));k = k.next;
  }null === g && (b.lastUpdate = null);null === m ? b.lastCapturedUpdate = null : a.effectTag |= 32;null === g && null === m && (f = l);b.baseState = f;b.firstUpdate = g;b.firstCapturedUpdate = m;a.expirationTime = h;a.memoizedState = l;
}
function tf(a, b, c) {
  null !== b.firstCapturedUpdate && (null !== b.lastUpdate && (b.lastUpdate.next = b.firstCapturedUpdate, b.lastUpdate = b.lastCapturedUpdate), b.firstCapturedUpdate = b.lastCapturedUpdate = null);uf(b.firstEffect, c);b.firstEffect = b.lastEffect = null;uf(b.firstCapturedEffect, c);b.firstCapturedEffect = b.lastCapturedEffect = null;
}function uf(a, b) {
  for (; null !== a;) {
    var c = a.callback;if (null !== c) {
      a.callback = null;var d = b;"function" !== typeof c ? t("191", c) : void 0;c.call(d);
    }a = a.nextEffect;
  }
}
function vf(a, b) {
  return { value: a, source: b, stack: nc(b) };
}var wf = { current: null },
    xf = null,
    yf = null,
    zf = null;function Af(a, b) {
  var c = a.type._context;I(wf, c._currentValue, a);c._currentValue = b;
}function Bf(a) {
  var b = wf.current;H(wf, a);a.type._context._currentValue = b;
}function Cf(a) {
  xf = a;zf = yf = null;a.firstContextDependency = null;
}
function Df(a, b) {
  if (zf !== a && !1 !== b && 0 !== b) {
    if ("number" !== typeof b || 1073741823 === b) zf = a, b = 1073741823;b = { context: a, observedBits: b, next: null };null === yf ? (null === xf ? t("293") : void 0, xf.firstContextDependency = yf = b) : yf = yf.next = b;
  }return a._currentValue;
}var Ef = {},
    N = { current: Ef },
    Ff = { current: Ef },
    Gf = { current: Ef };function Hf(a) {
  a === Ef ? t("174") : void 0;return a;
}
function If(a, b) {
  I(Gf, b, a);I(Ff, a, a);I(N, Ef, a);var c = b.nodeType;switch (c) {case 9:case 11:
      b = (b = b.documentElement) ? b.namespaceURI : me(null, "");break;default:
      c = 8 === c ? b.parentNode : b, b = c.namespaceURI || null, c = c.tagName, b = me(b, c);}H(N, a);I(N, b, a);
}function Jf(a) {
  H(N, a);H(Ff, a);H(Gf, a);
}function Kf(a) {
  Hf(Gf.current);var b = Hf(N.current);var c = me(b, a.type);b !== c && (I(Ff, a, a), I(N, c, a));
}function Lf(a) {
  Ff.current === a && (H(N, a), H(Ff, a));
}
function O(a, b) {
  if (a && a.defaultProps) {
    b = n({}, b);a = a.defaultProps;for (var c in a) {
      void 0 === b[c] && (b[c] = a[c]);
    }
  }return b;
}function Mf(a) {
  var b = a._result;switch (a._status) {case 1:
      return b;case 2:
      throw b;case 0:
      throw b;default:
      throw a._status = 0, b = a._ctor, b = b(), b.then(function (b) {
        0 === a._status && (b = b.default, a._status = 1, a._result = b);
      }, function (b) {
        0 === a._status && (a._status = 2, a._result = b);
      }), a._result = b, b;}
}var Nf = Xb.ReactCurrentOwner,
    Of = new aa.Component().refs;
function Pf(a, b, c, d) {
  b = a.memoizedState;c = c(d, b);c = null === c || void 0 === c ? b : n({}, b, c);a.memoizedState = c;d = a.updateQueue;null !== d && 0 === a.expirationTime && (d.baseState = c);
}
var Uf = { isMounted: function isMounted(a) {
    return (a = a._reactInternalFiber) ? 2 === kd(a) : !1;
  }, enqueueSetState: function enqueueSetState(a, b, c) {
    a = a._reactInternalFiber;var d = Qf();d = Rf(d, a);var e = mf(d);e.payload = b;void 0 !== c && null !== c && (e.callback = c);Sf();of(a, e);Tf(a, d);
  }, enqueueReplaceState: function enqueueReplaceState(a, b, c) {
    a = a._reactInternalFiber;var d = Qf();d = Rf(d, a);var e = mf(d);e.tag = 1;e.payload = b;void 0 !== c && null !== c && (e.callback = c);Sf();of(a, e);Tf(a, d);
  }, enqueueForceUpdate: function enqueueForceUpdate(a, b) {
    a = a._reactInternalFiber;var c = Qf();c = Rf(c, a);var d = mf(c);d.tag = 2;void 0 !== b && null !== b && (d.callback = b);Sf();of(a, d);Tf(a, c);
  } };function Vf(a, b, c, d, e, f, g) {
  a = a.stateNode;return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !jd(c, d) || !jd(e, f) : !0;
}
function Wf(a, b, c) {
  var d = !1,
      e = Je;var f = b.contextType;"object" === (typeof f === "undefined" ? "undefined" : _typeof(f)) && null !== f ? f = Nf.currentDispatcher.readContext(f) : (e = L(b) ? Ke : J.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Le(a, e) : Je);b = new b(c, f);a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;b.updater = Uf;a.stateNode = b;b._reactInternalFiber = a;d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);return b;
}
function Xf(a, b, c, d) {
  a = b.state;"function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);"function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);b.state !== a && Uf.enqueueReplaceState(b, b.state, null);
}
function Yf(a, b, c, d) {
  var e = a.stateNode;e.props = c;e.state = a.memoizedState;e.refs = Of;var f = b.contextType;"object" === (typeof f === "undefined" ? "undefined" : _typeof(f)) && null !== f ? e.context = Nf.currentDispatcher.readContext(f) : (f = L(b) ? Ke : J.current, e.context = Le(a, f));f = a.updateQueue;null !== f && (sf(a, f, c, e, d), e.state = a.memoizedState);f = b.getDerivedStateFromProps;"function" === typeof f && (Pf(a, b, f, c), e.state = a.memoizedState);"function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Uf.enqueueReplaceState(e, e.state, null), f = a.updateQueue, null !== f && (sf(a, f, c, e, d), e.state = a.memoizedState));"function" === typeof e.componentDidMount && (a.effectTag |= 4);
}var Zf = Array.isArray;
function $f(a, b, c) {
  a = c.ref;if (null !== a && "function" !== typeof a && "object" !== (typeof a === "undefined" ? "undefined" : _typeof(a))) {
    if (c._owner) {
      c = c._owner;var d = void 0;c && (1 !== c.tag ? t("289") : void 0, d = c.stateNode);d ? void 0 : t("147", a);var e = "" + a;if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;b = function b(a) {
        var b = d.refs;b === Of && (b = d.refs = {});null === a ? delete b[e] : b[e] = a;
      };b._stringRef = e;return b;
    }"string" !== typeof a ? t("284") : void 0;c._owner ? void 0 : t("290", a);
  }return a;
}
function ag(a, b) {
  "textarea" !== a.type && t("31", "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, "");
}
function bg(a) {
  function b(b, c) {
    if (a) {
      var d = b.lastEffect;null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;c.nextEffect = null;c.effectTag = 8;
    }
  }function c(c, d) {
    if (!a) return null;for (; null !== d;) {
      b(c, d), d = d.sibling;
    }return null;
  }function d(a, b) {
    for (a = new Map(); null !== b;) {
      null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
    }return a;
  }function e(a, b, c) {
    a = Ze(a, b, c);a.index = 0;a.sibling = null;return a;
  }function f(b, c, d) {
    b.index = d;if (!a) return c;d = b.alternate;if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;b.effectTag = 2;return c;
  }function g(b) {
    a && null === b.alternate && (b.effectTag = 2);return b;
  }function h(a, b, c, d) {
    if (null === b || 6 !== b.tag) return b = cf(c, a.mode, d), b.return = a, b;b = e(b, c, d);b.return = a;return b;
  }function k(a, b, c, d) {
    if (null !== b && b.elementType === c.type) return d = e(b, c.props, d), d.ref = $f(a, b, c), d.return = a, d;d = $e(c.type, c.key, c.props, null, a.mode, d);d.ref = $f(a, b, c);d.return = a;return d;
  }function l(a, b, c, d) {
    if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = df(c, a.mode, d), b.return = a, b;b = e(b, c.children || [], d);b.return = a;return b;
  }function m(a, b, c, d, g) {
    if (null === b || 7 !== b.tag) return b = af(c, a.mode, d, g), b.return = a, b;b = e(b, c, d);b.return = a;return b;
  }function q(a, b, c) {
    if ("string" === typeof b || "number" === typeof b) return b = cf("" + b, a.mode, c), b.return = a, b;if ("object" === (typeof b === "undefined" ? "undefined" : _typeof(b)) && null !== b) {
      switch (b.$$typeof) {case Zb:
          return c = $e(b.type, b.key, b.props, null, a.mode, c), c.ref = $f(a, null, b), c.return = a, c;case $b:
          return b = df(b, a.mode, c), b.return = a, b;}if (Zf(b) || lc(b)) return b = af(b, a.mode, c, null), b.return = a, b;ag(a, b);
    }return null;
  }function x(a, b, c, d) {
    var e = null !== b ? b.key : null;if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);if ("object" === (typeof c === "undefined" ? "undefined" : _typeof(c)) && null !== c) {
      switch (c.$$typeof) {case Zb:
          return c.key === e ? c.type === ac ? m(a, b, c.props.children, d, e) : k(a, b, c, d) : null;case $b:
          return c.key === e ? l(a, b, c, d) : null;}if (Zf(c) || lc(c)) return null !== e ? null : m(a, b, c, d, null);ag(a, c);
    }return null;
  }function z(a, b, c, d, e) {
    if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);if ("object" === (typeof d === "undefined" ? "undefined" : _typeof(d)) && null !== d) {
      switch (d.$$typeof) {case Zb:
          return a = a.get(null === d.key ? c : d.key) || null, d.type === ac ? m(b, a, d.props.children, e, d.key) : k(b, a, d, e);case $b:
          return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);}if (Zf(d) || lc(d)) return a = a.get(c) || null, m(b, a, d, e, null);ag(b, d);
    }return null;
  }function B(e, g, h, k) {
    for (var l = null, r = null, m = g, u = g = 0, p = null; null !== m && u < h.length; u++) {
      m.index > u ? (p = m, m = null) : p = m.sibling;var v = x(e, m, h[u], k);if (null === v) {
        null === m && (m = p);break;
      }a && m && null === v.alternate && b(e, m);g = f(v, g, u);null === r ? l = v : r.sibling = v;r = v;m = p;
    }if (u === h.length) return c(e, m), l;if (null === m) {
      for (; u < h.length; u++) {
        if (m = q(e, h[u], k)) g = f(m, g, u), null === r ? l = m : r.sibling = m, r = m;
      }return l;
    }for (m = d(e, m); u < h.length; u++) {
      if (p = z(m, e, u, h[u], k)) a && null !== p.alternate && m.delete(null === p.key ? u : p.key), g = f(p, g, u), null === r ? l = p : r.sibling = p, r = p;
    }a && m.forEach(function (a) {
      return b(e, a);
    });return l;
  }function Q(e, g, h, k) {
    var l = lc(h);"function" !== typeof l ? t("150") : void 0;h = l.call(h);null == h ? t("151") : void 0;
    for (var m = l = null, r = g, u = g = 0, p = null, v = h.next(); null !== r && !v.done; u++, v = h.next()) {
      r.index > u ? (p = r, r = null) : p = r.sibling;var y = x(e, r, v.value, k);if (null === y) {
        r || (r = p);break;
      }a && r && null === y.alternate && b(e, r);g = f(y, g, u);null === m ? l = y : m.sibling = y;m = y;r = p;
    }if (v.done) return c(e, r), l;if (null === r) {
      for (; !v.done; u++, v = h.next()) {
        v = q(e, v.value, k), null !== v && (g = f(v, g, u), null === m ? l = v : m.sibling = v, m = v);
      }return l;
    }for (r = d(e, r); !v.done; u++, v = h.next()) {
      v = z(r, e, u, v.value, k), null !== v && (a && null !== v.alternate && r.delete(null === v.key ? u : v.key), g = f(v, g, u), null === m ? l = v : m.sibling = v, m = v);
    }a && r.forEach(function (a) {
      return b(e, a);
    });return l;
  }return function (a, d, f, h) {
    var k = "object" === (typeof f === "undefined" ? "undefined" : _typeof(f)) && null !== f && f.type === ac && null === f.key;k && (f = f.props.children);var l = "object" === (typeof f === "undefined" ? "undefined" : _typeof(f)) && null !== f;if (l) switch (f.$$typeof) {case Zb:
        a: {
          l = f.key;for (k = d; null !== k;) {
            if (k.key === l) {
              if (7 === k.tag ? f.type === ac : k.elementType === f.type) {
                c(a, k.sibling);d = e(k, f.type === ac ? f.props.children : f.props, h);d.ref = $f(a, k, f);d.return = a;a = d;break a;
              } else {
                c(a, k);break;
              }
            } else b(a, k);k = k.sibling;
          }f.type === ac ? (d = af(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $e(f.type, f.key, f.props, null, a.mode, h), h.ref = $f(a, d, f), h.return = a, a = h);
        }return g(a);case $b:
        a: {
          for (k = f.key; null !== d;) {
            if (d.key === k) {
              if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                c(a, d.sibling);d = e(d, f.children || [], h);d.return = a;a = d;break a;
              } else {
                c(a, d);break;
              }
            } else b(a, d);d = d.sibling;
          }d = df(f, a.mode, h);d.return = a;a = d;
        }return g(a);}if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f, h), d.return = a, a = d) : (c(a, d), d = cf(f, a.mode, h), d.return = a, a = d), g(a);if (Zf(f)) return B(a, d, f, h);if (lc(f)) return Q(a, d, f, h);l && ag(a, f);if ("undefined" === typeof f && !k) switch (a.tag) {case 1:case 0:
        h = a.type, t("152", h.displayName || h.name || "Component");}return c(a, d);
  };
}var cg = bg(!0),
    dg = bg(!1),
    eg = null,
    fg = null,
    gg = !1;
function hg(a, b) {
  var c = M(5, null, null, 0);c.elementType = "DELETED";c.type = "DELETED";c.stateNode = b;c.return = a;c.effectTag = 8;null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}function ig(a, b) {
  switch (a.tag) {case 5:
      var c = a.type;b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;return null !== b ? (a.stateNode = b, !0) : !1;case 6:
      return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;default:
      return !1;}
}
function jg(a) {
  if (gg) {
    var b = fg;if (b) {
      var c = b;if (!ig(a, b)) {
        b = Fe(c);if (!b || !ig(a, b)) {
          a.effectTag |= 2;gg = !1;eg = a;return;
        }hg(eg, c);
      }eg = a;fg = Ge(b);
    } else a.effectTag |= 2, gg = !1, eg = a;
  }
}function kg(a) {
  for (a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag;) {
    a = a.return;
  }eg = a;
}function lg(a) {
  if (a !== eg) return !1;if (!gg) return kg(a), gg = !0, !1;var b = a.type;if (5 !== a.tag || "head" !== b && "body" !== b && !Ce(b, a.memoizedProps)) for (b = fg; b;) {
    hg(a, b), b = Fe(b);
  }kg(a);fg = eg ? Fe(a.stateNode) : null;return !0;
}function mg() {
  fg = eg = null;gg = !1;
}var ng = Xb.ReactCurrentOwner;
function P(a, b, c, d) {
  b.child = null === a ? dg(b, null, c, d) : cg(b, a.child, c, d);
}function og(a, b, c, d, e) {
  c = c.render;var f = b.ref;Cf(b, e);d = c(d, f);b.effectTag |= 1;P(a, b, d, e);return b.child;
}
function pg(a, b, c, d, e, f) {
  if (null === a) {
    var g = c.type;if ("function" === typeof g && !Xe(g) && void 0 === g.defaultProps && null === c.compare) return b.tag = 15, b.type = g, qg(a, b, g, d, e, f);a = $e(c.type, null, d, null, b.mode, f);a.ref = b.ref;a.return = b;return b.child = a;
  }g = a.child;if (e < f && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : jd, c(e, d) && a.ref === b.ref)) return rg(a, b, f);b.effectTag |= 1;a = Ze(g, d, f);a.ref = b.ref;a.return = b;return b.child = a;
}
function qg(a, b, c, d, e, f) {
  return null !== a && e < f && jd(a.memoizedProps, d) && a.ref === b.ref ? rg(a, b, f) : sg(a, b, c, d, f);
}function tg(a, b) {
  var c = b.ref;if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
}function sg(a, b, c, d, e) {
  var f = L(c) ? Ke : J.current;f = Le(b, f);Cf(b, e);c = c(d, f);b.effectTag |= 1;P(a, b, c, e);return b.child;
}
function ug(a, b, c, d, e) {
  if (L(c)) {
    var f = !0;Qe(b);
  } else f = !1;Cf(b, e);if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), Wf(b, c, d, e), Yf(b, c, d, e), d = !0;else if (null === a) {
    var g = b.stateNode,
        h = b.memoizedProps;g.props = h;var k = g.context,
        l = c.contextType;"object" === (typeof l === "undefined" ? "undefined" : _typeof(l)) && null !== l ? l = Nf.currentDispatcher.readContext(l) : (l = L(c) ? Ke : J.current, l = Le(b, l));var m = c.getDerivedStateFromProps,
        q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Xf(b, g, d, l);jf = !1;var x = b.memoizedState;k = g.state = x;var z = b.updateQueue;null !== z && (sf(b, z, d, g, e), k = b.memoizedState);h !== d || x !== k || K.current || jf ? ("function" === typeof m && (Pf(b, c, m, d), k = b.memoizedState), (h = jf || Vf(b, c, h, d, x, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), d = !1);
  } else g = b.stateNode, h = b.memoizedProps, g.props = b.type === b.elementType ? h : O(b.type, h), k = g.context, l = c.contextType, "object" === (typeof l === "undefined" ? "undefined" : _typeof(l)) && null !== l ? l = Nf.currentDispatcher.readContext(l) : (l = L(c) ? Ke : J.current, l = Le(b, l)), m = c.getDerivedStateFromProps, (q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Xf(b, g, d, l), jf = !1, k = b.memoizedState, x = g.state = k, z = b.updateQueue, null !== z && (sf(b, z, d, g, e), x = b.memoizedState), h !== d || k !== x || K.current || jf ? ("function" === typeof m && (Pf(b, c, m, d), x = b.memoizedState), (m = jf || Vf(b, c, h, d, k, x, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, l), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, l)), "function" === typeof g.componentDidUpdate && (b.effectTag |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = l, d = m) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), d = !1);return vg(a, b, c, d, f, e);
}
function vg(a, b, c, d, e, f) {
  tg(a, b);var g = 0 !== (b.effectTag & 64);if (!d && !g) return e && Re(b, c, !1), rg(a, b, f);d = b.stateNode;ng.current = b;var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();b.effectTag |= 1;null !== a && g ? (b.child = cg(b, a.child, null, f), b.child = cg(b, null, h, f)) : P(a, b, h, f);b.memoizedState = d.state;e && Re(b, c, !0);return b.child;
}function wg(a) {
  var b = a.stateNode;b.pendingContext ? Oe(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Oe(a, b.context, !1);If(a, b.containerInfo);
}
function xg(a, b, c) {
  var d = b.mode,
      e = b.pendingProps,
      f = b.memoizedState;if (0 === (b.effectTag & 64)) {
    f = null;var g = !1;
  } else f = { timedOutAt: null !== f ? f.timedOutAt : 0 }, g = !0, b.effectTag &= -65;null === a ? g ? (g = e.fallback, e = af(null, d, 0, null), 0 === (b.mode & 1) && (e.child = null !== b.memoizedState ? b.child.child : b.child), d = af(g, d, c, null), e.sibling = d, c = e, c.return = d.return = b) : c = d = dg(b, null, e.children, c) : null !== a.memoizedState ? (d = a.child, a = d.sibling, g ? (c = e.fallback, e = Ze(d, d.pendingProps, 0), 0 === (b.mode & 1) && (g = null !== b.memoizedState ? b.child.child : b.child, g !== d.child && (e.child = g)), d = e.sibling = Ze(a, c, a.expirationTime), c = e, e.childExpirationTime = 0, c.return = d.return = b) : c = d = cg(b, d.child, e.children, c)) : (a = a.child, g ? (g = e.fallback, e = af(null, d, 0, null), e.child = a, 0 === (b.mode & 1) && (e.child = null !== b.memoizedState ? b.child.child : b.child), d = e.sibling = af(g, d, c, null), d.effectTag |= 2, c = e, e.childExpirationTime = 0, c.return = d.return = b) : d = c = cg(b, a, e.children, c));b.memoizedState = f;b.child = c;return d;
}
function rg(a, b, c) {
  null !== a && (b.firstContextDependency = a.firstContextDependency);if (b.childExpirationTime < c) return null;null !== a && b.child !== a.child ? t("153") : void 0;if (null !== b.child) {
    a = b.child;c = Ze(a, a.pendingProps, a.expirationTime);b.child = c;for (c.return = b; null !== a.sibling;) {
      a = a.sibling, c = c.sibling = Ze(a, a.pendingProps, a.expirationTime), c.return = b;
    }c.sibling = null;
  }return b.child;
}
function yg(a, b, c) {
  var d = b.expirationTime;if (null !== a && a.memoizedProps === b.pendingProps && !K.current && d < c) {
    switch (b.tag) {case 3:
        wg(b);mg();break;case 5:
        Kf(b);break;case 1:
        L(b.type) && Qe(b);break;case 4:
        If(b, b.stateNode.containerInfo);break;case 10:
        Af(b, b.memoizedProps.value);break;case 13:
        if (null !== b.memoizedState) {
          d = b.child.childExpirationTime;if (0 !== d && d >= c) return xg(a, b, c);b = rg(a, b, c);return null !== b ? b.sibling : null;
        }}return rg(a, b, c);
  }b.expirationTime = 0;switch (b.tag) {case 2:
      d = b.elementType;null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);a = b.pendingProps;var e = Le(b, J.current);Cf(b, c);e = d(a, e);b.effectTag |= 1;if ("object" === (typeof e === "undefined" ? "undefined" : _typeof(e)) && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
        b.tag = 1;if (L(d)) {
          var f = !0;Qe(b);
        } else f = !1;b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;var g = d.getDerivedStateFromProps;"function" === typeof g && Pf(b, d, g, a);e.updater = Uf;b.stateNode = e;e._reactInternalFiber = b;Yf(b, d, a, c);b = vg(null, b, d, !0, f, c);
      } else b.tag = 0, P(null, b, e, c), b = b.child;
      return b;case 16:
      e = b.elementType;null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);f = b.pendingProps;a = Mf(e);b.type = a;e = b.tag = Ye(a);f = O(a, f);g = void 0;switch (e) {case 0:
          g = sg(null, b, a, f, c);break;case 1:
          g = ug(null, b, a, f, c);break;case 11:
          g = og(null, b, a, f, c);break;case 14:
          g = pg(null, b, a, O(a.type, f), d, c);break;default:
          t("283", a);}return g;case 0:
      return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : O(d, e), sg(a, b, d, e, c);case 1:
      return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : O(d, e), ug(a, b, d, e, c);case 3:
      wg(b);d = b.updateQueue;null === d ? t("282") : void 0;e = b.memoizedState;e = null !== e ? e.element : null;sf(b, d, b.pendingProps, null, c);d = b.memoizedState.element;if (d === e) mg(), b = rg(a, b, c);else {
        e = b.stateNode;if (e = (null === a || null === a.child) && e.hydrate) fg = Ge(b.stateNode.containerInfo), eg = b, e = gg = !0;e ? (b.effectTag |= 2, b.child = dg(b, null, d, c)) : (P(a, b, d, c), mg());b = b.child;
      }return b;case 5:
      return Kf(b), null === a && jg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Ce(d, e) ? g = null : null !== f && Ce(d, f) && (b.effectTag |= 16), tg(a, b), 1 !== c && b.mode & 1 && e.hidden ? (b.expirationTime = 1, b = null) : (P(a, b, g, c), b = b.child), b;case 6:
      return null === a && jg(b), null;case 13:
      return xg(a, b, c);case 4:
      return If(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = cg(b, null, d, c) : P(a, b, d, c), b.child;case 11:
      return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : O(d, e), og(a, b, d, e, c);case 7:
      return P(a, b, b.pendingProps, c), b.child;case 8:
      return P(a, b, b.pendingProps.children, c), b.child;case 12:
      return P(a, b, b.pendingProps.children, c), b.child;case 10:
      a: {
        d = b.type._context;e = b.pendingProps;g = b.memoizedProps;f = e.value;Af(b, f);if (null !== g) {
          var h = g.value;f = h === f && (0 !== h || 1 / h === 1 / f) || h !== h && f !== f ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0;if (0 === f) {
            if (g.children === e.children && !K.current) {
              b = rg(a, b, c);break a;
            }
          } else for (g = b.child, null !== g && (g.return = b); null !== g;) {
            h = g.firstContextDependency;if (null !== h) {
              do {
                if (h.context === d && 0 !== (h.observedBits & f)) {
                  if (1 === g.tag) {
                    var k = mf(c);k.tag = 2;of(g, k);
                  }g.expirationTime < c && (g.expirationTime = c);k = g.alternate;null !== k && k.expirationTime < c && (k.expirationTime = c);for (var l = g.return; null !== l;) {
                    k = l.alternate;if (l.childExpirationTime < c) l.childExpirationTime = c, null !== k && k.childExpirationTime < c && (k.childExpirationTime = c);else if (null !== k && k.childExpirationTime < c) k.childExpirationTime = c;else break;l = l.return;
                  }
                }k = g.child;h = h.next;
              } while (null !== h);
            } else k = 10 === g.tag ? g.type === b.type ? null : g.child : g.child;if (null !== k) k.return = g;else for (k = g; null !== k;) {
              if (k === b) {
                k = null;break;
              }g = k.sibling;
              if (null !== g) {
                g.return = k.return;k = g;break;
              }k = k.return;
            }g = k;
          }
        }P(a, b, e.children, c);b = b.child;
      }return b;case 9:
      return e = b.type, f = b.pendingProps, d = f.children, Cf(b, c), e = Df(e, f.unstable_observedBits), d = d(e), b.effectTag |= 1, P(a, b, d, c), b.child;case 14:
      return e = b.type, f = O(e.type, b.pendingProps), pg(a, b, e, f, d, c);case 15:
      return qg(a, b, b.type, b.pendingProps, d, c);case 17:
      return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : O(d, e), null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), b.tag = 1, L(d) ? (a = !0, Qe(b)) : a = !1, Cf(b, c), Wf(b, d, e, c), Yf(b, d, e, c), vg(null, b, d, !0, a, c);default:
      t("156");}
}function zg(a) {
  a.effectTag |= 4;
}var Ag = void 0,
    Bg = void 0,
    Fg = void 0,
    Gg = void 0;Ag = function Ag(a, b) {
  for (var c = b.child; null !== c;) {
    if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);else if (4 !== c.tag && null !== c.child) {
      c.child.return = c;c = c.child;continue;
    }if (c === b) break;for (; null === c.sibling;) {
      if (null === c.return || c.return === b) return;c = c.return;
    }c.sibling.return = c.return;c = c.sibling;
  }
};Bg = function Bg() {};
Fg = function Fg(a, b, c, d, e) {
  var f = a.memoizedProps;if (f !== d) {
    var g = b.stateNode;Hf(N.current);a = null;switch (c) {case "input":
        f = Ac(g, f);d = Ac(g, d);a = [];break;case "option":
        f = ee(g, f);d = ee(g, d);a = [];break;case "select":
        f = n({}, f, { value: void 0 });d = n({}, d, { value: void 0 });a = [];break;case "textarea":
        f = ge(g, f);d = ge(g, d);a = [];break;default:
        "function" !== typeof f.onClick && "function" === typeof d.onClick && (g.onclick = ye);}ve(c, d);g = c = void 0;var h = null;for (c in f) {
      if (!d.hasOwnProperty(c) && f.hasOwnProperty(c) && null != f[c]) if ("style" === c) {
        var k = f[c];for (g in k) {
          k.hasOwnProperty(g) && (h || (h = {}), h[g] = "");
        }
      } else "dangerouslySetInnerHTML" !== c && "children" !== c && "suppressContentEditableWarning" !== c && "suppressHydrationWarning" !== c && "autoFocus" !== c && (sa.hasOwnProperty(c) ? a || (a = []) : (a = a || []).push(c, null));
    }for (c in d) {
      var l = d[c];k = null != f ? f[c] : void 0;if (d.hasOwnProperty(c) && l !== k && (null != l || null != k)) if ("style" === c) {
        if (k) {
          for (g in k) {
            !k.hasOwnProperty(g) || l && l.hasOwnProperty(g) || (h || (h = {}), h[g] = "");
          }for (g in l) {
            l.hasOwnProperty(g) && k[g] !== l[g] && (h || (h = {}), h[g] = l[g]);
          }
        } else h || (a || (a = []), a.push(c, h)), h = l;
      } else "dangerouslySetInnerHTML" === c ? (l = l ? l.__html : void 0, k = k ? k.__html : void 0, null != l && k !== l && (a = a || []).push(c, "" + l)) : "children" === c ? k === l || "string" !== typeof l && "number" !== typeof l || (a = a || []).push(c, "" + l) : "suppressContentEditableWarning" !== c && "suppressHydrationWarning" !== c && (sa.hasOwnProperty(c) ? (null != l && xe(e, c), a || k === l || (a = [])) : (a = a || []).push(c, l));
    }h && (a = a || []).push("style", h);e = a;(b.updateQueue = e) && zg(b);
  }
};Gg = function Gg(a, b, c, d) {
  c !== d && zg(b);
};
function Hg(a, b) {
  var c = b.source,
      d = b.stack;null === d && null !== c && (d = nc(c));null !== c && mc(c.type);b = b.value;null !== a && 1 === a.tag && mc(a.type);try {
    console.error(b);
  } catch (e) {
    setTimeout(function () {
      throw e;
    });
  }
}function Ig(a) {
  var b = a.ref;if (null !== b) if ("function" === typeof b) try {
    b(null);
  } catch (c) {
    Jg(a, c);
  } else b.current = null;
}
function Kg(a) {
  "function" === typeof Te && Te(a);switch (a.tag) {case 0:case 11:case 14:case 15:
      var b = a.updateQueue;if (null !== b && (b = b.lastEffect, null !== b)) {
        var c = b = b.next;do {
          var d = c.destroy;if (null !== d) {
            var e = a;try {
              d();
            } catch (f) {
              Jg(e, f);
            }
          }c = c.next;
        } while (c !== b);
      }break;case 1:
      Ig(a);b = a.stateNode;if ("function" === typeof b.componentWillUnmount) try {
        b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
      } catch (f) {
        Jg(a, f);
      }break;case 5:
      Ig(a);break;case 4:
      Lg(a);}
}
function Mg(a) {
  return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Ng(a) {
  a: {
    for (var b = a.return; null !== b;) {
      if (Mg(b)) {
        var c = b;break a;
      }b = b.return;
    }t("160");c = void 0;
  }var d = b = void 0;switch (c.tag) {case 5:
      b = c.stateNode;d = !1;break;case 3:
      b = c.stateNode.containerInfo;d = !0;break;case 4:
      b = c.stateNode.containerInfo;d = !0;break;default:
      t("161");}c.effectTag & 16 && (pe(b, ""), c.effectTag &= -17);a: b: for (c = a;;) {
    for (; null === c.sibling;) {
      if (null === c.return || Mg(c.return)) {
        c = null;break a;
      }c = c.return;
    }c.sibling.return = c.return;for (c = c.sibling; 5 !== c.tag && 6 !== c.tag;) {
      if (c.effectTag & 2) continue b;
      if (null === c.child || 4 === c.tag) continue b;else c.child.return = c, c = c.child;
    }if (!(c.effectTag & 2)) {
      c = c.stateNode;break a;
    }
  }for (var e = a;;) {
    if (5 === e.tag || 6 === e.tag) {
      if (c) {
        if (d) {
          var f = b,
              g = e.stateNode,
              h = c;8 === f.nodeType ? f.parentNode.insertBefore(g, h) : f.insertBefore(g, h);
        } else b.insertBefore(e.stateNode, c);
      } else d ? (g = b, h = e.stateNode, 8 === g.nodeType ? (f = g.parentNode, f.insertBefore(h, g)) : (f = g, f.appendChild(h)), g = g._reactRootContainer, null !== g && void 0 !== g || null !== f.onclick || (f.onclick = ye)) : b.appendChild(e.stateNode);
    } else if (4 !== e.tag && null !== e.child) {
      e.child.return = e;e = e.child;continue;
    }if (e === a) break;for (; null === e.sibling;) {
      if (null === e.return || e.return === a) return;e = e.return;
    }e.sibling.return = e.return;e = e.sibling;
  }
}
function Lg(a) {
  for (var b = a, c = !1, d = void 0, e = void 0;;) {
    if (!c) {
      c = b.return;a: for (;;) {
        null === c ? t("160") : void 0;switch (c.tag) {case 5:
            d = c.stateNode;e = !1;break a;case 3:
            d = c.stateNode.containerInfo;e = !0;break a;case 4:
            d = c.stateNode.containerInfo;e = !0;break a;}c = c.return;
      }c = !0;
    }if (5 === b.tag || 6 === b.tag) {
      a: for (var f = b, g = f;;) {
        if (Kg(g), null !== g.child && 4 !== g.tag) g.child.return = g, g = g.child;else {
          if (g === f) break;for (; null === g.sibling;) {
            if (null === g.return || g.return === f) break a;g = g.return;
          }g.sibling.return = g.return;g = g.sibling;
        }
      }e ? (f = d, g = b.stateNode, 8 === f.nodeType ? f.parentNode.removeChild(g) : f.removeChild(g)) : d.removeChild(b.stateNode);
    } else if (4 === b.tag ? (d = b.stateNode.containerInfo, e = !0) : Kg(b), null !== b.child) {
      b.child.return = b;b = b.child;continue;
    }if (b === a) break;for (; null === b.sibling;) {
      if (null === b.return || b.return === a) return;b = b.return;4 === b.tag && (c = !1);
    }b.sibling.return = b.return;b = b.sibling;
  }
}
function Og(a, b) {
  switch (b.tag) {case 0:case 11:case 14:case 15:
      break;case 1:
      break;case 5:
      var c = b.stateNode;if (null != c) {
        var d = b.memoizedProps,
            e = null !== a ? a.memoizedProps : d;a = b.type;var f = b.updateQueue;b.updateQueue = null;if (null !== f) {
          c[Ha] = d;"input" === a && "radio" === d.type && null != d.name && Cc(c, d);we(a, e);b = we(a, d);for (e = 0; e < f.length; e += 2) {
            var g = f[e],
                h = f[e + 1];"style" === g ? te(c, h) : "dangerouslySetInnerHTML" === g ? oe(c, h) : "children" === g ? pe(c, h) : yc(c, g, h, b);
          }switch (a) {case "input":
              Dc(c, d);break;case "textarea":
              ie(c, d);break;case "select":
              b = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, a = d.value, null != a ? fe(c, !!d.multiple, a, !1) : b !== !!d.multiple && (null != d.defaultValue ? fe(c, !!d.multiple, d.defaultValue, !0) : fe(c, !!d.multiple, d.multiple ? [] : "", !1));}
        }
      }break;case 6:
      null === b.stateNode ? t("162") : void 0;b.stateNode.nodeValue = b.memoizedProps;break;case 3:
      break;case 12:
      break;case 13:
      c = b.memoizedState;a = b;null === c ? d = !1 : (d = !0, a = b.child, 0 === c.timedOutAt && (c.timedOutAt = Qf()));if (null !== a) a: for (b = c = a;;) {
        if (5 === b.tag) a = b.stateNode, d ? a.style.display = "none" : (a = b.stateNode, f = b.memoizedProps.style, f = void 0 !== f && null !== f && f.hasOwnProperty("display") ? f.display : null, a.style.display = se("display", f));else if (6 === b.tag) b.stateNode.nodeValue = d ? "" : b.memoizedProps;else if (13 === b.tag && null !== b.memoizedState) {
          a = b.child.sibling;a.return = b;b = a;continue;
        } else if (null !== b.child) {
          b.child.return = b;b = b.child;continue;
        }if (b === c) break a;for (; null === b.sibling;) {
          if (null === b.return || b.return === c) break a;b = b.return;
        }b.sibling.return = b.return;b = b.sibling;
      }break;case 17:
      break;default:
      t("163");}
}function Pg(a, b, c) {
  c = mf(c);c.tag = 3;c.payload = { element: null };var d = b.value;c.callback = function () {
    Qg(d);Hg(a, b);
  };return c;
}
function Rg(a, b, c) {
  c = mf(c);c.tag = 3;var d = a.type.getDerivedStateFromError;if ("function" === typeof d) {
    var e = b.value;c.payload = function () {
      return d(e);
    };
  }var f = a.stateNode;null !== f && "function" === typeof f.componentDidCatch && (c.callback = function () {
    "function" !== typeof d && (null === Sg ? Sg = new Set([this]) : Sg.add(this));var c = b.value,
        e = b.stack;Hg(a, b);this.componentDidCatch(c, { componentStack: null !== e ? e : "" });
  });return c;
}
function Tg(a) {
  switch (a.tag) {case 1:
      L(a.type) && Me(a);var b = a.effectTag;return b & 2048 ? (a.effectTag = b & -2049 | 64, a) : null;case 3:
      return Jf(a), Ne(a), b = a.effectTag, 0 !== (b & 64) ? t("285") : void 0, a.effectTag = b & -2049 | 64, a;case 5:
      return Lf(a), null;case 13:
      return b = a.effectTag, b & 2048 ? (a.effectTag = b & -2049 | 64, a) : null;case 4:
      return Jf(a), null;case 10:
      return Bf(a), null;default:
      return null;}
}
var Ug = { readContext: Df },
    Vg = Xb.ReactCurrentOwner,
    Wg = 1073741822,
    Xg = 0,
    Yg = !1,
    R = null,
    S = null,
    T = 0,
    Zg = -1,
    $g = !1,
    U = null,
    ah = !1,
    bh = null,
    ch = null,
    Sg = null;function dh() {
  if (null !== R) for (var a = R.return; null !== a;) {
    var b = a;switch (b.tag) {case 1:
        var c = b.type.childContextTypes;null !== c && void 0 !== c && Me(b);break;case 3:
        Jf(b);Ne(b);break;case 5:
        Lf(b);break;case 4:
        Jf(b);break;case 10:
        Bf(b);}a = a.return;
  }S = null;T = 0;Zg = -1;$g = !1;R = null;
}function Sf() {
  null !== ch && (ba.unstable_cancelCallback(bh), ch());
}
function eh(a) {
  for (;;) {
    var b = a.alternate,
        c = a.return,
        d = a.sibling;if (0 === (a.effectTag & 1024)) {
      R = a;a: {
        var e = b;b = a;var f = T;var g = b.pendingProps;switch (b.tag) {case 2:
            break;case 16:
            break;case 15:case 0:
            break;case 1:
            L(b.type) && Me(b);break;case 3:
            Jf(b);Ne(b);g = b.stateNode;g.pendingContext && (g.context = g.pendingContext, g.pendingContext = null);if (null === e || null === e.child) lg(b), b.effectTag &= -3;Bg(b);break;case 5:
            Lf(b);var h = Hf(Gf.current);f = b.type;if (null !== e && null != b.stateNode) Fg(e, b, f, g, h), e.ref !== b.ref && (b.effectTag |= 128);else if (g) {
              var k = Hf(N.current);if (lg(b)) {
                g = b;e = g.stateNode;var l = g.type,
                    m = g.memoizedProps,
                    q = h;e[Ga] = g;e[Ha] = m;f = void 0;h = l;switch (h) {case "iframe":case "object":
                    G("load", e);break;case "video":case "audio":
                    for (l = 0; l < bb.length; l++) {
                      G(bb[l], e);
                    }break;case "source":
                    G("error", e);break;case "img":case "image":case "link":
                    G("error", e);G("load", e);break;case "form":
                    G("reset", e);G("submit", e);break;case "details":
                    G("toggle", e);break;case "input":
                    Bc(e, m);G("invalid", e);xe(q, "onChange");break;case "select":
                    e._wrapperState = { wasMultiple: !!m.multiple };G("invalid", e);xe(q, "onChange");break;case "textarea":
                    he(e, m), G("invalid", e), xe(q, "onChange");}ve(h, m);l = null;for (f in m) {
                  m.hasOwnProperty(f) && (k = m[f], "children" === f ? "string" === typeof k ? e.textContent !== k && (l = ["children", k]) : "number" === typeof k && e.textContent !== "" + k && (l = ["children", "" + k]) : sa.hasOwnProperty(f) && null != k && xe(q, f));
                }switch (h) {case "input":
                    Vb(e);Fc(e, m, !0);break;case "textarea":
                    Vb(e);je(e, m);break;case "select":case "option":
                    break;default:
                    "function" === typeof m.onClick && (e.onclick = ye);}f = l;g.updateQueue = f;g = null !== f ? !0 : !1;g && zg(b);
              } else {
                m = b;e = f;q = g;l = 9 === h.nodeType ? h : h.ownerDocument;k === ke.html && (k = le(e));k === ke.html ? "script" === e ? (e = l.createElement("div"), e.innerHTML = "<script>\x3c/script>", l = e.removeChild(e.firstChild)) : "string" === typeof q.is ? l = l.createElement(e, { is: q.is }) : (l = l.createElement(e), "select" === e && q.multiple && (l.multiple = !0)) : l = l.createElementNS(k, e);e = l;e[Ga] = m;e[Ha] = g;Ag(e, b, !1, !1);q = e;l = f;m = g;var x = h,
                    z = we(l, m);switch (l) {case "iframe":case "object":
                    G("load", q);h = m;break;case "video":case "audio":
                    for (h = 0; h < bb.length; h++) {
                      G(bb[h], q);
                    }h = m;break;case "source":
                    G("error", q);h = m;break;case "img":case "image":case "link":
                    G("error", q);G("load", q);h = m;break;case "form":
                    G("reset", q);G("submit", q);h = m;break;case "details":
                    G("toggle", q);h = m;break;case "input":
                    Bc(q, m);h = Ac(q, m);G("invalid", q);xe(x, "onChange");break;case "option":
                    h = ee(q, m);break;case "select":
                    q._wrapperState = { wasMultiple: !!m.multiple };h = n({}, m, { value: void 0 });G("invalid", q);xe(x, "onChange");break;case "textarea":
                    he(q, m);h = ge(q, m);G("invalid", q);xe(x, "onChange");break;default:
                    h = m;}ve(l, h);k = void 0;var B = l,
                    Q = q,
                    v = h;for (k in v) {
                  if (v.hasOwnProperty(k)) {
                    var r = v[k];"style" === k ? te(Q, r) : "dangerouslySetInnerHTML" === k ? (r = r ? r.__html : void 0, null != r && oe(Q, r)) : "children" === k ? "string" === typeof r ? ("textarea" !== B || "" !== r) && pe(Q, r) : "number" === typeof r && pe(Q, "" + r) : "suppressContentEditableWarning" !== k && "suppressHydrationWarning" !== k && "autoFocus" !== k && (sa.hasOwnProperty(k) ? null != r && xe(x, k) : null != r && yc(Q, k, r, z));
                  }
                }switch (l) {case "input":
                    Vb(q);
                    Fc(q, m, !1);break;case "textarea":
                    Vb(q);je(q, m);break;case "option":
                    null != m.value && q.setAttribute("value", "" + zc(m.value));break;case "select":
                    h = q;h.multiple = !!m.multiple;q = m.value;null != q ? fe(h, !!m.multiple, q, !1) : null != m.defaultValue && fe(h, !!m.multiple, m.defaultValue, !0);break;default:
                    "function" === typeof h.onClick && (q.onclick = ye);}(g = Be(f, g)) && zg(b);b.stateNode = e;
              }null !== b.ref && (b.effectTag |= 128);
            } else null === b.stateNode ? t("166") : void 0;break;case 6:
            e && null != b.stateNode ? Gg(e, b, e.memoizedProps, g) : ("string" !== typeof g && (null === b.stateNode ? t("166") : void 0), e = Hf(Gf.current), Hf(N.current), lg(b) ? (g = b, f = g.stateNode, e = g.memoizedProps, f[Ga] = g, (g = f.nodeValue !== e) && zg(b)) : (f = b, g = (9 === e.nodeType ? e : e.ownerDocument).createTextNode(g), g[Ga] = b, f.stateNode = g));break;case 11:
            break;case 13:
            g = b.memoizedState;if (0 !== (b.effectTag & 64)) {
              b.expirationTime = f;R = b;break a;
            }g = null !== g;f = null !== e && null !== e.memoizedState;null !== e && !g && f && (e = e.child.sibling, null !== e && (h = b.firstEffect, null !== h ? (b.firstEffect = e, e.nextEffect = h) : (b.firstEffect = b.lastEffect = e, e.nextEffect = null), e.effectTag = 8));if (g !== f || 0 === (b.effectTag & 1) && g) b.effectTag |= 4;break;case 7:
            break;case 8:
            break;case 12:
            break;case 4:
            Jf(b);Bg(b);break;case 10:
            Bf(b);break;case 9:
            break;case 14:
            break;case 17:
            L(b.type) && Me(b);break;default:
            t("156");}R = null;
      }b = a;if (1 === T || 1 !== b.childExpirationTime) {
        g = 0;for (f = b.child; null !== f;) {
          e = f.expirationTime, h = f.childExpirationTime, e > g && (g = e), h > g && (g = h), f = f.sibling;
        }b.childExpirationTime = g;
      }if (null !== R) return R;null !== c && 0 === (c.effectTag & 1024) && (null === c.firstEffect && (c.firstEffect = a.firstEffect), null !== a.lastEffect && (null !== c.lastEffect && (c.lastEffect.nextEffect = a.firstEffect), c.lastEffect = a.lastEffect), 1 < a.effectTag && (null !== c.lastEffect ? c.lastEffect.nextEffect = a : c.firstEffect = a, c.lastEffect = a));
    } else {
      a = Tg(a, T);if (null !== a) return a.effectTag &= 1023, a;null !== c && (c.firstEffect = c.lastEffect = null, c.effectTag |= 1024);
    }if (null !== d) return d;if (null !== c) a = c;else break;
  }return null;
}
function fh(a) {
  var b = yg(a.alternate, a, T);a.memoizedProps = a.pendingProps;null === b && (b = eh(a));Vg.current = null;return b;
}
function gh(a, b) {
  Yg ? t("243") : void 0;Sf();Yg = !0;Vg.currentDispatcher = Ug;var c = a.nextExpirationTimeToWorkOn;if (c !== T || a !== S || null === R) dh(), S = a, T = c, R = Ze(S.current, null, T), a.pendingCommitExpirationTime = 0;var d = !1;do {
    try {
      if (b) for (; null !== R && !hh();) {
        R = fh(R);
      } else for (; null !== R;) {
        R = fh(R);
      }
    } catch (B) {
      if (zf = yf = xf = null, null === R) d = !0, Qg(B);else {
        null === R ? t("271") : void 0;var e = R,
            f = e.return;if (null === f) d = !0, Qg(B);else {
          a: {
            var g = a,
                h = f,
                k = e,
                l = B;f = T;k.effectTag |= 1024;k.firstEffect = k.lastEffect = null;if (null !== l && "object" === (typeof l === "undefined" ? "undefined" : _typeof(l)) && "function" === typeof l.then) {
              var m = l;l = h;var q = -1,
                  x = -1;do {
                if (13 === l.tag) {
                  var z = l.alternate;if (null !== z && (z = z.memoizedState, null !== z)) {
                    x = 10 * (1073741822 - z.timedOutAt);break;
                  }z = l.pendingProps.maxDuration;if ("number" === typeof z) if (0 >= z) q = 0;else if (-1 === q || z < q) q = z;
                }l = l.return;
              } while (null !== l);l = h;do {
                if (z = 13 === l.tag) z = void 0 === l.memoizedProps.fallback ? !1 : null === l.memoizedState;if (z) {
                  h = ih.bind(null, g, l, k, 0 === (l.mode & 1) ? 1073741823 : f);m.then(h, h);if (0 === (l.mode & 1)) {
                    l.effectTag |= 64;k.effectTag &= -1957;
                    1 === k.tag && null === k.alternate && (k.tag = 17);k.expirationTime = f;break a;
                  }-1 === q ? g = 1073741823 : (-1 === x && (x = 10 * (1073741822 - hf(g, f)) - 5E3), g = x + q);0 <= g && Zg < g && (Zg = g);l.effectTag |= 2048;l.expirationTime = f;break a;
                }l = l.return;
              } while (null !== l);l = Error((mc(k.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + nc(k));
            }$g = !0;l = vf(l, k);g = h;do {
              switch (g.tag) {case 3:
                  k = l;g.effectTag |= 2048;g.expirationTime = f;f = Pg(g, k, f);pf(g, f);break a;case 1:
                  if (k = l, h = g.type, m = g.stateNode, 0 === (g.effectTag & 64) && ("function" === typeof h.getDerivedStateFromError || null !== m && "function" === typeof m.componentDidCatch && (null === Sg || !Sg.has(m)))) {
                    g.effectTag |= 2048;g.expirationTime = f;f = Rg(g, k, f);pf(g, f);break a;
                  }}g = g.return;
            } while (null !== g);
          }R = eh(e);continue;
        }
      }
    }break;
  } while (1);Yg = !1;zf = yf = xf = Vg.currentDispatcher = null;if (d) S = null, a.finishedWork = null;else if (null !== R) a.finishedWork = null;else {
    d = a.current.alternate;
    null === d ? t("281") : void 0;S = null;if ($g) {
      e = a.latestPendingTime;f = a.latestSuspendedTime;g = a.latestPingedTime;if (0 !== e && e < c || 0 !== f && f < c || 0 !== g && g < c) {
        gf(a, c);jh(a, d, c, a.expirationTime, -1);return;
      }if (!a.didError && b) {
        a.didError = !0;c = a.nextExpirationTimeToWorkOn = c;b = a.expirationTime = 1073741823;jh(a, d, c, b, -1);return;
      }
    }b && -1 !== Zg ? (gf(a, c), b = 10 * (1073741822 - hf(a, c)), b < Zg && (Zg = b), b = 10 * (1073741822 - Qf()), b = Zg - b, jh(a, d, c, a.expirationTime, 0 > b ? 0 : b)) : (a.pendingCommitExpirationTime = c, a.finishedWork = d);
  }
}
function Jg(a, b) {
  for (var c = a.return; null !== c;) {
    switch (c.tag) {case 1:
        var d = c.stateNode;if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Sg || !Sg.has(d))) {
          a = vf(b, a);a = Rg(c, a, 1073741823);of(c, a);Tf(c, 1073741823);return;
        }break;case 3:
        a = vf(b, a);a = Pg(c, a, 1073741823);of(c, a);Tf(c, 1073741823);return;}c = c.return;
  }3 === a.tag && (c = vf(b, a), c = Pg(a, c, 1073741823), of(a, c), Tf(a, 1073741823));
}
function Rf(a, b) {
  0 !== Xg ? a = Xg : Yg ? a = ah ? 1073741823 : T : b.mode & 1 ? (a = kh ? 1073741822 - 10 * (((1073741822 - a + 15) / 10 | 0) + 1) : 1073741822 - 25 * (((1073741822 - a + 500) / 25 | 0) + 1), null !== S && a === T && --a) : a = 1073741823;kh && (0 === lh || a < lh) && (lh = a);return a;
}
function ih(a, b, c, d) {
  var e = a.earliestSuspendedTime;var f = a.latestSuspendedTime;if (0 !== e && d <= e && d >= f) {
    f = e = d;a.didError = !1;var g = a.latestPingedTime;if (0 === g || g > f) a.latestPingedTime = f;ff(f, a);
  } else e = Qf(), e = Rf(e, b), ef(a, e);0 !== (b.mode & 1) && a === S && T === d && (S = null);mh(b, e);0 === (b.mode & 1) && (mh(c, e), 1 === c.tag && null !== c.stateNode && (b = mf(e), b.tag = 2, of(c, b)));c = a.expirationTime;0 !== c && nh(a, c);
}
function mh(a, b) {
  a.expirationTime < b && (a.expirationTime = b);var c = a.alternate;null !== c && c.expirationTime < b && (c.expirationTime = b);var d = a.return,
      e = null;if (null === d && 3 === a.tag) e = a.stateNode;else for (; null !== d;) {
    c = d.alternate;d.childExpirationTime < b && (d.childExpirationTime = b);null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);if (null === d.return && 3 === d.tag) {
      e = d.stateNode;break;
    }d = d.return;
  }return e;
}
function Tf(a, b) {
  a = mh(a, b);null !== a && (!Yg && 0 !== T && b > T && dh(), ef(a, b), Yg && !ah && S === a || nh(a, a.expirationTime), oh > ph && (oh = 0, t("185")));
}function qh(a, b, c, d, e) {
  var f = Xg;Xg = 1073741823;try {
    return a(b, c, d, e);
  } finally {
    Xg = f;
  }
}var rh = null,
    V = null,
    sh = 0,
    th = void 0,
    W = !1,
    uh = null,
    X = 0,
    lh = 0,
    vh = !1,
    wh = null,
    Z = !1,
    xh = !1,
    kh = !1,
    yh = null,
    zh = ba.unstable_now(),
    Ah = 1073741822 - (zh / 10 | 0),
    Bh = Ah,
    ph = 50,
    oh = 0,
    Ch = null;function Dh() {
  Ah = 1073741822 - ((ba.unstable_now() - zh) / 10 | 0);
}
function Eh(a, b) {
  if (0 !== sh) {
    if (b < sh) return;null !== th && ba.unstable_cancelCallback(th);
  }sh = b;a = ba.unstable_now() - zh;th = ba.unstable_scheduleCallback(Fh, { timeout: 10 * (1073741822 - b) - a });
}function jh(a, b, c, d, e) {
  a.expirationTime = d;0 !== e || hh() ? 0 < e && (a.timeoutHandle = De(Gh.bind(null, a, b, c), e)) : (a.pendingCommitExpirationTime = c, a.finishedWork = b);
}function Gh(a, b, c) {
  a.pendingCommitExpirationTime = c;a.finishedWork = b;Dh();Bh = Ah;Hh(a, c);
}function Qf() {
  if (W) return Bh;Ih();if (0 === X || 1 === X) Dh(), Bh = Ah;return Bh;
}
function nh(a, b) {
  null === a.nextScheduledRoot ? (a.expirationTime = b, null === V ? (rh = V = a, a.nextScheduledRoot = a) : (V = V.nextScheduledRoot = a, V.nextScheduledRoot = rh)) : b > a.expirationTime && (a.expirationTime = b);W || (Z ? xh && (uh = a, X = 1073741823, Jh(a, 1073741823, !1)) : 1073741823 === b ? Kh(1073741823, !1) : Eh(a, b));
}
function Ih() {
  var a = 0,
      b = null;if (null !== V) for (var c = V, d = rh; null !== d;) {
    var e = d.expirationTime;if (0 === e) {
      null === c || null === V ? t("244") : void 0;if (d === d.nextScheduledRoot) {
        rh = V = d.nextScheduledRoot = null;break;
      } else if (d === rh) rh = e = d.nextScheduledRoot, V.nextScheduledRoot = e, d.nextScheduledRoot = null;else if (d === V) {
        V = c;V.nextScheduledRoot = rh;d.nextScheduledRoot = null;break;
      } else c.nextScheduledRoot = d.nextScheduledRoot, d.nextScheduledRoot = null;d = c.nextScheduledRoot;
    } else {
      e > a && (a = e, b = d);if (d === V) break;if (1073741823 === a) break;c = d;d = d.nextScheduledRoot;
    }
  }uh = b;X = a;
}var Lh = !1;function hh() {
  return Lh ? !0 : ba.unstable_shouldYield() ? Lh = !0 : !1;
}function Fh() {
  try {
    if (!hh() && null !== rh) {
      Dh();var a = rh;do {
        var b = a.expirationTime;0 !== b && Ah <= b && (a.nextExpirationTimeToWorkOn = Ah);a = a.nextScheduledRoot;
      } while (a !== rh);
    }Kh(0, !0);
  } finally {
    Lh = !1;
  }
}
function Kh(a, b) {
  Ih();if (b) for (Dh(), Bh = Ah; null !== uh && 0 !== X && a <= X && !(Lh && Ah > X);) {
    Jh(uh, X, Ah > X), Ih(), Dh(), Bh = Ah;
  } else for (; null !== uh && 0 !== X && a <= X;) {
    Jh(uh, X, !1), Ih();
  }b && (sh = 0, th = null);0 !== X && Eh(uh, X);oh = 0;Ch = null;if (null !== yh) for (a = yh, yh = null, b = 0; b < a.length; b++) {
    var c = a[b];try {
      c._onComplete();
    } catch (d) {
      vh || (vh = !0, wh = d);
    }
  }if (vh) throw a = wh, wh = null, vh = !1, a;
}function Hh(a, b) {
  W ? t("253") : void 0;uh = a;X = b;Jh(a, b, !1);Kh(1073741823, !1);
}
function Jh(a, b, c) {
  W ? t("245") : void 0;W = !0;if (c) {
    var d = a.finishedWork;null !== d ? Mh(a, d, b) : (a.finishedWork = null, d = a.timeoutHandle, -1 !== d && (a.timeoutHandle = -1, Ee(d)), gh(a, c), d = a.finishedWork, null !== d && (hh() ? a.finishedWork = d : Mh(a, d, b)));
  } else d = a.finishedWork, null !== d ? Mh(a, d, b) : (a.finishedWork = null, d = a.timeoutHandle, -1 !== d && (a.timeoutHandle = -1, Ee(d)), gh(a, c), d = a.finishedWork, null !== d && Mh(a, d, b));W = !1;
}
function Mh(a, b, c) {
  var d = a.firstBatch;if (null !== d && d._expirationTime >= c && (null === yh ? yh = [d] : yh.push(d), d._defer)) {
    a.finishedWork = b;a.expirationTime = 0;return;
  }a.finishedWork = null;a === Ch ? oh++ : (Ch = a, oh = 0);ah = Yg = !0;a.current === b ? t("177") : void 0;c = a.pendingCommitExpirationTime;0 === c ? t("261") : void 0;a.pendingCommitExpirationTime = 0;d = b.expirationTime;var e = b.childExpirationTime;d = e > d ? e : d;a.didError = !1;0 === d ? (a.earliestPendingTime = 0, a.latestPendingTime = 0, a.earliestSuspendedTime = 0, a.latestSuspendedTime = 0, a.latestPingedTime = 0) : (e = a.latestPendingTime, 0 !== e && (e > d ? a.earliestPendingTime = a.latestPendingTime = 0 : a.earliestPendingTime > d && (a.earliestPendingTime = a.latestPendingTime)), e = a.earliestSuspendedTime, 0 === e ? ef(a, d) : d < a.latestSuspendedTime ? (a.earliestSuspendedTime = 0, a.latestSuspendedTime = 0, a.latestPingedTime = 0, ef(a, d)) : d > e && ef(a, d));ff(0, a);Vg.current = null;1 < b.effectTag ? null !== b.lastEffect ? (b.lastEffect.nextEffect = b, d = b.firstEffect) : d = b : d = b.firstEffect;ze = Hd;e = Td();if (Ud(e)) {
    if ("selectionStart" in e) var f = { start: e.selectionStart,
      end: e.selectionEnd };else a: {
      f = (f = e.ownerDocument) && f.defaultView || window;var g = f.getSelection && f.getSelection();if (g && 0 !== g.rangeCount) {
        f = g.anchorNode;var h = g.anchorOffset,
            k = g.focusNode;g = g.focusOffset;try {
          f.nodeType, k.nodeType;
        } catch (db) {
          f = null;break a;
        }var l = 0,
            m = -1,
            q = -1,
            x = 0,
            z = 0,
            B = e,
            Q = null;b: for (;;) {
          for (var v;;) {
            B !== f || 0 !== h && 3 !== B.nodeType || (m = l + h);B !== k || 0 !== g && 3 !== B.nodeType || (q = l + g);3 === B.nodeType && (l += B.nodeValue.length);if (null === (v = B.firstChild)) break;Q = B;B = v;
          }for (;;) {
            if (B === e) break b;Q === f && ++x === h && (m = l);Q === k && ++z === g && (q = l);if (null !== (v = B.nextSibling)) break;B = Q;Q = B.parentNode;
          }B = v;
        }f = -1 === m || -1 === q ? null : { start: m, end: q };
      } else f = null;
    }f = f || { start: 0, end: 0 };
  } else f = null;Ae = { focusedElem: e, selectionRange: f };Hd = !1;for (U = d; null !== U;) {
    e = !1;f = void 0;try {
      for (; null !== U;) {
        if (U.effectTag & 256) a: {
          var r = U.alternate;h = U;switch (h.tag) {case 0:case 11:case 15:
              break a;case 1:
              if (h.effectTag & 256 && null !== r) {
                var u = r.memoizedProps,
                    y = r.memoizedState,
                    Y = h.stateNode,
                    Th = Y.getSnapshotBeforeUpdate(h.elementType === h.type ? u : O(h.type, u), y);Y.__reactInternalSnapshotBeforeUpdate = Th;
              }break a;case 3:case 5:case 6:case 4:case 17:
              break a;default:
              t("163");}
        }U = U.nextEffect;
      }
    } catch (db) {
      e = !0, f = db;
    }e && (null === U ? t("178") : void 0, Jg(U, f), null !== U && (U = U.nextEffect));
  }for (U = d; null !== U;) {
    r = !1;u = void 0;try {
      for (; null !== U;) {
        var w = U.effectTag;w & 16 && pe(U.stateNode, "");if (w & 128) {
          var C = U.alternate;if (null !== C) {
            var p = C.ref;null !== p && ("function" === typeof p ? p(null) : p.current = null);
          }
        }switch (w & 14) {case 2:
            Ng(U);U.effectTag &= -3;break;case 6:
            Ng(U);U.effectTag &= -3;Og(U.alternate, U);break;case 4:
            Og(U.alternate, U);break;case 8:
            y = U, Lg(y), y.return = null, y.child = null, y.alternate && (y.alternate.child = null, y.alternate.return = null);}U = U.nextEffect;
      }
    } catch (db) {
      r = !0, u = db;
    }r && (null === U ? t("178") : void 0, Jg(U, u), null !== U && (U = U.nextEffect));
  }p = Ae;C = Td();w = p.focusedElem;u = p.selectionRange;if (C !== w && w && w.ownerDocument && Sd(w.ownerDocument.documentElement, w)) {
    null !== u && Ud(w) && (C = u.start, p = u.end, void 0 === p && (p = C), "selectionStart" in w ? (w.selectionStart = C, w.selectionEnd = Math.min(p, w.value.length)) : (p = (C = w.ownerDocument || document) && C.defaultView || window, p.getSelection && (p = p.getSelection(), y = w.textContent.length, r = Math.min(u.start, y), u = void 0 === u.end ? r : Math.min(u.end, y), !p.extend && r > u && (y = u, u = r, r = y), y = Rd(w, r), Y = Rd(w, u), y && Y && (1 !== p.rangeCount || p.anchorNode !== y.node || p.anchorOffset !== y.offset || p.focusNode !== Y.node || p.focusOffset !== Y.offset) && (C = C.createRange(), C.setStart(y.node, y.offset), p.removeAllRanges(), r > u ? (p.addRange(C), p.extend(Y.node, Y.offset)) : (C.setEnd(Y.node, Y.offset), p.addRange(C))))));C = [];for (p = w; p = p.parentNode;) {
      1 === p.nodeType && C.push({ element: p, left: p.scrollLeft, top: p.scrollTop });
    }"function" === typeof w.focus && w.focus();for (w = 0; w < C.length; w++) {
      p = C[w], p.element.scrollLeft = p.left, p.element.scrollTop = p.top;
    }
  }Ae = null;Hd = !!ze;ze = null;a.current = b;for (U = d; null !== U;) {
    d = !1;w = void 0;try {
      for (C = c; null !== U;) {
        var Fb = U.effectTag;if (Fb & 36) {
          var Gb = U.alternate;p = U;r = C;switch (p.tag) {case 0:case 11:case 15:
              break;case 1:
              var wc = p.stateNode;if (p.effectTag & 4) if (null === Gb) wc.componentDidMount();else {
                var ci = p.elementType === p.type ? Gb.memoizedProps : O(p.type, Gb.memoizedProps);wc.componentDidUpdate(ci, Gb.memoizedState, wc.__reactInternalSnapshotBeforeUpdate);
              }var Cg = p.updateQueue;null !== Cg && tf(p, Cg, wc, r);break;case 3:
              var Dg = p.updateQueue;if (null !== Dg) {
                u = null;if (null !== p.child) switch (p.child.tag) {case 5:
                    u = p.child.stateNode;break;case 1:
                    u = p.child.stateNode;}tf(p, Dg, u, r);
              }break;case 5:
              var di = p.stateNode;null === Gb && p.effectTag & 4 && Be(p.type, p.memoizedProps) && di.focus();break;case 6:
              break;case 4:
              break;
            case 12:
              break;case 13:
              break;case 17:
              break;default:
              t("163");}
        }if (Fb & 128) {
          var Ic = U.ref;if (null !== Ic) {
            var Eg = U.stateNode;switch (U.tag) {case 5:
                var ce = Eg;break;default:
                ce = Eg;}"function" === typeof Ic ? Ic(ce) : Ic.current = ce;
          }
        }U = U.nextEffect;
      }
    } catch (db) {
      d = !0, w = db;
    }d && (null === U ? t("178") : void 0, Jg(U, w), null !== U && (U = U.nextEffect));
  }Yg = ah = !1;"function" === typeof Se && Se(b.stateNode);Fb = b.expirationTime;b = b.childExpirationTime;b = b > Fb ? b : Fb;0 === b && (Sg = null);a.expirationTime = b;a.finishedWork = null;
}
function Qg(a) {
  null === uh ? t("246") : void 0;uh.expirationTime = 0;vh || (vh = !0, wh = a);
}function Nh(a, b) {
  var c = Z;Z = !0;try {
    return a(b);
  } finally {
    (Z = c) || W || Kh(1073741823, !1);
  }
}function Oh(a, b) {
  if (Z && !xh) {
    xh = !0;try {
      return a(b);
    } finally {
      xh = !1;
    }
  }return a(b);
}function Ph(a, b, c) {
  if (kh) return a(b, c);Z || W || 0 === lh || (Kh(lh, !1), lh = 0);var d = kh,
      e = Z;Z = kh = !0;try {
    return a(b, c);
  } finally {
    kh = d, (Z = e) || W || Kh(1073741823, !1);
  }
}
function Qh(a, b, c, d, e) {
  var f = b.current;a: if (c) {
    c = c._reactInternalFiber;b: {
      2 === kd(c) && 1 === c.tag ? void 0 : t("170");var g = c;do {
        switch (g.tag) {case 3:
            g = g.stateNode.context;break b;case 1:
            if (L(g.type)) {
              g = g.stateNode.__reactInternalMemoizedMergedChildContext;break b;
            }}g = g.return;
      } while (null !== g);t("171");g = void 0;
    }if (1 === c.tag) {
      var h = c.type;if (L(h)) {
        c = Pe(c, h, g);break a;
      }
    }c = g;
  } else c = Je;null === b.context ? b.context = c : b.pendingContext = c;b = e;e = mf(d);e.payload = { element: a };b = void 0 === b ? null : b;null !== b && (e.callback = b);
  Sf();of(f, e);Tf(f, d);return d;
}function Rh(a, b, c, d) {
  var e = b.current,
      f = Qf();e = Rf(f, e);return Qh(a, b, c, e, d);
}function Sh(a) {
  a = a.current;if (!a.child) return null;switch (a.child.tag) {case 5:
      return a.child.stateNode;default:
      return a.child.stateNode;}
}function Uh(a, b, c) {
  var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;return { $$typeof: $b, key: null == d ? null : "" + d, children: a, containerInfo: b, implementation: c };
}
Cb = function Cb(a, b, c) {
  switch (b) {case "input":
      Dc(a, c);b = c.name;if ("radio" === c.type && null != b) {
        for (c = a; c.parentNode;) {
          c = c.parentNode;
        }c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');for (b = 0; b < c.length; b++) {
          var d = c[b];if (d !== a && d.form === a.form) {
            var e = La(d);e ? void 0 : t("90");Wb(d);Dc(d, e);
          }
        }
      }break;case "textarea":
      ie(a, c);break;case "select":
      b = c.value, null != b && fe(a, !!c.multiple, b, !1);}
};
function Vh(a) {
  var b = 1073741822 - 25 * (((1073741822 - Qf() + 500) / 25 | 0) + 1);b >= Wg && (b = Wg - 1);this._expirationTime = Wg = b;this._root = a;this._callbacks = this._next = null;this._hasChildren = this._didComplete = !1;this._children = null;this._defer = !0;
}Vh.prototype.render = function (a) {
  this._defer ? void 0 : t("250");this._hasChildren = !0;this._children = a;var b = this._root._internalRoot,
      c = this._expirationTime,
      d = new Wh();Qh(a, b, null, c, d._onCommit);return d;
};
Vh.prototype.then = function (a) {
  if (this._didComplete) a();else {
    var b = this._callbacks;null === b && (b = this._callbacks = []);b.push(a);
  }
};
Vh.prototype.commit = function () {
  var a = this._root._internalRoot,
      b = a.firstBatch;this._defer && null !== b ? void 0 : t("251");if (this._hasChildren) {
    var c = this._expirationTime;if (b !== this) {
      this._hasChildren && (c = this._expirationTime = b._expirationTime, this.render(this._children));for (var d = null, e = b; e !== this;) {
        d = e, e = e._next;
      }null === d ? t("251") : void 0;d._next = e._next;this._next = b;a.firstBatch = this;
    }this._defer = !1;Hh(a, c);b = this._next;this._next = null;b = a.firstBatch = b;null !== b && b._hasChildren && b.render(b._children);
  } else this._next = null, this._defer = !1;
};Vh.prototype._onComplete = function () {
  if (!this._didComplete) {
    this._didComplete = !0;var a = this._callbacks;if (null !== a) for (var b = 0; b < a.length; b++) {
      (0, a[b])();
    }
  }
};function Wh() {
  this._callbacks = null;this._didCommit = !1;this._onCommit = this._onCommit.bind(this);
}Wh.prototype.then = function (a) {
  if (this._didCommit) a();else {
    var b = this._callbacks;null === b && (b = this._callbacks = []);b.push(a);
  }
};
Wh.prototype._onCommit = function () {
  if (!this._didCommit) {
    this._didCommit = !0;var a = this._callbacks;if (null !== a) for (var b = 0; b < a.length; b++) {
      var c = a[b];"function" !== typeof c ? t("191", c) : void 0;c();
    }
  }
};
function Xh(a, b, c) {
  b = M(3, null, null, b ? 3 : 0);a = { current: b, containerInfo: a, pendingChildren: null, earliestPendingTime: 0, latestPendingTime: 0, earliestSuspendedTime: 0, latestSuspendedTime: 0, latestPingedTime: 0, didError: !1, pendingCommitExpirationTime: 0, finishedWork: null, timeoutHandle: -1, context: null, pendingContext: null, hydrate: c, nextExpirationTimeToWorkOn: 0, expirationTime: 0, firstBatch: null, nextScheduledRoot: null };this._internalRoot = b.stateNode = a;
}
Xh.prototype.render = function (a, b) {
  var c = this._internalRoot,
      d = new Wh();b = void 0 === b ? null : b;null !== b && d.then(b);Rh(a, c, null, d._onCommit);return d;
};Xh.prototype.unmount = function (a) {
  var b = this._internalRoot,
      c = new Wh();a = void 0 === a ? null : a;null !== a && c.then(a);Rh(null, b, null, c._onCommit);return c;
};Xh.prototype.legacy_renderSubtreeIntoContainer = function (a, b, c) {
  var d = this._internalRoot,
      e = new Wh();c = void 0 === c ? null : c;null !== c && e.then(c);Rh(b, d, a, e._onCommit);return e;
};
Xh.prototype.createBatch = function () {
  var a = new Vh(this),
      b = a._expirationTime,
      c = this._internalRoot,
      d = c.firstBatch;if (null === d) c.firstBatch = a, a._next = null;else {
    for (c = null; null !== d && d._expirationTime >= b;) {
      c = d, d = d._next;
    }a._next = d;null !== c && (c._next = a);
  }return a;
};function Yh(a) {
  return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}Kb = Nh;Lb = Ph;Mb = function Mb() {
  W || 0 === lh || (Kh(lh, !1), lh = 0);
};
function Zh(a, b) {
  b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));if (!b) for (var c; c = a.lastChild;) {
    a.removeChild(c);
  }return new Xh(a, !1, b);
}
function $h(a, b, c, d, e) {
  Yh(c) ? void 0 : t("200");var f = c._reactRootContainer;if (f) {
    if ("function" === typeof e) {
      var g = e;e = function e() {
        var a = Sh(f._internalRoot);g.call(a);
      };
    }null != a ? f.legacy_renderSubtreeIntoContainer(a, b, e) : f.render(b, e);
  } else {
    f = c._reactRootContainer = Zh(c, d);if ("function" === typeof e) {
      var h = e;e = function e() {
        var a = Sh(f._internalRoot);h.call(a);
      };
    }Oh(function () {
      null != a ? f.legacy_renderSubtreeIntoContainer(a, b, e) : f.render(b, e);
    });
  }return Sh(f._internalRoot);
}
function ai(a, b) {
  var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;Yh(b) ? void 0 : t("200");return Uh(a, b, null, c);
}
var bi = { createPortal: ai, findDOMNode: function findDOMNode(a) {
    if (null == a) return null;if (1 === a.nodeType) return a;var b = a._reactInternalFiber;void 0 === b && ("function" === typeof a.render ? t("188") : t("268", Object.keys(a)));a = nd(b);a = null === a ? null : a.stateNode;return a;
  }, hydrate: function hydrate(a, b, c) {
    return $h(null, a, b, !0, c);
  }, render: function render(a, b, c) {
    return $h(null, a, b, !1, c);
  }, unstable_renderSubtreeIntoContainer: function unstable_renderSubtreeIntoContainer(a, b, c, d) {
    null == a || void 0 === a._reactInternalFiber ? t("38") : void 0;return $h(a, b, c, !1, d);
  }, unmountComponentAtNode: function unmountComponentAtNode(a) {
    Yh(a) ? void 0 : t("40");return a._reactRootContainer ? (Oh(function () {
      $h(null, null, a, !1, function () {
        a._reactRootContainer = null;
      });
    }), !0) : !1;
  }, unstable_createPortal: function unstable_createPortal() {
    return ai.apply(void 0, arguments);
  }, unstable_batchedUpdates: Nh, unstable_interactiveUpdates: Ph, flushSync: function flushSync(a, b) {
    W ? t("187") : void 0;var c = Z;Z = !0;try {
      return qh(a, b);
    } finally {
      Z = c, Kh(1073741823, !1);
    }
  }, unstable_flushControlled: function unstable_flushControlled(a) {
    var b = Z;Z = !0;try {
      qh(a);
    } finally {
      (Z = b) || W || Kh(1073741823, !1);
    }
  }, __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: { Events: [Ja, Ka, La, Ca.injectEventPluginsByName, qa, Ra, function (a) {
      za(a, Qa);
    }, Ib, Jb, Jd, Ea] }, unstable_createRoot: function unstable_createRoot(a, b) {
    Yh(a) ? void 0 : t("299", "unstable_createRoot");return new Xh(a, !0, null != b && !0 === b.hydrate);
  } };(function (a) {
  var b = a.findFiberByHostInstance;return Ve(n({}, a, { findHostInstanceByFiber: function findHostInstanceByFiber(a) {
      a = nd(a);return null === a ? null : a.stateNode;
    }, findFiberByHostInstance: function findFiberByHostInstance(a) {
      return b ? b(a) : null;
    } }));
})({ findFiberByHostInstance: Ia, bundleType: 0, version: "16.6.3", rendererPackageName: "react-dom" });
var ei = { default: bi },
    fi = ei && bi || ei;module.exports = fi.default || fi;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.6.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", { value: !0 });var d = null,
    f = !1,
    h = 3,
    k = -1,
    l = -1,
    m = !1,
    n = !1;function p() {
  if (!m) {
    var a = d.expirationTime;n ? q() : n = !0;_r(t, a);
  }
}
function u() {
  var a = d,
      b = d.next;if (d === b) d = null;else {
    var c = d.previous;d = c.next = b;b.previous = c;
  }a.next = a.previous = null;c = a.callback;b = a.expirationTime;a = a.priorityLevel;var e = h,
      Q = l;h = a;l = b;try {
    var g = c();
  } finally {
    h = e, l = Q;
  }if ("function" === typeof g) if (g = { callback: g, priorityLevel: a, expirationTime: b, next: null, previous: null }, null === d) d = g.next = g.previous = g;else {
    c = null;a = d;do {
      if (a.expirationTime >= b) {
        c = a;break;
      }a = a.next;
    } while (a !== d);null === c ? c = d : c === d && (d = g, p());b = c.previous;b.next = c.previous = g;g.next = c;g.previous = b;
  }
}function v() {
  if (-1 === k && null !== d && 1 === d.priorityLevel) {
    m = !0;try {
      do {
        u();
      } while (null !== d && 1 === d.priorityLevel);
    } finally {
      m = !1, null !== d ? p() : n = !1;
    }
  }
}function t(a) {
  m = !0;var b = f;f = a;try {
    if (a) for (; null !== d;) {
      var c = exports.unstable_now();if (d.expirationTime <= c) {
        do {
          u();
        } while (null !== d && d.expirationTime <= c);
      } else break;
    } else if (null !== d) {
      do {
        u();
      } while (null !== d && !w());
    }
  } finally {
    m = !1, f = b, null !== d ? p() : n = !1, v();
  }
}
var x = Date,
    y = "function" === typeof setTimeout ? setTimeout : void 0,
    z = "function" === typeof clearTimeout ? clearTimeout : void 0,
    A = "function" === typeof requestAnimationFrame ? requestAnimationFrame : void 0,
    B = "function" === typeof cancelAnimationFrame ? cancelAnimationFrame : void 0,
    C,
    D;function E(a) {
  C = A(function (b) {
    z(D);a(b);
  });D = y(function () {
    B(C);a(exports.unstable_now());
  }, 100);
}
if ("object" === (typeof performance === "undefined" ? "undefined" : _typeof(performance)) && "function" === typeof performance.now) {
  var F = performance;exports.unstable_now = function () {
    return F.now();
  };
} else exports.unstable_now = function () {
  return x.now();
};var _r, q, w;
if ("undefined" !== typeof window && window._schedMock) {
  var G = window._schedMock;_r = G[0];q = G[1];w = G[2];
} else if ("undefined" === typeof window || "function" !== typeof window.addEventListener) {
  var H = null,
      I = -1,
      J = function J(a, b) {
    if (null !== H) {
      var c = H;H = null;try {
        I = b, c(a);
      } finally {
        I = -1;
      }
    }
  };_r = function r(a, b) {
    -1 !== I ? setTimeout(_r, 0, a, b) : (H = a, setTimeout(J, b, !0, b), setTimeout(J, 1073741823, !1, 1073741823));
  };q = function q() {
    H = null;
  };w = function w() {
    return !1;
  };exports.unstable_now = function () {
    return -1 === I ? 0 : I;
  };
} else {
  "undefined" !== typeof console && ("function" !== typeof A && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"), "function" !== typeof B && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));var K = null,
      L = !1,
      M = -1,
      N = !1,
      O = !1,
      P = 0,
      R = 33,
      S = 33;w = function w() {
    return P <= exports.unstable_now();
  };var T = "__reactIdleCallback$" + Math.random().toString(36).slice(2);
  window.addEventListener("message", function (a) {
    if (a.source === window && a.data === T) {
      L = !1;a = K;var b = M;K = null;M = -1;var c = exports.unstable_now(),
          e = !1;if (0 >= P - c) if (-1 !== b && b <= c) e = !0;else {
        N || (N = !0, E(U));K = a;M = b;return;
      }if (null !== a) {
        O = !0;try {
          a(e);
        } finally {
          O = !1;
        }
      }
    }
  }, !1);var U = function U(a) {
    if (null !== K) {
      E(U);var b = a - P + S;b < S && R < S ? (8 > b && (b = 8), S = b < R ? R : b) : R = b;P = a + S;L || (L = !0, window.postMessage(T, "*"));
    } else N = !1;
  };_r = function _r(a, b) {
    K = a;M = b;O || 0 > b ? window.postMessage(T, "*") : N || (N = !0, E(U));
  };q = function q() {
    K = null;L = !1;M = -1;
  };
}
exports.unstable_ImmediatePriority = 1;exports.unstable_UserBlockingPriority = 2;exports.unstable_NormalPriority = 3;exports.unstable_IdlePriority = 5;exports.unstable_LowPriority = 4;exports.unstable_runWithPriority = function (a, b) {
  switch (a) {case 1:case 2:case 3:case 4:case 5:
      break;default:
      a = 3;}var c = h,
      e = k;h = a;k = exports.unstable_now();try {
    return b();
  } finally {
    h = c, k = e, v();
  }
};
exports.unstable_scheduleCallback = function (a, b) {
  var c = -1 !== k ? k : exports.unstable_now();if ("object" === (typeof b === "undefined" ? "undefined" : _typeof(b)) && null !== b && "number" === typeof b.timeout) b = c + b.timeout;else switch (h) {case 1:
      b = c + -1;break;case 2:
      b = c + 250;break;case 5:
      b = c + 1073741823;break;case 4:
      b = c + 1E4;break;default:
      b = c + 5E3;}a = { callback: a, priorityLevel: h, expirationTime: b, next: null, previous: null };if (null === d) d = a.next = a.previous = a, p();else {
    c = null;var e = d;do {
      if (e.expirationTime > b) {
        c = e;break;
      }e = e.next;
    } while (e !== d);null === c ? c = d : c === d && (d = a, p());
    b = c.previous;b.next = c.previous = a;a.next = c;a.previous = b;
  }return a;
};exports.unstable_cancelCallback = function (a) {
  var b = a.next;if (null !== b) {
    if (b === a) d = null;else {
      a === d && (d = b);var c = a.previous;c.next = b;b.previous = c;
    }a.next = a.previous = null;
  }
};exports.unstable_wrapCallback = function (a) {
  var b = h;return function () {
    var c = h,
        e = k;h = b;k = exports.unstable_now();try {
      return a.apply(this, arguments);
    } finally {
      h = c, k = e, v();
    }
  };
};exports.unstable_getCurrentPriorityLevel = function () {
  return h;
};
exports.unstable_shouldYield = function () {
  return !f && (null !== d && d.expirationTime < l || w());
};

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(143);

function emptyFunction() {}

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(145);
} else {
  module.exports = require('./cjs/react-reconciler.development.js');
}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/** @license React v16.6.1
 * react-reconciler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
module.exports = function $$$reconciler($$$hostConfig) {
  'use strict';
  var aa = __webpack_require__(75),
      ba = __webpack_require__(0);var ca = __webpack_require__(41);function da(a, b, c, d, e, g, f, l) {
    if (!a) {
      a = void 0;if (void 0 === b) a = Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
        var h = [c, d, e, g, f, l],
            k = 0;a = Error(b.replace(/%s/g, function () {
          return h[k++];
        }));a.name = "Invariant Violation";
      }a.framesToPop = 1;throw a;
    }
  }
  function m(a) {
    for (var b = arguments.length - 1, c = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, d = 0; d < b; d++) {
      c += "&args[]=" + encodeURIComponent(arguments[d + 1]);
    }da(!1, "Minified React error #" + a + "; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ", c);
  }
  var ea = ba.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
      n = "function" === typeof Symbol && Symbol.for,
      fa = n ? Symbol.for("react.element") : 60103,
      ha = n ? Symbol.for("react.portal") : 60106,
      ia = n ? Symbol.for("react.fragment") : 60107,
      ja = n ? Symbol.for("react.strict_mode") : 60108,
      ka = n ? Symbol.for("react.profiler") : 60114,
      la = n ? Symbol.for("react.provider") : 60109,
      ma = n ? Symbol.for("react.context") : 60110,
      na = n ? Symbol.for("react.concurrent_mode") : 60111,
      oa = n ? Symbol.for("react.forward_ref") : 60112,
      pa = n ? Symbol.for("react.suspense") : 60113,
      qa = n ? Symbol.for("react.memo") : 60115,
      ra = n ? Symbol.for("react.lazy") : 60116,
      sa = "function" === typeof Symbol && Symbol.iterator;function ua(a) {
    if (null === a || "object" !== (typeof a === "undefined" ? "undefined" : _typeof(a))) return null;a = sa && a[sa] || a["@@iterator"];return "function" === typeof a ? a : null;
  }
  function va(a) {
    if (null == a) return null;if ("function" === typeof a) return a.displayName || a.name || null;if ("string" === typeof a) return a;switch (a) {case na:
        return "ConcurrentMode";case ia:
        return "Fragment";case ha:
        return "Portal";case ka:
        return "Profiler";case ja:
        return "StrictMode";case pa:
        return "Suspense";}if ("object" === (typeof a === "undefined" ? "undefined" : _typeof(a))) switch (a.$$typeof) {case ma:
        return "Context.Consumer";case la:
        return "Context.Provider";case oa:
        var b = a.render;b = b.displayName || b.name || "";return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");case qa:
        return va(a.type);case ra:
        if (a = 1 === a._status ? a._result : null) return va(a);}return null;
  }function wa(a) {
    var b = a;if (a.alternate) for (; b.return;) {
      b = b.return;
    } else {
      if (0 !== (b.effectTag & 2)) return 1;for (; b.return;) {
        if (b = b.return, 0 !== (b.effectTag & 2)) return 1;
      }
    }return 3 === b.tag ? 2 : 3;
  }function xa(a) {
    2 !== wa(a) ? m("188") : void 0;
  }
  function ya(a) {
    var b = a.alternate;if (!b) return b = wa(a), 3 === b ? m("188") : void 0, 1 === b ? null : a;for (var c = a, d = b;;) {
      var e = c.return,
          g = e ? e.alternate : null;if (!e || !g) break;if (e.child === g.child) {
        for (var f = e.child; f;) {
          if (f === c) return xa(e), a;if (f === d) return xa(e), b;f = f.sibling;
        }m("188");
      }if (c.return !== d.return) c = e, d = g;else {
        f = !1;for (var l = e.child; l;) {
          if (l === c) {
            f = !0;c = e;d = g;break;
          }if (l === d) {
            f = !0;d = e;c = g;break;
          }l = l.sibling;
        }if (!f) {
          for (l = g.child; l;) {
            if (l === c) {
              f = !0;c = g;d = e;break;
            }if (l === d) {
              f = !0;d = g;c = e;break;
            }l = l.sibling;
          }f ? void 0 : m("189");
        }
      }c.alternate !== d ? m("190") : void 0;
    }3 !== c.tag ? m("188") : void 0;return c.stateNode.current === c ? a : b;
  }function za(a) {
    a = ya(a);if (!a) return null;for (var b = a;;) {
      if (5 === b.tag || 6 === b.tag) return b;if (b.child) b.child.return = b, b = b.child;else {
        if (b === a) break;for (; !b.sibling;) {
          if (!b.return || b.return === a) return null;b = b.return;
        }b.sibling.return = b.return;b = b.sibling;
      }
    }return null;
  }
  function Aa(a) {
    a = ya(a);if (!a) return null;for (var b = a;;) {
      if (5 === b.tag || 6 === b.tag) return b;if (b.child && 4 !== b.tag) b.child.return = b, b = b.child;else {
        if (b === a) break;for (; !b.sibling;) {
          if (!b.return || b.return === a) return null;b = b.return;
        }b.sibling.return = b.return;b = b.sibling;
      }
    }return null;
  }
  var Ba = $$$hostConfig.getPublicInstance,
      Ca = $$$hostConfig.getRootHostContext,
      Da = $$$hostConfig.getChildHostContext,
      Ea = $$$hostConfig.prepareForCommit,
      Fa = $$$hostConfig.resetAfterCommit,
      Ga = $$$hostConfig.createInstance,
      Ha = $$$hostConfig.appendInitialChild,
      Ia = $$$hostConfig.finalizeInitialChildren,
      Ja = $$$hostConfig.prepareUpdate,
      Ka = $$$hostConfig.shouldSetTextContent,
      La = $$$hostConfig.shouldDeprioritizeSubtree,
      Ma = $$$hostConfig.createTextInstance,
      Na = $$$hostConfig.scheduleDeferredCallback,
      Oa = $$$hostConfig.cancelDeferredCallback,
      Pa = $$$hostConfig.shouldYield,
      Qa = $$$hostConfig.setTimeout,
      Ra = $$$hostConfig.clearTimeout,
      Sa = $$$hostConfig.noTimeout,
      Ta = $$$hostConfig.now,
      Ua = $$$hostConfig.isPrimaryRenderer,
      Va = $$$hostConfig.supportsMutation,
      Wa = $$$hostConfig.supportsPersistence,
      Xa = $$$hostConfig.supportsHydration,
      Ya = $$$hostConfig.appendChild,
      Za = $$$hostConfig.appendChildToContainer,
      $a = $$$hostConfig.commitTextUpdate,
      ab = $$$hostConfig.commitMount,
      bb = $$$hostConfig.commitUpdate,
      cb = $$$hostConfig.insertBefore,
      db = $$$hostConfig.insertInContainerBefore,
      eb = $$$hostConfig.removeChild,
      fb = $$$hostConfig.removeChildFromContainer,
      gb = $$$hostConfig.resetTextContent,
      hb = $$$hostConfig.hideInstance,
      ib = $$$hostConfig.hideTextInstance,
      jb = $$$hostConfig.unhideInstance,
      kb = $$$hostConfig.unhideTextInstance,
      lb = $$$hostConfig.cloneInstance,
      mb = $$$hostConfig.createContainerChildSet,
      nb = $$$hostConfig.appendChildToContainerChildSet,
      ob = $$$hostConfig.finalizeContainerChildren,
      pb = $$$hostConfig.replaceContainerChildren,
      qb = $$$hostConfig.cloneHiddenInstance,
      rb = $$$hostConfig.cloneUnhiddenInstance,
      tb = $$$hostConfig.createHiddenTextInstance,
      ub = $$$hostConfig.canHydrateInstance,
      vb = $$$hostConfig.canHydrateTextInstance,
      wb = $$$hostConfig.getNextHydratableSibling,
      xb = $$$hostConfig.getFirstHydratableChild,
      yb = $$$hostConfig.hydrateInstance,
      zb = $$$hostConfig.hydrateTextInstance,
      Ab = /^(.*)[\\\/]/;
  function Bb(a) {
    var b = "";do {
      a: switch (a.tag) {case 2:case 16:case 0:case 1:case 5:case 8:case 13:
          var c = a._debugOwner,
              d = a._debugSource,
              e = va(a.type);var g = null;c && (g = va(c.type));c = e;e = "";d ? e = " (at " + d.fileName.replace(Ab, "") + ":" + d.lineNumber + ")" : g && (e = " (created by " + g + ")");g = "\n    in " + (c || "Unknown") + e;break a;default:
          g = "";}b += g;a = a.return;
    } while (a);return b;
  }new Set();var Cb = [],
      Db = -1;function x(a) {
    0 > Db || (a.current = Cb[Db], Cb[Db] = null, Db--);
  }function z(a, b) {
    Db++;Cb[Db] = a.current;a.current = b;
  }
  var Eb = {},
      A = { current: Eb },
      B = { current: !1 },
      Fb = Eb;function Gb(a, b) {
    var c = a.type.contextTypes;if (!c) return Eb;var d = a.stateNode;if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;var e = {},
        g;for (g in c) {
      e[g] = b[g];
    }d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);return e;
  }function C(a) {
    a = a.childContextTypes;return null !== a && void 0 !== a;
  }function Hb(a) {
    x(B, a);x(A, a);
  }
  function Ib(a) {
    x(B, a);x(A, a);
  }function Jb(a, b, c) {
    A.current !== Eb ? m("168") : void 0;z(A, b, a);z(B, c, a);
  }function Kb(a, b, c) {
    var d = a.stateNode;a = b.childContextTypes;if ("function" !== typeof d.getChildContext) return c;d = d.getChildContext();for (var e in d) {
      e in a ? void 0 : m("108", va(b) || "Unknown", e);
    }return aa({}, c, d);
  }function Lb(a) {
    var b = a.stateNode;b = b && b.__reactInternalMemoizedMergedChildContext || Eb;Fb = A.current;z(A, b, a);z(B, B.current, a);return !0;
  }
  function Mb(a, b, c) {
    var d = a.stateNode;d ? void 0 : m("169");c ? (b = Kb(a, b, Fb), d.__reactInternalMemoizedMergedChildContext = b, x(B, a), x(A, a), z(A, b, a)) : x(B, a);z(B, c, a);
  }var Nb = null,
      Ob = null;function Pb(a) {
    return function (b) {
      try {
        return a(b);
      } catch (c) {}
    };
  }
  function Qb(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;if (b.isDisabled || !b.supportsFiber) return !0;try {
      var c = b.inject(a);Nb = Pb(function (a) {
        return b.onCommitFiberRoot(c, a);
      });Ob = Pb(function (a) {
        return b.onCommitFiberUnmount(c, a);
      });
    } catch (d) {}return !0;
  }
  function Rb(a, b, c, d) {
    this.tag = a;this.key = c;this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;this.index = 0;this.ref = null;this.pendingProps = b;this.firstContextDependency = this.memoizedState = this.updateQueue = this.memoizedProps = null;this.mode = d;this.effectTag = 0;this.lastEffect = this.firstEffect = this.nextEffect = null;this.childExpirationTime = this.expirationTime = 0;this.alternate = null;
  }function D(a, b, c, d) {
    return new Rb(a, b, c, d);
  }
  function Sb(a) {
    a = a.prototype;return !(!a || !a.isReactComponent);
  }function Tb(a) {
    if ("function" === typeof a) return Sb(a) ? 1 : 0;if (void 0 !== a && null !== a) {
      a = a.$$typeof;if (a === oa) return 11;if (a === qa) return 14;
    }return 2;
  }
  function Ub(a, b) {
    var c = a.alternate;null === c ? (c = D(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.effectTag = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);c.childExpirationTime = a.childExpirationTime;c.expirationTime = a.expirationTime;c.child = a.child;c.memoizedProps = a.memoizedProps;c.memoizedState = a.memoizedState;c.updateQueue = a.updateQueue;c.firstContextDependency = a.firstContextDependency;c.sibling = a.sibling;
    c.index = a.index;c.ref = a.ref;return c;
  }
  function Vb(a, b, c, d, e, g) {
    var f = 2;d = a;if ("function" === typeof a) Sb(a) && (f = 1);else if ("string" === typeof a) f = 5;else a: switch (a) {case ia:
        return Wb(c.children, e, g, b);case na:
        return Xb(c, e | 3, g, b);case ja:
        return Xb(c, e | 2, g, b);case ka:
        return a = D(12, c, b, e | 4), a.elementType = ka, a.type = ka, a.expirationTime = g, a;case pa:
        return a = D(13, c, b, e), a.elementType = pa, a.type = pa, a.expirationTime = g, a;default:
        if ("object" === (typeof a === "undefined" ? "undefined" : _typeof(a)) && null !== a) switch (a.$$typeof) {case la:
            f = 10;break a;case ma:
            f = 9;break a;case oa:
            f = 11;break a;case qa:
            f = 14;break a;case ra:
            f = 16;d = null;break a;}m("130", null == a ? a : typeof a === "undefined" ? "undefined" : _typeof(a), "");}b = D(f, c, b, e);b.elementType = a;b.type = d;b.expirationTime = g;return b;
  }function Wb(a, b, c, d) {
    a = D(7, a, d, b);a.expirationTime = c;return a;
  }function Xb(a, b, c, d) {
    a = D(8, a, d, b);b = 0 === (b & 1) ? ja : na;a.elementType = b;a.type = b;a.expirationTime = c;return a;
  }function Yb(a, b, c) {
    a = D(6, a, null, b);a.expirationTime = c;return a;
  }
  function Zb(a, b, c) {
    b = D(4, null !== a.children ? a.children : [], a.key, b);b.expirationTime = c;b.stateNode = { containerInfo: a.containerInfo, pendingChildren: null, implementation: a.implementation };return b;
  }function $b(a, b) {
    a.didError = !1;var c = a.earliestPendingTime;0 === c ? a.earliestPendingTime = a.latestPendingTime = b : c < b ? a.earliestPendingTime = b : a.latestPendingTime > b && (a.latestPendingTime = b);ac(b, a);
  }
  function bc(a, b) {
    a.didError = !1;var c = a.latestPingedTime;0 !== c && c >= b && (a.latestPingedTime = 0);c = a.earliestPendingTime;var d = a.latestPendingTime;c === b ? a.earliestPendingTime = d === b ? a.latestPendingTime = 0 : d : d === b && (a.latestPendingTime = c);c = a.earliestSuspendedTime;d = a.latestSuspendedTime;0 === c ? a.earliestSuspendedTime = a.latestSuspendedTime = b : c < b ? a.earliestSuspendedTime = b : d > b && (a.latestSuspendedTime = b);ac(b, a);
  }
  function cc(a, b) {
    var c = a.earliestPendingTime;a = a.earliestSuspendedTime;c > b && (b = c);a > b && (b = a);return b;
  }function ac(a, b) {
    var c = b.earliestSuspendedTime,
        d = b.latestSuspendedTime,
        e = b.earliestPendingTime,
        g = b.latestPingedTime;e = 0 !== e ? e : g;0 === e && (0 === a || d < a) && (e = d);a = e;0 !== a && c > a && (a = c);b.nextExpirationTimeToWorkOn = e;b.expirationTime = a;
  }var ec = !1;
  function fc(a) {
    return { baseState: a, firstUpdate: null, lastUpdate: null, firstCapturedUpdate: null, lastCapturedUpdate: null, firstEffect: null, lastEffect: null, firstCapturedEffect: null, lastCapturedEffect: null };
  }function gc(a) {
    return { baseState: a.baseState, firstUpdate: a.firstUpdate, lastUpdate: a.lastUpdate, firstCapturedUpdate: null, lastCapturedUpdate: null, firstEffect: null, lastEffect: null, firstCapturedEffect: null, lastCapturedEffect: null };
  }
  function hc(a) {
    return { expirationTime: a, tag: 0, payload: null, callback: null, next: null, nextEffect: null };
  }function ic(a, b) {
    null === a.lastUpdate ? a.firstUpdate = a.lastUpdate = b : (a.lastUpdate.next = b, a.lastUpdate = b);
  }
  function E(a, b) {
    var c = a.alternate;if (null === c) {
      var d = a.updateQueue;var e = null;null === d && (d = a.updateQueue = fc(a.memoizedState));
    } else d = a.updateQueue, e = c.updateQueue, null === d ? null === e ? (d = a.updateQueue = fc(a.memoizedState), e = c.updateQueue = fc(c.memoizedState)) : d = a.updateQueue = gc(e) : null === e && (e = c.updateQueue = gc(d));null === e || d === e ? ic(d, b) : null === d.lastUpdate || null === e.lastUpdate ? (ic(d, b), ic(e, b)) : (ic(d, b), e.lastUpdate = b);
  }
  function jc(a, b) {
    var c = a.updateQueue;c = null === c ? a.updateQueue = fc(a.memoizedState) : kc(a, c);null === c.lastCapturedUpdate ? c.firstCapturedUpdate = c.lastCapturedUpdate = b : (c.lastCapturedUpdate.next = b, c.lastCapturedUpdate = b);
  }function kc(a, b) {
    var c = a.alternate;null !== c && b === c.updateQueue && (b = a.updateQueue = gc(b));return b;
  }
  function lc(a, b, c, d, e, g) {
    switch (c.tag) {case 1:
        return a = c.payload, "function" === typeof a ? a.call(g, d, e) : a;case 3:
        a.effectTag = a.effectTag & -2049 | 64;case 0:
        a = c.payload;e = "function" === typeof a ? a.call(g, d, e) : a;if (null === e || void 0 === e) break;return aa({}, d, e);case 2:
        ec = !0;}return d;
  }
  function mc(a, b, c, d, e) {
    ec = !1;b = kc(a, b);for (var g = b.baseState, f = null, l = 0, h = b.firstUpdate, k = g; null !== h;) {
      var p = h.expirationTime;p < e ? (null === f && (f = h, g = k), l < p && (l = p)) : (k = lc(a, b, h, k, c, d), null !== h.callback && (a.effectTag |= 32, h.nextEffect = null, null === b.lastEffect ? b.firstEffect = b.lastEffect = h : (b.lastEffect.nextEffect = h, b.lastEffect = h)));h = h.next;
    }p = null;for (h = b.firstCapturedUpdate; null !== h;) {
      var y = h.expirationTime;y < e ? (null === p && (p = h, null === f && (g = k)), l < y && (l = y)) : (k = lc(a, b, h, k, c, d), null !== h.callback && (a.effectTag |= 32, h.nextEffect = null, null === b.lastCapturedEffect ? b.firstCapturedEffect = b.lastCapturedEffect = h : (b.lastCapturedEffect.nextEffect = h, b.lastCapturedEffect = h)));h = h.next;
    }null === f && (b.lastUpdate = null);null === p ? b.lastCapturedUpdate = null : a.effectTag |= 32;null === f && null === p && (g = k);b.baseState = g;b.firstUpdate = f;b.firstCapturedUpdate = p;a.expirationTime = l;a.memoizedState = k;
  }
  function nc(a, b, c) {
    null !== b.firstCapturedUpdate && (null !== b.lastUpdate && (b.lastUpdate.next = b.firstCapturedUpdate, b.lastUpdate = b.lastCapturedUpdate), b.firstCapturedUpdate = b.lastCapturedUpdate = null);oc(b.firstEffect, c);b.firstEffect = b.lastEffect = null;oc(b.firstCapturedEffect, c);b.firstCapturedEffect = b.lastCapturedEffect = null;
  }function oc(a, b) {
    for (; null !== a;) {
      var c = a.callback;if (null !== c) {
        a.callback = null;var d = b;"function" !== typeof c ? m("191", c) : void 0;c.call(d);
      }a = a.nextEffect;
    }
  }
  function pc(a, b) {
    return { value: a, source: b, stack: Bb(b) };
  }var qc = { current: null },
      rc = null,
      sc = null,
      tc = null;function uc(a, b) {
    var c = a.type._context;Ua ? (z(qc, c._currentValue, a), c._currentValue = b) : (z(qc, c._currentValue2, a), c._currentValue2 = b);
  }function vc(a) {
    var b = qc.current;x(qc, a);a = a.type._context;Ua ? a._currentValue = b : a._currentValue2 = b;
  }function wc(a) {
    rc = a;tc = sc = null;a.firstContextDependency = null;
  }
  function xc(a, b) {
    if (tc !== a && !1 !== b && 0 !== b) {
      if ("number" !== typeof b || 1073741823 === b) tc = a, b = 1073741823;b = { context: a, observedBits: b, next: null };null === sc ? (null === rc ? m("293") : void 0, rc.firstContextDependency = sc = b) : sc = sc.next = b;
    }return Ua ? a._currentValue : a._currentValue2;
  }var yc = {},
      zc = { current: yc },
      Ac = { current: yc },
      Bc = { current: yc };function Cc(a) {
    a === yc ? m("174") : void 0;return a;
  }function Dc(a, b) {
    z(Bc, b, a);z(Ac, a, a);z(zc, yc, a);b = Ca(b);x(zc, a);z(zc, b, a);
  }function Ec(a) {
    x(zc, a);x(Ac, a);x(Bc, a);
  }
  function Fc() {
    return Cc(zc.current);
  }function Gc(a) {
    var b = Cc(Bc.current),
        c = Cc(zc.current);b = Da(c, a.type, b);c !== b && (z(Ac, a, a), z(zc, b, a));
  }function Hc(a) {
    Ac.current === a && (x(zc, a), x(Ac, a));
  }var Ic = Object.prototype.hasOwnProperty;function Jc(a, b) {
    return a === b ? 0 !== a || 0 !== b || 1 / a === 1 / b : a !== a && b !== b;
  }
  function Kc(a, b) {
    if (Jc(a, b)) return !0;if ("object" !== (typeof a === "undefined" ? "undefined" : _typeof(a)) || null === a || "object" !== (typeof b === "undefined" ? "undefined" : _typeof(b)) || null === b) return !1;var c = Object.keys(a),
        d = Object.keys(b);if (c.length !== d.length) return !1;for (d = 0; d < c.length; d++) {
      if (!Ic.call(b, c[d]) || !Jc(a[c[d]], b[c[d]])) return !1;
    }return !0;
  }function F(a, b) {
    if (a && a.defaultProps) {
      b = aa({}, b);a = a.defaultProps;for (var c in a) {
        void 0 === b[c] && (b[c] = a[c]);
      }
    }return b;
  }
  function Lc(a) {
    var b = a._result;switch (a._status) {case 1:
        return b;case 2:
        throw b;case 0:
        throw b;default:
        throw a._status = 0, b = a._ctor, b = b(), b.then(function (b) {
          0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function (b) {
          0 === a._status && (a._status = 2, a._result = b);
        }), a._result = b, b;}
  }var Mc = ea.ReactCurrentOwner,
      Nc = new ba.Component().refs;
  function Oc(a, b, c, d) {
    b = a.memoizedState;c = c(d, b);c = null === c || void 0 === c ? b : aa({}, b, c);a.memoizedState = c;d = a.updateQueue;null !== d && 0 === a.expirationTime && (d.baseState = c);
  }
  var Sc = { isMounted: function isMounted(a) {
      return (a = a._reactInternalFiber) ? 2 === wa(a) : !1;
    }, enqueueSetState: function enqueueSetState(a, b, c) {
      a = a._reactInternalFiber;var d = G();d = Pc(d, a);var e = hc(d);e.payload = b;void 0 !== c && null !== c && (e.callback = c);Qc();E(a, e);Rc(a, d);
    }, enqueueReplaceState: function enqueueReplaceState(a, b, c) {
      a = a._reactInternalFiber;var d = G();d = Pc(d, a);var e = hc(d);e.tag = 1;e.payload = b;void 0 !== c && null !== c && (e.callback = c);Qc();E(a, e);Rc(a, d);
    }, enqueueForceUpdate: function enqueueForceUpdate(a, b) {
      a = a._reactInternalFiber;var c = G();c = Pc(c, a);var d = hc(c);d.tag = 2;
      void 0 !== b && null !== b && (d.callback = b);Qc();E(a, d);Rc(a, c);
    } };function Tc(a, b, c, d, e, g, f) {
    a = a.stateNode;return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, g, f) : b.prototype && b.prototype.isPureReactComponent ? !Kc(c, d) || !Kc(e, g) : !0;
  }
  function Uc(a, b, c) {
    var d = !1,
        e = Eb;var g = b.contextType;"object" === (typeof g === "undefined" ? "undefined" : _typeof(g)) && null !== g ? g = Mc.currentDispatcher.readContext(g) : (e = C(b) ? Fb : A.current, d = b.contextTypes, g = (d = null !== d && void 0 !== d) ? Gb(a, e) : Eb);b = new b(c, g);a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;b.updater = Sc;a.stateNode = b;b._reactInternalFiber = a;d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = g);return b;
  }
  function Vc(a, b, c, d) {
    a = b.state;"function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);"function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);b.state !== a && Sc.enqueueReplaceState(b, b.state, null);
  }
  function Wc(a, b, c, d) {
    var e = a.stateNode;e.props = c;e.state = a.memoizedState;e.refs = Nc;var g = b.contextType;"object" === (typeof g === "undefined" ? "undefined" : _typeof(g)) && null !== g ? e.context = Mc.currentDispatcher.readContext(g) : (g = C(b) ? Fb : A.current, e.context = Gb(a, g));g = a.updateQueue;null !== g && (mc(a, g, c, e, d), e.state = a.memoizedState);g = b.getDerivedStateFromProps;"function" === typeof g && (Oc(a, b, g, c), e.state = a.memoizedState);"function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Sc.enqueueReplaceState(e, e.state, null), g = a.updateQueue, null !== g && (mc(a, g, c, e, d), e.state = a.memoizedState));"function" === typeof e.componentDidMount && (a.effectTag |= 4);
  }var Xc = Array.isArray;
  function Yc(a, b, c) {
    a = c.ref;if (null !== a && "function" !== typeof a && "object" !== (typeof a === "undefined" ? "undefined" : _typeof(a))) {
      if (c._owner) {
        c = c._owner;var d = void 0;c && (1 !== c.tag ? m("289") : void 0, d = c.stateNode);d ? void 0 : m("147", a);var e = "" + a;if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;b = function b(_b) {
          var a = d.refs;a === Nc && (a = d.refs = {});null === _b ? delete a[e] : a[e] = _b;
        };b._stringRef = e;return b;
      }"string" !== typeof a ? m("284") : void 0;c._owner ? void 0 : m("290", a);
    }return a;
  }
  function Zc(a, b) {
    "textarea" !== a.type && m("31", "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, "");
  }
  function $c(a) {
    function b(b, c) {
      if (a) {
        var d = b.lastEffect;null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;c.nextEffect = null;c.effectTag = 8;
      }
    }function c(c, d) {
      if (!a) return null;for (; null !== d;) {
        b(c, d), d = d.sibling;
      }return null;
    }function d(b, a) {
      for (b = new Map(); null !== a;) {
        null !== a.key ? b.set(a.key, a) : b.set(a.index, a), a = a.sibling;
      }return b;
    }function e(b, a, c) {
      b = Ub(b, a, c);b.index = 0;b.sibling = null;return b;
    }function g(b, c, d) {
      b.index = d;if (!a) return c;d = b.alternate;if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;b.effectTag = 2;return c;
    }function f(b) {
      a && null === b.alternate && (b.effectTag = 2);return b;
    }function l(b, a, c, d) {
      if (null === a || 6 !== a.tag) return a = Yb(c, b.mode, d), a.return = b, a;a = e(a, c, d);a.return = b;return a;
    }function h(b, a, c, d) {
      if (null !== a && a.elementType === c.type) return d = e(a, c.props, d), d.ref = Yc(b, a, c), d.return = b, d;d = Vb(c.type, c.key, c.props, null, b.mode, d);d.ref = Yc(b, a, c);d.return = b;return d;
    }function k(b, a, c, d) {
      if (null === a || 4 !== a.tag || a.stateNode.containerInfo !== c.containerInfo || a.stateNode.implementation !== c.implementation) return a = Zb(c, b.mode, d), a.return = b, a;a = e(a, c.children || [], d);a.return = b;return a;
    }function p(b, a, c, d, f) {
      if (null === a || 7 !== a.tag) return a = Wb(c, b.mode, d, f), a.return = b, a;a = e(a, c, d);a.return = b;return a;
    }function y(b, a, c) {
      if ("string" === typeof a || "number" === typeof a) return a = Yb("" + a, b.mode, c), a.return = b, a;if ("object" === (typeof a === "undefined" ? "undefined" : _typeof(a)) && null !== a) {
        switch (a.$$typeof) {case fa:
            return c = Vb(a.type, a.key, a.props, null, b.mode, c), c.ref = Yc(b, null, a), c.return = b, c;case ha:
            return a = Zb(a, b.mode, c), a.return = b, a;}if (Xc(a) || ua(a)) return a = Wb(a, b.mode, c, null), a.return = b, a;Zc(b, a);
      }return null;
    }function v(b, a, c, d) {
      var e = null !== a ? a.key : null;if ("string" === typeof c || "number" === typeof c) return null !== e ? null : l(b, a, "" + c, d);if ("object" === (typeof c === "undefined" ? "undefined" : _typeof(c)) && null !== c) {
        switch (c.$$typeof) {case fa:
            return c.key === e ? c.type === ia ? p(b, a, c.props.children, d, e) : h(b, a, c, d) : null;case ha:
            return c.key === e ? k(b, a, c, d) : null;}if (Xc(c) || ua(c)) return null !== e ? null : p(b, a, c, d, null);Zc(b, c);
      }return null;
    }function u(b, a, c, d, e) {
      if ("string" === typeof d || "number" === typeof d) return b = b.get(c) || null, l(a, b, "" + d, e);if ("object" === (typeof d === "undefined" ? "undefined" : _typeof(d)) && null !== d) {
        switch (d.$$typeof) {case fa:
            return b = b.get(null === d.key ? c : d.key) || null, d.type === ia ? p(a, b, d.props.children, e, d.key) : h(a, b, d, e);case ha:
            return b = b.get(null === d.key ? c : d.key) || null, k(a, b, d, e);}if (Xc(d) || ua(d)) return b = b.get(c) || null, p(a, b, d, e, null);Zc(a, d);
      }return null;
    }function J(e, f, h, l) {
      for (var k = null, w = null, q = f, t = f = 0, p = null; null !== q && t < h.length; t++) {
        q.index > t ? (p = q, q = null) : p = q.sibling;var r = v(e, q, h[t], l);if (null === r) {
          null === q && (q = p);break;
        }a && q && null === r.alternate && b(e, q);f = g(r, f, t);null === w ? k = r : w.sibling = r;w = r;q = p;
      }if (t === h.length) return c(e, q), k;if (null === q) {
        for (; t < h.length; t++) {
          if (q = y(e, h[t], l)) f = g(q, f, t), null === w ? k = q : w.sibling = q, w = q;
        }return k;
      }for (q = d(e, q); t < h.length; t++) {
        if (p = u(q, e, t, h[t], l)) a && null !== p.alternate && q.delete(null === p.key ? t : p.key), f = g(p, f, t), null === w ? k = p : w.sibling = p, w = p;
      }a && q.forEach(function (a) {
        return b(e, a);
      });return k;
    }function ta(e, f, h, l) {
      var k = ua(h);"function" !== typeof k ? m("150") : void 0;h = k.call(h);null == h ? m("151") : void 0;
      for (var q = k = null, t = f, w = f = 0, p = null, r = h.next(); null !== t && !r.done; w++, r = h.next()) {
        t.index > w ? (p = t, t = null) : p = t.sibling;var U = v(e, t, r.value, l);if (null === U) {
          t || (t = p);break;
        }a && t && null === U.alternate && b(e, t);f = g(U, f, w);null === q ? k = U : q.sibling = U;q = U;t = p;
      }if (r.done) return c(e, t), k;if (null === t) {
        for (; !r.done; w++, r = h.next()) {
          r = y(e, r.value, l), null !== r && (f = g(r, f, w), null === q ? k = r : q.sibling = r, q = r);
        }return k;
      }for (t = d(e, t); !r.done; w++, r = h.next()) {
        r = u(t, e, w, r.value, l), null !== r && (a && null !== r.alternate && t.delete(null === r.key ? w : r.key), f = g(r, f, w), null === q ? k = r : q.sibling = r, q = r);
      }a && t.forEach(function (a) {
        return b(e, a);
      });return k;
    }return function (a, d, g, h) {
      var k = "object" === (typeof g === "undefined" ? "undefined" : _typeof(g)) && null !== g && g.type === ia && null === g.key;k && (g = g.props.children);var l = "object" === (typeof g === "undefined" ? "undefined" : _typeof(g)) && null !== g;if (l) switch (g.$$typeof) {case fa:
          a: {
            l = g.key;for (k = d; null !== k;) {
              if (k.key === l) {
                if (7 === k.tag ? g.type === ia : k.elementType === g.type) {
                  c(a, k.sibling);d = e(k, g.type === ia ? g.props.children : g.props, h);d.ref = Yc(a, k, g);d.return = a;a = d;break a;
                } else {
                  c(a, k);break;
                }
              } else b(a, k);k = k.sibling;
            }g.type === ia ? (d = Wb(g.props.children, a.mode, h, g.key), d.return = a, a = d) : (h = Vb(g.type, g.key, g.props, null, a.mode, h), h.ref = Yc(a, d, g), h.return = a, a = h);
          }return f(a);case ha:
          a: {
            for (k = g.key; null !== d;) {
              if (d.key === k) {
                if (4 === d.tag && d.stateNode.containerInfo === g.containerInfo && d.stateNode.implementation === g.implementation) {
                  c(a, d.sibling);d = e(d, g.children || [], h);d.return = a;a = d;break a;
                } else {
                  c(a, d);break;
                }
              } else b(a, d);d = d.sibling;
            }d = Zb(g, a.mode, h);d.return = a;a = d;
          }return f(a);}if ("string" === typeof g || "number" === typeof g) return g = "" + g, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, g, h), d.return = a, a = d) : (c(a, d), d = Yb(g, a.mode, h), d.return = a, a = d), f(a);if (Xc(g)) return J(a, d, g, h);if (ua(g)) return ta(a, d, g, h);l && Zc(a, g);if ("undefined" === typeof g && !k) switch (a.tag) {case 1:case 0:
          h = a.type, m("152", h.displayName || h.name || "Component");}return c(a, d);
    };
  }var ad = $c(!0),
      bd = $c(!1),
      H = null,
      cd = null,
      dd = !1;
  function ed(a, b) {
    var c = D(5, null, null, 0);c.elementType = "DELETED";c.type = "DELETED";c.stateNode = b;c.return = a;c.effectTag = 8;null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
  }function fd(a, b) {
    switch (a.tag) {case 5:
        return b = ub(b, a.type, a.pendingProps), null !== b ? (a.stateNode = b, !0) : !1;case 6:
        return b = vb(b, a.pendingProps), null !== b ? (a.stateNode = b, !0) : !1;default:
        return !1;}
  }
  function id(a) {
    if (dd) {
      var b = cd;if (b) {
        var c = b;if (!fd(a, b)) {
          b = wb(c);if (!b || !fd(a, b)) {
            a.effectTag |= 2;dd = !1;H = a;return;
          }ed(H, c);
        }H = a;cd = xb(b);
      } else a.effectTag |= 2, dd = !1, H = a;
    }
  }function jd(a) {
    for (a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag;) {
      a = a.return;
    }H = a;
  }function kd(a) {
    if (!Xa || a !== H) return !1;if (!dd) return jd(a), dd = !0, !1;var b = a.type;if (5 !== a.tag || "head" !== b && "body" !== b && !Ka(b, a.memoizedProps)) for (b = cd; b;) {
      ed(a, b), b = wb(b);
    }jd(a);cd = H ? wb(a.stateNode) : null;return !0;
  }function ld() {
    Xa && (cd = H = null, dd = !1);
  }var md = ea.ReactCurrentOwner;
  function I(a, b, c, d) {
    b.child = null === a ? bd(b, null, c, d) : ad(b, a.child, c, d);
  }function nd(a, b, c, d, e) {
    c = c.render;var g = b.ref;wc(b, e);d = c(d, g);b.effectTag |= 1;I(a, b, d, e);return b.child;
  }
  function od(a, b, c, d, e, g) {
    if (null === a) {
      var f = c.type;if ("function" === typeof f && !Sb(f) && void 0 === f.defaultProps && null === c.compare) return b.tag = 15, b.type = f, pd(a, b, f, d, e, g);a = Vb(c.type, null, d, null, b.mode, g);a.ref = b.ref;a.return = b;return b.child = a;
    }f = a.child;if (e < g && (e = f.memoizedProps, c = c.compare, c = null !== c ? c : Kc, c(e, d) && a.ref === b.ref)) return qd(a, b, g);b.effectTag |= 1;a = Ub(f, d, g);a.ref = b.ref;a.return = b;return b.child = a;
  }
  function pd(a, b, c, d, e, g) {
    return null !== a && e < g && Kc(a.memoizedProps, d) && a.ref === b.ref ? qd(a, b, g) : rd(a, b, c, d, g);
  }function sd(a, b) {
    var c = b.ref;if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
  }function rd(a, b, c, d, e) {
    var g = C(c) ? Fb : A.current;g = Gb(b, g);wc(b, e);c = c(d, g);b.effectTag |= 1;I(a, b, c, e);return b.child;
  }
  function td(a, b, c, d, e) {
    if (C(c)) {
      var g = !0;Lb(b);
    } else g = !1;wc(b, e);if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), Uc(b, c, d, e), Wc(b, c, d, e), d = !0;else if (null === a) {
      var f = b.stateNode,
          l = b.memoizedProps;f.props = l;var h = f.context,
          k = c.contextType;"object" === (typeof k === "undefined" ? "undefined" : _typeof(k)) && null !== k ? k = Mc.currentDispatcher.readContext(k) : (k = C(c) ? Fb : A.current, k = Gb(b, k));var p = c.getDerivedStateFromProps,
          y = "function" === typeof p || "function" === typeof f.getSnapshotBeforeUpdate;y || "function" !== typeof f.UNSAFE_componentWillReceiveProps && "function" !== typeof f.componentWillReceiveProps || (l !== d || h !== k) && Vc(b, f, d, k);ec = !1;var v = b.memoizedState;h = f.state = v;var u = b.updateQueue;null !== u && (mc(b, u, d, f, e), h = b.memoizedState);l !== d || v !== h || B.current || ec ? ("function" === typeof p && (Oc(b, c, p, d), h = b.memoizedState), (l = ec || Tc(b, c, l, d, v, h, k)) ? (y || "function" !== typeof f.UNSAFE_componentWillMount && "function" !== typeof f.componentWillMount || ("function" === typeof f.componentWillMount && f.componentWillMount(), "function" === typeof f.UNSAFE_componentWillMount && f.UNSAFE_componentWillMount()), "function" === typeof f.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof f.componentDidMount && (b.effectTag |= 4), b.memoizedProps = d, b.memoizedState = h), f.props = d, f.state = h, f.context = k, d = l) : ("function" === typeof f.componentDidMount && (b.effectTag |= 4), d = !1);
    } else f = b.stateNode, l = b.memoizedProps, f.props = b.type === b.elementType ? l : F(b.type, l), h = f.context, k = c.contextType, "object" === (typeof k === "undefined" ? "undefined" : _typeof(k)) && null !== k ? k = Mc.currentDispatcher.readContext(k) : (k = C(c) ? Fb : A.current, k = Gb(b, k)), p = c.getDerivedStateFromProps, (y = "function" === typeof p || "function" === typeof f.getSnapshotBeforeUpdate) || "function" !== typeof f.UNSAFE_componentWillReceiveProps && "function" !== typeof f.componentWillReceiveProps || (l !== d || h !== k) && Vc(b, f, d, k), ec = !1, h = b.memoizedState, v = f.state = h, u = b.updateQueue, null !== u && (mc(b, u, d, f, e), v = b.memoizedState), l !== d || h !== v || B.current || ec ? ("function" === typeof p && (Oc(b, c, p, d), v = b.memoizedState), (p = ec || Tc(b, c, l, d, h, v, k)) ? (y || "function" !== typeof f.UNSAFE_componentWillUpdate && "function" !== typeof f.componentWillUpdate || ("function" === typeof f.componentWillUpdate && f.componentWillUpdate(d, v, k), "function" === typeof f.UNSAFE_componentWillUpdate && f.UNSAFE_componentWillUpdate(d, v, k)), "function" === typeof f.componentDidUpdate && (b.effectTag |= 4), "function" === typeof f.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof f.componentDidUpdate || l === a.memoizedProps && h === a.memoizedState || (b.effectTag |= 4), "function" !== typeof f.getSnapshotBeforeUpdate || l === a.memoizedProps && h === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = d, b.memoizedState = v), f.props = d, f.state = v, f.context = k, d = p) : ("function" !== typeof f.componentDidUpdate || l === a.memoizedProps && h === a.memoizedState || (b.effectTag |= 4), "function" !== typeof f.getSnapshotBeforeUpdate || l === a.memoizedProps && h === a.memoizedState || (b.effectTag |= 256), d = !1);return ud(a, b, c, d, g, e);
  }
  function ud(a, b, c, d, e, g) {
    sd(a, b);var f = 0 !== (b.effectTag & 64);if (!d && !f) return e && Mb(b, c, !1), qd(a, b, g);d = b.stateNode;md.current = b;var l = f && "function" !== typeof c.getDerivedStateFromError ? null : d.render();b.effectTag |= 1;null !== a && f ? (b.child = ad(b, a.child, null, g), b.child = ad(b, null, l, g)) : I(a, b, l, g);b.memoizedState = d.state;e && Mb(b, c, !0);return b.child;
  }function vd(a) {
    var b = a.stateNode;b.pendingContext ? Jb(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Jb(a, b.context, !1);Dc(a, b.containerInfo);
  }
  function wd(a, b, c) {
    var d = b.mode,
        e = b.pendingProps,
        g = b.memoizedState;if (0 === (b.effectTag & 64)) {
      g = null;var f = !1;
    } else g = { timedOutAt: null !== g ? g.timedOutAt : 0 }, f = !0, b.effectTag &= -65;null === a ? f ? (f = e.fallback, e = Wb(null, d, 0, null), 0 === (b.mode & 1) && (e.child = null !== b.memoizedState ? b.child.child : b.child), d = Wb(f, d, c, null), e.sibling = d, c = e, c.return = d.return = b) : c = d = bd(b, null, e.children, c) : null !== a.memoizedState ? (d = a.child, a = d.sibling, f ? (c = e.fallback, e = Ub(d, d.pendingProps, 0), 0 === (b.mode & 1) && (f = null !== b.memoizedState ? b.child.child : b.child, f !== d.child && (e.child = f)), d = e.sibling = Ub(a, c, a.expirationTime), c = e, e.childExpirationTime = 0, c.return = d.return = b) : c = d = ad(b, d.child, e.children, c)) : (a = a.child, f ? (f = e.fallback, e = Wb(null, d, 0, null), e.child = a, 0 === (b.mode & 1) && (e.child = null !== b.memoizedState ? b.child.child : b.child), d = e.sibling = Wb(f, d, c, null), d.effectTag |= 2, c = e, e.childExpirationTime = 0, c.return = d.return = b) : d = c = ad(b, a, e.children, c));b.memoizedState = g;b.child = c;return d;
  }
  function qd(a, b, c) {
    null !== a && (b.firstContextDependency = a.firstContextDependency);if (b.childExpirationTime < c) return null;null !== a && b.child !== a.child ? m("153") : void 0;if (null !== b.child) {
      a = b.child;c = Ub(a, a.pendingProps, a.expirationTime);b.child = c;for (c.return = b; null !== a.sibling;) {
        a = a.sibling, c = c.sibling = Ub(a, a.pendingProps, a.expirationTime), c.return = b;
      }c.sibling = null;
    }return b.child;
  }
  function xd(a, b, c) {
    var d = b.expirationTime;if (null !== a && a.memoizedProps === b.pendingProps && !B.current && d < c) {
      switch (b.tag) {case 3:
          vd(b);ld();break;case 5:
          Gc(b);break;case 1:
          C(b.type) && Lb(b);break;case 4:
          Dc(b, b.stateNode.containerInfo);break;case 10:
          uc(b, b.memoizedProps.value);break;case 13:
          if (null !== b.memoizedState) {
            d = b.child.childExpirationTime;if (0 !== d && d >= c) return wd(a, b, c);b = qd(a, b, c);return null !== b ? b.sibling : null;
          }}return qd(a, b, c);
    }b.expirationTime = 0;switch (b.tag) {case 2:
        d = b.elementType;null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);a = b.pendingProps;var e = Gb(b, A.current);wc(b, c);e = d(a, e);b.effectTag |= 1;if ("object" === (typeof e === "undefined" ? "undefined" : _typeof(e)) && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
          b.tag = 1;if (C(d)) {
            var g = !0;Lb(b);
          } else g = !1;b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;var f = d.getDerivedStateFromProps;"function" === typeof f && Oc(b, d, f, a);e.updater = Sc;b.stateNode = e;e._reactInternalFiber = b;Wc(b, d, a, c);b = ud(null, b, d, !0, g, c);
        } else b.tag = 0, I(null, b, e, c), b = b.child;
        return b;case 16:
        e = b.elementType;null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);g = b.pendingProps;a = Lc(e);b.type = a;e = b.tag = Tb(a);g = F(a, g);f = void 0;switch (e) {case 0:
            f = rd(null, b, a, g, c);break;case 1:
            f = td(null, b, a, g, c);break;case 11:
            f = nd(null, b, a, g, c);break;case 14:
            f = od(null, b, a, F(a.type, g), d, c);break;default:
            m("283", a);}return f;case 0:
        return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : F(d, e), rd(a, b, d, e, c);case 1:
        return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : F(d, e), td(a, b, d, e, c);case 3:
        vd(b);d = b.updateQueue;null === d ? m("282") : void 0;e = b.memoizedState;e = null !== e ? e.element : null;mc(b, d, b.pendingProps, null, c);d = b.memoizedState.element;if (d === e) ld(), b = qd(a, b, c);else {
          e = b.stateNode;if (e = (null === a || null === a.child) && e.hydrate) Xa ? (cd = xb(b.stateNode.containerInfo), H = b, e = dd = !0) : e = !1;e ? (b.effectTag |= 2, b.child = bd(b, null, d, c)) : (I(a, b, d, c), ld());b = b.child;
        }return b;case 5:
        return Gc(b), null === a && id(b), d = b.type, e = b.pendingProps, g = null !== a ? a.memoizedProps : null, f = e.children, Ka(d, e) ? f = null : null !== g && Ka(d, g) && (b.effectTag |= 16), sd(a, b), 1 !== c && b.mode & 1 && La(d, e) ? (b.expirationTime = 1, b = null) : (I(a, b, f, c), b = b.child), b;case 6:
        return null === a && id(b), null;case 13:
        return wd(a, b, c);case 4:
        return Dc(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = ad(b, null, d, c) : I(a, b, d, c), b.child;case 11:
        return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : F(d, e), nd(a, b, d, e, c);case 7:
        return I(a, b, b.pendingProps, c), b.child;case 8:
        return I(a, b, b.pendingProps.children, c), b.child;case 12:
        return I(a, b, b.pendingProps.children, c), b.child;case 10:
        a: {
          d = b.type._context;e = b.pendingProps;f = b.memoizedProps;g = e.value;uc(b, g);if (null !== f) {
            var l = f.value;g = l === g && (0 !== l || 1 / l === 1 / g) || l !== l && g !== g ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(l, g) : 1073741823) | 0;if (0 === g) {
              if (f.children === e.children && !B.current) {
                b = qd(a, b, c);break a;
              }
            } else for (f = b.child, null !== f && (f.return = b); null !== f;) {
              l = f.firstContextDependency;if (null !== l) {
                do {
                  if (l.context === d && 0 !== (l.observedBits & g)) {
                    if (1 === f.tag) {
                      var h = hc(c);h.tag = 2;E(f, h);
                    }f.expirationTime < c && (f.expirationTime = c);h = f.alternate;null !== h && h.expirationTime < c && (h.expirationTime = c);for (var k = f.return; null !== k;) {
                      h = k.alternate;if (k.childExpirationTime < c) k.childExpirationTime = c, null !== h && h.childExpirationTime < c && (h.childExpirationTime = c);else if (null !== h && h.childExpirationTime < c) h.childExpirationTime = c;else break;k = k.return;
                    }
                  }h = f.child;l = l.next;
                } while (null !== l);
              } else h = 10 === f.tag ? f.type === b.type ? null : f.child : f.child;if (null !== h) h.return = f;else for (h = f; null !== h;) {
                if (h === b) {
                  h = null;break;
                }f = h.sibling;if (null !== f) {
                  f.return = h.return;h = f;break;
                }h = h.return;
              }f = h;
            }
          }I(a, b, e.children, c);b = b.child;
        }return b;case 9:
        return e = b.type, g = b.pendingProps, d = g.children, wc(b, c), e = xc(e, g.unstable_observedBits), d = d(e), b.effectTag |= 1, I(a, b, d, c), b.child;case 14:
        return e = b.type, g = F(e.type, b.pendingProps), od(a, b, e, g, d, c);case 15:
        return pd(a, b, b.type, b.pendingProps, d, c);case 17:
        return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : F(d, e), null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), b.tag = 1, C(d) ? (a = !0, Lb(b)) : a = !1, wc(b, c), Uc(b, d, e, c), Wc(b, d, e, c), ud(null, b, d, !0, a, c);default:
        m("156");}
  }function K(a) {
    a.effectTag |= 4;
  }var _yd = void 0,
      zd = void 0,
      Ad = void 0,
      Bd = void 0;
  if (Va) _yd = function yd(a, b) {
    for (var c = b.child; null !== c;) {
      if (5 === c.tag || 6 === c.tag) Ha(a, c.stateNode);else if (4 !== c.tag && null !== c.child) {
        c.child.return = c;c = c.child;continue;
      }if (c === b) break;for (; null === c.sibling;) {
        if (null === c.return || c.return === b) return;c = c.return;
      }c.sibling.return = c.return;c = c.sibling;
    }
  }, zd = function zd() {}, Ad = function Ad(a, b, c, d, e) {
    a = a.memoizedProps;if (a !== d) {
      var g = b.stateNode,
          f = Fc();c = Ja(g, c, a, d, e, f);(b.updateQueue = c) && K(b);
    }
  }, Bd = function Bd(a, b, c, d) {
    c !== d && K(b);
  };else if (Wa) {
    _yd = function yd(a, b, c, d) {
      for (var e = b.child; null !== e;) {
        a: if (5 === e.tag) {
          var g = e.stateNode;if (c) {
            var f = e.memoizedProps,
                l = e.type;g = d ? qb(g, l, f, e) : rb(g, l, f, e);e.stateNode = g;
          }Ha(a, g);
        } else if (6 === e.tag) g = e.stateNode, c && (g = e.memoizedProps, f = Cc(Bc.current), l = Fc(), g = d ? tb(g, f, l, b) : Ma(g, f, l, b), e.stateNode = g), Ha(a, g);else if (4 !== e.tag) {
          if (13 === e.tag && (f = e.alternate, null !== f && (g = null !== e.memoizedState, null !== f.memoizedState !== g))) {
            f = g ? e.child : e;null !== f && _yd(a, f, !0, g);break a;
          }if (null !== e.child) {
            e.child.return = e;e = e.child;continue;
          }
        }if (e === b) break;for (; null === e.sibling;) {
          if (null === e.return || e.return === b) return;e = e.return;
        }e.sibling.return = e.return;e = e.sibling;
      }
    };var Cd = function Cd(a, b, c, d) {
      for (var e = b.child; null !== e;) {
        a: if (5 === e.tag) {
          var g = e.stateNode;if (c) {
            var f = e.memoizedProps,
                l = e.type;g = d ? qb(g, l, f, e) : rb(g, l, f, e);e.stateNode = g;
          }nb(a, g);
        } else if (6 === e.tag) g = e.stateNode, c && (g = e.memoizedProps, f = Cc(Bc.current), l = Fc(), g = d ? tb(g, f, l, b) : Ma(g, f, l, b), e.stateNode = g), nb(a, g);else if (4 !== e.tag) {
          if (13 === e.tag && (f = e.alternate, null !== f && (g = null !== e.memoizedState, null !== f.memoizedState !== g))) {
            f = g ? e.child : e;null !== f && Cd(a, f, !0, g);break a;
          }if (null !== e.child) {
            e.child.return = e;e = e.child;continue;
          }
        }if (e === b) break;for (; null === e.sibling;) {
          if (null === e.return || e.return === b) return;e = e.return;
        }e.sibling.return = e.return;e = e.sibling;
      }
    };zd = function zd(a) {
      var b = a.stateNode;if (null !== a.firstEffect) {
        var c = b.containerInfo,
            d = mb(c);Cd(d, a, !1, !1);b.pendingChildren = d;K(a);ob(c, d);
      }
    };Ad = function Ad(a, b, c, d, e) {
      var g = a.stateNode,
          f = a.memoizedProps;if ((a = null === b.firstEffect) && f === d) b.stateNode = g;else {
        var l = b.stateNode,
            h = Fc(),
            k = null;f !== d && (k = Ja(l, c, f, d, e, h));a && null === k ? b.stateNode = g : (g = lb(g, k, c, f, d, b, a, l), Ia(g, c, d, e, h) && K(b), b.stateNode = g, a ? K(b) : _yd(g, b, !1, !1));
      }
    };Bd = function Bd(a, b, c, d) {
      c !== d && (a = Cc(Bc.current), c = Fc(), b.stateNode = Ma(d, a, c, b), K(b));
    };
  } else zd = function zd() {}, Ad = function Ad() {}, Bd = function Bd() {};function Dd(a, b) {
    var c = b.source,
        d = b.stack;null === d && null !== c && (d = Bb(c));null !== c && va(c.type);b = b.value;null !== a && 1 === a.tag && va(a.type);try {
      console.error(b);
    } catch (e) {
      setTimeout(function () {
        throw e;
      });
    }
  }
  function Ed(a) {
    var b = a.ref;if (null !== b) if ("function" === typeof b) try {
      b(null);
    } catch (c) {
      Fd(a, c);
    } else b.current = null;
  }
  function Gd(a) {
    "function" === typeof Ob && Ob(a);switch (a.tag) {case 0:case 11:case 14:case 15:
        var b = a.updateQueue;if (null !== b && (b = b.lastEffect, null !== b)) {
          var c = b = b.next;do {
            var d = c.destroy;if (null !== d) {
              var e = a;try {
                d();
              } catch (g) {
                Fd(e, g);
              }
            }c = c.next;
          } while (c !== b);
        }break;case 1:
        Ed(a);b = a.stateNode;if ("function" === typeof b.componentWillUnmount) try {
          b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
        } catch (g) {
          Fd(a, g);
        }break;case 5:
        Ed(a);break;case 4:
        Va ? Hd(a) : Wa && Wa && (a = a.stateNode.containerInfo, b = mb(a), pb(a, b));}
  }function Id(a) {
    for (var b = a;;) {
      if (Gd(b), null === b.child || Va && 4 === b.tag) {
        if (b === a) break;for (; null === b.sibling;) {
          if (null === b.return || b.return === a) return;b = b.return;
        }b.sibling.return = b.return;b = b.sibling;
      } else b.child.return = b, b = b.child;
    }
  }function Jd(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
  }
  function Kd(a) {
    if (Va) {
      a: {
        for (var b = a.return; null !== b;) {
          if (Jd(b)) {
            var c = b;break a;
          }b = b.return;
        }m("160");c = void 0;
      }var d = b = void 0;switch (c.tag) {case 5:
          b = c.stateNode;d = !1;break;case 3:
          b = c.stateNode.containerInfo;d = !0;break;case 4:
          b = c.stateNode.containerInfo;d = !0;break;default:
          m("161");}c.effectTag & 16 && (gb(b), c.effectTag &= -17);a: b: for (c = a;;) {
        for (; null === c.sibling;) {
          if (null === c.return || Jd(c.return)) {
            c = null;break a;
          }c = c.return;
        }c.sibling.return = c.return;for (c = c.sibling; 5 !== c.tag && 6 !== c.tag;) {
          if (c.effectTag & 2) continue b;
          if (null === c.child || 4 === c.tag) continue b;else c.child.return = c, c = c.child;
        }if (!(c.effectTag & 2)) {
          c = c.stateNode;break a;
        }
      }for (var e = a;;) {
        if (5 === e.tag || 6 === e.tag) c ? d ? db(b, e.stateNode, c) : cb(b, e.stateNode, c) : d ? Za(b, e.stateNode) : Ya(b, e.stateNode);else if (4 !== e.tag && null !== e.child) {
          e.child.return = e;e = e.child;continue;
        }if (e === a) break;for (; null === e.sibling;) {
          if (null === e.return || e.return === a) return;e = e.return;
        }e.sibling.return = e.return;e = e.sibling;
      }
    }
  }
  function Hd(a) {
    for (var b = a, c = !1, d = void 0, e = void 0;;) {
      if (!c) {
        c = b.return;a: for (;;) {
          null === c ? m("160") : void 0;switch (c.tag) {case 5:
              d = c.stateNode;e = !1;break a;case 3:
              d = c.stateNode.containerInfo;e = !0;break a;case 4:
              d = c.stateNode.containerInfo;e = !0;break a;}c = c.return;
        }c = !0;
      }if (5 === b.tag || 6 === b.tag) Id(b), e ? fb(d, b.stateNode) : eb(d, b.stateNode);else if (4 === b.tag ? (d = b.stateNode.containerInfo, e = !0) : Gd(b), null !== b.child) {
        b.child.return = b;b = b.child;continue;
      }if (b === a) break;for (; null === b.sibling;) {
        if (null === b.return || b.return === a) return;b = b.return;4 === b.tag && (c = !1);
      }b.sibling.return = b.return;b = b.sibling;
    }
  }
  function Ld(a, b) {
    if (Va) switch (b.tag) {case 0:case 11:case 14:case 15:
        break;case 1:
        break;case 5:
        var c = b.stateNode;if (null != c) {
          var d = b.memoizedProps;a = null !== a ? a.memoizedProps : d;var e = b.type,
              g = b.updateQueue;b.updateQueue = null;null !== g && bb(c, g, e, a, d, b);
        }break;case 6:
        null === b.stateNode ? m("162") : void 0;c = b.memoizedProps;$a(b.stateNode, null !== a ? a.memoizedProps : c, c);break;case 3:
        break;case 12:
        break;case 13:
        d = b.memoizedState;a = b;null === d ? c = !1 : (c = !0, a = b.child, 0 === d.timedOutAt && (d.timedOutAt = G()));if (null !== a) a: if (b = a, Va) for (d = b;;) {
          if (5 === d.tag) a = d.stateNode, c ? hb(a) : jb(d.stateNode, d.memoizedProps);else if (6 === d.tag) a = d.stateNode, c ? ib(a) : kb(a, d.memoizedProps);else if (13 === d.tag && null !== d.memoizedState) {
            a = d.child.sibling;a.return = d;d = a;continue;
          } else if (null !== d.child) {
            d.child.return = d;d = d.child;continue;
          }if (d === b) break a;for (; null === d.sibling;) {
            if (null === d.return || d.return === b) break a;d = d.return;
          }d.sibling.return = d.return;d = d.sibling;
        }break;case 17:
        break;default:
        m("163");} else {
      switch (b.tag) {case 0:case 11:case 14:case 15:
          return;}if (Wa) switch (b.tag) {case 1:
          break;
        case 5:
          break;case 6:
          break;case 3:case 4:
          b = b.stateNode;pb(b.containerInfo, b.pendingChildren);break;default:
          m("163");}
    }
  }function Md(a, b, c) {
    c = hc(c);c.tag = 3;c.payload = { element: null };var d = b.value;c.callback = function () {
      Nd(d);Dd(a, b);
    };return c;
  }
  function Od(a, b, c) {
    c = hc(c);c.tag = 3;var d = a.type.getDerivedStateFromError;if ("function" === typeof d) {
      var e = b.value;c.payload = function () {
        return d(e);
      };
    }var g = a.stateNode;null !== g && "function" === typeof g.componentDidCatch && (c.callback = function () {
      "function" !== typeof d && (null === Pd ? Pd = new Set([this]) : Pd.add(this));var c = b.value,
          e = b.stack;Dd(a, b);this.componentDidCatch(c, { componentStack: null !== e ? e : "" });
    });return c;
  }
  function Qd(a) {
    switch (a.tag) {case 1:
        C(a.type) && Hb(a);var b = a.effectTag;return b & 2048 ? (a.effectTag = b & -2049 | 64, a) : null;case 3:
        return Ec(a), Ib(a), b = a.effectTag, 0 !== (b & 64) ? m("285") : void 0, a.effectTag = b & -2049 | 64, a;case 5:
        return Hc(a), null;case 13:
        return b = a.effectTag, b & 2048 ? (a.effectTag = b & -2049 | 64, a) : null;case 4:
        return Ec(a), null;case 10:
        return vc(a), null;default:
        return null;}
  }
  var Rd = { readContext: xc },
      Sd = ea.ReactCurrentOwner,
      Td = 1073741822,
      Ud = 0,
      Vd = !1,
      L = null,
      M = null,
      N = 0,
      Wd = -1,
      Xd = !1,
      O = null,
      Yd = !1,
      Zd = null,
      $d = null,
      Pd = null;function ae() {
    if (null !== L) for (var a = L.return; null !== a;) {
      var b = a;switch (b.tag) {case 1:
          var c = b.type.childContextTypes;null !== c && void 0 !== c && Hb(b);break;case 3:
          Ec(b);Ib(b);break;case 5:
          Hc(b);break;case 4:
          Ec(b);break;case 10:
          vc(b);}a = a.return;
    }M = null;N = 0;Wd = -1;Xd = !1;L = null;
  }function Qc() {
    null !== $d && (ca.unstable_cancelCallback(Zd), $d());
  }
  function be(a) {
    for (;;) {
      var b = a.alternate,
          c = a.return,
          d = a.sibling;if (0 === (a.effectTag & 1024)) {
        L = a;a: {
          var e = b;b = a;var g = N,
              f = b.pendingProps;switch (b.tag) {case 2:
              break;case 16:
              break;case 15:case 0:
              break;case 1:
              C(b.type) && Hb(b);break;case 3:
              Ec(b);Ib(b);f = b.stateNode;f.pendingContext && (f.context = f.pendingContext, f.pendingContext = null);if (null === e || null === e.child) kd(b), b.effectTag &= -3;zd(b);break;case 5:
              Hc(b);g = Cc(Bc.current);var l = b.type;if (null !== e && null != b.stateNode) Ad(e, b, l, f, g), e.ref !== b.ref && (b.effectTag |= 128);else if (f) {
                e = Fc();if (kd(b)) f = b, Xa || m("175"), e = yb(f.stateNode, f.type, f.memoizedProps, g, e, f), f.updateQueue = e, e = null !== e ? !0 : !1, e && K(b);else {
                  var h = Ga(l, f, g, e, b);_yd(h, b, !1, !1);Ia(h, l, f, g, e) && K(b);b.stateNode = h;
                }null !== b.ref && (b.effectTag |= 128);
              } else null === b.stateNode ? m("166") : void 0;break;case 6:
              e && null != b.stateNode ? Bd(e, b, e.memoizedProps, f) : ("string" !== typeof f && (null === b.stateNode ? m("166") : void 0), e = Cc(Bc.current), g = Fc(), kd(b) ? (e = b, Xa || m("176"), (e = zb(e.stateNode, e.memoizedProps, e)) && K(b)) : b.stateNode = Ma(f, e, g, b));break;case 11:
              break;case 13:
              f = b.memoizedState;if (0 !== (b.effectTag & 64)) {
                b.expirationTime = g;L = b;break a;
              }f = null !== f;g = null !== e && null !== e.memoizedState;null !== e && !f && g && (e = e.child.sibling, null !== e && (l = b.firstEffect, null !== l ? (b.firstEffect = e, e.nextEffect = l) : (b.firstEffect = b.lastEffect = e, e.nextEffect = null), e.effectTag = 8));if (f !== g || 0 === (b.effectTag & 1) && f) b.effectTag |= 4;break;case 7:
              break;case 8:
              break;case 12:
              break;case 4:
              Ec(b);zd(b);break;case 10:
              vc(b);break;case 9:
              break;case 14:
              break;case 17:
              C(b.type) && Hb(b);break;default:
              m("156");}L = null;
        }b = a;if (1 === N || 1 !== b.childExpirationTime) {
          e = 0;for (f = b.child; null !== f;) {
            g = f.expirationTime, l = f.childExpirationTime, g > e && (e = g), l > e && (e = l), f = f.sibling;
          }b.childExpirationTime = e;
        }if (null !== L) return L;null !== c && 0 === (c.effectTag & 1024) && (null === c.firstEffect && (c.firstEffect = a.firstEffect), null !== a.lastEffect && (null !== c.lastEffect && (c.lastEffect.nextEffect = a.firstEffect), c.lastEffect = a.lastEffect), 1 < a.effectTag && (null !== c.lastEffect ? c.lastEffect.nextEffect = a : c.firstEffect = a, c.lastEffect = a));
      } else {
        a = Qd(a, N);if (null !== a) return a.effectTag &= 1023, a;null !== c && (c.firstEffect = c.lastEffect = null, c.effectTag |= 1024);
      }if (null !== d) return d;if (null !== c) a = c;else break;
    }return null;
  }function ce(a) {
    var b = xd(a.alternate, a, N);a.memoizedProps = a.pendingProps;null === b && (b = be(a));Sd.current = null;return b;
  }
  function de(a, b) {
    Vd ? m("243") : void 0;Qc();Vd = !0;Sd.currentDispatcher = Rd;var c = a.nextExpirationTimeToWorkOn;if (c !== N || a !== M || null === L) ae(), M = a, N = c, L = Ub(M.current, null, N), a.pendingCommitExpirationTime = 0;var d = !1;do {
      try {
        if (b) for (; null !== L && !ee();) {
          L = ce(L);
        } else for (; null !== L;) {
          L = ce(L);
        }
      } catch (J) {
        if (tc = sc = rc = null, null === L) d = !0, Nd(J);else {
          null === L ? m("271") : void 0;var e = L,
              g = e.return;if (null === g) d = !0, Nd(J);else {
            a: {
              var f = a,
                  l = g,
                  h = e,
                  k = J;g = N;h.effectTag |= 1024;h.firstEffect = h.lastEffect = null;if (null !== k && "object" === (typeof k === "undefined" ? "undefined" : _typeof(k)) && "function" === typeof k.then) {
                var p = k;k = l;var y = -1,
                    v = -1;do {
                  if (13 === k.tag) {
                    var u = k.alternate;if (null !== u && (u = u.memoizedState, null !== u)) {
                      v = 10 * (1073741822 - u.timedOutAt);break;
                    }u = k.pendingProps.maxDuration;if ("number" === typeof u) if (0 >= u) y = 0;else if (-1 === y || u < y) y = u;
                  }k = k.return;
                } while (null !== k);k = l;do {
                  if (u = 13 === k.tag) u = void 0 === k.memoizedProps.fallback ? !1 : null === k.memoizedState;if (u) {
                    l = fe.bind(null, f, k, h, 0 === (k.mode & 1) ? 1073741823 : g);p.then(l, l);if (0 === (k.mode & 1)) {
                      k.effectTag |= 64;h.effectTag &= -1957;
                      1 === h.tag && null === h.alternate && (h.tag = 17);h.expirationTime = g;break a;
                    }-1 === y ? f = 1073741823 : (-1 === v && (v = 10 * (1073741822 - cc(f, g)) - 5E3), f = v + y);0 <= f && Wd < f && (Wd = f);k.effectTag |= 2048;k.expirationTime = g;break a;
                  }k = k.return;
                } while (null !== k);k = Error((va(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + Bb(h));
              }Xd = !0;k = pc(k, h);f = l;do {
                switch (f.tag) {case 3:
                    h = k;f.effectTag |= 2048;f.expirationTime = g;g = Md(f, h, g);jc(f, g);break a;case 1:
                    if (h = k, l = f.type, p = f.stateNode, 0 === (f.effectTag & 64) && ("function" === typeof l.getDerivedStateFromError || null !== p && "function" === typeof p.componentDidCatch && (null === Pd || !Pd.has(p)))) {
                      f.effectTag |= 2048;f.expirationTime = g;g = Od(f, h, g);jc(f, g);break a;
                    }}f = f.return;
              } while (null !== f);
            }L = be(e);continue;
          }
        }
      }break;
    } while (1);Vd = !1;tc = sc = rc = Sd.currentDispatcher = null;if (d) M = null, a.finishedWork = null;else if (null !== L) a.finishedWork = null;else {
      d = a.current.alternate;
      null === d ? m("281") : void 0;M = null;if (Xd) {
        e = a.latestPendingTime;g = a.latestSuspendedTime;f = a.latestPingedTime;if (0 !== e && e < c || 0 !== g && g < c || 0 !== f && f < c) {
          bc(a, c);ge(a, d, c, a.expirationTime, -1);return;
        }if (!a.didError && b) {
          a.didError = !0;c = a.nextExpirationTimeToWorkOn = c;b = a.expirationTime = 1073741823;ge(a, d, c, b, -1);return;
        }
      }b && -1 !== Wd ? (bc(a, c), b = 10 * (1073741822 - cc(a, c)), b < Wd && (Wd = b), b = 10 * (1073741822 - G()), b = Wd - b, ge(a, d, c, a.expirationTime, 0 > b ? 0 : b)) : (a.pendingCommitExpirationTime = c, a.finishedWork = d);
    }
  }
  function Fd(a, b) {
    for (var c = a.return; null !== c;) {
      switch (c.tag) {case 1:
          var d = c.stateNode;if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Pd || !Pd.has(d))) {
            a = pc(b, a);a = Od(c, a, 1073741823);E(c, a);Rc(c, 1073741823);return;
          }break;case 3:
          a = pc(b, a);a = Md(c, a, 1073741823);E(c, a);Rc(c, 1073741823);return;}c = c.return;
    }3 === a.tag && (c = pc(b, a), c = Md(a, c, 1073741823), E(a, c), Rc(a, 1073741823));
  }
  function Pc(a, b) {
    0 !== Ud ? a = Ud : Vd ? a = Yd ? 1073741823 : N : b.mode & 1 ? (a = P ? 1073741822 - 10 * (((1073741822 - a + 15) / 10 | 0) + 1) : 1073741822 - 25 * (((1073741822 - a + 500) / 25 | 0) + 1), null !== M && a === N && --a) : a = 1073741823;P && (0 === Q || a < Q) && (Q = a);return a;
  }
  function fe(a, b, c, d) {
    var e = a.earliestSuspendedTime;var g = a.latestSuspendedTime;if (0 !== e && d <= e && d >= g) {
      g = e = d;a.didError = !1;var f = a.latestPingedTime;if (0 === f || f > g) a.latestPingedTime = g;ac(g, a);
    } else e = G(), e = Pc(e, b), $b(a, e);0 !== (b.mode & 1) && a === M && N === d && (M = null);he(b, e);0 === (b.mode & 1) && (he(c, e), 1 === c.tag && null !== c.stateNode && (b = hc(e), b.tag = 2, E(c, b)));c = a.expirationTime;0 !== c && ie(a, c);
  }
  function he(a, b) {
    a.expirationTime < b && (a.expirationTime = b);var c = a.alternate;null !== c && c.expirationTime < b && (c.expirationTime = b);var d = a.return,
        e = null;if (null === d && 3 === a.tag) e = a.stateNode;else for (; null !== d;) {
      c = d.alternate;d.childExpirationTime < b && (d.childExpirationTime = b);null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);if (null === d.return && 3 === d.tag) {
        e = d.stateNode;break;
      }d = d.return;
    }return e;
  }
  function Rc(a, b) {
    a = he(a, b);null !== a && (!Vd && 0 !== N && b > N && ae(), $b(a, b), Vd && !Yd && M === a || ie(a, a.expirationTime), je > ke && (je = 0, m("185")));
  }function le(a, b, c, d, e) {
    var g = Ud;Ud = 1073741823;try {
      return a(b, c, d, e);
    } finally {
      Ud = g;
    }
  }var R = null,
      S = null,
      me = 0,
      ne = void 0,
      T = !1,
      V = null,
      W = 0,
      Q = 0,
      oe = !1,
      pe = null,
      X = !1,
      qe = !1,
      P = !1,
      re = null,
      se = Ta(),
      Y = 1073741822 - (se / 10 | 0),
      te = Y,
      ke = 50,
      je = 0,
      ue = null;function ve() {
    Y = 1073741822 - ((Ta() - se) / 10 | 0);
  }
  function we(a, b) {
    if (0 !== me) {
      if (b < me) return;null !== ne && Oa(ne);
    }me = b;a = Ta() - se;ne = Na(xe, { timeout: 10 * (1073741822 - b) - a });
  }function ge(a, b, c, d, e) {
    a.expirationTime = d;0 !== e || ee() ? 0 < e && (a.timeoutHandle = Qa(ze.bind(null, a, b, c), e)) : (a.pendingCommitExpirationTime = c, a.finishedWork = b);
  }function ze(a, b, c) {
    a.pendingCommitExpirationTime = c;a.finishedWork = b;ve();te = Y;Ae(a, c);
  }function G() {
    if (T) return te;Be();if (0 === W || 1 === W) ve(), te = Y;return te;
  }
  function ie(a, b) {
    null === a.nextScheduledRoot ? (a.expirationTime = b, null === S ? (R = S = a, a.nextScheduledRoot = a) : (S = S.nextScheduledRoot = a, S.nextScheduledRoot = R)) : b > a.expirationTime && (a.expirationTime = b);T || (X ? qe && (V = a, W = 1073741823, Ce(a, 1073741823, !1)) : 1073741823 === b ? Z(1073741823, !1) : we(a, b));
  }
  function Be() {
    var a = 0,
        b = null;if (null !== S) for (var c = S, d = R; null !== d;) {
      var e = d.expirationTime;if (0 === e) {
        null === c || null === S ? m("244") : void 0;if (d === d.nextScheduledRoot) {
          R = S = d.nextScheduledRoot = null;break;
        } else if (d === R) R = e = d.nextScheduledRoot, S.nextScheduledRoot = e, d.nextScheduledRoot = null;else if (d === S) {
          S = c;S.nextScheduledRoot = R;d.nextScheduledRoot = null;break;
        } else c.nextScheduledRoot = d.nextScheduledRoot, d.nextScheduledRoot = null;d = c.nextScheduledRoot;
      } else {
        e > a && (a = e, b = d);if (d === S) break;if (1073741823 === a) break;
        c = d;d = d.nextScheduledRoot;
      }
    }V = b;W = a;
  }var De = !1;function ee() {
    return De ? !0 : Pa() ? De = !0 : !1;
  }function xe() {
    try {
      if (!ee() && null !== R) {
        ve();var a = R;do {
          var b = a.expirationTime;0 !== b && Y <= b && (a.nextExpirationTimeToWorkOn = Y);a = a.nextScheduledRoot;
        } while (a !== R);
      }Z(0, !0);
    } finally {
      De = !1;
    }
  }
  function Z(a, b) {
    Be();if (b) for (ve(), te = Y; null !== V && 0 !== W && a <= W && !(De && Y > W);) {
      Ce(V, W, Y > W), Be(), ve(), te = Y;
    } else for (; null !== V && 0 !== W && a <= W;) {
      Ce(V, W, !1), Be();
    }b && (me = 0, ne = null);0 !== W && we(V, W);je = 0;ue = null;if (null !== re) for (a = re, re = null, b = 0; b < a.length; b++) {
      var c = a[b];try {
        c._onComplete();
      } catch (d) {
        oe || (oe = !0, pe = d);
      }
    }if (oe) throw a = pe, pe = null, oe = !1, a;
  }function Ae(a, b) {
    T ? m("253") : void 0;V = a;W = b;Ce(a, b, !1);Z(1073741823, !1);
  }
  function Ce(a, b, c) {
    T ? m("245") : void 0;T = !0;if (c) {
      var d = a.finishedWork;null !== d ? Ee(a, d, b) : (a.finishedWork = null, d = a.timeoutHandle, d !== Sa && (a.timeoutHandle = Sa, Ra(d)), de(a, c), d = a.finishedWork, null !== d && (ee() ? a.finishedWork = d : Ee(a, d, b)));
    } else d = a.finishedWork, null !== d ? Ee(a, d, b) : (a.finishedWork = null, d = a.timeoutHandle, d !== Sa && (a.timeoutHandle = Sa, Ra(d)), de(a, c), d = a.finishedWork, null !== d && Ee(a, d, b));T = !1;
  }
  function Ee(a, b, c) {
    var d = a.firstBatch;if (null !== d && d._expirationTime >= c && (null === re ? re = [d] : re.push(d), d._defer)) {
      a.finishedWork = b;a.expirationTime = 0;return;
    }a.finishedWork = null;a === ue ? je++ : (ue = a, je = 0);Yd = Vd = !0;a.current === b ? m("177") : void 0;c = a.pendingCommitExpirationTime;0 === c ? m("261") : void 0;a.pendingCommitExpirationTime = 0;d = b.expirationTime;var e = b.childExpirationTime;d = e > d ? e : d;a.didError = !1;0 === d ? (a.earliestPendingTime = 0, a.latestPendingTime = 0, a.earliestSuspendedTime = 0, a.latestSuspendedTime = 0, a.latestPingedTime = 0) : (e = a.latestPendingTime, 0 !== e && (e > d ? a.earliestPendingTime = a.latestPendingTime = 0 : a.earliestPendingTime > d && (a.earliestPendingTime = a.latestPendingTime)), e = a.earliestSuspendedTime, 0 === e ? $b(a, d) : d < a.latestSuspendedTime ? (a.earliestSuspendedTime = 0, a.latestSuspendedTime = 0, a.latestPingedTime = 0, $b(a, d)) : d > e && $b(a, d));ac(0, a);Sd.current = null;1 < b.effectTag ? null !== b.lastEffect ? (b.lastEffect.nextEffect = b, d = b.firstEffect) : d = b : d = b.firstEffect;Ea(a.containerInfo);for (O = d; null !== O;) {
      e = !1;var g = void 0;try {
        for (; null !== O;) {
          if (O.effectTag & 256) a: {
            var f = O.alternate,
                l = O;switch (l.tag) {case 0:case 11:case 15:
                break a;case 1:
                if (l.effectTag & 256 && null !== f) {
                  var h = f.memoizedProps,
                      k = f.memoizedState,
                      p = l.stateNode,
                      y = p.getSnapshotBeforeUpdate(l.elementType === l.type ? h : F(l.type, h), k);p.__reactInternalSnapshotBeforeUpdate = y;
                }break a;case 3:case 5:case 6:case 4:case 17:
                break a;default:
                m("163");}
          }O = O.nextEffect;
        }
      } catch (r) {
        e = !0, g = r;
      }e && (null === O ? m("178") : void 0, Fd(O, g), null !== O && (O = O.nextEffect));
    }for (O = d; null !== O;) {
      f = !1;h = void 0;try {
        for (; null !== O;) {
          var v = O.effectTag;v & 16 && Va && gb(O.stateNode);if (v & 128) {
            var u = O.alternate;if (null !== u) {
              var J = u.ref;null !== J && ("function" === typeof J ? J(null) : J.current = null);
            }
          }switch (v & 14) {case 2:
              Kd(O);O.effectTag &= -3;break;case 6:
              Kd(O);O.effectTag &= -3;Ld(O.alternate, O);break;case 4:
              Ld(O.alternate, O);break;case 8:
              k = O, Va ? Hd(k) : Id(k), k.return = null, k.child = null, k.alternate && (k.alternate.child = null, k.alternate.return = null);}O = O.nextEffect;
        }
      } catch (r) {
        f = !0, h = r;
      }f && (null === O ? m("178") : void 0, Fd(O, h), null !== O && (O = O.nextEffect));
    }Fa(a.containerInfo);
    a.current = b;for (O = d; null !== O;) {
      v = !1;u = void 0;try {
        for (J = c; null !== O;) {
          var ta = O.effectTag;if (ta & 36) {
            var q = O.alternate;f = O;h = J;switch (f.tag) {case 0:case 11:case 15:
                break;case 1:
                var w = f.stateNode;if (f.effectTag & 4) if (null === q) w.componentDidMount();else {
                  var t = f.elementType === f.type ? q.memoizedProps : F(f.type, q.memoizedProps);w.componentDidUpdate(t, q.memoizedState, w.__reactInternalSnapshotBeforeUpdate);
                }var U = f.updateQueue;null !== U && nc(f, U, w, h);break;case 3:
                var gd = f.updateQueue;if (null !== gd) {
                  k = null;if (null !== f.child) switch (f.child.tag) {case 5:
                      k = Ba(f.child.stateNode);break;case 1:
                      k = f.child.stateNode;}nc(f, gd, k, h);
                }break;case 5:
                var ye = f.stateNode;null === q && f.effectTag & 4 && ab(ye, f.type, f.memoizedProps, f);break;case 6:
                break;case 4:
                break;case 12:
                break;case 13:
                break;case 17:
                break;default:
                m("163");}
          }if (ta & 128) {
            var sb = O.ref;if (null !== sb) {
              var hd = O.stateNode;switch (O.tag) {case 5:
                  var dc = Ba(hd);break;default:
                  dc = hd;}"function" === typeof sb ? sb(dc) : sb.current = dc;
            }
          }O = O.nextEffect;
        }
      } catch (r) {
        v = !0, u = r;
      }v && (null === O ? m("178") : void 0, Fd(O, u), null !== O && (O = O.nextEffect));
    }Vd = Yd = !1;"function" === typeof Nb && Nb(b.stateNode);ta = b.expirationTime;b = b.childExpirationTime;b = b > ta ? b : ta;0 === b && (Pd = null);a.expirationTime = b;a.finishedWork = null;
  }function Nd(a) {
    null === V ? m("246") : void 0;V.expirationTime = 0;oe || (oe = !0, pe = a);
  }
  function Fe(a, b, c, d, e) {
    var g = b.current;a: if (c) {
      c = c._reactInternalFiber;b: {
        2 === wa(c) && 1 === c.tag ? void 0 : m("170");var f = c;do {
          switch (f.tag) {case 3:
              f = f.stateNode.context;break b;case 1:
              if (C(f.type)) {
                f = f.stateNode.__reactInternalMemoizedMergedChildContext;break b;
              }}f = f.return;
        } while (null !== f);m("171");f = void 0;
      }if (1 === c.tag) {
        var l = c.type;if (C(l)) {
          c = Kb(c, l, f);break a;
        }
      }c = f;
    } else c = Eb;null === b.context ? b.context = c : b.pendingContext = c;b = e;e = hc(d);e.payload = { element: a };b = void 0 === b ? null : b;null !== b && (e.callback = b);
    Qc();E(g, e);Rc(g, d);return d;
  }function Ge(a) {
    var b = a._reactInternalFiber;void 0 === b && ("function" === typeof a.render ? m("188") : m("268", Object.keys(a)));a = za(b);return null === a ? null : a.stateNode;
  }
  var He = { updateContainerAtExpirationTime: Fe, createContainer: function createContainer(a, b, c) {
      b = D(3, null, null, b ? 3 : 0);a = { current: b, containerInfo: a, pendingChildren: null, earliestPendingTime: 0, latestPendingTime: 0, earliestSuspendedTime: 0, latestSuspendedTime: 0, latestPingedTime: 0, didError: !1, pendingCommitExpirationTime: 0, finishedWork: null, timeoutHandle: Sa, context: null, pendingContext: null, hydrate: c, nextExpirationTimeToWorkOn: 0, expirationTime: 0, firstBatch: null, nextScheduledRoot: null };return b.stateNode = a;
    }, updateContainer: function updateContainer(a, b, c, d) {
      var e = b.current,
          g = G();e = Pc(g, e);return Fe(a, b, c, e, d);
    }, flushRoot: Ae, requestWork: ie, computeUniqueAsyncExpiration: function computeUniqueAsyncExpiration() {
      var a = 1073741822 - 25 * (((1073741822 - G() + 500) / 25 | 0) + 1);a >= Td && (a = Td - 1);return Td = a;
    }, batchedUpdates: function batchedUpdates(a, b) {
      var c = X;X = !0;try {
        return a(b);
      } finally {
        (X = c) || T || Z(1073741823, !1);
      }
    }, unbatchedUpdates: function unbatchedUpdates(a, b) {
      if (X && !qe) {
        qe = !0;try {
          return a(b);
        } finally {
          qe = !1;
        }
      }return a(b);
    }, deferredUpdates: function deferredUpdates(a) {
      var b = G(),
          c = Ud,
          d = P;Ud = 1073741822 - 25 * (((1073741822 - b + 500) / 25 | 0) + 1);P = !1;try {
        return a();
      } finally {
        Ud = c, P = d;
      }
    }, syncUpdates: le, interactiveUpdates: function interactiveUpdates(a, b, c) {
      if (P) return a(b, c);X || T || 0 === Q || (Z(Q, !1), Q = 0);var d = P,
          e = X;X = P = !0;try {
        return a(b, c);
      } finally {
        P = d, (X = e) || T || Z(1073741823, !1);
      }
    }, flushInteractiveUpdates: function flushInteractiveUpdates() {
      T || 0 === Q || (Z(Q, !1), Q = 0);
    }, flushControlled: function flushControlled(a) {
      var b = X;X = !0;try {
        le(a);
      } finally {
        (X = b) || T || Z(1073741823, !1);
      }
    }, flushSync: function flushSync(a, b) {
      T ? m("187") : void 0;var c = X;X = !0;try {
        return le(a, b);
      } finally {
        X = c, Z(1073741823, !1);
      }
    }, getPublicRootInstance: function getPublicRootInstance(a) {
      a = a.current;if (!a.child) return null;
      switch (a.child.tag) {case 5:
          return Ba(a.child.stateNode);default:
          return a.child.stateNode;}
    }, findHostInstance: Ge, findHostInstanceWithWarning: function findHostInstanceWithWarning(a) {
      return Ge(a);
    }, findHostInstanceWithNoPortals: function findHostInstanceWithNoPortals(a) {
      a = Aa(a);return null === a ? null : a.stateNode;
    }, injectIntoDevTools: function injectIntoDevTools(a) {
      var b = a.findFiberByHostInstance;return Qb(aa({}, a, { findHostInstanceByFiber: function findHostInstanceByFiber(a) {
          a = za(a);return null === a ? null : a.stateNode;
        }, findFiberByHostInstance: function findFiberByHostInstance(a) {
          return b ? b(a) : null;
        } }));
    } };module.exports = He.default || He;

  var $$$renderer = module.exports;
  module.exports = $$$reconciler;
  return $$$renderer;
};

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getClosestInstanceFromNode = getClosestInstanceFromNode;
// from https://github.com/facebook/react/blob/87ae211ccd8d61796cfdef138d1e12fb7a74f85d/packages/shared/ReactTypeOfWork.js
var HostComponent = 5;
var HostText = 6;

// adapted FROM: https://github.com/facebook/react/blob/master/packages/react-dom/src/client/ReactDOMComponentTree.js

var randomKey = Math.random().toString(36).slice(2);
var internalInstanceKey = '__reactInternalInstance$' + randomKey;

/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */
function getClosestInstanceFromNode(node) {
  if (node[internalInstanceKey]) {
    return node[internalInstanceKey];
  }

  while (!node[internalInstanceKey]) {
    if (node.parentNode) {
      node = node.parentNode;
    } else {
      // Top of the tree. This node must not be part of a React tree (or is
      // unmounted, potentially).
      return null;
    }
  }

  var inst = node[internalInstanceKey];
  if (inst.tag === HostComponent || inst.tag === HostText) {
    // In Fiber, this will always be the deepest root.
    return inst;
  }

  return null;
}

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.supportsMutation = exports.isPrimaryRenderer = exports.noTimeout = exports.cancelTimeout = exports.scheduleTimeout = exports.cancelDeferredCallback = exports.shouldYield = exports.scheduleDeferredCallback = exports.now = undefined;

var _HostConfigWithNoPersistence = __webpack_require__(148);

Object.keys(_HostConfigWithNoPersistence).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _HostConfigWithNoPersistence[key];
    }
  });
});

var _HostConfigWithNoHydration = __webpack_require__(149);

Object.keys(_HostConfigWithNoHydration).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _HostConfigWithNoHydration[key];
    }
  });
});

var _scheduler = __webpack_require__(41);

Object.defineProperty(exports, 'now', {
  enumerable: true,
  get: function get() {
    return _scheduler.unstable_now;
  }
});
Object.defineProperty(exports, 'scheduleDeferredCallback', {
  enumerable: true,
  get: function get() {
    return _scheduler.unstable_scheduleCallback;
  }
});
Object.defineProperty(exports, 'shouldYield', {
  enumerable: true,
  get: function get() {
    return _scheduler.unstable_shouldYield;
  }
});
Object.defineProperty(exports, 'cancelDeferredCallback', {
  enumerable: true,
  get: function get() {
    return _scheduler.unstable_cancelCallback;
  }
});
exports.appendInitialChild = appendInitialChild;
exports.createInstance = createInstance;
exports.createTextInstance = createTextInstance;
exports.finalizeInitialChildren = finalizeInitialChildren;
exports.getPublicInstance = getPublicInstance;
exports.prepareForCommit = prepareForCommit;
exports.prepareUpdate = prepareUpdate;
exports.resetAfterCommit = resetAfterCommit;
exports.resetTextContent = resetTextContent;
exports.shouldDeprioritizeSubtree = shouldDeprioritizeSubtree;
exports.getRootHostContext = getRootHostContext;
exports.getChildHostContext = getChildHostContext;
exports.shouldSetTextContent = shouldSetTextContent;
exports.appendChild = appendChild;
exports.appendChildToContainer = appendChildToContainer;
exports.insertBefore = insertBefore;
exports.insertInContainerBefore = insertInContainerBefore;
exports.removeChild = removeChild;
exports.removeChildFromContainer = removeChildFromContainer;
exports.commitTextUpdate = commitTextUpdate;
exports.commitMount = commitMount;
exports.commitUpdate = commitUpdate;
exports.hideInstance = hideInstance;
exports.hideTextInstance = hideTextInstance;
exports.unhideInstance = unhideInstance;
exports.unhideTextInstance = unhideTextInstance;

var _konva = __webpack_require__(76);

var _konva2 = _interopRequireDefault(_konva);

var _makeUpdates = __webpack_require__(77);

var _invariant = __webpack_require__(42);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var NO_CONTEXT = {};
var UPDATE_SIGNAL = {};

function appendInitialChild(parentInstance, child) {
  if (typeof child === 'string') {
    // Noop for string children of Text (eg <Text>foo</Text>)
    (0, _invariant2.default)(false, 'Don not use plain text as child of Konva.Node. You are using text: "%s"', child);
    return;
  }

  parentInstance.add(child);

  (0, _makeUpdates.updatePicture)(parentInstance);
}

function createInstance(type, props, internalInstanceHandle) {
  var NodeClass = _konva2.default[type];
  if (!NodeClass) {
    (0, _invariant2.default)(instance, 'ReactKonva does not support the type "%s". If you want to render DOM elements as part of canvas tree take a look into this demo: https://konvajs.github.io/docs/react/DOM_Portal.html', type);
    return;
  }

  var instance = new NodeClass();
  instance._applyProps = _makeUpdates.applyNodeProps;
  instance._applyProps(instance, props);

  return instance;
}

function createTextInstance(text, rootContainerInstance, internalInstanceHandle) {
  (0, _invariant2.default)(false, 'Text components are not supported for now in ReactKonva. You text is: "' + text + '"');
}

function finalizeInitialChildren(domElement, type, props) {
  return false;
}

function getPublicInstance(instance) {
  return instance;
}

function prepareForCommit() {
  // Noop
}

function prepareUpdate(domElement, type, oldProps, newProps) {
  return UPDATE_SIGNAL;
}

function resetAfterCommit() {
  // Noop
}

function resetTextContent(domElement) {
  // Noop
}

function shouldDeprioritizeSubtree(type, props) {
  return false;
}

function getRootHostContext() {
  return NO_CONTEXT;
}

function getChildHostContext() {
  return NO_CONTEXT;
}

var scheduleTimeout = exports.scheduleTimeout = setTimeout;
var cancelTimeout = exports.cancelTimeout = clearTimeout;
var noTimeout = exports.noTimeout = -1;

function shouldSetTextContent(type, props) {
  return false;
}

// The Konva renderer is secondary to the React DOM renderer.
var isPrimaryRenderer = exports.isPrimaryRenderer = false;

var supportsMutation = exports.supportsMutation = true;

function appendChild(parentInstance, child) {
  if (child.parent === parentInstance) {
    child.moveToTop();
  } else {
    parentInstance.add(child);
  }

  (0, _makeUpdates.updatePicture)(parentInstance);
}

function appendChildToContainer(parentInstance, child) {
  if (child.parent === parentInstance) {
    child.moveToTop();
  } else {
    parentInstance.add(child);
  }
  (0, _makeUpdates.updatePicture)(parentInstance);
}

function insertBefore(parentInstance, child, beforeChild) {
  (0, _invariant2.default)(child !== beforeChild, 'ReactKonva: Can not insert node before itself');
  // remove and add back to reset zIndex
  child.remove();
  parentInstance.add(child);
  child.setZIndex(beforeChild.getZIndex());
  (0, _makeUpdates.updatePicture)(parentInstance);
}

function insertInContainerBefore(parentInstance, child, beforeChild) {
  (0, _invariant2.default)(child !== beforeChild, 'ReactKonva: Can not insert node before itself');
  // remove and add back to reset zIndex
  child.remove();
  parentInstance.add(child);
  child.setZIndex(beforeChild.getZIndex());
  (0, _makeUpdates.updatePicture)(parentInstance);
}

function removeChild(parentInstance, child) {
  child.destroy();
  child.off(_makeUpdates.EVENTS_NAMESPACE);
  (0, _makeUpdates.updatePicture)(parentInstance);
}

function removeChildFromContainer(parentInstance, child) {
  child.destroy();
  child.off(_makeUpdates.EVENTS_NAMESPACE);
  (0, _makeUpdates.updatePicture)(parentInstance);
}

function commitTextUpdate(textInstance, oldText, newText) {
  (0, _invariant2.default)(false, 'Text components are not yet supported in ReactKonva. You text is: "' + newText + '"');
}

function commitMount(instance, type, newProps) {
  // Noop
}

function commitUpdate(instance, updatePayload, type, oldProps, newProps) {
  instance._applyProps(instance, newProps, oldProps);
}

function hideInstance(instance) {
  instance.hide();
  (0, _makeUpdates.updatePicture)(instance);
}

function hideTextInstance(textInstance) {
  // Noop
}

function unhideInstance(instance, props) {
  if (props.visible == null || props.visible) {
    instance.show();
  }
}

function unhideTextInstance(textInstance, text) {
  // Noop
}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createHiddenTextInstance = exports.cloneUnhiddenInstance = exports.cloneHiddenInstance = exports.replaceContainerChildren = exports.finalizeContainerChildren = exports.appendChildToContainerChildSet = exports.createContainerChildSet = exports.cloneInstance = exports.supportsPersistence = undefined;

var _invariant = __webpack_require__(42);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

// Renderers that don't support persistence
// can re-export everything from this module.

function shim() {
  (0, _invariant2.default)(false, 'The current renderer does not support persistence. ' + 'This error is likely caused by a bug in React. ' + 'Please file an issue.');
}

// Persistence (when unsupported)
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var supportsPersistence = exports.supportsPersistence = false;
var cloneInstance = exports.cloneInstance = shim;
var createContainerChildSet = exports.createContainerChildSet = shim;
var appendChildToContainerChildSet = exports.appendChildToContainerChildSet = shim;
var finalizeContainerChildren = exports.finalizeContainerChildren = shim;
var replaceContainerChildren = exports.replaceContainerChildren = shim;
var cloneHiddenInstance = exports.cloneHiddenInstance = shim;
var cloneUnhiddenInstance = exports.cloneUnhiddenInstance = shim;
var createHiddenTextInstance = exports.createHiddenTextInstance = shim;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.didNotFindHydratableTextInstance = exports.didNotFindHydratableInstance = exports.didNotFindHydratableContainerTextInstance = exports.didNotFindHydratableContainerInstance = exports.didNotHydrateInstance = exports.didNotHydrateContainerInstance = exports.didNotMatchHydratedTextInstance = exports.didNotMatchHydratedContainerTextInstance = exports.hydrateTextInstance = exports.hydrateInstance = exports.getFirstHydratableChild = exports.getNextHydratableSibling = exports.canHydrateTextInstance = exports.canHydrateInstance = exports.supportsHydration = undefined;

var _invariant = __webpack_require__(42);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

// Renderers that don't support hydration
// can re-export everything from this module.

function shim() {
  (0, _invariant2.default)(false, 'The current renderer does not support hyration. ' + 'This error is likely caused by a bug in React. ' + 'Please file an issue.');
}

// Hydration (when unsupported)
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var supportsHydration = exports.supportsHydration = false;
var canHydrateInstance = exports.canHydrateInstance = shim;
var canHydrateTextInstance = exports.canHydrateTextInstance = shim;
var getNextHydratableSibling = exports.getNextHydratableSibling = shim;
var getFirstHydratableChild = exports.getFirstHydratableChild = shim;
var hydrateInstance = exports.hydrateInstance = shim;
var hydrateTextInstance = exports.hydrateTextInstance = shim;
var didNotMatchHydratedContainerTextInstance = exports.didNotMatchHydratedContainerTextInstance = shim;
var didNotMatchHydratedTextInstance = exports.didNotMatchHydratedTextInstance = shim;
var didNotHydrateContainerInstance = exports.didNotHydrateContainerInstance = shim;
var didNotHydrateInstance = exports.didNotHydrateInstance = shim;
var didNotFindHydratableContainerInstance = exports.didNotFindHydratableContainerInstance = shim;
var didNotFindHydratableContainerTextInstance = exports.didNotFindHydratableContainerTextInstance = shim;
var didNotFindHydratableInstance = exports.didNotFindHydratableInstance = shim;
var didNotFindHydratableTextInstance = exports.didNotFindHydratableTextInstance = shim;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
        // Callback can either be a function or a string
        if (typeof callback !== "function") {
            callback = new Function("" + callback);
        }
        // Copy function arguments
        var args = new Array(arguments.length - 1);
        for (var i = 0; i < args.length; i++) {
            args[i] = arguments[i + 1];
        }
        // Store and register the task
        var task = { callback: callback, args: args };
        tasksByHandle[nextHandle] = task;
        registerImmediate(nextHandle);
        return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
            case 0:
                callback();
                break;
            case 1:
                callback(args[0]);
                break;
            case 2:
                callback(args[0], args[1]);
                break;
            case 3:
                callback(args[0], args[1], args[2]);
                break;
            default:
                callback.apply(undefined, args);
                break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function registerImmediate(handle) {
            process.nextTick(function () {
                runIfPresent(handle);
            });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function () {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function onGlobalMessage(event) {
            if (event.source === global && typeof event.data === "string" && event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function registerImmediate(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function (event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function registerImmediate(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function registerImmediate(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function registerImmediate(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();
    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();
    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();
    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();
    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
})(typeof self === "undefined" ? typeof global === "undefined" ? undefined : global : self);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14), __webpack_require__(151)))

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while (len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) {
    return [];
};

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () {
    return '/';
};
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function () {
    return 0;
};

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = function (Complaints, SelectImages) {
  var MultipleComplaintImage = function (_Component) {
    _inherits(MultipleComplaintImage, _Component);

    function MultipleComplaintImage(props) {
      _classCallCheck(this, MultipleComplaintImage);

      var _this = _possibleConstructorReturn(this, (MultipleComplaintImage.__proto__ || Object.getPrototypeOf(MultipleComplaintImage)).call(this, props));

      _initialiseProps.call(_this);

      var _this$props = _this.props,
          value = _this$props.value,
          _this$props$value = _this$props.value;
      _this$props$value = _this$props$value === undefined ? {} : _this$props$value;
      var active = _this$props$value.active;


      var initVariables = {};
      if (!value || _this.isEmpty(value)) {
        initVariables = _this.initComplaintsObject();
      }
      var activeKey = active ? active : _this.props.images && _this.props.images[0].key;

      _this.state = _extends({
        drawingMode: false
      }, value, {
        active: activeKey
      }, initVariables);
      _this.changeImage(activeKey, false);
      return _this;
    }

    _createClass(MultipleComplaintImage, [{
      key: "clearDrawings",
      value: function clearDrawings() {
        var image = this.refs.drawinglayer;
        image && image.clear();
      }
    }, {
      key: "componentWillUpdate",
      value: function componentWillUpdate(nextProps, nextState) {
        if (this.state.active !== nextState.active) {
          this.updateDrawing = true;
        } else {
          this.updateDrawing = false;
        }
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        var _ReactDOM$findDOMNode = _reactDom2.default.findDOMNode(this.refs["image-frame"]).getBoundingClientRect(),
            width = _ReactDOM$findDOMNode.width;

        var imagePadding = this.props.imagePadding;


        this.currentWidth = width;

        this.currentSrcWidth = this.state.srcWidth;

        var stage = this.refs.stage.getStage();
        this.imageSize = width - imagePadding;

        stage.width(width);
        stage.height(width);

        var image = this.refs.image;
        image.width(width - imagePadding);
        image.height(width - imagePadding);
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _props = this.props,
            images = _props.images,
            _props$complaint = _props.complaint,
            circle = _props$complaint.circle,
            text = _props$complaint.text,
            imageClassName = _props.imageClassName,
            complaintClassName = _props.complaintClassName,
            markerColors = _props.markerColors;
        var _state = this.state,
            active = _state.active,
            image = _state.image;

        var complaints = this.state[active] ? this.state[active].complaints : [];

        var uiDisplay = null;
        var uiOptions = null;
        this.props.images.forEach(function (item) {
          if (item.key === _this2.state.active) {
            uiDisplay = item.uiDisplay;
            uiOptions = item.uiOptions;
          }
        });

        return _react2.default.createElement(
          _react.Fragment,
          null,
          _react2.default.createElement(
            "div",
            { id: "image", className: imageClassName, ref: "image-frame" },
            _react2.default.createElement(SelectImages, {
              images: images,
              selected: active,
              onSelect: this.changeImage
            }),
            _react2.default.createElement(
              "div",
              { style: { margin: "3px" } },
              _react2.default.createElement(
                "a",
                {
                  className: "complaint_image_link",
                  style: {
                    left: "1px",
                    zIndex: 1
                  },
                  onClick: this.handleClearAll
                },
                _react2.default.createElement("span", {
                  style: { fontSize: "11px" },
                  className: "glyphicon glyphicon-refresh"
                }),
                "\xA0Clear All"
              ),
              _react2.default.createElement(
                "span",
                { className: "pull-right" },
                _react2.default.createElement(
                  "label",
                  { className: "radio-inline select-mode-container" },
                  _react2.default.createElement("input", {
                    type: "radio",
                    checked: !this.state.drawingMode,
                    onChange: function onChange() {
                      _this2.setState(function () {
                        return { drawingMode: false };
                      });
                    }
                  }),
                  "Selection Mode"
                ),
                _react2.default.createElement(
                  "label",
                  { className: "radio-inline draw-mode-container" },
                  _react2.default.createElement("input", {
                    type: "radio",
                    checked: this.state.drawingMode,
                    onChange: function onChange() {
                      _this2.setState(function () {
                        return { drawingMode: true };
                      });
                    }
                  }),
                  "Drawing Mode"
                )
              )
            ),
            _react2.default.createElement("hr", null),
            _react2.default.createElement(
              "div",
              {
                className: "complaints-image-block",
                style: { cursor: this.state.drawingMode ? "cell" : "default" }
              },
              _react2.default.createElement(
                _reactKonva.Stage,
                {
                  onClick: this.handleClick,
                  onTap: this.handleTap,
                  ref: "stage"
                },
                _react2.default.createElement(
                  _reactKonva.Layer,
                  { visible: true, ref: "layer" },
                  _react2.default.createElement(_reactKonva.Image, { ref: "image", image: image }),
                  this.imageSize && !this.updateDrawing && _react2.default.createElement(Drawing, {
                    ref: "drawinglayer",
                    isDrawingMode: this.state.drawingMode,
                    notifyParent: this.notify,
                    parentImageSize: this.imageSize,
                    getDrawnPoints: function getDrawnPoints(points) {
                      return _this2.getDrawnPoints(points);
                    },
                    allPoints: this.state[this.state.active]["drawnPoints"],
                    complaints: this.state[this.state.active]["complaints"],
                    srcWidth: this.currentSrcWidth,
                    currentWidth: this.currentWidth
                  }),
                  complaints.map(function (conf, i) {
                    var stroke = markerColors ? markerColors[i % markerColors.length] : circle.stroke;
                    var markerConf = Object.assign({}, conf, circle, {
                      stroke: stroke
                    });
                    return _react2.default.createElement(_ComplaintMarker2.default, _extends({ key: i }, markerConf));
                  }),
                  complaints.map(function (conf, i) {
                    var fill = markerColors ? markerColors[i % markerColors.length] : circle.fill;
                    var indicatorConf = Object.assign({}, conf, text, { fill: fill });
                    return _react2.default.createElement(_ComplaintIndicator2.default, _extends({
                      key: i,
                      index: i
                    }, indicatorConf));
                  })
                )
              )
            )
          ),
          _react2.default.createElement(
            "div",
            { className: complaintClassName },
            _react2.default.createElement(Complaints, {
              complaints: complaints,
              markerColors: markerColors,
              onChange: this.handleTextChange,
              onDelete: this.handleDelete,
              uiDisplay: uiDisplay,
              uiOptions: uiOptions
            })
          )
        );
      }
    }]);

    return MultipleComplaintImage;
  }(_react.Component);

  var _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.isEmpty = function (obj) {
      return Object.keys(obj).length === 0 && obj.constructor === Object;
    };

    this.initComplaintsObject = function () {
      return _this3.props.images.reduce(function (agg, item) {
        var key = item.key;
        agg[key] = {
          complaints: [],
          url: item.url
        };
        return agg;
      }, []);
    };

    this.changeImage = function (active) {
      var notifyOnLoad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var image = new window.Image();
      var currentUrl = _this3.state[active] && _this3.state[active].url;
      image.src = currentUrl;
      image.onload = function () {
        _this3.clearDrawings();
        if (notifyOnLoad) {
          _this3.setState({ image: image, active: active }, _this3.notify);
        } else {
          _this3.setState({ image: image, active: active });
        }
      };
    };

    this.handleClick = function (evt) {
      if (!_this3.state.drawingMode) {
        var pointerPos = evt.currentTarget.pointerPos,
            className = evt.target.className;

        if (className !== "Image") {
          return;
        }

        _this3.setState(function (state) {
          var _updatedItem;

          var active = state.active;

          var activeObject = state[active];
          var complaints = activeObject.complaints.concat({ pos: pointerPos });
          var currentWidth = _this3.currentWidth;
          var updatedItem = (_updatedItem = {}, _defineProperty(_updatedItem, active, _extends({}, activeObject, { complaints: complaints })), _defineProperty(_updatedItem, "srcWidth", currentWidth), _updatedItem);
          return Object.assign({}, state, updatedItem);
        }, _this3.notify);
      }
    };

    this.handleTap = function (evt) {
      if (!_this3.state.drawingMode) {
        var pointerPos = evt.currentTarget.pointerPos,
            className = evt.target.className;

        if (className !== "Image") {
          return;
        }

        _this3.setState(function (state) {
          var _updatedItem2;

          var active = state.active;

          var activeObject = state[active];
          var complaints = activeObject.complaints.concat({ pos: pointerPos });
          var currentWidth = _this3.currentWidth;
          var updatedItem = (_updatedItem2 = {}, _defineProperty(_updatedItem2, active, _extends({}, activeObject, { complaints: complaints })), _defineProperty(_updatedItem2, "srcWidth", currentWidth), _updatedItem2);
          return Object.assign({}, state, updatedItem);
        }, _this3.notify);
      }
    };

    this.handleTextChange = function (i, text) {
      _this3.setState(function (state) {
        var _updatedItem3;

        var active = state.active;

        var activeObj = state[active];
        var complaints = activeObj.complaints;
        var complaint = Object.assign({}, complaints[i], { text: text });
        complaints = complaints.slice();
        complaints.splice(i, 1, complaint);
        var currentWidth = _this3.currentWidth;
        var updatedItem = (_updatedItem3 = {}, _defineProperty(_updatedItem3, active, _extends({}, activeObj, { complaints: complaints })), _defineProperty(_updatedItem3, "srcWidth", currentWidth), _updatedItem3);
        return Object.assign({}, state, updatedItem);
      }, _this3.notify);
    };

    this.handleDelete = function (i) {
      _this3.setState(function (state) {
        var _updatedItem4;

        var active = state.active;

        var activeObj = state[active];
        var complaints = activeObj.complaints;
        complaints = complaints.slice();
        complaints.splice(i, 1);
        var currentWidth = _this3.currentWidth;
        var updatedItem = (_updatedItem4 = {}, _defineProperty(_updatedItem4, active, _extends({}, activeObj, { complaints: complaints })), _defineProperty(_updatedItem4, "srcWidth", currentWidth), _updatedItem4);
        return Object.assign({}, state, updatedItem);
      }, _this3.notify);
    };

    this.handleClearAll = function () {
      _this3.clearDrawings();
      _this3.setState(function (state) {
        var active = state.active;

        var activeObj = state[active];
        var updatedItem = _defineProperty({}, active, _extends({}, activeObj, { complaints: [], drawnPoints: [] }));
        return Object.assign({}, state, updatedItem);
      }, _this3.notify);
    };

    this.notify = function () {
      /** 
        I believe render is in the call stack and this async operation settimeout sends the function to the webapi.
        Even if the timeout is 0, it does not get added to the call stack until the call stack is empty
        this solves our problem of notify executing before the render function
        or use promise new Promise((event) => setTimeout(event, 10)).then(()=> {
      */

      if (_this3.state.srcWidth !== undefined) {
        _this3.setState({
          srcWidth: _this3.currentWidth
        });
      }

      (0, _timers.setTimeout)(function () {
        // this is done to prevent passing active and image objects to the onchange event
        var _state2 = _this3.state,
            image = _state2.image,
            values = _objectWithoutProperties(_state2, ["image"]);

        var active = _this3.state.active;

        if (_this3.props.onChange) {
          var stage = _this3.refs.stage.getStage();
          values[active] ? values[active].dataURI = stage.toDataURL() : null;
          var event = _extends({}, values);
          _this3.props.onChange(event);
        }
      }, 0);
    };

    this.getDrawnPoints = function (points) {
      var currentWidth = _this3.currentWidth;
      if (points && points.length > 0) {
        _this3.setState(function (state) {
          var _updatedItem6;

          var active = state.active;

          var activeObject = state[active];
          var updatedItem = (_updatedItem6 = {}, _defineProperty(_updatedItem6, active, _extends({}, activeObject, { drawnPoints: points })), _defineProperty(_updatedItem6, "srcWidth", currentWidth), _updatedItem6);
          return Object.assign({}, state, updatedItem);
        });
      }
    };
  };

  MultipleComplaintImage.defaultProps = {
    complaint: {
      circle: {
        radius: 10,
        stroke: "#38A8E8",
        strokeWidth: 2
      },
      text: {
        fontSize: 12,
        fontFamily: "Roboto",
        fill: "black"
      }
    },
    imagePadding: 30,
    imageClassName: "col-md-5 col-sm-12",
    complaintClassName: "col-md-7 col-sm-12"
  };

  MultipleComplaintImage.propTypes = {
    value: _propTypes2.default.shape({
      complaint: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        pos: _propTypes2.default.shape({
          x: _propTypes2.default.number.isRequired,
          y: _propTypes2.default.number.isRequired
        }),
        text: _propTypes2.default.string.isRequired
      }))
    }),
    images: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      name: _propTypes2.default.string.isRequired,
      url: _propTypes2.default.string.isRequired
    })).isRequired,
    imagePadding: _propTypes2.default.number,
    imageClassName: _propTypes2.default.string,
    complaintClassName: _propTypes2.default.string,
    complaint: _propTypes2.default.shape({
      radius: _propTypes2.default.number,
      stroke: _propTypes2.default.string,
      strokeWidth: _propTypes2.default.number
    }),
    markerColors: _propTypes2.default.arrayOf(_propTypes2.default.string),
    onChange: _propTypes2.default.func
  };

  return MultipleComplaintImage;
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(6);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactKonva = __webpack_require__(28);

var _ComplaintMarker = __webpack_require__(78);

var _ComplaintMarker2 = _interopRequireDefault(_ComplaintMarker);

var _ComplaintIndicator = __webpack_require__(79);

var _ComplaintIndicator2 = _interopRequireDefault(_ComplaintIndicator);

var _timers = __webpack_require__(80);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Class Component the inserts free drawn image of the layer in the stage
 */
var Drawing = function (_Component2) {
  _inherits(Drawing, _Component2);

  function Drawing() {
    var _ref;

    var _temp, _this4, _ret;

    _classCallCheck(this, Drawing);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this4 = _possibleConstructorReturn(this, (_ref = Drawing.__proto__ || Object.getPrototypeOf(Drawing)).call.apply(_ref, [this].concat(args))), _this4), _this4.state = {
      isDrawing: false,
      currentPoints: [],
      allPoints: []
    }, _this4.handleMouseDown = function () {
      if (!_this4.props.isDrawingMode) {
        return;
      }
      _this4.setState(function () {
        return {
          isDrawing: true
        };
      }, function () {
        var stage = _this4.image.parent.parent;
        _this4.lastPointerPosition = stage.getPointerPosition();
        var localPos = {
          x: _this4.lastPointerPosition.x - _this4.image.x(),
          y: _this4.lastPointerPosition.y - _this4.image.y()
        };
        var currentPoints = [];
        currentPoints.push.apply(currentPoints, _toConsumableArray(_this4.state.currentPoints).concat([localPos]));
        _this4.setState({
          currentPoints: currentPoints
        });
      });
    }, _this4.handleMouseUp = function () {
      if (!_this4.props.isDrawingMode && !_this4.state.isDrawing) {
        return;
      }
      if (_this4.state.currentPoints && _this4.state.currentPoints.length > 1) {
        var allPoints = [].concat(_toConsumableArray(_this4.state.allPoints), [_this4.state.currentPoints]);
        _this4.setState({ isDrawing: false, allPoints: allPoints, currentPoints: [] });
        _this4.props.getDrawnPoints(allPoints);
      } else {
        _this4.setState({ isDrawing: false, currentPoints: [] });
      }
      _this4.props.notifyParent();
    }, _this4.clear = function () {
      var context = _this4.state.context;

      context.clearRect(0, 0, _this4.props.parentImageSize, _this4.props.parentImageSize);
      _this4.image.getLayer().draw();
      _this4.setState({
        allPoints: [],
        currentPoints: []
      });
    }, _this4.handleMouseMove = function () {
      var _this4$state = _this4.state,
          context = _this4$state.context,
          isDrawing = _this4$state.isDrawing;

      if (!_this4.props.isDrawingMode) {
        return;
      }
      if (isDrawing) {
        context.strokeStyle = "#df4b26";
        context.lineJoin = "round";
        context.lineWidth = 1;

        context.globalCompositeOperation = "source-over";
        context.beginPath();

        var localPos = {
          x: _this4.lastPointerPosition.x - _this4.image.x(),
          y: _this4.lastPointerPosition.y - _this4.image.y()
        };
        context.moveTo(localPos.x, localPos.y);

        var stage = _this4.image.parent.parent;
        var pos = stage.getPointerPosition();
        localPos = {
          x: pos.x - _this4.image.x(),
          y: pos.y - _this4.image.y()
        };
        context.lineTo(localPos.x, localPos.y);
        context.closePath();
        context.stroke();
        _this4.lastPointerPosition = pos;
        _this4.image.getLayer().draw();

        var currentPoints = [];
        currentPoints.push.apply(currentPoints, _toConsumableArray(_this4.state.currentPoints).concat([localPos]));
        _this4.setState({ currentPoints: currentPoints });
      }
    }, _temp), _possibleConstructorReturn(_this4, _ret);
  }

  _createClass(Drawing, [{
    key: "componentDidMount",


    /**
     * componentDidMount- creates the canvas element and adds that to local state
     * If points are passed as props, those get drawn when the component loads
     */
    value: function componentDidMount() {
      var canvas = document.createElement("canvas");
      canvas.width = this.props.parentImageSize;
      canvas.height = this.props.parentImageSize;
      var context = canvas.getContext("2d");
      var allPointsArray = [];
      var srcWidth = this.props.srcWidth;
      var currentWidth = this.props.currentWidth;
      if (srcWidth && this.currentWidth !== srcWidth && this.props.complaints && this.props.complaints.length > 0) {
        this.props.complaints.forEach(function (item) {
          var positionX = "";
          var positionY = "";
          positionX = item.pos.x * (currentWidth / srcWidth);
          positionY = item.pos.y * (currentWidth / srcWidth);
          item.pos.x = Math.round(positionX);
          item.pos.y = Math.round(positionY);
        });
      }
      if (this.props.allPoints && this.props.allPoints.length > 0) {
        context.strokeStyle = "#df4b26";
        context.lineJoin = "round";
        context.lineWidth = 1;
        context.beginPath();
        this.props.allPoints.forEach(function (group) {
          group.forEach(function (localPos, i) {
            if (srcWidth && currentWidth !== srcWidth) {
              var positionX = "";
              var positionY = "";
              positionX = localPos.x * (currentWidth / srcWidth);
              positionY = localPos.y * (currentWidth / srcWidth);
              localPos.x = Math.round(positionX);
              localPos.y = Math.round(positionY);
            }
            if (i !== 0) {
              context.lineTo(localPos.x, localPos.y);
            }
            context.moveTo(localPos.x, localPos.y);
          });
          context.closePath();
          context.stroke();
        });
        this.image.getLayer().draw();
        allPointsArray = this.props.allPoints;
      }
      this.setState(function () {
        return { canvas: canvas, context: context, allPoints: allPointsArray };
      }, this.props.notifyParent);
    }

    /**
     * handleMouseDown- Function to handle mouse down operation
     * function sets isDrawing to true and saves the first point to the state
     */


    /**
     * handleMouseUp- This is where isDrawing is set to false, state is updated with
     * the most recent points and parent component is notified
     */


    /**
     * clear() is used to clear the drawings
     */

    /**
     * handleMouseMove- This is where the drawing logic is implemented using context.
     * points are added to the state too
     */

  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var canvas = this.state.canvas;

      return _react2.default.createElement(_reactKonva.Image, {
        image: canvas,
        ref: function ref(node) {
          return _this5.image = node;
        },
        width: this.props.parentImageSize,
        height: this.props.parentImageSize,
        onMouseDown: this.handleMouseDown,
        onTouchStart: this.handleMouseDown,
        onMouseUp: this.handleMouseUp,
        onTouchEnd: this.handleMouseUp,
        onMouseMove: this.handleMouseMove,
        onTouchMove: this.handleMouseMove,
        onMouseLeave: this.handleMouseUp
      });
    }
  }]);

  return Drawing;
}(_react.Component);

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrapTypeahead = __webpack_require__(154);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Complaint = function (_Component) {
  _inherits(Complaint, _Component);

  function Complaint(props) {
    _classCallCheck(this, Complaint);

    var _this = _possibleConstructorReturn(this, (Complaint.__proto__ || Object.getPrototypeOf(Complaint)).call(this, props));

    _this.handleTypeaheadChange = function (items) {
      var selectedValues = items.map(function (item) {
        return (typeof item === "undefined" ? "undefined" : _typeof(item)) === "object" ? item.label : item;
      });
      _this.setState({ typeaheadValue: selectedValues });
      _this.props.onChange(selectedValues.join(" & "));
    };

    _this.handleChange = function (event) {
      _this.setState({ value: event.target.value });
    };

    _this.handleSubmit = function (event) {
      event.preventDefault();
      if (_this.state.value !== _this.props.text) {
        _this.props.onChange(_this.state.value);
      }
    };

    _this.handleKeyDown = function (event) {
      if (event.keyCode === 13) {
        _this.handleSubmit(event);
      }
    };

    var _props$text = props.text,
        text = _props$text === undefined ? "" : _props$text;

    _this.state = {
      value: text,
      typeaheadValue: text ? text.split(" & ") : []
    };
    return _this;
  }

  _createClass(Complaint, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.text !== this.props.text) {
        this.setState({
          value: this.props.text,
          typeaheadValue: this.props.text ? this.props.text.split(" & ") : []
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          "td",
          null,
          this.props.uiDisplay == "typeahead" && this.props.uiOptions ? _react2.default.createElement(_reactBootstrapTypeahead.Typeahead, _extends({
            selected: this.state.typeaheadValue,
            onChange: this.handleTypeaheadChange,
            placeholder: "Choose an item...",
            autoFocus: true
          }, this.props.uiOptions)) : _react2.default.createElement("input", {
            autoFocus: true,
            type: "text",
            value: this.state.value,
            className: "form-control",
            onKeyDown: this.handleKeyDown,
            onBlur: this.handleSubmit,
            onChange: this.handleChange
          })
        ),
        _react2.default.createElement(
          "td",
          null,
          _react2.default.createElement(
            "button",
            { className: "btn btn-default", onClick: this.props.onDelete },
            "Delete"
          )
        )
      );
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.text !== prevState.text) {
        return {
          text: nextProps.text
        };
      } else {
        return null;
      }
    }
  }]);

  return Complaint;
}(_react.Component);

function ComplaintText(_ref) {
  var complaints = _ref.complaints,
      _onChange = _ref.onChange,
      _onDelete = _ref.onDelete,
      uiDisplay = _ref.uiDisplay,
      uiOptions = _ref.uiOptions;

  return _react2.default.createElement(
    "table",
    { className: "table" },
    _react2.default.createElement(
      "thead",
      null,
      _react2.default.createElement(
        "tr",
        null,
        _react2.default.createElement(
          "th",
          { className: "col-md-1" },
          "#"
        ),
        _react2.default.createElement(
          "th",
          null,
          "Complaint"
        ),
        _react2.default.createElement("th", { className: "col-md-1" })
      )
    ),
    _react2.default.createElement(
      "tbody",
      null,
      complaints.map(function (complaint, i) {
        return _react2.default.createElement(
          _react.Fragment,
          { key: i },
          _react2.default.createElement(
            "tr",
            null,
            _react2.default.createElement(
              "td",
              { style: { paddingTop: 14 } },
              i + 1
            ),
            _react2.default.createElement(Complaint, _extends({}, complaint, {
              onChange: function onChange(text) {
                return _onChange(i, text);
              },
              onDelete: function onDelete() {
                return _onDelete(i);
              },
              uiDisplay: uiDisplay,
              uiOptions: _extends({}, uiOptions, {
                autoFocus: uiOptions && uiOptions.autoFocus && complaints.length - 1 === i && complaint.text === undefined
              })
            }))
          )
        );
      })
    )
  );
}
exports.default = ComplaintText;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tokenContainer = exports.menuItemContainer = exports.asyncContainer = exports.TypeaheadMenu = exports.Typeahead = exports.Token = exports.MenuItem = exports.Menu = exports.Highlighter = exports.AsyncTypeahead = undefined;

var _AsyncTypeahead2 = __webpack_require__(155);

var _AsyncTypeahead3 = _interopRequireDefault(_AsyncTypeahead2);

var _Highlighter2 = __webpack_require__(132);

var _Highlighter3 = _interopRequireDefault(_Highlighter2);

var _Menu2 = __webpack_require__(133);

var _Menu3 = _interopRequireDefault(_Menu2);

var _MenuItem2 = __webpack_require__(70);

var _MenuItem3 = _interopRequireDefault(_MenuItem2);

var _Token2 = __webpack_require__(126);

var _Token3 = _interopRequireDefault(_Token2);

var _Typeahead2 = __webpack_require__(103);

var _Typeahead3 = _interopRequireDefault(_Typeahead2);

var _TypeaheadMenu2 = __webpack_require__(131);

var _TypeaheadMenu3 = _interopRequireDefault(_TypeaheadMenu2);

var _asyncContainer2 = __webpack_require__(81);

var _asyncContainer3 = _interopRequireDefault(_asyncContainer2);

var _menuItemContainer2 = __webpack_require__(134);

var _menuItemContainer3 = _interopRequireDefault(_menuItemContainer2);

var _tokenContainer2 = __webpack_require__(127);

var _tokenContainer3 = _interopRequireDefault(_tokenContainer2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.AsyncTypeahead = _AsyncTypeahead3.default; /* eslint-disable object-curly-spacing */

// Components

exports.Highlighter = _Highlighter3.default;
exports.Menu = _Menu3.default;
exports.MenuItem = _MenuItem3.default;
exports.Token = _Token3.default;
exports.Typeahead = _Typeahead3.default;
exports.TypeaheadMenu = _TypeaheadMenu3.default;

// HOCs

exports.asyncContainer = _asyncContainer3.default;
exports.menuItemContainer = _menuItemContainer3.default;
exports.tokenContainer = _tokenContainer3.default;

/* eslint-enable object-curly-spacing */

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _asyncContainer = __webpack_require__(81);

var _asyncContainer2 = _interopRequireDefault(_asyncContainer);

var _Typeahead = __webpack_require__(103);

var _Typeahead2 = _interopRequireDefault(_Typeahead);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = (0, _asyncContainer2.default)(_Typeahead2.default);

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isObject = __webpack_require__(7),
    now = __webpack_require__(157),
    toNumber = __webpack_require__(158);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var root = __webpack_require__(4);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function now() {
  return root.Date.now();
};

module.exports = now;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isObject = __webpack_require__(7),
    isSymbol = __webpack_require__(29);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? other + '' : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}

module.exports = toNumber;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Symbol = __webpack_require__(23);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(3);

function addCustomOption(results, props) {
  var allowNew = props.allowNew,
      labelKey = props.labelKey,
      text = props.text;

  if (!allowNew || !text.trim()) {
    return false;
  }

  // If the consumer has provided a callback, use that to determine whether or
  // not to add the custom option.
  if (typeof allowNew === 'function') {
    return allowNew(results, props);
  }

  // By default, don't add the custom option if there is an exact text match
  // with an existing option.
  return !results.some(function (o) {
    return (0, _index.getOptionLabel)(o, labelKey) === text;
  });
}

exports.default = addCustomOption;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = defaultFilterBy;

var _isEqual = __webpack_require__(83);

var _isEqual2 = _interopRequireDefault(_isEqual);

var _isFunction = __webpack_require__(45);

var _isFunction2 = _interopRequireDefault(_isFunction);

var _isString = __webpack_require__(218);

var _isString2 = _interopRequireDefault(_isString);

var _some = __webpack_require__(219);

var _some2 = _interopRequireDefault(_some);

var _stripDiacritics = __webpack_require__(53);

var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);

var _warn = __webpack_require__(9);

var _warn2 = _interopRequireDefault(_warn);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function isMatch(input, string, props) {
  if (!props.caseSensitive) {
    input = input.toLowerCase();
    string = string.toLowerCase();
  }

  if (props.ignoreDiacritics) {
    input = (0, _stripDiacritics2.default)(input);
    string = (0, _stripDiacritics2.default)(string);
  }

  return string.indexOf(input) !== -1;
}

/**
 * Default algorithm for filtering results.
 */
function defaultFilterBy(option, props) {
  var filterBy = props.filterBy,
      labelKey = props.labelKey,
      multiple = props.multiple,
      selected = props.selected,
      text = props.text;

  // Don't show selected options in the menu for the multi-select case.

  if (multiple && selected.some(function (o) {
    return (0, _isEqual2.default)(o, option);
  })) {
    return false;
  }

  var fields = filterBy.slice();

  if ((0, _isFunction2.default)(labelKey) && isMatch(text, labelKey(option), props)) {
    return true;
  }

  if ((0, _isString2.default)(labelKey)) {
    // Add the `labelKey` field to the list of fields if it isn't already there.
    if (fields.indexOf(labelKey) === -1) {
      fields.unshift(labelKey);
    }
  }

  if ((0, _isString2.default)(option)) {
    (0, _warn2.default)(fields.length <= 1, 'You cannot filter by properties when `option` is a string.');

    return isMatch(text, option, props);
  }

  return (0, _some2.default)(fields, function (field) {
    var value = option[field];

    if (!(0, _isString2.default)(value)) {
      (0, _warn2.default)(false, 'Fields passed to `filterBy` should have string values. Value will ' + 'be converted to a string; results may be unexpected.');

      // Coerce to string since `toString` isn't null-safe.
      value = value + '';
    }

    return isMatch(text, value, props);
  });
}

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Stack = __webpack_require__(84),
    equalArrays = __webpack_require__(86),
    equalByTag = __webpack_require__(194),
    equalObjects = __webpack_require__(198),
    getTag = __webpack_require__(214),
    isArray = __webpack_require__(2),
    isBuffer = __webpack_require__(89),
    isTypedArray = __webpack_require__(91);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack());
    return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack());
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assocIndexOf = __webpack_require__(31);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assocIndexOf = __webpack_require__(31);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assocIndexOf = __webpack_require__(31);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assocIndexOf = __webpack_require__(31);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ListCache = __webpack_require__(30);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache();
  this.size = 0;
}

module.exports = stackClear;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ListCache = __webpack_require__(30),
    Map = __webpack_require__(44),
    MapCache = __webpack_require__(46);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isFunction = __webpack_require__(45),
    isMasked = __webpack_require__(175),
    isObject = __webpack_require__(7),
    toSource = __webpack_require__(85);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var coreJsData = __webpack_require__(176);

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

module.exports = isMasked;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var root = __webpack_require__(4);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Hash = __webpack_require__(179),
    ListCache = __webpack_require__(30),
    Map = __webpack_require__(44);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map || ListCache)(),
    'string': new Hash()
  };
}

module.exports = mapCacheClear;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hashClear = __webpack_require__(180),
    hashDelete = __webpack_require__(181),
    hashGet = __webpack_require__(182),
    hashHas = __webpack_require__(183),
    hashSet = __webpack_require__(184);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var nativeCreate = __webpack_require__(33);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var nativeCreate = __webpack_require__(33);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var nativeCreate = __webpack_require__(33);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

module.exports = hashHas;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var nativeCreate = __webpack_require__(33);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getMapData = __webpack_require__(34);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

module.exports = isKeyable;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getMapData = __webpack_require__(34);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getMapData = __webpack_require__(34);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getMapData = __webpack_require__(34);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var MapCache = __webpack_require__(46),
    setCacheAdd = __webpack_require__(191),
    setCacheHas = __webpack_require__(192);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
    var index = -1,
        length = values == null ? 0 : values.length;

    this.__data__ = new MapCache();
    while (++index < length) {
        this.add(values[index]);
    }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Symbol = __webpack_require__(23),
    Uint8Array = __webpack_require__(195),
    eq = __webpack_require__(32),
    equalArrays = __webpack_require__(86),
    mapToArray = __webpack_require__(196),
    setToArray = __webpack_require__(197);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == other + '';

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var root = __webpack_require__(4);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function (value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function (value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getAllKeys = __webpack_require__(199);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseGetAllKeys = __webpack_require__(200),
    getSymbols = __webpack_require__(201),
    keys = __webpack_require__(47);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var arrayPush = __webpack_require__(88),
    isArray = __webpack_require__(2);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var arrayFilter = __webpack_require__(202),
    stubArray = __webpack_require__(203);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function (symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseTimes = __webpack_require__(205),
    isArguments = __webpack_require__(48),
    isArray = __webpack_require__(2),
    isBuffer = __webpack_require__(89),
    isIndex = __webpack_require__(35),
    isTypedArray = __webpack_require__(91);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (
    // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' ||
    // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') ||
    // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
    // Skip index properties.
    isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseGetTag = __webpack_require__(11),
    isObjectLike = __webpack_require__(8);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseGetTag = __webpack_require__(11),
    isLength = __webpack_require__(49),
    isObjectLike = __webpack_require__(8);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}

module.exports = baseUnary;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var freeGlobal = __webpack_require__(82);

/** Detect free variable `exports`. */
var freeExports = ( false ? 'undefined' : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && ( false ? 'undefined' : _typeof(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = function () {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}();

module.exports = nodeUtil;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(90)(module)))

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isPrototype = __webpack_require__(212),
    nativeKeys = __webpack_require__(213);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;

  return value === proto;
}

module.exports = isPrototype;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var overArg = __webpack_require__(92);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DataView = __webpack_require__(215),
    Map = __webpack_require__(44),
    Promise = __webpack_require__(216),
    Set = __webpack_require__(217),
    WeakMap = __webpack_require__(93),
    baseGetTag = __webpack_require__(11),
    toSource = __webpack_require__(85);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
    getTag = function getTag(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
            switch (ctorString) {
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
        }
        return result;
    };
}

module.exports = getTag;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getNative = __webpack_require__(12),
    root = __webpack_require__(4);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getNative = __webpack_require__(12),
    root = __webpack_require__(4);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getNative = __webpack_require__(12),
    root = __webpack_require__(4);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseGetTag = __webpack_require__(11),
    isArray = __webpack_require__(2),
    isObjectLike = __webpack_require__(8);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
    return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
}

module.exports = isString;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var arraySome = __webpack_require__(87),
    baseIteratee = __webpack_require__(220),
    baseSome = __webpack_require__(236),
    isArray = __webpack_require__(2),
    isIterateeCall = __webpack_require__(242);

/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = isArray(collection) ? arraySome : baseSome;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = some;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var baseMatches = __webpack_require__(221),
    baseMatchesProperty = __webpack_require__(224),
    identity = __webpack_require__(98),
    isArray = __webpack_require__(2),
    property = __webpack_require__(233);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object') {
    return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseIsMatch = __webpack_require__(222),
    getMatchData = __webpack_require__(223),
    matchesStrictComparable = __webpack_require__(95);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function (object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Stack = __webpack_require__(84),
    baseIsEqual = __webpack_require__(43);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack();
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isStrictComparable = __webpack_require__(94),
    keys = __webpack_require__(47);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
    var result = keys(object),
        length = result.length;

    while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
    }
    return result;
}

module.exports = getMatchData;

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseIsEqual = __webpack_require__(43),
    get = __webpack_require__(225),
    hasIn = __webpack_require__(97),
    isKey = __webpack_require__(52),
    isStrictComparable = __webpack_require__(94),
    matchesStrictComparable = __webpack_require__(95),
    toKey = __webpack_require__(24);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function (object) {
    var objValue = get(object, path);
    return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseGet = __webpack_require__(51);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var memoizeCapped = __webpack_require__(227);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function (string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
      result.push('');
    }
  string.replace(rePropName, function (match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
  });
  return result;
});

module.exports = stringToPath;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var memoize = __webpack_require__(228);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function (key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var MapCache = __webpack_require__(46);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function memoized() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache)();
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Symbol = __webpack_require__(23),
    arrayMap = __webpack_require__(230),
    isArray = __webpack_require__(2),
    isSymbol = __webpack_require__(29);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

module.exports = baseToString;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var castPath = __webpack_require__(36),
    isArguments = __webpack_require__(48),
    isArray = __webpack_require__(2),
    isIndex = __webpack_require__(35),
    isLength = __webpack_require__(49),
    toKey = __webpack_require__(24);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}

module.exports = hasPath;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseProperty = __webpack_require__(234),
    basePropertyDeep = __webpack_require__(235),
    isKey = __webpack_require__(52),
    toKey = __webpack_require__(24);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function (object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseGet = __webpack_require__(51);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function (object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseEach = __webpack_require__(237);

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome(collection, predicate) {
  var result;

  baseEach(collection, function (value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

module.exports = baseSome;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseForOwn = __webpack_require__(238),
    createBaseEach = __webpack_require__(241);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseFor = __webpack_require__(239),
    keys = __webpack_require__(47);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createBaseFor = __webpack_require__(240);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function (object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArrayLike = __webpack_require__(50);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function (collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while (fromRight ? index-- : ++index < length) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var eq = __webpack_require__(32),
    isArrayLike = __webpack_require__(50),
    isIndex = __webpack_require__(35),
    isObject = __webpack_require__(7);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index === 'undefined' ? 'undefined' : _typeof(index);
  if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function warning() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function getAccessibilityStatus(props) {
  var a11yNumResults = props.a11yNumResults,
      a11yNumSelected = props.a11yNumSelected,
      emptyLabel = props.emptyLabel,
      isMenuShown = props.isMenuShown,
      results = props.results,
      selected = props.selected;

  // If the menu is hidden, display info about the number of selections.

  if (!isMenuShown) {
    return a11yNumSelected(selected);
  }

  // Display info about the number of matches.
  if (results.length === 0) {
    return emptyLabel;
  }

  return a11yNumResults(results);
}

exports.default = getAccessibilityStatus;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getDisplayName;
function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getMatchBounds = __webpack_require__(99);

var _getMatchBounds2 = _interopRequireDefault(_getMatchBounds);

var _getOptionLabel = __webpack_require__(54);

var _getOptionLabel2 = _interopRequireDefault(_getOptionLabel);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function getHintText(_ref) {
  var activeItem = _ref.activeItem,
      initialItem = _ref.initialItem,
      isMenuShown = _ref.isMenuShown,
      labelKey = _ref.labelKey,
      multiple = _ref.multiple,
      selected = _ref.selected,
      text = _ref.text;

  // Don't display a hint under the following conditions:
  if (
  // No text entered.
  !text ||
  // The menu is hidden.
  !isMenuShown ||
  // No item in the menu.
  !initialItem ||
  // The initial item is a custom option.
  initialItem.customOption ||
  // One of the menu items is active.
  activeItem ||
  // There's already a selection in single-select mode.
  !!selected.length && !multiple) {
    return '';
  }

  var initialItemStr = (0, _getOptionLabel2.default)(initialItem, labelKey);
  var bounds = (0, _getMatchBounds2.default)(initialItemStr.toLowerCase(), text.toLowerCase());

  if (!(bounds && bounds.start === 0)) {
    return '';
  }

  // Text matching is case- and accent-insensitive, so to display the hint
  // correctly, splice the input string with the hint string.
  return text + initialItemStr.slice(bounds.end, initialItemStr.length);
}

exports.default = getHintText;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var matchOperatorsRe = /[|\\{}()[\]^$+*?.]/g;

module.exports = function (str) {
	if (typeof str !== 'string') {
		throw new TypeError('Expected a string');
	}

	return str.replace(matchOperatorsRe, '\\$&');
};

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function invariant(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var overArg = __webpack_require__(92);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _head = __webpack_require__(55);

var _head2 = _interopRequireDefault(_head);

var _getOptionLabel = __webpack_require__(54);

var _getOptionLabel2 = _interopRequireDefault(_getOptionLabel);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function getInputText(_ref) {
  var activeItem = _ref.activeItem,
      labelKey = _ref.labelKey,
      multiple = _ref.multiple,
      selected = _ref.selected,
      text = _ref.text;

  if (activeItem) {
    // Display the input value if the pagination item is active.
    return activeItem.paginationOption ? text : (0, _getOptionLabel2.default)(activeItem, labelKey);
  }

  var selectedItem = !multiple && !!selected.length && (0, _head2.default)(selected);
  if (selectedItem) {
    return (0, _getOptionLabel2.default)(selectedItem, labelKey);
  }

  return text;
}

exports.default = getInputText;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getMenuItemId;
function getMenuItemId(position) {
  return "rbt-menu-item-" + position;
}

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Truncates the result set based on `maxResults` and returns the new set.
 */
function getTruncatedOptions(options, maxResults) {
  if (!maxResults || maxResults >= options.length) {
    return options;
  }

  return options.slice(0, maxResults);
}

exports.default = getTruncatedOptions;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isShown;
function isShown(results, props) {
  var emptyLabel = props.emptyLabel,
      minLength = props.minLength,
      showMenu = props.showMenu,
      text = props.text;

  if (!showMenu) {
    return false;
  }

  if (text.length < minLength) {
    return false;
  }

  return !!(results.length || emptyLabel);
}

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = pluralize;
/**
 * Basic util for pluralizing words. By default, simply adds an 's' to the word.
 * Also allows for a custom plural version.
 */
function pluralize(text, count, plural) {
  plural = plural || text + "s";
  return count === 1 ? "1 " + text : count + " " + plural;
}

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = preventInputBlur;
/**
 * Prevent the main input from blurring when a menu item or the clear button is
 * clicked. (#226 & #310)
 */
function preventInputBlur(e) {
  e.preventDefault();
}

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Partial polyfill for webkit `scrollIntoViewIfNeeded()` method. Addresses
 * vertical scrolling only.
 *
 * Inspired by https://gist.github.com/hsablonniere/2581101, but uses
 * `getBoundingClientRect`.
 */
function scrollIntoViewIfNeeded(node) {
  // Webkit browsers
  if (Element.prototype.scrollIntoViewIfNeeded) {
    node.scrollIntoViewIfNeeded();
    return;
  }

  // FF, IE, etc.
  var rect = node.getBoundingClientRect();
  var parent = node.parentNode;
  var parentRect = parent.getBoundingClientRect();

  var parentComputedStyle = window.getComputedStyle(parent, null);
  var parentBorderTopWidth = parseInt(parentComputedStyle.getPropertyValue('border-top-width'));

  if (rect.top < parentRect.top || rect.bottom > parentRect.bottom) {
    parent.scrollTop = node.offsetTop - parent.offsetTop - parent.clientHeight / 2 - parentBorderTopWidth + node.clientHeight / 2;
  }
}

exports.default = scrollIntoViewIfNeeded;

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var basePick = __webpack_require__(258),
    flatRest = __webpack_require__(106);

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function (object, paths) {
  return object == null ? {} : basePick(object, paths);
});

module.exports = pick;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var basePickBy = __webpack_require__(259),
    hasIn = __webpack_require__(97);

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function (value, path) {
    return hasIn(object, path);
  });
}

module.exports = basePick;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseGet = __webpack_require__(51),
    baseSet = __webpack_require__(260),
    castPath = __webpack_require__(36);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
    var index = -1,
        length = paths.length,
        result = {};

    while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
            baseSet(result, castPath(path, object), value);
        }
    }
    return result;
}

module.exports = basePickBy;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assignValue = __webpack_require__(261),
    castPath = __webpack_require__(36),
    isIndex = __webpack_require__(35),
    isObject = __webpack_require__(7),
    toKey = __webpack_require__(24);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseAssignValue = __webpack_require__(262),
    eq = __webpack_require__(32);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defineProperty = __webpack_require__(105);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseFlatten = __webpack_require__(264);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var arrayPush = __webpack_require__(88),
    isFlattenable = __webpack_require__(265);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Symbol = __webpack_require__(23),
    isArguments = __webpack_require__(48),
    isArray = __webpack_require__(2);

/** Built-in value references. */
var spreadableSymbol = _Symbol ? _Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
    return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var apply = __webpack_require__(267);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? func.length - 1 : start, 0);
  return function () {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseSetToString = __webpack_require__(269),
    shortOut = __webpack_require__(271);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var constant = __webpack_require__(270),
    defineProperty = __webpack_require__(105),
    identity = __webpack_require__(98);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function (func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function () {
    return value;
  };
}

module.exports = constant;

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function () {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var Loader = function Loader(_ref) {
  var bsSize = _ref.bsSize;
  return _react2.default.createElement('div', {
    className: (0, _classnames2.default)('rbt-loader', {
      'rbt-loader-lg': bsSize === 'large' || bsSize === 'lg',
      'rbt-loader-sm': bsSize === 'small' || bsSize === 'sm'
    })
  });
};

Loader.propTypes = {
  bsSize: _propTypes2.default.oneOf(['large', 'lg', 'small', 'sm'])
};

exports.default = Loader;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(56);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _Portal = __webpack_require__(275);

var _Portal2 = _interopRequireDefault(_Portal);

var _Popper = __webpack_require__(278);

var _Popper2 = _interopRequireDefault(_Popper);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var BODY_CLASS = 'rbt-body-container';

// When appending the overlay to `document.body`, clicking on it will register
// as an "outside" click and immediately close the overlay. This classname tells
// `react-onclickoutside` to ignore the click.
var IGNORE_CLICK_OUTSIDE = 'ignore-react-onclickoutside';

function getModifiers(_ref) {
  var align = _ref.align,
      flip = _ref.flip;

  return {
    computeStyles: {
      enabled: true,
      fn: function fn(data) {
        // Use the following condition instead of `align === 'justify'` since
        // it allows the component to fall back to justifying the menu width
        // even when `align` is undefined.
        if (align !== 'right' && align !== 'left') {
          // Set the popper width to match the target width.
          data.styles.width = data.offsets.reference.width;
        }
        return data;
      }
    },
    flip: {
      enabled: flip
    },
    preventOverflow: {
      escapeWithReference: true
    }
  };
}

function isBody(container) {
  return container === document.body;
}

/**
 * Custom `Overlay` component, since the version in `react-overlays` doesn't
 * work for our needs. Specifically, the `Position` component doesn't provide
 * the customized placement we need.
 */

var Overlay = function (_React$Component) {
  _inherits(Overlay, _React$Component);

  function Overlay() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, Overlay);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call.apply(_ref2, [this].concat(args))), _this), _this._update = function () {
      var _container$classList;

      var _this$props = _this.props,
          className = _this$props.className,
          container = _this$props.container,
          show = _this$props.show;

      // Positioning is only used when body is the container.

      if (!(show && isBody(container))) {
        return;
      }

      // Set a classname on the body for scoping purposes.
      container.classList.add(BODY_CLASS);
      !!className && (_container$classList = container.classList).add.apply(_container$classList, _toConsumableArray(className.split(' ')));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Overlay, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._update();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var onMenuHide = nextProps.onMenuHide,
          onMenuShow = nextProps.onMenuShow,
          show = nextProps.show;

      if (this.props.show && !show) {
        onMenuHide();
      }

      if (!this.props.show && show) {
        onMenuShow();
      }

      // Remove scoping classes if menu isn't being appended to document body.
      var _props = this.props,
          className = _props.className,
          container = _props.container;

      if (isBody(container) && !isBody(nextProps.container)) {
        var _container$classList2;

        container.classList.remove(BODY_CLASS);
        !!className && (_container$classList2 = container.classList).remove.apply(_container$classList2, _toConsumableArray(className.split(' ')));
      }

      this._update();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          align = _props2.align,
          children = _props2.children,
          container = _props2.container,
          dropup = _props2.dropup,
          referenceElement = _props2.referenceElement,
          show = _props2.show;

      if (!(show && _react.Children.count(children) && referenceElement)) {
        return null;
      }

      var child = _react.Children.only(children);

      var xPlacement = align === 'right' ? 'end' : 'start';
      var yPlacement = dropup ? 'top' : 'bottom';

      return _react2.default.createElement(_Portal2.default, { container: container }, _react2.default.createElement(_Popper2.default, {
        modifiers: getModifiers(this.props),
        placement: yPlacement + '-' + xPlacement,
        referenceElement: referenceElement }, function (_ref3) {
        var ref = _ref3.ref,
            props = _objectWithoutProperties(_ref3, ['ref']);

        return (0, _react.cloneElement)(child, _extends({}, child.props, props, {
          className: (0, _classnames2.default)(child.props.className, _defineProperty({}, IGNORE_CLICK_OUTSIDE, isBody(container))),
          innerRef: ref
        }));
      }));
    }
  }]);

  return Overlay;
}(_react2.default.Component);

Overlay.propTypes = {
  children: _propTypes2.default.element,
  container: _componentOrElement2.default.isRequired,
  onMenuHide: _propTypes2.default.func.isRequired,
  onMenuShow: _propTypes2.default.func.isRequired,
  referenceElement: _componentOrElement2.default,
  show: _propTypes2.default.bool
};

Overlay.defaultProps = {
  show: false
};

exports.default = Overlay;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

// Mostly taken from ReactPropTypes.

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
      }

      return null;
    }

    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}
module.exports = exports['default'];

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(56);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(6);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _getContainer = __webpack_require__(108);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(109);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _LegacyPortal = __webpack_require__(277);

var _LegacyPortal2 = _interopRequireDefault(_LegacyPortal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
 * The children of `<Portal/>` component will be appended to the `container` specified.
 */
var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.setContainer = function () {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;

      _this._portalContainerNode = (0, _getContainer2.default)(props.container, (0, _ownerDocument2.default)(_this).body);
    }, _this.getMountNode = function () {
      return _this._portalContainerNode;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Portal.prototype.componentDidMount = function componentDidMount() {
    this.setContainer();
    this.forceUpdate(this.props.onRendered);
  };

  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.container !== this.props.container) {
      this.setContainer(nextProps);
    }
  };

  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
    this._portalContainerNode = null;
  };

  Portal.prototype.render = function render() {
    return this.props.children && this._portalContainerNode ? _reactDom2.default.createPortal(this.props.children, this._portalContainerNode) : null;
  };

  return Portal;
}(_react2.default.Component);

Portal.displayName = 'Portal';
Portal.propTypes = {
  /**
   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  onRendered: _propTypes2.default.func
};
exports.default = _reactDom2.default.createPortal ? Portal : _LegacyPortal2.default;
module.exports = exports['default'];

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = ownerDocument;

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

module.exports = exports["default"];

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(56);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(6);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _getContainer = __webpack_require__(108);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(109);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
 * The children of `<Portal/>` component will be appended to the `container` specified.
 */
var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._mountOverlayTarget = function () {
      if (!_this._overlayTarget) {
        _this._overlayTarget = document.createElement('div');
        _this._portalContainerNode = (0, _getContainer2.default)(_this.props.container, (0, _ownerDocument2.default)(_this).body);
        _this._portalContainerNode.appendChild(_this._overlayTarget);
      }
    }, _this._unmountOverlayTarget = function () {
      if (_this._overlayTarget) {
        _this._portalContainerNode.removeChild(_this._overlayTarget);
        _this._overlayTarget = null;
      }
      _this._portalContainerNode = null;
    }, _this._renderOverlay = function () {
      var overlay = !_this.props.children ? null : _react2.default.Children.only(_this.props.children);

      // Save reference for future access.
      if (overlay !== null) {
        _this._mountOverlayTarget();

        var initialRender = !_this._overlayInstance;

        _this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(_this, overlay, _this._overlayTarget, function () {
          if (initialRender && _this.props.onRendered) {
            _this.props.onRendered();
          }
        });
      } else {
        // Unrender if the component is null for transitions to null
        _this._unrenderOverlay();
        _this._unmountOverlayTarget();
      }
    }, _this._unrenderOverlay = function () {
      if (_this._overlayTarget) {
        _reactDom2.default.unmountComponentAtNode(_this._overlayTarget);
        _this._overlayInstance = null;
      }
    }, _this.getMountNode = function () {
      return _this._overlayTarget;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Portal.prototype.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    this._renderOverlay();
  };

  Portal.prototype.componentDidUpdate = function componentDidUpdate() {
    this._renderOverlay();
  };

  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this._overlayTarget && nextProps.container !== this.props.container) {
      this._portalContainerNode.removeChild(this._overlayTarget);
      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
      this._portalContainerNode.appendChild(this._overlayTarget);
    }
  };

  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
    this._isMounted = false;
    this._unrenderOverlay();
    this._unmountOverlayTarget();
  };

  Portal.prototype.render = function render() {
    return null;
  };

  return Portal;
}(_react2.default.Component);

Portal.displayName = 'Portal';
Portal.propTypes = {
  /**
   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  onRendered: _propTypes2.default.func
};
exports.default = Portal;
module.exports = exports['default'];

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.placements = exports.InnerPopper = undefined;

var _extends2 = __webpack_require__(110);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(118);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(119);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(125);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = Popper;

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _popper = __webpack_require__(316);

var _popper2 = _interopRequireDefault(_popper);

var _Manager = __webpack_require__(317);

var _utils = __webpack_require__(323);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var initialStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  opacity: 0,
  pointerEvents: 'none'
};

var initialArrowStyle = {};

var InnerPopper = exports.InnerPopper = function (_React$Component) {
  (0, _inherits3.default)(InnerPopper, _React$Component);

  function InnerPopper() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, InnerPopper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      data: undefined,
      placement: undefined
    }, _this.popperNode = null, _this.arrowNode = null, _this.setPopperNode = function (popperNode) {
      if (_this.popperNode === popperNode) return;

      (0, _utils.safeInvoke)(_this.props.innerRef, popperNode);
      _this.popperNode = popperNode;

      _this.updatePopperInstance();
    }, _this.setArrowNode = function (arrowNode) {
      if (_this.arrowNode === arrowNode) return;
      _this.arrowNode = arrowNode;

      if (!_this.popperInstance) _this.updatePopperInstance();
    }, _this.updateStateModifier = {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        var placement = data.placement;

        _this.setState({ data: data, placement: placement }, placement !== _this.state.placement ? _this.scheduleUpdate : undefined);
        return data;
      }
    }, _this.getOptions = function () {
      return {
        placement: _this.props.placement,
        eventsEnabled: _this.props.eventsEnabled,
        positionFixed: _this.props.positionFixed,
        modifiers: (0, _extends3.default)({}, _this.props.modifiers, {
          arrow: (0, _extends3.default)({}, _this.props.modifiers && _this.props.modifiers.arrow, {
            enabled: !!_this.arrowNode,
            element: _this.arrowNode
          }),
          applyStyle: { enabled: false },
          updateStateModifier: _this.updateStateModifier
        })
      };
    }, _this.getPopperStyle = function () {
      return !_this.popperNode || !_this.state.data ? initialStyle : (0, _extends3.default)({
        position: _this.state.data.offsets.popper.position
      }, _this.state.data.styles);
    }, _this.getPopperPlacement = function () {
      return !_this.state.data ? undefined : _this.state.placement;
    }, _this.getArrowStyle = function () {
      return !_this.arrowNode || !_this.state.data ? initialArrowStyle : _this.state.data.arrowStyles;
    }, _this.getOutOfBoundariesState = function () {
      return _this.state.data ? _this.state.data.hide : undefined;
    }, _this.destroyPopperInstance = function () {
      if (!_this.popperInstance) return;

      _this.popperInstance.destroy();
      _this.popperInstance = null;
    }, _this.updatePopperInstance = function () {
      _this.destroyPopperInstance();

      var _this2 = _this,
          popperNode = _this2.popperNode;
      var referenceElement = _this.props.referenceElement;

      if (!referenceElement || !popperNode) return;

      _this.popperInstance = new _popper2.default(referenceElement, popperNode, _this.getOptions());
    }, _this.scheduleUpdate = function () {
      if (_this.popperInstance) {
        _this.popperInstance.scheduleUpdate();
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  InnerPopper.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    // If the Popper.js options have changed, update the instance (destroy + create)
    if (this.props.placement !== prevProps.placement || this.props.referenceElement !== prevProps.referenceElement || this.props.positionFixed !== prevProps.positionFixed) {
      this.updatePopperInstance();
    } else if (this.props.eventsEnabled !== prevProps.eventsEnabled && this.popperInstance) {
      this.props.eventsEnabled ? this.popperInstance.enableEventListeners() : this.popperInstance.disableEventListeners();
    }

    // A placement difference in state means popper determined a new placement
    // apart from the props value. By the time the popper element is rendered with
    // the new position Popper has already measured it, if the place change triggers
    // a size change it will result in a misaligned popper. So we schedule an update to be sure.
    if (prevState.placement !== this.state.placement) {
      this.scheduleUpdate();
    }
  };

  InnerPopper.prototype.componentWillUnmount = function componentWillUnmount() {
    this.destroyPopperInstance();
  };

  InnerPopper.prototype.render = function render() {
    return (0, _utils.unwrapArray)(this.props.children)({
      ref: this.setPopperNode,
      style: this.getPopperStyle(),
      placement: this.getPopperPlacement(),
      outOfBoundaries: this.getOutOfBoundariesState(),
      scheduleUpdate: this.scheduleUpdate,
      arrowProps: {
        ref: this.setArrowNode,
        style: this.getArrowStyle()
      }
    });
  };

  return InnerPopper;
}(React.Component);

InnerPopper.defaultProps = {
  placement: 'bottom',
  eventsEnabled: true,
  referenceElement: undefined,
  positionFixed: false
};

var placements = _popper2.default.placements;
exports.placements = placements;
function Popper(props) {
  return React.createElement(_Manager.ManagerContext.Consumer, null, function (_ref) {
    var referenceNode = _ref.referenceNode;
    return React.createElement(InnerPopper, (0, _extends3.default)({ referenceElement: referenceNode }, props));
  });
}

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { "default": __webpack_require__(280), __esModule: true };

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(281);
module.exports = __webpack_require__(15).Object.assign;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(25);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(283) });

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)

var getKeys = __webpack_require__(38);
var gOPS = __webpack_require__(63);
var pIE = __webpack_require__(40);
var toObject = __webpack_require__(117);
var IObject = __webpack_require__(115);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(27)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) {
    B[k] = k;
  });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) {
  // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
    }
  }return T;
} : $assign;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(20);
var toLength = __webpack_require__(285);
var toAbsoluteIndex = __webpack_require__(286);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
      // Array#indexOf ignores holes, Array#includes - not
    } else for (; length > index; index++) {
      if (IS_INCLUDES || index in O) {
        if (O[index] === el) return IS_INCLUDES || index || 0;
      }
    }return !IS_INCLUDES && -1;
  };
};

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 7.1.15 ToLength
var toInteger = __webpack_require__(59);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toInteger = __webpack_require__(59);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { "default": __webpack_require__(288), __esModule: true };

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(289);
__webpack_require__(295);
module.exports = __webpack_require__(68).f('iterator');

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $at = __webpack_require__(290)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(121)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0; // next index
  // 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toInteger = __webpack_require__(59);
var defined = __webpack_require__(58);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var create = __webpack_require__(66);
var descriptor = __webpack_require__(37);
var setToStringTag = __webpack_require__(67);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(16)(IteratorPrototype, __webpack_require__(21)('iterator'), function () {
  return this;
});

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var dP = __webpack_require__(17);
var anObject = __webpack_require__(26);
var getKeys = __webpack_require__(38);

module.exports = __webpack_require__(19) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) {
    dP.f(O, P = keys[i++], Properties[P]);
  }return O;
};

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var document = __webpack_require__(10).document;
module.exports = document && document.documentElement;

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(13);
var toObject = __webpack_require__(117);
var IE_PROTO = __webpack_require__(60)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  }return O instanceof Object ? ObjectProto : null;
};

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(296);
var global = __webpack_require__(10);
var hide = __webpack_require__(16);
var Iterators = __webpack_require__(65);
var TO_STRING_TAG = __webpack_require__(21)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' + 'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' + 'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' + 'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' + 'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var addToUnscopables = __webpack_require__(297);
var step = __webpack_require__(298);
var Iterators = __webpack_require__(65);
var toIObject = __webpack_require__(20);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(121)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0; // next index
  this._k = kind; // kind
  // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {/* empty */};

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (done, value) {
  return { value: value, done: !!done };
};

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { "default": __webpack_require__(300), __esModule: true };

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(301);
__webpack_require__(306);
__webpack_require__(307);
__webpack_require__(308);
module.exports = __webpack_require__(15).Symbol;

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var global = __webpack_require__(10);
var has = __webpack_require__(13);
var DESCRIPTORS = __webpack_require__(19);
var $export = __webpack_require__(25);
var redefine = __webpack_require__(122);
var META = __webpack_require__(302).KEY;
var $fails = __webpack_require__(27);
var shared = __webpack_require__(61);
var setToStringTag = __webpack_require__(67);
var uid = __webpack_require__(39);
var wks = __webpack_require__(21);
var wksExt = __webpack_require__(68);
var wksDefine = __webpack_require__(69);
var enumKeys = __webpack_require__(303);
var isArray = __webpack_require__(304);
var anObject = __webpack_require__(26);
var isObject = __webpack_require__(18);
var toIObject = __webpack_require__(20);
var toPrimitive = __webpack_require__(57);
var createDesc = __webpack_require__(37);
var _create = __webpack_require__(66);
var gOPNExt = __webpack_require__(305);
var $GOPD = __webpack_require__(124);
var $DP = __webpack_require__(17);
var $keys = __webpack_require__(38);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function get() {
      return dP(this, 'a', { value: 7 }).a;
    }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function wrap(tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && _typeof($Symbol.iterator) == 'symbol' ? function (it) {
  return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    }return setSymbolDesc(it, key, D);
  }return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) {
    $defineProperty(it, key = keys[i++], P[key]);
  }return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  }return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  }return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function _Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function $set(value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(123).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(40).f = $propertyIsEnumerable;
  __webpack_require__(63).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(64)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols =
// 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), j = 0; es6Symbols.length > j;) {
  wks(es6Symbols[j++]);
}for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) {
  wksDefine(wellKnownSymbols[k++]);
}$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function _for(key) {
    return has(SymbolRegistry, key += '') ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) {
      if (SymbolRegistry[key] === sym) return key;
    }
  },
  useSetter: function useSetter() {
    setter = true;
  },
  useSimple: function useSimple() {
    setter = false;
  }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) {
      args.push(arguments[i++]);
    }$replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function replacer(key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(16)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var META = __webpack_require__(39)('meta');
var isObject = __webpack_require__(18);
var has = __webpack_require__(13);
var setDesc = __webpack_require__(17).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(27)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function setMeta(it) {
  setDesc(it, META, { value: {
      i: 'O' + ++id, // object ID
      w: {} // weak collections IDs
    } });
};
var fastKey = function fastKey(it, create) {
  // return primitive with prefix
  if (!isObject(it)) return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
    // return object ID
  }return it[META].i;
};
var getWeak = function getWeak(it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
    // return hash weak collections IDs
  }return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function onFreeze(it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(38);
var gOPS = __webpack_require__(63);
var pIE = __webpack_require__(40);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) {
      if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
  }return result;
};

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 7.2.2 IsArray(argument)
var cof = __webpack_require__(116);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(20);
var gOPN = __webpack_require__(123).f;
var toString = {}.toString;

var windowNames = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function getWindowNames(it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(69)('asyncIterator');

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(69)('observable');

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { "default": __webpack_require__(310), __esModule: true };

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(311);
module.exports = __webpack_require__(15).Object.setPrototypeOf;

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(25);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(312).set });

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(18);
var anObject = __webpack_require__(26);
var check = function check(O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
  function (test, buggy, set) {
    try {
      set = __webpack_require__(111)(Function.call, __webpack_require__(124).f(Object.prototype, '__proto__').set, 2);
      set(test, []);
      buggy = !(test instanceof Array);
    } catch (e) {
      buggy = true;
    }
    return function setPrototypeOf(O, proto) {
      check(O, proto);
      if (buggy) O.__proto__ = proto;else set(O, proto);
      return O;
    };
  }({}, false) : undefined),
  check: check
};

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { "default": __webpack_require__(314), __esModule: true };

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(315);
var $Object = __webpack_require__(15).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(25);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(66) });

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.14.6
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;
for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineProperty = function defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  return isFixed(getParentNode(element));
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthOddness = reference.width % 2 === popper.width % 2;
  var bothOddWidth = reference.width % 2 === 1 && popper.width % 2 === 1;
  var noRound = function noRound(v) {
    return v;
  };

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthOddness ? Math.round : Math.floor;
  var verticalToInteger = !shouldRound ? noRound : Math.round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport'
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
   * @param {HTMLElement} popper - The HTML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */

    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */

Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

exports.default = Popper;
//# sourceMappingURL=popper.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ManagerContext = undefined;

var _extends2 = __webpack_require__(110);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(118);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(119);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(125);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _createReactContext = __webpack_require__(318);

var _createReactContext2 = _interopRequireDefault(_createReactContext);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var ManagerContext = exports.ManagerContext = (0, _createReactContext2.default)({ getReferenceRef: undefined, referenceNode: undefined });

var Manager = function (_React$Component) {
  (0, _inherits3.default)(Manager, _React$Component);

  function Manager() {
    (0, _classCallCheck3.default)(this, Manager);

    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this));

    _this.getReferenceRef = function (referenceNode) {
      return _this.setState(function (_ref) {
        var context = _ref.context;
        return {
          context: (0, _extends3.default)({}, context, { referenceNode: referenceNode })
        };
      });
    };

    _this.state = {
      context: {
        getReferenceRef: _this.getReferenceRef,
        referenceNode: undefined
      }
    };
    return _this;
  }

  Manager.prototype.render = function render() {
    return React.createElement(ManagerContext.Provider, { value: this.state.context }, this.props.children);
  };

  return Manager;
}(React.Component);

exports.default = Manager;

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _implementation = __webpack_require__(319);

var _implementation2 = _interopRequireDefault(_implementation);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = _react2.default.createContext || _implementation2.default;
module.exports = exports['default'];

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _gud = __webpack_require__(320);

var _gud2 = _interopRequireDefault(_gud);

var _warning = __webpack_require__(321);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var MAX_SIGNED_31_BIT_INT = 1073741823;

// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    function Provider() {
      var _temp, _this, _ret;

      _classCallCheck(this, Provider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
    }

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits = void 0;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0; // No change
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
          if (false) {
            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    Provider.prototype.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(_react.Component);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);

  var Consumer = function (_Component2) {
    _inherits(Consumer, _Component2);

    function Consumer() {
      var _temp2, _this2, _ret2;

      _classCallCheck(this, Consumer);

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
        value: _this2.getValue()
      }, _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;
        if ((observedBits & changedBits) !== 0) {
          _this2.setState({ value: _this2.getValue() });
        }
      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }
      var observedBits = this.props.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    Consumer.prototype.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    Consumer.prototype.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(_react.Component);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);

  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

exports.default = createReactContext;
module.exports = exports['default'];

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var key = '__global_unique_id__';

module.exports = function () {
  return global[key] = (global[key] || 0) + 1;
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(322);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = exports.unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};

/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */
var safeInvoke = exports.safeInvoke = function safeInvoke(fn) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  if (typeof fn === "function") {
    return fn.apply(undefined, args);
  }
};

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _AutosizeInput = __webpack_require__(325);

var _AutosizeInput2 = _interopRequireDefault(_AutosizeInput);

var _Token = __webpack_require__(126);

var _Token2 = _interopRequireDefault(_Token);

var _utils = __webpack_require__(3);

var _hintContainer = __webpack_require__(129);

var _hintContainer2 = _interopRequireDefault(_hintContainer);

var _inputContainer = __webpack_require__(130);

var _inputContainer2 = _interopRequireDefault(_inputContainer);

var _keyCode = __webpack_require__(22);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var HintedAutosizeInput = (0, _hintContainer2.default)(_AutosizeInput2.default);

var TypeaheadInputMulti = function (_React$Component) {
  _inherits(TypeaheadInputMulti, _React$Component);

  function TypeaheadInputMulti() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TypeaheadInputMulti);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TypeaheadInputMulti.__proto__ || Object.getPrototypeOf(TypeaheadInputMulti)).call.apply(_ref, [this].concat(args))), _this), _this._renderToken = function (option, idx) {
      var _this$props = _this.props,
          _onRemove = _this$props.onRemove,
          renderToken = _this$props.renderToken;

      var props = _extends({}, _this.props, {
        onRemove: function onRemove() {
          return _onRemove(option);
        }
      });

      return renderToken(option, props, idx);
    }, _this._handleContainerClickOrFocus = function (e) {
      // Don't focus the input if it's disabled.
      if (_this.props.disabled) {
        e.target.blur();
        return;
      }

      // Move cursor to the end if the user clicks outside the actual input.
      var inputNode = _this._input;
      if (e.target !== inputNode) {
        inputNode.selectionStart = inputNode.value.length;
      }

      inputNode.focus();
    }, _this._handleKeyDown = function (e) {
      var _this$props2 = _this.props,
          onKeyDown = _this$props2.onKeyDown,
          selected = _this$props2.selected,
          value = _this$props2.value;

      switch (e.keyCode) {
        case _keyCode.BACKSPACE:
          if (e.target === _this._input && selected.length && !value) {
            // If the input is selected and there is no text, focus the last
            // token when the user hits backspace.
            var children = _this._wrapper.children;
            var lastToken = children[children.length - 2];
            lastToken && lastToken.focus();
          }
          break;
      }

      onKeyDown(e);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TypeaheadInputMulti, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          inputClassName = _props.inputClassName,
          labelKey = _props.labelKey,
          onRemove = _props.onRemove,
          renderToken = _props.renderToken,
          selected = _props.selected,
          props = _objectWithoutProperties(_props, ['className', 'inputClassName', 'labelKey', 'onRemove', 'renderToken', 'selected']);

      return (
        /* eslint-disable jsx-a11y/no-static-element-interactions */
        /* eslint-disable jsx-a11y/click-events-have-key-events */
        _react2.default.createElement('div', {
          className: (0, _classnames2.default)('form-control', 'rbt-input-multi', className),
          disabled: props.disabled,
          onClick: this._handleContainerClickOrFocus,
          onFocus: this._handleContainerClickOrFocus,
          tabIndex: -1 }, _react2.default.createElement('div', { className: 'rbt-input-wrapper', ref: function ref(el) {
            return _this2._wrapper = el;
          } }, selected.map(this._renderToken), _react2.default.createElement(HintedAutosizeInput, _extends({}, props, {
          inputClassName: (0, _classnames2.default)('rbt-input-main', inputClassName),
          inputRef: function inputRef(input) {
            _this2._input = input;
            _this2.props.inputRef(input);
          },
          inputStyle: {
            backgroundColor: 'transparent',
            border: 0,
            boxShadow: 'none',
            cursor: 'inherit',
            outline: 'none',
            padding: 0
          },
          onKeyDown: this._handleKeyDown,
          style: {
            position: 'relative',
            zIndex: 1
          }
        }))))
        /* eslint-enable jsx-a11y/no-static-element-interactions */
        /* eslint-enable jsx-a11y/click-events-have-key-events */

      );
    }

    /**
     * Forward click or focus events on the container element to the input.
     */

  }]);

  return TypeaheadInputMulti;
}(_react2.default.Component);

TypeaheadInputMulti.propTypes = {
  /**
   * Provides a hook for customized rendering of tokens when multiple
   * selections are enabled.
   */
  renderToken: _propTypes2.default.func
};

TypeaheadInputMulti.defaultProps = {
  renderToken: function renderToken(option, props, idx) {
    return _react2.default.createElement(_Token2.default, {
      disabled: props.disabled,
      key: idx,
      onRemove: props.onRemove,
      tabIndex: props.tabIndex }, (0, _utils.getOptionLabel)(option, props.labelKey));
  }
};

exports.default = (0, _inputContainer2.default)(TypeaheadInputMulti);

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var SIZER_STYLE = {
  height: 0,
  left: 0,
  overflow: 'scroll',
  position: 'absolute',
  top: 0,
  visibility: 'hidden',
  whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['inputClassName', 'inputRef', 'inputStyle'];

var MIN_WIDTH = 1;

var cleanInputProps = function cleanInputProps(inputProps) {
  INPUT_PROPS_BLACKLIST.forEach(function (field) {
    return delete inputProps[field];
  });
  return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
  node.style.fontSize = styles.fontSize;
  node.style.fontFamily = styles.fontFamily;
  node.style.fontWeight = styles.fontWeight;
  node.style.fontStyle = styles.fontStyle;
  node.style.letterSpacing = styles.letterSpacing;
  node.style.textTransform = styles.textTransform;
};

var AutosizeInput = function (_React$Component) {
  _inherits(AutosizeInput, _React$Component);

  function AutosizeInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AutosizeInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      inputWidth: MIN_WIDTH
    }, _this._copyInputStyles = function () {
      var inputStyles = _this._input && window.getComputedStyle && window.getComputedStyle(_this._input);

      if (!inputStyles) {
        return;
      }

      copyStyles(inputStyles, _this._sizer);

      if (_this._placeHolderSizer) {
        copyStyles(inputStyles, _this._placeHolderSizer);
      }
    }, _this._updateInputWidth = function () {
      if (!_this._sizer || _this._sizer.scrollWidth === undefined) {
        return;
      }

      _this._copyInputStyles();

      var placeholderWidth = _this._placeHolderSizer && _this._placeHolderSizer.scrollWidth || MIN_WIDTH;

      var inputWidth = Math.max(_this._sizer.scrollWidth, placeholderWidth) + 2;

      if (inputWidth !== _this.state.inputWidth) {
        _this.setState({ inputWidth: inputWidth });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AutosizeInput, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._updateInputWidth();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      this._updateInputWidth();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          defaultValue = _props.defaultValue,
          placeholder = _props.placeholder,
          value = _props.value;

      var wrapperStyle = _extends({}, this.props.style);
      if (!wrapperStyle.display) {
        wrapperStyle.display = 'inline-block';
      }

      var inputProps = cleanInputProps(_extends({}, this.props, {
        className: this.props.inputClassName,
        style: _extends({}, this.props.inputStyle, {
          boxSizing: 'content-box',
          width: this.state.inputWidth + 'px'
        })
      }));

      return _react2.default.createElement('div', { className: className, style: wrapperStyle }, _react2.default.createElement('input', _extends({}, inputProps, {
        ref: function ref(el) {
          _this2._input = el;
          if (typeof _this2.props.inputRef === 'function') {
            _this2.props.inputRef(el);
          }
        }
      })), _react2.default.createElement('div', {
        ref: function ref(el) {
          return _this2._sizer = el;
        },
        style: SIZER_STYLE }, defaultValue || value || ''), placeholder ? _react2.default.createElement('div', {
        ref: function ref(el) {
          return _this2._placeHolderSizer = el;
        },
        style: SIZER_STYLE }, placeholder) : null);
    }
  }]);

  return AutosizeInput;
}(_react2.default.Component);

AutosizeInput.propTypes = {
  /**
   * ClassName for the input element.
   */
  inputClassName: _propTypes2.default.string,
  /**
   * Ref callback for the input element.
   */
  inputRef: _propTypes2.default.func,
  /**
   * CSS styles for the input element.
   */
  inputStyle: _propTypes2.default.object
};

exports.default = AutosizeInput;

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _hintContainer = __webpack_require__(129);

var _hintContainer2 = _interopRequireDefault(_hintContainer);

var _inputContainer = __webpack_require__(130);

var _inputContainer2 = _interopRequireDefault(_inputContainer);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var TypeaheadInputSingle = function (_React$Component) {
  _inherits(TypeaheadInputSingle, _React$Component);

  function TypeaheadInputSingle() {
    _classCallCheck(this, TypeaheadInputSingle);

    return _possibleConstructorReturn(this, (TypeaheadInputSingle.__proto__ || Object.getPrototypeOf(TypeaheadInputSingle)).apply(this, arguments));
  }

  _createClass(TypeaheadInputSingle, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          inputRef = _props.inputRef,
          props = _objectWithoutProperties(_props, ['className', 'inputRef']);

      return _react2.default.createElement('input', _extends({}, props, {
        className: (0, _classnames2.default)('rbt-input-main', 'form-control', className),
        ref: inputRef,
        type: 'text'
      }));
    }
  }]);

  return TypeaheadInputSingle;
}(_react2.default.Component);

exports.default = (0, _inputContainer2.default)((0, _hintContainer2.default)(TypeaheadInputSingle));

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isRequiredForA11y;
function isRequiredForA11y(validator) {
  return function validate(props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
    }

    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      args[_key - 5] = arguments[_key];
    }

    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
  };
}
module.exports = exports['default'];

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _flowRight = __webpack_require__(329);

var _flowRight2 = _interopRequireDefault(_flowRight);

var _head = __webpack_require__(55);

var _head2 = _interopRequireDefault(_head);

var _isEqual = __webpack_require__(83);

var _isEqual2 = _interopRequireDefault(_isEqual);

var _noop = __webpack_require__(71);

var _noop2 = _interopRequireDefault(_noop);

var _uniqueId = __webpack_require__(337);

var _uniqueId2 = _interopRequireDefault(_uniqueId);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactOnclickoutside = __webpack_require__(128);

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _highlightOnlyResultContainer = __webpack_require__(338);

var _highlightOnlyResultContainer2 = _interopRequireDefault(_highlightOnlyResultContainer);

var _propTypes3 = __webpack_require__(339);

var _utils = __webpack_require__(3);

var _defaultLabelKey = __webpack_require__(102);

var _keyCode = __webpack_require__(22);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function genId() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return prefix + Math.random().toString(36).substr(2, 12);
}

function getInitialState(props) {
  var defaultInputValue = props.defaultInputValue,
      defaultSelected = props.defaultSelected,
      maxResults = props.maxResults,
      multiple = props.multiple;

  var selected = props.selected ? props.selected.slice() : defaultSelected.slice();

  var text = defaultInputValue;

  if (!multiple && selected.length) {
    // Set the text if an initial selection is passed in.
    text = (0, _utils.getOptionLabel)((0, _head2.default)(selected), props.labelKey);

    if (selected.length > 1) {
      // Limit to 1 selection in single-select mode.
      selected = selected.slice(0, 1);
    }
  }

  return {
    activeIndex: -1,
    activeItem: null,
    initialItem: null,
    selected: selected,
    showMenu: false,
    shownResults: maxResults,
    text: text
  };
}

function typeaheadContainer(Typeahead) {
  // Nested HOCs to encapsulate behaviors. In order from outer to inner.
  Typeahead = (0, _flowRight2.default)(_highlightOnlyResultContainer2.default)(Typeahead);

  var WrappedTypeahead = function (_React$Component) {
    _inherits(WrappedTypeahead, _React$Component);

    function WrappedTypeahead(props) {
      _classCallCheck(this, WrappedTypeahead);

      var _this = _possibleConstructorReturn(this, (WrappedTypeahead.__proto__ || Object.getPrototypeOf(WrappedTypeahead)).call(this, props));

      _this.blur = function () {
        _this.getInput().blur();
        _this._hideMenu();
      };

      _this.clear = function () {
        _this.setState(_extends({}, getInitialState(_this.props), {
          selected: [],
          text: ''
        }));
      };

      _this.focus = function () {
        _this.getInput().focus();
      };

      _this.getInput = function () {
        return _this._input;
      };

      _this._handleActiveIndexChange = function (activeIndex) {
        var newState = { activeIndex: activeIndex };

        if (activeIndex === -1) {
          // Reset the active item if there is no active index.
          newState.activeItem = null;
        }

        _this.setState(newState);
      };

      _this._handleActiveItemChange = function (activeItem) {
        _this.setState({ activeItem: activeItem });
      };

      _this._handleClear = function () {
        _this.clear();
        _this._updateSelected([]);
      };

      _this._handleFocus = function (e) {
        _this.setState({ showMenu: true }, function () {
          return _this.props.onFocus(e);
        });
      };

      _this._handleInitialItemChange = function (initialItem) {
        var labelKey = _this.props.labelKey;

        var currentItem = _this.state.initialItem;

        // Don't update the initial item if it hasn't changed. For custom items,
        // compare the `labelKey` values since a unique id is generated each time,
        // causing the comparison to always return false otherwise.
        if ((0, _isEqual2.default)(initialItem, currentItem) || currentItem && initialItem && initialItem.customOption && initialItem[labelKey] === currentItem[labelKey]) {
          return;
        }

        _this.setState({ initialItem: initialItem });
      };

      _this._handleInputChange = function (e) {
        e.persist();

        var text = e.target.value;

        var _getInitialState = getInitialState(_this.props),
            activeIndex = _getInitialState.activeIndex,
            activeItem = _getInitialState.activeItem,
            shownResults = _getInitialState.shownResults;

        var _this$props = _this.props,
            multiple = _this$props.multiple,
            onInputChange = _this$props.onInputChange;

        _this.setState({
          activeIndex: activeIndex,
          activeItem: activeItem,
          showMenu: true,
          shownResults: shownResults,
          text: text
        }, function () {
          return onInputChange(text, e);
        });

        // Clear any selections if text is entered in single-select mode.
        if (_this.state.selected.length && !multiple) {
          _this._updateSelected([]);
        }
      };

      _this._handleKeyDown = function (e, results, isMenuShown) {
        var activeItem = _this.state.activeItem;

        switch (e.keyCode) {
          case _keyCode.UP:
          case _keyCode.DOWN:
            if (!isMenuShown) {
              _this._showMenu();
              break;
            }

            var activeIndex = _this.state.activeIndex;

            // Prevents input cursor from going to the beginning when pressing up.

            e.preventDefault();

            // Increment or decrement index based on user keystroke.
            activeIndex += e.keyCode === _keyCode.UP ? -1 : 1;

            // Skip over any disabled options.
            while (results[activeIndex] && results[activeIndex].disabled) {
              activeIndex += e.keyCode === _keyCode.UP ? -1 : 1;
            }

            // If we've reached the end, go back to the beginning or vice-versa.
            if (activeIndex === results.length) {
              activeIndex = -1;
            } else if (activeIndex === -2) {
              activeIndex = results.length - 1;
            }

            _this._handleActiveIndexChange(activeIndex);
            break;
          case _keyCode.ESC:
            isMenuShown && _this._hideMenu();
            break;
          case _keyCode.RETURN:
            if (!isMenuShown) {
              break;
            }

            // Prevent form submission while menu is open.
            e.preventDefault();
            activeItem && _this._handleMenuItemSelect(activeItem, e);
            break;
          case _keyCode.RIGHT:
          case _keyCode.TAB:
            if (!isMenuShown) {
              break;
            }

            if (activeItem && !activeItem.paginationOption) {
              // Prevent blurring when selecting the active item.
              e.keyCode === _keyCode.TAB && e.preventDefault();
              _this._handleSelectionAdd(activeItem);
              break;
            }

            if (e.keyCode === _keyCode.TAB) {
              _this._hideMenu();
            }
            break;
        }

        _this.props.onKeyDown(e);
      };

      _this._handleMenuItemSelect = function (option, e) {
        if (option.paginationOption) {
          _this._handlePaginate(e);
        } else {
          _this._handleSelectionAdd(option);
        }
      };

      _this._handlePaginate = function (e) {
        e.persist();
        var _this$props2 = _this.props,
            maxResults = _this$props2.maxResults,
            onPaginate = _this$props2.onPaginate;

        var shownResults = _this.state.shownResults + maxResults;

        _this.setState({ shownResults: shownResults }, function () {
          return onPaginate(e, shownResults);
        });
      };

      _this._handleSelectionAdd = function (selection) {
        var _this$props3 = _this.props,
            multiple = _this$props3.multiple,
            labelKey = _this$props3.labelKey;

        var selected = void 0;
        var text = void 0;

        if (multiple) {
          // If multiple selections are allowed, add the new selection to the
          // existing selections.
          selected = _this.state.selected.concat(selection);
          text = '';
        } else {
          // If only a single selection is allowed, replace the existing selection
          // with the new one.
          selected = [selection];
          text = (0, _utils.getOptionLabel)(selection, labelKey);
        }

        _this._hideMenu();
        _this.setState({
          initialItem: selection,
          text: text
        });

        // Text must be updated before the selection to fix #211.
        // TODO: Find a more robust way of solving the issue.
        _this._updateSelected(selected);
      };

      _this._handleSelectionRemove = function (selection) {
        var selected = _this.state.selected.filter(function (option) {
          return !(0, _isEqual2.default)(option, selection);
        });

        // Make sure the input stays focused after the item is removed.
        _this.focus();
        _this._hideMenu();
        _this._updateSelected(selected);
      };

      _this.handleClickOutside = function (e) {
        _this.state.showMenu && _this._hideMenu();
      };

      _this._hideMenu = function () {
        var _getInitialState2 = getInitialState(_this.props),
            activeIndex = _getInitialState2.activeIndex,
            activeItem = _getInitialState2.activeItem,
            showMenu = _getInitialState2.showMenu,
            shownResults = _getInitialState2.shownResults;

        _this.setState({
          activeIndex: activeIndex,
          activeItem: activeItem,
          showMenu: showMenu,
          shownResults: shownResults
        });
      };

      _this._showMenu = function () {
        _this.setState({ showMenu: true });
      };

      _this._updateSelected = function (selected) {
        _this.setState({ selected: selected }, function () {
          return _this.props.onChange(selected);
        });
      };

      _this.state = getInitialState(props);
      return _this;
    }

    _createClass(WrappedTypeahead, [{
      key: 'getChildContext',
      value: function getChildContext() {
        return {
          activeIndex: this.state.activeIndex,
          onActiveItemChange: this._handleActiveItemChange,
          onInitialItemChange: this._handleInitialItemChange,
          onMenuItemClick: this._handleMenuItemSelect
        };
      }
    }, {
      key: 'componentWillMount',
      value: function componentWillMount() {
        // Generate random id here since doing it in defaultProps will generate
        // the same id for every instance.
        this._menuId = genId('rbt-menu-');
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.props.autoFocus && this.focus();
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var labelKey = nextProps.labelKey,
            multiple = nextProps.multiple,
            selected = nextProps.selected;

        // If new selections are passed via props, treat as a controlled input.

        if (selected && !(0, _isEqual2.default)(selected, this.state.selected)) {
          this.setState({ selected: selected });

          if (multiple) {
            return;
          }

          this.setState({
            text: selected.length ? (0, _utils.getOptionLabel)((0, _head2.default)(selected), labelKey) : ''
          });
        }

        // Truncate selections when in single-select mode.
        var newSelected = selected || this.state.selected;
        if (!multiple && newSelected.length > 1) {
          newSelected = newSelected.slice(0, 1);
          this.setState({
            selected: newSelected,
            text: (0, _utils.getOptionLabel)((0, _head2.default)(newSelected), labelKey)
          });
          return;
        }

        if (multiple !== this.props.multiple) {
          this.setState({ text: '' });
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var mergedPropsAndState = _extends({}, this.props, this.state);

        var filterBy = mergedPropsAndState.filterBy,
            labelKey = mergedPropsAndState.labelKey,
            minLength = mergedPropsAndState.minLength,
            options = mergedPropsAndState.options,
            paginate = mergedPropsAndState.paginate,
            paginationText = mergedPropsAndState.paginationText,
            shownResults = mergedPropsAndState.shownResults,
            text = mergedPropsAndState.text;

        var results = [];
        if (text.length >= minLength) {
          var cb = Array.isArray(filterBy) ? _utils.defaultFilterBy : filterBy;
          results = options.filter(function (option) {
            return cb(option, mergedPropsAndState);
          });
        }

        // This must come before results are truncated.
        var shouldPaginate = paginate && results.length > shownResults;

        // Truncate results if necessary.
        results = (0, _utils.getTruncatedOptions)(results, shownResults);

        // Add the custom option if necessary.
        if ((0, _utils.addCustomOption)(results, mergedPropsAndState)) {
          results.push(_defineProperty({
            customOption: true,
            id: (0, _uniqueId2.default)('new-id-')
          }, (0, _utils.getStringLabelKey)(labelKey), text));
        }

        // Add the pagination item if necessary.
        if (shouldPaginate) {
          var _results$push2;

          results.push((_results$push2 = {}, _defineProperty(_results$push2, (0, _utils.getStringLabelKey)(labelKey), paginationText), _defineProperty(_results$push2, 'paginationOption', true), _results$push2));
        }

        // This must come after checks for the custom option and pagination.
        var isMenuShown = (0, _utils.isShown)(results, mergedPropsAndState);

        return _react2.default.createElement(Typeahead, _extends({}, mergedPropsAndState, {
          inputRef: function inputRef(input) {
            return _this2._input = input;
          },
          isMenuShown: isMenuShown,
          menuId: this.props.menuId || this._menuId,
          onAdd: this._handleSelectionAdd,
          onChange: this._handleInputChange,
          onClear: this._handleClear,
          onFocus: this._handleFocus,
          onInitialItemChange: this._handleInitialItemChange,
          onKeyDown: function onKeyDown(e) {
            return _this2._handleKeyDown(e, results, isMenuShown);
          },
          onRemove: this._handleSelectionRemove,
          results: results
        }));
      }

      /**
       * From `onClickOutside` HOC.
       */

    }]);

    return WrappedTypeahead;
  }(_react2.default.Component);

  WrappedTypeahead.displayName = 'TypeaheadContainer(' + (0, _utils.getDisplayName)(Typeahead) + ')';

  WrappedTypeahead.propTypes = {
    /**
     * For localized accessibility: Should return a string indicating the number
     * of results for screen readers. Receives the current results.
     */
    a11yNumResults: _propTypes2.default.func,
    /**
     * For localized accessibility: Should return a string indicating the number
     * of selections for screen readers. Receives the current selections.
     */
    a11yNumSelected: _propTypes2.default.func,
    /**
     * Specify menu alignment. The default value is `justify`, which makes the
     * menu as wide as the input and truncates long values. Specifying `left`
     * or `right` will align the menu to that side and the width will be
     * determined by the length of menu item values.
     */
    align: _propTypes2.default.oneOf(['justify', 'left', 'right']),
    /**
     * Allows the creation of new selections on the fly. Note that any new items
     * will be added to the list of selections, but not the list of original
     * options unless handled as such by `Typeahead`'s parent.
     *
     * If a function is specified, it will be used to determine whether a custom
     * option should be included. The return value should be true or false.
     */
    allowNew: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func]),
    /**
     * Autofocus the input when the component initially mounts.
     */
    autoFocus: _propTypes2.default.bool,
    /**
     * Whether to render the menu inline or attach to `document.body`.
     */
    bodyContainer: _propTypes2.default.bool,
    /**
     * Whether or not filtering should be case-sensitive.
     */
    caseSensitive: (0, _propTypes3.checkPropType)(_propTypes2.default.bool, _propTypes3.caseSensitiveType),
    /**
     * Displays a button to clear the input when there are selections.
     */
    clearButton: _propTypes2.default.bool,
    /**
     * The initial value displayed in the text input.
     */
    defaultInputValue: (0, _propTypes3.checkPropType)(_propTypes2.default.string, _propTypes3.defaultInputValueType),
    /**
     * Specify any pre-selected options. Use only if you want the component to
     * be uncontrolled.
     */
    defaultSelected: _propTypes3.optionType,
    /**
     * Whether to disable the component.
     */
    disabled: _propTypes2.default.bool,
    /**
     * Specify whether the menu should appear above the input.
     */
    dropup: _propTypes2.default.bool,
    /**
     * Message to display in the menu if there are no valid results.
     */
    emptyLabel: _propTypes2.default.node,
    /**
     * Either an array of fields in `option` to search, or a custom filtering
     * callback.
     */
    filterBy: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string.isRequired), _propTypes2.default.func]),
    /**
     * Whether or not to automatically adjust the position of the menu when it
     * reaches the viewport boundaries.
     */
    flip: _propTypes2.default.bool,
    /**
     * Highlights the menu item if there is only one result and allows selecting
     * that item by hitting enter. Does not work with `allowNew`.
     */
    highlightOnlyResult: (0, _propTypes3.checkPropType)(_propTypes2.default.bool, _propTypes3.highlightOnlyResultType),
    /**
     * Whether the filter should ignore accents and other diacritical marks.
     */
    ignoreDiacritics: (0, _propTypes3.checkPropType)(_propTypes2.default.bool, _propTypes3.ignoreDiacriticsType),
    /**
     * Props to be applied directly to the input. `onBlur`, `onChange`,
     * `onFocus`, and `onKeyDown` are ignored.
     */
    inputProps: (0, _propTypes3.checkPropType)(_propTypes2.default.object, _propTypes3.inputPropsType),
    /**
     * Bootstrap 4 only. Adds the `is-invalid` classname to the `form-control`.
     */
    isInvalid: _propTypes2.default.bool,
    /**
     * Indicate whether an asynchronous data fetch is happening.
     */
    isLoading: _propTypes2.default.bool,
    /**
     * Bootstrap 4 only. Adds the `is-valid` classname to the `form-control`.
     */
    isValid: _propTypes2.default.bool,
    /**
     * Specify the option key to use for display or a function returning the
     * display string. By default, the selector will use the `label` key.
     */
    labelKey: (0, _propTypes3.checkPropType)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]), _propTypes3.labelKeyType),
    /**
     * Maximum number of results to display by default. Mostly done for
     * performance reasons so as not to render too many DOM nodes in the case of
     * large data sets.
     */
    maxResults: _propTypes2.default.number,
    /**
     * Id applied to the top-level menu element. Required for accessibility.
     */
    menuId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    /**
     * Number of input characters that must be entered before showing results.
     */
    minLength: _propTypes2.default.number,
    /**
     * Whether or not multiple selections are allowed.
     */
    multiple: _propTypes2.default.bool,
    /**
     * Invoked when the input is blurred. Receives an event.
     */
    onBlur: _propTypes2.default.func,
    /**
     * Invoked whenever items are added or removed. Receives an array of the
     * selected options.
     */
    onChange: _propTypes2.default.func,
    /**
     * Invoked when the input is focused. Receives an event.
     */
    onFocus: _propTypes2.default.func,
    /**
     * Invoked when the input value changes. Receives the string value of the
     * input.
     */
    onInputChange: _propTypes2.default.func,
    /**
     * Invoked when a key is pressed. Receives an event.
     */
    onKeyDown: _propTypes2.default.func,
    /**
     * Invoked when the menu is hidden.
     */
    onMenuHide: _propTypes2.default.func,
    /**
     * Invoked when the menu is shown.
     */
    onMenuShow: _propTypes2.default.func,
    /**
     * Invoked when the pagination menu item is clicked. Receives an event.
     */
    onPaginate: _propTypes2.default.func,
    /**
     * Full set of options, including pre-selected options. Must either be an
     * array of objects (recommended) or strings.
     */
    options: _propTypes3.optionType.isRequired,
    /**
     * Give user the ability to display additional results if the number of
     * results exceeds `maxResults`.
     */
    paginate: _propTypes2.default.bool,
    /**
     * Prompt displayed when large data sets are paginated.
     */
    paginationText: _propTypes2.default.string,
    /**
     * Placeholder text for the input.
     */
    placeholder: _propTypes2.default.string,
    /**
     * Callback for custom menu rendering.
     */
    renderMenu: _propTypes2.default.func,
    /**
     * The selected option(s) displayed in the input. Use this prop if you want
     * to control the component via its parent.
     */
    selected: _propTypes3.optionType,
    /**
     * Allows selecting the hinted result by pressing enter.
     */
    selectHintOnEnter: _propTypes2.default.bool
  };

  WrappedTypeahead.defaultProps = {
    a11yNumResults: function a11yNumResults(results) {
      var resultString = (0, _utils.pluralize)('result', results.length);
      return resultString + '. Use up and down arrow keys to navigate.';
    },
    a11yNumSelected: function a11yNumSelected(selected) {
      return (0, _utils.pluralize)('selection', selected.length);
    },
    align: 'justify',
    allowNew: false,
    autoFocus: false,
    bodyContainer: false,
    caseSensitive: false,
    clearButton: false,
    defaultInputValue: '',
    defaultSelected: [],
    disabled: false,
    dropup: false,
    emptyLabel: 'No matches found.',
    filterBy: [],
    flip: false,
    highlightOnlyResult: false,
    ignoreDiacritics: true,
    inputProps: {},
    isInvalid: false,
    isLoading: false,
    isValid: false,
    labelKey: _defaultLabelKey.DEFAULT_LABELKEY,
    maxResults: 100,
    minLength: 0,
    multiple: false,
    onBlur: _noop2.default,
    onChange: _noop2.default,
    onFocus: _noop2.default,
    onInputChange: _noop2.default,
    onKeyDown: _noop2.default,
    onMenuHide: _noop2.default,
    onMenuShow: _noop2.default,
    onPaginate: _noop2.default,
    paginate: true,
    paginationText: 'Display additional results...',
    placeholder: '',
    selectHintOnEnter: false
  };

  WrappedTypeahead.childContextTypes = {
    activeIndex: _propTypes2.default.number.isRequired,
    onActiveItemChange: _propTypes2.default.func.isRequired,
    onInitialItemChange: _propTypes2.default.func.isRequired,
    onMenuItemClick: _propTypes2.default.func.isRequired
  };

  return (0, _reactOnclickoutside2.default)(WrappedTypeahead);
}

exports.default = typeaheadContainer;

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createFlow = __webpack_require__(330);

/**
 * This method is like `_.flow` except that it creates a function that
 * invokes the given functions from right to left.
 *
 * @static
 * @since 3.0.0
 * @memberOf _
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flow
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flowRight([square, _.add]);
 * addSquare(1, 2);
 * // => 9
 */
var flowRight = createFlow(true);

module.exports = flowRight;

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var LodashWrapper = __webpack_require__(72),
    flatRest = __webpack_require__(106),
    getData = __webpack_require__(136),
    getFuncName = __webpack_require__(137),
    isArray = __webpack_require__(2),
    isLaziable = __webpack_require__(333);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */
function createFlow(fromRight) {
  return flatRest(function (funcs) {
    var length = funcs.length,
        index = length,
        prereq = LodashWrapper.prototype.thru;

    if (fromRight) {
      funcs.reverse();
    }
    while (index--) {
      var func = funcs[index];
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
        var wrapper = new LodashWrapper([], true);
      }
    }
    index = wrapper ? index : length;
    while (++index < length) {
      func = funcs[index];

      var funcName = getFuncName(func),
          data = funcName == 'wrapper' ? getData(func) : undefined;

      if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) {
        wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
      } else {
        wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
      }
    }
    return function () {
      var args = arguments,
          value = args[0];

      if (wrapper && args.length == 1 && isArray(value)) {
        return wrapper.plant(value).value();
      }
      var index = 0,
          result = length ? funcs[index].apply(this, args) : value;

      while (++index < length) {
        result = funcs[index].call(this, result);
      }
      return result;
    };
  });
}

module.exports = createFlow;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var WeakMap = __webpack_require__(93);

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap();

module.exports = metaMap;

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var LazyWrapper = __webpack_require__(74),
    getData = __webpack_require__(136),
    getFuncName = __webpack_require__(137),
    lodash = __webpack_require__(334);

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var LazyWrapper = __webpack_require__(74),
    LodashWrapper = __webpack_require__(72),
    baseLodash = __webpack_require__(73),
    isArray = __webpack_require__(2),
    isObjectLike = __webpack_require__(8),
    wrapperClone = __webpack_require__(335);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var LazyWrapper = __webpack_require__(74),
    LodashWrapper = __webpack_require__(72),
    copyArray = __webpack_require__(336);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__ = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toString = __webpack_require__(96);

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}

module.exports = uniqueId;

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _head = __webpack_require__(55);

var _head2 = _interopRequireDefault(_head);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _keyCode = __webpack_require__(22);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function highlightOnlyResultContainer(Typeahead) {
  var WrappedTypeahead = function (_React$Component) {
    _inherits(WrappedTypeahead, _React$Component);

    function WrappedTypeahead() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, WrappedTypeahead);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WrappedTypeahead.__proto__ || Object.getPrototypeOf(WrappedTypeahead)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        isOnlyResult: false
      }, _this._handleKeyDown = function (e) {
        var _this$props = _this.props,
            initialItem = _this$props.initialItem,
            onKeyDown = _this$props.onKeyDown,
            onAdd = _this$props.onAdd;

        switch (e.keyCode) {
          case _keyCode.RETURN:
            if (_this.state.isOnlyResult) {
              onAdd(initialItem);
            }
            break;
        }

        onKeyDown(e);
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(WrappedTypeahead, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var allowNew = nextProps.allowNew,
            highlightOnlyResult = nextProps.highlightOnlyResult,
            results = nextProps.results;

        if (!highlightOnlyResult || allowNew) {
          return;
        }

        if (results.length !== this.props.results.length) {
          this.setState({
            isOnlyResult: results.length === 1 && !(0, _head2.default)(results).disabled
          });
        }
      }
    }, {
      key: 'getChildContext',
      value: function getChildContext() {
        return {
          isOnlyResult: this.state.isOnlyResult
        };
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Typeahead, _extends({}, this.props, {
          onKeyDown: this._handleKeyDown
        }));
      }
    }]);

    return WrappedTypeahead;
  }(_react2.default.Component);

  WrappedTypeahead.childContextTypes = {
    isOnlyResult: _propTypes2.default.bool.isRequired
  };

  return WrappedTypeahead;
}

exports.default = highlightOnlyResultContainer;

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.optionType = exports.labelKeyType = exports.inputPropsType = exports.ignoreDiacriticsType = exports.highlightOnlyResultType = exports.defaultInputValueType = exports.checkPropType = exports.caseSensitiveType = undefined;

var _caseSensitiveType2 = __webpack_require__(340);

var _caseSensitiveType3 = _interopRequireDefault(_caseSensitiveType2);

var _checkPropType2 = __webpack_require__(341);

var _checkPropType3 = _interopRequireDefault(_checkPropType2);

var _defaultInputValueType2 = __webpack_require__(342);

var _defaultInputValueType3 = _interopRequireDefault(_defaultInputValueType2);

var _highlightOnlyResultType2 = __webpack_require__(343);

var _highlightOnlyResultType3 = _interopRequireDefault(_highlightOnlyResultType2);

var _ignoreDiacriticsType2 = __webpack_require__(344);

var _ignoreDiacriticsType3 = _interopRequireDefault(_ignoreDiacriticsType2);

var _inputPropsType2 = __webpack_require__(345);

var _inputPropsType3 = _interopRequireDefault(_inputPropsType2);

var _labelKeyType2 = __webpack_require__(346);

var _labelKeyType3 = _interopRequireDefault(_labelKeyType2);

var _optionType2 = __webpack_require__(347);

var _optionType3 = _interopRequireDefault(_optionType2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.caseSensitiveType = _caseSensitiveType3.default; /* eslint-disable object-curly-spacing */

exports.checkPropType = _checkPropType3.default;
exports.defaultInputValueType = _defaultInputValueType3.default;
exports.highlightOnlyResultType = _highlightOnlyResultType3.default;
exports.ignoreDiacriticsType = _ignoreDiacriticsType3.default;
exports.inputPropsType = _inputPropsType3.default;
exports.labelKeyType = _labelKeyType3.default;
exports.optionType = _optionType3.default;
/* eslint-enable object-curly-spacing */

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = caseSensitiveType;

var _warn = __webpack_require__(9);

var _warn2 = _interopRequireDefault(_warn);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function caseSensitiveType(props, propName, componentName) {
  var caseSensitive = props.caseSensitive,
      filterBy = props.filterBy;

  (0, _warn2.default)(!caseSensitive || typeof filterBy !== 'function', 'Your `filterBy` function will override the `caseSensitive` prop.');
}

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = checkPropType;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

/**
 * Allows additional warnings or messaging related to prop validation.
 */
function checkPropType(validator, callback) {
  return function (props, propName, componentName) {
    _propTypes2.default.checkPropTypes(_defineProperty({}, propName, validator), props, 'prop', componentName);

    typeof callback === 'function' && callback(props, propName, componentName);
  };
}

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = defaultInputValueType;

var _warn = __webpack_require__(9);

var _warn2 = _interopRequireDefault(_warn);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function defaultInputValueType(props, propName, componentName) {
  var defaultInputValue = props.defaultInputValue,
      defaultSelected = props.defaultSelected,
      multiple = props.multiple,
      selected = props.selected;

  var name = defaultSelected.length ? 'defaultSelected' : 'selected';

  (0, _warn2.default)(!(!multiple && defaultInputValue && (defaultSelected.length || selected && selected.length)), '`defaultInputValue` will be overridden by the value from `' + name + '`.');
}

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = highlightOnlyResultType;

var _warn = __webpack_require__(9);

var _warn2 = _interopRequireDefault(_warn);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function highlightOnlyResultType(props, propName, componentName) {
  var allowNew = props.allowNew,
      highlightOnlyResult = props.highlightOnlyResult;

  (0, _warn2.default)(!(highlightOnlyResult && allowNew), '`highlightOnlyResult` will not work with `allowNew`.');
}

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ignoreDiacriticsType;

var _warn = __webpack_require__(9);

var _warn2 = _interopRequireDefault(_warn);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function ignoreDiacriticsType(props, propName, componentName) {
  var filterBy = props.filterBy,
      ignoreDiacritics = props.ignoreDiacritics;

  (0, _warn2.default)(ignoreDiacritics || typeof filterBy !== 'function', 'Your `filterBy` function will override the `ignoreDiacritics` prop.');
}

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = inputPropsType;

var _isPlainObject = __webpack_require__(100);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _warn = __webpack_require__(9);

var _warn2 = _interopRequireDefault(_warn);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var BLACKLIST = [{ alt: 'onBlur', prop: 'onBlur' }, { alt: 'onInputChange', prop: 'onChange' }, { alt: 'onFocus', prop: 'onFocus' }, { alt: 'onKeyDown', prop: 'onKeyDown' }];

function inputPropsType(props, propName, componentName) {
  var inputProps = props.inputProps;

  if (!(inputProps && (0, _isPlainObject2.default)(inputProps))) {
    return;
  }

  // Blacklisted properties.
  BLACKLIST.forEach(function (_ref) {
    var alt = _ref.alt,
        prop = _ref.prop;

    var msg = alt ? ' Use the top-level `' + alt + '` prop instead.' : null;
    (0, _warn2.default)(!inputProps.hasOwnProperty(prop), 'The `' + prop + '` property of `inputProps` will be ignored.' + msg);
  });
}

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = labelKeyType;

var _warn = __webpack_require__(9);

var _warn2 = _interopRequireDefault(_warn);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function labelKeyType(props, propName, componentName) {
  var allowNew = props.allowNew,
      labelKey = props.labelKey;

  (0, _warn2.default)(!(typeof labelKey === 'function' && allowNew), '`labelKey` must be a string when `allowNew={true}`.');
}

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.object.isRequired), _propTypes2.default.arrayOf(_propTypes2.default.string.isRequired)]);

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SelectImages;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SelectImages(_ref) {
  var images = _ref.images,
      selected = _ref.selected,
      onSelect = _ref.onSelect;

  return _react2.default.createElement(
    "div",
    { className: "form-group field field-number" },
    _react2.default.createElement(
      "select",
      {
        onChange: function onChange(evt) {
          return onSelect(evt.target.value);
        },
        value: selected,
        className: "form-control" },
      images.map(function (_ref2, i) {
        var name = _ref2.name,
            url = _ref2.url;
        return _react2.default.createElement(
          "option",
          { key: i, value: url },
          name
        );
      })
    )
  );
}

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SelectImages;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SelectImages(_ref) {
  var images = _ref.images,
      selected = _ref.selected,
      onSelect = _ref.onSelect;

  return _react2.default.createElement(
    "div",
    { className: "form-group field field-number" },
    _react2.default.createElement(
      "select",
      {
        onChange: function onChange(evt) {
          return onSelect(evt.target.value);
        },
        value: selected,
        className: "form-control" },
      images.map(function (_ref2, i) {
        var name = _ref2.name,
            key = _ref2.key;
        return _react2.default.createElement(
          "option",
          { key: i, value: key },
          name
        );
      })
    )
  );
}

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// react-complaint-image.js